/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 339);
/******/ })
/************************************************************************/
/******/ ({

/***/ 1:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var config = {
  env: "QA",
  alkmapsUrl: "//maps-aws-qa.alk.com/api/1.2/ALKMaps.js",
  alkmapsApiKey: "48667533B12E8942B038B8533A35F4A5",
  reportApiKey: {
    "NA": "7BD8599CEA4B8A46AC336735444E486C",
    "EU": "48667533B12E8942B038B8533A35F4A5",
    "OC": "48667533B12E8942B038B8533A35F4A5"
  },
  braze: {
    apiKey: "01e442af-cfcb-43ba-b63f-dbef1f587dac",
    // make this value smaller before demoing
    minimumIntervalBetweenTriggerActionsInSeconds: 30,
    enableLogging: true
  },
  chat: {
    enabled: true,
    regionWhitelist: ["NA"],
    scriptUrl: "https://wchat.freshchat.com/js/widget.js",
    // shared token for all environments
    fcToken: "797ed190-4ef3-4faa-81f8-367d7ba5e6dc"
  },
  pcmwsUrl: "https://pcmiler-aws-qa.alk.com/APIs/REST/v1.0/service.svc/",
  urlWeatherRadar: "https://aws.contentsvc.qa.alk.com/ContentService.svc/xml/WeatherImageTile?x=${x}&y=${y}&z=${z}&weatherDisplay=0&authtoken=",
  urlWeatherSatellite: "https://aws.contentsvc.qa.alk.com/ContentService.svc/xml/WeatherImageTile?x=${x}&y=${y}&z=${z}&weatherDisplay=1&authtoken=",
  daUrl: "https://dataanywhere-qa.alk.com/api/",
  ssoUrl: "https://authws-qa.alk.com/api/",
  fleetLinkUrl: "https://api-copilotfleetportal-qa.alk.com/",
  singleSearchUrl: "https://singlesearch-aws-qa.alk.com/ww/api/search/",
  singleSearchAuthToken: "A7FEE5D40BDF4A4A97D623094A657AFB",
  alkiconsUrl: "https://maps.trimble.com/fonts/alk-icons.min.css",
  linkMappingUrl: "https://linkmapping-qa.alk.com/api",
  creditExpireWarningDays: 14,
  trackJsEnvironment: "pcmwebui-qa",
  applicationName: "PCMilerWebsite",
  tidApplicationName: "PC_Miler_Web--dev-qa",
  clientId: "4340ee42-2cd9-4fc6-9c3e-2721ae85e384",
  trimbleCloudUrl: "https://stage.id.trimblecloud.com/",
  alkCloudApplicationName: "PC*Miler Interactive",
  promo: {
    userId: 11553434,
    accountId: 127896
  },
  pcmModernSite: "https://qa.pcmilerweb.com/",
  sumoUrl: "https://collectors.us2.sumologic.com/receiver/v1/http/ZaVnC4dhaV3NqK1vVtGOb0Fly8fu4vYhxD_B70jkxrlh33lFU53ial6DElnwM9kHMctfNvhXGVcis-2-dxiDOmDQ3w-S3fo7i2R0Up-n6sX1lQRT67QAOg=="
};

module.exports = config;

/***/ }),

/***/ 105:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* globals moment */

// TODO pchen: make eventTracker a class so we can change init to a constructor and appboy a property
var appboy = void 0;

function init(config, _appboy) {
  appboy = _appboy;
  appboy.initialize(config.braze.apiKey, {
    // 1 hour to match SSO token expiration
    sessionTimeoutInSeconds: 3600,
    minimumIntervalBetweenTriggerActionsInSeconds: config.braze.minimumIntervalBetweenTriggerActionsInSeconds,
    enableLogging: config.braze.enableLogging
  });
  appboy.openSession();
  // appboy.display.automaticallyShowNewInAppMessages();
}

var EVENTS = {
  // events that should be unpacked instead of being sent to braze (prefix with _)
  LOGIN: "_login",
  SIGNUP: "_signup",
  CANCEL_ACCOUNT: "_cancel_account",
  UPDATE_BILLING: "_update_billing",
  WEATHER_LAYER: "_weather_layer",
  UPDATE_SUB_LEVEL: "_update_sub_level",
  APP_CHANGE: "_app_change",
  RT_OPTIONS: "_rt_options",
  LEAST_DATA_VERSION: "_least_data_version",
  LOGOUT: "_logout"
  // TODO pchen: add constants for event names sent to braze
};

var ATTRS = {};

var DATES = {};

function setAttr(name, value) {
  appboy.getUser().setCustomUserAttribute(name, value);
}

function delAttr(name) {
  appboy.getUser().setCustomUserAttribute(name, null);
}

function track(event) {
  var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (event) {
    case EVENTS.LOGIN:
      trackLogin(args);
      appboy.requestImmediateDataFlush();
      break;
    case EVENTS.SIGNUP:
      trackSignup(args);
      appboy.requestImmediateDataFlush();
      break;
    case EVENTS.CANCEL_ACCOUNT:
      trackCancelAcc(args);
      appboy.requestImmediateDataFlush();
      break;
    case EVENTS.UPDATE_BILLING:
      trackUpdateBilling(args);
      appboy.requestImmediateDataFlush();
      break;
    case EVENTS.UPDATE_SUB_LEVEL:
      trackUpdateSubLevel(args);
      appboy.requestImmediateDataFlush();
      break;
    case EVENTS.WEATHER_LAYER:
      trackWeatherLayer(args);
      appboy.requestImmediateDataFlush();
      break;
    case EVENTS.APP_CHANGE:
      trackAppChange(args);
      appboy.requestImmediateDataFlush();
      break;
    case EVENTS.RT_OPTIONS:
      trackRouteOptions(args);
      appboy.requestImmediateDataFlush();
      break;
    case EVENTS.LEAST_DATA_VERSION:
      trackLeastDataversionUsedByCustomer(args);
      appboy.requestImmediateDataFlush();
      break;
    case EVENTS.LOGOUT:
      trackLogout(args);
      break;
    default:
      // _ prefix means event should be unpacked above instead of being sent to braze
      if (event && event[0] !== "_") {
        appboy.logCustomEvent(event);
        appboy.requestImmediateDataFlush();
      } else {
        console.error("unimplemented event: " + event);
      }
  }
}

function uniqueId(_ref) {
  var userName = _ref.userName,
      account = _ref.account;

  // TODO: use uuids instead
  return userName + "@" + account;
}

function trackLogin(_ref2) {
  var user = _ref2.user;

  if (user.firstName && user.lastName && user.userName) {
    // braze analytics for login
    appboy.changeUser(uniqueId(user));
    appboy.getUser().setFirstName(user.firstName);
    appboy.getUser().setLastName(user.lastName);
    // username should be an email address
    appboy.getUser().setEmail(user.userName);
    appboy.getUser().setCustomUserAttribute("Last Used Version", "V1");
    var featureLevel = user.accountType === "Trial" ? "Trial" : user.subscriptionLevel;
    appboy.getUser().setCustomUserAttribute("Subscription Level", featureLevel);
    appboy.getUser().setCustomUserAttribute("Trial End", user.expirationDate);
    var remainingRoutes = user.remainingRoutes < 0 ? null : user.remainingRoutes;
    appboy.getUser().setCustomUserAttribute("Routes Remaining (Trial User)", remainingRoutes);
    var data = window.localStorage.getItem("user_authToken");
    if (user && user.authToken !== data) {
      appboy.logCustomEvent("Login Legacy");
      window.localStorage.setItem("user_authToken", user.authToken);
    }
    appboy.subscribeToInAppMessage(function (inAppMessage) {
      appboy.display.showInAppMessage(inAppMessage);
    });
  }
}

function trackSignup(_ref3) {
  var signup = _ref3.signup;

  // braze analytics for sign up
  appboy.changeUser(uniqueId({ userName: signup.userName, account: signup.companyName }));
  appboy.getUser().setFirstName(signup.firstName);
  appboy.getUser().setLastName(signup.lastName);
  // username should be an email address
  appboy.getUser().setEmail(signup.userName);
  var featureLevel = signup.featureLevel;
  if (featureLevel === "Trial") {
    appboy.logCustomEvent("Trial Activation");
    appboy.getUser().setCustomUserAttribute("Trial Start", new Date());
    // TODO: get these values from signup response (which is currently nothing) if possible
    //   instead of hardcoding default values of 7 days and 35 routes
    appboy.getUser().setCustomUserAttribute("Trial End", moment().add(7, "d").toDate());
    appboy.getUser().setCustomUserAttribute("Routes Remaining (Trial User)", 35);
  } else if (featureLevel === "Standard") {
    appboy.logCustomEvent("Standard Sub Purchase");
    appboy.getUser().setCustomUserAttribute("Standard Subscription Start", new Date());
  } else if (featureLevel === "Premium") {
    appboy.logCustomEvent("Premium Sub Purchase");
    appboy.getUser().setCustomUserAttribute("Premium Subscription Start", new Date());
  }
  appboy.getUser().setCustomUserAttribute("Subscription Level", featureLevel);
  appboy.getUser().setHomeCity(signup.city + ", " + signup.state);
  appboy.getUser().setCustomUserAttribute("User City", signup.city);
  appboy.getUser().setCustomUserAttribute("User State", signup.state);
  // switch back to BrazeDummyUser because user still has to sign in after signing up
  trackLogout();
}

function trackCancelAcc(_ref4) {
  var featureLevel = _ref4.featureLevel;

  // braze analytics for canceling account
  if (featureLevel === "Trial") {
    appboy.logCustomEvent("Trial Cancelled");
  } else if (featureLevel === "Standard") {
    appboy.logCustomEvent("Standard Sub Cancelled");
  } else if (featureLevel === "Premium") {
    appboy.logCustomEvent("Premium Sub Cancelled");
  }
  appboy.getUser().setCustomUserAttribute("Deactivation Date", new Date());
}

function trackUpdateBilling(_ref5) {
  var ogCity = _ref5.ogCity,
      newCity = _ref5.newCity,
      ogState = _ref5.ogState,
      newState = _ref5.newState;

  // braze analytics for updating account billing features
  if (ogCity !== newCity || ogState !== newState) {
    if (ogCity !== newCity) {
      appboy.getUser().setCustomUserAttribute("User City", newCity);
    }
    if (ogState !== newState) {
      appboy.getUser().setCustomUserAttribute("User State", newState);
    }
    appboy.getUser().setHomeCity(newCity + ", " + newState);
  }
}

function trackUpdateSubLevel(_ref6) {
  var ogFL = _ref6.ogFL,
      newFL = _ref6.newFL;

  // braze analytics for updating account feature level
  // pchen: some checks in the if conditions might be redundant based on where this function is called
  if (ogFL === "Trial") {
    appboy.logCustomEvent(newFL + " Sub Purchase");
  } else if (ogFL === "Standard" && newFL === "Premium") {
    appboy.logCustomEvent("Standard to Premium Upgrade");
  } else if (ogFL === "Premium" && newFL === "Standard") {
    appboy.logCustomEvent("Premium to Standard Downgrade");
  }
  appboy.getUser().setCustomUserAttribute("Subscription Level", newFL);
  if (newFL !== "Trial") {
    appboy.getUser().setCustomUserAttribute(newFL + " Subscription Start", new Date());
  }
}

function trackWeatherLayer(_ref7) {
  var mapService = _ref7.mapService;

  // braze analytics for toggling a weather layer on or off
  var alerts = mapService.isWeatherAlertsVisible();
  var cloud = mapService.isWeatherCloudVisible();
  var radar = mapService.isWeatherRadarVisible();
  var rs = mapService.isRoadSurfaceVisible();
  var weatherUsage = [alerts, cloud, radar, rs];
  // translate weather usage into array of strings to log into appboy custom user attribute
  var weatherUsageReadable = ["Weather Alerts", "Cloud Layer", "Radar Layer", "Road Conditions Layer"].filter(function (s, i) {
    return weatherUsage[i];
  });
  if (weatherUsageReadable.length > 0) {
    appboy.logCustomEvent("Show Weather Layers");
    appboy.getUser().setCustomUserAttribute("Weather", weatherUsageReadable);
  } else {
    appboy.logCustomEvent("Hide Weather Layers");
    appboy.getUser().setCustomUserAttribute("Weather", null);
  }
}

function trackAppChange(_ref8) {
  var product = _ref8.product;

  // braze diagnostics for cloud menu
  var appboyEventName = "Clicks to ";
  switch (product.productTitle) {
    case "Content Tools":
    case "MapSure":
      appboyEventName += product.productTitle;
      break;
    default:
      appboyEventName = null;
  }
  if (appboyEventName) {
    appboy.logCustomEvent(appboyEventName);
  }
}

function trackRouteOptions(_ref9) {
  var options = _ref9.options;

  // braze analytics for route options
  if (options.useTraffic) {
    appboy.logCustomEvent("Use Traffic");
    appboy.getUser().setCustomUserAttribute("Traffic", true);
  } else {
    appboy.getUser().setCustomUserAttribute("Traffic", null);
  }
  if (options.afSetIDs && options.afSetIDs.length > 0) {
    appboy.logCustomEvent("Route Modifiers");
  }
  appboy.logCustomEvent("Changed Legacy Routing Options");
}

function trackLeastDataversionUsedByCustomer(_ref10) {
  var version = _ref10.version;

  appboy.getUser().setCustomUserAttribute("Minimum Data Version Used", version);
}

function trackLogout() {
  // braze analytics for logout
  // dummy user so that logging out and back in will update campaigns from braze
  // shouldn't be used for anything else, and should change to a real user before any data is logged
  appboy.changeUser("BrazeDummyUser");
}

module.exports = { init: init, EVENTS: EVENTS, setAttr: setAttr, delAttr: delAttr, track: track };

/***/ }),

/***/ 106:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
* Braze Web SDK v2.5.2
* (c) Braze, Inc. 2020 - http://braze.com
* License available at https://github.com/Appboy/appboy-web-sdk/blob/master/LICENSE
* Compiled on 2020-04-16
*/
(function(){(function(b,a){if(true)!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (a),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else if("object"===typeof module&&module.exports)module.exports=a();else if(b.appboy){var d=a(),c;for(c in d)b.appboy[c]=d[c]}else b.appboy=a()})("undefined"!==typeof self?self:this,function(){var appboyInterface={};var p,aa="function"==typeof Object.create?Object.create:function(a){function b(){}b.prototype=a;return new b},ba;if("function"==typeof Object.setPrototypeOf)ba=Object.setPrototypeOf;else{var ca;a:{var da={Gf:!0},fa={};try{fa.__proto__=da;ca=fa.Gf;break a}catch(a){}ca=!1}ba=ca?function(a,b){a.__proto__=b;if(a.__proto__!==b)throw new TypeError(a+" is not extensible");return a}:null}var ha=ba;
function ia(a,b){a.prototype=aa(b.prototype);a.prototype.constructor=a;if(ha)ha(a,b);else for(var c in b)if("prototype"!=c)if(Object.defineProperties){var d=Object.getOwnPropertyDescriptor(b,c);d&&Object.defineProperty(a,c,d)}else a[c]=b[c];a.Kg=b.prototype}var ja="undefined"!=typeof window&&window===this?this:"undefined"!=typeof global&&null!=global?global:this,ka="function"==typeof Object.defineProperties?Object.defineProperty:function(a,b,c){a!=Array.prototype&&a!=Object.prototype&&(a[b]=c.value)};
function la(a,b){if(b){var c=ja;a=a.split(".");for(var d=0;d<a.length-1;d++){var e=a[d];e in c||(c[e]={});c=c[e]}a=a[a.length-1];d=c[a];b=b(d);b!=d&&null!=b&&ka(c,a,{configurable:!0,writable:!0,value:b})}}
la("String.prototype.repeat",function(a){return a?a:function(b){if(null==this)throw new TypeError("The 'this' value for String.prototype.repeat must not be null or undefined");var c=this+"";if(0>b||1342177279<b)throw new RangeError("Invalid count value");b|=0;for(var d="";b;)if(b&1&&(d+=c),b>>>=1)c+=c;return d}});
var ma={zg:function(a){var b="=".repeat((4-a.length%4)%4);a=(a+b).replace(/\-/g,"+").replace(/_/g,"/");a=atob(a);b=new Uint8Array(a.length);for(var c=0;c<a.length;++c)b[c]=a.charCodeAt(c);return b}};var oa={Ya:function(){function a(b){var c=(Math.random().toString(16)+"000000000").substr(2,8);return b?"-"+c.substr(0,4)+"-"+c.substr(4,4):c}return a()+a(!0)+a(!0)+a()}};function pa(a){var b=v;this.Wd="undefined"===typeof window?self:window;this.o=a;this.w=b}function qa(a){if("indexedDB"in a.Wd)return a.Wd.indexedDB}
function ra(a){try{if(null==qa(a))return!1;qa(a).open("Braze IndexedDB Support Test");if("undefined"!==typeof window){var b=window.Fg||window.vb||window.Hg;if(b&&b.cg&&b.cg.id)return a.w.info("Not using IndexedDB for storage because we are running inside an extension"),!1}return!0}catch(c){return a.w.info("Not using IndexedDB for storage due to following error: "+c),!1}}
function sa(a,b,c){var d=qa(a).open(a.o.F,a.o.VERSION);if(null==d)return"function"===typeof c&&c(),!1;d.onupgradeneeded=function(e){a.w.info("Upgrading indexedDB "+a.o.F+" to v"+a.o.VERSION+"...");e=e.target.result;for(var f in a.o.M)a.o.M.hasOwnProperty(f)&&!e.objectStoreNames.contains(a.o.M[f])&&e.createObjectStore(a.o.M[f])};d.onsuccess=function(e){a.w.debug("Opened indexedDB "+a.o.F+" v"+a.o.VERSION);var f=e.target.result;f.onversionchange=function(){f.close();"function"===typeof c&&c();a.w.error("Needed to close the database unexpectedly because of an upgrade in another tab")};
b(f)};d.onerror=function(e){a.w.info("Could not open indexedDB "+a.o.F+" v"+a.o.VERSION+": "+e.target.errorCode);"function"===typeof c&&c();return!0};return!0}
pa.prototype.setItem=function(a,b,c,d,e){if(!ra(this))return"function"===typeof e&&e(),!1;var f=this;return sa(this,function(g){g.objectStoreNames.contains(a)?(g=g.transaction([a],"readwrite").objectStore(a).put(c,b),g.onerror=function(){f.w.error("Could not store object "+b+" in "+a+" on indexedDB "+f.o.F);"function"===typeof e&&e()},g.onsuccess=function(){f.w.debug("Stored object "+b+" in "+a+" on indexedDB "+f.o.F);"function"===typeof d&&d()}):(f.w.error("Could not store object "+b+" in "+a+" on indexedDB "+
f.o.F+" - "+a+" is not a valid objectStore"),"function"===typeof e&&e())},e)};
pa.prototype.getItem=function(a,b,c){if(!ra(this))return!1;var d=this;return sa(this,function(e){e.objectStoreNames.contains(a)?(e=e.transaction([a],"readonly").objectStore(a).get(b),e.onerror=function(){d.w.error("Could not retrieve object "+b+" in "+a+" on indexedDB "+d.o.F)},e.onsuccess=function(f){d.w.debug("Retrieved object "+b+" in "+a+" on indexedDB "+d.o.F);f=f.target.result;null!=f&&c(f)}):d.w.error("Could not retrieve object "+b+" in "+a+" on indexedDB "+d.o.F+" - "+a+" is not a valid objectStore")})};
function ta(a,b,c,d){ra(a)?sa(a,function(e){e.objectStoreNames.contains(b)?(e=e.transaction([b],"readonly").objectStore(b).openCursor(null,"prev"),e.onerror=function(){a.w.error("Could not open cursor for "+b+" on indexedDB "+a.o.F);"function"===typeof d&&d()},e.onsuccess=function(f){f=f.target.result;null!=f&&null!=f.value&&null!=f.key?(a.w.debug("Retrieved last record "+f.key+" in "+b+" on indexedDB "+a.o.F),c(f.key,f.value)):"function"===typeof d&&d()}):(a.w.error("Could not retrieve last record from "+
b+" on indexedDB "+a.o.F+" - "+b+" is not a valid objectStore"),"function"===typeof d&&d())},d):"function"===typeof d&&d()}
function ua(a,b,c){ra(a)&&sa(a,function(d){d.objectStoreNames.contains(b)?(d=d.transaction([b],"readwrite").objectStore(b)["delete"](c),d.onerror=function(){a.w.error("Could not delete record "+c+" from "+b+" on indexedDB "+a.o.F)},d.onsuccess=function(){a.w.debug("Deleted record "+c+" from "+b+" on indexedDB "+a.o.F)}):a.w.error("Could not delete record "+c+" from "+b+" on indexedDB "+a.o.F+" - "+b+" is not a valid objectStore")})}
function va(a,b,c){ra(a)&&sa(a,function(d){if(d.objectStoreNames.contains(b)){var e=d.transaction([b],"readwrite").objectStore(b);d=e.openCursor();var f=[];d.onerror=function(){0<f.length?(a.w.info("Cursor closed midway through for "+b+" on indexedDB "+a.o.F),c(f)):a.w.error("Could not open cursor for "+b+" on indexedDB "+a.o.F)};d.onsuccess=function(g){var h=g.target.result;null!=h?(null!=h.value&&null!=h.key&&(e["delete"](h.key).onsuccess=function(){f.push(h.value)}),h.continue()):0<f.length&&c(f)}}else a.w.error("Could not retrieve objects from "+
b+" on indexedDB "+a.o.F+" - "+b+" is not a valid objectStore")})}
pa.prototype.clearData=function(){if(!ra(this))return!1;var a=[],b;for(b in this.o.M)this.o.M.hasOwnProperty(b)&&this.o.M[b]!==this.o.M.Ic&&a.push(this.o.M[b]);var c=this;return sa(this,function(d){d=d.transaction(a,"readwrite");for(var e=0;e<a.length;e++){var f=d.objectStore(a[e]).clear();f.onsuccess=function(){c.w.debug("Cleared "+this.source.name+" on indexedDB "+c.o.F)};f.onerror=function(){c.w.error("Could not clear "+this.source.name+" on indexedDB "+c.o.F)}}d.oncomplete=function(){c.w.debug("Cleared all object stores on indexedDB "+
c.o.F)};d.onerror=function(){c.w.error("Could not clear object stores on indexedDB "+c.o.F)}})};var w={dd:function(a){if(void 0!==a||void 0===w.Ba)w.Ba=!!a;w.Sd||(w.Sd=!0)},yb:function(){w.Sd=!1;w.Ba=void 0;w.w=void 0},pd:function(a){"function"!==typeof a?w.info("Ignoring setLogger call since logger is not a function"):(w.dd(),w.w=a)},sd:function(){w.dd();w.Ba?(console.log("Disabling Appboy logging"),w.Ba=!1):(console.log("Enabled Appboy logging"),w.Ba=!0)},debug:function(a){w.Ba&&null!=w.w&&w.w("Appboy: "+a)},info:function(a){w.Ba&&(a="Appboy: "+a,null!=w.w?w.w(a):console.log(a))},error:function(a){w.Ba&&
(a="Appboy SDK Error: "+a+" (v2.5.2)",null!=w.w?w.w(a):console.error(a))}};var B={CustomEvent:"ce",bf:"p",nf:"pc",Dg:"ca",df:"i",cf:"ie",Me:"cci",Oe:"ccic",Ke:"ccc",Le:"ccd",Id:"ss",rf:"se",af:"si",Bd:"sc",Ad:"sbc",$e:"sfe",Pe:"iec",kf:"lr",Ge:"uae",Je:"ci",Ie:"cc",hf:"lcaa",jf:"lcar",Re:"inc",Qe:"add",Se:"rem",Te:"set"},wa={Ze:"feed_displayed",Ne:"content_cards_displayed"},xa={Na:{F:"AppboyServiceWorkerAsyncStorage",VERSION:5,M:{Ue:"data",Fd:"pushClicks",Kc:"pushSubscribed",Cg:"fallbackDevice",He:"cardUpdates",Ic:"optOut"},Ub:1}},v=w;function ya(a,b,c,d){a=za(a);return-1===a.indexOf(b)?(v.error(c+" Valid values from "+d+' are "'+a.join('"/"')+'".'),!1):!0}function Aa(a){return Array.isArray?Array.isArray(a):"[object Array]"===Object.prototype.toString.call(a)}function Ba(a){return"[object Date]"===Object.prototype.toString.call(a)}
function Ca(a){null==a&&(a=[]);for(var b=[],c=arguments.length,d=0,e=a.length;d<e;d++){var f=a[d];if(-1===b.indexOf(f)){var g;for(g=1;g<c&&-1!==arguments[g].indexOf(f);g++);g===c&&b.push(f)}}return b}function Da(a){var b=[],c;for(c in a)a.hasOwnProperty(c)&&b.push(c);return b}function za(a){var b=[],c;for(c in a)a.hasOwnProperty(c)&&void 0!==a[c]&&b.push(a[c]);return b}
function Ea(a,b){if(a===b)return 0!==a||1/a===1/b;if(null==a||null==b)return a===b;var c=a.toString();if(c!==b.toString())return!1;switch(c){case "[object RegExp]":case "[object String]":return""+a===""+b;case "[object Number]":return+a!==+a?+b!==+b:0===+a?1/+a===1/b:+a===+b;case "[object Date]":case "[object Boolean]":return+a===+b}c="[object Array]"===c;if(!c){if("object"!==typeof a||"object"!==typeof b)return!1;var d=a.constructor,e=b.constructor;if(d!==e&&!("function"===typeof d&&d instanceof
d&&"function"===typeof e&&e instanceof e)&&"constructor"in a&&"constructor"in b)return!1}d=[];e=[];for(var f=d.length;f--;)if(d[f]===a)return e[f]===b;d.push(a);e.push(b);if(c){f=a.length;if(f!==b.length)return!1;for(;f--;)if(!Ea(a[f],b[f]))return!1}else{c=Da(a);f=c.length;if(Da(b).length!==f)return!1;for(;f--;){var g=c[f];if(!b.hasOwnProperty(g)||!Ea(a[g],b[g]))return!1}}d.pop();e.pop();return!0};function Fa(a,b){a/=1E3;b&&(a=Math.floor(a));return a}function Ga(a){var b=parseInt(a);return null==a||isNaN(b)?null:new Date(1E3*b)}function Ha(a){return null!=a&&Ba(a)?a.toISOString().replace(/\.[0-9]{3}Z$/,""):a}function Ia(a){return null==a||""===a?null:new Date(a)};function D(a,b,c,d,e){this.Fb=a;this.type=b;this.time=null==c||""===c?(new Date).valueOf():c;this.sessionId=d;this.data=e}D.prototype.ic=function(){var a={name:this.type,time:Fa(this.time),data:this.data||{},session_id:this.sessionId};null!=this.Fb&&(a.user_id=this.Fb);return a};D.prototype.B=function(){return{u:this.Fb,t:this.type,ts:this.time,s:this.sessionId,d:this.data}};function Ja(a){return null!=a&&"[object Object]"===Object.prototype.toString.call(a)&&null!=a.t&&""!==a.t}
function Ka(a){return new D(a.u,a.t,a.ts,a.s,a.d)};function Ma(a,b,c){null==a&&(a=oa.Ya());c=parseInt(c);if(isNaN(c)||0===c)c=(new Date).valueOf();this.ea=a;this.xb=c;this.nc=(new Date).valueOf();this.bd=b}Ma.prototype.B=function(){return{g:this.ea,e:this.bd,c:this.xb,l:this.nc}};function Na(a){if(null==a||null==a.g)return null;var b=new Ma(a.g,a.e,a.c);b.nc=a.l;return b};function Oa(a,b,c,d){(d="string"===typeof a||null===a&&d)||v.error("Cannot "+b+" because "+c+' "'+a+'" is invalid.');return d}function Pa(a,b,c){var d=null!=a&&"string"===typeof a&&(""===a||a.match(Qa));d||v.error("Cannot "+b+" because "+c+' "'+a+'" is invalid.');return d}var Qa=/^[^\x00-\x1F\x22]+$/,Ra=/(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;var I={};function J(a,b){this.f=a;this.J=b}p=J.prototype;p.A=function(a){null==a&&v.error("getUserId must be supplied with a callback. e.g., appboy.getUser().getUserId(function(userId) {console.log('the user id is ' + userId)})");"function"===typeof a&&a(this.f.A())};
p.Hf=function(a,b){if(!Oa(a,"add alias","the alias",!1)||0>=a.length)return v.error("addAlias requires a non-empty alias"),!1;if(!Oa(b,"add alias","the label",!1)||0>=b.length)return v.error("addAlias requires a non-empty label"),!1;var c=this.J,d=new Sa,e=Ta(c.G),f=B.Ge;d.j.push(new D(c.f.A(),f,(new Date).valueOf(),e,{a:a,l:b}));d.h=Ua(c.b,d.j);return d.h};p.kg=function(a){return Oa(a,"set first name","the firstName",!0)?this.f.H("first_name",a):!1};
p.og=function(a){return Oa(a,"set last name","the lastName",!0)?this.f.H("last_name",a):!1};p.ig=function(a){return null===a||"string"===typeof a&&null!=a.toLowerCase().match(Ra)?this.f.H("email",a):(v.error('Cannot set email address - "'+a+'" did not pass RFC-5322 validation.'),!1)};p.lg=function(a){"string"===typeof a&&(a=a.toLowerCase());return null===a||ya(Va,a,'Gender "'+a+'" is not a valid gender.',"User.Genders")?this.f.H("gender",a):!1};
p.hg=function(a,b,c){if(null===a&&null===b&&null===c)return this.f.H("dob",null);a=parseInt(a);b=parseInt(b);c=parseInt(c);return isNaN(a)||isNaN(b)||isNaN(c)||12<b||1>b||31<c||1>c?(v.error("Cannot set date of birth - parameters should comprise a valid date e.g. setDateOfBirth(1776, 7, 4);"),!1):this.f.H("dob",""+a+"-"+b+"-"+c)};p.fg=function(a){return Oa(a,"set country","the country",!0)?this.f.H("country",a):!1};
p.mg=function(a){return Oa(a,"set home city","the homeCity",!0)?this.f.H("home_city",a):!1};p.ng=function(a){return Oa(a,"set language","the language",!0)?this.f.H("language",a):!1};p.jg=function(a){return ya(Wa,a,'Email notification setting "'+a+'" is not a valid subscription type.',"User.NotificationSubscriptionTypes")?this.f.H("email_subscribe",a):!1};
p.qd=function(a){return ya(Wa,a,'Push notification setting "'+a+'" is not a valid subscription type.',"User.NotificationSubscriptionTypes")?this.f.H("push_subscribe",a):!1};p.pg=function(a){return Oa(a,"set phone number","the phoneNumber",!0)?null===a||a.match(Xa)?this.f.H("phone",a):(v.error('Cannot set phone number - "'+a+'" did not pass validation.'),!1):!1};p.eg=function(a){return this.f.H("image_url",a)};
p.vc=function(a,b,c,d,e){if(null==a||null==b)return v.error("Cannot set last-known location - latitude and longitude are required."),!1;a=parseFloat(a);b=parseFloat(b);null!=c&&(c=parseFloat(c));null!=d&&(d=parseFloat(d));null!=e&&(e=parseFloat(e));return isNaN(a)||isNaN(b)||null!=c&&isNaN(c)||null!=d&&isNaN(d)||null!=e&&isNaN(e)?(v.error("Cannot set last-known location - all supplied parameters must be numeric."),!1):90<a||-90>a||180<b||-180>b?(v.error("Cannot set last-known location - latitude and longitude are bounded by \u00b190 and \u00b1180 respectively."),
!1):null!=c&&0>c||null!=e&&0>e?(v.error("Cannot set last-known location - accuracy and altitudeAccuracy may not be negative."),!1):this.J.vc(this.f.A(),a,b,d,c,e).h};
p.od=function(a,b){if(!Pa(a,"set custom user attribute","the given key"))return!1;var c=typeof b,d=Ba(b),e=Aa(b);if("number"!==c&&"boolean"!==c&&!d&&!e&&null!==b&&!Pa(b,'set custom user attribute "'+a+'"',"the given value"))return!1;d&&(b=Ha(b));if(e){for(c=0;c<b.length;c++)if(!Pa(b[c],'set custom user attribute "'+a+'"',"the element in the given array"))return!1;return Ya(this.J,B.Te,a,b).h}return this.f.od(a,b)};
p.If=function(a,b){return!Pa(a,"add to custom user attribute array","the given key")||null!=b&&!Pa(b,"add to custom user attribute array","the given value")?!1:Ya(this.J,B.Qe,a,b).h};p.ag=function(a,b){return!Pa(a,"remove from custom user attribute array","the given key")||null!=b&&!Pa(b,"remove from custom user attribute array","the given value")?!1:Ya(this.J,B.Se,a,b).h};
p.Vf=function(a,b){if(!Pa(a,"increment custom user attribute","the given key"))return!1;null==b&&(b=1);var c=parseInt(b);return isNaN(c)||c!==parseFloat(b)?(v.error('Cannot increment custom user attribute because the given incrementValue "'+b+'" is not an integer.'),!1):Ya(this.J,B.Re,a,c).h};p.nd=function(a,b,c,d,e){this.f.nd(a,b,c,d,e);Za(this.J)};p.nb=function(a){this.f.nb(a)};
p.gg=function(a,b,c){if(!Pa(a,"set custom location attribute","the given key"))return!1;if(null!==b||null!==c)if(b=parseFloat(b),c=parseFloat(c),isNaN(b)||90<b||-90>b||isNaN(c)||180<c||-180>c)return v.error("Received invalid values for latitude and/or longitude. Latitude and longitude are bounded by \u00b190 and \u00b1180 respectively, or must both be null for removal."),!1;var d=this.J,e=c;c=new Sa;if($a(d.D,a))v.info('Custom Attribute "'+a+'" is blacklisted, ignoring.'),c.h=!1;else{var f=Ta(d.G);
if(null===b&&null===e){var g=B.jf;a={key:a}}else g=B.hf,a={key:a,latitude:b,longitude:e};c.j.push(new D(d.f.A(),g,(new Date).valueOf(),f,a));c.h=Ua(d.b,c.j)}return c.h};var Xa=/^[0-9 .\\(\\)\\+\\-]+$/,Va={MALE:"m",FEMALE:"f",OTHER:"o",UNKNOWN:"u",NOT_APPLICABLE:"n",PREFER_NOT_TO_SAY:"p"},Wa={OPTED_IN:"opted_in",SUBSCRIBED:"subscribed",UNSUBSCRIBED:"unsubscribed"};I.User=J;I.User.Genders=Va;I.User.NotificationSubscriptionTypes=Wa;I.User.prototype.getUserId=J.prototype.A;
I.User.prototype.setFirstName=J.prototype.kg;I.User.prototype.setLastName=J.prototype.og;I.User.prototype.setEmail=J.prototype.ig;I.User.prototype.setGender=J.prototype.lg;I.User.prototype.setDateOfBirth=J.prototype.hg;I.User.prototype.setCountry=J.prototype.fg;I.User.prototype.setHomeCity=J.prototype.mg;I.User.prototype.setLanguage=J.prototype.ng;I.User.prototype.setEmailNotificationSubscriptionType=J.prototype.jg;I.User.prototype.setPushNotificationSubscriptionType=J.prototype.qd;
I.User.prototype.setPhoneNumber=J.prototype.pg;I.User.prototype.setAvatarImageUrl=J.prototype.eg;I.User.prototype.setLastKnownLocation=J.prototype.vc;I.User.prototype.setUserAttribute=J.prototype.H;I.User.prototype.setCustomUserAttribute=J.prototype.od;I.User.prototype.addToCustomAttributeArray=J.prototype.If;I.User.prototype.removeFromCustomAttributeArray=J.prototype.ag;I.User.prototype.incrementCustomUserAttribute=J.prototype.Vf;I.User.prototype.addAlias=J.prototype.Hf;
I.User.prototype.setCustomLocationAttribute=J.prototype.gg;function ab(){var a=navigator.userAgent||"",b=a.match(/(samsungbrowser|tizen|roku|konqueror|icab|crios|opera|ucbrowser|chrome|safari|firefox|camino|msie|trident(?=\/))\/?\s*(\.?\d+(\.\d+)*)/i)||[];if(/trident/i.test(b[1])){var c=/\brv[ :]+(\.?\d+(\.\d+)*)/g.exec(a)||[];return[bb,c[1]||""]}if(-1!==a.indexOf("(Web0S; Linux/SmartTV)"))return["LG Smart TV",null];if(-1!==a.indexOf("CrKey"))return["Chromecast",null];if(-1!==a.indexOf("BRAVIA")||-1!==a.indexOf("SonyCEBrowser")||-1!==a.indexOf("SonyDTV"))return["Sony Smart TV",
null];if(-1!==a.indexOf("PhilipsTV"))return["Philips Smart TV",null];if(a.match(/\b(Roku)\b/))return["Roku",null];if(a.match(/\bAFTM\b/))return["Amazon Fire Stick",null];if(b[1]===cb&&(c=a.match(/\b(OPR|Edge|EdgA|Edg|UCBrowser)\/(\.?\d+(\.\d+)*)/),null!=c))return c=c.slice(1),c[0]=c[0].replace("OPR",db),c[0]=c[0].replace("EdgA",eb),"Edg"===c[0]&&(c[0]=eb),[c[0],c[1]];if(b[1]===fb&&(c=a.match(/\b(EdgiOS)\/(\.?\d+(\.\d+)*)/),null!=c))return c=c.slice(1),c[0]=c[0].replace("EdgiOS",eb),[c[0],c[1]];b=
b[2]?[b[1],b[2]]:[null,null];null!=(c=a.match(/version\/(\.?\d+(\.\d+)*)/i))&&b.splice(1,1,c[1]);null!=(c=a.match(/\b(UCBrowser)\/(\.?\d+(\.\d+)*)/))&&b.splice(1,1,c[2]);if(b[0]===db&&null!=(c=a.match(/mini\/(\.?\d+(\.\d+)*)/i)))return["Opera Mini",c[1]||""];b[0]&&(a=b[0].toLowerCase(),"msie"===a&&(b[0]=bb),"crios"===a&&(b[0]=cb),"tizen"===a&&(b[0]="Samsung Smart TV",b[1]=null),"samsungbrowser"===a&&(b[0]="Samsung Browser"));return b}
function gb(){for(var a=hb,b=0;b<a.length;b++){var c=a[b].V,d=a[b].Jg;if(c)if(c=c.toLowerCase(),Aa(a[b].P))for(d=0;d<a[b].P.length;d++){if(-1!==c.indexOf(a[b].P[d].toLowerCase()))return a[b].R}else{if(-1!==c.indexOf(a[b].P.toLowerCase()))return a[b].R}else if(d)return a[b].R}}
var ib={td:"Android",Bc:"iOS",lf:"Mac",sf:"Windows"},cb="Chrome",eb="Edge",bb="Internet Explorer",db="Opera",fb="Safari",hb=[{V:navigator.platform,P:"Win",R:ib.sf},{V:navigator.platform,P:"Mac",R:ib.lf},{V:navigator.platform,P:"BlackBerry",R:"BlackBerry"},{V:navigator.platform,P:"FreeBSD",R:"FreeBSD"},{V:navigator.platform,P:"OpenBSD",R:"OpenBSD"},{V:navigator.platform,P:"Nintendo",R:"Nintendo"},{V:navigator.platform,P:"SunOS",R:"SunOS"},{V:navigator.platform,P:"PlayStation",R:"PlayStation"},{V:navigator.platform,
P:"X11",R:"X11"},{V:navigator.userAgent,P:["iPhone","iPad","iPod"],R:ib.Bc},{V:navigator.platform,P:"Pike v",R:ib.Bc},{V:navigator.userAgent,P:["Web0S"],R:"WebOS"},{V:navigator.platform,P:["Linux armv7l","Android"],R:ib.td},{V:navigator.userAgent,P:["Android"],R:ib.td},{V:navigator.platform,P:"Linux",R:"Linux"}],jb=new function(){var a=ab();this.vb=a[0]||"Unknown Browser";this.version=a[1]||"Unknown Version";this.Dd=gb()||navigator.platform;this.language=(navigator.Mg||navigator.language||navigator.browserLanguage||
navigator.Lg||"").toLowerCase();a:{a=navigator.userAgent;a=a.toLowerCase();for(var b="googlebot bingbot slurp duckduckbot baiduspider yandex facebookexternalhit sogou ia_archiver https://github.com/prerender/prerender aolbuild bingpreview msnbot adsbot mediapartners-google teoma".split(" "),c=0;c<b.length;c++)if(-1!==a.indexOf(b[c])){a=!0;break a}a=!1}this.Wf=a;this.userAgent=navigator.userAgent;this.Zf=ib};function kb(a,b){this.ia=a;this.T=b}function lb(a,b,c){var d=c;null!=c&&c instanceof Ma&&(d=c.B());a.ia.store(b,d)}function Ua(a,b){if(null==b||0===b.length)return!1;Aa(b)||(b=[b]);var c=a.T.O(M.Gb);null!=c&&Aa(c)||(c=[]);for(var d=0;d<b.length;d++)c.push(b[d].B());return a.T.store(M.Gb,c)}
function mb(a){var b=a.T.O(M.Gb);a.T.remove(M.Gb);null==b&&(b=[]);a=[];var c=!1,d=null;if(Aa(b))for(var e=0;e<b.length;e++)Ja(b[e])?a.push(Ka(b[e])):d=e;else c=!0;if(c||null!=d)e="Stored events could not be deserialized as Events",c&&(e+=", was "+Object.prototype.toString.call(b)+" not an array"),null!=d&&(e+=", value at index "+d+" does not look like an event"),e+=", serialized values were of type "+typeof b+": "+JSON.stringify(b),a.push(new D(null,B.cf,(new Date).valueOf(),null,{e:e}));return a}
function P(a,b,c){ya(M,b,"StorageManager cannot store object.","StorageManager.KEYS.OBJECTS")&&a.T.store(b,c)}function Q(a,b){return ya(M,b,"StorageManager cannot retrieve object.","StorageManager.KEYS.OBJECTS")?a.T.O(b):!1}function R(a,b){ya(M,b,"StorageManager cannot remove object.","StorageManager.KEYS.OBJECTS")&&a.T.remove(b)}kb.prototype.clearData=function(){for(var a=Da(nb),b=Da(M),c=0;c<a.length;c++)this.ia.remove(nb[a[c]]);for(a=0;a<b.length;a++)this.T.remove(M[b[a]])};
function ob(a,b){var c=a.T.O(M.Ka);null==c&&(c={});var d=b.user_id||M.ud,e;for(e in b)"user_id"===e||null!=c[d]&&null!=c[d][e]||pb(a,b.user_id,e,b[e])}function pb(a,b,c,d){var e=a.T.O(M.Ka);null==e&&(e={});var f=b||M.ud,g=e[f];null==g&&(g={},null!=b&&(g.user_id=b));if("custom"===c){null==g[c]&&(g[c]={});for(var h in d)g[c][h]=d[h]}else g[c]=d;e[f]=g;return a.T.store(M.Ka,e)}function qb(a){var b=a.T.O(M.Ka);a.T.remove(M.Ka);a=[];for(var c in b)null!=b[c]&&a.push(b[c]);return a}
var nb={Oc:"ab.storage.userId",xd:"ab.storage.deviceId",Oa:"ab.storage.sessionId"},M={Lc:"ab.test",Gb:"ab.storage.events",Ka:"ab.storage.attributes",zc:"ab.storage.device",Tb:"ab.storage.pushToken",Gc:"ab.storage.newsFeed",Ec:"ab.storage.lastNewsFeedRefresh",ob:"ab.storage.cardImpressions",Hd:"ab.storage.serverConfig",Mc:"ab.storage.triggers",Nc:"ab.storage.triggers.ts",ff:"ab.storage.lastTriggeredTime",ef:"ab.storage.lastTriggeredTimesById",gf:"ab.storage.lastTriggerEventDataById",Pb:"ab.storage.messagingSessionStart",
pb:"ab.storage.cc",Lb:"ab.storage.ccLastFullSync",Kb:"ab.storage.ccLastCardUpdated",fb:"ab.storage.ccClicks",gb:"ab.storage.ccImpressions",ra:"ab.storage.ccDismissals",Ob:"ab.storage.lastDisplayedTriggerTimesById",Dc:"ab.storage.lastDisplayedTriggerTime",rb:"ab.storage.triggerFireInstancesById"};function rb(a){this.Z=a;this.ne=jb.vb===fb?3:10}rb.prototype.Sa=function(a){return a+"."+this.Z};
rb.prototype.store=function(a,b){b={v:b};try{return localStorage.setItem(this.Sa(a),JSON.stringify(b)),!0}catch(c){return v.info("Storage failure: "+c.message),!1}};rb.prototype.O=function(a){try{var b=JSON.parse(localStorage.getItem(this.Sa(a)));return null==b?null:b.v}catch(c){return v.info("Storage retrieval failure: "+c.message),null}};rb.prototype.remove=function(a){try{localStorage.removeItem(this.Sa(a))}catch(b){return v.info("Storage removal failure: "+b.message),!1}};
function sb(a,b){this.Z=a;a=0;for(var c=document.domain,d=c.split("."),e="ab._gd"+(new Date).valueOf();a<d.length-1&&-1===document.cookie.indexOf(e+"="+e);)a++,c="."+d.slice(-1-a).join("."),document.cookie=e+"="+e+";domain="+c+";";document.cookie=e+"=;expires="+(new Date(0)).toGMTString()+";domain="+c+";";this.Xd=c;this.Pd=525949;this.ae=!!b}sb.prototype.Sa=function(a){return null!=this.Z?a+"."+this.Z:a};function tb(a){var b=new Date;b.setTime(b.getTime()+6E4*a.Pd);return b.getFullYear()}
sb.prototype.store=function(a,b){for(var c=za(nb),d=document.cookie.split(";"),e=0;e<d.length;e++){for(var f=d[e];" "===f.charAt(0);)f=f.substring(1);for(var g=!1,h=0;h<c.length;h++)if(0===f.indexOf(c[h])){g=!0;break}g&&(f=f.split("=")[0],-1===f.indexOf("."+this.Z)&&ub(this,f))}c=new Date;c.setTime(c.getTime()+6E4*this.Pd);c="expires="+c.toUTCString();d="domain="+this.Xd;b=this.ae?b:encodeURIComponent(JSON.stringify(b));a=this.Sa(a)+"="+b+";"+c+";"+d+";path=/";if(4093<=a.length)return v.info("Storage failure: string is "+
a.length+" chars which is too large to store as a cookie."),!1;document.cookie=a;return!0};
sb.prototype.O=function(a){for(var b=[],c=this.Sa(a)+"=",d=document.cookie.split(";"),e=0;e<d.length;e++){for(var f=d[e];" "===f.charAt(0);)f=f.substring(1);if(0===f.indexOf(c))try{var g=void 0;g=this.ae?f.substring(c.length,f.length):JSON.parse(decodeURIComponent(f.substring(c.length,f.length)));b.push(g)}catch(h){return v.info("Storage retrieval failure: "+h.message),this.remove(a),null}}return 0<b.length?b[b.length-1]:null};sb.prototype.remove=function(a){ub(this,this.Sa(a))};
function ub(a,b){b=b+"=;expires="+(new Date(0)).toGMTString();document.cookie=b;document.cookie=b+";path=/";document.cookie=b+";path="+document.location.pathname;a=b+";domain="+a.Xd;document.cookie=a;document.cookie=a+";path=/";document.cookie=a+";path="+document.location.pathname}function vb(){this.Vc={};this.Vd=5242880;this.ne=3}
vb.prototype.store=function(a,b){var c={value:b};var d=[];b=[b];for(var e=0;b.length;){var f=b.pop();if("boolean"===typeof f)e+=4;else if("string"===typeof f)e+=2*f.length;else if("number"===typeof f)e+=8;else if("object"===typeof f&&-1===d.indexOf(f)){d.push(f);for(var g in f)b.push(f[g])}}d=e;if(d>this.Vd)return v.info("Storage failure: object is \u2248"+d+" bytes which is greater than the max of "+this.Vd),!1;this.Vc[a]=c;return!0};vb.prototype.O=function(a){a=this.Vc[a];return null==a?null:a.value};
vb.prototype.remove=function(a){this.Vc[a]=null};function wb(a,b,c){this.ha=[];b&&this.ha.push(new sb(a));c&&this.ha.push(new rb(a));this.ha.push(new vb)}wb.prototype.store=function(a,b){for(var c=!0,d=0;d<this.ha.length;d++)c=this.ha[d].store(a,b)&&c;return c};wb.prototype.O=function(a){for(var b=0;b<this.ha.length;b++){var c=this.ha[b].O(a);if(null!=c)return c}return null};wb.prototype.remove=function(a){for(var b=0;b<this.ha.length;b++)this.ha[b].remove(a)};function xb(){this.ub={}}function yb(a,b){if("function"!==typeof b)return null;var c=oa.Ya();a.ub[c]=b;return c}xb.prototype.S=function(a){delete this.ub[a]};xb.prototype.N=function(){this.ub={}};function zb(a,b){var c=[],d;for(d in a.ub)c.push(a.ub[d](b))};function Ab(){var a=this;if(null==this.Wc){this.Wc=!1;try{var b=Object.defineProperty({},"passive",{get:function(){a.Wc=!0}});window.addEventListener("testPassive",null,b);window.removeEventListener("testPassive",null,b)}catch(c){}}return this.Wc}function Bb(a,b,c){a.addEventListener(b,c,Ab()?{passive:!0}:!1)}
function Cb(a,b,c,d){if(null==a)return!1;b=b||!1;c=c||!1;a=a.getBoundingClientRect();return null==a?!1:(0<=a.top&&a.top<=(window.innerHeight||document.documentElement.clientHeight)||!b)&&(0<=a.left||!d)&&(0<=a.bottom&&a.bottom<=(window.innerHeight||document.documentElement.clientHeight)||!c)&&(a.right<=(window.innerWidth||document.documentElement.clientWidth)||!d)}function Db(a){if(a.onclick){var b=document.createEvent("MouseEvents");b.initEvent("click",!0,!0);a.onclick.apply(a,[b])}}
function Eb(a,b,c){var d=null,e=null;Bb(a,"touchstart",function(f){d=f.touches[0].clientX;e=f.touches[0].clientY});Bb(a,"touchmove",function(f){if(null!=d&&null!=e){var g=d-f.touches[0].clientX,h=e-f.touches[0].clientY;Math.abs(g)>Math.abs(h)&&25<=Math.abs(g)?(0<g&&b===Fb?c(f):0>g&&b===Gb&&c(f),e=d=null):25<=Math.abs(h)&&(0<h&&b===Hb&&a.scrollTop===a.scrollHeight-a.offsetHeight?c(f):0>h&&b===Ib&&0===a.scrollTop&&c(f),e=d=null)}})}
function Jb(a,b,c){var d=document.createElementNS("http://www.w3.org/2000/svg","svg");d.setAttribute("viewBox",a);d.setAttribute("xmlns","http://www.w3.org/2000/svg");a=document.createElementNS("http://www.w3.org/2000/svg","path");a.setAttribute("d",b);null!=c&&a.setAttribute("fill",c);d.appendChild(a);return d}var Hb="up",Ib="down",Fb="left",Gb="right";function Kb(a,b,c){var d=document.createElement("button");d.setAttribute("aria-label",a);d.setAttribute("tabindex","0");d.setAttribute("role","button");Bb(d,"touchstart",function(){});d.className="ab-close-button";a=Jb("0 0 15 15","M15 1.5L13.5 0l-6 6-6-6L0 1.5l6 6-6 6L1.5 15l6-6 6 6 1.5-1.5-6-6 6-6z",b);d.appendChild(a);d.addEventListener("keydown",function(e){if(32===e.keyCode||13===e.keyCode)c(),e.stopPropagation()});d.onclick=function(e){c();e.stopPropagation()};return d};var Lb={Xf:function(){return 600>=screen.width},Sf:function(){if("orientation"in window)return 90===Math.abs(window.orientation)||270===window.orientation?Lb.Ma.Cc:Lb.Ma.Sb;if("screen"in window){var a=window.screen.orientation||screen.Gg||screen.Ig;null!=a&&"object"===typeof a&&(a=a.type);if("landscape-primary"===a||"landscape-secondary"===a)return Lb.Ma.Cc}return Lb.Ma.Sb},Yf:function(a,b,c){c||null!=b&&b.metaKey?window.open(a):window.location=a},Ma:{Sb:0,Cc:1}};I.WindowUtils=Lb;
I.WindowUtils.openUri=Lb.Yf;function Mb(a,b,c,d,e,f,g,h,l,k,m,q,t,r,y,A){this.id=a;this.viewed=b||!1;this.title=c||"";this.imageUrl=d;this.description=e||"";this.created=f||null;this.updated=g||null;this.categories=h||[];this.expiresAt=l||null;this.url=k;this.linkText=m;q=parseFloat(q);this.aspectRatio=isNaN(q)?null:q;this.extras=t;this.pinned=r||!1;this.dismissible=y||!1;this.dismissed=!1;this.clicked=A||!1;this.Rc=this.W=null}function Nb(a){null==a.W&&(a.W=new xb);return a.W}
function Ob(a){null==a.Rc&&(a.Rc=new xb);return a.Rc}p=Mb.prototype;p.wc=function(a){return yb(Nb(this),a)};p.ye=function(a){return yb(Ob(this),a)};p.S=function(a){Nb(this).S(a);Ob(this).S(a)};p.N=function(){Nb(this).N();Ob(this).N()};p.md=function(){this.viewed=!0};p.eb=function(){this.clicked=this.viewed=!0;zb(Nb(this))};p.kd=function(){return this.dismissible&&!this.dismissed?(this.dismissed=!0,zb(Ob(this)),!0):!1};
function Pb(a,b){if(null==b||b[S.ta]!==a.id)return!0;if(b[S.Gd])return!1;if(null!=b[S.aa]&&null!=a.updated&&b[S.aa]<Fa(a.updated.valueOf()))return!0;b[S.wa]&&!a.viewed&&(a.viewed=!0);b[S.qa]&&!a.clicked&&(a.clicked=b[S.qa]);null!=b[S.Pa]&&(a.title=b[S.Pa]);null!=b[S.ua]&&(a.imageUrl=b[S.ua]);null!=b[S.La]&&(a.description=b[S.La]);if(null!=b[S.aa]){var c=Ga(b[S.aa]);null!=c&&(a.updated=c)}null!=b[S.$]&&(a.expiresAt=b[S.$]===Qb?null:Ga(b[S.$]));null!=b[S.URL]&&(a.url=b[S.URL]);null!=b[S.va]&&(a.linkText=
b[S.va]);null!=b[S.pa]&&(c=parseFloat(b[S.pa]),a.aspectRatio=isNaN(c)?null:c);null!=b[S.fa]&&(a.extras=b[S.fa]);null!=b[S.ga]&&(a.pinned=b[S.ga]);null!=b[S.sa]&&(a.dismissible=b[S.sa]);return!0}
function Rb(a){if(a[S.Gd])return null;var b=a[S.ta],c=a[S.Qa],d=a[S.wa],e=a[S.Pa],f=a[S.ua],g=a[S.La],h=Ga(a[S.aa]);var l=a[S.$]===Qb?null:Ga(a[S.$]);var k=a[S.URL],m=a[S.va],q=a[S.pa],t=a[S.fa],r=a[S.ga],y=a[S.sa];a=a[T.qa];return c===Sb.Kd||c===Sb.Rb?new Tb(b,d,e,f,g,null,h,null,l,k,m,q,t,r,y,a):c===Sb.Ib?new Ub(b,d,e,f,g,null,h,null,l,k,m,q,t,r,y,a):c===Sb.Hb?new Vb(b,d,f,null,h,null,l,k,m,q,t,r,y,a):c===Sb.xc?new Wb(b,d,h,l,t,r):null}
function Xb(a){var b=a[T.ta],c=a[T.Qa],d=a[T.wa],e=a[T.Pa],f=a[T.ua],g=a[T.La],h=Ia(a[T.Mb]),l=Ia(a[T.aa]),k=a[T.Jb],m=Ia(a[T.$]),q=a[T.URL],t=a[T.va],r=a[T.pa],y=a[T.fa],A=a[T.ga],z=a[T.sa];a=a[T.qa];if(c===Sb.Rb)return new Tb(b,d,e,f,g,h,l,k,m,q,t,r,y,A,z,a);if(c===Sb.Ib)return new Ub(b,d,e,f,g,h,l,k,m,q,t,r,y,A,z,a);if(c===Sb.Hb)return new Vb(b,d,f,h,l,k,m,q,t,r,y,A,z,a);if(c===Sb.xc)return new Wb(b,d,l,m,y,A)}
function Yb(a){null!=a&&(a=a.querySelectorAll(".ab-unread-indicator")[0],null!=a&&(a.className+=" read"))}
p.Y=function(a,b,c){function d(q){Yb(f);g&&(a(e),Lb.openUri(e.url,q,c));return!1}var e=this,f=document.createElement("div");f.className="ab-card ab-effect-card "+this.constructor.prototype.jc;f.setAttribute("data-ab-card-id",this.id);f.setAttribute("role","article");f.setAttribute("tabindex","0");var g=this.url&&""!==this.url;if(this.pinned){var h=document.createElement("div");h.className="ab-pinned-indicator";var l=document.createElement("i");l.className="fa fa-star";h.appendChild(l);f.appendChild(h)}this.imageUrl&&
""!==this.imageUrl&&(h=document.createElement("div"),h.className="ab-image-area",l=document.createElement("img"),l.setAttribute("src",this.imageUrl),h.appendChild(l),f.className+=" with-image",g&&!this.constructor.prototype.mc?(l=document.createElement("a"),l.setAttribute("href",this.url),l.onclick=d,l.appendChild(h),f.appendChild(l)):f.appendChild(h));h=document.createElement("div");h.className="ab-card-body";if(this.dismissible){this.Ud=b;var k=Kb("Dismiss Card",void 0,this.le.bind(this));f.appendChild(k);
Eb(h,Fb,function(q){f.className+=" ab-swiped-left";k.onclick(q)});Eb(h,Gb,function(q){f.className+=" ab-swiped-right";k.onclick(q)})}if(b=this.title&&""!==this.title){l=document.createElement("h1");l.className="ab-title";l.id=oa.Ya();f.setAttribute("aria-labelledby",l.id);if(g){var m=document.createElement("a");m.setAttribute("href",this.url);m.onclick=d;m.appendChild(document.createTextNode(this.title));l.appendChild(m)}else l.appendChild(document.createTextNode(this.title));h.appendChild(l)}l=document.createElement("div");
l.className=b?"ab-description":"ab-description ab-no-title";l.id=oa.Ya();f.setAttribute("aria-describedby",l.id);l.appendChild(document.createTextNode(this.description));g&&(b=document.createElement("div"),b.className="ab-url-area",m=document.createElement("a"),m.setAttribute("href",this.url),m.appendChild(document.createTextNode(this.linkText)),m.onclick=d,b.appendChild(m),l.appendChild(b));h.appendChild(l);f.appendChild(h);h=document.createElement("div");h.className="ab-unread-indicator";this.viewed&&
(h.className+=" read");f.appendChild(h);return this.yf=f};p.le=function(){if(this.dismissible&&!this.dismissed){this.Ud&&this.Ud(this);var a=this.yf;a&&(a.style.height=a.offsetHeight+"px",a.className+=" ab-hide",setTimeout(function(){a&&a.parentNode&&(a.style.height="0",a.style.margin="0",setTimeout(function(){a&&a.parentNode&&a.parentNode.removeChild(a)},Zb))},$b))}};
var Qb=-1,Sb={Ib:"captioned_image",Kd:"text_announcement",Rb:"short_news",Hb:"banner_image",xc:"control"},S={ta:"id",wa:"v",sa:"db",Gd:"r",aa:"ca",ga:"p",$:"ea",fa:"e",Qa:"tp",ua:"i",Pa:"tt",La:"ds",URL:"u",va:"dm",pa:"ar",qa:"cl"},T={ta:"id",wa:"v",sa:"db",Mb:"cr",aa:"ca",ga:"p",Jb:"t",$:"ea",fa:"e",Qa:"tp",ua:"i",Pa:"tt",La:"ds",URL:"u",va:"dm",pa:"ar",qa:"cl"},Zb=400;I.Card=Mb;I.Card.prototype.dismissCard=Mb.prototype.le;function Vb(a,b,c,d,e,f,g,h,l,k,m,q,t,r){Mb.call(this,a,b,null,c,null,d,e,f,g,h,l,k,m,q,t,r)}ia(Vb,Mb);Vb.prototype.B=function(){var a={};a[T.Qa]=Sb.Hb;a[T.ta]=this.id;a[T.wa]=this.viewed;a[T.ua]=this.imageUrl;a[T.aa]=this.updated;a[T.Mb]=this.created;a[T.Jb]=this.categories;a[T.$]=this.expiresAt;a[T.URL]=this.url;a[T.va]=this.linkText;a[T.pa]=this.aspectRatio;a[T.fa]=this.extras;a[T.ga]=this.pinned;a[T.sa]=this.dismissible;a[T.qa]=this.clicked;return a};
ja.Object.defineProperties(Vb.prototype,{jc:{configurable:!0,enumerable:!0,get:function(){return"ab-banner"}},mc:{configurable:!0,enumerable:!0,get:function(){return!1}}});I.Banner=Vb;function Ub(a,b,c,d,e,f,g,h,l,k,m,q,t,r,y,A){Mb.call(this,a,b,c,d,e,f,g,h,l,k,m,q,t,r,y,A)}ia(Ub,Mb);Ub.prototype.B=function(){var a={};a[T.Qa]=Sb.Ib;a[T.ta]=this.id;a[T.wa]=this.viewed;a[T.Pa]=this.title;a[T.ua]=this.imageUrl;a[T.La]=this.description;a[T.aa]=this.updated;a[T.Mb]=this.created;a[T.Jb]=this.categories;a[T.$]=this.expiresAt;a[T.URL]=this.url;a[T.va]=this.linkText;a[T.pa]=this.aspectRatio;a[T.fa]=this.extras;a[T.ga]=this.pinned;a[T.sa]=this.dismissible;a[T.qa]=this.clicked;return a};
ja.Object.defineProperties(Ub.prototype,{jc:{configurable:!0,enumerable:!0,get:function(){return"ab-captioned-image"}},mc:{configurable:!0,enumerable:!0,get:function(){return!0}}});I.CaptionedImage=Ub;function Tb(a,b,c,d,e,f,g,h,l,k,m,q,t,r,y,A){Mb.call(this,a,b,c,d,e,f,g,h,l,k,m,q,t,r,y,A)}ia(Tb,Mb);Tb.prototype.B=function(){var a={};a[T.Qa]=Sb.Rb;a[T.ta]=this.id;a[T.wa]=this.viewed;a[T.Pa]=this.title;a[T.ua]=this.imageUrl;a[T.La]=this.description;a[T.aa]=this.updated;a[T.Mb]=this.created;a[T.Jb]=this.categories;a[T.$]=this.expiresAt;a[T.URL]=this.url;a[T.va]=this.linkText;a[T.pa]=this.aspectRatio;a[T.fa]=this.extras;a[T.ga]=this.pinned;a[T.sa]=this.dismissible;a[T.qa]=this.clicked;return a};
ja.Object.defineProperties(Tb.prototype,{jc:{configurable:!0,enumerable:!0,get:function(){return"ab-classic-card"}},mc:{configurable:!0,enumerable:!0,get:function(){return!0}}});I.ClassicCard=Tb;function Wb(a,b,c,d,e,f){Mb.call(this,a,b,null,null,null,null,c,null,d,null,null,null,e,f,null)}ia(Wb,Mb);Wb.prototype.B=function(){var a={};a[T.Qa]=Sb.xc;a[T.ta]=this.id;a[T.wa]=this.viewed;a[T.aa]=this.updated;a[T.$]=this.expiresAt;a[T.fa]=this.extras;a[T.ga]=this.pinned;return a};ja.Object.defineProperties(Wb.prototype,{jc:{configurable:!0,enumerable:!0,get:function(){return"ab-control-card"}},mc:{configurable:!0,enumerable:!0,get:function(){return!1}}});I.ControlCard=Wb;function ac(a){a=parseInt(a);return!isNaN(a)&&0===(a&4278190080)>>>24}function bc(a){a=parseInt(a);if(isNaN(a))return"";var b=parseFloat(b);isNaN(b)&&(b=1);a>>>=0;var c=a&255,d=(a&65280)>>>8,e=(a&16711680)>>>16;return(jb.vb===bb?8<jb.version:1)?"rgba("+[e,d,c,((a&4278190080)>>>24)/255*b].join()+")":"rgb("+[e,d,c].join()+")"};function U(a,b,c,d,e,f,g,h,l,k,m,q,t,r,y,A,z,F,G,E,K,N,L,Y,ea,n,u,x,C,H,O){this.message=a;this.messageAlignment=b||cc.CENTER;this.duration=q||5E3;this.slideFrom=c||dc.BOTTOM;this.extras=d||[];this.campaignId=e;this.cardId=f;this.triggerId=g;this.clickAction=h||ec.NONE;this.uri=l;this.openTarget=k||fc.NONE;this.dismissType=m||gc.AUTO_DISMISS;this.icon=t;this.imageUrl=r;this.imageStyle=y||hc.TOP;this.iconColor=A||ic.Pc;this.iconBackgroundColor=z||ic.vd;this.backgroundColor=F||ic.Pc;this.textColor=G||
ic.wd;this.closeButtonColor=E||ic.Ve;this.animateIn=K;null==this.animateIn&&(this.animateIn=!0);this.animateOut=N;null==this.animateOut&&(this.animateOut=!0);this.header=L;this.headerAlignment=Y||cc.CENTER;this.headerTextColor=ea||ic.wd;this.frameColor=n||ic.qf;this.buttons=u||[];this.cropType=x||jc;this.orientation=C;this.htmlId=H;this.css=O;this.Qd=this.Ra=this.Rd=!1;this.W=new xb;this.Yb=new xb}p=U.prototype;p.Za=function(){return!0};p.Ce=function(){return this.Za()};
function kc(a){return null!=a.htmlId&&4<a.htmlId.length}function lc(a){return kc(a)&&null!=a.css&&0<a.css.length}function mc(a){if(kc(a)&&lc(a))return a.htmlId+"-css"}p.wc=function(a){return yb(this.W,a)};p.ye=function(a){return yb(this.Yb,a)};p.S=function(a){this.W.S(a);this.Yb.S(a)};p.N=function(){this.W.N();this.Yb.N()};p.md=function(){return this.Rd?!1:this.Rd=!0};p.eb=function(){return this.Ra?!1:(this.Ra=!0,zb(this.W),!0)};p.kd=function(){return this.Qd?!1:(this.Qd=!0,zb(this.Yb),!0)};
function nc(a){if(a.is_control)return new oc(a.trigger_id);var b=a.type;null!=b&&(b=b.toUpperCase());var c=a.message,d=a.text_align_message,e=a.slide_from,f=a.extras,g=a.campaign_id,h=a.card_id,l=a.trigger_id,k=a.click_action,m=a.uri,q=a.open_target,t=a.message_close,r=a.duration,y=a.icon,A=a.image_url,z=a.image_style,F=a.icon_color,G=a.icon_bg_color,E=a.bg_color,K=a.text_color,N=a.close_btn_color,L=a.header,Y=a.text_align_header,ea=a.header_text_color,n=a.frame_color,u=[],x=a.btns;null==x&&(x=[]);
for(var C=0;C<x.length;C++){var H=x[C];u.push(new pc(H.text,H.bg_color,H.text_color,H.border_color,H.click_action,H.uri,H.id))}x=a.crop_type;C=a.orientation;H=a.animate_in;var O=a.animate_out,Z=a.html_id,na=a.css;if(null==Z||""===Z||null==na||""===na)na=Z=void 0;if(b===qc||b===rc)c=new sc(c,d,f,g,h,l,k,m,q,t,r,y,A,z,F,G,E,K,N,H,O,L,Y,ea,n,u,x,Z,na);else if(b===tc)c=new uc(c,d,f,g,h,l,k,m,q,t,r,y,A,z,F,G,E,K,N,H,O,L,Y,ea,n,u,x,C,Z,na);else if(b===vc)c=new wc(c,d,e,f,g,h,l,k,m,q,t,r,y,A,F,G,E,K,N,H,
O,Z,na);else if(b===xc||b===yc)c=new zc(c,f,g,h,l,t,r,H,O,n,Z,na,a.message_fields),c.xg=a.trusted||!1;else{v.error("Ignoring message with unknown type "+b);return}c.dg=b;return c}function Ac(a,b){if(b&&b.parentNode){var c=b.closest(".ab-iam-root");null==c&&(c=b);a.Za()&&null!=c.parentNode&&((b=c.parentNode.classList)&&b.contains(Bc)&&b.remove(Bc),document.body.removeEventListener("touchmove",Cc));c.className=c.className.replace(Dc,Ec)}return a.animateOut}
function Fc(a,b,c){if(null!=b){a.bc=null;var d=-1===b.className.indexOf("ab-in-app-message")?b.getElementsByClassName("ab-in-app-message")[0]:b;var e=!1;d&&(e=Ac(a,d));var f=document.body;if(null!=f)var g=f.scrollTop;d=function(){if(b&&b.parentNode){var h=b.closest(".ab-iam-root");null==h&&(h=b);h.parentNode&&h.parentNode.removeChild(h)}null!=mc(a)&&(h=document.getElementById(mc(a)))&&h.parentNode&&h.parentNode.removeChild(h);null!=f&&"Safari"===jb.vb&&(f.scrollTop=g);c?c():a.kd()};e?setTimeout(d,
Gc):d();a.cc&&a.cc.focus()}}p.ge=function(){Fc(this,this.bc)};
p.Y=function(a,b,c,d){function e(){-1!==g.className.indexOf("ab-start-hidden")&&(g.className=g.className.replace("ab-start-hidden",""),c(g))}var f=this,g=document.createElement("div");g.className="ab-in-app-message ab-start-hidden ab-background";this.Za()&&(g.className+=" ab-modal-interactions",g.setAttribute("tabindex","-1"));lc(this)||(g.style.color=bc(this.textColor),g.style.backgroundColor=bc(this.backgroundColor),ac(this.backgroundColor)&&(g.className+=" ab-no-shadow"));this.imageStyle===hc.GRAPHIC&&
(g.className+=" graphic");this.orientation===Hc.LANDSCAPE&&(g.className+=" landscape");0===this.buttons.length&&(this.clickAction!==ec.NONE&&(g.className+=" ab-clickable"),g.onclick=function(t){Fc(f,g,function(){a.qc(f);f.clickAction===ec.URI?Lb.openUri(f.uri,t,d||f.openTarget===fc.BLANK):f.clickAction===ec.NEWS_FEED&&b()});t.stopPropagation();return!1});var h=Kb("Close Message",lc(this)?void 0:bc(this.closeButtonColor),function(){Fc(f,g)});g.appendChild(h);h=document.createElement("div");h.className=
"ab-message-text";h.className+=" "+(this.messageAlignment||this.constructor.DefaultTextAlignment).toLowerCase()+"-aligned";var l=!1,k=document.createElement("div");k.className="ab-image-area";if(this.imageUrl){if(this.cropType===Ic.CENTER_CROP){var m=document.createElement("span");m.className="ab-center-cropped-img";m.style.backgroundImage="url("+this.imageUrl+")";k.appendChild(m)}else m=document.createElement("img"),m.setAttribute("src",this.imageUrl),l=!0,m.onload=e,setTimeout(e,1E3),k.appendChild(m);
g.appendChild(k);h.className+=" ab-with-image"}else if(this.icon){k.className+=" ab-icon-area";m=document.createElement("span");m.className="ab-icon";lc(this)||(m.style.backgroundColor=bc(this.iconBackgroundColor),m.style.color=bc(this.iconColor));var q=document.createElement("i");q.className="fa";q.appendChild(document.createTextNode(this.icon));m.appendChild(q);k.appendChild(m);g.appendChild(k);h.className+=" ab-with-icon"}Bb(h,"touchstart",function(){});this.header&&0<this.header.length&&(k=document.createElement("h1"),
k.className="ab-message-header",this.Sc=oa.Ya(),k.id=this.Sc,k.className+=" "+(this.headerAlignment||Jc).toLowerCase()+"-aligned",lc(this)||(k.style.color=bc(this.headerTextColor)),k.appendChild(document.createTextNode(this.header)),h.appendChild(k));h.appendChild(this.fe());g.appendChild(h);l||e();return this.bc=g};p.fe=function(){return document.createTextNode(this.message)};
function Cc(a){a.targetTouches&&1<a.targetTouches.length||a.target.classList&&a.target.classList.contains("ab-message-text")&&a.target.scrollHeight>a.target.clientHeight||a.preventDefault()}p.rc=function(a){this.Za()&&null!=a.parentNode&&this.orientation!==Hc.LANDSCAPE&&(null!=a.parentNode.classList&&a.parentNode.classList.add(Bc),document.body.addEventListener("touchmove",Cc,Ab()?{passive:!1}:!1));a.className+=" "+Dc};
p.ma=function(){var a="";this.animateIn&&(a+=" ab-animate-in");this.animateOut&&(a+=" ab-animate-out");return a};
var ic={wd:4281545523,Pc:4294967295,vd:4278219733,We:4293914607,Xe:4283782485,qf:3224580915,Ve:4288387995},Kc={yd:"hd",Fe:"ias",mf:"of",Ye:"do",sb:"umt",qb:"tf",zd:"te"},dc={TOP:"TOP",BOTTOM:"BOTTOM"},ec={NEWS_FEED:"NEWS_FEED",URI:"URI",NONE:"NONE"},gc={AUTO_DISMISS:"AUTO_DISMISS",MANUAL:"SWIPE"},fc={NONE:"NONE",BLANK:"BLANK"},hc={TOP:"TOP",GRAPHIC:"GRAPHIC"},Hc={PORTRAIT:"PORTRAIT",LANDSCAPE:"LANDSCAPE"},Jc="CENTER",cc={START:"START",CENTER:Jc,END:"END"},jc="FIT_CENTER",Ic={CENTER_CROP:"CENTER_CROP",
FIT_CENTER:jc},vc="SLIDEUP",qc="MODAL",rc="MODAL_STYLED",tc="FULL",xc="WEB_HTML",yc="HTML",Gc=500,Dc="ab-show",Ec="ab-hide",Bc="ab-pause-scrolling";I.InAppMessage=U;I.InAppMessage.SlideFrom=dc;I.InAppMessage.ClickAction=ec;I.InAppMessage.DismissType=gc;I.InAppMessage.OpenTarget=fc;I.InAppMessage.ImageStyle=hc;I.InAppMessage.TextAlignment=cc;I.InAppMessage.Orientation=Hc;I.InAppMessage.CropType=Ic;I.InAppMessage.prototype.subscribeToClickedEvent=U.prototype.wc;
I.InAppMessage.prototype.subscribeToDismissedEvent=U.prototype.ye;I.InAppMessage.prototype.removeSubscription=U.prototype.S;I.InAppMessage.prototype.removeAllSubscriptions=U.prototype.N;I.InAppMessage.prototype.closeMessage=U.prototype.ge;function pc(a,b,c,d,e,f,g){this.text=a||"";this.backgroundColor=b||ic.vd;this.textColor=c||ic.Pc;this.borderColor=d||this.backgroundColor;this.clickAction=e||ec.NEWS_FEED;this.uri=f;null==g&&(g=Lc);this.id=g;this.Ra=!1;this.W=new xb}pc.prototype.wc=function(a){return yb(this.W,a)};pc.prototype.S=function(a){this.W.S(a)};pc.prototype.N=function(){this.W.N()};pc.prototype.eb=function(){return this.Ra?!1:(this.Ra=!0,zb(this.W),!0)};var Lc=-1;I.InAppMessage.Button=pc;
I.InAppMessage.Button.prototype.subscribeToClickedEvent=pc.prototype.wc;I.InAppMessage.Button.prototype.removeSubscription=pc.prototype.S;I.InAppMessage.Button.prototype.removeAllSubscriptions=pc.prototype.N;function oc(a){this.triggerId=a}I.ControlMessage=oc;function Mc(a){var b=a.querySelectorAll(".ab-close-button, .ab-message-button");if(0<b.length){var c=b[0],d=b[b.length-1];a.addEventListener("keydown",function(e){var f=document.activeElement;9===e.keyCode&&(e.shiftKey||f!==d&&f!==a?!e.shiftKey||f!==c&&f!==a||(e.preventDefault(),d.focus()):(e.preventDefault(),c.focus()))})}}function Nc(a,b){b.setAttribute("role","dialog");b.setAttribute("aria-modal",!0);b.setAttribute("aria-label","Modal Message");a&&b.setAttribute("aria-labelledby",a)}
function Oc(a,b,c,d,e){if(0<a.buttons.length){var f=document.createElement("div");f.className="ab-message-buttons";d.appendChild(f);var g=d.getElementsByClassName("ab-message-text")[0];null!=g&&(g.className+=" ab-with-buttons");g=function(q){return function(t){Fc(a,d,function(){b.pc(q,a);q.clickAction===ec.URI?Lb.openUri(q.uri,t,e||a.openTarget===fc.BLANK):q.clickAction===ec.NEWS_FEED&&c()});t.stopPropagation();return!1}};for(var h=0;h<a.buttons.length;h++){var l=a.buttons[h],k=document.createElement("button");
k.className="ab-message-button";k.setAttribute("type","button");Bb(k,"touchstart",function(){});var m=l.text;""===l.text&&(m="\u00a0");k.appendChild(document.createTextNode(m));lc(a)||(k.style.backgroundColor=bc(l.backgroundColor),k.style.color=bc(l.textColor),k.style.borderColor=bc(l.borderColor));k.onclick=g(l);f.appendChild(k)}}};function uc(a,b,c,d,e,f,g,h,l,k,m,q,t,r,y,A,z,F,G,E,K,N,L,Y,ea,n,u,x,C,H){k=k||gc.MANUAL;x=x||Hc.PORTRAIT;u=u||Ic.CENTER_CROP;U.call(this,a,b,null,c,d,e,f,g,h,l,k,m,q,t,r,y,A,z,F,G,E,K,N,L,Y,ea,n,u,x,C,H)}ia(uc,U);uc.prototype.Y=function(a,b,c,d,e){this.cc=document.activeElement;b=U.prototype.Y.call(this,a,c,d,e);b.className+=" ab-fullscreen ab-centered";Oc(this,a,c,b,e);Mc(b);Nc(this.Sc,b);return b};uc.prototype.ma=function(){return U.prototype.ma.call(this)+" ab-effect-fullscreen"};
uc.DefaultTextAlignment=Jc;I.FullScreenMessage=uc;var Pc=new function(){this.je=".ab-pause-scrolling,body.ab-pause-scrolling,html.ab-pause-scrolling{overflow:hidden;touch-action:none}.ab-centering-div,.ab-iam-root.v3{position:fixed;top:0;right:0;bottom:0;left:0;pointer-events:none;z-index:1050;-webkit-tap-highlight-color:transparent}.ab-centering-div:focus,.ab-iam-root.v3:focus{outline:0}.ab-centering-div.ab-effect-fullscreen,.ab-centering-div.ab-effect-html,.ab-centering-div.ab-effect-modal,.ab-iam-root.v3.ab-effect-fullscreen,.ab-iam-root.v3.ab-effect-html,.ab-iam-root.v3.ab-effect-modal{opacity:0}.ab-centering-div.ab-effect-fullscreen.ab-show,.ab-centering-div.ab-effect-html.ab-show,.ab-centering-div.ab-effect-modal.ab-show,.ab-iam-root.v3.ab-effect-fullscreen.ab-show,.ab-iam-root.v3.ab-effect-html.ab-show,.ab-iam-root.v3.ab-effect-modal.ab-show{opacity:1}.ab-centering-div.ab-effect-fullscreen.ab-show.ab-animate-in,.ab-centering-div.ab-effect-html.ab-show.ab-animate-in,.ab-centering-div.ab-effect-modal.ab-show.ab-animate-in,.ab-iam-root.v3.ab-effect-fullscreen.ab-show.ab-animate-in,.ab-iam-root.v3.ab-effect-html.ab-show.ab-animate-in,.ab-iam-root.v3.ab-effect-modal.ab-show.ab-animate-in{-webkit-transition:opacity .5s;-moz-transition:opacity .5s;-o-transition:opacity .5s;transition:opacity .5s}.ab-centering-div.ab-effect-fullscreen.ab-hide,.ab-centering-div.ab-effect-html.ab-hide,.ab-centering-div.ab-effect-modal.ab-hide,.ab-iam-root.v3.ab-effect-fullscreen.ab-hide,.ab-iam-root.v3.ab-effect-html.ab-hide,.ab-iam-root.v3.ab-effect-modal.ab-hide{opacity:0}.ab-centering-div.ab-effect-fullscreen.ab-hide.ab-animate-out,.ab-centering-div.ab-effect-html.ab-hide.ab-animate-out,.ab-centering-div.ab-effect-modal.ab-hide.ab-animate-out,.ab-iam-root.v3.ab-effect-fullscreen.ab-hide.ab-animate-out,.ab-iam-root.v3.ab-effect-html.ab-hide.ab-animate-out,.ab-iam-root.v3.ab-effect-modal.ab-hide.ab-animate-out{-webkit-transition:opacity .5s;-moz-transition:opacity .5s;-o-transition:opacity .5s;transition:opacity .5s}.ab-centering-div.ab-effect-slide .ab-in-app-message,.ab-iam-root.v3.ab-effect-slide .ab-in-app-message{-webkit-transform:translateX(535px);-moz-transform:translateX(535px);-ms-transform:translateX(535px);transform:translateX(535px)}.ab-centering-div.ab-effect-slide.ab-show .ab-in-app-message,.ab-iam-root.v3.ab-effect-slide.ab-show .ab-in-app-message{-webkit-transform:translateX(0);-moz-transform:translateX(0);-ms-transform:translateX(0);transform:translateX(0)}.ab-centering-div.ab-effect-slide.ab-show.ab-animate-in .ab-in-app-message,.ab-iam-root.v3.ab-effect-slide.ab-show.ab-animate-in .ab-in-app-message{-webkit-transition:transform .5s ease-in-out;-moz-transition:transform .5s ease-in-out;-o-transition:transform .5s ease-in-out;transition:transform .5s ease-in-out}.ab-centering-div.ab-effect-slide.ab-hide .ab-in-app-message,.ab-iam-root.v3.ab-effect-slide.ab-hide .ab-in-app-message{-webkit-transform:translateX(535px);-moz-transform:translateX(535px);-ms-transform:translateX(535px);transform:translateX(535px)}.ab-centering-div.ab-effect-slide.ab-hide .ab-in-app-message.ab-swiped-left,.ab-iam-root.v3.ab-effect-slide.ab-hide .ab-in-app-message.ab-swiped-left{-webkit-transform:translateX(-535px);-moz-transform:translateX(-535px);-ms-transform:translateX(-535px);transform:translateX(-535px)}.ab-centering-div.ab-effect-slide.ab-hide .ab-in-app-message.ab-swiped-up,.ab-iam-root.v3.ab-effect-slide.ab-hide .ab-in-app-message.ab-swiped-up{-webkit-transform:translateY(-535px);-moz-transform:translateY(-535px);-ms-transform:translateY(-535px);transform:translateY(-535px)}.ab-centering-div.ab-effect-slide.ab-hide .ab-in-app-message.ab-swiped-down,.ab-iam-root.v3.ab-effect-slide.ab-hide .ab-in-app-message.ab-swiped-down{-webkit-transform:translateY(535px);-moz-transform:translateY(535px);-ms-transform:translateY(535px);transform:translateY(535px)}.ab-centering-div.ab-effect-slide.ab-hide.ab-animate-out .ab-in-app-message,.ab-iam-root.v3.ab-effect-slide.ab-hide.ab-animate-out .ab-in-app-message{-webkit-transition:transform .5s ease-in-out;-moz-transition:transform .5s ease-in-out;-o-transition:transform .5s ease-in-out;transition:transform .5s ease-in-out}.ab-centering-div .ab-ios-scroll-wrapper,.ab-iam-root.v3 .ab-ios-scroll-wrapper{position:fixed;top:0;right:0;bottom:0;left:0;overflow:auto;pointer-events:all;touch-action:auto;-webkit-overflow-scrolling:touch}.ab-centering-div .ab-in-app-message,.ab-iam-root.v3 .ab-in-app-message{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;position:fixed;text-align:center;-webkit-box-shadow:0 0 4px rgba(0,0,0,.3);-moz-box-shadow:0 0 4px rgba(0,0,0,.3);box-shadow:0 0 4px rgba(0,0,0,.3);line-height:normal;letter-spacing:normal;font-family:'Helvetica Neue Light','Helvetica Neue',Helvetica,Arial,'Lucida Grande',sans-serif;z-index:1050;max-width:100%;overflow:hidden;display:inline-block;pointer-events:all;color:#333}.ab-centering-div .ab-in-app-message.ab-no-shadow,.ab-iam-root.v3 .ab-in-app-message.ab-no-shadow{-webkit-box-shadow:none;-moz-box-shadow:none;box-shadow:none}.ab-centering-div .ab-in-app-message :focus,.ab-centering-div .ab-in-app-message:focus,.ab-iam-root.v3 .ab-in-app-message :focus,.ab-iam-root.v3 .ab-in-app-message:focus{outline:0}.ab-centering-div .ab-in-app-message.ab-clickable,.ab-iam-root.v3 .ab-in-app-message.ab-clickable{cursor:pointer}.ab-centering-div .ab-in-app-message.ab-background,.ab-iam-root.v3 .ab-in-app-message.ab-background{background-color:#fff}.ab-centering-div .ab-in-app-message .ab-close-button,.ab-iam-root.v3 .ab-in-app-message .ab-close-button{-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box;background-color:transparent;background-repeat:no-repeat;background-origin:content-box;background-size:15px;border:none;width:15px;height:15px;-webkit-border-radius:7.5px;-moz-border-radius:7.5px;border-radius:7.5px;cursor:pointer;display:block;font-size:15px;line-height:0;padding-top:15px;padding-right:15px;padding-left:10px;padding-bottom:10px;position:absolute;right:0;top:0;text-align:center;z-index:1060}.ab-centering-div .ab-in-app-message .ab-close-button svg,.ab-iam-root.v3 .ab-in-app-message .ab-close-button svg{-webkit-transition:.2s ease;-moz-transition:.2s ease;-o-transition:.2s ease;transition:.2s ease;fill:#9b9b9b}.ab-centering-div .ab-in-app-message .ab-close-button svg.ab-chevron,.ab-iam-root.v3 .ab-in-app-message .ab-close-button svg.ab-chevron{display:none}.ab-centering-div .ab-in-app-message .ab-close-button:active,.ab-iam-root.v3 .ab-in-app-message .ab-close-button:active{background-color:transparent}.ab-centering-div .ab-in-app-message .ab-close-button:focus,.ab-iam-root.v3 .ab-in-app-message .ab-close-button:focus{background-color:transparent}.ab-centering-div .ab-in-app-message .ab-close-button:hover,.ab-iam-root.v3 .ab-in-app-message .ab-close-button:hover{background-color:transparent}.ab-centering-div .ab-in-app-message .ab-close-button:hover svg,.ab-iam-root.v3 .ab-in-app-message .ab-close-button:hover svg{fill-opacity:.8}.ab-centering-div .ab-in-app-message .ab-message-text,.ab-iam-root.v3 .ab-in-app-message .ab-message-text{line-height:1.5;margin:20px 25px;max-width:100%;overflow:hidden;overflow-y:auto;vertical-align:text-bottom;word-wrap:break-word;white-space:pre-wrap}.ab-centering-div .ab-in-app-message .ab-message-text.start-aligned,.ab-iam-root.v3 .ab-in-app-message .ab-message-text.start-aligned{text-align:left;text-align:start}.ab-centering-div .ab-in-app-message .ab-message-text.end-aligned,.ab-iam-root.v3 .ab-in-app-message .ab-message-text.end-aligned{text-align:right;text-align:end}.ab-centering-div .ab-in-app-message .ab-message-text.center-aligned,.ab-iam-root.v3 .ab-in-app-message .ab-message-text.center-aligned{text-align:center}.ab-centering-div .ab-in-app-message .ab-message-text::-webkit-scrollbar,.ab-iam-root.v3 .ab-in-app-message .ab-message-text::-webkit-scrollbar{-webkit-appearance:none;width:14px}.ab-centering-div .ab-in-app-message .ab-message-text::-webkit-scrollbar-thumb,.ab-iam-root.v3 .ab-in-app-message .ab-message-text::-webkit-scrollbar-thumb{-webkit-appearance:none;border:4px solid transparent;background-clip:padding-box;-webkit-border-radius:7px;-moz-border-radius:7px;border-radius:7px;background-color:rgba(0,0,0,.2)}.ab-centering-div .ab-in-app-message .ab-message-text::-webkit-scrollbar-button,.ab-iam-root.v3 .ab-in-app-message .ab-message-text::-webkit-scrollbar-button{width:0;height:0;display:none}.ab-centering-div .ab-in-app-message .ab-message-text::-webkit-scrollbar-corner,.ab-iam-root.v3 .ab-in-app-message .ab-message-text::-webkit-scrollbar-corner{background-color:transparent}.ab-centering-div .ab-in-app-message .ab-message-header,.ab-iam-root.v3 .ab-in-app-message .ab-message-header{letter-spacing:0;margin:0;font-weight:700;display:block;font-size:20px;margin-bottom:10px;line-height:1.3}.ab-centering-div .ab-in-app-message .ab-message-header.start-aligned,.ab-iam-root.v3 .ab-in-app-message .ab-message-header.start-aligned{text-align:left;text-align:start}.ab-centering-div .ab-in-app-message .ab-message-header.end-aligned,.ab-iam-root.v3 .ab-in-app-message .ab-message-header.end-aligned{text-align:right;text-align:end}.ab-centering-div .ab-in-app-message .ab-message-header.center-aligned,.ab-iam-root.v3 .ab-in-app-message .ab-message-header.center-aligned{text-align:center}.ab-centering-div .ab-in-app-message.ab-fullscreen,.ab-centering-div .ab-in-app-message.ab-modal,.ab-centering-div .ab-in-app-message.ab-slideup,.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen,.ab-iam-root.v3 .ab-in-app-message.ab-modal,.ab-iam-root.v3 .ab-in-app-message.ab-slideup{-webkit-border-radius:8px;-moz-border-radius:8px;border-radius:8px}.ab-centering-div .ab-in-app-message.ab-slideup,.ab-iam-root.v3 .ab-in-app-message.ab-slideup{-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box;cursor:pointer;overflow:hidden;word-wrap:break-word;text-overflow:ellipsis;font-size:14px;font-weight:700;margin:20px;margin-top:calc(constant(safe-area-inset-top,0) + 20px);margin-right:calc(constant(safe-area-inset-right,0) + 20px);margin-bottom:calc(constant(safe-area-inset-bottom,0) + 20px);margin-left:calc(constant(safe-area-inset-left,0) + 20px);margin-top:calc(env(safe-area-inset-top,0) + 20px);margin-right:calc(env(safe-area-inset-right,0) + 20px);margin-bottom:calc(env(safe-area-inset-bottom,0) + 20px);margin-left:calc(env(safe-area-inset-left,0) + 20px);max-height:150px;padding:10px;right:0;background-color:#efefef}.ab-centering-div .ab-in-app-message.ab-slideup.simulate-phone,.ab-iam-root.v3 .ab-in-app-message.ab-slideup.simulate-phone{max-height:66px;margin:10px;margin-top:calc(constant(safe-area-inset-top,0) + 10px);margin-right:calc(constant(safe-area-inset-right,0) + 10px);margin-bottom:calc(constant(safe-area-inset-bottom,0) + 10px);margin-left:calc(constant(safe-area-inset-left,0) + 10px);margin-top:calc(env(safe-area-inset-top,0) + 10px);margin-right:calc(env(safe-area-inset-right,0) + 10px);margin-bottom:calc(env(safe-area-inset-bottom,0) + 10px);margin-left:calc(env(safe-area-inset-left,0) + 10px);max-width:90%;max-width:calc(100% - 40px);min-width:90%;min-width:calc(100% - 40px)}.ab-centering-div .ab-in-app-message.ab-slideup.simulate-phone .ab-close-button,.ab-iam-root.v3 .ab-in-app-message.ab-slideup.simulate-phone .ab-close-button{display:none}.ab-centering-div .ab-in-app-message.ab-slideup.simulate-phone .ab-close-button svg:not(.ab-chevron),.ab-iam-root.v3 .ab-in-app-message.ab-slideup.simulate-phone .ab-close-button svg:not(.ab-chevron){display:none}.ab-centering-div .ab-in-app-message.ab-slideup.simulate-phone.ab-clickable .ab-close-button,.ab-iam-root.v3 .ab-in-app-message.ab-slideup.simulate-phone.ab-clickable .ab-close-button{display:block;height:20px;padding:0 20px 0 18px;pointer-events:none;top:50%;-webkit-transform:translateY(-50%);-moz-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);width:12px}.ab-centering-div .ab-in-app-message.ab-slideup.simulate-phone.ab-clickable .ab-close-button svg.ab-chevron,.ab-iam-root.v3 .ab-in-app-message.ab-slideup.simulate-phone.ab-clickable .ab-close-button svg.ab-chevron{display:inline}.ab-centering-div .ab-in-app-message.ab-slideup.simulate-phone.ab-clickable .ab-message-text,.ab-iam-root.v3 .ab-in-app-message.ab-slideup.simulate-phone.ab-clickable .ab-message-text{border-right-width:40px}.ab-centering-div .ab-in-app-message.ab-slideup.simulate-phone .ab-message-text,.ab-iam-root.v3 .ab-in-app-message.ab-slideup.simulate-phone .ab-message-text{max-width:100%;border-right-width:10px}.ab-centering-div .ab-in-app-message.ab-slideup.simulate-phone .ab-message-text span,.ab-iam-root.v3 .ab-in-app-message.ab-slideup.simulate-phone .ab-message-text span{max-height:66px}.ab-centering-div .ab-in-app-message.ab-slideup.simulate-phone .ab-message-text.ab-with-icon,.ab-centering-div .ab-in-app-message.ab-slideup.simulate-phone .ab-message-text.ab-with-image,.ab-iam-root.v3 .ab-in-app-message.ab-slideup.simulate-phone .ab-message-text.ab-with-icon,.ab-iam-root.v3 .ab-in-app-message.ab-slideup.simulate-phone .ab-message-text.ab-with-image{max-width:80%;max-width:calc(100% - 50px - 5px - 10px - 25px)}.ab-centering-div .ab-in-app-message.ab-slideup.simulate-phone .ab-image-area,.ab-iam-root.v3 .ab-in-app-message.ab-slideup.simulate-phone .ab-image-area{width:50px}.ab-centering-div .ab-in-app-message.ab-slideup.simulate-phone .ab-image-area img,.ab-iam-root.v3 .ab-in-app-message.ab-slideup.simulate-phone .ab-image-area img{max-width:50px;max-height:50px;width:auto}.ab-centering-div .ab-in-app-message.ab-slideup.ab-clickable:active .ab-message-text,.ab-centering-div .ab-in-app-message.ab-slideup.ab-clickable:focus .ab-message-text,.ab-centering-div .ab-in-app-message.ab-slideup.ab-clickable:hover .ab-message-text,.ab-iam-root.v3 .ab-in-app-message.ab-slideup.ab-clickable:active .ab-message-text,.ab-iam-root.v3 .ab-in-app-message.ab-slideup.ab-clickable:focus .ab-message-text,.ab-iam-root.v3 .ab-in-app-message.ab-slideup.ab-clickable:hover .ab-message-text{opacity:.8}.ab-centering-div .ab-in-app-message.ab-slideup.ab-clickable:active .ab-close-button svg.ab-chevron,.ab-centering-div .ab-in-app-message.ab-slideup.ab-clickable:focus .ab-close-button svg.ab-chevron,.ab-centering-div .ab-in-app-message.ab-slideup.ab-clickable:hover .ab-close-button svg.ab-chevron,.ab-iam-root.v3 .ab-in-app-message.ab-slideup.ab-clickable:active .ab-close-button svg.ab-chevron,.ab-iam-root.v3 .ab-in-app-message.ab-slideup.ab-clickable:focus .ab-close-button svg.ab-chevron,.ab-iam-root.v3 .ab-in-app-message.ab-slideup.ab-clickable:hover .ab-close-button svg.ab-chevron{fill-opacity:.8}.ab-centering-div .ab-in-app-message.ab-slideup .ab-message-text,.ab-iam-root.v3 .ab-in-app-message.ab-slideup .ab-message-text{-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box;display:table-cell;border-color:transparent;border-style:solid;border-width:5px 25px 5px 10px;max-width:430px;vertical-align:middle;margin:0}.ab-centering-div .ab-in-app-message.ab-slideup .ab-message-text span,.ab-iam-root.v3 .ab-in-app-message.ab-slideup .ab-message-text span{display:block;max-height:150px;overflow:auto}.ab-centering-div .ab-in-app-message.ab-slideup .ab-message-text.ab-with-icon,.ab-centering-div .ab-in-app-message.ab-slideup .ab-message-text.ab-with-image,.ab-iam-root.v3 .ab-in-app-message.ab-slideup .ab-message-text.ab-with-icon,.ab-iam-root.v3 .ab-in-app-message.ab-slideup .ab-message-text.ab-with-image{max-width:365px;border-top:0;border-bottom:0}.ab-centering-div .ab-in-app-message.ab-slideup .ab-close-button,.ab-iam-root.v3 .ab-in-app-message.ab-slideup .ab-close-button{-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box;background-color:transparent;background-repeat:no-repeat;background-origin:content-box;background-size:15px;border:none;width:15px;height:15px;-webkit-border-radius:7.5px;-moz-border-radius:7.5px;border-radius:7.5px;cursor:pointer;display:block;font-size:15px;line-height:0;padding-top:10px;padding-right:10px;padding-left:6.66666667px;padding-bottom:6.66666667px;position:absolute;right:0;top:0;text-align:center;z-index:1060}.ab-centering-div .ab-in-app-message.ab-slideup .ab-close-button svg,.ab-iam-root.v3 .ab-in-app-message.ab-slideup .ab-close-button svg{-webkit-transition:.2s ease;-moz-transition:.2s ease;-o-transition:.2s ease;transition:.2s ease;fill:#9b9b9b}.ab-centering-div .ab-in-app-message.ab-slideup .ab-close-button svg.ab-chevron,.ab-iam-root.v3 .ab-in-app-message.ab-slideup .ab-close-button svg.ab-chevron{display:none}.ab-centering-div .ab-in-app-message.ab-slideup .ab-close-button:active,.ab-iam-root.v3 .ab-in-app-message.ab-slideup .ab-close-button:active{background-color:transparent}.ab-centering-div .ab-in-app-message.ab-slideup .ab-close-button:focus,.ab-iam-root.v3 .ab-in-app-message.ab-slideup .ab-close-button:focus{background-color:transparent}.ab-centering-div .ab-in-app-message.ab-slideup .ab-close-button:hover,.ab-iam-root.v3 .ab-in-app-message.ab-slideup .ab-close-button:hover{background-color:transparent}.ab-centering-div .ab-in-app-message.ab-slideup .ab-close-button:hover svg,.ab-iam-root.v3 .ab-in-app-message.ab-slideup .ab-close-button:hover svg{fill-opacity:.8}.ab-centering-div .ab-in-app-message.ab-slideup .ab-image-area,.ab-iam-root.v3 .ab-in-app-message.ab-slideup .ab-image-area{-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box;display:table-cell;border-color:transparent;border-style:solid;border-width:5px 0 5px 5px;vertical-align:top;width:60px;margin:0}.ab-centering-div .ab-in-app-message.ab-slideup .ab-image-area.ab-icon-area,.ab-iam-root.v3 .ab-in-app-message.ab-slideup .ab-image-area.ab-icon-area{width:auto}.ab-centering-div .ab-in-app-message.ab-slideup .ab-image-area img,.ab-iam-root.v3 .ab-in-app-message.ab-slideup .ab-image-area img{width:100%}.ab-centering-div .ab-in-app-message.ab-fullscreen,.ab-centering-div .ab-in-app-message.ab-modal,.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen,.ab-iam-root.v3 .ab-in-app-message.ab-modal{font-size:14px}.ab-centering-div .ab-in-app-message.ab-fullscreen .ab-image-area,.ab-centering-div .ab-in-app-message.ab-modal .ab-image-area,.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen .ab-image-area,.ab-iam-root.v3 .ab-in-app-message.ab-modal .ab-image-area{position:relative;display:block;overflow:hidden}.ab-centering-div .ab-in-app-message.ab-fullscreen .ab-image-area .ab-center-cropped-img,.ab-centering-div .ab-in-app-message.ab-modal .ab-image-area .ab-center-cropped-img,.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen .ab-image-area .ab-center-cropped-img,.ab-iam-root.v3 .ab-in-app-message.ab-modal .ab-image-area .ab-center-cropped-img{background-size:cover;background-repeat:no-repeat;background-position:50% 50%;position:absolute;top:0;right:0;bottom:0;left:0}.ab-centering-div .ab-in-app-message.ab-fullscreen .ab-icon,.ab-centering-div .ab-in-app-message.ab-modal .ab-icon,.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen .ab-icon,.ab-iam-root.v3 .ab-in-app-message.ab-modal .ab-icon{margin-top:20px}.ab-centering-div .ab-in-app-message.ab-fullscreen.graphic,.ab-centering-div .ab-in-app-message.ab-modal.graphic,.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen.graphic,.ab-iam-root.v3 .ab-in-app-message.ab-modal.graphic{padding:0}.ab-centering-div .ab-in-app-message.ab-fullscreen.graphic .ab-message-text,.ab-centering-div .ab-in-app-message.ab-modal.graphic .ab-message-text,.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen.graphic .ab-message-text,.ab-iam-root.v3 .ab-in-app-message.ab-modal.graphic .ab-message-text{display:none}.ab-centering-div .ab-in-app-message.ab-fullscreen.graphic .ab-message-buttons,.ab-centering-div .ab-in-app-message.ab-modal.graphic .ab-message-buttons,.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen.graphic .ab-message-buttons,.ab-iam-root.v3 .ab-in-app-message.ab-modal.graphic .ab-message-buttons{bottom:0;left:0}.ab-centering-div .ab-in-app-message.ab-fullscreen.graphic .ab-image-area,.ab-centering-div .ab-in-app-message.ab-modal.graphic .ab-image-area,.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen.graphic .ab-image-area,.ab-iam-root.v3 .ab-in-app-message.ab-modal.graphic .ab-image-area{height:auto;margin:0}.ab-centering-div .ab-in-app-message.ab-fullscreen.graphic .ab-image-area img,.ab-centering-div .ab-in-app-message.ab-modal.graphic .ab-image-area img,.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen.graphic .ab-image-area img,.ab-iam-root.v3 .ab-in-app-message.ab-modal.graphic .ab-image-area img{display:block;top:0;-webkit-transform:none;-moz-transform:none;-ms-transform:none;transform:none}.ab-centering-div .ab-in-app-message.ab-modal,.ab-iam-root.v3 .ab-in-app-message.ab-modal{padding-top:20px;width:450px;max-width:450px;max-height:720px}.ab-centering-div .ab-in-app-message.ab-modal.simulate-phone,.ab-iam-root.v3 .ab-in-app-message.ab-modal.simulate-phone{max-width:91%;max-width:calc(100% - 30px)}.ab-centering-div .ab-in-app-message.ab-modal.simulate-phone.graphic .ab-image-area img,.ab-iam-root.v3 .ab-in-app-message.ab-modal.simulate-phone.graphic .ab-image-area img{max-width:91vw;max-width:calc(100vw - 30px)}.ab-centering-div .ab-in-app-message.ab-modal .ab-message-text,.ab-iam-root.v3 .ab-in-app-message.ab-modal .ab-message-text{max-height:660px}.ab-centering-div .ab-in-app-message.ab-modal .ab-message-text.ab-with-image,.ab-iam-root.v3 .ab-in-app-message.ab-modal .ab-message-text.ab-with-image{max-height:524.82758621px}.ab-centering-div .ab-in-app-message.ab-modal .ab-message-text.ab-with-icon,.ab-iam-root.v3 .ab-in-app-message.ab-modal .ab-message-text.ab-with-icon{max-height:610px}.ab-centering-div .ab-in-app-message.ab-modal .ab-message-text.ab-with-buttons,.ab-iam-root.v3 .ab-in-app-message.ab-modal .ab-message-text.ab-with-buttons{margin-bottom:93px;max-height:587px}.ab-centering-div .ab-in-app-message.ab-modal .ab-message-text.ab-with-buttons.ab-with-image,.ab-iam-root.v3 .ab-in-app-message.ab-modal .ab-message-text.ab-with-buttons.ab-with-image{max-height:451.82758621px}.ab-centering-div .ab-in-app-message.ab-modal .ab-message-text.ab-with-buttons.ab-with-icon,.ab-iam-root.v3 .ab-in-app-message.ab-modal .ab-message-text.ab-with-buttons.ab-with-icon{max-height:537px}.ab-centering-div .ab-in-app-message.ab-modal .ab-image-area,.ab-iam-root.v3 .ab-in-app-message.ab-modal .ab-image-area{margin-top:-20px;max-height:155.17241379px}.ab-centering-div .ab-in-app-message.ab-modal .ab-image-area img,.ab-iam-root.v3 .ab-in-app-message.ab-modal .ab-image-area img{max-width:100%;max-height:155.17241379px}.ab-centering-div .ab-in-app-message.ab-modal .ab-image-area.ab-icon-area,.ab-iam-root.v3 .ab-in-app-message.ab-modal .ab-image-area.ab-icon-area{height:auto}.ab-centering-div .ab-in-app-message.ab-modal.graphic,.ab-iam-root.v3 .ab-in-app-message.ab-modal.graphic{width:auto;overflow:hidden}.ab-centering-div .ab-in-app-message.ab-modal.graphic .ab-image-area,.ab-iam-root.v3 .ab-in-app-message.ab-modal.graphic .ab-image-area{display:inline}.ab-centering-div .ab-in-app-message.ab-modal.graphic .ab-image-area img,.ab-iam-root.v3 .ab-in-app-message.ab-modal.graphic .ab-image-area img{max-height:720px;max-width:450px}.ab-centering-div .ab-in-app-message.ab-fullscreen,.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen{width:450px;max-height:720px}.ab-centering-div .ab-in-app-message.ab-fullscreen.landscape,.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen.landscape{width:720px;max-height:450px}.ab-centering-div .ab-in-app-message.ab-fullscreen.landscape .ab-image-area,.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen.landscape .ab-image-area{height:225px}.ab-centering-div .ab-in-app-message.ab-fullscreen.landscape.graphic .ab-image-area,.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen.landscape.graphic .ab-image-area{height:450px}.ab-centering-div .ab-in-app-message.ab-fullscreen.landscape .ab-message-text,.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen.landscape .ab-message-text{max-height:112px}.ab-centering-div .ab-in-app-message.ab-fullscreen .ab-message-text,.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen .ab-message-text{max-height:247px}.ab-centering-div .ab-in-app-message.ab-fullscreen .ab-message-text.ab-with-buttons,.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen .ab-message-text.ab-with-buttons{margin-bottom:93px}.ab-centering-div .ab-in-app-message.ab-fullscreen .ab-image-area,.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen .ab-image-area{height:360px}.ab-centering-div .ab-in-app-message.ab-fullscreen.graphic .ab-image-area,.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen.graphic .ab-image-area{height:720px}.ab-centering-div .ab-in-app-message.ab-fullscreen.simulate-phone,.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen.simulate-phone{-webkit-transition:top none;-moz-transition:top none;-o-transition:top none;transition:top none;top:0;right:0;bottom:0;left:0;height:100%;width:100%;max-height:none;-webkit-border-radius:0;-moz-border-radius:0;border-radius:0;-webkit-transform:none;-moz-transform:none;-ms-transform:none;transform:none;height:auto!important}.ab-centering-div .ab-in-app-message.ab-fullscreen.simulate-phone.landscape .ab-close-button,.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen.simulate-phone.landscape .ab-close-button{margin-right:calc(constant(safe-area-inset-bottom,0) + constant(safe-area-inset-top,0));margin-right:calc(env(safe-area-inset-bottom,0) + env(safe-area-inset-top,0));margin-left:calc(constant(safe-area-inset-bottom,0) + constant(safe-area-inset-top,0));margin-left:calc(env(safe-area-inset-bottom,0) + env(safe-area-inset-top,0))}.ab-centering-div .ab-in-app-message.ab-fullscreen.simulate-phone .ab-image-area,.ab-centering-div .ab-in-app-message.ab-fullscreen.simulate-phone.landscape .ab-image-area,.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen.simulate-phone .ab-image-area,.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen.simulate-phone.landscape .ab-image-area{height:50%}.ab-centering-div .ab-in-app-message.ab-fullscreen.simulate-phone .ab-message-text,.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen.simulate-phone .ab-message-text{max-height:48%;max-height:calc(50% - 20px - 20px)}.ab-centering-div .ab-in-app-message.ab-fullscreen.simulate-phone .ab-message-text.ab-with-buttons,.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen.simulate-phone .ab-message-text.ab-with-buttons{margin-bottom:20px;max-height:30%;max-height:calc(50% - 93px - 20px)}.ab-centering-div .ab-in-app-message.ab-fullscreen.simulate-phone.landscape .ab-message-text.ab-with-buttons,.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen.simulate-phone.landscape .ab-message-text.ab-with-buttons{max-height:20%;max-height:calc(50% - 93px - 20px)}.ab-centering-div .ab-in-app-message.ab-fullscreen.simulate-phone:not(.graphic),.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen.simulate-phone:not(.graphic){padding-bottom:0;padding-bottom:constant(safe-area-inset-bottom,0);padding-bottom:env(safe-area-inset-bottom,0)}.ab-centering-div .ab-in-app-message.ab-fullscreen.simulate-phone:not(.graphic) .ab-message-buttons,.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen.simulate-phone:not(.graphic) .ab-message-buttons{padding-top:0;position:relative}.ab-centering-div .ab-in-app-message.ab-fullscreen.simulate-phone.graphic,.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen.simulate-phone.graphic{display:block}.ab-centering-div .ab-in-app-message.ab-fullscreen.simulate-phone.graphic .ab-image-area,.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen.simulate-phone.graphic .ab-image-area{height:100%}.ab-centering-div .ab-in-app-message.ab-fullscreen.simulate-phone.graphic .ab-message-button,.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen.simulate-phone.graphic .ab-message-button{margin-bottom:0;margin-bottom:constant(safe-area-inset-bottom,0);margin-bottom:env(safe-area-inset-bottom,0)}.ab-centering-div .ab-in-app-message.ab-html-message,.ab-iam-root.v3 .ab-in-app-message.ab-html-message{background-color:transparent;border:none;height:100%;overflow:auto;position:relative;touch-action:auto;width:100%}.ab-centering-div .ab-in-app-message .ab-message-buttons,.ab-iam-root.v3 .ab-in-app-message .ab-message-buttons{position:absolute;bottom:0;width:100%;padding:17px 25px 30px 25px;z-index:inherit;-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box}.ab-centering-div .ab-in-app-message .ab-message-button,.ab-iam-root.v3 .ab-in-app-message .ab-message-button{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;-webkit-border-radius:5px;-moz-border-radius:5px;border-radius:5px;-webkit-box-shadow:none;-moz-box-shadow:none;box-shadow:none;cursor:pointer;display:inline-block;font-size:14px;font-weight:700;height:44px;line-height:normal;letter-spacing:normal;margin:0;max-width:100%;min-width:80px;padding:0 12px;position:relative;text-transform:none;width:48%;width:calc(50% - 5px);border:1px solid #1b78cf;-webkit-transition:.2s ease;-moz-transition:.2s ease;-o-transition:.2s ease;transition:.2s ease;overflow:hidden;word-wrap:break-word;text-overflow:ellipsis;word-wrap:normal;white-space:nowrap}.ab-centering-div .ab-in-app-message .ab-message-button:first-of-type,.ab-iam-root.v3 .ab-in-app-message .ab-message-button:first-of-type{float:left;background-color:#fff;color:#1b78cf}.ab-centering-div .ab-in-app-message .ab-message-button:last-of-type,.ab-iam-root.v3 .ab-in-app-message .ab-message-button:last-of-type{float:right;background-color:#1b78cf;color:#fff}.ab-centering-div .ab-in-app-message .ab-message-button:first-of-type:last-of-type,.ab-iam-root.v3 .ab-in-app-message .ab-message-button:first-of-type:last-of-type{float:none;width:auto}.ab-centering-div .ab-in-app-message .ab-message-button:after,.ab-iam-root.v3 .ab-in-app-message .ab-message-button:after{content:'';position:absolute;top:0;left:0;width:100%;height:100%;background-color:transparent}.ab-centering-div .ab-in-app-message .ab-message-button:after,.ab-iam-root.v3 .ab-in-app-message .ab-message-button:after{-webkit-transition:.2s ease;-moz-transition:.2s ease;-o-transition:.2s ease;transition:.2s ease}.ab-centering-div .ab-in-app-message .ab-message-button:hover,.ab-iam-root.v3 .ab-in-app-message .ab-message-button:hover{opacity:.8}.ab-centering-div .ab-in-app-message .ab-message-button:active:after,.ab-iam-root.v3 .ab-in-app-message .ab-message-button:active:after{content:'';position:absolute;top:0;left:0;width:100%;height:100%;background-color:rgba(0,0,0,.08)}.ab-centering-div .ab-in-app-message .ab-message-button:focus:after,.ab-iam-root.v3 .ab-in-app-message .ab-message-button:focus:after{content:'';position:absolute;top:0;left:0;width:100%;height:100%;background-color:rgba(0,0,0,.15)}.ab-centering-div .ab-in-app-message .ab-message-button a,.ab-iam-root.v3 .ab-in-app-message .ab-message-button a{color:inherit;text-decoration:inherit}.ab-centering-div .ab-in-app-message img,.ab-iam-root.v3 .ab-in-app-message img{display:inline-block}.ab-centering-div .ab-in-app-message .ab-icon,.ab-iam-root.v3 .ab-in-app-message .ab-icon{display:inline-block;padding:10px;-webkit-border-radius:8px;-moz-border-radius:8px;border-radius:8px}.ab-centering-div .ab-in-app-message .ab-icon .fa,.ab-iam-root.v3 .ab-in-app-message .ab-icon .fa{font-size:30px;width:30px}.ab-centering-div .ab-start-hidden,.ab-iam-root.v3 .ab-start-hidden{visibility:hidden}.ab-centering-div .ab-centered,.ab-centering-div.ab-centering-div .ab-modal,.ab-iam-root.v3 .ab-centered,.ab-iam-root.v3.ab-centering-div .ab-modal{margin:auto;position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);-moz-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.ab-email-capture,.ab-iam-root.v3{-webkit-border-radius:0;-moz-border-radius:0;border-radius:0}.ab-email-capture .ab-page-blocker,.ab-iam-root.v3 .ab-page-blocker{position:fixed;top:0;left:0;width:100%;height:100%;z-index:1040;pointer-events:all;background-color:rgba(51,51,51,.75)}.ab-email-capture .ab-in-app-message.ab-modal .ab-email-capture-input{margin-bottom:30px}.ab-email-capture .ab-in-app-message.ab-modal .ab-message-buttons~.ab-message-text{max-height:541px;margin-bottom:160px}.ab-email-capture .ab-in-app-message.ab-modal .ab-message-buttons~.ab-message-text.with-explanatory-link{max-height:513px;margin-bottom:188px}.ab-email-capture .ab-in-app-message.ab-modal .ab-image-area~.ab-message-text{max-height:385.82758621px}.ab-email-capture .ab-in-app-message.ab-modal .ab-image-area~.ab-message-text.with-explanatory-link{max-height:357.82758621px}.ab-email-capture .ab-in-app-message.ab-modal .ab-email-validation-error{margin-top:62px}.ab-email-capture .ab-in-app-message.ab-modal .ab-explanatory-link{display:block}.ab-email-capture .ab-in-app-message.ab-modal .ab-background,.ab-email-capture .ab-in-app-message.ab-modal .ab-mask{position:absolute;top:0;right:0;bottom:0;left:0;z-index:-1}.ab-email-capture .ab-in-app-message.ab-modal .ab-close-button{line-height:normal}.ab-email-capture .ab-in-app-message.ab-modal .ab-html-close-button{right:3px;top:-1px;font-size:34px;padding-top:0}@media (max-width:600px){.ab-iam-root.v3 .ab-in-app-message.ab-slideup{max-height:66px;margin:10px;margin-top:calc(constant(safe-area-inset-top,0) + 10px);margin-right:calc(constant(safe-area-inset-right,0) + 10px);margin-bottom:calc(constant(safe-area-inset-bottom,0) + 10px);margin-left:calc(constant(safe-area-inset-left,0) + 10px);margin-top:calc(env(safe-area-inset-top,0) + 10px);margin-right:calc(env(safe-area-inset-right,0) + 10px);margin-bottom:calc(env(safe-area-inset-bottom,0) + 10px);margin-left:calc(env(safe-area-inset-left,0) + 10px);max-width:90%;max-width:calc(100% - 40px);min-width:90%;min-width:calc(100% - 40px)}.ab-iam-root.v3 .ab-in-app-message.ab-slideup .ab-close-button{display:none}.ab-iam-root.v3 .ab-in-app-message.ab-slideup .ab-close-button svg:not(.ab-chevron){display:none}.ab-iam-root.v3 .ab-in-app-message.ab-slideup.ab-clickable .ab-close-button{display:block;height:20px;padding:0 20px 0 18px;pointer-events:none;top:50%;-webkit-transform:translateY(-50%);-moz-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);width:12px}.ab-iam-root.v3 .ab-in-app-message.ab-slideup.ab-clickable .ab-close-button svg.ab-chevron{display:inline}.ab-iam-root.v3 .ab-in-app-message.ab-slideup.ab-clickable .ab-message-text{border-right-width:40px}.ab-iam-root.v3 .ab-in-app-message.ab-slideup .ab-message-text{max-width:100%;border-right-width:10px}.ab-iam-root.v3 .ab-in-app-message.ab-slideup .ab-message-text span{max-height:66px}.ab-iam-root.v3 .ab-in-app-message.ab-slideup .ab-message-text.ab-with-icon,.ab-iam-root.v3 .ab-in-app-message.ab-slideup .ab-message-text.ab-with-image{max-width:80%;max-width:calc(100% - 50px - 5px - 10px - 25px)}.ab-iam-root.v3 .ab-in-app-message.ab-slideup .ab-image-area{width:50px}.ab-iam-root.v3 .ab-in-app-message.ab-slideup .ab-image-area img{max-width:50px;max-height:50px;width:auto}.ab-iam-root.v3 .ab-in-app-message:not(.force-desktop).ab-fullscreen,.ab-iam-root.v3 .ab-in-app-message:not(.force-desktop).ab-fullscreen.landscape{-webkit-transition:top none;-moz-transition:top none;-o-transition:top none;transition:top none;top:0;right:0;bottom:0;left:0;height:100%;width:100%;max-height:none;-webkit-border-radius:0;-moz-border-radius:0;border-radius:0;-webkit-transform:none;-moz-transform:none;-ms-transform:none;transform:none;height:auto!important}.ab-iam-root.v3 .ab-in-app-message:not(.force-desktop).ab-fullscreen.landscape .ab-close-button,.ab-iam-root.v3 .ab-in-app-message:not(.force-desktop).ab-fullscreen.landscape.landscape .ab-close-button{margin-right:calc(constant(safe-area-inset-bottom,0) + constant(safe-area-inset-top,0));margin-right:calc(env(safe-area-inset-bottom,0) + env(safe-area-inset-top,0));margin-left:calc(constant(safe-area-inset-bottom,0) + constant(safe-area-inset-top,0));margin-left:calc(env(safe-area-inset-bottom,0) + env(safe-area-inset-top,0))}.ab-iam-root.v3 .ab-in-app-message:not(.force-desktop).ab-fullscreen .ab-image-area,.ab-iam-root.v3 .ab-in-app-message:not(.force-desktop).ab-fullscreen.landscape .ab-image-area,.ab-iam-root.v3 .ab-in-app-message:not(.force-desktop).ab-fullscreen.landscape.landscape .ab-image-area{height:50%}.ab-iam-root.v3 .ab-in-app-message:not(.force-desktop).ab-fullscreen .ab-message-text,.ab-iam-root.v3 .ab-in-app-message:not(.force-desktop).ab-fullscreen.landscape .ab-message-text{max-height:48%;max-height:calc(50% - 20px - 20px)}.ab-iam-root.v3 .ab-in-app-message:not(.force-desktop).ab-fullscreen .ab-message-text.ab-with-buttons,.ab-iam-root.v3 .ab-in-app-message:not(.force-desktop).ab-fullscreen.landscape .ab-message-text.ab-with-buttons{margin-bottom:20px;max-height:30%;max-height:calc(50% - 93px - 20px)}.ab-iam-root.v3 .ab-in-app-message:not(.force-desktop).ab-fullscreen.landscape .ab-message-text.ab-with-buttons,.ab-iam-root.v3 .ab-in-app-message:not(.force-desktop).ab-fullscreen.landscape.landscape .ab-message-text.ab-with-buttons{max-height:20%;max-height:calc(50% - 93px - 20px)}.ab-iam-root.v3 .ab-in-app-message:not(.force-desktop).ab-fullscreen.landscape:not(.graphic),.ab-iam-root.v3 .ab-in-app-message:not(.force-desktop).ab-fullscreen:not(.graphic){padding-bottom:0;padding-bottom:constant(safe-area-inset-bottom,0);padding-bottom:env(safe-area-inset-bottom,0)}.ab-iam-root.v3 .ab-in-app-message:not(.force-desktop).ab-fullscreen.landscape:not(.graphic) .ab-message-buttons,.ab-iam-root.v3 .ab-in-app-message:not(.force-desktop).ab-fullscreen:not(.graphic) .ab-message-buttons{padding-top:0;position:relative}.ab-iam-root.v3 .ab-in-app-message:not(.force-desktop).ab-fullscreen.graphic,.ab-iam-root.v3 .ab-in-app-message:not(.force-desktop).ab-fullscreen.landscape.graphic{display:block}.ab-iam-root.v3 .ab-in-app-message:not(.force-desktop).ab-fullscreen.graphic .ab-image-area,.ab-iam-root.v3 .ab-in-app-message:not(.force-desktop).ab-fullscreen.landscape.graphic .ab-image-area{height:100%}.ab-iam-root.v3 .ab-in-app-message:not(.force-desktop).ab-fullscreen.graphic .ab-message-button,.ab-iam-root.v3 .ab-in-app-message:not(.force-desktop).ab-fullscreen.landscape.graphic .ab-message-button{margin-bottom:0;margin-bottom:constant(safe-area-inset-bottom,0);margin-bottom:env(safe-area-inset-bottom,0)}}@media (max-width:480px){.ab-email-capture .ab-in-app-message.ab-modal,.ab-iam-root.v3 .ab-in-app-message.ab-modal{max-width:91%;max-width:calc(100% - 30px)}.ab-email-capture .ab-in-app-message.ab-modal.graphic .ab-image-area img,.ab-iam-root.v3 .ab-in-app-message.ab-modal.graphic .ab-image-area img{max-width:91vw;max-width:calc(100vw - 30px)}}@media (max-height:750px){.ab-email-capture .ab-in-app-message.ab-modal,.ab-iam-root.v3 .ab-in-app-message.ab-modal{max-height:91%;max-height:calc(100% - 30px)}.ab-email-capture .ab-in-app-message.ab-modal.graphic .ab-image-area img,.ab-iam-root.v3 .ab-in-app-message.ab-modal.graphic .ab-image-area img{max-height:91vh;max-height:calc(100vh - 30px)}.ab-email-capture .ab-in-app-message.ab-modal .ab-message-text,.ab-iam-root.v3 .ab-in-app-message.ab-modal .ab-message-text{max-height:65vh;max-height:calc(100vh - 30px - 60px)}.ab-email-capture .ab-in-app-message.ab-modal .ab-message-text.ab-with-image,.ab-iam-root.v3 .ab-in-app-message.ab-modal .ab-message-text.ab-with-image{max-height:45vh;max-height:calc(100vh - 30px - 155.17241379310346px - 40px)}.ab-email-capture .ab-in-app-message.ab-modal .ab-message-text.ab-with-icon,.ab-iam-root.v3 .ab-in-app-message.ab-modal .ab-message-text.ab-with-icon{max-height:45vh;max-height:calc(100vh - 30px - 70px - 40px)}.ab-email-capture .ab-in-app-message.ab-modal .ab-message-text.ab-with-buttons,.ab-iam-root.v3 .ab-in-app-message.ab-modal .ab-message-text.ab-with-buttons{max-height:50vh;max-height:calc(100vh - 30px - 93px - 40px)}.ab-email-capture .ab-in-app-message.ab-modal .ab-message-text.ab-with-buttons.ab-with-image,.ab-iam-root.v3 .ab-in-app-message.ab-modal .ab-message-text.ab-with-buttons.ab-with-image{max-height:30vh;max-height:calc(100vh - 30px - 155.17241379310346px - 93px - 20px)}.ab-email-capture .ab-in-app-message.ab-modal .ab-message-text.ab-with-buttons.ab-with-icon,.ab-iam-root.v3 .ab-in-app-message.ab-modal .ab-message-text.ab-with-buttons.ab-with-icon{max-height:30vh;max-height:calc(100vh - 30px - 70px - 93px - 20px)}}@media (min-width:601px){.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen .ab-image-area img{max-height:100%;max-width:100%}}@media (max-height:750px) and (min-width:601px){.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen:not(.landscape):not(.force-desktop){-webkit-transition:top none;-moz-transition:top none;-o-transition:top none;transition:top none;top:0;right:0;bottom:0;left:0;height:100%;width:100%;max-height:none;-webkit-border-radius:0;-moz-border-radius:0;border-radius:0;-webkit-transform:none;-moz-transform:none;-ms-transform:none;transform:none;height:auto!important;width:450px}.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen:not(.landscape):not(.force-desktop).landscape .ab-close-button{margin-right:calc(constant(safe-area-inset-bottom,0) + constant(safe-area-inset-top,0));margin-right:calc(env(safe-area-inset-bottom,0) + env(safe-area-inset-top,0));margin-left:calc(constant(safe-area-inset-bottom,0) + constant(safe-area-inset-top,0));margin-left:calc(env(safe-area-inset-bottom,0) + env(safe-area-inset-top,0))}.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen:not(.landscape):not(.force-desktop) .ab-image-area,.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen:not(.landscape):not(.force-desktop).landscape .ab-image-area{height:50%}.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen:not(.landscape):not(.force-desktop) .ab-message-text{max-height:48%;max-height:calc(50% - 20px - 20px)}.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen:not(.landscape):not(.force-desktop) .ab-message-text.ab-with-buttons{margin-bottom:20px;max-height:30%;max-height:calc(50% - 93px - 20px)}.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen:not(.landscape):not(.force-desktop).landscape .ab-message-text.ab-with-buttons{max-height:20%;max-height:calc(50% - 93px - 20px)}.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen:not(.landscape):not(.force-desktop):not(.graphic){padding-bottom:0;padding-bottom:constant(safe-area-inset-bottom,0);padding-bottom:env(safe-area-inset-bottom,0)}.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen:not(.landscape):not(.force-desktop):not(.graphic) .ab-message-buttons{padding-top:0;position:relative}.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen:not(.landscape):not(.force-desktop).graphic{display:block}.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen:not(.landscape):not(.force-desktop).graphic .ab-image-area{height:100%}.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen:not(.landscape):not(.force-desktop).graphic .ab-message-button{margin-bottom:0;margin-bottom:constant(safe-area-inset-bottom,0);margin-bottom:env(safe-area-inset-bottom,0)}}@media (max-height:480px){.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen.landscape:not(.force-desktop){-webkit-transition:top none;-moz-transition:top none;-o-transition:top none;transition:top none;top:0;right:0;bottom:0;left:0;height:100%;width:100%;max-height:none;-webkit-border-radius:0;-moz-border-radius:0;border-radius:0;-webkit-transform:none;-moz-transform:none;-ms-transform:none;transform:none;height:auto!important}.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen.landscape:not(.force-desktop).landscape .ab-close-button{margin-right:calc(constant(safe-area-inset-bottom,0) + constant(safe-area-inset-top,0));margin-right:calc(env(safe-area-inset-bottom,0) + env(safe-area-inset-top,0));margin-left:calc(constant(safe-area-inset-bottom,0) + constant(safe-area-inset-top,0));margin-left:calc(env(safe-area-inset-bottom,0) + env(safe-area-inset-top,0))}.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen.landscape:not(.force-desktop) .ab-image-area,.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen.landscape:not(.force-desktop).landscape .ab-image-area{height:50%}.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen.landscape:not(.force-desktop) .ab-message-text{max-height:48%;max-height:calc(50% - 20px - 20px)}.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen.landscape:not(.force-desktop) .ab-message-text.ab-with-buttons{margin-bottom:20px;max-height:30%;max-height:calc(50% - 93px - 20px)}.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen.landscape:not(.force-desktop).landscape .ab-message-text.ab-with-buttons{max-height:20%;max-height:calc(50% - 93px - 20px)}.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen.landscape:not(.force-desktop):not(.graphic){padding-bottom:0;padding-bottom:constant(safe-area-inset-bottom,0);padding-bottom:env(safe-area-inset-bottom,0)}.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen.landscape:not(.force-desktop):not(.graphic) .ab-message-buttons{padding-top:0;position:relative}.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen.landscape:not(.force-desktop).graphic{display:block}.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen.landscape:not(.force-desktop).graphic .ab-image-area{height:100%}.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen.landscape:not(.force-desktop).graphic .ab-message-button{margin-bottom:0;margin-bottom:constant(safe-area-inset-bottom,0);margin-bottom:env(safe-area-inset-bottom,0)}}@media (max-width:750px){.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen.landscape:not(.force-desktop){-webkit-transition:top none;-moz-transition:top none;-o-transition:top none;transition:top none;top:0;right:0;bottom:0;left:0;height:100%;width:100%;max-height:none;-webkit-border-radius:0;-moz-border-radius:0;border-radius:0;-webkit-transform:none;-moz-transform:none;-ms-transform:none;transform:none;height:auto!important}.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen.landscape:not(.force-desktop).landscape .ab-close-button{margin-right:calc(constant(safe-area-inset-bottom,0) + constant(safe-area-inset-top,0));margin-right:calc(env(safe-area-inset-bottom,0) + env(safe-area-inset-top,0));margin-left:calc(constant(safe-area-inset-bottom,0) + constant(safe-area-inset-top,0));margin-left:calc(env(safe-area-inset-bottom,0) + env(safe-area-inset-top,0))}.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen.landscape:not(.force-desktop) .ab-image-area,.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen.landscape:not(.force-desktop).landscape .ab-image-area{height:50%}.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen.landscape:not(.force-desktop) .ab-message-text{max-height:48%;max-height:calc(50% - 20px - 20px)}.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen.landscape:not(.force-desktop) .ab-message-text.ab-with-buttons{margin-bottom:20px;max-height:30%;max-height:calc(50% - 93px - 20px)}.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen.landscape:not(.force-desktop).landscape .ab-message-text.ab-with-buttons{max-height:20%;max-height:calc(50% - 93px - 20px)}.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen.landscape:not(.force-desktop):not(.graphic){padding-bottom:0;padding-bottom:constant(safe-area-inset-bottom,0);padding-bottom:env(safe-area-inset-bottom,0)}.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen.landscape:not(.force-desktop):not(.graphic) .ab-message-buttons{padding-top:0;position:relative}.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen.landscape:not(.force-desktop).graphic{display:block}.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen.landscape:not(.force-desktop).graphic .ab-image-area{height:100%}.ab-iam-root.v3 .ab-in-app-message.ab-fullscreen.landscape:not(.force-desktop).graphic .ab-message-button{margin-bottom:0;margin-bottom:constant(safe-area-inset-bottom,0);margin-bottom:env(safe-area-inset-bottom,0)}}body>.ab-feed{position:fixed;top:0;right:0;bottom:0;width:421px;-webkit-border-radius:0;-moz-border-radius:0;border-radius:0}body>.ab-feed .ab-feed-body{position:absolute;top:0;left:0;right:0;border:none;border-left:1px solid #d0d0d0;padding-top:58px;min-height:100%}body>.ab-feed .ab-no-cards-message{position:absolute;width:100%;margin-left:-20px;top:40%}.ab-feed{-webkit-border-radius:3px;-moz-border-radius:3px;border-radius:3px;-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;-webkit-box-shadow:0 1px 7px 1px rgba(66,82,113,.15);-moz-box-shadow:0 1px 7px 1px rgba(66,82,113,.15);box-shadow:0 1px 7px 1px rgba(66,82,113,.15);width:402px;background-color:#eee;font-family:'Helvetica Neue Light','Helvetica Neue',Helvetica,Arial,'Lucida Grande',sans-serif;font-size:13px;line-height:130%;letter-spacing:normal;overflow-y:auto;overflow-x:visible;z-index:1050;-webkit-overflow-scrolling:touch}.ab-feed :focus,.ab-feed:focus{outline:0}.ab-feed .ab-feed-body{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;border:1px solid #d0d0d0;border-top:none;padding:20px 20px 0 20px}.ab-feed.ab-effect-slide{-webkit-transform:translateX(450px);-moz-transform:translateX(450px);-ms-transform:translateX(450px);transform:translateX(450px);-webkit-transition:transform .5s ease-in-out;-moz-transition:transform .5s ease-in-out;-o-transition:transform .5s ease-in-out;transition:transform .5s ease-in-out}.ab-feed.ab-effect-slide.ab-show{-webkit-transform:translateX(0);-moz-transform:translateX(0);-ms-transform:translateX(0);transform:translateX(0)}.ab-feed.ab-effect-slide.ab-hide{-webkit-transform:translateX(450px);-moz-transform:translateX(450px);-ms-transform:translateX(450px);transform:translateX(450px)}.ab-feed .ab-card{position:relative;-webkit-box-shadow:0 2px 3px 0 rgba(178,178,178,.5);-moz-box-shadow:0 2px 3px 0 rgba(178,178,178,.5);box-shadow:0 2px 3px 0 rgba(178,178,178,.5);-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;-webkit-border-radius:3px;-moz-border-radius:3px;border-radius:3px;width:100%;border:1px solid #d0d0d0;margin-bottom:20px;overflow:hidden;background-color:#fff;-webkit-transition:height .4s ease-in-out,margin .4s ease-in-out;-moz-transition:height .4s ease-in-out,margin .4s ease-in-out;-o-transition:height .4s ease-in-out,margin .4s ease-in-out;transition:height .4s ease-in-out,margin .4s ease-in-out}.ab-feed .ab-card .ab-pinned-indicator{position:absolute;right:0;top:0;margin-right:-1px;width:0;height:0;border-style:solid;border-width:0 24px 24px 0;border-color:transparent #1676d0 transparent transparent}.ab-feed .ab-card .ab-pinned-indicator .fa-star{position:absolute;right:-21px;top:2px;font-size:9px;color:#fff}.ab-feed .ab-card.ab-effect-card.ab-hide{-webkit-transition:all .5s ease-in-out;-moz-transition:all .5s ease-in-out;-o-transition:all .5s ease-in-out;transition:all .5s ease-in-out}.ab-feed .ab-card.ab-effect-card.ab-hide.ab-swiped-left{-webkit-transform:translateX(-450px);-moz-transform:translateX(-450px);-ms-transform:translateX(-450px);transform:translateX(-450px)}.ab-feed .ab-card.ab-effect-card.ab-hide.ab-swiped-right{-webkit-transform:translateX(450px);-moz-transform:translateX(450px);-ms-transform:translateX(450px);transform:translateX(450px)}.ab-feed .ab-card.ab-effect-card.ab-hide:not(.ab-swiped-left):not(.ab-swiped-right){opacity:0}.ab-feed .ab-card .ab-close-button{-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box;background-color:transparent;background-repeat:no-repeat;background-origin:content-box;background-size:15px;border:none;width:15px;height:15px;-webkit-border-radius:7.5px;-moz-border-radius:7.5px;border-radius:7.5px;cursor:pointer;display:block;font-size:15px;line-height:0;padding-top:15px;padding-right:15px;padding-left:10px;padding-bottom:10px;position:absolute;right:0;top:0;text-align:center;z-index:1060;opacity:0;-webkit-transition:.5s;-moz-transition:.5s;-o-transition:.5s;transition:.5s}.ab-feed .ab-card .ab-close-button svg{-webkit-transition:.2s ease;-moz-transition:.2s ease;-o-transition:.2s ease;transition:.2s ease;fill:#9b9b9b}.ab-feed .ab-card .ab-close-button svg.ab-chevron{display:none}.ab-feed .ab-card .ab-close-button:active{background-color:transparent}.ab-feed .ab-card .ab-close-button:focus{background-color:transparent}.ab-feed .ab-card .ab-close-button:hover{background-color:transparent}.ab-feed .ab-card .ab-close-button:hover svg{fill-opacity:.8}.ab-feed .ab-card .ab-close-button:hover{opacity:1}.ab-feed .ab-card .ab-close-button:focus{opacity:1}.ab-feed .ab-card a{color:inherit;text-decoration:none}.ab-feed .ab-card a:hover{text-decoration:underline}.ab-feed .ab-card .ab-image-area{display:inline-block;vertical-align:top;line-height:0;overflow:hidden;width:100%;-webkit-box-sizing:initial;-moz-box-sizing:initial;box-sizing:initial}.ab-feed .ab-card .ab-image-area img{height:auto;width:100%}.ab-feed .ab-card.ab-banner .ab-card-body{display:none}.ab-feed .ab-card .ab-card-body{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;display:inline-block;width:100%;position:relative}.ab-feed .ab-card .ab-unread-indicator{position:absolute;bottom:0;margin-right:-1px;width:100%;height:5px;background-color:#1676d0}.ab-feed .ab-card .ab-unread-indicator.read{background-color:transparent}.ab-feed .ab-card .ab-title{letter-spacing:0;margin:0;font-weight:700;display:block;overflow:hidden;word-wrap:break-word;text-overflow:ellipsis;font-size:18px;line-height:130%;font-family:'Helvetica Neue Light','Helvetica Neue',Helvetica,Arial,'Lucida Grande',sans-serif;padding:20px 25px 0 25px}.ab-feed .ab-card .ab-description{color:#545454;padding:15px 25px 20px 25px;word-wrap:break-word;white-space:pre-wrap}.ab-feed .ab-card .ab-description.ab-no-title{padding-top:20px}.ab-feed .ab-card .ab-url-area{color:#1676d0;margin-top:12px;font-family:'Helvetica Neue Light','Helvetica Neue',Helvetica,Arial,'Lucida Grande',sans-serif}.ab-feed .ab-card.ab-classic-card .ab-card-body{min-height:40px;-webkit-border-radius:3px;-moz-border-radius:3px;border-radius:3px}.ab-feed .ab-card.ab-classic-card.with-image .ab-card-body{min-height:100px;padding-left:72px}.ab-feed .ab-card.ab-classic-card.with-image .ab-image-area{width:60px;height:60px;padding:25px 0 25px 25px;position:absolute}.ab-feed .ab-card.ab-classic-card.with-image .ab-image-area img{-webkit-border-radius:3px;-moz-border-radius:3px;border-radius:3px;width:60px;height:60px}.ab-feed .ab-card.ab-classic-card.with-image .ab-title{background-color:transparent;font-size:16px}.ab-feed .ab-card.ab-classic-card.with-image .ab-description{padding-top:10px}.ab-feed .ab-card.ab-control-card{height:0;width:0;margin:0;border:0}.ab-feed .ab-feed-buttons-wrapper{position:relative;background-color:#282828;height:38px;-webkit-box-shadow:0 2px 3px 0 rgba(178,178,178,.5);-moz-box-shadow:0 2px 3px 0 rgba(178,178,178,.5);box-shadow:0 2px 3px 0 rgba(178,178,178,.5);z-index:1}.ab-feed .ab-feed-buttons-wrapper .ab-close-button,.ab-feed .ab-feed-buttons-wrapper .ab-refresh-button{cursor:pointer;color:#fff;font-size:18px;margin:10px;-webkit-transition:.2s;-moz-transition:.2s;-o-transition:.2s;transition:.2s}.ab-feed .ab-feed-buttons-wrapper .ab-close-button:hover,.ab-feed .ab-feed-buttons-wrapper .ab-refresh-button:hover{font-size:22px}.ab-feed .ab-feed-buttons-wrapper .ab-close-button{float:right;margin-top:9px}.ab-feed .ab-feed-buttons-wrapper .ab-close-button:hover{margin-top:6px;margin-right:9px}.ab-feed .ab-feed-buttons-wrapper .ab-refresh-button{margin-left:12px}.ab-feed .ab-feed-buttons-wrapper .ab-refresh-button:hover{margin-top:8px;margin-left:10px}.ab-feed .ab-no-cards-message{text-align:center;margin-bottom:20px}@media (max-width:600px){body>.ab-feed{width:100%}}"};function Qc(a){null==a&&(a="");var b=a.split("?").slice(1).join("?");a={};if(null!=b){b=b.split("&");for(var c=0;c<b.length;c++){var d=b[c].split("=");""!==d[0]&&(a[d[0]]=d[1])}}return a}function Rc(a){return a&&(a=a.toString().toLowerCase(),0===a.lastIndexOf("javascript:",0)||0===a.lastIndexOf("data:",0))?!0:!1};function zc(a,b,c,d,e,f,g,h,l,k,m,q,t){f=f||gc.MANUAL;null!=a&&0<a.length&&0<a.indexOf('"ab-in-app-message ab-html-message ab-email-capture"')&&0<a.indexOf('"ab-in-app-message ab-show ab-modal ab-effect-modal"')&&(l=h=!0);U.call(this,a,null,null,b,c,d,e,null,null,null,f,g,null,null,null,null,null,null,null,null,h,l,null,null,null,k,void 0,void 0,void 0,m,q);this.messageFields=t}ia(zc,U);zc.prototype.Ce=function(){return!1};zc.prototype.eb=function(a){return this.Ra?!1:(this.Ra=!0,zb(this.W,a),!0)};
zc.prototype.Y=function(a,b,c,d,e){function f(l){var k=l.getAttribute("href"),m=l.onclick;return function(q){if(null==m||"function"!==typeof m||!1!==m()){var t=Qc(k).abButtonId;if(null==t||""===t)t=l.getAttribute("id");if(null!=k&&""!==k&&0!==k.indexOf("#")){var r="blank"===(l.getAttribute("target")||"").toLowerCase().replace("_",""),y=e||g.openTarget===fc.BLANK||r;r=function(){a.Bb(g,t,k);Lb.openUri(k,q,y)};y?r():Fc(g,h,r)}else a.Bb(g,t,k);q.stopPropagation();return!1}}}var g=this;this.cc=document.activeElement;
var h=document.createElement("iframe");h.setAttribute("title","Modal Message");h.onload=function(){function l(z){return function(){var F=arguments;Fc(g,h,function(){b.display[z].apply(b.display,Array.prototype.slice.call(F))})}}function k(z){return function(){var F=b.getUser();F[z].apply(F,Array.prototype.slice.call(arguments))}}function m(z){return function(){b[z].apply(b,Array.prototype.slice.call(arguments))}}var q=null,t=a.Tf();if(null!=t){q=document.createElement("html");q.innerHTML=g.message;
for(var r=q.getElementsByTagName("style"),y=0;y<r.length;y++)r[y].setAttribute("nonce",t);r=q.getElementsByTagName("script");for(y=0;y<r.length;y++)r[y].setAttribute("nonce",t)}h.contentWindow.focus();h.contentWindow.document.write(q?q.innerHTML:g.message);q=h.contentWindow.document.getElementsByTagName("head")[0];null!=q&&(r=document.createElement("style"),r.innerHTML=Pc.je,null!=t&&r.setAttribute("nonce",t),q.appendChild(r),lc(g)&&(r=document.createElement("style"),r.innerHTML=g.css,r.id=mc(g),
null!=t&&r.setAttribute("nonce",t),q.appendChild(r)),t=h.contentWindow.document.createElement("base"),t.setAttribute("target","_parent"),q.appendChild(t));t=h.contentWindow.document.getElementsByTagName("title");0<t.length&&h.setAttribute("title",t[0].textContent);t={closeMessage:function(){Fc(g,h)},logClick:function(){var z=[g];0<arguments.length&&z.push(arguments[0]);b.logInAppMessageHtmlClick.apply(b,z)},display:{},web:{}};q=["requestImmediateDataFlush","logCustomEvent","logPurchase","unregisterAppboyPushMessages"];
for(r=0;r<q.length;r++)t[q[r]]=m(q[r]);q="setFirstName setLastName setEmail setGender setDateOfBirth setCountry setHomeCity setEmailNotificationSubscriptionType setPushNotificationSubscriptionType setPhoneNumber setCustomUserAttribute addToCustomAttributeArray removeFromCustomAttributeArray incrementCustomUserAttribute setCustomLocationAttribute".split(" ");var A={};for(r=0;r<q.length;r++)A[q[r]]=k(q[r]);t.getUser=function(){return A};q=["showFeed"];for(r=0;r<q.length;r++)t.display[q[r]]=l(q[r]);
q=["registerAppboyPushMessages","trackLocation"];for(r=0;r<q.length;r++)t.web[q[r]]=m(q[r]);h.contentWindow.appboyBridge=t;if(g.dg!==yc){q=h.contentWindow.document.getElementsByTagName("a");for(r=0;r<q.length;r++)q[r].onclick=f(q[r]);q=h.contentWindow.document.getElementsByTagName("button");for(r=0;r<q.length;r++)q[r].onclick=f(q[r])}q=h.contentWindow.document.body;null!=q&&(kc(g)&&(q.id=g.htmlId),r=document.createElement("hidden"),r.onclick=t.closeMessage,r.className="ab-programmatic-close-button",
q.appendChild(r));h.contentWindow.dispatchEvent(new CustomEvent("ab.BridgeReady"));-1!==h.className.indexOf("ab-start-hidden")&&(h.className=h.className.replace("ab-start-hidden",""),d(h));document.activeElement!==h&&h.focus()};h.className="ab-in-app-message ab-start-hidden ab-html-message ab-modal-interactions";return jb.Dd===jb.Zf.Bc?(c=document.createElement("div"),c.className="ab-ios-scroll-wrapper",c.appendChild(h),this.bc=c):this.bc=h};
zc.prototype.ma=function(){return U.prototype.ma.call(this)+" ab-effect-html"};I.HtmlMessage=zc;function sc(a,b,c,d,e,f,g,h,l,k,m,q,t,r,y,A,z,F,G,E,K,N,L,Y,ea,n,u,x,C){k=k||gc.MANUAL;u=u||Ic.FIT_CENTER;U.call(this,a,b,null,c,d,e,f,g,h,l,k,m,q,t,r,y,A,z,F,G,E,K,N,L,Y,ea,n,u,void 0,x,C)}ia(sc,U);sc.prototype.Y=function(a,b,c,d,e){this.cc=document.activeElement;b=U.prototype.Y.call(this,a,c,d,e);b.className+=" ab-modal ab-centered";Oc(this,a,c,b,e);Mc(b);Nc(this.Sc,b);return b};sc.prototype.ma=function(){return U.prototype.ma.call(this)+" ab-effect-modal"};sc.DefaultTextAlignment=Jc;
I.ModalMessage=sc;function wc(a,b,c,d,e,f,g,h,l,k,m,q,t,r,y,A,z,F,G,E,K,N,L){F=F||ic.Xe;z=z||ic.We;b=b||cc.START;U.call(this,a,b,c,d,e,f,g,h,l,k,m,q,t,r,null,y,A,z,F,G,E,K,void 0,void 0,void 0,void 0,void 0,void 0,void 0,N,L)}ia(wc,U);p=wc.prototype;p.Za=function(){return!1};
p.Y=function(a,b,c,d,e){var f=U.prototype.Y.call(this,a,c,d,e);f.className+=" ab-slideup";var g=f.getElementsByClassName("ab-close-button")[0];null!=g&&(a=Jb("0 0 11.38 19.44","M11.38 9.72l-9.33 9.72L0 17.3l7.27-7.58L0 2.14 2.05 0l9.33 9.72z",lc(this)?void 0:bc(this.closeButtonColor)),a.setAttribute("class","ab-chevron"),g.appendChild(a));Eb(f,Fb,function(l){f.className+=" ab-swiped-left";g.onclick(l)});Eb(f,Gb,function(l){f.className+=" ab-swiped-right";g.onclick(l)});if(this.slideFrom===dc.TOP){a=
Hb;var h=" ab-swiped-up"}else a=Ib,h=" ab-swiped-down";Eb(f,a,function(l){f.className+=h;g.onclick(l)});return f};p.fe=function(){var a=document.createElement("span");a.appendChild(document.createTextNode(this.message));return a};p.rc=function(a){var b=a.getElementsByClassName("ab-in-app-message")[0];Cb(b,!0,!0)||(this.slideFrom===dc.TOP?b.style.top="0px":b.style.bottom="0px");U.prototype.rc.call(this,a)};p.ma=function(){return U.prototype.ma.call(this)+" ab-effect-slide"};
wc.DefaultTextAlignment="START";I.SlideUpMessage=wc;function Sc(a,b){Tc={en:{NO_CARDS_MESSAGE:"We have no updates for you at this time.<br/>Please check again later.",FEED_TIMEOUT_MESSAGE:"Sorry, this refresh timed out.<br/>Please try again later."},ar:{NO_CARDS_MESSAGE:"\u0644\u064a\u0633 \u0644\u062f\u064a\u0646\u0627 \u0623\u064a \u062a\u062d\u062f\u064a\u062b. \u064a\u0631\u062c\u0649 \u0627\u0644\u062a\u062d\u0642\u0642 \u0645\u0631\u0629 \u0623\u062e\u0631\u0649 \u0644\u0627\u062d\u0642\u0627\u064b",FEED_TIMEOUT_MESSAGE:"\u064a\u0631\u062c\u0649 \u062a\u0643\u0631\u0627\u0631 \u0627\u0644\u0645\u062d\u0627\u0648\u0644\u0629 \u0644\u0627\u062d\u0642\u0627"},
cs:{NO_CARDS_MESSAGE:"V tuto chv\u00edli pro v\u00e1s nem\u00e1me \u017e\u00e1dn\u00e9 aktualizace.<br/>Zkontrolujte pros\u00edm znovu pozd\u011bji.",FEED_TIMEOUT_MESSAGE:"Pros\u00edm zkuste to znovu pozd\u011bji."},da:{NO_CARDS_MESSAGE:"Vi har ingen updates.<br/>Pr\u00f8v venligst senere.",FEED_TIMEOUT_MESSAGE:"Pr\u00f8v venligst senere."},de:{NO_CARDS_MESSAGE:"Derzeit sind keine Updates verf\u00fcgbar.<br/>Bitte sp\u00e4ter noch einmal versuchen.",FEED_TIMEOUT_MESSAGE:"Bitte sp\u00e4ter noch einmal versuchen."},
es:{NO_CARDS_MESSAGE:"No tenemos actualizaciones.<br/>Por favor compru\u00e9belo m\u00e1s tarde.",FEED_TIMEOUT_MESSAGE:"Por favor int\u00e9ntelo m\u00e1s tarde."},"es-mx":{NO_CARDS_MESSAGE:"No tenemos ninguna actualizaci\u00f3n.<br/>Vuelva a verificar m\u00e1s tarde.",FEED_TIMEOUT_MESSAGE:"Por favor, vuelva a intentarlo m\u00e1s tarde."},et:{NO_CARDS_MESSAGE:"Uuendusi pole praegu saadaval.<br/>Proovige hiljem uuesti.",FEED_TIMEOUT_MESSAGE:"Palun proovige hiljem uuesti."},fi:{NO_CARDS_MESSAGE:"P\u00e4ivityksi\u00e4 ei ole saatavilla.<br/>Tarkista my\u00f6hemmin uudelleen.",
FEED_TIMEOUT_MESSAGE:"Yrit\u00e4 my\u00f6hemmin uudelleen."},fr:{NO_CARDS_MESSAGE:"Aucune mise \u00e0 jour disponible.<br/>Veuillez v\u00e9rifier ult\u00e9rieurement.",FEED_TIMEOUT_MESSAGE:"Veuillez r\u00e9essayer ult\u00e9rieurement."},he:{NO_CARDS_MESSAGE:".\u05d0\u05d9\u05df \u05dc\u05e0\u05d5 \u05e2\u05d3\u05db\u05d5\u05e0\u05d9\u05dd. \u05d1\u05d1\u05e7\u05e9\u05d4 \u05d1\u05d3\u05d5\u05e7 \u05e9\u05d5\u05d1 \u05d1\u05e7\u05e8\u05d5\u05d1",FEED_TIMEOUT_MESSAGE:".\u05d1\u05d1\u05e7\u05e9\u05d4 \u05e0\u05e1\u05d4 \u05e9\u05d5\u05d1 \u05d1\u05e7\u05e8\u05d5\u05d1"},
hi:{NO_CARDS_MESSAGE:"\u0939\u092e\u093e\u0930\u0947 \u092a\u093e\u0938 \u0915\u094b\u0908 \u0905\u092a\u0921\u0947\u091f \u0928\u0939\u0940\u0902 \u0939\u0948\u0902\u0964 \u0915\u0943\u092a\u092f\u093e \u092c\u093e\u0926 \u092e\u0947\u0902 \u092b\u093f\u0930 \u0938\u0947 \u091c\u093e\u0901\u091a \u0915\u0930\u0947\u0902.\u0964",FEED_TIMEOUT_MESSAGE:"\u0915\u0943\u092a\u092f\u093e \u092c\u093e\u0926 \u092e\u0947\u0902 \u0926\u094b\u092c\u093e\u0930\u093e \u092a\u094d\u0930\u092f\u093e\u0938 \u0915\u0930\u0947\u0902\u0964."},
id:{NO_CARDS_MESSAGE:"Kami tidak memiliki pembaruan. Coba lagi nanti.",FEED_TIMEOUT_MESSAGE:"Coba lagi nanti."},it:{NO_CARDS_MESSAGE:"Non ci sono aggiornamenti.<br/>Ricontrollare pi\u00f9 tardi.",FEED_TIMEOUT_MESSAGE:"Riprovare pi\u00f9 tardi."},ja:{NO_CARDS_MESSAGE:"\u30a2\u30c3\u30d7\u30c7\u30fc\u30c8\u306f\u3042\u308a\u307e\u305b\u3093\u3002<br/>\u5f8c\u3067\u3082\u3046\u4e00\u5ea6\u78ba\u8a8d\u3057\u3066\u304f\u3060\u3055\u3044\u3002",FEED_TIMEOUT_MESSAGE:"\u5f8c\u3067\u3082\u3046\u4e00\u5ea6\u8a66\u3057\u3066\u304f\u3060\u3055\u3044\u3002"},
ko:{NO_CARDS_MESSAGE:"\uc5c5\ub370\uc774\ud2b8\uac00 \uc5c6\uc2b5\ub2c8\ub2e4. \ub2e4\uc74c\uc5d0 \ub2e4\uc2dc \ud655\uc778\ud574 \uc8fc\uc2ed\uc2dc\uc624.",FEED_TIMEOUT_MESSAGE:"\ub098\uc911\uc5d0 \ub2e4\uc2dc \uc2dc\ub3c4\ud574 \uc8fc\uc2ed\uc2dc\uc624."},ms:{NO_CARDS_MESSAGE:"Tiada kemas kini. Sila periksa kemudian.",FEED_TIMEOUT_MESSAGE:"Sila cuba kemudian."},nl:{NO_CARDS_MESSAGE:"Er zijn geen updates.<br/>Probeer het later opnieuw.",FEED_TIMEOUT_MESSAGE:"Probeer het later opnieuw."},no:{NO_CARDS_MESSAGE:"Vi har ingen oppdateringer.<br/>Vennligst sjekk igjen senere.",
FEED_TIMEOUT_MESSAGE:"Vennligst pr\u00f8v igjen senere."},pl:{NO_CARDS_MESSAGE:"Brak aktualizacji.<br/>Prosz\u0119 sprawdzi\u0107 ponownie p\u00f3\u017aniej.",FEED_TIMEOUT_MESSAGE:"Prosz\u0119 spr\u00f3bowa\u0107 ponownie p\u00f3\u017aniej."},pt:{NO_CARDS_MESSAGE:"N\u00e3o temos atualiza\u00e7\u00f5es.<br/>Por favor, verifique mais tarde.",FEED_TIMEOUT_MESSAGE:"Por favor, tente mais tarde."},"pt-br":{NO_CARDS_MESSAGE:"N\u00e3o temos nenhuma atualiza\u00e7\u00e3o.<br/>Verifique novamente mais tarde.",
FEED_TIMEOUT_MESSAGE:"Tente novamente mais tarde."},ru:{NO_CARDS_MESSAGE:"\u041e\u0431\u043d\u043e\u0432\u043b\u0435\u043d\u0438\u044f \u043d\u0435\u0434\u043e\u0441\u0442\u0443\u043f\u043d\u044b.<br/>\u041f\u043e\u0436\u0430\u043b\u0443\u0439\u0441\u0442\u0430, \u043f\u0440\u043e\u0432\u0435\u0440\u044c\u0442\u0435 \u0441\u043d\u043e\u0432\u0430 \u043f\u043e\u0437\u0436\u0435.",FEED_TIMEOUT_MESSAGE:"\u041f\u043e\u0436\u0430\u043b\u0443\u0439\u0441\u0442\u0430, \u043f\u043e\u0432\u0442\u043e\u0440\u0438\u0442\u0435 \u043f\u043e\u043f\u044b\u0442\u043a\u0443 \u043f\u043e\u0437\u0436\u0435."},
sv:{NO_CARDS_MESSAGE:"Det finns inga uppdateringar.<br/>F\u00f6rs\u00f6k igen senare.",FEED_TIMEOUT_MESSAGE:"F\u00f6rs\u00f6k igen senare."},th:{NO_CARDS_MESSAGE:"\u0e40\u0e23\u0e32\u0e44\u0e21\u0e48\u0e21\u0e35\u0e01\u0e32\u0e23\u0e2d\u0e31\u0e1e\u0e40\u0e14\u0e15 \u0e01\u0e23\u0e38\u0e13\u0e32\u0e15\u0e23\u0e27\u0e08\u0e2a\u0e2d\u0e1a\u0e20\u0e32\u0e22\u0e2b\u0e25\u0e31\u0e07.",FEED_TIMEOUT_MESSAGE:"\u0e01\u0e23\u0e38\u0e13\u0e32\u0e25\u0e2d\u0e07\u0e43\u0e2b\u0e21\u0e48\u0e20\u0e32\u0e22\u0e2b\u0e25\u0e31\u0e07."},
uk:{NO_CARDS_MESSAGE:"\u041e\u043d\u043e\u0432\u043b\u0435\u043d\u043d\u044f \u043d\u0435\u0434\u043e\u0441\u0442\u0443\u043f\u043d\u0456.<br/>\u043b\u0430\u0441\u043a\u0430, \u043f\u0435\u0440\u0435\u0432\u0456\u0440\u0442\u0435 \u0437\u043d\u043e\u0432\u0443 \u043f\u0456\u0437\u043d\u0456\u0448\u0435.",FEED_TIMEOUT_MESSAGE:"\u0411\u0443\u0434\u044c \u043b\u0430\u0441\u043a\u0430, \u0441\u043f\u0440\u043e\u0431\u0443\u0439\u0442\u0435 \u0449\u0435 \u0440\u0430\u0437 \u043f\u0456\u0437\u043d\u0456\u0448\u0435."},
vi:{NO_CARDS_MESSAGE:"Ch\u00fang t\u00f4i kh\u00f4ng c\u00f3 c\u1eadp nh\u1eadt n\u00e0o.<br/>Vui l\u00f2ng ki\u1ec3m tra l\u1ea1i sau.",FEED_TIMEOUT_MESSAGE:"Vui l\u00f2ng th\u1eed l\u1ea1i sau."},"zh-hk":{NO_CARDS_MESSAGE:"\u66ab\u6642\u6c92\u6709\u66f4\u65b0.<br/>\u8acb\u7a0d\u5019\u518d\u8a66.",FEED_TIMEOUT_MESSAGE:"\u8acb\u7a0d\u5019\u518d\u8a66."},"zh-hans":{NO_CARDS_MESSAGE:"\u6682\u65f6\u6ca1\u6709\u66f4\u65b0.<br/>\u8bf7\u7a0d\u540e\u518d\u8bd5.",FEED_TIMEOUT_MESSAGE:"\u8bf7\u7a0d\u5019\u518d\u8bd5."},
"zh-hant":{NO_CARDS_MESSAGE:"\u66ab\u6642\u6c92\u6709\u66f4\u65b0.<br/>\u8acb\u7a0d\u5019\u518d\u8a66.",FEED_TIMEOUT_MESSAGE:"\u8acb\u7a0d\u5019\u518d\u8a66."},"zh-tw":{NO_CARDS_MESSAGE:"\u66ab\u6642\u6c92\u6709\u66f4\u65b0.<br/>\u8acb\u7a0d\u5019\u518d\u8a66.",FEED_TIMEOUT_MESSAGE:"\u8acb\u7a0d\u5019\u518d\u8a66."},zh:{NO_CARDS_MESSAGE:"\u6682\u65f6\u6ca1\u6709\u66f4\u65b0.<br/>\u8bf7\u7a0d\u540e\u518d\u8bd5.",FEED_TIMEOUT_MESSAGE:"\u8bf7\u7a0d\u5019\u518d\u8bd5."}};null!=a&&(a=a.toLowerCase());
if(null!=a&&null==Tc[a]){var c=a.indexOf("-");0<c&&(a=a.substring(0,c))}null==Tc[a]&&(a="Braze does not yet have a localization for language "+a+", defaulting to English. Please contact us if you are willing and able to help us translate our SDK into this language.",b?v.error(a):v.info(a),a="en");Uc=a}var Tc,Uc;function Vc(a,b){this.cards=a;this.lastUpdated=b}p=Vc.prototype;p.oe=function(){for(var a=0,b=0;b<this.cards.length;b++)this.cards[b].viewed||a++;return a};function Wc(a,b){b&&(b.className=b.className.replace("ab-show","ab-hide"),setTimeout(function(){b&&b.parentNode&&b.parentNode.removeChild(b)},$b));var c=b.getAttribute(Xc);null!=c&&a.S(c)}p.Ga=function(a,b){a.Ga(b)};p.Fa=function(a,b){a.Fa(b)};
function Yc(a,b,c){var d=document.createElement("div");d.className="ab-feed-body";if(null==a.lastUpdated){c=document.createElement("div");c.className="ab-no-cards-message";var e=document.createElement("i");e.className="fa fa-spinner fa-spin fa-4x ab-initial-spinner";c.appendChild(e);d.appendChild(c)}else{e=!1;for(var f=function(k){a.Fa(b,k)},g=function(k){b.oc(k)},h=0;h<a.cards.length;h++){var l=a.cards[h]instanceof Wb;!l||a instanceof Zc?(d.appendChild(a.cards[h].Y(f,g,c)),e=e||!l):v.error("Received a control card for a legacy news feed. Control cards are only supported with content cards.")}e||
(c=document.createElement("div"),c.className="ab-no-cards-message",c.innerHTML=Tc[Uc].NO_CARDS_MESSAGE,d.appendChild(c))}return d}
function $c(a,b,c){if(null!=c){var d=[];c=c.querySelectorAll(".ab-card");a.Qc||(a.Qc={});for(var e=0;e<c.length;e++){var f=c[e].getAttribute("data-ab-card-id");if(!a.Qc[f]){var g=c[e];g=null!=g&&!!g.getAttribute("data-ab-had-top-impression");var h=c[e];h=null!=h&&!!h.getAttribute("data-ab-had-bottom-impression");var l=g,k=h,m=Cb(c[e],!0,!1,!1),q=Cb(c[e],!1,!0,!1);if(!g&&m){g=!0;var t=c[e];null!=t&&t.setAttribute("data-ab-had-top-impression",!0)}!h&&q&&(h=!0,t=c[e],null!=t&&t.setAttribute("data-ab-had-bottom-impression",
!0));if(g&&h&&(m||q||Yb(c[e]),!l||!k))for(g=0;g<a.cards.length;g++)if(a.cards[e].id===f){a.Qc[a.cards[e].id]=!0;d.push(a.cards[e]);break}}}0<d.length&&a.Ga(b,d)}}p.ce=function(a){a.uc()};
function ad(a,b,c){c.setAttribute("aria-busy","true");var d=c.querySelectorAll(".ab-refresh-button")[0];null!=d&&(d.className+=" fa-spin");var e=(new Date).valueOf().toString();c.setAttribute(bd,e);setTimeout(function(){if(c.getAttribute(bd)===e){for(var f=c.querySelectorAll(".fa-spin"),g=0;g<f.length;g++)f[g].className=f[g].className.replace(/fa-spin/g,"");f=c.querySelectorAll(".ab-initial-spinner")[0];null!=f&&(g=document.createElement("span"),g.innerHTML=Tc[Uc].FEED_TIMEOUT_MESSAGE,f.parentNode.appendChild(g),
f.parentNode.removeChild(f));"true"===c.getAttribute("aria-busy")&&c.setAttribute("aria-busy","false")}},cd);a.ce(b)}
p.Y=function(a,b){function c(k){ad(e,a,f);k.stopPropagation()}function d(k){Wc(a,f);k.stopPropagation()}var e=this,f=document.createElement("div");f.className="ab-feed ab-hide ab-effect-slide";f.setAttribute("tabindex","-1");f.setAttribute("aria-label","Feed");f.setAttribute("role","feed");var g=document.createElement("div");g.className="ab-feed-buttons-wrapper";f.appendChild(g);var h=document.createElement("i");h.className="fa fa-times ab-close-button";h.setAttribute("aria-label","Close Feed");h.setAttribute("tabindex",
"0");h.setAttribute("role","button");h.addEventListener("keydown",function(k){32!==k.keyCode&&13!==k.keyCode||d(k)});h.onclick=d;var l=document.createElement("i");l.className="fa fa-refresh ab-refresh-button";null==this.lastUpdated&&(l.className+=" fa-spin");l.setAttribute("aria-label","Refresh Feed");l.setAttribute("tabindex","0");l.setAttribute("role","button");l.addEventListener("keydown",function(k){32!==k.keyCode&&13!==k.keyCode||c(k)});l.onclick=c;g.appendChild(l);g.appendChild(h);f.appendChild(Yc(this,
a,b));f.onscroll=function(){$c(e,a,f)};return f};function dd(a,b,c,d,e,f){if(Aa(b)){for(var g=[],h=0;h<b.length;h++)b[h]instanceof Mb&&g.push(b[h]);a.cards=g;a.lastUpdated=c;null!=d&&(d.setAttribute("aria-busy","false"),null==a.lastUpdated?Wc(e,d):(b=d.querySelectorAll(".ab-feed-body")[0],null!=b&&(f=Yc(a,e,f),b.parentNode.replaceChild(f,b),$c(a,e,f.parentNode))))}}var $b=500,Xc="data-update-subscription-id",bd="data-last-requested-refresh",cd=1E4;I.Feed=Vc;I.Feed.prototype.getUnreadCardCount=Vc.prototype.oe;function Zc(a,b){Vc.call(this,a,b)}ia(Zc,Vc);Zc.prototype.Uf=function(){return Vc.prototype.oe.call(this)};Zc.prototype.Ga=function(a,b){a.Ga(b,!0)};Zc.prototype.Fa=function(a,b){a.Fa(b,!0)};Zc.prototype.ce=function(a){a.Ha()};I.ContentCards=Zc;I.ContentCards.prototype.getUnviewedCardCount=Zc.prototype.Uf;function Sa(){this.h=!1;this.j=[]};function ed(a){this.Xa=a}ed.prototype.ba=function(a){return null==this.Xa||this.Xa===a[0]};ed.prototype.B=function(){return this.Xa};function fd(a,b,c,d){this.te=a;this.tc=b;this.jb=c;this.I=d;this.tc===gd&&this.jb!==hd&&this.jb!==id&&this.jb!==jd&&this.jb!==kd&&(this.I=Ga(this.I))}
fd.prototype.ba=function(a){var b=null;null!=a&&(b=a[this.te]);switch(this.jb){case ld:return null!=b&&b.valueOf()===this.I.valueOf();case md:return null==b||b.valueOf()!==this.I.valueOf();case nd:return typeof b===typeof this.I&&b>this.I;case hd:return this.tc===gd?null!=b&&Ba(b)&&((new Date).valueOf()-b.valueOf())/1E3<=this.I:typeof b===typeof this.I&&b>=this.I;case od:return typeof b===typeof this.I&&b<this.I;case id:return this.tc===gd?null!=b&&Ba(b)&&((new Date).valueOf()-b.valueOf())/1E3>=this.I:
typeof b===typeof this.I&&b<=this.I;case pd:return null!=b&&"string"===typeof b&&typeof b===typeof this.I&&null!=b.match(this.I);case qd:return null!=b;case rd:return null==b;case jd:return null!=b&&Ba(b)&&(b.valueOf()-(new Date).valueOf())/1E3<this.I;case kd:return null!=b&&Ba(b)&&(b.valueOf()-(new Date).valueOf())/1E3>this.I;case sd:return null==b||typeof b!==typeof this.I||"string"!==typeof b||null==b.match(this.I)}return!1};
fd.prototype.B=function(){var a=this.I;Ba(this.I)&&(a=Fa(a.valueOf()));return{k:this.te,t:this.tc,c:this.jb,v:a}};var ld=1,md=2,nd=3,hd=4,od=5,id=6,pd=10,qd=11,rd=12,jd=15,kd=16,sd=17,gd="date";function td(a){this.filters=a}td.prototype.ba=function(a){for(var b=!0,c=0;c<this.filters.length;c++){for(var d=this.filters[c],e=!1,f=0;f<d.length;f++)if(d[f].ba(a)){e=!0;break}if(!e){b=!1;break}}return b};function ud(a){if(null==a||!Aa(a))return null;for(var b=[],c=0;c<a.length;c++){for(var d=[],e=a[c],f=0;f<e.length;f++){var g=e[f];d.push(new fd(g.property_key,g.property_type,g.comparator,g.property_value))}b.push(d)}return new td(b)}
td.prototype.B=function(){for(var a=[],b=0;b<this.filters.length;b++){for(var c=this.filters[b],d=[],e=0;e<c.length;e++)d.push(c[e].B());a.push(d)}return a};function vd(a){for(var b=[],c=0;c<a.length;c++){for(var d=[],e=a[c],f=0;f<e.length;f++){var g=e[f];d.push(new fd(g.k,g.t,g.c,g.v))}b.push(d)}return new td(b)};function wd(a,b){this.Xa=a;this.cb=b}wd.prototype.ba=function(a){if(null==this.Xa||null==this.cb)return!1;var b=a[1];return a[0]===this.Xa&&this.cb.ba(b)};wd.prototype.B=function(){return{e:this.Xa,pf:this.cb.B()}};function xd(a,b){this.Ta=a;this.wb=b}xd.prototype.ba=function(a){if(null==this.Ta)return!1;var b=yd(a[0],this.Ta);if(!b)return!1;var c=null==this.wb||0===this.wb.length;if(null!=this.wb)for(var d=0;d<this.wb.length;d++)if(this.wb[d]===a[1]){c=!0;break}return b&&c};xd.prototype.B=function(){return this.Ta};function zd(a){this.bb=a}zd.prototype.ba=function(a){return null==this.bb||a[0]===this.bb};zd.prototype.B=function(){return this.bb};function Ad(a,b){this.bb=a;this.cb=b}Ad.prototype.ba=function(a){if(null==this.bb||null==this.cb)return!1;var b=a[1];return a[0]===this.bb&&this.cb.ba(b)};Ad.prototype.B=function(){return{id:this.bb,pf:this.cb.B()}};function Bd(a){this.Ta=a}Bd.prototype.ba=function(a){return null==this.Ta?!0:yd(a[0],this.Ta)};Bd.prototype.B=function(){return this.Ta};var Cd={OPEN:"open",Jc:"purchase",Ed:"push_click",yc:"custom_event",Nb:"iam_click",Vb:"test"};function Dd(a,b){this.type=a;this.data=b}function Ed(a,b,c){return Fd[a.type]===b&&(null==a.data||a.data.ba(c))}function yd(a,b){var c=null;try{c=window.atob(a)}catch(d){return v.info("Failed to unencode analytics id "+a+": "+d.message),!1}return b===c.split("_")[0]}
function Gd(a){var b=a.type;switch(b){case Hd:var c=null;break;case Id:a=a.data;c=new zd(a?a.product_id:null);break;case Jd:a=a.data;c=new Ad(a?a.product_id:null,a?ud(a.property_filters):null);break;case Kd:a=a.data;c=new Bd(a?a.campaign_id:null);break;case Ld:a=a.data;c=new ed(a?a.event_name:null);break;case Md:a=a.data;c=new wd(a?a.event_name:null,a?ud(a.property_filters):null);break;case Nd:a=a.data;c=new xd(a?a.id:null,a?a.buttons:null);break;case Od:c=null}return new Dd(b,c)}
Dd.prototype.B=function(){return{t:this.type,d:this.data?this.data.B():null}};function Pd(a){switch(a.t){case Hd:var b=null;break;case Id:b=new zd(a.d);break;case Jd:b=a.d||{};b=new Ad(b.id,vd(b.pf||[]));break;case Kd:b=new Bd(a.d);break;case Ld:b=new ed(a.d);break;case Md:b=a.d||{};b=new wd(b.e,vd(b.pf||[]));break;case Nd:b=new xd(a.d);break;case Od:b=null}return new Dd(a.t,b)}
var Hd="open",Id="purchase",Jd="purchase_property",Kd="push_click",Ld="custom_event",Md="custom_event_property",Nd="iam_click",Od="test",Fd={};Fd[Hd]=Cd.OPEN;Fd[Id]=Cd.Jc;Fd[Jd]=Cd.Jc;Fd[Kd]=Cd.Ed;Fd[Ld]=Cd.yc;Fd[Md]=Cd.yc;Fd[Nd]=Cd.Nb;Fd[Od]=Cd.Vb;function Qd(a,b,c,d,e,f,g,h,l,k,m,q){this.id=a;this.kb=b||[];void 0===c&&(c=null);this.startTime=c;void 0===d&&(d=null);this.endTime=d;this.priority=e||0;this.type=f;this.Wa=h||0;null==k&&(k=1E3*(this.Wa+30));this.Ia=k;this.data=g;null==l&&(l=Rd);this.Db=l;this.se=m;this.za=q||null}
function Sd(a,b){var c=(new Date).valueOf()-b;(b=null==b||isNaN(c)||null==a.Ia||c<a.Ia)||v.info("Trigger action "+a.type+" is no longer eligible for display - fired "+c+"ms ago and has a timeout of "+a.Ia+"ms");return!b}Qd.prototype.B=function(){for(var a=[],b=0;b<this.kb.length;b++)a.push(this.kb[b].B());return{i:this.id,c:a,s:this.startTime,e:this.endTime,p:this.priority,t:this.type,da:this.data,d:this.Wa,r:this.Db,tm:this.Ia,ss:this.se,ld:this.za}};
function Td(a){for(var b=[],c=0;c<a.c.length;c++)b.push(Pd(a.c[c]));return new Qd(a.i,b,Ia(a.s),Ia(a.e),a.p,a.t,a.da,a.d,a.r,a.tm,a.ss,a.ld)}var Rd=-1,Ud={Ac:"inapp",Jd:"templated_iam"};function Vd(a,b){a=Math.ceil(a);b=Math.floor(b);return Math.floor(Math.random()*(b-a+1))+a};function Wd(a){var b,c=!1;try{if(window.XMLHttpRequest&&(b=new XMLHttpRequest)&&"undefined"!==typeof b.withCredentials||("undefined"!==typeof XDomainRequest?(b=new XDomainRequest,c=b.async=!0):v.error("This browser does not have any supported ajax options!")),null!=b){var d=function(){"function"===typeof a.error&&a.error(b.status);"function"===typeof a.hc&&a.hc(!1)};b.onload=function(){if(c)var h=!0;else{if(4!==b.readyState)return;h=200<=b.status&&300>b.status||304===b.status}h?("function"===typeof a.h&&
a.h(JSON.parse(b.responseText)),"function"===typeof a.hc&&a.hc(!0)):d()};b.onerror=function(){d()};b.ontimeout=function(){d()};var e=JSON.stringify(a.data);if(c)b.onprogress=function(){},b.open("post",a.url);else{b.open("POST",a.url,!0);b.setRequestHeader("Content-type","application/json");b.setRequestHeader("X-Requested-With","XMLHttpRequest");for(var f=a.headers||[],g=0;g<f.length;g++)b.setRequestHeader(f[g][0],f[g][1])}b.send(e)}}catch(h){v.error("Network request error: "+h.message)}};function Xd(a,b,c,d,e,f,g,h,l,k,m){this.Z=a;this.Cf=b;this.Zd=c;this.xf=d;this.Wb=e;this.hb=0;this.$b=k.T.ne;this.Td=null;this.G=f;this.Xb=g;this.f=h;this.D=l;this.b=k;this.vf=m;this.Uc=new xb;this.uf=1E3;this.tf=6E4}function Yd(a,b){var c=Zd(a.Xb),d=c.ic(),e=Q(a.b,M.zc);Ea(e,d)||(b.device=d);b.api_key=a.Z;b.time=Fa((new Date).valueOf(),!0);b.sdk_version=a.Cf;a.Zd&&(b.sdk_flavor=a.Zd);b.app_version=a.xf;b.device_id=c.id;return b}
function $d(a,b){if(b.error){var c=b.error;"invalid_api_key"===b.error?c='The API key "'+a.api_key+'" is invalid.':"blacklisted"===b.error?c="Sorry, we are not currently accepting your requests. If you think this is in error, please contact us.":"no_device_identifier"===b.error&&(c="No device identifier. Please contact support@braze.com");v.error("Backend error: "+c);return!1}return!0}
function ae(a,b,c,d,e,f,g){null==d&&(d=!0);d&&be(a);var h=mb(a.b),l=qb(a.b),k=ce(a.G);if(0<h.length)for(var m=0;m<h.length;m++)h[m].type===B.Id&&(k=!0);var q=c||k;if(!d||0!==h.length||0!==l.length||b||q){var t=de(a,b,q);if(0<h.length){b=[];for(c=0;c<h.length;c++)b.push(h[c].ic());t.events=b}0<l.length&&(t.attributes=l);t=Yd(a,t);b=ee(a,t);q&&a.hb++;Wd({url:""+a.Wb+"/data/",data:t,headers:b,h:function(r){q&&(a.hb=Math.max(a.hb-1,0));if($d(t,r)){var y=a.D;if(null!=r&&null!=r.config){var A=r.config;
if(A.time>fe(y).$a){A=new ge(A.time,A.events_blacklist,A.attributes_blacklist,A.purchases_blacklist,A.messaging_session_timeout,A.vapid_public_key,A.content_cards);var z=!1;null!=A.oa&&fe(y).oa!==A.oa&&(z=!0);var F=!1;null!=A.Va.enabled&&(fe(y).Va.enabled||!1)!==A.Va.enabled&&(F=!0);y.dc=A;P(y.b,M.Hd,A.B());z&&zb(y.Zc);F&&zb(y.Ld)}}if(null==t.respond_with||t.respond_with.user_id==a.f.A())null!=t.device&&P(a.b,M.zc,t.device),a.vf(r),"function"===typeof e&&e()}},error:function(){q&&(a.hb=Math.max(a.hb-
1,0));Ua(a.b,h);for(var r=0;r<l.length;r++)ob(a.b,l[r]);"function"===typeof f&&f()},hc:function(r){"function"===typeof g&&g(r);if(d)if(r)ie(a);else{r=a.Td;if(null==r||r<1E3*a.$b)r=1E3*a.$b;ie(a,Math.min(3E5,Vd(1E3*a.$b,3*r)))}}});k&&(v.info("Invoking new session subscriptions"),zb(a.Uc))}else ie(a),"function"===typeof g&&g(!0)}function je(a,b){var c="HTTP error ";null!=a&&(c+=a+" ");v.error(c+b)}
function ke(a,b,c,d,e){var f=de(a,!1,!1);f=Yd(a,f);f.template={trigger_id:b.Ja,trigger_event_type:c};null!=d&&(f.template.data=d.ic());var g=ee(a,f);Wd({url:""+a.Wb+"/template/",data:f,headers:g,h:function(h){$d(f,h)?null==h||null==h.templated_message?a.L(b.Ja,Kc.qb):(h=h.templated_message,h.type!==Ud.Ac?a.L(b.Ja,Kc.sb):(h=nc(h.data),null==h?a.L(b.Ja,Kc.sb):"function"===typeof b.Ee?b.Ee(h):a.L(b.Ja,Kc.qb))):(a.L(b.Ja,Kc.qb),"function"===typeof b.De&&b.De())},error:function(h){var l="getting user personalization for message "+
b.Ja;if((new Date).valueOf()-b.kc>b.Ia)a.L(b.Ja,Kc.qb);else{var k=Math.min(b.Ia,a.tf),m=a.uf;null==e&&(e=m);var q=Math.min(k,Vd(m,3*e));l+=". Retrying in "+q+"ms";setTimeout(function(){ke(a,b,c,d,q)},q)}je(h,l)}})}p=Xd.prototype;
p.Ha=function(a,b,c){var d=Yd(this,{});d.last_full_sync_at=a;d.last_card_updated_at=b;a=this.f.A();null!=a&&(d.user_id=a);Wd({url:""+this.Wb+"/content_cards/sync",data:d,headers:[["X-Braze-Api-Key",this.Z],["X-Braze-DataRequest","true"],["X-Braze-ContentCardsRequest","true"]],h:function(e){$d(d,e)&&c(e)},error:function(e){je(e,"retrieving content cards")}})};
function de(a,b,c){var d={};b&&(d.feed=!0);c&&(d.triggers=!0);b=a.f.A();null!=b&&(d.user_id=b);d.config={config_time:fe(a.D).$a};return{respond_with:d}}function ee(a,b){a=[["X-Braze-Api-Key",a.Z]];var c=!1;null!=b.respond_with&&b.respond_with.triggers&&(a.push(["X-Braze-TriggersRequest","true"]),c=!0);null!=b.respond_with&&b.respond_with.feed&&(a.push(["X-Braze-FeedRequest","true"]),c=!0);c&&a.push(["X-Braze-DataRequest","true"]);return a}
function le(a){if(null==a.campaignId&&null==a.cardId&&null==a.triggerId)return v.info("The in-app message has no analytics id. Not logging event to Braze servers."),null;var b={};null!=a.cardId&&(b.card_ids=[a.cardId]);null!=a.campaignId&&(b.campaign_ids=[a.campaignId]);null!=a.triggerId&&(b.trigger_ids=[a.triggerId]);return b}function me(a){for(var b=null,c=0;c<a.length;c++)null!=a[c].id&&""!==a[c].id&&(b=b||{},b.ids=b.ids||[],b.ids.push(a[c].id));return b}
function ie(a,b){a.Nd||(null==b&&(b=1E3*a.$b),be(a),a.ac=setTimeout(function(){if(document.hidden){var c=function(){document.hidden||(document.removeEventListener("visibilitychange",c,!1),ae(a))};document.addEventListener("visibilitychange",c,!1)}else ae(a)},b),a.Td=b)}function be(a){null!=a.ac&&(clearTimeout(a.ac),a.ac=null)}p.ed=function(){this.Nd=!1;ie(this)};p.yb=function(){this.Uc.N();be(this);this.Nd=!0;ae(this,null,null,!1);this.ac=null};function ne(a,b){yb(a.Uc,b)}
p.sc=function(a,b){var c=this,d=oe(this.G),e=Ta(this.G);d=d!==e;ae(this,null,!1,null,null,null,b);Za(this);if(d&&null!=a&&(a.Ab()||a.Da())){var f=function(){a.zf?v.info("Push token maintenance is disabled, not refreshing token for backend."):a.subscribe()};b=xa.Na;ta(new pa(b),b.M.Kc,function(g,h){h&&f()},function(){var g=Q(c.b,M.Tb);(null==g||g)&&f()})}};
p.Ua=function(a,b,c,d){var e=this.f.A();if(e!==a){var f=this.G,g=Na(f.b.ia.O(nb.Oa));null!=g&&(f.b.ia.remove(nb.Oa),g=pe(f,(new Date).valueOf(),g),null==g||Ua(f.b,[g]));f=this.f;g=null==f.A();lb(f.b,nb.Oc,new Ma(a));if(g){f=f.b;g=f.T.O(M.Ka);if(null!=g){var h=M.ud,l=g[h];null!=l&&(g[h]=void 0,f.T.store(M.Ka,g),l.user_id=a,ob(f,l))}h=Na(f.ia.O(nb.Oa));g=null;null!=h&&(g=h.ea);h=mb(f);if(null!=h)for(l=0;l<h.length;l++){var k=h[l];null==k.Fb&&k.sessionId==g&&(k.Fb=a);null==k||Ua(f,[k])}}for(f=0;f<b.length;f++)b[f].Ua(null==
e);null!=e&&R(this.b,M.ob);R(this.b,M.zc);this.sc(d,c);v.info('Changed user to "'+a+'".')}else"function"===typeof c?(v.info('Current user is already "'+a+'". Executing networkCallCompleteCallback.'),c()):v.info('Current user is already "'+a+'". Doing nothing.')};p.mb=function(){return new J(this.f,this)};p.Eb=function(a){be(this);Ta(this.G);ae(this,null,null,null,null,null,a)};p.uc=function(){Ta(this.G);ae(this,!0)};
function qe(a,b,c){Ta(a.G);v.info("Requesting explicit trigger refresh.");ae(a,null,!0,null,b,c)}p.gd=function(a,b){var c=new Sa,d=Ta(this.G);if(-1!==fe(this.D).me.indexOf(a))return v.info('Custom Event "'+a+'" is blacklisted, ignoring.'),c;c.j.push(new D(this.f.A(),B.CustomEvent,(new Date).valueOf(),d,{n:a,p:b}));c.h=Ua(this.b,c.j);return c};
function Ya(a,b,c,d){var e=new Sa,f=Ta(a.G);if($a(a.D,c))return v.info('Custom Attribute "'+c+'" is blacklisted, ignoring.'),e;e.j.push(new D(a.f.A(),b,(new Date).valueOf(),f,{key:c,value:d}));e.h=Ua(a.b,e.j);return e}p.hd=function(a,b,c,d,e){var f=new Sa,g=Ta(this.G);if(-1!==fe(this.D).ue.indexOf(a))return v.info('Purchase "'+a+'" is blacklisted, ignoring.'),f;f.j.push(new D(this.f.A(),B.bf,(new Date).valueOf(),g,{pid:a,c:c,p:b,q:d,pr:e}));f.h=Ua(this.b,f.j);return f};
p.vc=function(a,b,c,d,e,f){var g=new Sa,h=Ta(this.G);b={latitude:b,longitude:c};null!=d&&(b.altitude=d);null!=e&&(b.ll_accuracy=e);null!=f&&(b.alt_accuracy=f);g.j.push(new D(a,B.kf,(new Date).valueOf(),h,b));g.h=Ua(this.b,g.j);return g};
p.Cb=function(a){var b=new Sa,c=Ta(this.G);if(a instanceof oc)b.j.push(new D(this.f.A(),B.Pe,(new Date).valueOf(),c,{trigger_ids:[a.triggerId]}));else{if(!a.md())return v.info("This in-app message has already received an impression. Ignoring analytics event."),b;a=le(a);if(null==a)return b;b.j.push(new D(this.f.A(),B.af,(new Date).valueOf(),c,a))}b.h=Ua(this.b,b.j);return b};
p.qc=function(a){var b=new Sa,c=Ta(this.G);if(!a.eb())return v.info("This in-app message has already received a click. Ignoring analytics event."),b;a=le(a);if(null==a)return b;b.j.push(new D(this.f.A(),B.Bd,(new Date).valueOf(),c,a));b.h=Ua(this.b,b.j);return b};
p.pc=function(a,b){var c=new Sa,d=Ta(this.G);if(!a.eb())return v.info("This in-app message button has already received a click. Ignoring analytics event."),c;b=le(b);if(null==b)return c;if(a.id===Lc)return v.info("This in-app message button does not have a tracking id. Not logging event to Braze servers."),c;null!=a.id&&(b.bid=a.id);c.j.push(new D(this.f.A(),B.Ad,(new Date).valueOf(),d,b));c.h=Ua(this.b,c.j);return c};
p.Bb=function(a,b,c){var d=new Sa,e=Ta(this.G);if(!a.eb(c))return v.info("This in-app message has already received a click. Ignoring analytics event."),d;a=le(a);if(null==a)return d;c=B.Bd;null!=b&&(a.bid=b,c=B.Ad);d.j.push(new D(this.f.A(),c,(new Date).valueOf(),e,a));d.h=Ua(this.b,d.j);return d};p.L=function(a,b){var c=new Sa,d=Ta(this.G);a={trigger_ids:[a],error_code:b};c.j.push(new D(this.f.A(),B.$e,(new Date).valueOf(),d,a));c.h=Ua(this.b,c.j);return c};
p.Ga=function(a,b){var c=new Sa,d=Ta(this.G),e=[],f=[];var g=b?Q(this.b,M.gb)||{}:Q(this.b,M.ob)||{};for(var h=0;h<a.length;h++)a[h].md(),a[h]instanceof Wb?f.push(a[h]):e.push(a[h]),g[a[h].id]=!0;a=me(e);f=me(f);if(null==a&&null==f)return c;b?P(this.b,M.gb,g):P(this.b,M.ob,g);null!=a&&c.j.push(new D(this.f.A(),b?B.Me:B.Je,(new Date).valueOf(),d,a));null!=f&&b&&c.j.push(new D(this.f.A(),B.Oe,(new Date).valueOf(),d,f));c.h=Ua(this.b,c.j);return c};
p.Fa=function(a,b){var c=new Sa,d=Ta(this.G);a.eb();if(null==a.url||""===a.url)return v.info("Card "+a.id+" has no url. Not logging click to Braze servers."),c;if(b){var e=Q(this.b,M.fb)||{};e[a.id]=!0;P(this.b,M.fb,e)}a=me([a]);if(null==a)return c;c.j.push(new D(this.f.A(),b?B.Ke:B.Ie,(new Date).valueOf(),d,a));c.h=Ua(this.b,c.j);return c};
p.oc=function(a){var b=new Sa,c=Ta(this.G);if(!a.kd())return v.info("Card "+a.id+" refused this dismissal. Ignoring analytics event."),b;var d=Q(this.b,M.ra)||{};d[a.id]=!0;P(this.b,M.ra,d);a=me([a]);if(null==a)return b;b.j.push(new D(this.f.A(),B.Le,(new Date).valueOf(),c,a));b.h=Ua(this.b,b.j);return b};function re(a,b){var c=new Sa,d=Ta(a.G);c.j.push(new D(a.f.A(),B.df,(new Date).valueOf(),d,{n:b}));c.h=Ua(a.b,c.j);return c}
function se(a,b,c){var d=Ta(a.G);return new D(a.f.A(),B.nf,b,d,{cid:c})}function Za(a){var b=xa.Na;(new pa(b)).setItem(b.M.Ue,1,{baseUrl:a.Wb,data:{api_key:a.Z,device_id:Zd(a.Xb).id},userId:a.f.A()})};var V={BROWSER:"browser",BROWSER_VERSION:"browserVersion",OS:"os",RESOLUTION:"resolution",LANGUAGE:"language",TIME_ZONE:"timeZone",USER_AGENT:"userAgent"};I.DeviceProperties=V;function te(a){this.id=a}te.prototype.ic=function(){var a={};null!=this[V.BROWSER]&&(a.browser=this[V.BROWSER]);null!=this[V.BROWSER_VERSION]&&(a.browser_version=this[V.BROWSER_VERSION]);null!=this[V.OS]&&(a.os_version=this[V.OS]);null!=this[V.RESOLUTION]&&(a.resolution=this[V.RESOLUTION]);null!=this[V.LANGUAGE]&&(a.locale=this[V.LANGUAGE]);null!=this[V.TIME_ZONE]&&(a.time_zone=this[V.TIME_ZONE]);null!=this[V.USER_AGENT]&&(a.user_agent=this[V.USER_AGENT]);return a};function ue(a,b){this.b=a;null==b&&(b=za(V));this.Od=b}
function Zd(a){var b=Na(a.b.ia.O(nb.xd));null==b&&(b=new Ma(oa.Ya()),lb(a.b,nb.xd,b));b=new te(b.ea);for(var c=0;c<a.Od.length;c++){var d=a.Od[c];switch(d){case V.BROWSER:b[d]=jb.vb;break;case V.BROWSER_VERSION:b[d]=jb.version;break;case V.OS:b[d]=jb.Dd;break;case V.RESOLUTION:b[d]=screen.width+"x"+screen.height;break;case V.LANGUAGE:b[d]=jb.language;break;case V.TIME_ZONE:a:{var e=new Date;if("undefined"!==typeof Intl&&"function"===typeof Intl.DateTimeFormat)try{if("function"===typeof Intl.DateTimeFormat().resolvedOptions){var f=
Intl.DateTimeFormat().resolvedOptions().timeZone;if(null!=f&&""!==f){var g=f;break a}}}catch(k){v.info("Intl.DateTimeFormat threw an error, probably https://bugs.chromium.org/p/chromium/issues/detail?id=811403, falling back to GTM offset: "+k.message)}g=e.getTimezoneOffset();e=parseInt(g/60);var h=parseInt(g%60),l="GMT";0!==g&&(l=l+(0>g?"+":"-")+(("00"+Math.abs(e)).slice(-2)+":"+("00"+Math.abs(h)).slice(-2)));g=l}b[d]=g;break;case V.USER_AGENT:b[d]=jb.userAgent}}return b};function ve(a){this.la=a;this.fc=null;this.be="geolocation"in navigator}ve.prototype.Ff=function(a){var b=this;if(document.hidden){we(this);var c=function(){document.hidden||(document.removeEventListener("visibilitychange",c,!1),b.watchPosition())};document.addEventListener("visibilitychange",c,!1)}this.la.vc(a.coords.latitude,a.coords.longitude,a.coords.accuracy,a.coords.altitude,a.coords.altitudeAccuracy)};
ve.prototype.Ef=function(a){a.code===a.PERMISSION_DENIED?v.info(a.message):v.error("Could not detect user location: "+a.code+" - "+a.message)};ve.prototype.watchPosition=function(){this.be?(we(this),this.fc=navigator.geolocation.watchPosition(this.Ff.bind(this),this.Ef.bind(this)),v.info("Requested Geolocation")):v.info(this.Hc)};function we(a){a.be?null!=a.fc&&(navigator.geolocation.clearWatch(a.fc),a.fc=null,v.info("Stopped watching Geolocation")):v.info(a.Hc)};function xe(a,b,c,d,e){this.endpoint=a||null;this.ie=b||null;this.publicKey=c||null;this.Ag=d||null;this.oa=e||null}xe.prototype.B=function(){return{e:this.endpoint,c:this.ie,p:this.publicKey,u:this.Ag,v:this.oa}};function ye(a,b,c,d,e,f,g,h,l,k){this.la=a;this.Z=b;this.Xb=c;this.Bf=d;this.$d=e||"/service-worker.js";this.Yd=f;this.D=g;this.Tc=l||!1;this.zf=h||!1;this.b=k;this.ec="serviceWorker"in navigator&&"undefined"!==typeof ServiceWorkerRegistration&&"showNotification"in ServiceWorkerRegistration.prototype&&"PushManager"in window;this.Xc="safari"in window&&"pushNotification"in window.safari}p=ye.prototype;p.Ea=function(){return this.ec||this.Xc};
p.Da=function(){return this.Ea()&&null!=Notification&&null!=Notification.permission&&"denied"===Notification.permission};p.Ab=function(){return this.Ea()&&null!=Notification&&null!=Notification.permission&&"granted"===Notification.permission};
p.fd=function(a,b,c){var d=this;c=this.Yd||c;this.Ea()?this.ec?ze(this).then(function(e){d.Da()?b():null==e?b():e.pushManager.getSubscription().then(function(f){f?a():b()}).catch(function(){b()})}).catch(function(){b()}):null==c||""===c?v.error("You must supply the safariWebsitePushId argument in order to use isPushGranted on Safari"):"granted"===window.safari.pushNotification.permission(c).permission?a():b():b()};
function Ae(a,b,c,d,e,f){b.unsubscribe().then(function(g){g?Be(a,c,d,e,f):(v.error("Failed to unsubscribe device from push."),"function"===typeof f&&f(!1))}).catch(function(g){v.error("Push unsubscription error: "+g);"function"===typeof f&&f(!1)})}
function Ce(a,b,c,d){var e=function(h){if("string"===typeof h)return h;if(0!==h.endpoint.indexOf("https://android.googleapis.com/gcm/send"))return h.endpoint;var l=h.endpoint;h.subscriptionId&&-1===h.endpoint.indexOf(h.subscriptionId)&&(l=h.endpoint+"/"+h.subscriptionId);return l}(b),f=null,g=null;if(null!=b.getKey)try{f=btoa(String.fromCharCode.apply(null,new Uint8Array(b.getKey("p256dh")))),g=btoa(String.fromCharCode.apply(null,new Uint8Array(b.getKey("auth"))))}catch(h){if("invalid arguments"!==
h.message)throw h;}b=function(h){var l;return h.options&&(l=h.options.applicationServerKey)&&l.byteLength&&0<l.byteLength?btoa(String.fromCharCode.apply(null,new Uint8Array(l))).replace(/\+/g,"-").replace(/\//g,"_"):null}(b);a.la.nd(e,d,f,g,b);e&&"function"===typeof c&&c(e,f,g)}
function De(a,b,c,d,e){"default"===c.permission?window.safari.pushNotification.requestPermission(a.Bf,b,{api_key:a.Z,device_id:Zd(a.Xb).id},function(f){"granted"===f.permission&&a.la.qd(Wa.OPTED_IN);De(a,b,f,d,e)}):"denied"===c.permission?(a.la.nb(!1),v.info("The user has blocked notifications from this site, or Safari push is not configured in the Braze dashboard."),"function"===typeof e&&e(!1)):"granted"===c.permission&&(v.info("Device successfully subscribed to push."),Ce(a,c.deviceToken,d,new Date))}
function Ee(a,b,c){function d(g){switch(g){case "granted":"function"===typeof a&&a();break;case "default":"function"===typeof b&&b();break;case "denied":"function"===typeof c&&c();break;default:v.error("Received unexpected permission result "+g)}}var e=!1,f=Notification.requestPermission(function(g){e&&d(g)});f?f.then(function(g){d(g)}):e=!0}
function Be(a,b,c,d,e){var f={userVisibleOnly:!0};null!=c&&(f.applicationServerKey=c);b.pushManager.subscribe(f).then(function(g){v.info("Device successfully subscribed to push.");Ce(a,g,d,new Date)}).catch(function(g){a.Da()?(v.info("Permission for push notifications was denied."),"function"===typeof e&&e(!1)):v.error("Push subscription failed: "+g)})}
function ze(a){return a.Tc?navigator.serviceWorker.getRegistration():navigator.serviceWorker.register(a.$d).then(function(){return navigator.serviceWorker.ready.then(function(b){b&&"function"===typeof b.update&&b.update().catch(function(c){v.info("ServiceWorker update failed: "+c)});return b})})}
p.subscribe=function(a,b,c){var d=this;a=this.Yd||a;if(this.Ea())if(this.ec){if(!this.Tc&&null!=window.location){var e=this.$d;-1===e.indexOf(window.location.host)&&(e=window.location.host+e);-1===e.indexOf(window.location.protocol)&&(e=window.location.protocol+"//"+e);if(0!==window.location.href.indexOf(e.substr(0,e.lastIndexOf("/")+1))){v.error("Cannot subscribe to push from a path higher than the service worker location (tried to subscribe from "+window.location.pathname+" but service worker is at "+
e+")");return}}if(this.Da())v.info("Notifications from this site are blocked. This may be a temporary embargo or a permanent denial."),this.la.nb(!1),"function"===typeof c&&c();else if(this.D&&!fe(this.D).oa&&0===fe(this.D).$a)v.info("Waiting for VAPID key from server config before subscribing to push."),Fe(this.D,function(){d.subscribe(a,b,c)});else{var f=this.Ab();Ee(function(){f||d.la.qd(Wa.OPTED_IN);ze(d).then(function(g){null==g?(v.error("No service worker registration. Set the `manageServiceWorkerExternally` initialization option to false or ensure that your service worker is registered before calling registerAppboyPushMessages."),
"function"===typeof c&&c()):g.pushManager.getSubscription().then(function(h){var l=null;d.D&&null!=fe(d.D).oa&&(l=ma.zg(fe(d.D).oa));if(h){var k=null,m=null,q=Q(d.b,M.Tb);if(q&&!Aa(q)){try{var t=(new xe(q.e,Ia(q.c),q.p,q.u,q.v)).ie}catch(r){t=null}null==t||isNaN(t.getTime())||0===t.getTime()||(k=t,m=new Date(k),m.setMonth(k.getMonth()+6))}null!=l&&h.options&&h.options.applicationServerKey&&h.options.applicationServerKey.byteLength&&0<h.options.applicationServerKey.byteLength&&!Ea(l,new Uint8Array(h.options.applicationServerKey))?
(12<h.options.applicationServerKey.byteLength?v.info("Device was already subscribed to push using a different VAPID provider, creating new subscription."):v.info("Attempting to upgrade a gcm_sender_id-based push registration to VAPID - depending on the browser this may or may not result in the same gcm_sender_id-based subscription."),Ae(d,h,g,l,b,c)):h.expirationTime&&new Date(h.expirationTime)<=(new Date).valueOf()?(v.info("Push subscription is expired, creating new subscription."),Ae(d,h,g,l,b,
c)):q&&Aa(q)?Ae(d,h,g,l,b,c):null==m?(v.info("No push subscription creation date found, creating new subscription."),Ae(d,h,g,l,b,c)):m<=(new Date).valueOf()?(v.info("Push subscription older than 6 months, creating new subscription."),Ae(d,h,g,l,b,c)):(v.info("Device already subscribed to push, sending existing subscription to backend."),Ce(d,h,b,k))}else Be(d,g,l,b,c)}).catch(function(h){v.error("Error checking current push subscriptions: "+h)})}).catch(function(g){v.error("ServiceWorker registration failed: "+
g)})},function(){var g="Permission for push notifications was ignored.";d.Da()&&(g+=" The browser has automatically blocked further permission requests for a period (probably 1 week).");v.info(g);"function"===typeof c&&c(!0)},function(){v.info("Permission for push notifications was denied.");"function"===typeof c&&c(!1)})}}else this.Xc&&(null==a||""===a?v.error("You must supply the safariWebsitePushId argument in order to use registerAppboyPushMessages on Safari"):(e=window.safari.pushNotification.permission(a),
De(this,a,e,b,c)));else v.info(this.Hc)};
p.unsubscribe=function(a,b){var c=this;this.Ea()?this.ec?navigator.serviceWorker.getRegistration().then(function(d){d&&d.pushManager.getSubscription().then(function(e){e&&(c.la.nb(!0),e.unsubscribe().then(function(f){f?(v.info("Device successfully unsubscribed from push."),"function"===typeof a&&a()):(v.error("Failed to unsubscribe device from push."),"function"===typeof b&&b());c.Tc||(d.unregister(),v.info("Service worker successfully unregistered."))}).catch(function(f){v.error("Push unsubscription error: "+f);
"function"===typeof b&&b()}))}).catch(function(e){v.error("Error unsubscribing from push: "+e);"function"===typeof b&&b()})}):this.Xc&&(this.la.nb(!0),v.info("Device unsubscribed from push."),"function"===typeof a&&a()):v.info(this.Hc)};function ge(a,b,c,d,e,f,g){this.$a=a||0;this.me=b||[];this.ee=c||[];this.ue=d||[];this.jd=e;if(null==e||""===e)this.jd=null;this.oa=f||null;this.Va=g||{}}ge.prototype.B=function(){return{s:"2.5.2",l:this.$a,e:this.me,a:this.ee,p:this.ue,m:this.jd,v:this.oa,c:this.Va}};function Ge(a){this.b=a;this.Zc=new xb;this.Ld=new xb;this.dc=null}function fe(a){if(null==a.dc){var b=Q(a.b,M.Hd);if(null!=b){var c=b.l;"2.5.2"!==b.s&&(c=0);b=new ge(c,b.e,b.a,b.p,b.m,b.v,b.c)}else b=new ge;a.dc=b}return a.dc}function Fe(a,b){b=yb(a.Zc,b);a.Md&&a.Zc.S(a.Md);a.Md=b}function He(a,b){yb(a.Ld,b)}function $a(a,b){return-1!==fe(a).ee.indexOf(b)};function Ie(a,b,c,d){this.b=a;this.f=b;this.D=c;this.tb=1E3;d=parseFloat(d);isNaN(d)&&(d=1800);d<this.tb/1E3&&(v.info("Specified session timeout of "+d+"s is too small, using the minimum session timeout of "+this.tb/1E3+"s instead."),d=this.tb/1E3);this.Df=d}function pe(a,b,c){return new D(a.f.A(),B.rf,b,c.ea,{d:Fa(b-c.xb)})}function oe(a){a=Na(a.b.ia.O(nb.Oa));return null==a?null:a.ea}
function ce(a){var b=(new Date).valueOf(),c=fe(a.D).jd;if(null==c)return!1;var d=Q(a.b,M.Pb);(c=null==d||b-d>1E3*c)&&P(a.b,M.Pb,b);return c}
function Ta(a){var b=(new Date).valueOf(),c=b+1E3*a.Df,d=Na(a.b.ia.O(nb.Oa));if(null==d||(b-d.xb<a.tb?0:d.bd<b)){var e="Generating session start event with time "+b;if(null!=d){var f=d.nc;f-d.xb<a.tb&&(f=d.xb+a.Eg);d=pe(a,f,d);null==d||Ua(a.b,[d]);e+=" (old session ended "+f+")"}e+=". Will expire "+c.valueOf();v.info(e);c=new Ma(oa.Ya(),c);e=new D(a.f.A(),B.Id,b,c.ea);null==e||Ua(a.b,[e]);lb(a.b,nb.Oa,c);null==Q(a.b,M.Pb)&&P(a.b,M.Pb,b);return c.ea}d.nc=b;d.bd=c;lb(a.b,nb.Oa,d);return d.ea};function Je(a,b){var c=!1;try{if(localStorage&&localStorage.getItem)try{localStorage.setItem(M.Lc,!0),localStorage.getItem(M.Lc)&&(localStorage.removeItem(M.Lc),c=!0)}catch(e){if(("QuotaExceededError"===e.name||"NS_ERROR_DOM_QUOTA_REACHED"===e.name)&&0<localStorage.length)c=!0;else throw e;}}catch(e){v.info("Local Storage not supported!")}var d=navigator.cookieEnabled||"cookie"in document&&(0<document.cookie.length||-1<(document.cookie="test").indexOf.call(document.cookie,"test"));b=new wb(a,d&&!b,
c);return new kb(b,c?new rb(a):new vb)};function Ke(a){for(var b=a.length,c=a.length-1;0<=c;c--){var d=a.charCodeAt(c);127<d&&2047>=d?b++:2047<d&&65535>=d&&(b+=2);56320<=d&&57343>=d&&c--}return b};function Le(a,b){this.D=a;this.b=b}p=Le.prototype;p.A=function(){var a=Na(this.b.ia.O(nb.Oc));if(null==a)return null;var b=a.ea,c=Ke(b);if(997<c){for(;997<c;)b=b.slice(0,b.length-1),c=Ke(b);a.ea=b;lb(this.b,nb.Oc,a)}return b};p.od=function(a,b){if($a(this.D,a))return v.info('Custom Attribute "'+a+'" is blacklisted, ignoring.'),!1;var c={};c[a]=b;return this.H("custom",c)};p.H=function(a,b){return pb(this.b,this.A(),a,b)};
p.nd=function(a,b,c,d,e){this.H("push_token",a);this.H("custom_push_public_key",c);this.H("custom_push_user_auth",d);this.H("custom_push_vapid_public_key",e);var f=xa.Na,g=new pa(f);P(this.b,M.Tb,(new xe(a,b,c,d,e)).B());g.setItem(f.M.Kc,f.Ub,!0)};p.nb=function(a){this.H("push_token",null);this.H("custom_push_public_key",null);this.H("custom_push_user_auth",null);this.H("custom_push_vapid_public_key",null);if(a){a=xa.Na;var b=new pa(a);P(this.b,M.Tb,!1);b.setItem(a.M.Kc,a.Ub,!1)}};function Me(){}Me.prototype.zb=function(){};Me.prototype.Ua=function(){};Me.prototype.clearData=function(){};function Ne(a,b,c,d,e){this.ca=a;this.J=b;this.b=c;this.D=d;this.wf=e;this.xa=this.Aa=0;this.Ca()}ia(Ne,Me);p=Ne.prototype;p.Ca=function(){for(var a=Q(this.b,M.pb)||[],b=[],c=0;c<a.length;c++){var d=Xb(a[c]);null!=d&&b.push(d)}this.C=Oe(this,Pe(this,b,!1));this.Aa=Q(this.b,M.Lb)||this.Aa;this.xa=Q(this.b,M.Kb)||this.xa};
p.zb=function(a){if(!fe(this.D).Va.enabled)0!==fe(this.D).$a&&Qe(this);else if(null!=a&&a.cards){var b=a.full_sync;b||this.Ca();var c=a.cards,d=a.last_full_sync_at;a=a.last_card_updated_at;var e=b?[]:this.C.slice();for(var f=0;f<c.length;f++){for(var g=c[f],h=null,l=0;l<this.C.length;l++)if(g.id===this.C[l].id){h=this.C[l];break}if(b)g=Rb(g),null!=h&&h.viewed&&(g.viewed=!0),null!=g&&e.push(g);else if(null==h)g=Rb(g),null!=g&&e.push(g);else if(!Pb(h,g))for(h=0;h<e.length;h++)if(g.id===e[h].id){e.splice(h,
1);break}}this.C=Oe(this,Pe(this,e,b));this.gc();this.Aa=d||0;P(this.b,M.Lb,this.Aa);this.xa=a||0;P(this.b,M.Kb,this.xa);zb(this.ca,this.lb(!0))}};
function Re(a,b){if(fe(a.D).Va.enabled){a.Ca();var c=a.C.slice();a.J.mb().A(function(d){for(var e=0;e<b.length;e++)if(d===b[e].userId||null==d&&null==b[e].userId){for(var f=b[e].card,g=null,h=0;h<a.C.length;h++)if(f.id===a.C[h].id){g=a.C[h];break}if(null==g)f=Rb(f),null!=f&&c.push(f);else if(!Pb(g,f))for(g=0;g<c.length;g++)if(f.id===c[g].id){c.splice(g,1);break}}a.C=Oe(a,Pe(a,c,!1));a.gc();zb(a.ca,a.lb(!0))})}else 0!==fe(a.D).$a&&Qe(a)}
function Pe(a,b,c){for(var d=Q(a.b,M.fb)||{},e=Q(a.b,M.gb)||{},f=Q(a.b,M.ra)||{},g={},h={},l={},k=0;k<b.length;k++)d[b[k].id]&&(b[k].clicked=!0,g[b[k].id]=!0),e[b[k].id]&&(b[k].viewed=!0,h[b[k].id]=!0),f[b[k].id]&&(b[k].dismissed=!0,l[b[k].id]=!0);c&&(P(a.b,M.fb,g),P(a.b,M.gb,h),P(a.b,M.ra,l));return b}
function Oe(a,b){for(var c=[],d=new Date,e=Q(a.b,M.ra)||{},f=!1,g=0;g<b.length;g++){var h=b[g].url;!a.wf&&h&&Rc(h)?v.error('Card with url "'+h+'" will not be displayed because Javascript URLs are disabled. Use the "allowUserSuppliedJavascript" option for appboy.initialize to enable this card.'):(null==b[g].expiresAt||b[g].expiresAt>=d)&&!b[g].dismissed?c.push(b[g]):f=e[b[g].id]=!0}f&&P(a.b,M.ra,e);return c}p.gc=function(){for(var a=[],b=0;b<this.C.length;b++)a.push(this.C[b].B());P(this.b,M.pb,a)};
p.Ha=function(){if(fe(this.D).Va.enabled)return this.J.Ha(this.Aa,this.xa,this.zb.bind(this));0!==fe(this.D).$a&&Qe(this)};p.lb=function(a){a||this.Ca();a=Oe(this,this.C);a.sort(function(c,d){return c.pinned&&!d.pinned?-1:d.pinned&&!c.pinned?1:c.updated>d.updated?-1:d.updated>c.updated?1:0});var b=Math.max(this.xa||0,this.Aa||0);0===b&&(b=void 0);return new Zc(a,Ga(b))};
p.Ua=function(a){a||(this.C=[],zb(this.ca,new Zc(this.C.slice(),null)),R(this.b,M.pb),R(this.b,M.fb),R(this.b,M.gb),R(this.b,M.ra));this.xa=this.Aa=0;R(this.b,M.Lb);R(this.b,M.Kb)};p.clearData=function(a){this.xa=this.Aa=0;this.C=[];zb(this.ca,new Zc(this.C.slice(),null));a&&(R(this.b,M.pb),R(this.b,M.fb),R(this.b,M.gb),R(this.b,M.ra),R(this.b,M.Lb),R(this.b,M.Kb))};function Qe(a){zb(a.ca,new Zc([],(new Date).valueOf()));R(a.b,M.pb)};function Se(a,b){this.ca=a;this.b=b;this.Ca()}ia(Se,Me);p=Se.prototype;p.Ca=function(){for(var a=Q(this.b,M.Gc)||[],b=[],c=0;c<a.length;c++){var d=Xb(a[c]);null!=d&&b.push(d)}this.C=b;this.ib=Ia(Q(this.b,M.Ec))};p.gc=function(){for(var a=[],b=0;b<this.C.length;b++)a.push(this.C[b].B());P(this.b,M.Gc,a)};
p.zb=function(a){if(null!=a&&a.feed){this.Ca();a=a.feed;for(var b=[],c,d=Q(this.b,M.ob)||{},e={},f=0;f<a.length;f++){c=a[f];var g=c.id,h=c.type,l=c.viewed,k=c.title,m=c.image,q=c.description,t=Ga(c.created),r=Ga(c.updated),y=c.categories,A=Ga(c.expires_at),z=c.url,F=c.domain,G=c.aspect_ratio;c=c.extras;g=h===Sb.Kd||h===Sb.Rb?new Tb(g,l,k,m,q,t,r,y,A,z,F,G,c,!1,!1):h===Sb.Ib?new Ub(g,l,k,m,q,t,r,y,A,z,F,G,c,!1,!1):h===Sb.Hb?new Vb(g,l,m,t,r,y,A,z,F,G,c,!1,!1):null;null!=g&&(d[g.id]&&(g.viewed=!0,e[g.id]=
!0),b.push(g))}P(this.b,M.ob,e);this.C=b;this.gc();this.ib=new Date;P(this.b,M.Ec,this.ib);zb(this.ca,new Vc(this.C.slice(),this.ib))}};p.lc=function(){this.Ca();for(var a=[],b=new Date,c=0;c<this.C.length;c++)(null==this.C[c].expiresAt||this.C[c].expiresAt>=b)&&a.push(this.C[c]);return new Vc(a,this.ib)};p.clearData=function(a){null==a&&(a=!1);this.C=[];this.ib=null;a&&(R(this.b,M.Gc),R(this.b,M.Ec));zb(this.ca,new Vc(this.C.slice(),this.ib))};function Te(a,b,c,d,e){this.Ja=a;this.Ee=b;this.De=c;this.kc=d;this.Ia=e}function Ue(a,b,c,d,e){return null==a||null==a.trigger_id?null:new Te(a.trigger_id,b,c,d,e)};function Ve(a,b,c,d){this.Af=a;this.ca=b;this.b=c;this.J=d;this.Zb=[];this.ka=[];this.ya=null;this.K={};this.X={};We(this);Xe(this)}ia(Ve,Me);function Ye(a){a.ya=Q(a.b,M.Dc)||a.ya;a.K=Q(a.b,M.rb)||a.K;a.X=Q(a.b,M.Ob)||a.X;for(var b=0;b<a.U.length;b++){var c=a.U[b];null!=a.X[c.id]&&(c.za=a.X[c.id])}}function We(a){a.Yc=Q(a.b,M.Nc)||0;for(var b=Q(a.b,M.Mc)||[],c=[],d=0;d<b.length;d++)c.push(Td(b[d]));a.U=c;Ye(a)}
function Xe(a){function b(z,F,G,E,K){return function(){Ze(a,z,F,G,E,K)}}for(var c={},d=0;d<a.U.length;d++)c[a.U[d].id]=a.U[d];d=!1;for(var e=0;e<a.U.length;e++){var f=a.U[e];if(null!=a.K[f.id]){for(var g=a.K[f.id],h=[],l=0;l<g.length;l++){var k=g[l],m=Math.max(k.kc+1E3*f.Wa-(new Date).valueOf(),0);if(0<m){h.push(k);var q=void 0,t=void 0;null!=k.Be&&(q=k.Be);null!=k.$c&&Ja(k.$c)&&(t=Ka(k.$c));var r=[];if(Aa(k.cd))for(var y=0;y<k.cd.length;y++){var A=c[k.cd[y]];null!=A&&r.push(A)}a.ka.push(setTimeout(b(f,
k.kc,q,t,r),m))}}a.K[f.id].length>h.length&&(a.K[f.id]=h,d=!0,0===a.K[f.id].length&&delete a.K[f.id])}}d&&P(a.b,M.rb,a.K)}
Ve.prototype.zb=function(a){var b=!1;if(null!=a&&a.triggers){Ye(this);var c={},d={};this.U=[];for(var e=0;e<a.triggers.length;e++){for(var f=a.triggers[e],g=f.id,h=[],l=0;l<f.trigger_condition.length;l++)h.push(Gd(f.trigger_condition[l]));l=Ga(f.start_time);var k=Ga(f.end_time),m=f.priority,q=f.type,t=f.delay,r=f.re_eligibility,y=f.timeout,A=f.data;f=f.min_seconds_since_last_trigger;g=ya(Ud,q,"Could not construct Trigger from server data","Trigger.Types")?new Qd(g,h,l,k,m,q,A,t,r,y,f):null;null!=
this.X[g.id]&&(g.za=this.X[g.id],c[g.id]=this.X[g.id]);null!=this.K[g.id]&&(d[g.id]=this.K[g.id]);for(h=0;h<g.kb.length;h++)if(Ed(g.kb[h],Cd.Vb,null)){b=!0;break}null!=g&&this.U.push(g)}Ea(this.X,c)||(this.X=c,P(this.b,M.Ob,this.X));Ea(this.K,d)||(this.K=d,P(this.b,M.rb,this.K));a=[];for(c=0;c<this.U.length;c++)a.push(this.U[c].B());this.Yc=(new Date).valueOf();P(this.b,M.Mc,a);P(this.b,M.Nc,this.Yc);b&&(v.info("Trigger with test condition found, firing test."),this.na(Cd.Vb));this.na(Cd.OPEN);b=
this.Zb;this.Zb=[];for(a=0;a<b.length;a++)this.na.apply(this,b[a])}};
function Ze(a,b,c,d,e,f){function g(){Ye(a);var k=f.pop();if(null!=k)if($e(a,k,c,d,e,f),Sd(k,c)){var m="Server aborted in-app message display, but the timeout on fallback trigger "+k.id+"has already elapsed.";0<f.length&&(m+=" Continuing to fall back.");v.info(m);a.J.L(k.id,Kc.zd);g()}else v.info("Server aborted in-app message display. Falling back to lower priority "+k.type+" trigger action "+k.id),m=1E3*k.Wa-((new Date).valueOf()-c),0<m?a.ka.push(setTimeout(function(){Ze(a,k,c,d,e,f)},m)):Ze(a,
k,c,d,e,f)}function h(k){Ye(a);var m=(new Date).valueOf();Sd(b,c)?b.type===Ud.Jd?a.J.L(b.id,Kc.qb):a.J.L(b.id,Kc.zd):!1===navigator.onLine&&b.type===Ud.Ac&&k.imageUrl?(v.info("Not showing "+b.type+" trigger action "+b.id+" due to offline state."),a.J.L(b.id,Kc.Ye)):(null==b.za||b.Db!==Rd&&m-b.za>=1E3*b.Db)&&af(a,b,m,d)?(zb(a.ca,[k]),Ye(a),b.za=m,a.ya=m,P(a.b,M.Dc,m),a.X[b.id]=m,P(a.b,M.Ob,a.X)):v.info("Not displaying trigger "+b.id+" because display time fell outside of the acceptable time window.")}
switch(b.type){case Ud.Ac:var l=nc(b.data);if(null==l){v.error("Could not parse trigger data for trigger "+b.id+", ignoring.");a.J.L(b.id,Kc.sb);break}h(l);break;case Ud.Jd:l=Ue(b.data,h,g,c,b.Ia);if(null==l){v.error("Could not parse trigger data for trigger "+b.id+", ignoring.");a.J.L(b.id,Kc.sb);break}ke(a.J,l,d,e);break;default:v.error("Trigger "+b.id+" was of unexpected type "+b.type+", ignoring."),a.J.L(b.id,Kc.sb)}}
Ve.prototype.na=function(a,b,c){var d=this;if(ya(Cd,a,"Cannot fire trigger action.","TriggerEvents"))if(0<this.J.hb)v.info("Trigger sync is currently in progress, awaiting sync completion before firing trigger event."),this.Zb.push(arguments);else{(Q(this.b,M.Nc)||0)>this.Yc?We(this):Ye(this);for(var e=(new Date).valueOf(),f=e-this.ya,g=!0,h=!0,l=[],k=0;k<this.U.length;k++){var m=this.U[k],q=e+1E3*m.Wa;if((null==m.za||m.Db!==Rd&&q-m.za>=1E3*m.Db)&&(null==m.startTime||m.startTime<=e)&&(null==m.endTime||
m.endTime>=e)){for(var t=!1,r=0;r<m.kb.length;r++)if(Ed(m.kb[r],a,b)){t=!0;break}t&&(g=!1,af(this,m,q,a)&&(h=!1,l.push(m)))}}if(g)v.info("Trigger event "+a+" did not match any trigger conditions.");else if(h)v.info("Ignoring "+a+" trigger event because a trigger was displayed "+f/1E3+"s ago.");else{l.sort(function(A,z){return A.priority-z.priority});var y=l.pop();null!=y&&(v.info("Firing "+y.type+" trigger action "+y.id+" from trigger event "+a+"."),$e(this,y,e,a,c,l),0===y.Wa?Ze(this,y,e,a,c,l):
this.ka.push(setTimeout(function(){Ze(d,y,e,a,c,l)},1E3*y.Wa)))}}};Ve.prototype.Ua=function(a){this.U=[];R(this.b,M.Mc);if(!a){this.Zb=[];this.ya=null;this.X={};this.K={};for(a=0;a<this.ka.length;a++)clearTimeout(this.ka[a]);this.ka=[];R(this.b,M.Dc);R(this.b,M.Ob);R(this.b,M.rb);R(this.b,M.ff);R(this.b,M.ef);R(this.b,M.gf)}};Ve.prototype.clearData=function(){this.U=[];this.ya=null;this.X={};this.K={};for(var a=0;a<this.ka.length;a++)clearTimeout(this.ka[a]);this.ka=[]};
function af(a,b,c,d){if(null==a.ya)return!0;if(d===Cd.Vb)return v.info("Ignoring minimum interval between trigger because it is a test type."),!0;b=b.se;null==b&&(b=a.Af);return c-a.ya>=1E3*b}function $e(a,b,c,d,e,f){Ye(a);a.K[b.id]=a.K[b.id]||[];var g={};g.kc=c;g.Be=d;var h;null!=e&&(h=e.B());g.$c=h;c=[];for(d=0;d<f.length;d++)c.push(f[d].id);g.cd=c;a.K[b.id].push(g);P(a.b,M.rb,a.K)};var bf;"undefined"===typeof console&&(window.console={log:function(){}});var cf=window.Element.prototype;"function"!==typeof cf.matches&&(cf.matches=cf.msMatchesSelector||cf.mozMatchesSelector||cf.webkitMatchesSelector||function(a){a=(this.document||this.ownerDocument).querySelectorAll(a);for(var b=0;a[b]&&a[b]!==this;)++b;return!!a[b]});
Element.prototype.closest||(Element.prototype.closest=function(a){var b=this;if(!document.documentElement.contains(b))return null;do{if(b.matches(a))return b;b=b.parentElement||b.parentNode}while(null!==b&&1===b.nodeType);return null});
if("function"!==typeof window.CustomEvent){var df=function(a,b){b=b||{bubbles:!1,cancelable:!1,detail:null};var c=document.createEvent("CustomEvent");c.initCustomEvent(a,b.bubbles,b.cancelable,b.detail);return c};df.prototype=window.Event.prototype;window.CustomEvent=df};var ef;"object"===typeof module&&module.exports?ef=module.exports:(window.appboy||(window.appboy={}),ef=window.appboy);var ff=ef;var W=new function(a){function b(n){var u={},x;for(x in n){var C=n[x];null==C?delete n[x]:u[x]=Ba(C)?Ha(C):C}return u}function c(n,u,x,C,H){null==n&&(n={});if("object"!==typeof n||Aa(n))return v.error(u+" requires that "+x+" be an object. Ignoring "+H+"."),!1;for(var O in n){if(!Pa(O,C,"the "+H+" property name"))return!1;u=n[O];if(x=null!=u){x=typeof u;var Z=Ba(u);(x=null!=u&&("number"===x||"boolean"===x||Z||"string"===x))||v.error("Cannot "+C+" because the "+(H+' property "'+O+'" "')+u+'" is invalid.');
x=!x}if(x)return!1}return!0}function d(){v.yb();Y&&(zb(N),N.N(),r.clearData(!1),r=null,z.clearData(!1),z=null,t.N(),t=null,F.N(),F=null,y.N(),y=null,m.yb(),G=m=null,we(E),g=l=E=null,L=[],k=null);ea=Y=!1}function e(){if(ea)return!1;if(!Y)throw Error("Appboy must be initialized before calling methods.");return!0}var f={Lf:function(n,u){return new ue(n,u)},Pf:function(n,u,x,C,H,O,Z,na,La){null==H&&(H={});var he=new Le(La,Z),lf=new Ie(Z,he,La,H.sessionTimeoutInSeconds);return new Xd(n,x,C,H.appVersion,
u,lf,na,he,La,Z,O)},ad:function(){return new xb},Mf:function(n,u){return new Se(n,u)},Kf:function(n,u,x,C){return new Ne(n,u,x,C)},Qf:function(n,u,x,C){return new Ve(n,u,x,C)},Of:function(n,u,x,C,H,O,Z){null==H&&(H={});return new ye(n,u,x,C+"/safari/"+u,H.serviceWorkerLocation,H.safariWebsitePushId,O,H.manageServiceWorkerExternally,H.disablePushTokenMaintenance,Z)},Nf:function(n){return new ve(n)}};null==a&&(a=f);var g,h,l,k,m,q,t,r,y,A,z,F,G,E,K=new xb,N=new xb,L=[],Y=!1,ea=!1;bf={Cd:100,Qb:"inAppMessage must be an InAppMessage object",
Fc:"must be a Card object"};return{sg:function(n){return yb(K,n)},rg:function(n){return yb(N,n)},ed:function(n,u){if(Y)return v.info("Braze has already been initialized with an API key."),!0;v.dd(null!=u&&u.enableLogging);if(null==n||""===n||"string"!==typeof n)return v.error("Braze requires a valid API key to be initialized."),!1;g=n;l=u||{};if(jb.Wf&&!l.allowCrawlerActivity)return v.info("Ignoring activity from crawler bot "+navigator.userAgent),ea=!0,!1;h=u=Je(n,l.noCookies||!1);if((new sb(null,
!0)).O("ab.optOut"))return v.info("Ignoring all activity due to previous opt out"),ea=!0,!1;var x=["mparticle","wordpress","tealium"];if(null!=l.sdkFlavor){var C=l.sdkFlavor;-1!==x.indexOf(C)?k=C:v.error("Invalid sdk flavor passed: "+C)}var H=[];t=a.ad();L.push(t);r=a.Mf(t,u);H.push(r);F=a.ad();L.push(F);x=null!=l.baseUrl?l.baseUrl:"https://sdk.iad-01.braze.com/api/v3";x=x.replace(/(\.[a-z]+)[^\.]*$/i,"$1/api/v3");0!==x.indexOf("http")&&(x="https://"+x);C=l.devicePropertyWhitelist;if(null!=C)if(Aa(C)){for(var O=
[],Z=0;Z<C.length;Z++)ya(V,C[Z],"devicePropertyWhitelist contained an invalid value.","DeviceProperties")&&O.push(C[Z]);C=O}else v.error("devicePropertyWhitelist must be an array. Defaulting to all properties."),C=null;q=a.Lf(u,C);C=new Ge(u);m=a.Pf(g,x,"2.5.2",k,l,function(na){if(Y)for(var La=0;La<H.length;La++)H[La].zb(na)},u,q,C);O=l.minimumIntervalBetweenTriggerActionsInSeconds;null==O&&(O=30);z=a.Qf(O,F,u,m);H.push(z);O=!0===l.allowUserSuppliedJavascript||!0===l.enableHtmlInAppMessages;
y=a.ad();L.push(y);A=a.Kf(y,m,u,C,O);H.push(A);He(C,function(){A.Ha()});ne(m,function(){A.Ha()});m.ed();G=a.Of(m.mb(),g,q,x,l,C,u);E=a.Nf(m.mb());u="Initialized ";l&&l.baseUrl&&(u+='for the Braze backend at "'+l.baseUrl+'" ');v.info(u+('with API key "'+n+'".'));n=jb.language;u=!1;l&&(l.language&&(n=l.language,u=!0),l.localization&&(n=l.localization,u=!0));Sc(n,u);zb(K,l);return Y=!0},yb:function(){v.info("Destroying appboy instance");h=null;d()},Rf:function(n){e()&&(null==n&&v.error("getDeviceId must be supplied with a callback. e.g., appboy.getDeviceId(function(deviceId) {console.log('the device id is ' + deviceId)})"),
"function"===typeof n&&n(Zd(q).id))},sd:function(){v.sd()},pd:function(n){v.pd(n)},sc:function(n){if(e()){m.sc(G,n);var u=xa.Na,x=new pa(u);ta(x,u.M.Fd,function(C,H){function O(){z.na(Cd.Ed,[na],La)}var Z=H.lastClick,na=H.trackingString;v.info("Firing push click trigger from "+na+" push click at "+Z);var La=se(m,Z,na);qe(m,O,O);ua(x,u.M.Fd,C)});va(x,u.M.He,function(C){Re(A,C)})}},Ua:function(n,u){e()&&(null==n||0===n.length||n!==n?(v.error("changeUser requires a non-empty userId."),"function"===typeof u&&
(v.info("messagingReadyCallback provided with an empty userId. Firing immediately."),u())):997<Ke(n)?v.error('Rejected user id "'+n+'" because it is longer than 997 bytes.'):m.Ua(n.toString(),[r,A,z],u,G))},mb:function(){if(e())return m.mb()},Tf:function(){if(e())return l.contentSecurityNonce},Eb:function(n){e()&&m.Eb(n)},uc:function(){e()&&m.uc()},ze:function(n){if(e())return yb(t,n)},lc:function(){if(e())return r.lc()},Ha:function(){if(e())return A.Ha()},xe:function(n){if(e())return yb(y,n)},lb:function(){if(e())return A.lb(!1)},
tg:function(n){if(e())return yb(F,n)},Ae:function(n){if(e())return"function"!==typeof n?null:yb(F,function(u){n(u[0]);return u.slice(1)})},Cb:function(n){if(e())return n instanceof U||n instanceof oc?m.Cb(n).h:(v.error(bf.Qb),!1)},qc:function(n){if(e()){if(!(n instanceof U))return v.error(bf.Qb),!1;var u=m.qc(n);if(u.h)for(var x=0;x<u.j.length;x++)z.na(Cd.Nb,[n.triggerId],u.j[x]);return u.h}},pc:function(n,u){if(e()){if(!(n instanceof pc))return v.error("button must be an ab.InAppMessage.Button object"),
!1;if(!(u instanceof U))return v.error(bf.Qb),!1;var x=m.pc(n,u);if(x.h)for(var C=0;C<x.j.length;C++)z.na(Cd.Nb,[u.triggerId,n.id],x.j[C]);return x.h}},Bb:function(n,u,x){if(e()){if(!(n instanceof zc))return v.error("inAppMessage argument to logInAppMessageHtmlClick must be an HtmlMessage object."),!1;x=m.Bb(n,u,x);if(x.h)for(var C=0;C<x.j.length;C++)z.na(Cd.Nb,[n.triggerId,u],x.j[C]);return x.h}},L:function(n,u){if(e())return n instanceof U||n instanceof oc?ya(Kc,u,u+" is not a valid in-app message display failure",
"InAppMessage.DisplayFailures")?m.L(n.triggerId,u).h:!1:(v.error(bf.Qb),!1)},Ga:function(n,u){if(e()){if(!Aa(n))return v.error("cards must be an array"),!1;for(var x=0;x<n.length;x++)if(!(n[x]instanceof Mb))return v.error("Each card in cards "+bf.Fc),!1;return m.Ga(n,u).h}},Fa:function(n,u){if(e())return n instanceof Mb?m.Fa(n,u).h:(v.error("card "+bf.Fc),!1)},oc:function(n){if(e())return n instanceof Mb?m.oc(n).h:(v.error("card "+bf.Fc),!1)},re:function(){if(e())return re(m,wa.Ze).h},qe:function(){if(e())return re(m,
wa.Ne).h},S:function(n){if(e()){for(var u=0;u<L.length;u++)L[u].S(n);K.S(n);N.S(n)}},N:function(){if(e())for(var n=0;n<L.length;n++)L[n].N()},gd:function(n,u){if(e()){if(null==n||0>=n.length)return v.error('logCustomEvent requires a non-empty eventName, got "'+n+'". Ignoring event.'),!1;if(!Pa(n,"log custom event","the event name")||!c(u,"logCustomEvent","eventProperties",'log custom event "'+n+'"',"event"))return!1;var x=m.gd(n,b(u));if(x.h){v.info('Logged custom event "'+n+'".');for(var C=0;C<x.j.length;C++)z.na(Cd.yc,
[n,u],x.j[C])}return x.h}},hd:function(n,u,x,C,H){if(e()){null==x&&(x="USD");null==C&&(C=1);if(null==n||0>=n.length)return v.error('logPurchase requires a non-empty productId, got "'+n+'", ignoring.'),!1;if(!Pa(n,"log purchase","the purchase name"))return!1;var O=parseFloat(u);if(isNaN(O))return v.error("logPurchase requires a numeric price, got "+u+", ignoring."),!1;O=O.toFixed(2);u=parseInt(C);if(isNaN(u))return v.error("logPurchase requires an integer quantity, got "+C+", ignoring."),!1;if(1>u||
u>bf.Cd)return v.error("logPurchase requires a quantity >1 and <"+bf.Cd+", got "+u+", ignoring."),!1;x=x.toUpperCase();if(-1==="AED AFN ALL AMD ANG AOA ARS AUD AWG AZN BAM BBD BDT BGN BHD BIF BMD BND BOB BRL BSD BTC BTN BWP BYR BZD CAD CDF CHF CLF CLP CNY COP CRC CUC CUP CVE CZK DJF DKK DOP DZD EEK EGP ERN ETB EUR FJD FKP GBP GEL GGP GHS GIP GMD GNF GTQ GYD HKD HNL HRK HTG HUF IDR ILS IMP INR IQD IRR ISK JEP JMD JOD JPY KES KGS KHR KMF KPW KRW KWD KYD KZT LAK LBP LKR LRD LSL LTL LVL LYD MAD MDL MGA MKD MMK MNT MOP MRO MTL MUR MVR MWK MXN MYR MZN NAD NGN NIO NOK NPR NZD OMR PAB PEN PGK PHP PKR PLN PYG QAR RON RSD RUB RWF SAR SBD SCR SDG SEK SGD SHP SLL SOS SRD STD SVC SYP SZL THB TJS TMT TND TOP TRY TTD TWD TZS UAH UGX USD UYU UZS VEF VND VUV WST XAF XAG XAU XCD XDR XOF XPD XPF XPT YER ZAR ZMK ZMW ZWL".split(" ").indexOf(x))return v.error("logPurchase requires a valid currencyCode, got "+
x+", ignoring."),!1;if(!c(H,"logPurchase","purchaseProperties",'log purchase "'+n+'"',"purchase"))return!1;C=m.hd(n,O,x,u,b(H));if(C.h)for(v.info("Logged "+u+" purchase"+(1<u?"s":"")+' of "'+n+'" for '+x+" "+O+"."),x=0;x<C.j.length;x++)z.na(Cd.Jc,[n,H],C.j[x]);return C.h}},Ea:function(){if(e())return G.Ea()},Da:function(){if(e())return G.Da()},fd:function(n,u,x){e()&&G.fd(n,u,x)},Ab:function(){if(e())return G.Ab()},$f:function(n,u,x){if(e())return G.subscribe(x,function(C,H,O){m.Eb();"function"===
typeof n&&n(C,H,O)},u)},yg:function(n,u){if(e())return G.unsubscribe(n,u)},wg:function(){e()&&E.watchPosition()},qg:function(){null!=m&&m.Eb();var n=new sb(null,!0);n.store("ab.optOut","This-cookie-will-expire-in-"+tb(n));n=xa.Na;(new pa(n)).setItem(n.M.Ic,n.Ub,!0);d();ea=!0},bg:function(){(new sb(null,!0)).remove("ab.optOut");var n=xa.Na;ua(new pa(n),n.M.Ic,n.Ub);d()},Bg:function(){if(null==h)throw Error("Appboy must be initialized before calling methods.");h.clearData();for(var n=Da(xa),u=0;u<n.length;u++)(new pa(xa[n[u]])).clearData();
Y&&(r.clearData(!0),z.clearData(!0))}}},X={ab:{}},gf=X.ab,hf;for(hf in I)gf[hf]=I[hf];X.initialize=W.ed;X.destroy=W.yb;X.getDeviceId=W.Rf;X.toggleAppboyLogging=W.sd;X.setLogger=W.pd;X.openSession=W.sc;X.changeUser=W.Ua;X.getUser=W.mb;X.requestImmediateDataFlush=W.Eb;X.requestFeedRefresh=W.uc;X.getCachedFeed=W.lc;X.subscribeToFeedUpdates=W.ze;X.requestContentCardsRefresh=W.Ha;X.getCachedContentCards=W.lb;X.subscribeToContentCardsUpdates=W.xe;X.logCardImpressions=W.Ga;X.logCardClick=W.Fa;
X.logCardDismissal=W.oc;X.logFeedDisplayed=W.re;X.logContentCardsDisplayed=W.qe;X.logInAppMessageImpression=W.Cb;X.logInAppMessageClick=W.qc;X.logInAppMessageButtonClick=W.pc;X.logInAppMessageHtmlClick=W.Bb;X.subscribeToNewInAppMessages=W.tg;X.subscribeToInAppMessage=W.Ae;X.removeSubscription=W.S;X.removeAllSubscriptions=W.N;X.logCustomEvent=W.gd;X.logPurchase=W.hd;X.isPushSupported=W.Ea;X.isPushBlocked=W.Da;X.isPushGranted=W.fd;X.isPushPermissionGranted=W.Ab;X.registerAppboyPushMessages=W.$f;
X.unregisterAppboyPushMessages=W.yg;X.trackLocation=W.wg;X.stopWebTracking=W.qg;X.resumeWebTracking=W.bg;X.wipeData=W.Bg;for(var jf in X)"object"===typeof appboyInterface?appboyInterface[jf]=X[jf]:ff[jf]=X[jf];var kf="object"===typeof appboyInterface?appboyInterface:ff,mf=new function(a,b){var c=!1,d=!1,e=!1,f=!1,g=null,h=null,l=null;a.sg(function(k){function m(t){if(27===t.keyCode&&!e&&0<document.querySelectorAll(".ab-modal-interactions").length){t=document.getElementsByClassName("ab-html-message");for(var r=!1,y=0;y<t.length;y++){var A=t[y].contentWindow.document.getElementsByClassName("ab-programmatic-close-button")[0];null!=A&&(Db(A),r=!0)}r||(t=document.querySelectorAll(".ab-modal-interactions > .ab-close-button")[0],
null!=t&&Db(t))}}c=k.openInAppMessagesInNewTab||!1;d=k.openCardsInNewTab||k.openNewsFeedCardsInNewTab||!1;e=k.requireExplicitInAppMessageDismissal||!1;f=k.enableHtmlInAppMessages||!1;!0===k.allowUserSuppliedJavascript&&(f=!0);g=null;l=k.contentSecurityNonce||null;k.doNotLoadFontAwesome||null!==document.querySelector('link[rel=stylesheet][href="https://use.fontawesome.com/7f85a56ba4.css"]')||(k=document.createElement("link"),k.setAttribute("rel","stylesheet"),k.setAttribute("href","https://use.fontawesome.com/7f85a56ba4.css"),
document.getElementsByTagName("head")[0].appendChild(k));k="ab-css-definitions-"+"2.5.2".replace(/\./g,"-");if(null==document.getElementById(k)){var q=document.createElement("style");q.innerHTML=Pc.je;q.id=k;null!=l&&q.setAttribute("nonce",l);document.getElementsByTagName("head")[0].appendChild(q)}e||(document.addEventListener("keydown",m,!1),a.rg(function(){document.removeEventListener("keydown",m)}))});return{Jf:function(){null==g&&(g=a.Ae(function(k){a.display.we(k)}));return g},we:function(k,
m,q){if(null==k)return!1;if(k instanceof oc)return v.info("User received control for a multivariate test, logging to Braze servers."),a.Cb(k),!0;if(!(k instanceof U))return!1;var t=k instanceof zc;if(t&&!k.xg&&!f)return v.error('HTML in-app messages are disabled. Use the "enableHtmlInAppMessages" option for appboy.initialize to enable these messages.'),a.L(k,Kc.yd),!1;null==m&&(m=document.body);if(k.Za()&&0<m.querySelectorAll(".ab-modal-interactions").length)return v.info("Cannot show in-app message '"+
k.message+"' because another message is being shown."),a.L(k,Kc.Fe),!1;if(Lb.Xf()){var r=Lb.Sf();if(r===Lb.Ma.Sb&&k.orientation===Hc.LANDSCAPE||r===Lb.Ma.Cc&&k.orientation===Hc.PORTRAIT)return v.info("Not showing "+(k.orientation===Hc.PORTRAIT?"portrait":"landscape")+" in-app message '"+k.message+"' because the screen is currently "+(r===Lb.Ma.Sb?"portrait":"landscape")),a.L(k,Kc.mf),!1}if(!f){r=!1;if(k.buttons&&0<k.buttons.length)for(var y=k.buttons,A=0;A<y.length;A++)y[A].clickAction===ec.URI&&
(r=Rc(y[A].uri));else k.clickAction===ec.URI&&(r=Rc(k.uri));if(r)return v.error('Javascript click actions are disabled. Use the "allowUserSuppliedJavascript" option for appboy.initialize to enable these actions.'),a.L(k,Kc.yd),!1}var z=document.createElement("div");z.className="ab-iam-root v3";z.className+=k.ma();kc(k)&&(z.id=k.htmlId);m.appendChild(z);lc(k)&&(m=document.createElement("style"),m.innerHTML=k.css,m.id=mc(k),null!=l&&m.setAttribute("nonce",l),document.getElementsByTagName("head")[0].appendChild(m));
var F=k instanceof wc;m=k.Y(a,b,function(){a.display.rd()},function(G){if(k.Za()&&k.Ce()){var E=document.createElement("div");E.className="ab-page-blocker";lc(k)||(E.style.backgroundColor=bc(k.frameColor));z.appendChild(E);if(!e){var K=(new Date).valueOf();E.onclick=function(Y){200<(new Date).valueOf()-K&&(Fc(k,G),Y.stopPropagation())}}z.appendChild(G);G.focus();k.rc(z)}else if(F){var N=document.querySelectorAll(".ab-slideup");E=null;for(var L=N.length-1;0<=L;L--)if(N[L]!==G){E=N[L];break}k.slideFrom===
dc.TOP?(N=0,null!=E&&(N=E.offsetTop+E.offsetHeight),G.style.top=Math.max(N,0)+"px"):(N=0,null!=E&&(N=(window.innerHeight||document.documentElement.clientHeight)-E.offsetTop),G.style.bottom=Math.max(N,0)+"px")}else t&&!e&&G.contentWindow.addEventListener("keydown",function(Y){27===Y.keyCode&&k.ge()});a.Cb(k);k.dismissType===gc.AUTO_DISMISS&&setTimeout(function(){z.contains(G)&&Fc(k,G)},k.duration);"function"===typeof q&&q()},c);if(t||F)z.appendChild(m),k.rc(z);return!0},rd:function(k,m,q){function t(E){for(var K=
E.querySelectorAll(".ab-feed"),N=null,L=0;L<K.length;L++)K[L].parentNode===E&&(N=K[L]);null!=N?(Wc(a,N),N.parentNode.replaceChild(F,N)):E.appendChild(F);setTimeout(function(){F.className=F.className.replace("ab-hide","ab-show")},0);y&&F.focus();a.re();$c(z,a,F)}function r(E,K){if(null==K)return E;for(var N=[],L=0;L<K.length;L++)N.push(K[L].toLowerCase());K=[];for(L=0;L<E.length;L++){for(var Y=[],ea=0;ea<E[L].categories.length;ea++)Y.push(E[L].categories[ea].toLowerCase());0<Ca(Y,N).length&&K.push(E[L])}return K}
var y=!1;null==k&&(k=document.body,y=!0);var A=!1,z=null;null==m?(z=a.lc(),dd(z,r(z.cards,q),z.lastUpdated,null,a,d),A=!0):z=new Vc(r(m,q),new Date);var F=z.Y(a,d);if(A){if(null==z.lastUpdated||6E4<(new Date).valueOf()-z.lastUpdated.valueOf())v.info("Cached feed was older than max TTL of 60000 ms, requesting an update from the server."),ad(z,a,F);var G=(new Date).valueOf();m=a.ze(function(E){var K=F.querySelectorAll(".ab-refresh-button")[0];if(null!=K){var N=500,L=parseInt(F.getAttribute(bd));N=isNaN(L)?
N-((new Date).valueOf()-G):N-((new Date).valueOf()-L);setTimeout(function(){K.className=K.className.replace(/fa-spin/g,"")},Math.max(N,0))}dd(z,r(E.cards,q),E.lastUpdated,F,a,d)});F.setAttribute(Xc,m)}null!=k?t(k):window.onload=function(E){return function(){"function"===typeof E&&E();t(document.body)}}(window.onload)},ke:function(){for(var k=document.querySelectorAll(".ab-feed"),m=0;m<k.length;m++)Wc(a,k[m])},vg:function(k,m,q){0<document.querySelectorAll(".ab-feed").length?a.display.ke():a.display.rd(k,
m,q)},ve:function(k,m){function q(F){for(var G=F.querySelectorAll(".ab-feed"),E=null,K=0;K<G.length;K++)G[K].parentNode===F&&(E=G[K]);null!=E?(Wc(a,E),E.parentNode.replaceChild(y,E)):F.appendChild(y);setTimeout(function(){y.className=y.className.replace("ab-hide","ab-show")},0);t&&y.focus();a.qe();$c(r,a,y)}var t=!1;null==k&&(k=document.body,t=!0);var r=null;r=a.lb();"function"===typeof m&&dd(r,m(r.cards.slice()),r.lastUpdated,null,a,d);var y=r.Y(a,d);(null==r.lastUpdated||6E4<(new Date).valueOf()-
r.lastUpdated.valueOf())&&(null==h||6E4<(new Date).valueOf()-h.valueOf())&&(v.info("Cached content cards were older than max TTL of 60000 ms, requesting a sync from the server."),ad(r,a,y),h=(new Date).valueOf());var A=(new Date).valueOf(),z=a.xe(function(F){var G=y.querySelectorAll(".ab-refresh-button")[0];if(null!=G){var E=500,K=parseInt(y.getAttribute(bd));E=isNaN(K)?E-((new Date).valueOf()-A):E-((new Date).valueOf()-K);setTimeout(function(){G.className=G.className.replace(/fa-spin/g,"")},Math.max(E,
0))}E=F.cards;"function"===typeof m&&(E=m(E.slice()));dd(r,E,F.lastUpdated,y,a,d)});y.setAttribute(Xc,z);null!=k?q(k):window.onload=function(F){return function(){"function"===typeof F&&F();q(document.body)}}(window.onload)},pe:function(){for(var k=document.querySelectorAll(".ab-feed"),m=0;m<k.length;m++)Wc(a,k[m])},ug:function(k,m){0<document.querySelectorAll(".ab-feed").length?a.display.pe():a.display.ve(k,m)}}}(W,kf);kf.display={};kf.display.automaticallyShowNewInAppMessages=mf.Jf;
kf.display.showInAppMessage=mf.we;kf.display.showFeed=mf.rd;kf.display.destroyFeed=mf.ke;kf.display.toggleFeed=mf.vg;kf.display.showContentCards=mf.ve;kf.display.hideContentCards=mf.pe;kf.display.toggleContentCards=mf.ug;W.display=mf;return appboyInterface});var a=window.appboyQueue||("undefined"!==typeof appboyQueue?appboyQueue:null);
if("undefined"!==typeof a&&a&&a.length&&0<a.length){var b=a===window.appboyQueue;window.appboyQueue=appboyQueue=null;for(var c=0;c<a.length;c++)if(a[c].callee){var d=a[c].callee.name;if(null==d||""===d)d=/^function ([\w]*)\(/g.exec(a[c].callee.toString())[1];if(null!=d&&""!==d){for(var e=d.split("_"),f=b?window.appboy:appboy,g=this,h="appboy",k=0;k<e.length;k++){if("prototype"===e[k]){var l=eval({"appboy.ab.User":"appboy.getUser","appboy.ab.Feed":"appboy.getCachedFeed","appboy.ab.ContentCards":"appboy.getCachedContentCards"}[h]);
g=f=null!=l?l.apply():new f.constructor}else f=f[e[k]];h+="."+e[k]}null!=f&&"function"===typeof f&&f.apply(g,a[c])}}};
}).call(window);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(32)))

/***/ }),

/***/ 107:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, global) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * lodash 3.8.0 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern -d -o ./index.js`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '3.8.0';

  /** Used to compose bitmasks for wrapper metadata. */
  var BIND_FLAG = 1,
      BIND_KEY_FLAG = 2,
      CURRY_BOUND_FLAG = 4,
      CURRY_FLAG = 8,
      CURRY_RIGHT_FLAG = 16,
      PARTIAL_FLAG = 32,
      PARTIAL_RIGHT_FLAG = 64,
      ARY_FLAG = 128,
      REARG_FLAG = 256;

  /** Used as default options for `_.trunc`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect when a function becomes hot. */
  var HOT_COUNT = 150,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_DROP_WHILE_FLAG = 0,
      LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2;

  /** Used as the `TypeError` message for "Functions" methods. */
  var FUNC_ERROR_TEXT = 'Expected a function';

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      objectTag = '[object Object]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      weakMapTag = '[object WeakMap]';

  var arrayBufferTag = '[object ArrayBuffer]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39|#96);/g,
      reUnescapedHtml = /[&<>"'`]/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\n\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\n\\]|\\.)*?)\2)\]/g;

  /**
   * Used to match `RegExp` [special characters](http://www.regular-expressions.info/characters.html#special).
   * In addition to special characters the forward slash is escaped to allow for
   * easier `eval` use and `Function` compilation.
   */
  var reRegExpChars = /[.*+?^${}()|[\]\/\\]/g,
      reHasRegExpChars = RegExp(reRegExpChars.source);

  /** Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks). */
  var reComboMark = /[\u0300-\u036f\ufe20-\ufe23]/g;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /** Used to match [ES template delimiters](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-template-literal-lexical-components). */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect hexadecimal string values. */
  var reHasHexPrefix = /^0[xX]/;

  /** Used to detect host constructors (Safari > 5). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to match latin-1 supplementary letters (excluding mathematical operators). */
  var reLatin1 = /[\xc0-\xd6\xd8-\xde\xdf-\xf6\xf8-\xff]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to match words to create compound words. */
  var reWords = (function() {
    var upper = '[A-Z\\xc0-\\xd6\\xd8-\\xde]',
        lower = '[a-z\\xdf-\\xf6\\xf8-\\xff]+';

    return RegExp(upper + '+(?=' + upper + lower + ')|' + upper + '?' + lower + '|' + upper + '+|[0-9]+', 'g');
  }());

  /** Used to detect and test for whitespace. */
  var whitespace = (
    // Basic whitespace characters.
    ' \t\x0b\f\xa0\ufeff' +

    // Line terminators.
    '\n\r\u2028\u2029' +

    // Unicode category "Zs" space separators.
    '\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000'
  );

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'ArrayBuffer', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Math', 'Number',
    'Object', 'RegExp', 'Set', 'String', '_', 'clearTimeout', 'document',
    'isFinite', 'parseInt', 'setTimeout', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    'window'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dateTag] = typedArrayTags[errorTag] =
  typedArrayTags[funcTag] = typedArrayTags[mapTag] =
  typedArrayTags[numberTag] = typedArrayTags[objectTag] =
  typedArrayTags[regexpTag] = typedArrayTags[setTag] =
  typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[boolTag] =
  cloneableTags[dateTag] = cloneableTags[float32Tag] =
  cloneableTags[float64Tag] = cloneableTags[int8Tag] =
  cloneableTags[int16Tag] = cloneableTags[int32Tag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[stringTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[mapTag] = cloneableTags[setTag] =
  cloneableTags[weakMapTag] = false;

  /** Used as an internal `_.debounce` options object by `_.throttle`. */
  var debounceOptions = {
    'leading': false,
    'maxWait': 0,
    'trailing': false
  };

  /** Used to map latin-1 supplementary letters to basic latin letters. */
  var deburredLetters = {
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcC': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xeC': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
    '`': '&#96;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'",
    '&#96;': '`'
  };

  /** Used to determine if values are of the language type `Object`. */
  var objectTypes = {
    'function': true,
    'object': true
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Detect free variable `exports`. */
  var freeExports = objectTypes[typeof exports] && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = objectTypes[typeof module] && module && !module.nodeType && module;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = freeExports && freeModule && typeof global == 'object' && global && global.Object && global;

  /** Detect free variable `self`. */
  var freeSelf = objectTypes[typeof self] && self && self.Object && self;

  /** Detect free variable `window`. */
  var freeWindow = objectTypes[typeof window] && window && window.Object && window;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports && freeExports;

  /**
   * Used as a reference to the global object.
   *
   * The `this` value is used if it is the global object to avoid Greasemonkey's
   * restricted `window` object, otherwise the `window` object is used.
   */
  var root = freeGlobal || ((freeWindow !== (this && this.window)) && freeWindow) || freeSelf || this;

  /**
   * The base implementation of `compareAscending` which compares values and
   * sorts them in ascending order without guaranteeing a stable sort.
   *
   * @private
   * @param {*} value The value to compare to `other`.
   * @param {*} other The value to compare to `value`.
   * @returns {number} Returns the sort order indicator for `value`.
   */
  function baseCompareAscending(value, other) {
    if (value !== other) {
      var valIsReflexive = value === value,
          othIsReflexive = other === other;

      if (value > other || !valIsReflexive || (value === undefined && othIsReflexive)) {
        return 1;
      }
      if (value < other || !othIsReflexive || (other === undefined && valIsReflexive)) {
        return -1;
      }
    }
    return 0;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for callback shorthands and `this` binding.
   *
   * @private
   * @param {Array} array The array to search.
   * @param {Function} predicate The function invoked per iteration.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromRight) {
    var length = array.length,
        index = fromRight ? length : -1;

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without support for binary searches.
   *
   * @private
   * @param {Array} array The array to search.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    if (value !== value) {
      return indexOfNaN(array, fromIndex);
    }
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isFunction` without support for environments
   * with incorrect `typeof` results.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
   */
  function baseIsFunction(value) {
    // Avoid a Chakra JIT bug in compatibility modes of IE 11.
    // See https://github.com/jashkenas/underscore/issues/1621 for more details.
    return typeof value == 'function' || false;
  }

  /**
   * Converts `value` to a string if it is not one. An empty string is returned
   * for `null` or `undefined` values.
   *
   * @private
   * @param {*} value The value to process.
   * @returns {string} Returns the string.
   */
  function baseToString(value) {
    if (typeof value == 'string') {
      return value;
    }
    return value == null ? '' : (value + '');
  }

  /**
   * Used by `_.max` and `_.min` as the default callback for string values.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the code unit of the first character of the string.
   */
  function charAtCallback(string) {
    return string.charCodeAt(0);
  }

  /**
   * Used by `_.trim` and `_.trimLeft` to get the index of the first character
   * of `string` that is not found in `chars`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @param {string} chars The characters to find.
   * @returns {number} Returns the index of the first character not found in `chars`.
   */
  function charsLeftIndex(string, chars) {
    var index = -1,
        length = string.length;

    while (++index < length && chars.indexOf(string.charAt(index)) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimRight` to get the index of the last character
   * of `string` that is not found in `chars`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @param {string} chars The characters to find.
   * @returns {number} Returns the index of the last character not found in `chars`.
   */
  function charsRightIndex(string, chars) {
    var index = string.length;

    while (index-- && chars.indexOf(string.charAt(index)) > -1) {}
    return index;
  }

  /**
   * Used by `_.sortBy` to compare transformed elements of a collection and stable
   * sort them in ascending order.
   *
   * @private
   * @param {Object} object The object to compare to `other`.
   * @param {Object} other The object to compare to `object`.
   * @returns {number} Returns the sort order indicator for `object`.
   */
  function compareAscending(object, other) {
    return baseCompareAscending(object.criteria, other.criteria) || (object.index - other.index);
  }

  /**
   * Used by `_.sortByOrder` to compare multiple properties of each element
   * in a collection and stable sort them in the following order:
   *
   * If `orders` is unspecified, sort in ascending order for all properties.
   * Otherwise, for each property, sort in ascending order if its corresponding value in
   * orders is true, and descending order if false.
   *
   * @private
   * @param {Object} object The object to compare to `other`.
   * @param {Object} other The object to compare to `object`.
   * @param {boolean[]} orders The order to sort by for each property.
   * @returns {number} Returns the sort order indicator for `object`.
   */
  function compareMultiple(object, other, orders) {
    var index = -1,
        objCriteria = object.criteria,
        othCriteria = other.criteria,
        length = objCriteria.length,
        ordersLength = orders.length;

    while (++index < length) {
      var result = baseCompareAscending(objCriteria[index], othCriteria[index]);
      if (result) {
        if (index >= ordersLength) {
          return result;
        }
        return result * (orders[index] ? 1 : -1);
      }
    }
    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
    // that causes it, under certain circumstances, to provide the same value for
    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
    // for more details.
    //
    // This also ensures a stable sort in V8 and other engines.
    // See https://code.google.com/p/v8/issues/detail?id=90 for more details.
    return object.index - other.index;
  }

  /**
   * Used by `_.deburr` to convert latin-1 supplementary letters to basic latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  function deburrLetter(letter) {
    return deburredLetters[letter];
  }

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeHtmlChar(chr) {
    return htmlEscapes[chr];
  }

  /**
   * Used by `_.template` to escape characters for inclusion in compiled
   * string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the index at which the first occurrence of `NaN` is found in `array`.
   *
   * @private
   * @param {Array} array The array to search.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched `NaN`, else `-1`.
   */
  function indexOfNaN(array, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 0 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      var other = array[index];
      if (other !== other) {
        return index;
      }
    }
    return -1;
  }

  /**
   * Checks if `value` is object-like.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
   */
  function isObjectLike(value) {
    return !!value && typeof value == 'object';
  }

  /**
   * Used by `trimmedLeftIndex` and `trimmedRightIndex` to determine if a
   * character code is whitespace.
   *
   * @private
   * @param {number} charCode The character code to inspect.
   * @returns {boolean} Returns `true` if `charCode` is whitespace, else `false`.
   */
  function isSpace(charCode) {
    return ((charCode <= 160 && (charCode >= 9 && charCode <= 13) || charCode == 32 || charCode == 160) || charCode == 5760 || charCode == 6158 ||
      (charCode >= 8192 && (charCode <= 8202 || charCode == 8232 || charCode == 8233 || charCode == 8239 || charCode == 8287 || charCode == 12288 || charCode == 65279)));
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = -1,
        result = [];

    while (++index < length) {
      if (array[index] === placeholder) {
        array[index] = PLACEHOLDER;
        result[++resIndex] = index;
      }
    }
    return result;
  }

  /**
   * An implementation of `_.uniq` optimized for sorted arrays without support
   * for callback shorthands and `this` binding.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} [iteratee] The function invoked per iteration.
   * @returns {Array} Returns the new duplicate-value-free array.
   */
  function sortedUniq(array, iteratee) {
    var seen,
        index = -1,
        length = array.length,
        resIndex = -1,
        result = [];

    while (++index < length) {
      var value = array[index],
          computed = iteratee ? iteratee(value, index, array) : value;

      if (!index || seen !== computed) {
        seen = computed;
        result[++resIndex] = value;
      }
    }
    return result;
  }

  /**
   * Used by `_.trim` and `_.trimLeft` to get the index of the first non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the first non-whitespace character.
   */
  function trimmedLeftIndex(string) {
    var index = -1,
        length = string.length;

    while (++index < length && isSpace(string.charCodeAt(index))) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimRight` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */
  function trimmedRightIndex(string) {
    var index = string.length;

    while (index-- && isSpace(string.charCodeAt(index))) {}
    return index;
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  function unescapeHtmlChar(chr) {
    return htmlUnescapes[chr];
  }

  /**
   * Create a new pristine `lodash` function using the given `context` object.
   *
   * @static
   * @memberOf _
   * @category Utility
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // using `context` to mock `Date#getTime` use in `_.now`
   * var mock = _.runInContext({
   *   'Date': function() {
   *     return { 'getTime': getTimeMock };
   *   }
   * });
   *
   * // or creating a suped-up `defer` in Node.js
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  function runInContext(context) {
    // Avoid issues with some ES3 environments that attempt to use values, named
    // after built-in constructors like `Object`, for the creation of literals.
    // ES5 clears this up by stating that literals must use built-in constructors.
    // See https://es5.github.io/#x11.1.5 for more details.
    context = context ? _.defaults(root.Object(), context, _.pick(root, contextProps)) : root;

    /** Native constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Number = context.Number,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for native method references. */
    var arrayProto = Array.prototype,
        objectProto = Object.prototype,
        stringProto = String.prototype;

    /** Used to detect DOM support. */
    var document = (document = context.window) && document.document;

    /** Used to resolve the decompiled source of functions. */
    var fnToString = Function.prototype.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /**
     * Used to resolve the [`toStringTag`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-object.prototype.tostring)
     * of values.
     */
    var objToString = objectProto.toString;

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = context._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      escapeRegExp(objToString)
      .replace(/toString|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Native method references. */
    var ArrayBuffer = isNative(ArrayBuffer = context.ArrayBuffer) && ArrayBuffer,
        bufferSlice = isNative(bufferSlice = ArrayBuffer && new ArrayBuffer(0).slice) && bufferSlice,
        ceil = Math.ceil,
        clearTimeout = context.clearTimeout,
        floor = Math.floor,
        getOwnPropertySymbols = isNative(getOwnPropertySymbols = Object.getOwnPropertySymbols) && getOwnPropertySymbols,
        getPrototypeOf = isNative(getPrototypeOf = Object.getPrototypeOf) && getPrototypeOf,
        push = arrayProto.push,
        preventExtensions = isNative(preventExtensions = Object.preventExtensions) && preventExtensions,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        Set = isNative(Set = context.Set) && Set,
        setTimeout = context.setTimeout,
        splice = arrayProto.splice,
        Uint8Array = isNative(Uint8Array = context.Uint8Array) && Uint8Array,
        WeakMap = isNative(WeakMap = context.WeakMap) && WeakMap;

    /** Used to clone array buffers. */
    var Float64Array = (function() {
      // Safari 5 errors when using an array buffer to initialize a typed array
      // where the array buffer's `byteLength` is not a multiple of the typed
      // array's `BYTES_PER_ELEMENT`.
      try {
        var func = isNative(func = context.Float64Array) && func,
            result = new func(new ArrayBuffer(10), 0, 1) && func;
      } catch(e) {}
      return result;
    }());

    /** Used as `baseAssign`. */
    var nativeAssign = (function() {
      // Avoid `Object.assign` in Firefox 34-37 which have an early implementation
      // with a now defunct try/catch behavior. See https://bugzilla.mozilla.org/show_bug.cgi?id=1103344
      // for more details.
      //
      // Use `Object.preventExtensions` on a plain object instead of simply using
      // `Object('x')` because Chrome and IE fail to throw an error when attempting
      // to assign values to readonly indexes of strings.
      var func = preventExtensions && isNative(func = Object.assign) && func;
      try {
        if (func) {
          var object = preventExtensions({ '1': 0 });
          object[0] = 1;
        }
      } catch(e) {
        // Only attempt in strict mode.
        try { func(object, 'xo'); } catch(e) {}
        return !object[1] && func;
      }
      return false;
    }());

    /* Native method references for those with the same name as other `lodash` methods. */
    var nativeIsArray = isNative(nativeIsArray = Array.isArray) && nativeIsArray,
        nativeCreate = isNative(nativeCreate = Object.create) && nativeCreate,
        nativeIsFinite = context.isFinite,
        nativeKeys = isNative(nativeKeys = Object.keys) && nativeKeys,
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = isNative(nativeNow = Date.now) && nativeNow,
        nativeNumIsFinite = isNative(nativeNumIsFinite = Number.isFinite) && nativeNumIsFinite,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random;

    /** Used as references for `-Infinity` and `Infinity`. */
    var NEGATIVE_INFINITY = Number.NEGATIVE_INFINITY,
        POSITIVE_INFINITY = Number.POSITIVE_INFINITY;

    /** Used as references for the maximum length and index of an array. */
    var MAX_ARRAY_LENGTH = Math.pow(2, 32) - 1,
        MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
        HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

    /** Used as the size, in bytes, of each `Float64Array` element. */
    var FLOAT64_BYTES_PER_ELEMENT = Float64Array ? Float64Array.BYTES_PER_ELEMENT : 0;

    /**
     * Used as the [maximum length](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-number.max_safe_integer)
     * of an array-like value.
     */
    var MAX_SAFE_INTEGER = Math.pow(2, 53) - 1;

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit chaining.
     * Methods that operate on and return arrays, collections, and functions can
     * be chained together. Methods that return a boolean or single value will
     * automatically end the chain returning the unwrapped value. Explicit chaining
     * may be enabled using `_.chain`. The execution of chained methods is lazy,
     * that is, execution is deferred until `_#value` is implicitly or explicitly
     * called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion. Shortcut
     * fusion is an optimization that merges iteratees to avoid creating intermediate
     * arrays and reduce the number of iteratee executions.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `reverse`, `shift`, `slice`, `sort`,
     * `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `compact`, `drop`, `dropRight`, `dropRightWhile`, `dropWhile`, `filter`,
     * `first`, `initial`, `last`, `map`, `pluck`, `reject`, `rest`, `reverse`,
     * `slice`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, `toArray`,
     * and `where`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `at`, `before`, `bind`, `bindAll`, `bindKey`,
     * `callback`, `chain`, `chunk`, `commit`, `compact`, `concat`, `constant`,
     * `countBy`, `create`, `curry`, `debounce`, `defaults`, `defer`, `delay`,
     * `difference`, `drop`, `dropRight`, `dropRightWhile`, `dropWhile`, `fill`,
     * `filter`, `flatten`, `flattenDeep`, `flow`, `flowRight`, `forEach`,
     * `forEachRight`, `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `functions`,
     * `groupBy`, `indexBy`, `initial`, `intersection`, `invert`, `invoke`, `keys`,
     * `keysIn`, `map`, `mapValues`, `matches`, `matchesProperty`, `memoize`,
     * `merge`, `mixin`, `negate`, `omit`, `once`, `pairs`, `partial`, `partialRight`,
     * `partition`, `pick`, `plant`, `pluck`, `property`, `propertyOf`, `pull`,
     * `pullAt`, `push`, `range`, `rearg`, `reject`, `remove`, `rest`, `reverse`,
     * `shuffle`, `slice`, `sort`, `sortBy`, `sortByAll`, `sortByOrder`, `splice`,
     * `spread`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, `tap`,
     * `throttle`, `thru`, `times`, `toArray`, `toPlainObject`, `transform`,
     * `union`, `uniq`, `unshift`, `unzip`, `values`, `valuesIn`, `where`,
     * `without`, `wrap`, `xor`, `zip`, and `zipObject`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `clone`, `cloneDeep`, `deburr`,
     * `endsWith`, `escape`, `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`,
     * `findLast`, `findLastIndex`, `findLastKey`, `findWhere`, `first`, `has`,
     * `identity`, `includes`, `indexOf`, `inRange`, `isArguments`, `isArray`,
     * `isBoolean`, `isDate`, `isElement`, `isEmpty`, `isEqual`, `isError`, `isFinite`
     * `isFunction`, `isMatch`, `isNative`, `isNaN`, `isNull`, `isNumber`, `isObject`,
     * `isPlainObject`, `isRegExp`, `isString`, `isUndefined`, `isTypedArray`,
     * `join`, `kebabCase`, `last`, `lastIndexOf`, `max`, `min`, `noConflict`,
     * `noop`, `now`, `pad`, `padLeft`, `padRight`, `parseInt`, `pop`, `random`,
     * `reduce`, `reduceRight`, `repeat`, `result`, `runInContext`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedLastIndex`, `startCase`, `startsWith`,
     * `sum`, `template`, `trim`, `trimLeft`, `trimRight`, `trunc`, `unescape`,
     * `uniqueId`, `value`, and `words`
     *
     * The wrapper method `sample` will return a wrapped value when `n` is provided,
     * otherwise an unwrapped value is returned.
     *
     * @name _
     * @constructor
     * @category Chain
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // returns an unwrapped value
     * wrapped.reduce(function(total, n) {
     *   return total + n;
     * });
     * // => 6
     *
     * // returns a wrapped value
     * var squares = wrapped.map(function(n) {
     *   return n * n;
     * });
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__chain__') && hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The function whose prototype all chaining wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable chaining for all wrapper methods.
     * @param {Array} [actions=[]] Actions to peform to resolve the unwrapped value.
     */
    function LodashWrapper(value, chainAll, actions) {
      this.__wrapped__ = value;
      this.__actions__ = actions || [];
      this.__chain__ = !!chainAll;
    }

    /**
     * An object environment feature flags.
     *
     * @static
     * @memberOf _
     * @type Object
     */
    var support = lodash.support = {};

    (function(x) {
      var Ctor = function() { this.x = x; },
          args = arguments,
          object = { '0': x, 'length': x },
          props = [];

      Ctor.prototype = { 'valueOf': x, 'y': x };
      for (var key in new Ctor) { props.push(key); }

      /**
       * Detect if functions can be decompiled by `Function#toString`
       * (all but Firefox OS certified apps, older Opera mobile browsers, and
       * the PlayStation 3; forced `false` for Windows 8 apps).
       *
       * @memberOf _.support
       * @type boolean
       */
      support.funcDecomp = /\bthis\b/.test(function() { return this; });

      /**
       * Detect if `Function#name` is supported (all but IE).
       *
       * @memberOf _.support
       * @type boolean
       */
      support.funcNames = typeof Function.name == 'string';

      /**
       * Detect if the DOM is supported.
       *
       * @memberOf _.support
       * @type boolean
       */
      try {
        support.dom = document.createDocumentFragment().nodeType === 11;
      } catch(e) {
        support.dom = false;
      }

      /**
       * Detect if `arguments` object indexes are non-enumerable.
       *
       * In Firefox < 4, IE < 9, PhantomJS, and Safari < 5.1 `arguments` object
       * indexes are non-enumerable. Chrome < 25 and Node.js < 0.11.0 treat
       * `arguments` object indexes as non-enumerable and fail `hasOwnProperty`
       * checks for indexes that exceed the number of function parameters and
       * whose associated argument values are `0`.
       *
       * @memberOf _.support
       * @type boolean
       */
      try {
        support.nonEnumArgs = !propertyIsEnumerable.call(args, 1);
      } catch(e) {
        support.nonEnumArgs = true;
      }
    }(1, 0));

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB). Change the following template settings to use
     * alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type Object
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type RegExp
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type RegExp
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type RegExp
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type string
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type Object
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type Function
         */
        '_': lodash
      }
    };

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = null;
      this.__dir__ = 1;
      this.__dropCount__ = 0;
      this.__filtered__ = false;
      this.__iteratees__ = null;
      this.__takeCount__ = POSITIVE_INFINITY;
      this.__views__ = null;
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var actions = this.__actions__,
          iteratees = this.__iteratees__,
          views = this.__views__,
          result = new LazyWrapper(this.__wrapped__);

      result.__actions__ = actions ? arrayCopy(actions) : null;
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = iteratees ? arrayCopy(iteratees) : null;
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = views ? arrayCopy(views) : null;
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value();
      if (!isArray(array)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var dir = this.__dir__,
          isRight = dir < 0,
          view = getView(0, array.length, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          takeCount = nativeMin(length, this.__takeCount__),
          iteratees = this.__iteratees__,
          iterLength = iteratees ? iteratees.length : 0,
          resIndex = 0,
          result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type;

          if (type == LAZY_DROP_WHILE_FLAG) {
            if (data.done && (isRight ? (index > data.index) : (index < data.index))) {
              data.count = 0;
              data.done = false;
            }
            data.index = index;
            if (!data.done) {
              var limit = data.limit;
              if (!(data.done = limit > -1 ? (data.count++ >= limit) : !iteratee(value))) {
                continue outer;
              }
            }
          } else {
            var computed = iteratee(value);
            if (type == LAZY_MAP_FLAG) {
              value = computed;
            } else if (!computed) {
              if (type == LAZY_FILTER_FLAG) {
                continue outer;
              } else {
                break outer;
              }
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    /**
     * Creates a cache object to store key/value pairs.
     *
     * @private
     * @static
     * @name Cache
     * @memberOf _.memoize
     */
    function MapCache() {
      this.__data__ = {};
    }

    /**
     * Removes `key` and its value from the cache.
     *
     * @private
     * @name delete
     * @memberOf _.memoize.Cache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed successfully, else `false`.
     */
    function mapDelete(key) {
      return this.has(key) && delete this.__data__[key];
    }

    /**
     * Gets the cached value for `key`.
     *
     * @private
     * @name get
     * @memberOf _.memoize.Cache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the cached value.
     */
    function mapGet(key) {
      return key == '__proto__' ? undefined : this.__data__[key];
    }

    /**
     * Checks if a cached value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf _.memoize.Cache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapHas(key) {
      return key != '__proto__' && hasOwnProperty.call(this.__data__, key);
    }

    /**
     * Sets `value` to `key` of the cache.
     *
     * @private
     * @name set
     * @memberOf _.memoize.Cache
     * @param {string} key The key of the value to cache.
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache object.
     */
    function mapSet(key, value) {
      if (key != '__proto__') {
        this.__data__[key] = value;
      }
      return this;
    }

    /**
     *
     * Creates a cache object to store unique values.
     *
     * @private
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var length = values ? values.length : 0;

      this.data = { 'hash': nativeCreate(null), 'set': new Set };
      while (length--) {
        this.push(values[length]);
      }
    }

    /**
     * Checks if `value` is in `cache` mimicking the return signature of
     * `_.indexOf` by returning `0` if the value is found, else `-1`.
     *
     * @private
     * @param {Object} cache The cache to search.
     * @param {*} value The value to search for.
     * @returns {number} Returns `0` if `value` is found, else `-1`.
     */
    function cacheIndexOf(cache, value) {
      var data = cache.data,
          result = (typeof value == 'string' || isObject(value)) ? data.set.has(value) : data.hash[value];

      return result ? 0 : -1;
    }

    /**
     * Adds `value` to the cache.
     *
     * @private
     * @name push
     * @memberOf SetCache
     * @param {*} value The value to cache.
     */
    function cachePush(value) {
      var data = this.data;
      if (typeof value == 'string' || isObject(value)) {
        data.set.add(value);
      } else {
        data.hash[value] = true;
      }
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function arrayCopy(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * A specialized version of `_.forEach` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns `array`.
     */
    function arrayEach(array, iteratee) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        if (iteratee(array[index], index, array) === false) {
          break;
        }
      }
      return array;
    }

    /**
     * A specialized version of `_.forEachRight` for arrays without support for
     * callback shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns `array`.
     */
    function arrayEachRight(array, iteratee) {
      var length = array.length;

      while (length--) {
        if (iteratee(array[length], length, array) === false) {
          break;
        }
      }
      return array;
    }

    /**
     * A specialized version of `_.every` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     */
    function arrayEvery(array, predicate) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        if (!predicate(array[index], index, array)) {
          return false;
        }
      }
      return true;
    }

    /**
     * A specialized version of `_.filter` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function arrayFilter(array, predicate) {
      var index = -1,
          length = array.length,
          resIndex = -1,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result[++resIndex] = value;
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.map` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function arrayMap(array, iteratee) {
      var index = -1,
          length = array.length,
          result = Array(length);

      while (++index < length) {
        result[index] = iteratee(array[index], index, array);
      }
      return result;
    }

    /**
     * A specialized version of `_.max` for arrays without support for iteratees.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     */
    function arrayMax(array) {
      var index = -1,
          length = array.length,
          result = NEGATIVE_INFINITY;

      while (++index < length) {
        var value = array[index];
        if (value > result) {
          result = value;
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.min` for arrays without support for iteratees.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     */
    function arrayMin(array) {
      var index = -1,
          length = array.length,
          result = POSITIVE_INFINITY;

      while (++index < length) {
        var value = array[index];
        if (value < result) {
          result = value;
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.reduce` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @param {boolean} [initFromArray] Specify using the first element of `array`
     *  as the initial value.
     * @returns {*} Returns the accumulated value.
     */
    function arrayReduce(array, iteratee, accumulator, initFromArray) {
      var index = -1,
          length = array.length;

      if (initFromArray && length) {
        accumulator = array[++index];
      }
      while (++index < length) {
        accumulator = iteratee(accumulator, array[index], index, array);
      }
      return accumulator;
    }

    /**
     * A specialized version of `_.reduceRight` for arrays without support for
     * callback shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @param {boolean} [initFromArray] Specify using the last element of `array`
     *  as the initial value.
     * @returns {*} Returns the accumulated value.
     */
    function arrayReduceRight(array, iteratee, accumulator, initFromArray) {
      var length = array.length;
      if (initFromArray && length) {
        accumulator = array[--length];
      }
      while (length--) {
        accumulator = iteratee(accumulator, array[length], length, array);
      }
      return accumulator;
    }

    /**
     * A specialized version of `_.some` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function arraySome(array, predicate) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        if (predicate(array[index], index, array)) {
          return true;
        }
      }
      return false;
    }

    /**
     * A specialized version of `_.sum` for arrays without support for iteratees.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     */
    function arraySum(array) {
      var length = array.length,
          result = 0;

      while (length--) {
        result += +array[length] || 0;
      }
      return result;
    }

    /**
     * Used by `_.defaults` to customize its `_.assign` use.
     *
     * @private
     * @param {*} objectValue The destination object property value.
     * @param {*} sourceValue The source object property value.
     * @returns {*} Returns the value to assign to the destination object.
     */
    function assignDefaults(objectValue, sourceValue) {
      return objectValue === undefined ? sourceValue : objectValue;
    }

    /**
     * Used by `_.template` to customize its `_.assign` use.
     *
     * **Note:** This function is like `assignDefaults` except that it ignores
     * inherited property values when checking if a property is `undefined`.
     *
     * @private
     * @param {*} objectValue The destination object property value.
     * @param {*} sourceValue The source object property value.
     * @param {string} key The key associated with the object and source values.
     * @param {Object} object The destination object.
     * @returns {*} Returns the value to assign to the destination object.
     */
    function assignOwnDefaults(objectValue, sourceValue, key, object) {
      return (objectValue === undefined || !hasOwnProperty.call(object, key))
        ? sourceValue
        : objectValue;
    }

    /**
     * A specialized version of `_.assign` for customizing assigned values without
     * support for argument juggling, multiple sources, and `this` binding `customizer`
     * functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     */
    function assignWith(object, source, customizer) {
      var props = keys(source);
      push.apply(props, getSymbols(source));

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index],
            value = object[key],
            result = customizer(value, source[key], key, object, source);

        if ((result === result ? (result !== value) : (value === value)) ||
            (value === undefined && !(key in object))) {
          object[key] = result;
        }
      }
      return object;
    }

    /**
     * The base implementation of `_.assign` without support for argument juggling,
     * multiple sources, and `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    var baseAssign = nativeAssign || function(object, source) {
      return source == null
        ? object
        : baseCopy(source, getSymbols(source), baseCopy(source, keys(source), object));
    };

    /**
     * The base implementation of `_.at` without support for string collections
     * and individual key arguments.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {number[]|string[]} props The property names or indexes of elements to pick.
     * @returns {Array} Returns the new array of picked elements.
     */
    function baseAt(collection, props) {
      var index = -1,
          isNil = collection == null,
          isArr = !isNil && isArrayLike(collection),
          length = isArr && collection.length,
          propsLength = props.length,
          result = Array(propsLength);

      while(++index < propsLength) {
        var key = props[index];
        if (isArr) {
          result[index] = isIndex(key, length) ? collection[key] : undefined;
        } else {
          result[index] = isNil ? undefined : collection[key];
        }
      }
      return result;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property names to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @returns {Object} Returns `object`.
     */
    function baseCopy(source, props, object) {
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];
        object[key] = source[key];
      }
      return object;
    }

    /**
     * The base implementation of `_.callback` which supports specifying the
     * number of arguments to provide to `func`.
     *
     * @private
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {number} [argCount] The number of arguments to provide to `func`.
     * @returns {Function} Returns the callback.
     */
    function baseCallback(func, thisArg, argCount) {
      var type = typeof func;
      if (type == 'function') {
        return thisArg === undefined
          ? func
          : bindCallback(func, thisArg, argCount);
      }
      if (func == null) {
        return identity;
      }
      if (type == 'object') {
        return baseMatches(func);
      }
      return thisArg === undefined
        ? property(func)
        : baseMatchesProperty(func, thisArg);
    }

    /**
     * The base implementation of `_.clone` without support for argument juggling
     * and `this` binding `customizer` functions.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @param {Function} [customizer] The function to customize cloning values.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The object `value` belongs to.
     * @param {Array} [stackA=[]] Tracks traversed source objects.
     * @param {Array} [stackB=[]] Associates clones with source counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, isDeep, customizer, key, object, stackA, stackB) {
      var result;
      if (customizer) {
        result = object ? customizer(value, key, object) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return arrayCopy(value, result);
        }
      } else {
        var tag = objToString.call(value),
            isFunc = tag == funcTag;

        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = initCloneObject(isFunc ? {} : value);
          if (!isDeep) {
            return baseAssign(result, value);
          }
        } else {
          return cloneableTags[tag]
            ? initCloneByTag(value, tag, isDeep)
            : (object ? value : {});
        }
      }
      // Check for circular references and return corresponding clone.
      stackA || (stackA = []);
      stackB || (stackB = []);

      var length = stackA.length;
      while (length--) {
        if (stackA[length] == value) {
          return stackB[length];
        }
      }
      // Add the source value to the stack of traversed objects and associate it with its clone.
      stackA.push(value);
      stackB.push(result);

      // Recursively populate clone (susceptible to call stack limits).
      (isArr ? arrayEach : baseForOwn)(value, function(subValue, key) {
        result[key] = baseClone(subValue, isDeep, customizer, key, value, stackA, stackB);
      });
      return result;
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} prototype The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function Object() {}
      return function(prototype) {
        if (isObject(prototype)) {
          Object.prototype = prototype;
          var result = new Object;
          Object.prototype = null;
        }
        return result || context.Object();
      };
    }());

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts an index
     * of where to slice the arguments to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Object} args The arguments provide to `func`.
     * @returns {number} Returns the timer id.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of `_.difference` which accepts a single array
     * of values to exclude.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values) {
      var length = array ? array.length : 0,
          result = [];

      if (!length) {
        return result;
      }
      var index = -1,
          indexOf = getIndexOf(),
          isCommon = indexOf == baseIndexOf,
          cache = (isCommon && values.length >= 200) ? createCache(values) : null,
          valuesLength = values.length;

      if (cache) {
        indexOf = cacheIndexOf;
        isCommon = false;
        values = cache;
      }
      outer:
      while (++index < length) {
        var value = array[index];

        if (isCommon && value === value) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === value) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (indexOf(values, value, 0) < 0) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object|string} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object|string} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = start == null ? 0 : (+start || 0);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : (+end || 0);
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : (end >>> 0);
      start >>>= 0;

      while (start < length) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.find`, `_.findLast`, `_.findKey`, and `_.findLastKey`,
     * without support for callback shorthands and `this` binding, which iterates
     * over `collection` using the provided `eachFunc`.
     *
     * @private
     * @param {Array|Object|string} collection The collection to search.
     * @param {Function} predicate The function invoked per iteration.
     * @param {Function} eachFunc The function to iterate over `collection`.
     * @param {boolean} [retKey] Specify returning the key of the found element
     *  instead of the element itself.
     * @returns {*} Returns the found element or its key, else `undefined`.
     */
    function baseFind(collection, predicate, eachFunc, retKey) {
      var result;
      eachFunc(collection, function(value, key, collection) {
        if (predicate(value, key, collection)) {
          result = retKey ? key : value;
          return false;
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with added support for restricting
     * flattening and specifying the start index.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {boolean} [isDeep] Specify a deep flatten.
     * @param {boolean} [isStrict] Restrict flattening to arrays-like objects.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, isDeep, isStrict) {
      var index = -1,
          length = array.length,
          resIndex = -1,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (isObjectLike(value) && isArrayLike(value) &&
            (isStrict || isArray(value) || isArguments(value))) {
          if (isDeep) {
            // Recursively flatten arrays (susceptible to call stack limits).
            value = baseFlatten(value, isDeep, isStrict);
          }
          var valIndex = -1,
              valLength = value.length;

          while (++valIndex < valLength) {
            result[++resIndex] = value[valIndex];
          }
        } else if (!isStrict) {
          result[++resIndex] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForIn` and `baseForOwn` which iterates
     * over `object` properties returned by `keysFunc` invoking `iteratee` for
     * each property. Iteratee functions may exit iteration early by explicitly
     * returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forIn` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForIn(object, iteratee) {
      return baseFor(object, iteratee, keysIn);
    }

    /**
     * The base implementation of `_.forOwn` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from those provided.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the new array of filtered property names.
     */
    function baseFunctions(object, props) {
      var index = -1,
          length = props.length,
          resIndex = -1,
          result = [];

      while (++index < length) {
        var key = props[index];
        if (isFunction(object[key])) {
          result[++resIndex] = key;
        }
      }
      return result;
    }

    /**
     * The base implementation of `get` without support for string paths
     * and default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path of the property to get.
     * @param {string} [pathKey] The key representation of path.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path, pathKey) {
      if (object == null) {
        return;
      }
      if (pathKey !== undefined && pathKey in toObject(object)) {
        path = [pathKey];
      }
      var index = -1,
          length = path.length;

      while (object != null && ++index < length) {
        object = object[path[index]];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `_.isEqual` without support for `this` binding
     * `customizer` functions.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparing values.
     * @param {boolean} [isLoose] Specify performing partial comparisons.
     * @param {Array} [stackA] Tracks traversed `value` objects.
     * @param {Array} [stackB] Tracks traversed `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, customizer, isLoose, stackA, stackB) {
      // Exit early for identical values.
      if (value === other) {
        return true;
      }
      var valType = typeof value,
          othType = typeof other;

      // Exit early for unlike primitive values.
      if ((valType != 'function' && valType != 'object' && othType != 'function' && othType != 'object') ||
          value == null || other == null) {
        // Return `false` unless both values are `NaN`.
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, baseIsEqual, customizer, isLoose, stackA, stackB);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Function} [customizer] The function to customize comparing objects.
     * @param {boolean} [isLoose] Specify performing partial comparisons.
     * @param {Array} [stackA=[]] Tracks traversed `value` objects.
     * @param {Array} [stackB=[]] Tracks traversed `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = arrayTag,
          othTag = arrayTag;

      if (!objIsArr) {
        objTag = objToString.call(object);
        if (objTag == argsTag) {
          objTag = objectTag;
        } else if (objTag != objectTag) {
          objIsArr = isTypedArray(object);
        }
      }
      if (!othIsArr) {
        othTag = objToString.call(other);
        if (othTag == argsTag) {
          othTag = objectTag;
        } else if (othTag != objectTag) {
          othIsArr = isTypedArray(other);
        }
      }
      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && !(objIsArr || objIsObj)) {
        return equalByTag(object, other, objTag);
      }
      if (!isLoose) {
        var valWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (valWrapped || othWrapped) {
          return equalFunc(valWrapped ? object.value() : object, othWrapped ? other.value() : other, customizer, isLoose, stackA, stackB);
        }
      }
      if (!isSameTag) {
        return false;
      }
      // Assume cyclic values are equal.
      // For more information on detecting circular references see https://es5.github.io/#JO.
      stackA || (stackA = []);
      stackB || (stackB = []);

      var length = stackA.length;
      while (length--) {
        if (stackA[length] == object) {
          return stackB[length] == other;
        }
      }
      // Add `object` and `other` to the stack of traversed objects.
      stackA.push(object);
      stackB.push(other);

      var result = (objIsArr ? equalArrays : equalObjects)(object, other, equalFunc, customizer, isLoose, stackA, stackB);

      stackA.pop();
      stackB.pop();

      return result;
    }

    /**
     * The base implementation of `_.isMatch` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The source property names to match.
     * @param {Array} values The source values to match.
     * @param {Array} strictCompareFlags Strict comparison flags for source values.
     * @param {Function} [customizer] The function to customize comparing objects.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, props, values, strictCompareFlags, customizer) {
      var index = -1,
          length = props.length,
          noCustomizer = !customizer;

      while (++index < length) {
        if ((noCustomizer && strictCompareFlags[index])
              ? values[index] !== object[props[index]]
              : !(props[index] in object)
            ) {
          return false;
        }
      }
      index = -1;
      while (++index < length) {
        var key = props[index],
            objValue = object[key],
            srcValue = values[index];

        if (noCustomizer && strictCompareFlags[index]) {
          var result = objValue !== undefined || (key in object);
        } else {
          result = customizer ? customizer(objValue, srcValue, key) : undefined;
          if (result === undefined) {
            result = baseIsEqual(srcValue, objValue, customizer, true);
          }
        }
        if (!result) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.map` without support for callback shorthands
     * and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which does not clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new function.
     */
    function baseMatches(source) {
      var props = keys(source),
          length = props.length;

      if (!length) {
        return constant(true);
      }
      if (length == 1) {
        var key = props[0],
            value = source[key];

        if (isStrictComparable(value)) {
          return function(object) {
            if (object == null) {
              return false;
            }
            return object[key] === value && (value !== undefined || (key in toObject(object)));
          };
        }
      }
      var values = Array(length),
          strictCompareFlags = Array(length);

      while (length--) {
        value = source[props[length]];
        values[length] = value;
        strictCompareFlags[length] = isStrictComparable(value);
      }
      return function(object) {
        return object != null && baseIsMatch(toObject(object), props, values, strictCompareFlags);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which does not which does
     * not clone `value`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} value The value to compare.
     * @returns {Function} Returns the new function.
     */
    function baseMatchesProperty(path, value) {
      var isArr = isArray(path),
          isCommon = isKey(path) && isStrictComparable(value),
          pathKey = (path + '');

      path = toPath(path);
      return function(object) {
        if (object == null) {
          return false;
        }
        var key = pathKey;
        object = toObject(object);
        if ((isArr || !isCommon) && !(key in object)) {
          object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
          if (object == null) {
            return false;
          }
          key = last(path);
          object = toObject(object);
        }
        return object[key] === value
          ? (value !== undefined || (key in object))
          : baseIsEqual(value, object[key], null, true);
      };
    }

    /**
     * The base implementation of `_.merge` without support for argument juggling,
     * multiple sources, and `this` binding `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {Function} [customizer] The function to customize merging properties.
     * @param {Array} [stackA=[]] Tracks traversed source objects.
     * @param {Array} [stackB=[]] Associates values with source counterparts.
     * @returns {Object} Returns `object`.
     */
    function baseMerge(object, source, customizer, stackA, stackB) {
      if (!isObject(object)) {
        return object;
      }
      var isSrcArr = isArrayLike(source) && (isArray(source) || isTypedArray(source));
      if (!isSrcArr) {
        var props = keys(source);
        push.apply(props, getSymbols(source));
      }
      arrayEach(props || source, function(srcValue, key) {
        if (props) {
          key = srcValue;
          srcValue = source[key];
        }
        if (isObjectLike(srcValue)) {
          stackA || (stackA = []);
          stackB || (stackB = []);
          baseMergeDeep(object, source, key, baseMerge, customizer, stackA, stackB);
        }
        else {
          var value = object[key],
              result = customizer ? customizer(value, srcValue, key, object, source) : undefined,
              isCommon = result === undefined;

          if (isCommon) {
            result = srcValue;
          }
          if ((isSrcArr || result !== undefined) &&
              (isCommon || (result === result ? (result !== value) : (value === value)))) {
            object[key] = result;
          }
        }
      });
      return object;
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize merging properties.
     * @param {Array} [stackA=[]] Tracks traversed source objects.
     * @param {Array} [stackB=[]] Associates values with source counterparts.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseMergeDeep(object, source, key, mergeFunc, customizer, stackA, stackB) {
      var length = stackA.length,
          srcValue = source[key];

      while (length--) {
        if (stackA[length] == srcValue) {
          object[key] = stackB[length];
          return;
        }
      }
      var value = object[key],
          result = customizer ? customizer(value, srcValue, key, object, source) : undefined,
          isCommon = result === undefined;

      if (isCommon) {
        result = srcValue;
        if (isArrayLike(srcValue) && (isArray(srcValue) || isTypedArray(srcValue))) {
          result = isArray(value)
            ? value
            : (isArrayLike(value) ? arrayCopy(value) : []);
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          result = isArguments(value)
            ? toPlainObject(value)
            : (isPlainObject(value) ? value : {});
        }
        else {
          isCommon = false;
        }
      }
      // Add the source value to the stack of traversed objects and associate
      // it with its merged value.
      stackA.push(srcValue);
      stackB.push(result);

      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        object[key] = mergeFunc(result, srcValue, customizer, stackA, stackB);
      } else if (result === result ? (result !== value) : (value === value)) {
        object[key] = result;
      }
    }

    /**
     * The base implementation of `_.property` without support for deep paths.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @returns {Function} Returns the new function.
     */
    function baseProperty(key) {
      return function(object) {
        return object == null ? undefined : object[key];
      };
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new function.
     */
    function basePropertyDeep(path) {
      var pathKey = (path + '');
      path = toPath(path);
      return function(object) {
        return baseGet(object, path, pathKey);
      };
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * index arguments and capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0;
      while (length--) {
        var index = parseFloat(indexes[length]);
        if (index != previous && isIndex(index)) {
          var previous = index;
          splice.call(array, index, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for argument juggling
     * and returning floating-point numbers.
     *
     * @private
     * @param {number} min The minimum possible value.
     * @param {number} max The maximum possible value.
     * @returns {number} Returns the random number.
     */
    function baseRandom(min, max) {
      return min + floor(nativeRandom() * (max - min + 1));
    }

    /**
     * The base implementation of `_.reduce` and `_.reduceRight` without support
     * for callback shorthands and `this` binding, which iterates over `collection`
     * using the provided `eachFunc`.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {*} accumulator The initial value.
     * @param {boolean} initFromCollection Specify using the first or last element
     *  of `collection` as the initial value.
     * @param {Function} eachFunc The function to iterate over `collection`.
     * @returns {*} Returns the accumulated value.
     */
    function baseReduce(collection, iteratee, accumulator, initFromCollection, eachFunc) {
      eachFunc(collection, function(value, index, collection) {
        accumulator = initFromCollection
          ? (initFromCollection = false, value)
          : iteratee(accumulator, value, index, collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `setData` without support for hot loop detection.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      start = start == null ? 0 : (+start || 0);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : (+end || 0);
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for callback shorthands
     * and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortBy` which uses `comparer` to define
     * the sort order of `array` and replaces criteria objects with their
     * corresponding values.
     *
     * @private
     * @param {Array} array The array to sort.
     * @param {Function} comparer The function to define sort order.
     * @returns {Array} Returns `array`.
     */
    function baseSortBy(array, comparer) {
      var length = array.length;

      array.sort(comparer);
      while (length--) {
        array[length] = array[length].value;
      }
      return array;
    }

    /**
     * The base implementation of `_.sortByOrder` without param guards.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {boolean[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseSortByOrder(collection, iteratees, orders) {
      var callback = getCallback(),
          index = -1;

      iteratees = arrayMap(iteratees, function(iteratee) { return callback(iteratee); });

      var result = baseMap(collection, function(value) {
        var criteria = arrayMap(iteratees, function(iteratee) { return iteratee(value); });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.sum` without support for callback shorthands
     * and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {number} Returns the sum.
     */
    function baseSum(collection, iteratee) {
      var result = 0;
      baseEach(collection, function(value, index, collection) {
        result += +iteratee(value, index, collection) || 0;
      });
      return result;
    }

    /**
     * The base implementation of `_.uniq` without support for callback shorthands
     * and `this` binding.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The function invoked per iteration.
     * @returns {Array} Returns the new duplicate-value-free array.
     */
    function baseUniq(array, iteratee) {
      var index = -1,
          indexOf = getIndexOf(),
          length = array.length,
          isCommon = indexOf == baseIndexOf,
          isLarge = isCommon && length >= 200,
          seen = isLarge ? createCache() : null,
          result = [];

      if (seen) {
        indexOf = cacheIndexOf;
        isCommon = false;
      } else {
        isLarge = false;
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value, index, array) : value;

        if (isCommon && value === value) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (indexOf(seen, computed, 0) < 0) {
          if (iteratee || isLarge) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.values` and `_.valuesIn` which creates an
     * array of `object` property values corresponding to the property names
     * of `props`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} props The property names to get values for.
     * @returns {Object} Returns the array of property values.
     */
    function baseValues(object, props) {
      var index = -1,
          length = props.length,
          result = Array(length);

      while (++index < length) {
        result[index] = object[props[index]];
      }
      return result;
    }

    /**
     * The base implementation of `_.dropRightWhile`, `_.dropWhile`, `_.takeRightWhile`,
     * and `_.takeWhile` without support for callback shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) && predicate(array[index], index, array)) {}
      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to peform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      var index = -1,
          length = actions.length;

      while (++index < length) {
        var args = [result],
            action = actions[index];

        push.apply(args, action.args);
        result = action.func.apply(action.thisArg, args);
      }
      return result;
    }

    /**
     * Performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function binaryIndex(array, value, retHighest) {
      var low = 0,
          high = array ? array.length : low;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (retHighest ? (computed <= value) : (computed < value)) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return binaryIndexBy(array, value, identity, retHighest);
    }

    /**
     * This function is like `binaryIndex` except that it invokes `iteratee` for
     * `value` and each element of `array` to compute their sort ranking. The
     * iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function binaryIndexBy(array, value, iteratee, retHighest) {
      value = iteratee(value);

      var low = 0,
          high = array ? array.length : 0,
          valIsNaN = value !== value,
          valIsUndef = value === undefined;

      while (low < high) {
        var mid = floor((low + high) / 2),
            computed = iteratee(array[mid]),
            isReflexive = computed === computed;

        if (valIsNaN) {
          var setLow = isReflexive || retHighest;
        } else if (valIsUndef) {
          setLow = isReflexive && (retHighest || computed !== undefined);
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * A specialized version of `baseCallback` which only supports `this` binding
     * and specifying the number of arguments to provide to `func`.
     *
     * @private
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {number} [argCount] The number of arguments to provide to `func`.
     * @returns {Function} Returns the callback.
     */
    function bindCallback(func, thisArg, argCount) {
      if (typeof func != 'function') {
        return identity;
      }
      if (thisArg === undefined) {
        return func;
      }
      switch (argCount) {
        case 1: return function(value) {
          return func.call(thisArg, value);
        };
        case 3: return function(value, index, collection) {
          return func.call(thisArg, value, index, collection);
        };
        case 4: return function(accumulator, value, index, collection) {
          return func.call(thisArg, accumulator, value, index, collection);
        };
        case 5: return function(value, other, key, object, source) {
          return func.call(thisArg, value, other, key, object, source);
        };
      }
      return function() {
        return func.apply(thisArg, arguments);
      };
    }

    /**
     * Creates a clone of the given array buffer.
     *
     * @private
     * @param {ArrayBuffer} buffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function bufferClone(buffer) {
      return bufferSlice.call(buffer, 0);
    }
    if (!bufferSlice) {
      // PhantomJS has `ArrayBuffer` and `Uint8Array` but not `Float64Array`.
      bufferClone = !(ArrayBuffer && Uint8Array) ? constant(null) : function(buffer) {
        var byteLength = buffer.byteLength,
            floatLength = Float64Array ? floor(byteLength / FLOAT64_BYTES_PER_ELEMENT) : 0,
            offset = floatLength * FLOAT64_BYTES_PER_ELEMENT,
            result = new ArrayBuffer(byteLength);

        if (floatLength) {
          var view = new Float64Array(result, 0, floatLength);
          view.set(new Float64Array(buffer, 0, floatLength));
        }
        if (byteLength != offset) {
          view = new Uint8Array(result, offset);
          view.set(new Uint8Array(buffer, offset));
        }
        return result;
      };
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array|Object} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders) {
      var holdersLength = holders.length,
          argsIndex = -1,
          argsLength = nativeMax(args.length - holdersLength, 0),
          leftIndex = -1,
          leftLength = partials.length,
          result = Array(argsLength + leftLength);

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        result[holders[argsIndex]] = args[argsIndex];
      }
      while (argsLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array|Object} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders) {
      var holdersIndex = -1,
          holdersLength = holders.length,
          argsIndex = -1,
          argsLength = nativeMax(args.length - holdersLength, 0),
          rightIndex = -1,
          rightLength = partials.length,
          result = Array(argsLength + rightLength);

      while (++argsIndex < argsLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        result[offset + holders[holdersIndex]] = args[argsIndex++];
      }
      return result;
    }

    /**
     * Creates a function that aggregates a collection, creating an accumulator
     * object composed from the results of running each element in the collection
     * through an iteratee.
     *
     * **Note:** This function is used to create `_.countBy`, `_.groupBy`, `_.indexBy`,
     * and `_.partition`.
     *
     * @private
     * @param {Function} setter The function to set keys and values of the accumulator object.
     * @param {Function} [initializer] The function to initialize the accumulator object.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee, thisArg) {
        var result = initializer ? initializer() : {};
        iteratee = getCallback(iteratee, thisArg, 3);

        if (isArray(collection)) {
          var index = -1,
              length = collection.length;

          while (++index < length) {
            var value = collection[index];
            setter(result, value, iteratee(value, index, collection), collection);
          }
        } else {
          baseEach(collection, function(value, key, collection) {
            setter(result, value, iteratee(value, key, collection), collection);
          });
        }
        return result;
      };
    }

    /**
     * Creates a function that assigns properties of source object(s) to a given
     * destination object.
     *
     * **Note:** This function is used to create `_.assign`, `_.defaults`, and `_.merge`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return restParam(function(object, sources) {
        var index = -1,
            length = object == null ? 0 : sources.length,
            customizer = length > 2 && sources[length - 2],
            guard = length > 2 && sources[2],
            thisArg = length > 1 && sources[length - 1];

        if (typeof customizer == 'function') {
          customizer = bindCallback(customizer, thisArg, 5);
          length -= 2;
        } else {
          customizer = typeof thisArg == 'function' ? thisArg : null;
          length -= (customizer ? 1 : 0);
        }
        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? null : customizer;
          length = 1;
        }
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        var length = collection ? getLength(collection) : 0;
        if (!isLength(length)) {
          return eachFunc(collection, iteratee);
        }
        var index = fromRight ? length : -1,
            iterable = toObject(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for `_.forIn` or `_.forInRight`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var iterable = toObject(object),
            props = keysFunc(object),
            length = props.length,
            index = fromRight ? length : -1;

        while ((fromRight ? index-- : ++index < length)) {
          var key = props[index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` and invokes it with the `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to bind.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new bound function.
     */
    function createBindWrapper(func, thisArg) {
      var Ctor = createCtorWrapper(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(thisArg, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a `Set` cache object to optimize linear searches of large arrays.
     *
     * @private
     * @param {Array} [values] The values to cache.
     * @returns {null|Object} Returns the new cache object if `Set` is supported, else `null`.
     */
    var createCache = !(nativeCreate && Set) ? constant(null) : function(values) {
      return new SetCache(values);
    };

    /**
     * Creates a function that produces compound words out of the words in a
     * given string.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        var index = -1,
            array = words(deburr(string)),
            length = array.length,
            result = '';

        while (++index < length) {
          result = callback(result, array[index], index);
        }
        return result;
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtorWrapper(Ctor) {
      return function() {
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, arguments);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a `_.curry` or `_.curryRight` function.
     *
     * @private
     * @param {boolean} flag The curry bit flag.
     * @returns {Function} Returns the new curry function.
     */
    function createCurry(flag) {
      function curryFunc(func, arity, guard) {
        if (guard && isIterateeCall(func, arity, guard)) {
          arity = null;
        }
        var result = createWrapper(func, flag, null, null, null, null, null, arity);
        result.placeholder = curryFunc.placeholder;
        return result;
      }
      return curryFunc;
    }

    /**
     * Creates a `_.max` or `_.min` function.
     *
     * @private
     * @param {Function} arrayFunc The function to get the extremum value from an array.
     * @param {boolean} [isMin] Specify returning the minimum, instead of the maximum,
     *  extremum value.
     * @returns {Function} Returns the new extremum function.
     */
    function createExtremum(arrayFunc, isMin) {
      return function(collection, iteratee, thisArg) {
        if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
          iteratee = null;
        }
        var func = getCallback(),
            noIteratee = iteratee == null;

        if (!(func === baseCallback && noIteratee)) {
          noIteratee = false;
          iteratee = func(iteratee, thisArg, 3);
        }
        if (noIteratee) {
          var isArr = isArray(collection);
          if (!isArr && isString(collection)) {
            iteratee = charAtCallback;
          } else {
            return arrayFunc(isArr ? collection : toIterable(collection));
          }
        }
        return extremumBy(collection, iteratee, isMin);
      };
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new find function.
     */
    function createFind(eachFunc, fromRight) {
      return function(collection, predicate, thisArg) {
        predicate = getCallback(predicate, thisArg, 3);
        if (isArray(collection)) {
          var index = baseFindIndex(collection, predicate, fromRight);
          return index > -1 ? collection[index] : undefined;
        }
        return baseFind(collection, predicate, eachFunc);
      };
    }

    /**
     * Creates a `_.findIndex` or `_.findLastIndex` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new find function.
     */
    function createFindIndex(fromRight) {
      return function(array, predicate, thisArg) {
        if (!(array && array.length)) {
          return -1;
        }
        predicate = getCallback(predicate, thisArg, 3);
        return baseFindIndex(array, predicate, fromRight);
      };
    }

    /**
     * Creates a `_.findKey` or `_.findLastKey` function.
     *
     * @private
     * @param {Function} objectFunc The function to iterate over an object.
     * @returns {Function} Returns the new find function.
     */
    function createFindKey(objectFunc) {
      return function(object, predicate, thisArg) {
        predicate = getCallback(predicate, thisArg, 3);
        return baseFind(object, predicate, objectFunc, true);
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return function() {
        var length = arguments.length;
        if (!length) {
          return function() { return arguments[0]; };
        }
        var wrapper,
            index = fromRight ? length : -1,
            leftIndex = 0,
            funcs = Array(length);

        while ((fromRight ? index-- : ++index < length)) {
          var func = funcs[leftIndex++] = arguments[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          var funcName = wrapper ? '' : getFuncName(func);
          wrapper = funcName == 'wrapper' ? new LodashWrapper([]) : wrapper;
        }
        index = wrapper ? -1 : length;
        while (++index < length) {
          func = funcs[index];
          funcName = getFuncName(func);

          var data = funcName == 'wrapper' ? getData(func) : null;
          if (data && isLaziable(data[0]) && data[1] == (ARY_FLAG | CURRY_FLAG | PARTIAL_FLAG | REARG_FLAG) && !data[4].length && data[9] == 1) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func)) ? wrapper[funcName]() : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments;
          if (wrapper && args.length == 1 && isArray(args[0])) {
            return wrapper.plant(args[0]).value();
          }
          var index = 0,
              result = funcs[index].apply(this, args);

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      };
    }

    /**
     * Creates a function for `_.forEach` or `_.forEachRight`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over an array.
     * @param {Function} eachFunc The function to iterate over a collection.
     * @returns {Function} Returns the new each function.
     */
    function createForEach(arrayFunc, eachFunc) {
      return function(collection, iteratee, thisArg) {
        return (typeof iteratee == 'function' && thisArg === undefined && isArray(collection))
          ? arrayFunc(collection, iteratee)
          : eachFunc(collection, bindCallback(iteratee, thisArg, 3));
      };
    }

    /**
     * Creates a function for `_.forIn` or `_.forInRight`.
     *
     * @private
     * @param {Function} objectFunc The function to iterate over an object.
     * @returns {Function} Returns the new each function.
     */
    function createForIn(objectFunc) {
      return function(object, iteratee, thisArg) {
        if (typeof iteratee != 'function' || thisArg !== undefined) {
          iteratee = bindCallback(iteratee, thisArg, 3);
        }
        return objectFunc(object, iteratee, keysIn);
      };
    }

    /**
     * Creates a function for `_.forOwn` or `_.forOwnRight`.
     *
     * @private
     * @param {Function} objectFunc The function to iterate over an object.
     * @returns {Function} Returns the new each function.
     */
    function createForOwn(objectFunc) {
      return function(object, iteratee, thisArg) {
        if (typeof iteratee != 'function' || thisArg !== undefined) {
          iteratee = bindCallback(iteratee, thisArg, 3);
        }
        return objectFunc(object, iteratee);
      };
    }

    /**
     * Creates a function for `_.mapKeys` or `_.mapValues`.
     *
     * @private
     * @param {boolean} [isMapKeys] Specify mapping keys instead of values.
     * @returns {Function} Returns the new map function.
     */
    function createObjectMapper(isMapKeys) {
      return function(object, iteratee, thisArg) {
        var result = {};
        iteratee = getCallback(iteratee, thisArg, 3);

        baseForOwn(object, function(value, key, object) {
          var mapped = iteratee(value, key, object);
          key = isMapKeys ? mapped : key;
          value = isMapKeys ? value : mapped;
          result[key] = value;
        });
        return result;
      };
    }

    /**
     * Creates a function for `_.padLeft` or `_.padRight`.
     *
     * @private
     * @param {boolean} [fromRight] Specify padding from the right.
     * @returns {Function} Returns the new pad function.
     */
    function createPadDir(fromRight) {
      return function(string, length, chars) {
        string = baseToString(string);
        return (fromRight ? string : '') + createPadding(string, length, chars) + (fromRight ? '' : string);
      };
    }

    /**
     * Creates a `_.partial` or `_.partialRight` function.
     *
     * @private
     * @param {boolean} flag The partial bit flag.
     * @returns {Function} Returns the new partial function.
     */
    function createPartial(flag) {
      var partialFunc = restParam(function(func, partials) {
        var holders = replaceHolders(partials, partialFunc.placeholder);
        return createWrapper(func, flag, null, partials, holders);
      });
      return partialFunc;
    }

    /**
     * Creates a function for `_.reduce` or `_.reduceRight`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over an array.
     * @param {Function} eachFunc The function to iterate over a collection.
     * @returns {Function} Returns the new each function.
     */
    function createReduce(arrayFunc, eachFunc) {
      return function(collection, iteratee, accumulator, thisArg) {
        var initFromArray = arguments.length < 3;
        return (typeof iteratee == 'function' && thisArg === undefined && isArray(collection))
          ? arrayFunc(collection, iteratee, accumulator, initFromArray)
          : baseReduce(collection, getCallback(iteratee, thisArg, 4), accumulator, initFromArray, eachFunc);
      };
    }

    /**
     * Creates a function that wraps `func` and invokes it with optional `this`
     * binding of, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to reference.
     * @param {number} bitmask The bitmask of flags. See `createWrapper` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybridWrapper(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & ARY_FLAG,
          isBind = bitmask & BIND_FLAG,
          isBindKey = bitmask & BIND_KEY_FLAG,
          isCurry = bitmask & CURRY_FLAG,
          isCurryBound = bitmask & CURRY_BOUND_FLAG,
          isCurryRight = bitmask & CURRY_RIGHT_FLAG;

      var Ctor = !isBindKey && createCtorWrapper(func),
          key = func;

      function wrapper() {
        // Avoid `arguments` object use disqualifying optimizations by
        // converting it to an array before providing it to other functions.
        var length = arguments.length,
            index = length,
            args = Array(length);

        while (index--) {
          args[index] = arguments[index];
        }
        if (partials) {
          args = composeArgs(args, partials, holders);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight);
        }
        if (isCurry || isCurryRight) {
          var placeholder = wrapper.placeholder,
              argsHolders = replaceHolders(args, placeholder);

          length -= argsHolders.length;
          if (length < arity) {
            var newArgPos = argPos ? arrayCopy(argPos) : null,
                newArity = nativeMax(arity - length, 0),
                newsHolders = isCurry ? argsHolders : null,
                newHoldersRight = isCurry ? null : argsHolders,
                newPartials = isCurry ? args : null,
                newPartialsRight = isCurry ? null : args;

            bitmask |= (isCurry ? PARTIAL_FLAG : PARTIAL_RIGHT_FLAG);
            bitmask &= ~(isCurry ? PARTIAL_RIGHT_FLAG : PARTIAL_FLAG);

            if (!isCurryBound) {
              bitmask &= ~(BIND_FLAG | BIND_KEY_FLAG);
            }
            var newData = [func, bitmask, thisArg, newPartials, newsHolders, newPartialsRight, newHoldersRight, newArgPos, ary, newArity],
                result = createHybridWrapper.apply(undefined, newData);

            if (isLaziable(func)) {
              setData(result, newData);
            }
            result.placeholder = placeholder;
            return result;
          }
        }
        var thisBinding = isBind ? thisArg : this;
        if (isBindKey) {
          func = thisBinding[key];
        }
        if (argPos) {
          args = reorder(args, argPos);
        }
        if (isAry && ary < args.length) {
          args.length = ary;
        }
        var fn = (this && this !== root && this instanceof wrapper) ? (Ctor || createCtorWrapper(func)) : func;
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates the padding required for `string` based on the given `length`.
     * The `chars` string is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {string} string The string to create padding for.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the pad for `string`.
     */
    function createPadding(string, length, chars) {
      var strLength = string.length;
      length = +length;

      if (strLength >= length || !nativeIsFinite(length)) {
        return '';
      }
      var padLength = length - strLength;
      chars = chars == null ? ' ' : (chars + '');
      return repeat(chars, ceil(padLength / chars.length)).slice(0, padLength);
    }

    /**
     * Creates a function that wraps `func` and invokes it with the optional `this`
     * binding of `thisArg` and the `partials` prepended to those provided to
     * the wrapper.
     *
     * @private
     * @param {Function} func The function to partially apply arguments to.
     * @param {number} bitmask The bitmask of flags. See `createWrapper` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to the new function.
     * @returns {Function} Returns the new bound function.
     */
    function createPartialWrapper(func, bitmask, thisArg, partials) {
      var isBind = bitmask & BIND_FLAG,
          Ctor = createCtorWrapper(func);

      function wrapper() {
        // Avoid `arguments` object use disqualifying optimizations by
        // converting it to an array before providing it `func`.
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(argsLength + leftLength);

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.sortedIndex` or `_.sortedLastIndex` function.
     *
     * @private
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {Function} Returns the new index function.
     */
    function createSortedIndex(retHighest) {
      return function(array, value, iteratee, thisArg) {
        var func = getCallback(iteratee);
        return (func === baseCallback && iteratee == null)
          ? binaryIndex(array, value, retHighest)
          : binaryIndexBy(array, value, func(iteratee, thisArg, 1), retHighest);
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to reference.
     * @param {number} bitmask The bitmask of flags.
     *  The bitmask may be composed of the following flags:
     *     1 - `_.bind`
     *     2 - `_.bindKey`
     *     4 - `_.curry` or `_.curryRight` of a bound function
     *     8 - `_.curry`
     *    16 - `_.curryRight`
     *    32 - `_.partial`
     *    64 - `_.partialRight`
     *   128 - `_.rearg`
     *   256 - `_.ary`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrapper(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(PARTIAL_FLAG | PARTIAL_RIGHT_FLAG);
        partials = holders = null;
      }
      length -= (holders ? holders.length : 0);
      if (bitmask & PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = null;
      }
      var data = isBindKey ? null : getData(func),
          newData = [func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity];

      if (data) {
        mergeData(newData, data);
        bitmask = newData[1];
        arity = newData[9];
      }
      newData[9] = arity == null
        ? (isBindKey ? 0 : func.length)
        : (nativeMax(arity - length, 0) || 0);

      if (bitmask == BIND_FLAG) {
        var result = createBindWrapper(newData[0], newData[2]);
      } else if ((bitmask == PARTIAL_FLAG || bitmask == (BIND_FLAG | PARTIAL_FLAG)) && !newData[4].length) {
        result = createPartialWrapper.apply(undefined, newData);
      } else {
        result = createHybridWrapper.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setter(result, newData);
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Function} [customizer] The function to customize comparing arrays.
     * @param {boolean} [isLoose] Specify performing partial comparisons.
     * @param {Array} [stackA] Tracks traversed `value` objects.
     * @param {Array} [stackB] Tracks traversed `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, equalFunc, customizer, isLoose, stackA, stackB) {
      var index = -1,
          arrLength = array.length,
          othLength = other.length,
          result = true;

      if (arrLength != othLength && !(isLoose && othLength > arrLength)) {
        return false;
      }
      // Deep compare the contents, ignoring non-numeric properties.
      while (result && ++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        result = undefined;
        if (customizer) {
          result = isLoose
            ? customizer(othValue, arrValue, index)
            : customizer(arrValue, othValue, index);
        }
        if (result === undefined) {
          // Recursively compare arrays (susceptible to call stack limits).
          if (isLoose) {
            var othIndex = othLength;
            while (othIndex--) {
              othValue = other[othIndex];
              result = (arrValue && arrValue === othValue) || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB);
              if (result) {
                break;
              }
            }
          } else {
            result = (arrValue && arrValue === othValue) || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB);
          }
        }
      }
      return !!result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} value The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag) {
      switch (tag) {
        case boolTag:
        case dateTag:
          // Coerce dates and booleans to numbers, dates to milliseconds and booleans
          // to `1` or `0` treating invalid dates coerced to `NaN` as not equal.
          return +object == +other;

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case numberTag:
          // Treat `NaN` vs. `NaN` as equal.
          return (object != +object)
            ? other != +other
            : object == +other;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings primitives and string
          // objects as equal. See https://es5.github.io/#x15.10.6.4 for more details.
          return object == (other + '');
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Function} [customizer] The function to customize comparing values.
     * @param {boolean} [isLoose] Specify performing partial comparisons.
     * @param {Array} [stackA] Tracks traversed `value` objects.
     * @param {Array} [stackB] Tracks traversed `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
      var objProps = keys(object),
          objLength = objProps.length,
          othProps = keys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isLoose) {
        return false;
      }
      var skipCtor = isLoose,
          index = -1;

      while (++index < objLength) {
        var key = objProps[index],
            result = isLoose ? key in other : hasOwnProperty.call(other, key);

        if (result) {
          var objValue = object[key],
              othValue = other[key];

          result = undefined;
          if (customizer) {
            result = isLoose
              ? customizer(othValue, objValue, key)
              : customizer(objValue, othValue, key);
          }
          if (result === undefined) {
            // Recursively compare objects (susceptible to call stack limits).
            result = (objValue && objValue === othValue) || equalFunc(objValue, othValue, customizer, isLoose, stackA, stackB);
          }
        }
        if (!result) {
          return false;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (!skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Gets the extremum value of `collection` invoking `iteratee` for each value
     * in `collection` to generate the criterion by which the value is ranked.
     * The `iteratee` is invoked with three arguments: (value, index, collection).
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {boolean} [isMin] Specify returning the minimum, instead of the
     *  maximum, extremum value.
     * @returns {*} Returns the extremum value.
     */
    function extremumBy(collection, iteratee, isMin) {
      var exValue = isMin ? POSITIVE_INFINITY : NEGATIVE_INFINITY,
          computed = exValue,
          result = computed;

      baseEach(collection, function(value, index, collection) {
        var current = iteratee(value, index, collection);
        if ((isMin ? (current < computed) : (current > computed)) ||
            (current === exValue && current === result)) {
          computed = current;
          result = value;
        }
      });
      return result;
    }

    /**
     * Gets the appropriate "callback" function. If the `_.callback` method is
     * customized this function returns the custom method, otherwise it returns
     * the `baseCallback` function. If arguments are provided the chosen function
     * is invoked with them and its result is returned.
     *
     * @private
     * @returns {Function} Returns the chosen function or its result.
     */
    function getCallback(func, thisArg, argCount) {
      var result = lodash.callback || callback;
      result = result === callback ? baseCallback : result;
      return argCount ? result(func, thisArg, argCount) : result;
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    var getFuncName = (function() {
      if (!support.funcNames) {
        return constant('');
      }
      if (constant.name == 'constant') {
        return baseProperty('name');
      }
      return function(func) {
        var result = func.name,
            array = realNames[result],
            length = array ? array.length : 0;

        while (length--) {
          var data = array[length],
              otherFunc = data.func;

          if (otherFunc == null || otherFunc == func) {
            return data.name;
          }
        }
        return result;
      };
    }());

    /**
     * Gets the appropriate "indexOf" function. If the `_.indexOf` method is
     * customized this function returns the custom method, otherwise it returns
     * the `baseIndexOf` function. If arguments are provided the chosen function
     * is invoked with them and its result is returned.
     *
     * @private
     * @returns {Function|number} Returns the chosen function or its result.
     */
    function getIndexOf(collection, target, fromIndex) {
      var result = lodash.indexOf || indexOf;
      result = result === indexOf ? baseIndexOf : result;
      return collection ? result(collection, target, fromIndex) : result;
    }

    /**
     * Gets the "length" property value of `object`.
     *
     * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
     * that affects Safari on at least iOS 8.1-8.3 ARM64.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {*} Returns the "length" value.
     */
    var getLength = baseProperty('length');

    /**
     * Creates an array of the own symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !getOwnPropertySymbols ? constant([]) : function(object) {
      return getOwnPropertySymbols(toObject(object));
    };

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} [transforms] The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms ? transforms.length : 0;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add array properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      var Ctor = object.constructor;
      if (!(typeof Ctor == 'function' && Ctor instanceof Ctor)) {
        Ctor = Object;
      }
      return new Ctor;
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return bufferClone(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          var buffer = object.buffer;
          return new Ctor(isDeep ? bufferClone(buffer) : buffer, object.byteOffset, object.length);

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          var result = new Ctor(object.source, reFlags.exec(object));
          result.lastIndex = object.lastIndex;
      }
      return result;
    }

    /**
     * Invokes the method at `path` on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function invokePath(object, path, args) {
      if (object != null && !isKey(path, object)) {
        path = toPath(path);
        object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
        path = last(path);
      }
      var func = object == null ? object : object[path];
      return func == null ? undefined : func.apply(object, args);
    }

    /**
     * Checks if `value` is array-like.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     */
    function isArrayLike(value) {
      return value != null && isLength(getLength(value));
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      value = +value;
      length = length == null ? MAX_SAFE_INTEGER : length;
      return value > -1 && value % 1 == 0 && value < length;
    }

    /**
     * Checks if the provided arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call, else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
          ? (isArrayLike(object) && isIndex(index, object.length))
          : (type == 'string' && index in object)) {
        var other = object[index];
        return value === value ? (value === other) : (other !== other);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      var type = typeof value;
      if ((type == 'string' && reIsPlainProp.test(value)) || type == 'number') {
        return true;
      }
      if (isArray(value)) {
        return false;
      }
      var result = !reIsDeepProp.test(value);
      return result || (object != null && value in toObject(object));
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart, else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func);
      return !!funcName && func === lodash[funcName] && funcName in LazyWrapper.prototype;
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This function is based on [`ToLength`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength).
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     */
    function isLength(value) {
      return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers required to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and `_.rearg`
     * augment function arguments, making the order in which they are executed important,
     * preventing the merging of metadata. However, we make an exception for a safe
     * common case where curried functions have `_.ary` and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < ARY_FLAG;

      var isCombo =
        (srcBitmask == ARY_FLAG && bitmask == CURRY_FLAG) ||
        (srcBitmask == ARY_FLAG && bitmask == REARG_FLAG && data[7].length <= source[8]) ||
        (srcBitmask == (ARY_FLAG | REARG_FLAG) && bitmask == CURRY_FLAG);

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= (bitmask & BIND_FLAG) ? 0 : CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : arrayCopy(value);
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : arrayCopy(source[4]);
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : arrayCopy(value);
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : arrayCopy(source[6]);
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = arrayCopy(value);
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * A specialized version of `_.pick` which picks `object` properties specified
     * by `props`.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} props The property names to pick.
     * @returns {Object} Returns the new object.
     */
    function pickByArray(object, props) {
      object = toObject(object);

      var index = -1,
          length = props.length,
          result = {};

      while (++index < length) {
        var key = props[index];
        if (key in object) {
          result[key] = object[key];
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.pick` which picks `object` properties `predicate`
     * returns truthy for.
     *
     * @private
     * @param {Object} object The source object.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Object} Returns the new object.
     */
    function pickByCallback(object, predicate) {
      var result = {};
      baseForIn(object, function(value, key, object) {
        if (predicate(value, key, object)) {
          result[key] = value;
        }
      });
      return result;
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = arrayCopy(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity function
     * to avoid garbage collection pauses in V8. See [V8 issue 2070](https://code.google.com/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = (function() {
      var count = 0,
          lastCalled = 0;

      return function(key, value) {
        var stamp = now(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return key;
          }
        } else {
          count = 0;
        }
        return baseSetData(key, value);
      };
    }());

    /**
     * A fallback implementation of `_.isPlainObject` which checks if `value`
     * is an object created by the `Object` constructor or has a `[[Prototype]]`
     * of `null`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     */
    function shimIsPlainObject(value) {
      var Ctor,
          support = lodash.support;

      // Exit early for non `Object` objects.
      if (!(isObjectLike(value) && objToString.call(value) == objectTag) ||
          (!hasOwnProperty.call(value, 'constructor') &&
            (Ctor = value.constructor, typeof Ctor == 'function' && !(Ctor instanceof Ctor)))) {
        return false;
      }
      // IE < 9 iterates inherited properties before own properties. If the first
      // iterated property is an object's own property then there are no inherited
      // enumerable properties.
      var result;
      // In most environments an object's own properties are iterated before
      // its inherited properties. If the last iterated property is an object's
      // own property then there are no inherited enumerable properties.
      baseForIn(value, function(subValue, key) {
        result = key;
      });
      return result === undefined || hasOwnProperty.call(value, result);
    }

    /**
     * A fallback implementation of `Object.keys` which creates an array of the
     * own enumerable property names of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function shimKeys(object) {
      var props = keysIn(object),
          propsLength = props.length,
          length = propsLength && object.length,
          support = lodash.support;

      var allowIndexes = length && isLength(length) &&
        (isArray(object) || (support.nonEnumArgs && isArguments(object)));

      var index = -1,
          result = [];

      while (++index < propsLength) {
        var key = props[index];
        if ((allowIndexes && isIndex(key, length)) || hasOwnProperty.call(object, key)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to an array-like object if it is not one.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {Array|Object} Returns the array-like object.
     */
    function toIterable(value) {
      if (value == null) {
        return [];
      }
      if (!isArrayLike(value)) {
        return values(value);
      }
      return isObject(value) ? value : Object(value);
    }

    /**
     * Converts `value` to an object if it is not one.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {Object} Returns the object.
     */
    function toObject(value) {
      return isObject(value) ? value : Object(value);
    }

    /**
     * Converts `value` to property path array if it is not one.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {Array} Returns the property path array.
     */
    function toPath(value) {
      if (isArray(value)) {
        return value;
      }
      var result = [];
      baseToString(value).replace(rePropName, function(match, number, quote, string) {
        result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      return wrapper instanceof LazyWrapper
        ? wrapper.clone()
        : new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__, arrayCopy(wrapper.__actions__));
    }

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `collection` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the new array containing chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if (guard ? isIterateeCall(array, size, guard) : size == null) {
        size = 1;
      } else {
        size = nativeMax(+size || 1, 1);
      }
      var index = 0,
          length = array ? array.length : 0,
          resIndex = -1,
          result = Array(ceil(length / size));

      while (index < length) {
        result[++resIndex] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array ? array.length : 0,
          resIndex = -1,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[++resIndex] = value;
        }
      }
      return result;
    }

    /**
     * Creates an array excluding all values of the provided arrays using
     * [`SameValueZero`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The arrays of values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.difference([1, 2, 3], [4, 2]);
     * // => [1, 3]
     */
    var difference = restParam(function(array, values) {
      return isArrayLike(array)
        ? baseDifference(array, baseFlatten(values, false, true))
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (guard ? isIterateeCall(array, n, guard) : n == null) {
        n = 1;
      }
      return baseSlice(array, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (guard ? isIterateeCall(array, n, guard) : n == null) {
        n = 1;
      }
      n = length - (+n || 0);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * bound to `thisArg` and invoked with three arguments: (value, index, array).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that match the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRightWhile([1, 2, 3], function(n) {
     *   return n > 1;
     * });
     * // => [1]
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.dropRightWhile(users, { 'user': 'pebbles', 'active': false }), 'user');
     * // => ['barney', 'fred']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.dropRightWhile(users, 'active', false), 'user');
     * // => ['barney']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.dropRightWhile(users, 'active'), 'user');
     * // => ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate, thisArg) {
      return (array && array.length)
        ? baseWhile(array, getCallback(predicate, thisArg, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * bound to `thisArg` and invoked with three arguments: (value, index, array).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropWhile([1, 2, 3], function(n) {
     *   return n < 3;
     * });
     * // => [3]
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.dropWhile(users, { 'user': 'barney', 'active': false }), 'user');
     * // => ['fred', 'pebbles']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.dropWhile(users, 'active', false), 'user');
     * // => ['pebbles']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.dropWhile(users, 'active'), 'user');
     * // => ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate, thisArg) {
      return (array && array.length)
        ? baseWhile(array, getCallback(predicate, thisArg, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8], '*', 1, 2);
     * // => [4, '*', 8]
     */
    function fill(array, value, start, end) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(chr) {
     *   return chr.user == 'barney';
     * });
     * // => 0
     *
     * // using the `_.matches` callback shorthand
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.findIndex(users, 'active', false);
     * // => 0
     *
     * // using the `_.property` callback shorthand
     * _.findIndex(users, 'active');
     * // => 2
     */
    var findIndex = createFindIndex();

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(chr) {
     *   return chr.user == 'pebbles';
     * });
     * // => 2
     *
     * // using the `_.matches` callback shorthand
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.findLastIndex(users, 'active', false);
     * // => 2
     *
     * // using the `_.property` callback shorthand
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    var findLastIndex = createFindIndex(true);

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @alias head
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.first([1, 2, 3]);
     * // => 1
     *
     * _.first([]);
     * // => undefined
     */
    function first(array) {
      return array ? array[0] : undefined;
    }

    /**
     * Flattens a nested array. If `isDeep` is `true` the array is recursively
     * flattened, otherwise it is only flattened a single level.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {boolean} [isDeep] Specify a deep flatten.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, 3, [4]]]);
     * // => [1, 2, 3, [4]]
     *
     * // using `isDeep`
     * _.flatten([1, [2, 3, [4]]], true);
     * // => [1, 2, 3, 4]
     */
    function flatten(array, isDeep, guard) {
      var length = array ? array.length : 0;
      if (guard && isIterateeCall(array, isDeep, guard)) {
        isDeep = false;
      }
      return length ? baseFlatten(array, isDeep) : [];
    }

    /**
     * Recursively flattens a nested array.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to recursively flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, 3, [4]]]);
     * // => [1, 2, 3, 4]
     */
    function flattenDeep(array) {
      var length = array ? array.length : 0;
      return length ? baseFlatten(array, true) : [];
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it is used as the offset
     * from the end of `array`. If `array` is sorted providing `true` for `fromIndex`
     * performs a faster binary search.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to search.
     * @param {*} value The value to search for.
     * @param {boolean|number} [fromIndex=0] The index to search from or `true`
     *  to perform a binary search on a sorted array.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // using `fromIndex`
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     *
     * // performing a binary search
     * _.indexOf([1, 1, 2, 2], 2, true);
     * // => 2
     */
    function indexOf(array, value, fromIndex) {
      var length = array ? array.length : 0;
      if (!length) {
        return -1;
      }
      if (typeof fromIndex == 'number') {
        fromIndex = fromIndex < 0 ? nativeMax(length + fromIndex, 0) : fromIndex;
      } else if (fromIndex) {
        var index = binaryIndex(array, value),
            other = array[index];

        if (value === value ? (value === other) : (other !== other)) {
          return index;
        }
        return -1;
      }
      return baseIndexOf(array, value, fromIndex || 0);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      return dropRight(array, 1);
    }

    /**
     * Creates an array of unique values in all provided arrays using
     * [`SameValueZero`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of shared values.
     * @example
     * _.intersection([1, 2], [4, 2], [2, 1]);
     * // => [2]
     */
    function intersection() {
      var args = [],
          argsIndex = -1,
          argsLength = arguments.length,
          caches = [],
          indexOf = getIndexOf(),
          isCommon = indexOf == baseIndexOf,
          result = [];

      while (++argsIndex < argsLength) {
        var value = arguments[argsIndex];
        if (isArrayLike(value)) {
          args.push(value);
          caches.push((isCommon && value.length >= 120) ? createCache(argsIndex && value) : null);
        }
      }
      argsLength = args.length;
      if (argsLength < 2) {
        return result;
      }
      var array = args[0],
          index = -1,
          length = array ? array.length : 0,
          seen = caches[0];

      outer:
      while (++index < length) {
        value = array[index];
        if ((seen ? cacheIndexOf(seen, value) : indexOf(result, value, 0)) < 0) {
          argsIndex = argsLength;
          while (--argsIndex) {
            var cache = caches[argsIndex];
            if ((cache ? cacheIndexOf(cache, value) : indexOf(args[argsIndex], value, 0)) < 0) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(value);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array ? array.length : 0;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to search.
     * @param {*} value The value to search for.
     * @param {boolean|number} [fromIndex=array.length-1] The index to search from
     *  or `true` to perform a binary search on a sorted array.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // using `fromIndex`
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     *
     * // performing a binary search
     * _.lastIndexOf([1, 1, 2, 2], 2, true);
     * // => 3
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array ? array.length : 0;
      if (!length) {
        return -1;
      }
      var index = length;
      if (typeof fromIndex == 'number') {
        index = (fromIndex < 0 ? nativeMax(length + fromIndex, 0) : nativeMin(fromIndex || 0, length - 1)) + 1;
      } else if (fromIndex) {
        index = binaryIndex(array, value, true) - 1;
        var other = array[index];
        if (value === value ? (value === other) : (other !== other)) {
          return index;
        }
        return -1;
      }
      if (value !== value) {
        return indexOfNaN(array, index, true);
      }
      while (index--) {
        if (array[index] === value) {
          return index;
        }
      }
      return -1;
    }

    /**
     * Removes all provided values from `array` using
     * [`SameValueZero`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3, 1, 2, 3];
     *
     * _.pull(array, 2, 3);
     * console.log(array);
     * // => [1, 1]
     */
    function pull() {
      var args = arguments,
          array = args[0];

      if (!(array && array.length)) {
        return array;
      }
      var index = 0,
          indexOf = getIndexOf(),
          length = args.length;

      while (++index < length) {
        var fromIndex = 0,
            value = args[index];

        while ((fromIndex = indexOf(array, value, fromIndex)) > -1) {
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * Removes elements from `array` corresponding to the given indexes and returns
     * an array of the removed elements. Indexes may be specified as an array of
     * indexes or as individual arguments.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove,
     *  specified as individual indexes or arrays of indexes.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [5, 10, 15, 20];
     * var evens = _.pullAt(array, 1, 3);
     *
     * console.log(array);
     * // => [5, 15]
     *
     * console.log(evens);
     * // => [10, 20]
     */
    var pullAt = restParam(function(array, indexes) {
      indexes = baseFlatten(indexes);

      var result = baseAt(array, indexes);
      basePullAt(array, indexes.sort(baseCompareAscending));
      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is bound to
     * `thisArg` and invoked with three arguments: (value, index, array).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate, thisArg) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getCallback(predicate, thisArg, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @alias tail
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.rest([1, 2, 3]);
     * // => [2, 3]
     */
    function rest(array) {
      return drop(array, 1);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of `Array#slice` to support node
     * lists in IE < 9 and to ensure dense arrays are returned.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value` should
     * be inserted into `array` in order to maintain its sort order. If an iteratee
     * function is provided it is invoked for `value` and each element of `array`
     * to compute their sort ranking. The iteratee is bound to `thisArg` and
     * invoked with one argument; (value).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     *
     * _.sortedIndex([4, 4, 5, 5], 5);
     * // => 2
     *
     * var dict = { 'data': { 'thirty': 30, 'forty': 40, 'fifty': 50 } };
     *
     * // using an iteratee function
     * _.sortedIndex(['thirty', 'fifty'], 'forty', function(word) {
     *   return this.data[word];
     * }, dict);
     * // => 1
     *
     * // using the `_.property` callback shorthand
     * _.sortedIndex([{ 'x': 30 }, { 'x': 50 }], { 'x': 40 }, 'x');
     * // => 1
     */
    var sortedIndex = createSortedIndex();

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 4, 5, 5], 5);
     * // => 4
     */
    var sortedLastIndex = createSortedIndex(true);

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (guard ? isIterateeCall(array, n, guard) : n == null) {
        n = 1;
      }
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (guard ? isIterateeCall(array, n, guard) : n == null) {
        n = 1;
      }
      n = length - (+n || 0);
      return baseSlice(array, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is bound to `thisArg`
     * and invoked with three arguments: (value, index, array).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRightWhile([1, 2, 3], function(n) {
     *   return n > 1;
     * });
     * // => [2, 3]
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.takeRightWhile(users, { 'user': 'pebbles', 'active': false }), 'user');
     * // => ['pebbles']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.takeRightWhile(users, 'active', false), 'user');
     * // => ['fred', 'pebbles']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.takeRightWhile(users, 'active'), 'user');
     * // => []
     */
    function takeRightWhile(array, predicate, thisArg) {
      return (array && array.length)
        ? baseWhile(array, getCallback(predicate, thisArg, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is bound to
     * `thisArg` and invoked with three arguments: (value, index, array).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeWhile([1, 2, 3], function(n) {
     *   return n < 3;
     * });
     * // => [1, 2]
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false},
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.takeWhile(users, { 'user': 'barney', 'active': false }), 'user');
     * // => ['barney']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.takeWhile(users, 'active', false), 'user');
     * // => ['barney', 'fred']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.takeWhile(users, 'active'), 'user');
     * // => []
     */
    function takeWhile(array, predicate, thisArg) {
      return (array && array.length)
        ? baseWhile(array, getCallback(predicate, thisArg, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, of the provided arrays using
     * [`SameValueZero`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([1, 2], [4, 2], [2, 1]);
     * // => [1, 2, 4]
     */
    var union = restParam(function(arrays) {
      return baseUniq(baseFlatten(arrays, false, true));
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-samevaluezero)
     * for equality comparisons, in which only the first occurence of each element
     * is kept. Providing `true` for `isSorted` performs a faster search algorithm
     * for sorted arrays. If an iteratee function is provided it is invoked for
     * each element in the array to generate the criterion by which uniqueness
     * is computed. The `iteratee` is bound to `thisArg` and invoked with three
     * arguments: (value, index, array).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @alias unique
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {boolean} [isSorted] Specify the array is sorted.
     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the new duplicate-value-free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     *
     * // using `isSorted`
     * _.uniq([1, 1, 2], true);
     * // => [1, 2]
     *
     * // using an iteratee function
     * _.uniq([1, 2.5, 1.5, 2], function(n) {
     *   return this.floor(n);
     * }, Math);
     * // => [1, 2.5]
     *
     * // using the `_.property` callback shorthand
     * _.uniq([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniq(array, isSorted, iteratee, thisArg) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (isSorted != null && typeof isSorted != 'boolean') {
        thisArg = iteratee;
        iteratee = isIterateeCall(array, isSorted, thisArg) ? null : isSorted;
        isSorted = false;
      }
      var func = getCallback();
      if (!(func === baseCallback && iteratee == null)) {
        iteratee = func(iteratee, thisArg, 3);
      }
      return (isSorted && getIndexOf() == baseIndexOf)
        ? sortedUniq(array, iteratee)
        : baseUniq(array, iteratee);
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['fred', 'barney'], [30, 40], [true, false]);
     * // => [['fred', 30, true], ['barney', 40, false]]
     *
     * _.unzip(zipped);
     * // => [['fred', 'barney'], [30, 40], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var index = -1,
          length = 0;

      array = arrayFilter(array, function(group) {
        if (isArrayLike(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      var result = Array(length);
      while (++index < length) {
        result[index] = arrayMap(array, baseProperty(index));
      }
      return result;
    }

    /**
     * This method is like `_.unzip` except that it accepts an iteratee to specify
     * how regrouped values should be combined. The `iteratee` is bound to `thisArg`
     * and invoked with four arguments: (accumulator, value, index, group).
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee] The function to combine regrouped values.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee, thisArg) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      iteratee = bindCallback(iteratee, thisArg, 4);
      return arrayMap(result, function(group) {
        return arrayReduce(group, iteratee, undefined, true);
      });
    }

    /**
     * Creates an array excluding all provided values using
     * [`SameValueZero`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to filter.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.without([1, 2, 1, 3], 1, 2);
     * // => [3]
     */
    var without = restParam(function(array, values) {
      return isArrayLike(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array that is the [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the provided arrays.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of values.
     * @example
     *
     * _.xor([1, 2], [4, 2]);
     * // => [1, 4]
     */
    function xor() {
      var index = -1,
          length = arguments.length;

      while (++index < length) {
        var array = arguments[index];
        if (isArrayLike(array)) {
          var result = result
            ? baseDifference(result, array).concat(baseDifference(array, result))
            : array;
        }
      }
      return result ? baseUniq(result) : [];
    }

    /**
     * Creates an array of grouped elements, the first of which contains the first
     * elements of the given arrays, the second of which contains the second elements
     * of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['fred', 'barney'], [30, 40], [true, false]);
     * // => [['fred', 30, true], ['barney', 40, false]]
     */
    var zip = restParam(unzip);

    /**
     * The inverse of `_.pairs`; this method returns an object composed from arrays
     * of property names and values. Provide either a single two dimensional array,
     * e.g. `[[key1, value1], [key2, value2]]` or two arrays, one of property names
     * and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @alias object
     * @category Array
     * @param {Array} props The property names.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject([['fred', 30], ['barney', 40]]);
     * // => { 'fred': 30, 'barney': 40 }
     *
     * _.zipObject(['fred', 'barney'], [30, 40]);
     * // => { 'fred': 30, 'barney': 40 }
     */
    function zipObject(props, values) {
      var index = -1,
          length = props ? props.length : 0,
          result = {};

      if (length && !values && !isArray(props[0])) {
        values = [];
      }
      while (++index < length) {
        var key = props[index];
        if (values) {
          result[key] = values[index];
        } else if (key) {
          result[key[0]] = key[1];
        }
      }
      return result;
    }

    /**
     * This method is like `_.zip` except that it accepts an iteratee to specify
     * how grouped values should be combined. The `iteratee` is bound to `thisArg`
     * and invoked with four arguments: (accumulator, value, index, group).
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee] The function to combine grouped values.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], _.add);
     * // => [111, 222]
     */
    var zipWith = restParam(function(arrays) {
      var length = arrays.length,
          iteratee = arrays[length - 2],
          thisArg = arrays[length - 1];

      if (length > 2 && typeof iteratee == 'function') {
        length -= 2;
      } else {
        iteratee = (length > 1 && typeof thisArg == 'function') ? (--length, thisArg) : undefined;
        thisArg = undefined;
      }
      arrays.length = length;
      return unzipWith(arrays, iteratee, thisArg);
    });

    /**
     * Creates a `lodash` object that wraps `value` with explicit method
     * chaining enabled.
     *
     * @static
     * @memberOf _
     * @category Chain
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _.chain(users)
     *   .sortBy('age')
     *   .map(function(chr) {
     *     return chr.user + ' is ' + chr.age;
     *   })
     *   .first()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor is
     * bound to `thisArg` and invoked with one argument; (value). The purpose of
     * this method is to "tap into" a method chain in order to perform operations
     * on intermediate results within the chain.
     *
     * @static
     * @memberOf _
     * @category Chain
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @param {*} [thisArg] The `this` binding of `interceptor`.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor, thisArg) {
      interceptor.call(thisArg, value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     *
     * @static
     * @memberOf _
     * @category Chain
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @param {*} [thisArg] The `this` binding of `interceptor`.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor, thisArg) {
      return interceptor.call(thisArg, value);
    }

    /**
     * Enables explicit method chaining on the wrapper object.
     *
     * @name chain
     * @memberOf _
     * @category Chain
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // without explicit chaining
     * _(users).first();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // with explicit chaining
     * _(users).chain()
     *   .first()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chained sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @category Chain
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapper = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapper = wrapper.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapper.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Creates a clone of the chained sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @category Chain
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapper = _(array).map(function(value) {
     *   return Math.pow(value, 2);
     * });
     *
     * var other = [3, 4];
     * var otherWrapper = wrapper.plant(other);
     *
     * otherWrapper.value();
     * // => [9, 16]
     *
     * wrapper.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * Reverses the wrapped array so the first element becomes the last, the
     * second element becomes the second to last, and so on.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @category Chain
     * @returns {Object} Returns the new reversed `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        if (this.__actions__.length) {
          value = new LazyWrapper(this);
        }
        return new LodashWrapper(value.reverse(), this.__chain__);
      }
      return this.thru(function(value) {
        return value.reverse();
      });
    }

    /**
     * Produces the result of coercing the unwrapped value to a string.
     *
     * @name toString
     * @memberOf _
     * @category Chain
     * @returns {string} Returns the coerced string value.
     * @example
     *
     * _([1, 2, 3]).toString();
     * // => '1,2,3'
     */
    function wrapperToString() {
      return (this.value() + '');
    }

    /**
     * Executes the chained sequence to extract the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @alias run, toJSON, valueOf
     * @category Chain
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /**
     * Creates an array of elements corresponding to the given keys, or indexes,
     * of `collection`. Keys may be specified as individual arguments or as arrays
     * of keys.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {...(number|number[]|string|string[])} [props] The property names
     *  or indexes of elements to pick, specified individually or in arrays.
     * @returns {Array} Returns the new array of picked elements.
     * @example
     *
     * _.at(['a', 'b', 'c'], [0, 2]);
     * // => ['a', 'c']
     *
     * _.at(['barney', 'fred', 'pebbles'], 0, 2);
     * // => ['barney', 'pebbles']
     */
    var at = restParam(function(collection, props) {
      return baseAt(collection, baseFlatten(props));
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` through `iteratee`. The corresponding value
     * of each key is the number of times the key was returned by `iteratee`.
     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([4.3, 6.1, 6.4], function(n) {
     *   return Math.floor(n);
     * });
     * // => { '4': 1, '6': 2 }
     *
     * _.countBy([4.3, 6.1, 6.4], function(n) {
     *   return this.floor(n);
     * }, Math);
     * // => { '4': 1, '6': 2 }
     *
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      hasOwnProperty.call(result, key) ? ++result[key] : (result[key] = 1);
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * The predicate is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @alias all
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'active': false },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.every(users, 'active', false);
     * // => true
     *
     * // using the `_.property` callback shorthand
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, thisArg) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (thisArg && isIterateeCall(collection, predicate, thisArg)) {
        predicate = null;
      }
      if (typeof predicate != 'function' || thisArg !== undefined) {
        predicate = getCallback(predicate, thisArg, 3);
      }
      return func(collection, predicate);
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is bound to `thisArg` and
     * invoked with three arguments: (value, index|key, collection).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @alias select
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the new filtered array.
     * @example
     *
     * _.filter([4, 5, 6], function(n) {
     *   return n % 2 == 0;
     * });
     * // => [4, 6]
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.filter(users, { 'age': 36, 'active': true }), 'user');
     * // => ['barney']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.filter(users, 'active', false), 'user');
     * // => ['fred']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.filter(users, 'active'), 'user');
     * // => ['barney']
     */
    function filter(collection, predicate, thisArg) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      predicate = getCallback(predicate, thisArg, 3);
      return func(collection, predicate);
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is bound to `thisArg` and
     * invoked with three arguments: (value, index|key, collection).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @alias detect
     * @category Collection
     * @param {Array|Object|string} collection The collection to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.result(_.find(users, function(chr) {
     *   return chr.age < 40;
     * }), 'user');
     * // => 'barney'
     *
     * // using the `_.matches` callback shorthand
     * _.result(_.find(users, { 'age': 1, 'active': true }), 'user');
     * // => 'pebbles'
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.result(_.find(users, 'active', false), 'user');
     * // => 'fred'
     *
     * // using the `_.property` callback shorthand
     * _.result(_.find(users, 'active'), 'user');
     * // => 'barney'
     */
    var find = createFind(baseEach);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(baseEachRight, true);

    /**
     * Performs a deep comparison between each element in `collection` and the
     * source object, returning the first element that has equivalent property
     * values.
     *
     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
     * numbers, `Object` objects, regexes, and strings. Objects are compared by
     * their own, not inherited, enumerable properties. For comparing a single
     * own or inherited property value see `_.matchesProperty`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to search.
     * @param {Object} source The object of property values to match.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.result(_.findWhere(users, { 'age': 36, 'active': true }), 'user');
     * // => 'barney'
     *
     * _.result(_.findWhere(users, { 'age': 40, 'active': false }), 'user');
     * // => 'fred'
     */
    function findWhere(collection, source) {
      return find(collection, baseMatches(source));
    }

    /**
     * Iterates over elements of `collection` invoking `iteratee` for each element.
     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection). Iteratee functions may exit iteration early
     * by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length" property
     * are iterated like arrays. To avoid this behavior `_.forIn` or `_.forOwn`
     * may be used for object iteration.
     *
     * @static
     * @memberOf _
     * @alias each
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array|Object|string} Returns `collection`.
     * @example
     *
     * _([1, 2]).forEach(function(n) {
     *   console.log(n);
     * }).value();
     * // => logs each value from left to right and returns the array
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(n, key) {
     *   console.log(n, key);
     * });
     * // => logs each value-key pair and returns the object (iteration order is not guaranteed)
     */
    var forEach = createForEach(arrayEach, baseEach);

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @alias eachRight
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array|Object|string} Returns `collection`.
     * @example
     *
     * _([1, 2]).forEachRight(function(n) {
     *   console.log(n);
     * }).value();
     * // => logs each value from right to left and returns the array
     */
    var forEachRight = createForEach(arrayEachRight, baseEachRight);

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` through `iteratee`. The corresponding value
     * of each key is an array of the elements responsible for generating the key.
     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([4.2, 6.1, 6.4], function(n) {
     *   return Math.floor(n);
     * });
     * // => { '4': [4.2], '6': [6.1, 6.4] }
     *
     * _.groupBy([4.2, 6.1, 6.4], function(n) {
     *   return this.floor(n);
     * }, Math);
     * // => { '4': [4.2], '6': [6.1, 6.4] }
     *
     * // using the `_.property` callback shorthand
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        result[key] = [value];
      }
    });

    /**
     * Checks if `value` is in `collection` using
     * [`SameValueZero`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it is used as the offset
     * from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @alias contains, include
     * @category Collection
     * @param {Array|Object|string} collection The collection to search.
     * @param {*} target The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.reduce`.
     * @returns {boolean} Returns `true` if a matching element is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'user': 'fred', 'age': 40 }, 'fred');
     * // => true
     *
     * _.includes('pebbles', 'eb');
     * // => true
     */
    function includes(collection, target, fromIndex, guard) {
      var length = collection ? getLength(collection) : 0;
      if (!isLength(length)) {
        collection = values(collection);
        length = collection.length;
      }
      if (!length) {
        return false;
      }
      if (typeof fromIndex != 'number' || (guard && isIterateeCall(target, fromIndex, guard))) {
        fromIndex = 0;
      } else {
        fromIndex = fromIndex < 0 ? nativeMax(length + fromIndex, 0) : (fromIndex || 0);
      }
      return (typeof collection == 'string' || !isArray(collection) && isString(collection))
        ? (fromIndex < length && collection.indexOf(target, fromIndex) > -1)
        : (getIndexOf(collection, target, fromIndex) > -1);
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` through `iteratee`. The corresponding value
     * of each key is the last element responsible for generating the key. The
     * iteratee function is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var keyData = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.indexBy(keyData, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     *
     * _.indexBy(keyData, function(object) {
     *   return String.fromCharCode(object.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.indexBy(keyData, function(object) {
     *   return this.fromCharCode(object.code);
     * }, String);
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     */
    var indexBy = createAggregator(function(result, value, key) {
      result[key] = value;
    });

    /**
     * Invokes the method at `path` on each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `methodName` is a function it is
     * invoked for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invoke([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invoke([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invoke = restParam(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          isProp = isKey(path),
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        var func = isFunc ? path : (isProp && value != null && value[path]);
        result[++index] = func ? func.apply(value, args) : invokePath(value, path, args);
      });
      return result;
    });

    /**
     * Creates an array of values by running each element in `collection` through
     * `iteratee`. The `iteratee` is bound to `thisArg` and invoked with three
     * arguments: (value, index|key, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * Many lodash methods are guarded to work as interatees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `callback`, `chunk`, `clone`, `create`, `curry`, `curryRight`,
     * `drop`, `dropRight`, `every`, `fill`, `flatten`, `invert`, `max`, `min`,
     * `parseInt`, `slice`, `sortBy`, `take`, `takeRight`, `template`, `trim`,
     * `trimLeft`, `trimRight`, `trunc`, `random`, `range`, `sample`, `some`,
     * `sum`, `uniq`, and `words`
     *
     * @static
     * @memberOf _
     * @alias collect
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function timesThree(n) {
     *   return n * 3;
     * }
     *
     * _.map([1, 2], timesThree);
     * // => [3, 6]
     *
     * _.map({ 'a': 1, 'b': 2 }, timesThree);
     * // => [3, 6] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // using the `_.property` callback shorthand
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee, thisArg) {
      var func = isArray(collection) ? arrayMap : baseMap;
      iteratee = getCallback(iteratee, thisArg, 3);
      return func(collection, iteratee);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, while the second of which
     * contains elements `predicate` returns falsey for. The predicate is bound
     * to `thisArg` and invoked with three arguments: (value, index|key, collection).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * _.partition([1, 2, 3], function(n) {
     *   return n % 2;
     * });
     * // => [[1, 3], [2]]
     *
     * _.partition([1.2, 2.3, 3.4], function(n) {
     *   return this.floor(n) % 2;
     * }, Math);
     * // => [[1.2, 3.4], [2.3]]
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * var mapper = function(array) {
     *   return _.pluck(array, 'user');
     * };
     *
     * // using the `_.matches` callback shorthand
     * _.map(_.partition(users, { 'age': 1, 'active': false }), mapper);
     * // => [['pebbles'], ['barney', 'fred']]
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.map(_.partition(users, 'active', false), mapper);
     * // => [['barney', 'pebbles'], ['fred']]
     *
     * // using the `_.property` callback shorthand
     * _.map(_.partition(users, 'active'), mapper);
     * // => [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Gets the property value of `path` from all elements in `collection`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Array|string} path The path of the property to pluck.
     * @returns {Array} Returns the property values.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * _.pluck(users, 'user');
     * // => ['barney', 'fred']
     *
     * var userIndex = _.indexBy(users, 'user');
     * _.pluck(userIndex, 'age');
     * // => [36, 40] (iteration order is not guaranteed)
     */
    function pluck(collection, path) {
      return map(collection, property(path));
    }

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` through `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not provided the first element of `collection` is used as the initial
     * value. The `iteratee` is bound to `thisArg` and invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as interatees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `includes`, `merge`, `sortByAll`, and `sortByOrder`
     *
     * @static
     * @memberOf _
     * @alias foldl, inject
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.reduce([1, 2], function(total, n) {
     *   return total + n;
     * });
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2 }, function(result, n, key) {
     *   result[key] = n * 3;
     *   return result;
     * }, {});
     * // => { 'a': 3, 'b': 6 } (iteration order is not guaranteed)
     */
    var reduce = createReduce(arrayReduce, baseEach);

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @alias foldr
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    var reduceRight = createReduce(arrayReduceRight, baseEachRight);

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the new filtered array.
     * @example
     *
     * _.reject([1, 2, 3, 4], function(n) {
     *   return n % 2 == 0;
     * });
     * // => [1, 3]
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.reject(users, { 'age': 40, 'active': true }), 'user');
     * // => ['barney']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.reject(users, 'active', false), 'user');
     * // => ['fred']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.reject(users, 'active'), 'user');
     * // => ['barney']
     */
    function reject(collection, predicate, thisArg) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      predicate = getCallback(predicate, thisArg, 3);
      return func(collection, function(value, index, collection) {
        return !predicate(value, index, collection);
      });
    }

    /**
     * Gets a random element or `n` random elements from a collection.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to sample.
     * @param {number} [n] The number of elements to sample.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {*} Returns the random sample(s).
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     *
     * _.sample([1, 2, 3, 4], 2);
     * // => [3, 1]
     */
    function sample(collection, n, guard) {
      if (guard ? isIterateeCall(collection, n, guard) : n == null) {
        collection = toIterable(collection);
        var length = collection.length;
        return length > 0 ? collection[baseRandom(0, length - 1)] : undefined;
      }
      var result = shuffle(collection);
      result.length = nativeMin(n < 0 ? 0 : (+n || 0), result.length);
      return result;
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      collection = toIterable(collection);

      var index = -1,
          length = collection.length,
          result = Array(length);

      while (++index < length) {
        var rand = baseRandom(0, index);
        if (index != rand) {
          result[index] = result[rand];
        }
        result[rand] = collection[index];
      }
      return result;
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable properties for objects.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the size of `collection`.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      var length = collection ? getLength(collection) : 0;
      return isLength(length) ? length : keys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * The function returns as soon as it finds a passing value and does not iterate
     * over the entire collection. The predicate is bound to `thisArg` and invoked
     * with three arguments: (value, index|key, collection).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @alias any
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.some(users, 'active', false);
     * // => true
     *
     * // using the `_.property` callback shorthand
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, thisArg) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (thisArg && isIterateeCall(collection, predicate, thisArg)) {
        predicate = null;
      }
      if (typeof predicate != 'function' || thisArg !== undefined) {
        predicate = getCallback(predicate, thisArg, 3);
      }
      return func(collection, predicate);
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection through `iteratee`. This method performs
     * a stable sort, that is, it preserves the original sort order of equal elements.
     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * _.sortBy([1, 2, 3], function(n) {
     *   return Math.sin(n);
     * });
     * // => [3, 1, 2]
     *
     * _.sortBy([1, 2, 3], function(n) {
     *   return this.sin(n);
     * }, Math);
     * // => [3, 1, 2]
     *
     * var users = [
     *   { 'user': 'fred' },
     *   { 'user': 'pebbles' },
     *   { 'user': 'barney' }
     * ];
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.sortBy(users, 'user'), 'user');
     * // => ['barney', 'fred', 'pebbles']
     */
    function sortBy(collection, iteratee, thisArg) {
      if (collection == null) {
        return [];
      }
      if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
        iteratee = null;
      }
      var index = -1;
      iteratee = getCallback(iteratee, thisArg, 3);

      var result = baseMap(collection, function(value, key, collection) {
        return { 'criteria': iteratee(value, key, collection), 'index': ++index, 'value': value };
      });
      return baseSortBy(result, compareAscending);
    }

    /**
     * This method is like `_.sortBy` except that it can sort by multiple iteratees
     * or property names.
     *
     * If a property name is provided for an iteratee the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If an object is provided for an iteratee the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {...(Function|Function[]|Object|Object[]|string|string[])} iteratees
     *  The iteratees to sort by, specified as individual values or arrays of values.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 42 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.map(_.sortByAll(users, ['user', 'age']), _.values);
     * // => [['barney', 34], ['barney', 36], ['fred', 42], ['fred', 48]]
     *
     * _.map(_.sortByAll(users, 'user', function(chr) {
     *   return Math.floor(chr.age / 10);
     * }), _.values);
     * // => [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 42]]
     */
    var sortByAll = restParam(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var guard = iteratees[2];
      if (guard && isIterateeCall(iteratees[0], iteratees[1], guard)) {
        iteratees.length = 1;
      }
      return baseSortByOrder(collection, baseFlatten(iteratees), []);
    });

    /**
     * This method is like `_.sortByAll` except that it allows specifying the
     * sort orders of the iteratees to sort by. A truthy value in `orders` will
     * sort the corresponding property name in ascending order while a falsey
     * value will sort it in descending order.
     *
     * If a property name is provided for an iteratee the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If an object is provided for an iteratee the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {boolean[]} orders The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 42 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // sort by `user` in ascending order and by `age` in descending order
     * _.map(_.sortByOrder(users, ['user', 'age'], [true, false]), _.values);
     * // => [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 42]]
     */
    function sortByOrder(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (guard && isIterateeCall(iteratees, orders, guard)) {
        orders = null;
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseSortByOrder(collection, iteratees, orders);
    }

    /**
     * Performs a deep comparison between each element in `collection` and the
     * source object, returning an array of all elements that have equivalent
     * property values.
     *
     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
     * numbers, `Object` objects, regexes, and strings. Objects are compared by
     * their own, not inherited, enumerable properties. For comparing a single
     * own or inherited property value see `_.matchesProperty`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to search.
     * @param {Object} source The object of property values to match.
     * @returns {Array} Returns the new filtered array.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false, 'pets': ['hoppy'] },
     *   { 'user': 'fred',   'age': 40, 'active': true, 'pets': ['baby puss', 'dino'] }
     * ];
     *
     * _.pluck(_.where(users, { 'age': 36, 'active': false }), 'user');
     * // => ['barney']
     *
     * _.pluck(_.where(users, { 'pets': ['dino'] }), 'user');
     * // => ['fred']
     */
    function where(collection, source) {
      return filter(collection, baseMatches(source));
    }

    /**
     * Gets the number of milliseconds that have elapsed since the Unix epoch
     * (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @category Date
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => logs the number of milliseconds it took for the deferred function to be invoked
     */
    var now = nativeNow || function() {
      return new Date().getTime();
    };

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it is called `n` or more times.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => logs 'done saving!' after the two async saves have completed
     */
    function after(n, func) {
      if (typeof func != 'function') {
        if (typeof n == 'function') {
          var temp = n;
          n = func;
          func = temp;
        } else {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
      }
      n = nativeIsFinite(n = +n) ? n : 0;
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that accepts up to `n` arguments ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Function} Returns the new function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      if (guard && isIterateeCall(func, n, guard)) {
        n = null;
      }
      n = (func && n == null) ? func.length : nativeMax(+n || 0, 0);
      return createWrapper(func, ARY_FLAG, null, null, null, null, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it is called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery('#add').on('click', _.before(5, addContactToList));
     * // => allows adding up to 4 contacts to the list
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        if (typeof n == 'function') {
          var temp = n;
          n = func;
          func = temp;
        } else {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
      }
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = null;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and prepends any additional `_.bind` arguments to those provided to the
     * bound function.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind` this method does not set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var greet = function(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * };
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // using placeholders
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = restParam(function(func, thisArg, partials) {
      var bitmask = BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, bind.placeholder);
        bitmask |= PARTIAL_FLAG;
      }
      return createWrapper(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method. Method names may be specified as individual arguments or as arrays
     * of method names. If no method names are provided all enumerable function
     * properties, own and inherited, of `object` are bound.
     *
     * **Note:** This method does not set the "length" property of bound functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} [methodNames] The object method names to bind,
     *  specified as individual method names or arrays of method names.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'onClick': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view);
     * jQuery('#docs').on('click', view.onClick);
     * // => logs 'clicked docs' when the element is clicked
     */
    var bindAll = restParam(function(object, methodNames) {
      methodNames = methodNames.length ? baseFlatten(methodNames) : functions(object);

      var index = -1,
          length = methodNames.length;

      while (++index < length) {
        var key = methodNames[index];
        object[key] = createWrapper(object[key], BIND_FLAG, object);
      }
      return object;
    });

    /**
     * Creates a function that invokes the method at `object[key]` and prepends
     * any additional `_.bindKey` arguments to those provided to the bound function.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist.
     * See [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Object} object The object the method belongs to.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // using placeholders
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = restParam(function(object, key, partials) {
      var bitmask = BIND_FLAG | BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, bindKey.placeholder);
        bitmask |= PARTIAL_FLAG;
      }
      return createWrapper(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts one or more arguments of `func` that when
     * called either invokes `func` returning its result, if all `func` arguments
     * have been provided, or returns a function that accepts one or more of the
     * remaining `func` arguments, and so on. The arity of `func` may be specified
     * if `func.length` is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method does not set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // using placeholders
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    var curry = createCurry(CURRY_FLAG);

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method does not set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // using placeholders
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    var curryRight = createCurry(CURRY_RIGHT_FLAG);

    /**
     * Creates a function that delays invoking `func` until after `wait` milliseconds
     * have elapsed since the last time it was invoked. The created function comes
     * with a `cancel` method to cancel delayed invocations. Provide an options
     * object to indicate that `func` should be invoked on the leading and/or
     * trailing edge of the `wait` timeout. Subsequent calls to the debounced
     * function return the result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
     * on the trailing edge of the timeout only if the the debounced function is
     * invoked more than once during the `wait` timeout.
     *
     * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options] The options object.
     * @param {boolean} [options.leading=false] Specify invoking on the leading
     *  edge of the timeout.
     * @param {number} [options.maxWait] The maximum time `func` is allowed to be
     *  delayed before it is invoked.
     * @param {boolean} [options.trailing=true] Specify invoking on the trailing
     *  edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // avoid costly calculations while the window size is in flux
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // invoke `sendMail` when the click event is fired, debouncing subsequent calls
     * jQuery('#postbox').on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // ensure `batchLog` is invoked once after 1 second of debounced calls
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', _.debounce(batchLog, 250, {
     *   'maxWait': 1000
     * }));
     *
     * // cancel a debounced call
     * var todoChanges = _.debounce(batchLog, 1000);
     * Object.observe(models.todo, todoChanges);
     *
     * Object.observe(models, function(changes) {
     *   if (_.find(changes, { 'user': 'todo', 'type': 'delete'})) {
     *     todoChanges.cancel();
     *   }
     * }, ['delete']);
     *
     * // ...at some point `models.todo` is changed
     * models.todo.completed = true;
     *
     * // ...before 1 second has passed `models.todo` is deleted
     * // which cancels the debounced `todoChanges` call
     * delete models.todo;
     */
    function debounce(func, wait, options) {
      var args,
          maxTimeoutId,
          result,
          stamp,
          thisArg,
          timeoutId,
          trailingCall,
          lastCalled = 0,
          maxWait = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = wait < 0 ? 0 : (+wait || 0);
      if (options === true) {
        var leading = true;
        trailing = false;
      } else if (isObject(options)) {
        leading = options.leading;
        maxWait = 'maxWait' in options && nativeMax(+options.maxWait || 0, wait);
        trailing = 'trailing' in options ? options.trailing : trailing;
      }

      function cancel() {
        if (timeoutId) {
          clearTimeout(timeoutId);
        }
        if (maxTimeoutId) {
          clearTimeout(maxTimeoutId);
        }
        maxTimeoutId = timeoutId = trailingCall = undefined;
      }

      function delayed() {
        var remaining = wait - (now() - stamp);
        if (remaining <= 0 || remaining > wait) {
          if (maxTimeoutId) {
            clearTimeout(maxTimeoutId);
          }
          var isCalled = trailingCall;
          maxTimeoutId = timeoutId = trailingCall = undefined;
          if (isCalled) {
            lastCalled = now();
            result = func.apply(thisArg, args);
            if (!timeoutId && !maxTimeoutId) {
              args = thisArg = null;
            }
          }
        } else {
          timeoutId = setTimeout(delayed, remaining);
        }
      }

      function maxDelayed() {
        if (timeoutId) {
          clearTimeout(timeoutId);
        }
        maxTimeoutId = timeoutId = trailingCall = undefined;
        if (trailing || (maxWait !== wait)) {
          lastCalled = now();
          result = func.apply(thisArg, args);
          if (!timeoutId && !maxTimeoutId) {
            args = thisArg = null;
          }
        }
      }

      function debounced() {
        args = arguments;
        stamp = now();
        thisArg = this;
        trailingCall = trailing && (timeoutId || !leading);

        if (maxWait === false) {
          var leadingCall = leading && !timeoutId;
        } else {
          if (!maxTimeoutId && !leading) {
            lastCalled = stamp;
          }
          var remaining = maxWait - (stamp - lastCalled),
              isCalled = remaining <= 0 || remaining > maxWait;

          if (isCalled) {
            if (maxTimeoutId) {
              maxTimeoutId = clearTimeout(maxTimeoutId);
            }
            lastCalled = stamp;
            result = func.apply(thisArg, args);
          }
          else if (!maxTimeoutId) {
            maxTimeoutId = setTimeout(maxDelayed, remaining);
          }
        }
        if (isCalled && timeoutId) {
          timeoutId = clearTimeout(timeoutId);
        }
        else if (!timeoutId && wait !== maxWait) {
          timeoutId = setTimeout(delayed, wait);
        }
        if (leadingCall) {
          isCalled = true;
          result = func.apply(thisArg, args);
        }
        if (isCalled && !timeoutId && !maxTimeoutId) {
          args = thisArg = null;
        }
        return result;
      }
      debounced.cancel = cancel;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it is invoked.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke the function with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // logs 'deferred' after one or more milliseconds
     */
    var defer = restParam(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it is invoked.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke the function with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => logs 'later' after one second
     */
    var delay = restParam(function(func, wait, args) {
      return baseDelay(func, wait, args);
    });

    /**
     * Creates a function that returns the result of invoking the provided
     * functions with the `this` binding of the created function, where each
     * successive invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {...Function} [funcs] Functions to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow(_.add, square);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the provided functions from right to left.
     *
     * @static
     * @memberOf _
     * @alias backflow, compose
     * @category Function
     * @param {...Function} [funcs] Functions to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight(square, _.add);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is coerced to a string and used as the
     * cache key. The `func` is invoked with the `this` binding of the memoized
     * function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the [`Map`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-properties-of-the-map-prototype-object)
     * method interface of `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoizing function.
     * @example
     *
     * var upperCase = _.memoize(function(string) {
     *   return string.toUpperCase();
     * });
     *
     * upperCase('fred');
     * // => 'FRED'
     *
     * // modifying the result cache
     * upperCase.cache.set('fred', 'BARNEY');
     * upperCase('fred');
     * // => 'BARNEY'
     *
     * // replacing `_.memoize.Cache`
     * var object = { 'user': 'fred' };
     * var other = { 'user': 'barney' };
     * var identity = _.memoize(_.identity);
     *
     * identity(object);
     * // => { 'user': 'fred' }
     * identity(other);
     * // => { 'user': 'fred' }
     *
     * _.memoize.Cache = WeakMap;
     * var identity = _.memoize(_.identity);
     *
     * identity(object);
     * // => { 'user': 'fred' }
     * identity(other);
     * // => { 'user': 'barney' }
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            cache = memoized.cache,
            key = resolver ? resolver.apply(this, args) : args[0];

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        cache.set(key, result);
        return result;
      };
      memoized.cache = new memoize.Cache;
      return memoized;
    }

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        return !predicate.apply(this, arguments);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first call. The `func` is invoked
     * with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // `initialize` invokes `createApplication` once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with `partial` arguments prepended
     * to those provided to the new function. This method is like `_.bind` except
     * it does **not** alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method does not set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * var greet = function(greeting, name) {
     *   return greeting + ' ' + name;
     * };
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // using placeholders
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = createPartial(PARTIAL_FLAG);

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to those provided to the new function.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method does not set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * var greet = function(greeting, name) {
     *   return greeting + ' ' + name;
     * };
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // using placeholders
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = createPartial(PARTIAL_RIGHT_FLAG);

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified indexes where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes,
     *  specified as individual indexes or arrays of indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, 2, 0, 1);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     *
     * var map = _.rearg(_.map, [1, 0]);
     * map(function(n) {
     *   return n * 3;
     * }, [1, 2, 3]);
     * // => [3, 6, 9]
     */
    var rearg = restParam(function(func, indexes) {
      return createWrapper(func, REARG_FLAG, null, null, null, baseFlatten(indexes));
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as an array.
     *
     * **Note:** This method is based on the [rest parameter](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/rest_parameters).
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.restParam(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function restParam(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = nativeMax(start === undefined ? (func.length - 1) : (+start || 0), 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            rest = Array(length);

        while (++index < length) {
          rest[index] = args[start + index];
        }
        switch (start) {
          case 0: return func.call(this, rest);
          case 1: return func.call(this, args[0], rest);
          case 2: return func.call(this, args[0], args[1], rest);
        }
        var otherArgs = Array(start + 1);
        index = -1;
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = rest;
        return func.apply(this, otherArgs);
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the created
     * function and an array of arguments much like [`Function#apply`](https://es5.github.io/#x15.3.4.3).
     *
     * **Note:** This method is based on the [spread operator](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Spread_operator).
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * // with a Promise
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function(array) {
        return func.apply(this, array);
      };
    }

    /**
     * Creates a function that only invokes `func` at most once per every `wait`
     * milliseconds. The created function comes with a `cancel` method to cancel
     * delayed invocations. Provide an options object to indicate that `func`
     * should be invoked on the leading and/or trailing edge of the `wait` timeout.
     * Subsequent calls to the throttled function return the result of the last
     * `func` call.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
     * on the trailing edge of the timeout only if the the throttled function is
     * invoked more than once during the `wait` timeout.
     *
     * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options] The options object.
     * @param {boolean} [options.leading=true] Specify invoking on the leading
     *  edge of the timeout.
     * @param {boolean} [options.trailing=true] Specify invoking on the trailing
     *  edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // avoid excessively updating the position while scrolling
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // invoke `renewToken` when the click event is fired, but not more than once every 5 minutes
     * jQuery('.interactive').on('click', _.throttle(renewToken, 300000, {
     *   'trailing': false
     * }));
     *
     * // cancel a trailing throttled call
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (options === false) {
        leading = false;
      } else if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      debounceOptions.leading = leading;
      debounceOptions.maxWait = +wait;
      debounceOptions.trailing = trailing;
      return debounce(func, wait, debounceOptions);
    }

    /**
     * Creates a function that provides `value` to the wrapper function as its
     * first argument. Any additional arguments provided to the function are
     * appended to those provided to the wrapper function. The wrapper is invoked
     * with the `this` binding of the created function.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} wrapper The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      wrapper = wrapper == null ? identity : wrapper;
      return createWrapper(wrapper, PARTIAL_FLAG, null, [value], []);
    }

    /**
     * Creates a clone of `value`. If `isDeep` is `true` nested objects are cloned,
     * otherwise they are assigned by reference. If `customizer` is provided it is
     * invoked to produce the cloned values. If `customizer` returns `undefined`
     * cloning is handled by the method instead. The `customizer` is bound to
     * `thisArg` and invoked with two argument; (value [, index|key, object]).
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](http://www.w3.org/TR/html5/infrastructure.html#internal-structured-cloning-algorithm).
     * The enumerable properties of `arguments` objects and objects created by
     * constructors other than `Object` are cloned to plain `Object` objects. An
     * empty object is returned for uncloneable values such as functions, DOM nodes,
     * Maps, Sets, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @param {Function} [customizer] The function to customize cloning values.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {*} Returns the cloned value.
     * @example
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * var shallow = _.clone(users);
     * shallow[0] === users[0];
     * // => true
     *
     * var deep = _.clone(users, true);
     * deep[0] === users[0];
     * // => false
     *
     * // using a customizer callback
     * var el = _.clone(document.body, function(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * });
     *
     * el === document.body
     * // => false
     * el.nodeName
     * // => BODY
     * el.childNodes.length;
     * // => 0
     */
    function clone(value, isDeep, customizer, thisArg) {
      if (isDeep && typeof isDeep != 'boolean' && isIterateeCall(value, isDeep, customizer)) {
        isDeep = false;
      }
      else if (typeof isDeep == 'function') {
        thisArg = customizer;
        customizer = isDeep;
        isDeep = false;
      }
      customizer = typeof customizer == 'function' && bindCallback(customizer, thisArg, 1);
      return baseClone(value, isDeep, customizer);
    }

    /**
     * Creates a deep clone of `value`. If `customizer` is provided it is invoked
     * to produce the cloned values. If `customizer` returns `undefined` cloning
     * is handled by the method instead. The `customizer` is bound to `thisArg`
     * and invoked with two argument; (value [, index|key, object]).
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](http://www.w3.org/TR/html5/infrastructure.html#internal-structured-cloning-algorithm).
     * The enumerable properties of `arguments` objects and objects created by
     * constructors other than `Object` are cloned to plain `Object` objects. An
     * empty object is returned for uncloneable values such as functions, DOM nodes,
     * Maps, Sets, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to deep clone.
     * @param {Function} [customizer] The function to customize cloning values.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {*} Returns the deep cloned value.
     * @example
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * var deep = _.cloneDeep(users);
     * deep[0] === users[0];
     * // => false
     *
     * // using a customizer callback
     * var el = _.cloneDeep(document.body, function(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * });
     *
     * el === document.body
     * // => false
     * el.nodeName
     * // => BODY
     * el.childNodes.length;
     * // => 20
     */
    function cloneDeep(value, customizer, thisArg) {
      customizer = typeof customizer == 'function' && bindCallback(customizer, thisArg, 1);
      return baseClone(value, true, customizer);
    }

    /**
     * Checks if `value` is classified as an `arguments` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    function isArguments(value) {
      return isObjectLike(value) && isArrayLike(value) && objToString.call(value) == argsTag;
    }

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(function() { return arguments; }());
     * // => false
     */
    var isArray = nativeIsArray || function(value) {
      return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
    };

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false || (isObjectLike(value) && objToString.call(value) == boolTag);
    }

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    function isDate(value) {
      return isObjectLike(value) && objToString.call(value) == dateTag;
    }

    /**
     * Checks if `value` is a DOM element.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return !!value && value.nodeType === 1 && isObjectLike(value) &&
        (objToString.call(value).indexOf('Element') > -1);
    }
    // Fallback for environments without DOM support.
    if (!support.dom) {
      isElement = function(value) {
        return !!value && value.nodeType === 1 && isObjectLike(value) && !isPlainObject(value);
      };
    }

    /**
     * Checks if `value` is empty. A value is considered empty unless it is an
     * `arguments` object, array, string, or jQuery-like collection with a length
     * greater than `0` or an object with own enumerable properties.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {Array|Object|string} value The value to inspect.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) && (isArray(value) || isString(value) || isArguments(value) ||
          (isObjectLike(value) && isFunction(value.splice)))) {
        return !value.length;
      }
      return !keys(value).length;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent. If `customizer` is provided it is invoked to compare values.
     * If `customizer` returns `undefined` comparisons are handled by the method
     * instead. The `customizer` is bound to `thisArg` and invoked with three
     * arguments: (value, other [, index|key]).
     *
     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
     * numbers, `Object` objects, regexes, and strings. Objects are compared by
     * their own, not inherited, enumerable properties. Functions and DOM nodes
     * are **not** supported. Provide a customizer function to extend support
     * for comparing other values.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize value comparisons.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'user': 'fred' };
     * var other = { 'user': 'fred' };
     *
     * object == other;
     * // => false
     *
     * _.isEqual(object, other);
     * // => true
     *
     * // using a customizer callback
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqual(array, other, function(value, other) {
     *   if (_.every([value, other], RegExp.prototype.test, /^h(?:i|ello)$/)) {
     *     return true;
     *   }
     * });
     * // => true
     */
    function isEqual(value, other, customizer, thisArg) {
      customizer = typeof customizer == 'function' && bindCallback(customizer, thisArg, 3);
      if (!customizer && isStrictComparable(value) && isStrictComparable(other)) {
        return value === other;
      }
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      return isObjectLike(value) && typeof value.message == 'string' && objToString.call(value) == errorTag;
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on [`Number.isFinite`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-number.isfinite).
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(10);
     * // => true
     *
     * _.isFinite('10');
     * // => false
     *
     * _.isFinite(true);
     * // => false
     *
     * _.isFinite(Object(10));
     * // => false
     *
     * _.isFinite(Infinity);
     * // => false
     */
    var isFinite = nativeNumIsFinite || function(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    };

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    var isFunction = !(baseIsFunction(/x/) || (Uint8Array && !baseIsFunction(Uint8Array))) ? baseIsFunction : function(value) {
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in older versions of Chrome and Safari which return 'function' for regexes
      // and Safari 8 equivalents which return 'object' for typed array constructors.
      return objToString.call(value) == funcTag;
    };

    /**
     * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
     * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(1);
     * // => false
     */
    function isObject(value) {
      // Avoid a V8 JIT bug in Chrome 19-20.
      // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
      var type = typeof value;
      return type == 'function' || (!!value && type == 'object');
    }

    /**
     * Performs a deep comparison between `object` and `source` to determine if
     * `object` contains equivalent property values. If `customizer` is provided
     * it is invoked to compare values. If `customizer` returns `undefined`
     * comparisons are handled by the method instead. The `customizer` is bound
     * to `thisArg` and invoked with three arguments: (value, other, index|key).
     *
     * **Note:** This method supports comparing properties of arrays, booleans,
     * `Date` objects, numbers, `Object` objects, regexes, and strings. Functions
     * and DOM nodes are **not** supported. Provide a customizer function to extend
     * support for comparing other values.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize value comparisons.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'user': 'fred', 'age': 40 };
     *
     * _.isMatch(object, { 'age': 40 });
     * // => true
     *
     * _.isMatch(object, { 'age': 36 });
     * // => false
     *
     * // using a customizer callback
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatch(object, source, function(value, other) {
     *   return _.every([value, other], RegExp.prototype.test, /^h(?:i|ello)$/) || undefined;
     * });
     * // => true
     */
    function isMatch(object, source, customizer, thisArg) {
      var props = keys(source),
          length = props.length;

      if (!length) {
        return true;
      }
      if (object == null) {
        return false;
      }
      customizer = typeof customizer == 'function' && bindCallback(customizer, thisArg, 3);
      object = toObject(object);
      if (!customizer && length == 1) {
        var key = props[0],
            value = source[key];

        if (isStrictComparable(value)) {
          return value === object[key] && (value !== undefined || (key in object));
        }
      }
      var values = Array(length),
          strictCompareFlags = Array(length);

      while (length--) {
        value = values[length] = source[props[length]];
        strictCompareFlags[length] = isStrictComparable(value);
      }
      return baseIsMatch(object, props, values, strictCompareFlags, customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is not the same as [`isNaN`](https://es5.github.io/#x15.1.2.4)
     * which returns `true` for `undefined` and other non-numeric values.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some host objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a native function.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (value == null) {
        return false;
      }
      if (objToString.call(value) == funcTag) {
        return reIsNative.test(fnToString.call(value));
      }
      return isObjectLike(value) && reIsHostCtor.test(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are classified
     * as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isNumber(8.4);
     * // => true
     *
     * _.isNumber(NaN);
     * // => true
     *
     * _.isNumber('8.4');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' || (isObjectLike(value) && objToString.call(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * **Note:** This method assumes objects created by the `Object` constructor
     * have no inherited enumerable properties.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    var isPlainObject = !getPrototypeOf ? shimIsPlainObject : function(value) {
      if (!(value && objToString.call(value) == objectTag)) {
        return false;
      }
      var valueOf = value.valueOf,
          objProto = isNative(valueOf) && (objProto = getPrototypeOf(valueOf)) && getPrototypeOf(objProto);

      return objProto
        ? (value == objProto || getPrototypeOf(value) == objProto)
        : shimIsPlainObject(value);
    };

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    function isRegExp(value) {
      return isObjectLike(value) && objToString.call(value) == regexpTag;
    }

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' || (isObjectLike(value) && objToString.call(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    function isTypedArray(value) {
      return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objToString.call(value)];
    }

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Converts `value` to an array.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * (function() {
     *   return _.toArray(arguments).slice(1);
     * }(1, 2, 3));
     * // => [2, 3]
     */
    function toArray(value) {
      var length = value ? getLength(value) : 0;
      if (!isLength(length)) {
        return values(value);
      }
      if (!length) {
        return [];
      }
      return arrayCopy(value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable
     * properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return baseCopy(value, keysIn(value));
    }

    /**
     * Assigns own enumerable properties of source object(s) to the destination
     * object. Subsequent sources overwrite property assignments of previous sources.
     * If `customizer` is provided it is invoked to produce the assigned values.
     * The `customizer` is bound to `thisArg` and invoked with five arguments:
     * (objectValue, sourceValue, key, object, source).
     *
     * **Note:** This method mutates `object` and is based on
     * [`Object.assign`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-object.assign).
     *
     * @static
     * @memberOf _
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * _.assign({ 'user': 'barney' }, { 'age': 40 }, { 'user': 'fred' });
     * // => { 'user': 'fred', 'age': 40 }
     *
     * // using a customizer callback
     * var defaults = _.partialRight(_.assign, function(value, other) {
     *   return _.isUndefined(value) ? other : value;
     * });
     *
     * defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
     * // => { 'user': 'barney', 'age': 36 }
     */
    var assign = createAssigner(function(object, source, customizer) {
      return customizer
        ? assignWith(object, source, customizer)
        : baseAssign(object, source);
    });

    /**
     * Creates an object that inherits from the given `prototype` object. If a
     * `properties` object is provided its own enumerable properties are assigned
     * to the created object.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties, guard) {
      var result = baseCreate(prototype);
      if (guard && isIterateeCall(prototype, properties, guard)) {
        properties = null;
      }
      return properties ? baseAssign(result, properties) : result;
    }

    /**
     * Assigns own enumerable properties of source object(s) to the destination
     * object for all destination properties that resolve to `undefined`. Once a
     * property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * _.defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
     * // => { 'user': 'barney', 'age': 36 }
     */
    var defaults = restParam(function(args) {
      var object = args[0];
      if (object == null) {
        return object;
      }
      args.push(assignDefaults);
      return assign.apply(undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {string|undefined} Returns the key of the matched element, else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(chr) {
     *   return chr.age < 40;
     * });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // using the `_.matches` callback shorthand
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.findKey(users, 'active', false);
     * // => 'fred'
     *
     * // using the `_.property` callback shorthand
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    var findKey = createFindKey(baseForOwn);

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {string|undefined} Returns the key of the matched element, else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(chr) {
     *   return chr.age < 40;
     * });
     * // => returns `pebbles` assuming `_.findKey` returns `barney`
     *
     * // using the `_.matches` callback shorthand
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.findLastKey(users, 'active', false);
     * // => 'fred'
     *
     * // using the `_.property` callback shorthand
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    var findLastKey = createFindKey(baseForOwnRight);

    /**
     * Iterates over own and inherited enumerable properties of an object invoking
     * `iteratee` for each property. The `iteratee` is bound to `thisArg` and invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => logs 'a', 'b', and 'c' (iteration order is not guaranteed)
     */
    var forIn = createForIn(baseFor);

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => logs 'c', 'b', and 'a' assuming `_.forIn ` logs 'a', 'b', and 'c'
     */
    var forInRight = createForIn(baseForRight);

    /**
     * Iterates over own enumerable properties of an object invoking `iteratee`
     * for each property. The `iteratee` is bound to `thisArg` and invoked with
     * three arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => logs 'a' and 'b' (iteration order is not guaranteed)
     */
    var forOwn = createForOwn(baseForOwn);

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => logs 'b' and 'a' assuming `_.forOwn` logs 'a' and 'b'
     */
    var forOwnRight = createForOwn(baseForOwnRight);

    /**
     * Creates an array of function property names from all enumerable properties,
     * own and inherited, of `object`.
     *
     * @static
     * @memberOf _
     * @alias methods
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the new array of property names.
     * @example
     *
     * _.functions(_);
     * // => ['after', 'ary', 'assign', ...]
     */
    function functions(object) {
      return baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the property value of `path` on `object`. If the resolved value is
     * `undefined` the `defaultValue` is used in its place.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned if the resolved value is `undefined`.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, toPath(path), path + '');
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` is a direct property, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': { 'c': 3 } } };
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b.c');
     * // => true
     *
     * _.has(object, ['a', 'b', 'c']);
     * // => true
     */
    function has(object, path) {
      if (object == null) {
        return false;
      }
      var result = hasOwnProperty.call(object, path);
      if (!result && !isKey(path)) {
        path = toPath(path);
        object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
        path = last(path);
        result = object != null && hasOwnProperty.call(object, path);
      }
      return result;
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite property
     * assignments of previous values unless `multiValue` is `true`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to invert.
     * @param {boolean} [multiValue] Allow multiple values per key.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     *
     * // with `multiValue`
     * _.invert(object, true);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function invert(object, multiValue, guard) {
      if (guard && isIterateeCall(object, multiValue, guard)) {
        multiValue = null;
      }
      var index = -1,
          props = keys(object),
          length = props.length,
          result = {};

      while (++index < length) {
        var key = props[index],
            value = object[key];

        if (multiValue) {
          if (hasOwnProperty.call(result, value)) {
            result[value].push(key);
          } else {
            result[value] = [key];
          }
        }
        else {
          result[value] = key;
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-object.keys)
     * for more details.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    var keys = !nativeKeys ? shimKeys : function(object) {
      var Ctor = object != null && object.constructor;
      if ((typeof Ctor == 'function' && Ctor.prototype === object) ||
          (typeof object != 'function' && isArrayLike(object))) {
        return shimKeys(object);
      }
      return isObject(object) ? nativeKeys(object) : [];
    };

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      if (object == null) {
        return [];
      }
      if (!isObject(object)) {
        object = Object(object);
      }
      var length = object.length;
      length = (length && isLength(length) &&
        (isArray(object) || (support.nonEnumArgs && isArguments(object))) && length) || 0;

      var Ctor = object.constructor,
          index = -1,
          isProto = typeof Ctor == 'function' && Ctor.prototype === object,
          result = Array(length),
          skipIndexes = length > 0;

      while (++index < length) {
        result[index] = (index + '');
      }
      for (var key in object) {
        if (!(skipIndexes && isIndex(key, length)) &&
            !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * property of `object` through `iteratee`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns the new mapped object.
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    var mapKeys = createObjectMapper(true);

    /**
     * Creates an object with the same keys as `object` and values generated by
     * running each own enumerable property of `object` through `iteratee`. The
     * iteratee function is bound to `thisArg` and invoked with three arguments:
     * (value, key, object).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns the new mapped object.
     * @example
     *
     * _.mapValues({ 'a': 1, 'b': 2 }, function(n) {
     *   return n * 3;
     * });
     * // => { 'a': 3, 'b': 6 }
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * // using the `_.property` callback shorthand
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    var mapValues = createObjectMapper();

    /**
     * Recursively merges own enumerable properties of the source object(s), that
     * don't resolve to `undefined` into the destination object. Subsequent sources
     * overwrite property assignments of previous sources. If `customizer` is
     * provided it is invoked to produce the merged values of the destination and
     * source properties. If `customizer` returns `undefined` merging is handled
     * by the method instead. The `customizer` is bound to `thisArg` and invoked
     * with five arguments: (objectValue, sourceValue, key, object, source).
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var users = {
     *   'data': [{ 'user': 'barney' }, { 'user': 'fred' }]
     * };
     *
     * var ages = {
     *   'data': [{ 'age': 36 }, { 'age': 40 }]
     * };
     *
     * _.merge(users, ages);
     * // => { 'data': [{ 'user': 'barney', 'age': 36 }, { 'user': 'fred', 'age': 40 }] }
     *
     * // using a customizer callback
     * var object = {
     *   'fruits': ['apple'],
     *   'vegetables': ['beet']
     * };
     *
     * var other = {
     *   'fruits': ['banana'],
     *   'vegetables': ['carrot']
     * };
     *
     * _.merge(object, other, function(a, b) {
     *   if (_.isArray(a)) {
     *     return a.concat(b);
     *   }
     * });
     * // => { 'fruits': ['apple', 'banana'], 'vegetables': ['beet', 'carrot'] }
     */
    var merge = createAssigner(baseMerge);

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable properties of `object` that are not omitted.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {Function|...(string|string[])} [predicate] The function invoked per
     *  iteration or property names to omit, specified as individual property
     *  names or arrays of property names.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'user': 'fred', 'age': 40 };
     *
     * _.omit(object, 'age');
     * // => { 'user': 'fred' }
     *
     * _.omit(object, _.isNumber);
     * // => { 'user': 'fred' }
     */
    var omit = restParam(function(object, props) {
      if (object == null) {
        return {};
      }
      if (typeof props[0] != 'function') {
        var props = arrayMap(baseFlatten(props), String);
        return pickByArray(object, baseDifference(keysIn(object), props));
      }
      var predicate = bindCallback(props[0], props[1], 3);
      return pickByCallback(object, function(value, key, object) {
        return !predicate(value, key, object);
      });
    });

    /**
     * Creates a two dimensional array of the key-value pairs for `object`,
     * e.g. `[[key1, value1], [key2, value2]]`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the new array of key-value pairs.
     * @example
     *
     * _.pairs({ 'barney': 36, 'fred': 40 });
     * // => [['barney', 36], ['fred', 40]] (iteration order is not guaranteed)
     */
    function pairs(object) {
      var index = -1,
          props = keys(object),
          length = props.length,
          result = Array(length);

      while (++index < length) {
        var key = props[index];
        result[index] = [key, object[key]];
      }
      return result;
    }

    /**
     * Creates an object composed of the picked `object` properties. Property
     * names may be specified as individual arguments or as arrays of property
     * names. If `predicate` is provided it is invoked for each property of `object`
     * picking the properties `predicate` returns truthy for. The predicate is
     * bound to `thisArg` and invoked with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {Function|...(string|string[])} [predicate] The function invoked per
     *  iteration or property names to pick, specified as individual property
     *  names or arrays of property names.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'user': 'fred', 'age': 40 };
     *
     * _.pick(object, 'user');
     * // => { 'user': 'fred' }
     *
     * _.pick(object, _.isString);
     * // => { 'user': 'fred' }
     */
    var pick = restParam(function(object, props) {
      if (object == null) {
        return {};
      }
      return typeof props[0] == 'function'
        ? pickByCallback(object, bindCallback(props[0], props[1], 3))
        : pickByArray(object, baseFlatten(props));
    });

    /**
     * This method is like `_.get` except that if the resolved value is a function
     * it is invoked with the `this` binding of its parent object and its result
     * is returned.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned if the resolved value is `undefined`.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a.b.c', 'default');
     * // => 'default'
     *
     * _.result(object, 'a.b.c', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      var result = object == null ? undefined : object[path];
      if (result === undefined) {
        if (object != null && !isKey(path, object)) {
          path = toPath(path);
          object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
          result = object == null ? undefined : object[last(path)];
        }
        result = result === undefined ? defaultValue : result;
      }
      return isFunction(result) ? result.call(object) : result;
    }

    /**
     * Sets the property value of `path` on `object`. If a portion of `path`
     * does not exist it is created.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to augment.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, 'x[0].y.z', 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      if (object == null) {
        return object;
      }
      var pathKey = (path + '');
      path = (object[pathKey] != null || isKey(path, object)) ? [pathKey] : toPath(path);

      var index = -1,
          length = path.length,
          endIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = path[index];
        if (isObject(nested)) {
          if (index == endIndex) {
            nested[key] = value;
          } else if (nested[key] == null) {
            nested[key] = isIndex(path[index + 1]) ? [] : {};
          }
        }
        nested = nested[key];
      }
      return object;
    }

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own enumerable
     * properties through `iteratee`, with each invocation potentially mutating
     * the `accumulator` object. The `iteratee` is bound to `thisArg` and invoked
     * with four arguments: (accumulator, value, key, object). Iteratee functions
     * may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Array|Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * });
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2 }, function(result, n, key) {
     *   result[key] = n * 3;
     * });
     * // => { 'a': 3, 'b': 6 }
     */
    function transform(object, iteratee, accumulator, thisArg) {
      var isArr = isArray(object) || isTypedArray(object);
      iteratee = getCallback(iteratee, thisArg, 4);

      if (accumulator == null) {
        if (isArr || isObject(object)) {
          var Ctor = object.constructor;
          if (isArr) {
            accumulator = isArray(object) ? new Ctor : [];
          } else {
            accumulator = baseCreate(isFunction(Ctor) && Ctor.prototype);
          }
        } else {
          accumulator = {};
        }
      }
      (isArr ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Creates an array of the own enumerable property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable property values
     * of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return baseValues(object, keysIn(object));
    }

    /**
     * Checks if `n` is between `start` and up to but not including, `end`. If
     * `end` is not specified it is set to `start` with `start` then set to `0`.
     *
     * @static
     * @memberOf _
     * @category Number
     * @param {number} n The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `n` is in the range, else `false`.
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     */
    function inRange(value, start, end) {
      start = +start || 0;
      if (typeof end === 'undefined') {
        end = start;
        start = 0;
      } else {
        end = +end || 0;
      }
      return value >= nativeMin(start, end) && value < nativeMax(start, end);
    }

    /**
     * Produces a random number between `min` and `max` (inclusive). If only one
     * argument is provided a number between `0` and the given number is returned.
     * If `floating` is `true`, or either `min` or `max` are floats, a floating-point
     * number is returned instead of an integer.
     *
     * @static
     * @memberOf _
     * @category Number
     * @param {number} [min=0] The minimum possible value.
     * @param {number} [max=1] The maximum possible value.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(min, max, floating) {
      if (floating && isIterateeCall(min, max, floating)) {
        max = floating = null;
      }
      var noMin = min == null,
          noMax = max == null;

      if (floating == null) {
        if (noMax && typeof min == 'boolean') {
          floating = min;
          min = 1;
        }
        else if (typeof max == 'boolean') {
          floating = max;
          noMax = true;
        }
      }
      if (noMin && noMax) {
        max = 1;
        noMax = false;
      }
      min = +min || 0;
      if (noMax) {
        max = min;
        min = 0;
      } else {
        max = +max || 0;
      }
      if (floating || min % 1 || max % 1) {
        var rand = nativeRandom();
        return nativeMin(min + (rand * (max - min + parseFloat('1e-' + ((rand + '').length - 1)))), max);
      }
      return baseRandom(min, max);
    }

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar');
     * // => 'fooBar'
     *
     * _.camelCase('__foo_bar__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? (word.charAt(0).toUpperCase() + word.slice(1)) : word);
    });

    /**
     * Capitalizes the first character of `string`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('fred');
     * // => 'Fred'
     */
    function capitalize(string) {
      string = baseToString(string);
      return string && (string.charAt(0).toUpperCase() + string.slice(1));
    }

    /**
     * Deburrs `string` by converting [latin-1 supplementary letters](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * to basic latin letters and removing [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = baseToString(string);
      return string && string.replace(reLatin1, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to search.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search from.
     * @returns {boolean} Returns `true` if `string` ends with `target`, else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = baseToString(string);
      target = (target + '');

      var length = string.length;
      position = position === undefined
        ? length
        : nativeMin(position < 0 ? 0 : (+position || 0), length);

      position -= target.length;
      return position >= 0 && string.indexOf(target, position) == position;
    }

    /**
     * Converts the characters "&", "<", ">", '"', "'", and "\`", in `string` to
     * their corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional characters
     * use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't require escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value.
     * See [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * Backticks are escaped because in Internet Explorer < 9, they can break out
     * of attribute values or HTML comments. See [#59](https://html5sec.org/#59),
     * [#102](https://html5sec.org/#102), [#108](https://html5sec.org/#108), and
     * [#133](https://html5sec.org/#133) of the [HTML5 Security Cheatsheet](https://html5sec.org/)
     * for more details.
     *
     * When working with HTML you should always [quote attribute values](http://wonko.com/post/html-escaping)
     * to reduce XSS vectors.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      // Reset `lastIndex` because in IE < 9 `String#replace` does not.
      string = baseToString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "\", "/", "^", "$", ".", "|", "?",
     * "*", "+", "(", ")", "[", "]", "{" and "}" in `string`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https:\/\/lodash\.com\/\)'
     */
    function escapeRegExp(string) {
      string = baseToString(string);
      return (string && reHasRegExpChars.test(string))
        ? string.replace(reRegExpChars, '\\$&')
        : string;
    }

    /**
     * Converts `string` to [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__foo_bar__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Pads `string` on the left and right sides if it is shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = baseToString(string);
      length = +length;

      var strLength = string.length;
      if (strLength >= length || !nativeIsFinite(length)) {
        return string;
      }
      var mid = (length - strLength) / 2,
          leftLength = floor(mid),
          rightLength = ceil(mid);

      chars = createPadding('', rightLength, chars);
      return chars.slice(0, leftLength) + string + chars;
    }

    /**
     * Pads `string` on the left side if it is shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padLeft('abc', 6);
     * // => '   abc'
     *
     * _.padLeft('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padLeft('abc', 3);
     * // => 'abc'
     */
    var padLeft = createPadDir();

    /**
     * Pads `string` on the right side if it is shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padRight('abc', 6);
     * // => 'abc   '
     *
     * _.padRight('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padRight('abc', 3);
     * // => 'abc'
     */
    var padRight = createPadDir(true);

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a hexadecimal,
     * in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the [ES5 implementation](https://es5.github.io/#E)
     * of `parseInt`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard && isIterateeCall(string, radix, guard)) {
        radix = 0;
      }
      return nativeParseInt(string, radix);
    }
    // Fallback for environments with pre-ES5 implementations.
    if (nativeParseInt(whitespace + '08') != 8) {
      parseInt = function(string, radix, guard) {
        // Firefox < 21 and Opera < 15 follow ES3 for `parseInt`.
        // Chrome fails to trim leading <BOM> whitespace characters.
        // See https://code.google.com/p/v8/issues/detail?id=3109 for more details.
        if (guard ? isIterateeCall(string, radix, guard) : radix == null) {
          radix = 0;
        } else if (radix) {
          radix = +radix;
        }
        string = trim(string);
        return nativeParseInt(string, radix || (reHasHexPrefix.test(string) ? 16 : 10));
      };
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=0] The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n) {
      var result = '';
      string = baseToString(string);
      n = +n;
      if (n < 1 || !string || !nativeIsFinite(n)) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = floor(n / 2);
        string += string;
      } while (n);

      return result;
    }

    /**
     * Converts `string` to [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--foo-bar');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Converts `string` to [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__foo_bar__');
     * // => 'Foo Bar'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + (word.charAt(0).toUpperCase() + word.slice(1));
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to search.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`, else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = baseToString(string);
      position = position == null
        ? 0
        : nativeMin(position < 0 ? 0 : (+position || 0), string.length);

      return string.lastIndexOf(target, position) == position;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is provided it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options] The options object.
     * @param {RegExp} [options.escape] The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate] The "evaluate" delimiter.
     * @param {Object} [options.imports] An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate] The "interpolate" delimiter.
     * @param {string} [options.sourceURL] The sourceURL of the template's compiled source.
     * @param {string} [options.variable] The data object variable name.
     * @param- {Object} [otherOptions] Enables the legacy `options` param signature.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // using the "interpolate" delimiter to create a compiled template
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // using the HTML "escape" delimiter to escape data property values
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // using the "evaluate" delimiter to execute JavaScript and generate HTML
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // using the internal `print` function in "evaluate" delimiters
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // using the ES delimiter as an alternative to the default "interpolate" delimiter
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // using custom template delimiters
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // using backslashes to treat delimiters as plain text
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // using the `imports` option to import `jQuery` as `jq`
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // using the `sourceURL` option to specify a custom sourceURL for the template
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector
     *
     * // using the `variable` option to ensure a with-statement isn't used in the compiled template
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // using the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and a stack trace
     * fs.writeFileSync(path.join(cwd, 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, otherOptions) {
      // Based on John Resig's `tmpl` implementation (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (otherOptions && isIterateeCall(string, options, otherOptions)) {
        options = otherOptions = null;
      }
      string = baseToString(string);
      options = assignWith(baseAssign({}, otherOptions || options), settings, assignOwnDefaults);

      var imports = assignWith(baseAssign({}, options.imports), settings.imports, assignOwnDefaults),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      var sourceURL = '//# sourceURL=' +
        ('sourceURL' in options
          ? options.sourceURL
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products requires returning the `match`
        // string in order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      var value = string;
      string = baseToString(string);
      if (!string) {
        return string;
      }
      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
        return string.slice(trimmedLeftIndex(string), trimmedRightIndex(string) + 1);
      }
      chars = (chars + '');
      return string.slice(charsLeftIndex(string, chars), charsRightIndex(string, chars) + 1);
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimLeft('  abc  ');
     * // => 'abc  '
     *
     * _.trimLeft('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimLeft(string, chars, guard) {
      var value = string;
      string = baseToString(string);
      if (!string) {
        return string;
      }
      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
        return string.slice(trimmedLeftIndex(string));
      }
      return string.slice(charsLeftIndex(string, (chars + '')));
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimRight('  abc  ');
     * // => '  abc'
     *
     * _.trimRight('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimRight(string, chars, guard) {
      var value = string;
      string = baseToString(string);
      if (!string) {
        return string;
      }
      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
        return string.slice(0, trimmedRightIndex(string) + 1);
      }
      return string.slice(0, charsRightIndex(string, (chars + '')) + 1);
    }

    /**
     * Truncates `string` if it is longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object|number} [options] The options object or maximum string length.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.trunc('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.trunc('hi-diddly-ho there, neighborino', 24);
     * // => 'hi-diddly-ho there, n...'
     *
     * _.trunc('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.trunc('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.trunc('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function trunc(string, options, guard) {
      if (guard && isIterateeCall(string, options, guard)) {
        options = null;
      }
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (options != null) {
        if (isObject(options)) {
          var separator = 'separator' in options ? options.separator : separator;
          length = 'length' in options ? (+options.length || 0) : length;
          omission = 'omission' in options ? baseToString(options.omission) : omission;
        } else {
          length = +options || 0;
        }
      }
      string = baseToString(string);
      if (length >= string.length) {
        return string;
      }
      var end = length - omission.length;
      if (end < 1) {
        return omission;
      }
      var result = string.slice(0, end);
      if (separator == null) {
        return result + omission;
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              newEnd,
              substring = string.slice(0, end);

          if (!separator.global) {
            separator = RegExp(separator.source, (reFlags.exec(separator) || '') + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            newEnd = match.index;
          }
          result = result.slice(0, newEnd == null ? end : newEnd);
        }
      } else if (string.indexOf(separator, end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, `&#39;`, and `&#96;` in `string` to their
     * corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional HTML
     * entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = baseToString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      if (guard && isIterateeCall(string, pattern, guard)) {
        pattern = null;
      }
      string = baseToString(string);
      return string.match(pattern || reWords) || [];
    }

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it is invoked.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Function} func The function to attempt.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // avoid throwing errors for invalid selectors
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = restParam(function(func, args) {
      try {
        return func.apply(undefined, args);
      } catch(e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and arguments of the created function. If `func` is a property name the
     * created callback returns the property value for a given element. If `func`
     * is an object the created callback returns `true` for elements that contain
     * the equivalent object properties, otherwise it returns `false`.
     *
     * @static
     * @memberOf _
     * @alias iteratee
     * @category Utility
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // wrap to create custom callback shorthands
     * _.callback = _.wrap(_.callback, function(callback, func, thisArg) {
     *   var match = /^(.+?)__([gl]t)(.+)$/.exec(func);
     *   if (!match) {
     *     return callback(func, thisArg);
     *   }
     *   return function(object) {
     *     return match[2] == 'gt'
     *       ? object[match[1]] > match[3]
     *       : object[match[1]] < match[3];
     *   };
     * });
     *
     * _.filter(users, 'age__gt36');
     * // => [{ 'user': 'fred', 'age': 40 }]
     */
    function callback(func, thisArg, guard) {
      if (guard && isIterateeCall(func, thisArg, guard)) {
        thisArg = null;
      }
      return isObjectLike(func)
        ? matches(func)
        : baseCallback(func, thisArg);
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var object = { 'user': 'fred' };
     * var getter = _.constant(object);
     *
     * getter() === object;
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * This method returns the first argument provided to it.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'user': 'fred' };
     *
     * _.identity(object) === object;
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function which performs a deep comparison between a given object
     * and `source`, returning `true` if the given object has equivalent property
     * values, else `false`.
     *
     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
     * numbers, `Object` objects, regexes, and strings. Objects are compared by
     * their own, not inherited, enumerable properties. For comparing a single
     * own or inherited property value see `_.matchesProperty`.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, _.matches({ 'age': 40, 'active': false }));
     * // => [{ 'user': 'fred', 'age': 40, 'active': false }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, true));
    }

    /**
     * Creates a function which compares the property value of `path` on a given
     * object to `value`.
     *
     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
     * numbers, `Object` objects, regexes, and strings. Objects are compared by
     * their own, not inherited, enumerable properties.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Array|string} path The path of the property to get.
     * @param {*} value The value to compare.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * _.find(users, _.matchesProperty('user', 'fred'));
     * // => { 'user': 'fred' }
     */
    function matchesProperty(path, value) {
      return baseMatchesProperty(path, baseClone(value, true));
    }

    /**
     * Creates a function which invokes the method at `path` on a given object.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Array|string} path The path of the method to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': { 'c': _.constant(2) } } },
     *   { 'a': { 'b': { 'c': _.constant(1) } } }
     * ];
     *
     * _.map(objects, _.method('a.b.c'));
     * // => [2, 1]
     *
     * _.invoke(_.sortBy(objects, _.method(['a', 'b', 'c'])), 'a.b.c');
     * // => [1, 2]
     */
    var method = restParam(function(path, args) {
      return function(object) {
        return invokePath(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function which invokes
     * the method at a given path on `object`.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = restParam(function(object, args) {
      return function(path) {
        return invokePath(object, path, args);
      };
    });

    /**
     * Adds all own enumerable function properties of a source object to the
     * destination object. If `object` is a function then methods are added to
     * its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options] The options object.
     * @param {boolean} [options.chain=true] Specify whether the functions added
     *  are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * // use `_.runInContext` to avoid conflicts (esp. in Node.js)
     * var _ = require('lodash').runInContext();
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      if (options == null) {
        var isObj = isObject(source),
            props = isObj && keys(source),
            methodNames = props && props.length && baseFunctions(source, props);

        if (!(methodNames ? methodNames.length : isObj)) {
          methodNames = false;
          options = source;
          source = object;
          object = this;
        }
      }
      if (!methodNames) {
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = true,
          index = -1,
          isFunc = isFunction(object),
          length = methodNames.length;

      if (options === false) {
        chain = false;
      } else if (isObject(options) && 'chain' in options) {
        chain = options.chain;
      }
      while (++index < length) {
        var methodName = methodNames[index],
            func = source[methodName];

        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = (function(func) {
            return function() {
              var chainAll = this.__chain__;
              if (chain || chainAll) {
                var result = object(this.__wrapped__),
                    actions = result.__actions__ = arrayCopy(this.__actions__);

                actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
                result.__chain__ = chainAll;
                return result;
              }
              var args = [this.value()];
              push.apply(args, arguments);
              return func.apply(object, args);
            };
          }(func));
        }
      }
      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      context._ = oldDash;
      return this;
    }

    /**
     * A no-operation function which returns `undefined` regardless of the
     * arguments it receives.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @example
     *
     * var object = { 'user': 'fred' };
     *
     * _.noop(object) === undefined;
     * // => true
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function which returns the property value at `path` on a
     * given object.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': { 'c': 2 } } },
     *   { 'a': { 'b': { 'c': 1 } } }
     * ];
     *
     * _.map(objects, _.property('a.b.c'));
     * // => [2, 1]
     *
     * _.pluck(_.sortBy(objects, _.property(['a', 'b', 'c'])), 'a.b.c');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(path) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function which returns
     * the property value at a given path on `object`.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return baseGet(object, toPath(path), path + '');
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. If `end` is not specified it is
     * set to `start` with `start` then set to `0`. If `end` is less than `start`
     * a zero-length range is created unless a negative `step` is specified.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the new array of numbers.
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    function range(start, end, step) {
      if (step && isIterateeCall(start, end, step)) {
        end = step = null;
      }
      start = +start || 0;
      step = step == null ? 1 : (+step || 0);

      if (end == null) {
        end = start;
        start = 0;
      } else {
        end = +end || 0;
      }
      // Use `Array(length)` so engines like Chakra and V8 avoid slower modes.
      // See https://youtu.be/XAqIpGU8ZZk#t=17m25s for more details.
      var index = -1,
          length = nativeMax(ceil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (++index < length) {
        result[index] = start;
        start += step;
      }
      return result;
    }

    /**
     * Invokes the iteratee function `n` times, returning an array of the results
     * of each invocation. The `iteratee` is bound to `thisArg` and invoked with
     * one argument; (index).
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * var diceRolls = _.times(3, _.partial(_.random, 1, 6, false));
     * // => [3, 6, 4]
     *
     * _.times(3, function(n) {
     *   mage.castSpell(n);
     * });
     * // => invokes `mage.castSpell(n)` three times with `n` of `0`, `1`, and `2`
     *
     * _.times(3, function(n) {
     *   this.cast(n);
     * }, mage);
     * // => also invokes `mage.castSpell(n)` three times
     */
    function times(n, iteratee, thisArg) {
      n = floor(n);

      // Exit early to avoid a JSC JIT bug in Safari 8
      // where `Array(0)` is treated as `Array(1)`.
      if (n < 1 || !nativeIsFinite(n)) {
        return [];
      }
      var index = -1,
          result = Array(nativeMin(n, MAX_ARRAY_LENGTH));

      iteratee = bindCallback(iteratee, thisArg, 1);
      while (++index < n) {
        if (index < MAX_ARRAY_LENGTH) {
          result[index] = iteratee(index);
        } else {
          iteratee(index);
        }
      }
      return result;
    }

    /**
     * Generates a unique ID. If `prefix` is provided the ID is appended to it.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {string} [prefix] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return baseToString(prefix) + id;
    }

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {number} augend The first number to add.
     * @param {number} addend The second number to add.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    function add(augend, addend) {
      return (+augend || 0) + (+addend || 0);
    }

    /**
     * Gets the maximum value of `collection`. If `collection` is empty or falsey
     * `-Infinity` is returned. If an iteratee function is provided it is invoked
     * for each value in `collection` to generate the criterion by which the value
     * is ranked. The `iteratee` is bound to `thisArg` and invoked with three
     * arguments: (value, index, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => -Infinity
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * _.max(users, function(chr) {
     *   return chr.age;
     * });
     * // => { 'user': 'fred', 'age': 40 }
     *
     * // using the `_.property` callback shorthand
     * _.max(users, 'age');
     * // => { 'user': 'fred', 'age': 40 }
     */
    var max = createExtremum(arrayMax);

    /**
     * Gets the minimum value of `collection`. If `collection` is empty or falsey
     * `Infinity` is returned. If an iteratee function is provided it is invoked
     * for each value in `collection` to generate the criterion by which the value
     * is ranked. The `iteratee` is bound to `thisArg` and invoked with three
     * arguments: (value, index, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => Infinity
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * _.min(users, function(chr) {
     *   return chr.age;
     * });
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // using the `_.property` callback shorthand
     * _.min(users, 'age');
     * // => { 'user': 'barney', 'age': 36 }
     */
    var min = createExtremum(arrayMin, true);

    /**
     * Gets the sum of the values in `collection`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 6]);
     * // => 10
     *
     * _.sum({ 'a': 4, 'b': 6 });
     * // => 10
     *
     * var objects = [
     *   { 'n': 4 },
     *   { 'n': 6 }
     * ];
     *
     * _.sum(objects, function(object) {
     *   return object.n;
     * });
     * // => 10
     *
     * // using the `_.property` callback shorthand
     * _.sum(objects, 'n');
     * // => 10
     */
    function sum(collection, iteratee, thisArg) {
      if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
        iteratee = null;
      }
      var func = getCallback(),
          noIteratee = iteratee == null;

      if (!(func === baseCallback && noIteratee)) {
        noIteratee = false;
        iteratee = func(iteratee, thisArg, 3);
      }
      return noIteratee
        ? arraySum(isArray(collection) ? collection : toIterable(collection))
        : baseSum(collection, iteratee);
    }

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    // Add functions to the `Map` cache.
    MapCache.prototype['delete'] = mapDelete;
    MapCache.prototype.get = mapGet;
    MapCache.prototype.has = mapHas;
    MapCache.prototype.set = mapSet;

    // Add functions to the `Set` cache.
    SetCache.prototype.push = cachePush;

    // Assign cache to `_.memoize`.
    memoize.Cache = MapCache;

    // Add functions that return wrapped values when chaining.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.callback = callback;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.functions = functions;
    lodash.groupBy = groupBy;
    lodash.indexBy = indexBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.invert = invert;
    lodash.invoke = invoke;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.omit = omit;
    lodash.once = once;
    lodash.pairs = pairs;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pluck = pluck;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.restParam = restParam;
    lodash.set = set;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortByAll = sortByAll;
    lodash.sortByOrder = sortByOrder;
    lodash.spread = spread;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.times = times;
    lodash.toArray = toArray;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.union = union;
    lodash.uniq = uniq;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.where = where;
    lodash.without = without;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.backflow = flowRight;
    lodash.collect = map;
    lodash.compose = flowRight;
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.extend = assign;
    lodash.iteratee = callback;
    lodash.methods = functions;
    lodash.object = zipObject;
    lodash.select = filter;
    lodash.tail = rest;
    lodash.unique = uniq;

    // Add functions to `lodash.prototype`.
    mixin(lodash, lodash);

    // Add functions that return unwrapped values when chaining.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.deburr = deburr;
    lodash.endsWith = endsWith;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.findWhere = findWhere;
    lodash.first = first;
    lodash.get = get;
    lodash.has = has;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isBoolean = isBoolean;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isMatch = isMatch;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isString = isString;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.max = max;
    lodash.min = min;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padLeft = padLeft;
    lodash.padRight = padRight;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.result = result;
    lodash.runInContext = runInContext;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.sum = sum;
    lodash.template = template;
    lodash.trim = trim;
    lodash.trimLeft = trimLeft;
    lodash.trimRight = trimRight;
    lodash.trunc = trunc;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.words = words;

    // Add aliases.
    lodash.all = every;
    lodash.any = some;
    lodash.contains = includes;
    lodash.detect = find;
    lodash.foldl = reduce;
    lodash.foldr = reduceRight;
    lodash.head = first;
    lodash.include = includes;
    lodash.inject = reduce;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!lodash.prototype[methodName]) {
          source[methodName] = func;
        }
      });
      return source;
    }()), false);

    // Add functions capable of returning wrapped and unwrapped values when chaining.
    lodash.sample = sample;

    lodash.prototype.sample = function(n) {
      if (!this.__chain__ && n == null) {
        return sample(this.value());
      }
      return this.thru(function(value) {
        return sample(value, n);
      });
    };

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type string
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['dropWhile', 'filter', 'map', 'takeWhile'], function(methodName, type) {
      var isFilter = type != LAZY_MAP_FLAG,
          isDropWhile = type == LAZY_DROP_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee, thisArg) {
        var filtered = this.__filtered__,
            result = (filtered && isDropWhile) ? new LazyWrapper(this) : this.clone(),
            iteratees = result.__iteratees__ || (result.__iteratees__ = []);

        iteratees.push({
          'done': false,
          'count': 0,
          'index': 0,
          'iteratee': getCallback(iteratee, thisArg, 1),
          'limit': -1,
          'type': type
        });

        result.__filtered__ = filtered || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      var whileName = methodName + 'While';

      LazyWrapper.prototype[methodName] = function(n) {
        var filtered = this.__filtered__,
            result = (filtered && !index) ? this.dropWhile() : this.clone();

        n = n == null ? 1 : nativeMax(floor(n) || 0, 0);
        if (filtered) {
          if (index) {
            result.__takeCount__ = nativeMin(result.__takeCount__, n);
          } else {
            last(result.__iteratees__).limit = n;
          }
        } else {
          var views = result.__views__ || (result.__views__ = []);
          views.push({ 'size': n, 'type': methodName + (result.__dir__ < 0 ? 'Right' : '') });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };

      LazyWrapper.prototype[methodName + 'RightWhile'] = function(predicate, thisArg) {
        return this.reverse()[whileName](predicate, thisArg).reverse();
      };
    });

    // Add `LazyWrapper` methods for `_.first` and `_.last`.
    arrayEach(['first', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.rest`.
    arrayEach(['initial', 'rest'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this[dropName](1);
      };
    });

    // Add `LazyWrapper` methods for `_.pluck` and `_.where`.
    arrayEach(['pluck', 'where'], function(methodName, index) {
      var operationName = index ? 'filter' : 'map',
          createCallback = index ? baseMatches : property;

      LazyWrapper.prototype[methodName] = function(value) {
        return this[operationName](createCallback(value));
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.reject = function(predicate, thisArg) {
      predicate = getCallback(predicate, thisArg, 1);
      return this.filter(function(value) {
        return !predicate(value);
      });
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = start == null ? 0 : (+start || 0);

      var result = this;
      if (start < 0) {
        result = this.takeRight(-start);
      } else if (start) {
        result = this.drop(start);
      }
      if (end !== undefined) {
        end = (+end || 0);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.toArray = function() {
      return this.drop(0);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (!lodashFunc) {
        return;
      }
      var checkIteratee = /^(?:filter|map|reject)|While$/.test(methodName),
          retUnwrapped = /^(?:first|last)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments,
            chainAll = this.__chain__,
            value = this.__wrapped__,
            isHybrid = !!this.__actions__.length,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // avoid lazy use if the iteratee has a "length" value other than `1`
          isLazy = useLazy = false;
        }
        var onlyLazy = isLazy && !isHybrid;
        if (retUnwrapped && !chainAll) {
          return onlyLazy
            ? func.call(value)
            : lodashFunc.call(lodash, this.value());
        }
        var interceptor = function(value) {
          var otherArgs = [value];
          push.apply(otherArgs, args);
          return lodashFunc.apply(lodash, otherArgs);
        };
        if (useLazy) {
          var wrapper = onlyLazy ? value : new LazyWrapper(this),
              result = func.apply(wrapper, args);

          if (!retUnwrapped && (isHybrid || result.__actions__)) {
            var actions = result.__actions__ || (result.__actions__ = []);
            actions.push({ 'func': thru, 'args': [interceptor], 'thisArg': lodash });
          }
          return new LodashWrapper(result, chainAll);
        }
        return this.thru(interceptor);
      };
    });

    // Add `Array` and `String` methods to `lodash.prototype`.
    arrayEach(['concat', 'join', 'pop', 'push', 'replace', 'shift', 'sort', 'splice', 'split', 'unshift'], function(methodName) {
      var func = (/^(?:replace|split)$/.test(methodName) ? stringProto : arrayProto)[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:join|pop|replace|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          return func.apply(this.value(), args);
        }
        return this[chainName](function(value) {
          return func.apply(value, args);
        });
      };
    });

    // Map minified function names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name,
            names = realNames[key] || (realNames[key] = []);

        names.push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybridWrapper(null, BIND_KEY_FLAG).name] = [{ 'name': 'wrapper', 'func': null }];

    // Add functions to the lazy wrapper.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chaining functions to the `lodash` wrapper.
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toString = wrapperToString;
    lodash.prototype.run = lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add function aliases to the `lodash` wrapper.
    lodash.prototype.collect = lodash.prototype.map;
    lodash.prototype.head = lodash.prototype.first;
    lodash.prototype.select = lodash.prototype.filter;
    lodash.prototype.tail = lodash.prototype.rest;

    return lodash;
  }

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers like r.js check for condition patterns like the following:
  if (true) {
    // Expose lodash to the global object when an AMD loader is present to avoid
    // errors in cases where lodash is loaded by a script tag and not intended
    // as an AMD module. See http://requirejs.org/docs/errors.html#mismatch for
    // more details.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
      return _;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds an `exports` object.
  else if (freeExports && freeModule) {
    // Export for Node.js or RingoJS.
    if (moduleExports) {
      (freeModule.exports = _)._ = _;
    }
    // Export for Narwhal or Rhino -require.
    else {
      freeExports._ = _;
    }
  }
  else {
    // Export for a browser or Rhino.
    root._ = _;
  }
}.call(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(47)(module), __webpack_require__(32)))

/***/ }),

/***/ 32:
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ 339:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//The pre-loaded templates contain all the angular template html files in one javascript file
if (!undefined) {
  __webpack_require__(340);
} else {
  //Don't load if running npm start, to streamline development
  angular.module("templates-pcmWebUI", []);
}

var config = __webpack_require__(1);
var eventTracker = __webpack_require__(105);
eventTracker.init(config, __webpack_require__(106));

(function () {
  var id = "app";
  var app = angular.module(id, [
  // Angular modules
  "ngAnimate", // animations
  "ngRoute", // routing
  "ui.sortable", "ui.bootstrap", "ui.bootstrap.showErrors", "pcmCommon", "alk.authentication", "alk.accountManagement", "ui.utils", "uiSwitch", "templates-pcmWebUI", // pre-loaded templates
  "alk.services", "pcmwsui.message", "alk.maps", "alk.modal", "alk.import", "alk.cloud", "pascalprecht.translate", "alk.constants", "ngSanitize", "ngCookies", "alk.fleetportal", "alk.places", "alk.routeExceptions", "alk.filters", "alk.singlesearch", "alk.marketing", "alk.forms", "alk.directives", "alk.translations", "tmh.dynamicLocale", "visibilityChange"
  // Custom modules

  // 3rd Party Modules
  ]);

  app.constant("alkapplication", "pcmilerweb");
  app.constant("_", __webpack_require__(107));
  app.constant("ALKMaps", window.ALKMaps);
  app.constant("papaparse", __webpack_require__(341));
  app.constant("eventTracker", eventTracker);

  // Routes
  app.config(["$routeProvider", "$locationProvider", function ($routeProvider, $locationProvider) {
    $locationProvider.html5Mode(true);

    $routeProvider._when = $routeProvider.when;
    $routeProvider.when = function (path, route) {
      route.resolve = angular.merge(route.resolve || {}, {
        fingerprinted: ["$rootScope", "$q", function ($rootScope, $q) {
          var authenticationPromise = $q.defer();
          if ($rootScope.preloginFinished === true) {
            authenticationPromise.resolve();
            return authenticationPromise.promise;
          }

          $rootScope.$watch(function () {
            return $rootScope.preloginFinished;
          }, function () {
            if ($rootScope.preloginFinished === true) {
              authenticationPromise.resolve();
            }
          });

          return authenticationPromise.promise;
        }]
      });

      return $routeProvider._when(path, route);
    };

    $routeProvider.when("/", {
      templateUrl: "/pages/landingPage.html",
      requireLogin: false,
      bodyClass: "unrestricted homePage",
      title: "Home"
    }).when("/features", {
      templateUrl: "/pages/featuresPage.html",
      requireLogin: false,
      bodyClass: "unrestricted featuresPage contentPage",
      title: "Features"
    }).when("/info", {
      redirectTo: "/features"
    }).when("/contact", {
      redirectTo: "/"
    }).when("/contact/success", {
      redirectTo: "/"
    }).when("/contact/error", {
      redirectTo: "/"
    }).when("/login", {
      redirectTo: "/"
    }).when("/signupLogin", {
      redirectTo: "/"
    }).when("/signup", {
      templateUrl: "/pages/signUpPage.html",
      requireLogin: false,
      bodyClass: "unrestricted signUpPage contentPage",
      title: "Sign Up"
    }).when("/app", {
      templateUrl: "/pages/mainPage.html",
      requireLogin: true,
      bodyClass: "mainPage",
      title: "Route Planning and Reporting",
      reloadOnSearch: false,
      resolve: {
        // the app needs the default options for any routes that it creates so ensure that it is loaded.  This prevents having to restructure a lot to use promises everywhere.
        "defaultOptions": ["$rootScope", "$q", "routingProfile", function ($rootScope, $q, routingProfile) {
          var deferred = $q.defer();

          $rootScope.$watch(function () {
            return $rootScope.preloginFinished;
          }, function () {
            if ($rootScope.preloginFinished === true) {
              deferred.resolve();
            }
          });
          return deferred.promise.then(function () {
            return routingProfile.getDefaultOptionsPromise();
          });
        }],
        "placeSets": ["$rootScope", "$q", "userService", function ($rootScope, $q, userService) {
          //jira: SWPWEB-974
          return []; // userService.getPlacesDataPromise();
        }]
      }
    }).when("/account", {
      templateUrl: "/pages/accountPage.html",
      requireLogin: true,
      expiredUserAllowed: true,
      bodyClass: "accountPage withHeader",
      title: "My Account"
    }).when("/applicationSettings", {
      templateUrl: "/app/applicationSettings/applicationSettings.html",
      requireLogin: true,
      bodyClass: "applicationSetting withHeader",
      title: "Application Settings",
      resolve: {
        // the app needs the default options for any routes that it creates so ensure that it is loaded.  This prevents having to restructure a lot to use promises everywhere.
        "defaultOptions": ["$rootScope", "$q", "routingProfile", function ($rootScope, $q, routingProfile) {
          var deferred = $q.defer();

          $rootScope.$watch(function () {
            return $rootScope.preloginFinished;
          }, function () {
            if ($rootScope.preloginFinished === true) {
              deferred.resolve();
            }
          });
          return deferred.promise.then(function () {
            return routingProfile.getDefaultOptionsPromise();
          });
        }]
      }
    }).when("/help", {
      templateUrl: "/pages/helpPage.html",
      requireLogin: true,
      expiredUserAllowed: true,
      bodyClass: "helpPage withHeader",
      title: "Help"
    }).when("/resetPassword", {
      templateUrl: "/pages/resetPassword.html",
      requireLogin: false,
      bodyClass: "unrestricted loginPage contentPage",
      title: "Reset Password"
    }).when("/acceptterms", {
      templateUrl: "/pages/acceptterms.html",
      requireLogin: true,
      expiredUserAllowed: true,
      bodyClass: "unrestricted loginPage contentPage",
      title: "Terms of Use"
    }).when("/terms", {
      templateUrl: "/pages/terms.html",
      requireLogin: false,
      expiredUserAllowed: true,
      bodyClass: "unrestricted contentPage",
      title: "Terms of Use"
    }).when("/tid/redirect", {
      templateUrl: "/pages/landingPage.html",
      requireLogin: false,
      expiredUserAllowed: true,
      bodyClass: "unrestricted contentPage",
      title: "redirect"
    }).when("/tid/logout", {
      templateUrl: "/pages/logout.html",
      requireLogin: false,
      expiredUserAllowed: true,
      bodyClass: "unrestricted contentPage",
      title: "logout"
    }).otherwise({
      redirectTo: "/"
    });
  }]);

  app.config(["alkAuthenticationServiceProvider", "alk.authentication.config", "moment", function (alkAuthenticationServiceProvider, authConfig, moment) {

    //Setup track.js
    if (config.trackJsEnvironment && typeof trackJs !== "undefined") {
      //console.log("Setting up trackjs for application \"" + config.trackJsEnvironment + "\"");
      trackJs.configure({
        application: config.trackJsEnvironment
      });
    }

    // set up authorization provider
    alkAuthenticationServiceProvider.dataAnywhereUrl = config.daUrl;
    alkAuthenticationServiceProvider.pcmilerUrl = config.pcmwsUrl;
    authConfig.ssoUrl = config.ssoUrl;
    authConfig.applicationName = config.applicationName;
    authConfig.pcmwsUrl = config.pcmwsUrl;
    authConfig.alkmapsApiKey = config.alkmapsApiKey;
    authConfig.reportApiKey = config.reportApiKey;
    authConfig.linkMappingUrl = config.linkMappingUrl;
    authConfig.clientId = config.clientId;
    authConfig.tidApplicationName = config.tidApplicationName;
    authConfig.trimbleCloudUrl = config.trimbleCloudUrl;
    authConfig.skipLogoutOnForbidden = true;

    alkAuthenticationServiceProvider.shouldLogoutOnForbidden = function (rejection) {
      if (rejection.config.url.indexOf("/v1/authenticate") >= 0) {
        return false;
      }

      if (rejection.config.url.indexOf("/api/Migrate/") === 0) {
        return false;
      }

      return true;
    };

    alkAuthenticationServiceProvider.extraUserProperties = {
      isTrialValid: function isTrialValid() {
        if (this.accountType !== "Trial") {
          return true;
        }

        if (this.remainingRoutes <= 0) {
          return false;
        }

        if (this.expired === true) {
          return false;
        }

        if (this.expirationDate != null && this.expirationDate < new Date()) {
          return false;
        }

        return true;
      },
      isAdmin: function isAdmin() {
        var isAdmin = this.roles != null && this.roles.indexOf("Company Administrator") !== -1 ? true : false;

        return isAdmin;
      },
      isPremium: function isPremium() {
        return this.subscriptionLevel === "Premium" || this.subscriptionLevel === "Trial";
      },
      getCreditExpiresDate: function getCreditExpiresDate() {
        return moment.utc(this.creditExpiredDate).endOf("day");
      },
      creditExpiresSoon: function creditExpiresSoon() {
        if (!this.getCreditExpiresDate().isValid()) {
          return false;
        }

        var warnAt = this.getCreditExpiresDate().subtract(config.creditExpireWarningDays, "days");

        var now = moment().utc().startOf("day");

        return now.isAfter(warnAt);
      },
      checkCreditExpiration: function checkCreditExpiration() {
        if (!this.getCreditExpiresDate().isValid()) {
          return false;
        }

        var now = moment().utc().startOf("day");
        return now.isAfter(this.getCreditExpiresDate());
      },
      canUseTripDirect: function canUseTripDirect() {
        return this.isTripDirectEnabled && this.isPremium();
      }
    };
  }]);

  app.config(["alk.singlesearch.config", function (singleSearchConfig) {
    singleSearchConfig.url = config.singleSearchUrl;
    singleSearchConfig.authToken = config.singleSearchAuthToken;
  }]);

  app.config(["alk.fleetportal.config", function (fleetViewConfig) {
    fleetViewConfig.apiUrl = config.fleetLinkUrl;
  }]);

  app.factory("fcWidgetAsync", ["$window", "$q", function ($window, $q) {
    var fcWidgetStub = {
      init: function init() {},
      destroy: function destroy() {},
      isOpen: function isOpen() {},
      isInitialized: function isInitialized() {},
      user: {
        setProperties: function setProperties() {}
      },
      open: function open() {},
      close: function close() {}
    };

    function createFCWidgetAsync() {
      var deferred = $q.defer();
      var scriptElement = document.createElement("script");
      scriptElement.async = true;
      scriptElement.onload = function () {
        if ($window.fcWidget) {
          deferred.resolve($window.fcWidget);
        } else {
          deferred.reject(fcWidgetStub);
        }
      };
      scriptElement.onerror = function () {
        deferred.reject(fcWidgetStub);
      };
      scriptElement.src = config.chat.scriptUrl;
      document.body.appendChild(scriptElement);
      return deferred.promise;
    }

    return createFCWidgetAsync();
  }]);

  // Execute bootstrapping code and any dependencies.
  app.run(["$rootScope", "$http", "$location", "UserProvider", "$timeout", "$q", "alkAuthenticationService", "$window", "VisibilityChange", "fcWidgetAsync", function ($rootScope, $http, $location, UserProvider, $timeout, $q, alkAuthenticationService, $window, VisibilityChange, fcWidgetAsync) {
    //  now the app is starting, let's see if we can log in via our cookie
    $rootScope.preloginFinished = false;
    var redirectLocation = void 0;
    if ($location.search().r) {
      redirectLocation = decodeURIComponent($location.search().r);
    } else {
      var path = $location.path();
      if (path === undefined || path === null || path === "/") {
        redirectLocation = "/app";
      } else {
        redirectLocation = path;
      }
      if ($location.search().center) {
        redirectLocation += "?center=" + $location.search().center;
      }
    }

    var skipCookieLogin = false;
    if (redirectLocation === "/resetPassword" || redirectLocation === "/features" || redirectLocation === "/signup" || redirectLocation === "/terms" || redirectLocation === "/tid/redirect" || redirectLocation === "/tid/logout") {
      skipCookieLogin = true;
    }
    if (redirectLocation.indexOf("/promo") > -1) {
      skipCookieLogin = true;

      var authToken = redirectLocation.substring(7);

      if (authToken) {
        var userObj = {
          "promo": true,
          "isLoggedIn": true,
          "maxNumberOfUsers": 1,
          "accountType": "PCMWeb",
          "subscriptionLevel": "Premium",
          "dataset": "PCM_NA",
          "region": "NA",
          "remainingRoutes": -1,
          "isInvoiced": false,
          "creditExpiredDate": "9999-12-31T23:59:59.9999999",
          "isTripDirectEnabled": false,
          "netSuiteOnline": false,
          "isMonthlyPaidCustomer": false,
          "userName": "rmehra+ian@alk.com",
          "firstName": "Rishi",
          "lastName": "Mehra",
          "account": "Trimble MAPS Marketing Offers",
          "userId": config.promo.userId,
          "accountId": config.promo.accountId,
          "expired": false,
          "expirationDate": null,
          "isDisabled": false,
          "roles": ["Company Administrator"],
          "hasBillingIssue": false,
          "authToken": authToken,
          "currentTermsOfUseAccepted": true,
          "memberSince": "0001-01-01T00:00:00"
        };
      }
      UserProvider.loadUser(userObj);
      $timeout($location.url("/app"), 1000);
    }

    if (!skipCookieLogin) {
      var authenticationPromise = $q.defer();
      alkAuthenticationService.verify().then(function () {
        authenticationPromise.resolve();
        var user = UserProvider.getUser();
        var data = window.localStorage.getItem("user_authToken");
        if (user && user.authToken !== data) {
          var sumoLogicUrl = config.sumoUrl;
          var logData = {
            Message: "User logged in Legacy PCMilerWeb Application",
            Timestamp: new Date().toISOString(),
            UserName: user.userName,
            AccountName: user.account
          };
          $http.post(sumoLogicUrl, logData).then(function (response) {
            console.warn('Log sent to Sumo Logic');
          }).catch(function (error) {
            console.error('Failed to send log to Sumo Logic:', error);
          });
        }
      }, function (err) {
        authenticationPromise.reject();
        window.location.href = "" + config.pcmModernSite;
      });

      authenticationPromise.promise.then(function () {
        $rootScope.preloginFinished = true;
        $location.url(redirectLocation);
      }, function () {
        // $location.url("/");
        $rootScope.preloginFinished = true;
      });
    } else {
      $rootScope.preloginFinished = true;
    }

    $rootScope.$on("$routeChangeStart", function (event, next) {

      var requireLogin = next.$$route.requireLogin;
      if (requireLogin) {
        var user = UserProvider.getUser();

        if (user.isLoggedIn !== true) {
          event.preventDefault();
          var gotoLogin = function gotoLogin() {
            $location.url("/login?path=" + next.$$route.originalPath);
          };

          $timeout(gotoLogin);
        } else if (user.currentTermsOfUseAccepted !== true && next.$$route.originalPath.indexOf("/acceptterms") < 0) {
          event.preventDefault();
          // only enter this condition if we are not already trying to route to the terms of use.  Otherwise we end up in infinite loop.
          var gotoTerms = function gotoTerms() {
            $location.url("/acceptterms?path=" + next.$$route.originalPath);
          };

          $timeout(gotoTerms);
        } else if (user.isTrialValid() !== true && next.$$route.expiredUserAllowed !== true && next.$$route.originalPath.indexOf("/account") < 0) {
          event.preventDefault();
          var gotoAccount = function gotoAccount() {
            $location.url("/account");
          };

          $timeout(gotoAccount);
        } else if (!user.isMonthlyPaidCustomer && user.expired) {
          $location.url("/login");
          $rootScope.showAccountExpired = true;
        } else if (user.isMonthlyPaidCustomer && user.checkCreditExpiration() && next.$$route.expiredUserAllowed !== true && next.$$route.originalPath.indexOf("/account") < 0 && !user.isInvoiced) {
          event.preventDefault();
          var gotoAccount = function gotoAccount() {
            $location.url("/account");
          };

          $timeout(gotoAccount);

          // without the $evalAsync it was changing the url, but the view did not update.  Found this solution at the angular bug here: https://github.com/angular/angular.js/issues/9607
        } else if (user.hasBillingIssue === true && next.$$route.originalPath.indexOf("/app") >= 0) {
          // only force redirect to the account page when we have a billing issue and we are attempting to access the application.
          event.preventDefault();
          var gotoAccount = function gotoAccount() {
            $location.url("/account");
          };
          $timeout(gotoAccount);
        } else {
          eventTracker.track(eventTracker.EVENTS.LOGIN, {
            user: user
          });
          if (config.chat && config.chat.enabled) {
            // only enable chat for whitelisted regions
            var regionWL = config.chat.regionWhitelist;
            if (Array.isArray(regionWL) && regionWL.some(function (whitelistedRegion) {
              return user.region === whitelistedRegion;
            })) {
              fcWidgetAsync.then(function (fcWidget) {
                fcWidget.init({
                  token: config.chat.fcToken,
                  host: "https://wchat.freshchat.com",
                  // required, supposedly
                  externalId: user.userName,
                  config: {
                    headerProperty: {
                      hideChatButton: true
                    }
                  }
                });
              });
            }
          }
        }
      }
    });

    $rootScope.$on("$routeChangeSuccess", function (event, current) {
      $rootScope.bodyClass = current.$$route.bodyClass;
      $rootScope.title = current.$$route.title;
    });

    // SWCX-556 - Everytime user goes back to the app from other browser tab, check if it still has access to this app
    VisibilityChange.configure({
      broadcast: true
    });

    $rootScope.$on("pageBecameVisible", function (event) {
      if ($rootScope.userInfo) {
        alkAuthenticationService.verifyService().then(function (data) {}, // user is good, do nothing
        function (err) {
          // user can not access any more, redirect user to login.
          // UserProvider.clearUser();
          fcWidgetAsync.then(function (fcWidget) {
            fcWidget.destroy();
          });
          // $location.url("/");
        });
      }
    });
  }]);
})();

/***/ }),

/***/ 340:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('templates-pcmWebUI', []).run(['$templateCache', function ($templateCache) {
  $templateCache.put('/pages/acceptterms.html', '\n<div class="container">\n    <div class="panel col-md-12">\n        <div class="page-header" ng-include="\'/app/account/loginHeader.template.html\'"></div>\n        <div class="page-content">\n            <h1>Terms of Use</h1>\n            <h3>Read through to the bottom of the page to accept these terms</h3>\n            <div ng-include="\'/app/account/tos_text.html\'"></div>\n\n            <div ng-controller="termsController" class="text-center">\n                <button type="button" class="btn btn-lg btn-success" ng-disabled="isProcessing" ng-click="acceptTerms()">\n                    <i ng-show="isProcessing" class="ico ico-circle-notch ico-spin ng-cloak" ng-cloak></i> \n                    <span>Accept</span>\n                </button>\n            </div>\n        </div>\n    </div>\n</div>');
  $templateCache.put('/pages/accountPage.html', '<div class="page-container">\n  <div id="header" class="hidden-print alk-menu-bar slant" ng-include="\'/app/layout/supportNav.template.html\'"></div>\n\n  <div class="container">\n    <div class="panel panel-page forms-content forms-content-small account-page">\n      <div ng-controller="accountController as vm" ng-init="vm.init()">\n\n        <div class="container-fluid">\n          <div class="row">\n            <div class="col-md-12">\n              <!--<h1>Manage Account</h1>-->\n              <pcm-messages></pcm-messages>\n            </div>\n          </div>\n          <div class="row">\n            <div class="col-md-6">\n              <!-- <fieldset>\n                  <legend>Change Password</legend>\n                  <div class="row form-group">\n                    <div class="col-md-12">\n                      <p class="small">\n                        Password can be changed in web tools Menu.\n                      </p>\n                    </div>\n                  </div>\n              </fieldset> -->\n              <fieldset ng-show="userInfo.isAdmin()">\n                <legend class="page-header">Account Users</legend>\n                <div class="row form-group">\n                  <div class="col-md-8">\n                    <p class="form-control-static input-sm" style="margin-top: 1px;">\n                      <span class="ng-cloak" ng-show="userInfo.maxNumberOfUsers && vm.usersTotalCount" ng-bind="userInfo.maxNumberOfUsers - vm.usersTotalCount"></span>                      additional users available\n                      <span class="ico ico-info-circle" tooltip-placement="right" uib-tooltip="You can add more users to account in the Subscription Info Panel."></span>\n                    </p>\n\n                  </div>\n                  <div class="col-md-4 ">\n                    <button class="btn btn-sm btn-default pull-right" ng-disabled="(userInfo.maxNumberOfUsers - vm.usersTotalCount < 1) || vm.isProcessing || (userInfo.hasBillingIssue) || (userInfo.checkCreditExpiration())"\n                      ng-click="vm.toggleNewUserForm()" ng-bind="(vm.newUserFormVisible)?\'Cancel New User\':\'Add User to Account\'"></button>\n                  </div>\n                </div>\n\n                <form name="newUserForm" novalidate pcm-submit="vm.submitNewUser(vm.newUser)" ng-show="vm.newUserFormVisible" class="slideInOut">\n                  <h4 class="field-section">Add New User</h4>\n                  <div class="row form-group">\n                    <div class="col-md-3" ng-class="{ \'has-error\' : newUserForm.firstName.$invalid && newUserForm.submitted}">\n                      <label for="newFirstName" class="control-label label-sm">First Name</label>\n                      <input class="form-control input-sm" placeholder="" id="newFirstName" name="firstName" type="text" required ng-disabled="vm.isProcessing"\n                        ng-model="vm.newUser.firstName" pcm-class-on-value="filled" />\n                      <div ng-if="newUserForm.submitted">\n                        <p ng-if="newUserForm.firstName.$error.required" class="help-block">required</p>\n                      </div>\n                    </div>\n                    <div class="col-md-3" ng-class="{ \'has-error\' : newUserForm.lastName.$invalid && newUserForm.submitted}">\n                      <label for="newLastName" class="control-label label-sm">Last Name</label>\n                      <input class="form-control input-sm" id="newLastName" name="lastName" type="text" placeholder="" required ng-disabled="vm.isProcessing"\n                        ng-model="vm.newUser.lastName" pcm-class-on-value="filled" />\n                      <div ng-if="newUserForm.submitted">\n                        <p ng-if="newUserForm.lastName.$error.required" class="help-block">required</p>\n                      </div>\n                    </div>\n                    <div class="col-md-4" ng-class="{ \'has-error\' : newUserForm.email.$invalid && newUserForm.submitted}">\n                      <label for="email" class="control-label label-sm">Email Address</label>\n                      <input class="form-control input-sm" id="email" name="email" type="text" placeholder="" ng-model="vm.newUser.email" account-Email\n                        required ng-disabled="vm.isProcessing" pcm-class-on-value="filled" />\n                      <div ng-if="newUserForm.submitted">\n                        <p ng-if="newUserForm.email.$error.required" class="help-block">required</p>\n                        <p ng-if="newUserForm.email.$error.accountEmail" class="help-block">Not a valid email</p>\n                      </div>\n                    </div>\n                    <div class="col-md-2">\n                      <button type="submit" class="btn btn-sm btn-success" ng-disabled="vm.isProcessing">Add</button>\n                    </div>\n                  </div>\n                </form>\n\n                <h4 class="field-section">Current Users</h4>\n                <div class="row form-group">\n                  <div class="col-md-12">\n                    <table class="table table-bordered table-condensed">\n                      <thead>\n                        <tr>\n                          <th style="width: 100px;">Name</th>\n                          <th style="width: 150px;">Email (username)</th>\n                          <th class="text-center">Account<br />Administrator</th>\n                          <th class="text-center">Remove</th>\n                          <th class="text-center">Replace</th>\n                        </tr>\n                      </thead>\n                      <tbody>\n                        <tr ng-repeat="user in vm.account.users">\n                          <td style="width: 100px; max-width: 100px;" class="fixed">{{user.FullName}}</td>\n                          <td style="width: 150px; max-width: 150px;" class="fixed">{{user.UserName}}</td>\n                          <td class="text-center" style="position:relative;">\n                            <div class="loading-overlay" ng-show="user.isProcessing">\n                              <i class="ico ico-circle-notch ico-spin"></i>\n                            </div>\n                            <input ng-hide="user.isProcessing" type="checkbox" ng-model="user.isAdmin" ng-disabled="userInfo.userName === user.UserName || vm.isProcessing || userInfo.hasBillingIssue || userInfo.checkCreditExpiration()"\n                              ng-click="vm.toggleAdminRole(user)">\n                          </td>\n                          <td class="text-center">\n                            <button class="btn btn-default btn-xs" ng-click="vm.deleteUser(user)" ng-disabled="vm.isProcessing || userInfo.userName === user.UserName || userInfo.hasBillingIssue || userInfo.checkCreditExpiration()"><i class="ico ico-trash trash"></i></button>\n                          </td>\n                          <td class="text-center">\n                            <button class="btn btn-default btn-xs" ng-click="vm.replaceUser(user)" ng-disabled="vm.isProcessing || userInfo.hasBillingIssue || userInfo.checkCreditExpiration()"><i class="ico ico-user"></i></button>\n                          </td>\n                        </tr>\n                      </tbody>\n                    </table>\n                    <ul uib-pagination total-items="vm.usersTotalCount" ng-model="vm.usersCurrentPage" class="pagination-sm" ng-change="vm.usersPageChanged()"\n                      items-per-page="{{vm.usersPerPage}}" ng-show="vm.usersTotalCount > vm.usersPerPage"></ul>\n                  </div>\n                </div>\n              </fieldset>\n            </div>\n\n            <div class="col-md-6 left-border">\n              <form name="accountForm" pcm-submit="vm.submitAccountFeatures()" novalidate>\n                <fieldset>\n                  <legend class="page-header">Subscription Info</legend>\n                  <div class="form-group col-md-12 trial" ng-show="userInfo.accountType === \'Trial\'">\n                    <div class="col-md-12 trial-info alert alert-warning alert-sm" ng-show="!userInfo.expired">\n                      <strong>TRIAL ACCOUNT</strong>\n                      <span>Expires {{userInfo.expirationDate | moment:\'fromNow\'}}</span><br />\n                      <span>{{userInfo.remainingRoutes}} Remaining routes</span>\n                    </div>\n                    <div class="col-md-12 trial-info alert alert-danger alert-sm" ng-show="userInfo.expired">\n                      <strong>TRIAL ACCOUNT EXPIRED</strong>\n                      <span ng-show="userInfo.isAdmin()">Sign up for a paid plan to continue</span>\n                      <span ng-show="!userInfo.isAdmin()">Contact your company\'s account administrator</span>\n                    </div>\n                  </div>\n                  <div class="form-group col-md-12 trial" ng-show="userInfo.subscriptionLevel === \'Premium\' || userInfo.subscriptionLevel === \'Standard\'">\n                   \n                    <div class="col-md-12 trial-info alert alert-danger alert-sm" ng-show="(userInfo.isMonthlyPaidCustomer && userInfo.checkCreditExpiration())">\n                      <strong> {{userInfo.subscriptionLevel}} ACCOUNT EXPIRED.</strong>\n                      <span >To avoid disruption of this service, please contact your Company Administrator to update your card information. If the card information is not updated, your account access will be disabled.</span>\n                     \n                    </div>\n                  </div>\n                  <div class="form-group row">\n                    <div class="col-md-6">\n                      <label for="accountName" class="control-label label-sm">Account Name</label>\n                      <input id="accountName" name="accountName" class="form-control input-sm" type="text" ng-model="userInfo.account" readonly="readonly"\n                        disabled pcm-class-on-value="filled" />\n                    </div>\n                    <div class="col-md-6">\n                      <label for="userName" class="control-label label-sm">User Name</label>\n                      <input id="userName" name="userName" class="form-control input-sm" type="text" ng-model="userInfo.userName" readonly="readonly"\n                        disabled pcm-class-on-value="filled" />\n                    </div>\n                  </div>\n\n\n\n                  <div ng-if="!userInfo.isAdmin() || !userInfo.isMonthlyPaidCustomer || userInfo.isInvoiced">\n                    <h4 class="field-section">Feature Level</h4>\n                    <div class="row form-group">\n                      <div class="col-md-4">\n                        <p class="form-control-static input-sm" style="margin-top: 1px;">\n                          <span class="ng-cloak" ng-bind="vm.featureLevel.featureLevel"></span>\n                          <span class="ico ico-info-circle" tooltip-placement="right" uib-tooltip="Your Account Administrator can change the feature level."></span>\n                        </p>\n                        <label class="control-label label-sm"><a href="/features" target="_blank">View full feature list</a></label>\n                      </div>\n                    </div>\n\n                    <div class="form-group row ng-cloak trial" ng-if="userInfo.netSuiteOnline && userInfo.creditExpiresSoon() && !userInfo.hasBillingIssue && !userInfo.checkCreditExpiration()" ng-cloak>\n                      <div class="col-md-12 trial-info alert alert-warning alert-sm">\n                        <strong>BILLING WARNING</strong>\n                        <span>The credit card that is registered with PC*MILER Web\'s Credit Card payment is scheduled to expire soon. To avoid disruption of this service, please contact your Company Administrator to update your card information. If the card information is not updated, your account access will be disabled.</span>\n                      </div>\n                    </div>\n\n                    <div class="form-group row ng-cloak trial" ng-if="userInfo.hasBillingIssue && !userInfo.checkCreditExpiration()" ng-cloak>\n                      <div class="col-md-12 trial-info alert alert-danger alert-sm">\n                        <strong>BILLING ISSUE</strong>\n                        <span>There were billing issues with the credit card that is registered to PC*MILER Web\'s Credit Card Payment. To reinstate your account access, please contact your Company Administrator to update your card information.</span>\n                      </div>\n                    </div>\n                  </div>\n\n                  <!-- only monthly non-invoiced customers can update billing in account page -->\n                  <div ng-if="userInfo.isAdmin() && userInfo.isMonthlyPaidCustomer && !userInfo.isInvoiced">\n                    <h4 class="field-section">Feature Level</h4>\n                    <div class="form-group row">\n                      <div class="col-md-6" ng-class="{ \'has-error\' : accountForm.featureLevel.$invalid && (!accountForm.featureLevel.$pristine || accountForm.submitted) }">\n                        <label for="featureLevel" class="control-label label-sm">Choose a Feature Level<br /><a href="/features" target="_blank">View full feature list</a></label>\n                        <select id="featureLevel" name="featureLevel" ng-options="feature.name as (feature.name + \' ($\' + feature.cost + \'/month per user)\') for feature in vm.featureLevelInfo"\n                          class="form-control input-sm" ng-model="vm.featureLevel.featureLevel" required ng-disabled="vm.isProcessing"\n                          ng-change="vm.featureLevelChanged()" pcm-class-on-value="filled"></select>\n                        <p ng-show="accountForm.featureLevel.$error.required && (!accountForm.featureLevel.$pristine || accountForm.submitted)" class="help-block">Feature Level is required</p>\n                      </div>\n                      <div class="col-md-3">\n                        <label class="control-label label-sm">Number of Users </br></label>\n                        <input type="number" min="{{vm.usersTotalCount}}" class="form-control input-sm" ng-model="vm.featureLevel.newNumberOfUsers"\n                          ng-disabled="vm.featureLevel.featureLevel === \'Trial\' || vm.isProcessing" pcm-class-on-value="filled"\n                        />\n                      </div>\n\n                      <div class="col-md-3">\n                        <label class="control-label label-sm label-static">Total Cost/Month </br></label>\n                        <p class="form-control-static input-sm"><span class="ng-cloak" ng-bind="\'$\' + (vm.featureLevel.newNumberOfUsers * vm.featureLevelCost()).toFixed(2)"\n                            ng-show="vm.featureLevel.newNumberOfUsers"></span></p>\n                      </div>\n                    </div>\n\n                    <h4 class="field-section">Billing Address</h4>\n                    <div class="account-panel">\n                      <div class="ng-cloak loading-overlay" ng-cloak ng-show="vm.loadingPayment">\n                        <span><i class="ico ico-circle-notch ico-spin"></i> Loading...</span>\n                      </div>\n\n                      <billing-address ng-model="vm.billing" ng-disabled="vm.isProcessing" template="/app/account/billing_address.html"></billing-address>\n                    </div>\n\n                    <div class="form-group row ng-cloak" ng-show="userInfo.netSuiteOnline && userInfo.creditExpiresSoon() && !userInfo.hasBillingIssue" ng-cloak style="margin-top: 20px; margin-bottom: -20px;">\n                      <div class="col-md-12 trial-info alert alert-warning alert-sm">\n                        <strong>BILLING WARNING</strong>\n                        <span>The credit card that is registered with PC*MILER Web\'s Credit Card payment ending in <span class="ng-cloak" ng-cloak ng-bind="vm.originalCreditCard.last4Digits"></span>                        is scheduled to expire soon. To avoid disruption of this service, update your card information. If\n                        you do not update your information, your account access will be disabled.</span>\n                      </div>\n                    </div>\n\n                    <div class="form-group row ng-cloak" ng-show="userInfo.hasBillingIssue && !userInfo.checkCreditExpiration()" ng-cloak style="margin-top: 20px; margin-bottom: -20px;">\n                      <div class="col-md-12 trial-info alert alert-danger alert-sm">\n                        <strong>BILLING ISSUE</strong>\n                        <span>There were billing issues with the credit card that is registered with PC*MILER Web\'s Credit Card payment ending in <span class="ng-cloak" ng-cloak ng-bind="vm.originalCreditCard.last4Digits"></span>.\n                        Please update your card information to reinstate your account access.</span>\n                      </div>\n                    </div>\n\n                    <h4 class="field-section">Payment Method</h4>\n                    <div class="account-panel">\n                      <div class="ng-cloak loading-overlay" ng-cloak ng-show="vm.loadingPayment">\n                        <span><i class="ico ico-circle-notch ico-spin"></i> Loading...</span>\n                      </div>\n                      <billing-information ng-model="vm.creditCard" ng-disabled="vm.isProcessing" card-dirty="vm.creditCardDirty" show-errors-on-load="{{userInfo.hasBillingIssue}}"\n                        ng-required="vm.shouldSubmitCreditCard()"></billing-information>\n                    </div>\n\n                    <div class="form-group row">\n                      <div class="col-md-12">\n                        <button type="submit" class="btn btn-sm btn-success pull-right" style="margin-top: 10px;" ng-disabled="vm.isProcessing || vm.loadingPayment">\n                            <i ng-show="vm.isSubmittingAccountFeatures" class="ico ico-circle-notch ico-spin ng-cloak" ng-cloak></i>Update Billing\n                        </button>\n                      </div>\n                    </div>\n                  </div>\n\n                  <div ng-if="userInfo.isAdmin() && (!userInfo.isMonthlyPaidCustomer || userInfo.isInvoiced)">\n                    <div class="row form-group">\n                      <div class="col-md-12">\n                        <p class="small">\n                          Please contact Trimble Maps Support at support@trimblemaps.com to make billing changes to your account.\n                        </p>\n                      </div>\n                  </div>\n                </fieldset>\n              </form>\n              <div class="billing-screen-overlay" ng-if="!userInfo.netSuiteOnline" ng-cloak>\n                <span class="billing-screen-overlay-message">\n                  We are experiencing some technical issues with our billing system integration. <br />\n                  We are actively working on a fix. <br />\n                  There is no action required on your part.\n                </span>\n              </div>\n            </div>\n          </div>\n\n          <div class="row" ng-if="userInfo.isAdmin()">\n            <div class="col-md-12">\n              <form name="cancelAccountForm" pcm-submit="vm.cancelCustomer()" novalidate>\n                <fieldset>\n                  <legend class="page-header" ng-bind="(userInfo.accountType === \'Trial\')?\'Cancel Account\':\'Cancel Billing\'"></legend>\n                  <div class="form-group row">\n                    <div class="col-md-12">\n                      <p class="small" ng-bind="(userInfo.accountType === \'Trial\')?\'If you cancel the account, your access to the account will be disabled immediately.\':\'Cancelling billing will stop new charges and your access to the account will be disabled immediately. Please note that no refund will be issued for completed payments.\'"></p>\n                    </div>\n                  </div>\n                  <div class="form-group row">\n                    <div class="col-md-12">\n                      <button type="submit" class="btn btn-default btn-sm pull-left" ng-disabled="vm.isProcessing || !userInfo.netSuiteOnline"><i ng-show="vm.isProcessing && cancelAccountForm.submitted" class="ico ico-circle-notch ico-spin ng-cloak" ng-cloak></i> <span ng-bind="(vm.featureLevel.featureLevel === \'Trial\')?\'Cancel Account\':\'Cancel Billing\'"></span></button>\n                    </div>\n                  </div>\n\n                </fieldset>\n              </form>\n            </div>\n          </div>\n        </div>\n        <div>\n          <a href="/app">\n            <button ng-if="userInfo.isTrialValid() && !userInfo.hasBillingIssue && !((userInfo.isMonthlyPaidCustomer || !user.isInvoiced) && userInfo.checkCreditExpiration())" class="pull-right btn btn-md btn-primary" ng-disabled="vm.isProcessing">Close and Return</button>\n          </a>\n        </div>\n      </div>\n      \n    </div>\n  </div>\n  <map-footer app="PCMWebUI"></map-footer>\n</div>');
  $templateCache.put('/pages/contactErrorPage.html', '\n\n<div class="container">\n    <div class="panel main-panel">\n        <div class="page-header" ng-include="\'/app/layout/pageHeader.template.html\'"></div>\n        <div class="page-content forms-content">\n            <div class="row">\n                <div class="col-md-8 col-md-offset-2">\n                    <h3 style="margin-bottom: 40px; margin-top:40px">There was a problem with your submission please go back and try again.</h3>\n                    \n                </div>\n            </div>\n        </div>\n    </div>\n    <div ng-include="\'/app/layout/page_footer.html\'"></div>\n</div>\n');
  $templateCache.put('/pages/contactPage.html', '\n\n<div class="container">\n    <div class="panel main-panel">\n        <div class="page-header" ng-include="\'/app/layout/pageHeader.template.html\'"></div>\n        <div class="page-content forms-content">\n            <div class="row">\n                <div class="col-md-8 col-md-offset-2">\n                    <h3 style="margin-bottom: 40px; margin-top:40px">Contact Us for More Information</h3>\n                    <p>You can contact the PC*MILER Sales Department Mon - Fri, 9:00AM to 5:30PM EST<br/>\n                    Toll Free:  800-377-6453, ext 1<br/>\n                    Phone:  609-683-0220, ext 1</p>\n                    <p><br/><strong>Or fill in your contact information and we will get back to you.</strong></p>\n                    <form action="http://info.alk.com/l/43342/2015-02-04/91rlc" method="post">\n                        <div class="form-group row">\n                            <div class="col-md-12">\n                                <textarea id="QuestionsComments" name="QuestionsComments" class="form-control input-sm input-line" ng-model="contactquestions" pcm-class-on-value="filled"></textarea>\n                                <label for="QuestionsComments" class="control-label label-sm label-line label-line">Question or Comments</label>\n                            </div>\n                        </div>\n                        <div class="form-group row">\n                            <div class="col-md-6">\n                                <input id="email" name="email" class="form-control input-sm input-line" type="text" pcm-email required ng-model="contactemail" pcm-class-on-value="filled" />\n                                <label for="email" class="control-label label-sm label-line label-line">Email Address (required)</label>\n                            </div>\n                        </div>\n\n                        <div class="form-group row">\n                            <div class="col-md-6">\n                                <input id="FirstName" name="FirstName" class="form-control input-sm input-line" type="text" required ng-model="contactfirst" pcm-class-on-value="filled" />\n                                <label for="FirstName" class="control-label label-sm label-line label-line">First Name (required)</label>\n                            </div>\n\n                            <div class="col-md-6">\n                                <input id="LastName" name="LastName" class="form-control input-sm input-line" type="text" required ng-model="contactlast" pcm-class-on-value="filled" />\n                                <label for="LastName" class="control-label label-sm label-line label-line">Last Name (required)</label>\n                            </div>\n                        </div>\n\n                        <div class="form-group row">\n                            <div class="col-md-6">\n                                <input id="Company" name="Company" class="form-control input-sm input-line" type="text" ng-model="contactcompany" pcm-class-on-value="filled" />\n                                <label for="Company" class="control-label label-sm label-line label-line">Company</label>\n                            </div>\n\n                            <div class="col-md-6">\n                                <input id="Title" name="Title" class="form-control input-sm input-line" type="text" ng-model="contacttitle" pcm-class-on-value="filled" />\n                                <label for="Title" class="control-label label-sm label-line label-line">Title</label>\n                            </div>\n                        </div>\n\n                        <div class="form-group row">\n                            <div class="col-md-6">\n                                <input id="Phone" name="Phone" class="form-control input-sm input-line" type="text" required ng-model="contactphone" pcm-class-on-value="filled" />\n                                <label for="Phone" class="control-label label-sm label-line label-line">Phone Number (required)</label>\n                            </div>\n                        </div>\n\n                        <div class="form-group row">\n                            <div class="col-md-6">\n                                <select name="CompanyType" id="CompanyType" class="form-control input-sm input-line" required ng-model="contactcompanytype" pcm-class-on-value="filled">\n                                    <option value="" selected="selected"></option>\n                                    <option value="49060">Owner Operator</option>\n                                    <option value="49062">Company Driver</option>\n                                    <option value="49064">Motor Carrier</option>\n                                    <option value="49066">Private Fleet</option>\n                                    <option value="49068">Courier</option>\n                                    <option value="49070">Manufacturer</option>\n                                    <option value="49072">Logistics</option>\n                                    <option value="49074">Brokerage</option>\n                                    <option value="49076">Freight Forwarding</option>\n                                    <option value="49078">Consultant</option>\n                                    <option value="49080">Software Developer</option>\n                                    <option value="49082">Other</option>\n                                </select>\n                                <label for="CompanyType" class="control-label label-sm label-line label-line">Company Type (required)</label>\n                            </div>\n\n                            <div class="col-md-6">\n                                <input id="NumberofTrucks" name="NumberofTrucks" class="form-control input-sm input-line" type="number" ng-model="contactnumtrucks" pcm-class-on-value="filled" />\n                                <label for="NumberofTrucks" class="control-label label-sm label-line label-line">Number of Trucks (required)</label>\n                            </div>\n                        </div>\n                        <div class="form-group row">\n                            <div class="col-md-12">\n                                <button type="submit" class="btn btn-success pull-right">Submit</button>\n                            </div>\n                        </div>\n                    </form>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div ng-include="\'/app/layout/page_footer.html\'"></div>\n</div>\n');
  $templateCache.put('/pages/contactSuccessPage.html', '\n\n<div class="container">\n    <div class="panel main-panel">\n        <div class="page-header" ng-include="\'/app/layout/pageHeader.template.html\'"></div>\n        <div class="page-content forms-content">\n            <div class="row">\n                <div class="col-md-8 col-md-offset-2">\n                    <h3 style="margin-bottom: 40px; margin-top:40px">Your information has been received.  Thank you for contacting us, we will be in touch soon.</h3>\n                    \n                </div>\n            </div>\n        </div>\n    </div>\n    <div ng-include="\'/app/layout/page_footer.html\'"></div>\n</div>\n');
  $templateCache.put('/pages/faqPage.html', '\n\n<div class="container">\n    <div class="panel main-panel">\n        <div class="page-header" ng-include="\'/app/layout/pageHeader.template.html\'"></div>\n        <div class="page-content">\n            <div class="hero-container" style="max-height:300px;">\n                <img src="/img/faq-hero.jpg" style="width: 100%;" />\n            </div>\n            <h3 style="margin-bottom: 40px; margin-top:40px">Is PC*MILER|Web right for me?</h3>\n\n            <div class="row ">\n                <div class="col-md-6">\n                    <p>\n                        <b>First and foremost if you need to protect your most valuable assets\u2014your trucks and their contents\u2014then PC*MILER|Web is a must. </b>\n                        Truck restrictions and low clearances/overpasses can cause a lot of headaches\u2014not just in terms of costly fines, but also in damage to your expensive equipment. Protect your assets with the most trusted truck routing system on the market today.\n                    </p>\n                </div>\n                <div class="col-md-6">\n                    <p>\n                        <b>If you have a mobile work force that has limited access to the back office, PC*MILER|Web provides quick and easy access to the tools your team needs, wherever they are. </b>\n                        It\u2019s perfect for smaller sized companies that don\u2019t have the ability to maintain costly software and hardware.\n                    </p>\n                </div>\n            </div>\n\n            <hr />\n\n\n            <h3 style="margin-bottom: 40px;">Benefits by Company Type</h3>\n\n            <div class="row text-boxes">\n                <div class="col-md-4">\n                    <h5 class="col-header">Small Fleets</h5>\n                    <ul>\n                        <li> Use PC*MILER|Web as your complete, affordable online fleet management system. </li>\n                        <li> Manage every aspect of your business, including load planning, dispatch, driver pay, billing, and fuel tax reporting</li>\n                        <li> Reduce your out-of-route and empty fleet mileage.</li>\n                    </ul>\n                </div>\n\n                <div class="col-md-4">\n                    <h5 class="col-header">Owner Operators </h5>\n                    <ul>\n                        <li> Bill using industry standard mileage, and use maps and driving directions that take into account truck and trailer restrictions. </li>\n                        <li> Manage all of your applications online, from rate calculation to fuel tax reporting.</li>\n                        <li> Reduce your out-of-route and empty mileage.</li>\n                    </ul>\n                </div>\n\n                <div class="col-md-4">\n                    <h5 class="col-header">Company Drivers </h5>\n                    <ul>\n                        <li> Verify your driver pay using industry standard mileage. </li>\n                        <li> Access maps and driving directions that take into account truck and trailer restrictions. </li>\n                        <li> Reduce your out-of-route and empty mileage.</li>\n                    </ul>\n                </div>\n            </div>\n            <div class="row text-boxes">\n                <div class="col-md-4">\n                    <h55 class="col-header">Shippers </h55>\n                    <ul>\n                        <li> Get the miles you need for quick and easy load planning, freight rate calculation, and freight bill auditing.</li>\n                    </ul>\n                </div>\n\n                <div class="col-md-4">\n                    <h5 class="col-header">Brokers </h5>\n                    <ul>\n                        <li> Access PC*MILER\u2019s features without the installation of a full-fledged routing and mileage program on your PC, workstation, laptop or network server. </li>\n                    </ul>\n                </div>\n\n                <div class="col-md-4">\n                    <h5 class="col-header">Logistics Companies (3PLs) </h5>\n                    <ul>\n                        <li> Get the miles and drive times you need for bid preparation, carrier selection, lane analysis, and freight bill auditing.</li>\n                    </ul>\n                </div>\n\n            </div>\n            <hr />\n            <h3 style="margin-bottom: 40px;">Frequently Asked Questions</h3>\n            <div class="faq-container">\n                <uib-accordion close-others="true">\n                    <uib-accordion-group heading="What is the difference between PC*MILER|Web and PC*MILER?">\n                        <p>\n                            PC*MILER|Web is an online, web-based version of PC*MILER routing, mileage, and mapping software. You only need a web browser and an Internet connection to\n                            access PC*MILER|Web and there is nothing to install. You can purchase subscriptions online to access the database and core functionality and updates are\n                            automatically provided online. <a href="/features">View the complete list of PC*MILER|Web features</a>\n</p>\n                    </uib-accordion-group>\n                    <uib-accordion-group heading="When is it better to install PC*MILER rather than access PC*MILER|Web over the Internet?">\n\n                        <ul>\n                            <!--<li>\n                                You need to compare multiple routes on the map and in reports &#8211; PC*MILER allows users to run and compare up to 8 routes at a time, while\n                                PC*MILER|Web only allows for a single route to be run.\n                            </li>-->\n                            <li>\n                                You want to import a list of pickup/delivery or other company-specific locations &#8211; PC*MILER allows users to import an unlimited number of custom\n                                places, whereas there is no import functionality in PC*MILER|Web.\n                            </li>\n                            <li>\n                                You need to customize routes by applying your own avoid and favor preferences to road segments, entire roads or an entire jurisdiction &#8211; PC*MILER\n                                allows users to add these map customizations, whereas the PC*MILER|Web map does not.\n                            </li>\n                            <li>\n                                You need to search for locations in the database within a specified mileage radius around any location &#8211; PC*MILER&#8217;s Location Radius Tool\n                                provides this functionality, whereas this feature is not included in PC*MILER|Web.\n                            </li>\n                            <li>\n                                You\'d prefer to have an installed routing, mileage and mapping solution &#8211; PC*MILER|Web can only be accessed through an Internet connection, while\n                                PC*MILER can be installed in a Windows, AS/400, CICS, Unix or Linux environment.\n                            </li>\n                            <li>\n                                You want to calculate alternative rail intermodal routes between an origin and designation to compare truck vs. rail mileage, fuel consumption, and\n                                carbon emissions per route &#8211; PC*MILER includes an Intermodal Analysis tool, accessed through PC*MILER|Spreadsheets, that connects the PC*MILER\n                                and PC*MILER|Rail databases together for this purpose, whereas PC*MILER|Web does not have a connection to a spreadsheet application nor does it include\n                                access to Intermodal Analysis.\n                            </li>\n                            <li>\n                                You need to interface PC*MILER with a third-party system. PC*MILER|Web has no interfacing options. <a href="http://www.pcmiler.com/integration.aspx">Learn more about PC*MILER&#8217;s Integration Solutions</a>\n                            </li>\n                            <li>\n                                You&#8217;d rather pay once for unlimited access &#8211; PC*MILER is priced on a one-time fee with the option of signing up for our Annual Support and\n                                Update Program to receive new version releases at a reduced rate, where PC*MILER|Web is charged on a monthly basis to be able to access the site.\n                            </li>\n                        </ul>\n                        <p>\n                            <a href="http://www.pcmiler.com/products/pcmiler.aspx">Learn more about PC*MILER</a>\n                        </p>\n                    </uib-accordion-group>\n                    <uib-accordion-group heading="What is included with the free trial offer?">\n                        <p>\n                            The free trial provides full access to all of PC*MILER|Web&#8217;s features for up to 7 days or for the generation of 35 routes, whichever occurs first.\n                            You are under no obligation to purchase a subscription once the free trial has finished. You will not be automatically billed, unless requested. When you\n                            are finished with your trial, you will be asked if you&#8217;d like to purchase a Standard or Premium subscription to PC*MILER|Web.\n                        </p>\n                    </uib-accordion-group>\n                    <uib-accordion-group heading="How much does PC*MILER|Web cost? ">\n                        <p>\n                            Subscriptions start at just $59.99 per month (applicable sales taxes apply). <a href="/features">View pricing information</a>\n                        </p>\n                    </uib-accordion-group>\n                    <uib-accordion-group heading="I tried to purchase a PC*MILER|Web subscription but was not able to do so. What should I do?">\n                        <p>\n                            When purchasing a subscription you must enter your credit card billing address exactly as it appears on your monthly statement. If you\'ve entered your\n                            credit card information incorrectly, you must wait at least 48 hours to resubmit your information. This is a security measure designed to protect you. If\n                            you are still having trouble, please <a href="mailto:pcmsupport@alk.com?subject=PC*MILER%20Web%20Support%20Request">contact technical support</a> for\n                            assistance.\n                        </p>\n                    </uib-accordion-group>\n                    <uib-accordion-group heading="I having trouble logging in or I forgot my username and/or password. What should I do?">\n                        <p>\n                            You can obtain your user name and password from PC*MILER|Web by clicking the <a href="/forgotPassword">Forgot your password </a>link located on the login page. Enter the email\n    address you used when creating your account and we\'ll send your information to that address. If you are still having trouble, please <a href="mailto:pcmsupport@alk.com?subject=PC*MILER%20Web%20Forgot%20Password">contact technical support</a> for assistance.\n</p>\n                    </uib-accordion-group>\n\n                    <uib-accordion-group heading="Do you have a multi-user option and what does it cost?">\n                        <p>\n                        Yes, users can set up sub-users on an existing account. Note:There is an additional charge for each additional user added to an account  (applicable sales taxes apply).\n                        </p>\n                    </uib-accordion-group>\n                    <uib-accordion-group heading="Does PC*MILER|Web have street-level routing?">\n                        <p>\n                            Yes, the Premium subscription of PC*MILER|Web does have street-level routing. <a href="http://www.pcmiler.com/products/pcmiler-streets.aspx">Learn more about PC*MILER|Streets</a>\n</p>\n                    </uib-accordion-group>\n                    <uib-accordion-group heading="I need to integrate PC*MILER with my TMS, ERP or custom built system. Can I do this with PC*MILER|Web?">\n                        <p>\n                            No PC*MILER|Web does not offer integration options but there are several interfacing solutions available with other PC*MILER solutions.    <a href="http://www.pcmiler.com/integration.aspx">Learn more about PC*MILER&#8217;s Integration Solutions</a>\n                        </p>\n                    </uib-accordion-group>\n                    <uib-accordion-group heading="What web browsers are supported?">\n                        <p>\n                            PC*MILER|Web supports the following web browsers: Internet Explorer 9+, Firefox, and Google Chrome. If you are running an older version, please upgrade.\n                        </p>\n                    </uib-accordion-group>\n                </uib-accordion>\n\n            </div>\n        </div>\n    </div>\n    <div ng-include="\'/app/layout/page_footer.html\'"></div>\n</div>\n');
  $templateCache.put('/pages/featuresPage.html', '<div class="marketing-page login-page login-pcmweb">\n  <div class="marketing-page-header">\n    <div class="container">\n      <div class="row">\n        <div class="col-sm-12">\n          <a href="/"><img src="/img/PCMILER-Web_Logo_reversed.svg" alt="PC*MILER Web" class="page-logo"></a>\n        </div>\n        <h1 class="page-title">Features &amp; Pricing</h1>\n      </div>\n    </div>\n  </div>\n  <div class="pricing-section">\n    <div class="container">\n      <div class="row">\n        <div class="col-sm-12">\n          <!-- <h2>\n            PC*MILER Web is available to purchase on a monthly subscription basis. Feature sets vary depending on solution level. See\n            below for detail on what is included in each level.\n          </h2>\n          <h3 style="margin-bottom: 40px;">\n            Solution Level Pricing\n          </h3> -->\n          <div class="row pricing-table">\n            <div class="col-sm-offset-2 col-sm-4">\n              <table class="table free">\n                <tr class="price-title">\n                  <td>\n                    <p class="trial" for="account_type_trial">Trial</p>\n                  </td>\n                </tr>\n                <tr>\n                  <td>\n                    <p class="price">Free</p>\n                    <p class="price-note">for one user</p>\n                  </td>\n                </tr>\n                <tr>\n                  <td>\n                    <p class="price-features">Access to <strong>All Features</strong> for<br />7 days or 35 routes</p>\n                  </td>\n                </tr>\n                <tr>\n                  <td>\n                    <div class="text-center">\n                      <a href="/signup?featureLevel=Trial" class="btn btn-lg btn-warning">Get a Free Trial</a>\n                    </div>\n                  </td>\n                </tr>\n              </table>\n            </div>\n\n            <div class="col-sm-4">\n              <table class="table premium selected">\n                <tr class="price-title">\n                  <td>\n                    <p class="premium" for="account_type_premium">Premium</p>\n                  </td>\n                </tr>\n                <tr>\n                  <td>\n                    <p class="price">$84.99</p>\n                    <p class="price-note">a month per user</p>\n                  </td>\n                </tr>\n                <tr>\n                  <td>\n                    <p class="price-features">\n                      <strong>Full Service Set</strong><br/> of comprehensive routing options<br/> and planning tools with:<br\n                      />\n                      <small>Real-time traffic &amp; weather display</small>\n                      <small>Quarterly map &amp; toll data updates</small>\n                      <small>Street-level routing in the U.S. &amp; Canada</small>\n                    </p>\n                  </td>\n                </tr>\n                <tr>\n                  <td>\n                    <div class="text-center">\n                      <a href="/signup?featureLevel=Premium" class="btn btn-lg btn-success">Get Premium</a>\n                    </div>\n                  </td>\n                </tr>\n              </table>\n            </div>\n          </div>\n\n          <p class="text-center">\n            We accept <strong>Visa, MasterCard, and American Express</strong> credit cards. All credit card information is\n            confidential and securely transmitted online.*\n          </p>\n          <p class="text-center">\n            <em>*Applicable sales taxes apply on all orders.</em>\n          </p>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class="features-section">\n    <div class="container">\n      <div class="row">\n        <div class="col-sm-offset-3 col-sm-6">\n\n          <h3 style="margin-bottom: 40px;">\n            Full Feature List\n          </h3>\n          <table class="table table-bordered table-condensed feature-table">\n            <thead>\n              <tr>\n                <th colspan="2" class="feature-table-section text-center">\n                  <p>Features</p>\n                </th>\n              </tr>\n            </thead>\n            <tbody>\n              <tr>\n                <td class="feature-table-section">Data</td>\n                <td>North American Routing Database</td>\n                <!-- <td><i class="ico ico-check-circle-o"></i></td>\n                <td><i class="ico ico-check-circle-o"></i></td> -->\n              </tr>\n              <tr>\n                <td class="feature-no-border">&nbsp;</td>\n                <td>U.S. ZIP Codes</td>\n                <!-- <td><i class="ico ico-check-circle-o"></i></td>\n                <td><i class="ico ico-check-circle-o"></i></td> -->\n              </tr>\n              <tr>\n                <td class="feature-no-border">&nbsp;</td>\n                <td>Canadian &amp; Mexican Postal Codes</td>\n                <!-- <td><i class="ico ico-check-circle-o"></i></td>\n                <td><i class="ico ico-check-circle-o"></i></td> -->\n              </tr>\n              <tr>\n                <td class="feature-no-border">&nbsp;</td>\n                <td>Standard Point Location Codes (SPLC)</td>\n                <!-- <td>&nbsp;</td>\n                <td><i class="ico ico-check-circle-o"></i></td> -->\n              </tr>\n              <tr>\n                <td class="feature-no-border">&nbsp;</td>\n                <td>Toll Costs by Vehicle Type</td>\n                <!-- <td>&nbsp;</td>\n                <td><i class="ico ico-check-circle-o"></i></td> -->\n              </tr>\n              <tr>\n                <td class="feature-no-border">&nbsp;</td>\n                <td>Predictive Traffic Speeds</td>\n                <!-- <td>&nbsp;</td>\n                <td><i class="ico ico-check-circle-o"></i></td> -->\n              </tr>\n              <tr>\n                <td class="feature-table-section">Routing Options</td>\n                <td>Multi-Stop Routing</td>\n                <!-- <td class="text-center">Origin + 9 Stops</td>\n                <td class="text-center">Origin + Unlimited</td> -->\n              </tr>\n              <tr>\n                <td class="feature-no-border">&nbsp;</td>\n                <td>Truck-Specific Routing</td>\n                <!-- <td><i class="ico ico-check-circle-o"></i></td>\n                <td><i class="ico ico-check-circle-o"></i></td> -->\n              </tr>\n              <tr>\n                <td class="feature-no-border">&nbsp;</td>\n                <td>Light Vehicle Routing</td>\n                <!-- <td>&nbsp;</td>\n                <td><i class="ico ico-check-circle-o"></i></td> -->\n              </tr>\n              <tr>\n                <td class="feature-no-border">&nbsp;</td>\n                <td>Practical Routing</td>\n                <!-- <td><i class="ico ico-check-circle-o"></i></td>\n                <td><i class="ico ico-check-circle-o"></i></td> -->\n              </tr>\n              <tr>\n                <td class="feature-no-border">&nbsp;</td>\n                <td>Shortest Routing</td>\n                <!-- <td><i class="ico ico-check-circle-o"></i></td>\n                <td><i class="ico ico-check-circle-o"></i></td> -->\n              </tr>\n              <tr>\n                <td class="feature-no-border">&nbsp;</td>\n                <td>Fastest Routing</td>\n                <!-- <td><i class="ico ico-check-circle-o"></i></td>\n                <td><i class="ico ico-check-circle-o"></i></td> -->\n              </tr>\n              <tr>\n                <td class="feature-no-border">&nbsp;</td>\n                <td>Hub Routing</td>\n                <!-- <td><i class="ico ico-check-circle-o"></i></td>\n                <td><i class="ico ico-check-circle-o"></i></td> -->\n              </tr>\n              <tr>\n                <td class="feature-no-border">&nbsp;</td>\n                <td>National Network Routing</td>\n                <!-- <td><i class="ico ico-check-circle-o"></i></td>\n                <td><i class="ico ico-check-circle-o"></i></td> -->\n              </tr>\n              <tr>\n                <td class="feature-no-border">&nbsp;</td>\n                <td>Toll Discouraged Routing</td>\n                <!-- <td><i class="ico ico-check-circle-o"></i></td>\n                <td><i class="ico ico-check-circle-o"></i></td> -->\n              </tr>\n              <tr>\n                <td class="feature-no-border">&nbsp;</td>\n                <td>Borders Open/Closed Routing</td>\n                <!-- <td><i class="ico ico-check-circle-o"></i></td>\n                <td><i class="ico ico-check-circle-o"></i></td> -->\n              </tr>\n              <tr>\n                <td class="feature-no-border">&nbsp;</td>\n                <td>Override Truck Restrictions</td>\n                <!-- <td><i class="ico ico-check-circle-o"></i></td>\n                <td><i class="ico ico-check-circle-o"></i></td> -->\n              </tr>\n              <tr>\n                <td class="feature-no-border">&nbsp;</td>\n                <td>By-Route Greenhouse Gas Estimator</td>\n                <!-- <td><i class="ico ico-check-circle-o"></i></td>\n                <td><i class="ico ico-check-circle-o"></i></td> -->\n              </tr>\n              <tr>\n                <td class="feature-no-border">&nbsp;</td>\n                <td>Set Default Routing Options</td>\n                <!-- <td><i class="ico ico-check-circle-o"></i></td>\n                <td><i class="ico ico-check-circle-o"></i></td> -->\n              </tr>\n              <tr>\n                <td class="feature-no-border">&nbsp;</td>\n                <td>Save Routes</td>\n                <!-- <td><i class="ico ico-check-circle-o"></i></td>\n                <td><i class="ico ico-check-circle-o"></i></td> -->\n              </tr>\n              <tr>\n                <td class="feature-no-border">&nbsp;</td>\n                <td>Duplicate Routes</td>\n                <!-- <td><i class="ico ico-check-circle-o"></i></td>\n                <td><i class="ico ico-check-circle-o"></i></td> -->\n              </tr>\n              <tr>\n                <td class="feature-no-border">&nbsp;</td>\n                <td>Define Departure or Arrival Date/Time</td>\n                <!-- <td>&nbsp;</i></td>\n                <td><i class="ico ico-check-circle-o"></i></td> -->\n              </tr>\n              <tr>\n                <td class="feature-no-border">&nbsp;</td>\n                <td>Set Governor (Maximum) Speed</td>\n                <!-- <td><i class="ico ico-check-circle-o"></i></td>\n                <td><i class="ico ico-check-circle-o"></i></td> -->\n              </tr>\n              <tr>\n                <td class="feature-no-border">&nbsp;</td>\n                <td>Multi-Stop Route Resequencing</td>\n                <!-- <td>&nbsp;</td>\n                <td><i class="ico ico-check-circle-o"></i></td> -->\n              </tr>\n              <tr>\n                <td class="feature-no-border">&nbsp;</td>\n                <td>Elevation Discouraged Routing</td>\n                <!-- <td>&nbsp;</td>\n                <td><i class="ico ico-check-circle-o"></i></td> -->\n              </tr>\n              <tr>\n                <td class="feature-no-border">&nbsp;</td>\n                <td>Add Stops with Single Search Field</td>\n                <!-- <td>&nbsp;</td>\n                <td><i class="ico ico-check-circle-o"></i></td> -->\n              </tr>\n              <tr>\n                <td class="feature-no-border">&nbsp;</td>\n                <td>Import Stops from File</td>\n                <!-- <td>&nbsp;</td>\n                <td><i class="ico ico-check-circle-o"></i></td> -->\n              </tr>\n              <tr>\n                <td class="feature-no-border">&nbsp;</td>\n                <td>Vehicle Dimensions Routing</td>\n                <!-- <td>&nbsp;</td>\n                <td><i class="ico ico-check-circle-o"></i></td> -->\n              </tr>\n              <tr>\n                <td class="feature-no-border">&nbsp;</td>\n                <td>Street-Level Routing in U.S. and Canada</td>\n                <!-- <td>&nbsp;</td>\n                <td><i class="ico ico-check-circle-o"></i></td> -->\n              </tr>\n              <tr>\n                <td class="feature-no-border">&nbsp;</td>\n                <td>Hazardous Materials Routing</td>\n                <!-- <td>&nbsp;</td>\n                <td><i class="ico ico-check-circle-o"></i></td> -->\n              </tr>\n              <tr>\n                <td class="feature-no-border">&nbsp;</td>\n                <td>Input of Stop Durations</td>\n                <!-- <td>&nbsp;</td>\n                <td><i class="ico ico-check-circle-o"></i></td> -->\n              </tr>\n              <tr>\n                <td class="feature-no-border">&nbsp;</td>\n                <td>Save Favorite Places</td>\n                <!-- <td>&nbsp;</td>\n                <td><i class="ico ico-check-circle-o"></i></td> -->\n              </tr>\n              <tr>\n                <td class="feature-no-border">&nbsp;</td>\n                <td>Drag-and-drop Routing</td>\n                <!-- <td>&nbsp;</td>\n                <td><i class="ico ico-check-circle-o"></i></td> -->\n              </tr>\n              <tr>\n                <td class="feature-no-border">&nbsp;</td>\n                <td>Route Modifiers</td>\n                <!-- <td>&nbsp;</td>\n                <td><i class="ico ico-check-circle-o"></i></td> -->\n              </tr>\n              <tr>\n                <td class="feature-no-border">&nbsp;</td>\n                <td>Site Routing with Entry/Exit Gates</td>\n                <!-- <td>&nbsp;</td>\n                <td><i class="ico ico-check-circle-o"></i></td> -->\n              </tr>\n              <tr>\n                <td class="feature-table-section">Reporting</td>\n                <td>State/Country Distance Report</td>\n                <!-- <td><i class="ico ico-check-circle-o"></i></td>\n                <td><i class="ico ico-check-circle-o"></i></td> -->\n              </tr>\n              <tr>\n                <td class="feature-no-border">&nbsp;</td>\n                <td>Summary by Road Type Report</td>\n                <!-- <td><i class="ico ico-check-circle-o"></i></td>\n                <td><i class="ico ico-check-circle-o"></i></td> -->\n              </tr>\n              <tr>\n                <td class="feature-no-border">&nbsp;</td>\n                <td>Driving Directions Report</td>\n                <!-- <td></td>\n                <td><i class="ico ico-check-circle-o"></i></td> -->\n              </tr>\n              <tr>\n                <td class="feature-no-border">&nbsp;</td>\n                <td>Detailed Route Reports</td>\n                <!-- <td></td>\n                <td><i class="ico ico-check-circle-o"></i></td> -->\n              </tr>\n              <tr>\n                <td class="feature-no-border">&nbsp;</td>\n                <td>Customized Route Costs</td>\n                <!-- <td></td>\n                <td><i class="ico ico-check-circle-o"></i></td> -->\n              </tr>\n              <tr>\n                <td class="feature-table-section">Mapping</td>\n                <td>Multiple Map Styles, including Satellite Imagery</td>\n                <!-- <td><i class="ico ico-check-circle-o"></i></td>\n                <td><i class="ico ico-check-circle-o"></i></td> -->\n              </tr>\n              <tr>\n                <td class="feature-no-border">&nbsp;</td>\n                <td>Route Display</td>\n                <!-- <td><i class="ico ico-check-circle-o"></i></td>\n                <td><i class="ico ico-check-circle-o"></i></td> -->\n              </tr>\n              <tr>\n                <td class="feature-no-border">&nbsp;</td>\n                <td>Real-Time Traffic Display</td>\n                <!-- <td>&nbsp;</td>\n                <td><i class="ico ico-check-circle-o"></i></td> -->\n              </tr>\n              <tr>\n                <td class="feature-no-border">&nbsp;</td>\n                <td>Real-Time Weather Information</td>\n                <!-- <td>&nbsp;</td>\n                <td><i class="ico ico-check-circle-o"></i></td> -->\n              </tr>\n              <tr>\n                <td class="feature-table-section">Services</td>\n                <td>Hosted in Data Center</td>\n                <!-- <td><i class="ico ico-check-circle-o"></i></td>\n                <td><i class="ico ico-check-circle-o"></i></td> -->\n              </tr>\n              <tr>\n                <td class="feature-no-border">&nbsp;</td>\n                <td>Annual Updates</td>\n                <!-- <td><i class="ico ico-check-circle-o"></i></td>\n                <td><i class="ico ico-check-circle-o"></i></td> -->\n              </tr>\n              <tr>\n                <td class="feature-no-border">&nbsp;</td>\n                <td>Map and Toll Data Updates</td>\n                <!-- <td>&nbsp;</td>\n                <td><i class="ico ico-check-circle-o"></i></td> -->\n              </tr>\n              <tr>\n                <td class="feature-no-border">&nbsp;</td>\n                <td>Multiple Version Support (Reports Only)</td>\n                <!-- <td>&nbsp;</td>\n                <td><i class="ico ico-check-circle-o"></i></td> -->\n              </tr>\n              <tr>\n                <td class="feature-no-border">&nbsp;</td>\n                <td>Live Chat</td>\n                <!-- <td>&nbsp;</td>\n                <td><i class="ico ico-check-circle-o"></i></td> -->\n              </tr>\n            </tbody>\n          </table>\n        </div>\n      </div>\n    </div>\n  </div>\n  <marketing-footer></marketing-footer>\n</div>\n');
  $templateCache.put('/pages/forgotPassword.html', '\n<div class="container">\n    <div class="panel col-md-push-3 col-md-6">\n        <div class="page-header" ng-include="\'/app/account/loginHeader.template.html\'"></div>\n        <div class="page-content">\n            <h1>Forgot Password</h1>\n            <div ng-controller="forgotPasswordController">\n                <pcm-messages></pcm-messages>\n\n                <form name="forgotPasswordForm" pcm-submit="submitForgotPassword()" novalidate role="form">\n                    <div class="form-group" ng-class="{ \'has-error\' : forgotPasswordForm.email.$invalid && forgotPasswordForm.submitted }">\n                        <input id="email" name="email" class="form-control" type="text" ng-model="email" pcm-email placeholder="Email" ng-disabled="isProcessing" required />\n                        <div ng-show="forgotPasswordForm.submitted">\n                            <p ng-show="forgotPasswordForm.email.$error.pcmEmail" class="help-block">Email is invalid.</p>\n                            <p ng-show="forgotPasswordForm.email.$error.required" class="help-block">Email is required.</p>\n                        </div>\n                    </div>\n                    <button type="submit" class="btn btn-primary" ng-disabled="isProcessing"><i ng-show="isProcessing" class="ico ico-circle-notch ico-spin ng-cloak" ng-cloak></i> <span ng-bind="(isProcessing)?\'Submitting...\':\'Submit\'"></span></button>\n                </form>\n            </div>\n        </div>\n    </div>\n</div>');
  $templateCache.put('/pages/landingPage.html', '<div class="marketing-page login-page login-pcmweb" ng-controller="landingController as vm">\n  <div ng-controller="pcmtidloginController">\n \n  \n  <div class="top-section pcmweb-top-section">\n  <div id="tmxtid-banner-component" class="tmxtid-init ">\n  </div>\n  <div class="modern-switch" ng-controller="pcmmodernController as pm">\n    <span class="col-sm-5 text-center" style="background-color:#FFF5E4;\n    border-color: #E49325; width:100%; border-width: 1px; border-style: solid; font-size: 14px;\n    color: black; padding: 10px; "><img src="/img/switch-alert.png" alt="Modern Switch">\n     <b style="font-weight:800;">&nbsp;We\'ve redesigned PC*MILER Web!</b> <a target="_self"  rel="noopener" style="color: #0063A3;font-weight:700;" href="{{pm.pcmModernSite}}">Check out the new version with the latest updates now!</a><br>\n     <b style="font-weight:800;">&nbsp;Last updated {{pm.lastDeploymentDate}},</b> <a target="_blank"  rel="noopener" style="color: #0063A3;font-weight:700;" href="https://support.pcmilerweb.com/en/support/solutions/articles/19000156886-2024-releases">see what\'s new!</a>\n    </span>\n  </div>\n    <div class="container">\n      <div class="row">\n        <div class="col-sm-10"><img src="/img/PCMILER-Web_Logo_reversed.svg" alt="PC*MILER Web" class="page-logo img-responsive"></div>\n        <div class="col-sm-2 text-right form-group">\n          <div alk-language-select></div>\n        </div>\n      </div>\n      <div class="row">\n        <div class="col-sm-6" style="padding-top: 30px;">\n          <h1 class="with-icon">\n        \n          <span class="landing-app-icon">\n            <img src="/img/cloud-menu-pcmweb.svg" alt="PC*MILER Web Icon">\n          </span>\n          <span translate={{\'views.login.PCMWebHeading\'}}> </span>\n            </h1>\n          <div class="callout">\n          <p class="subhead">{{\'views.login.PCMWebSubhead1\' | translate}}</p>\n          <!-- <p class="subhead">{{\'views.login.PCMWebSubhead2\' | translate}}</p> -->\n        </div>\n          <p class="subhead bullet"><span class="ico ico-check-circle-o"></span>{{\'views.login.PCMWebBullet1\' | translate}}</p>\n          <p class="subhead bullet"><span class="ico ico-check-circle-o"></span>{{\'views.login.PCMWebBullet2\' | translate}}</p>\n          <p class="subhead bullet"><span class="ico ico-check-circle-o"></span>{{\'views.login.PCMWebBullet3\' | translate}}</p>\n          <p class="subhead bullet"><span class="ico ico-check-circle-o"></span>{{\'views.login.PCMWebBullet4\' | translate}}</p>\n        </div>\n       \n        <div class="col-sm-5 col-sm-offset-1">\n          <div class="center-countdown">\n          <div id="tmxtid-countdown-component" class="tmxtid-init"></div>\n        </div>\n          <div class="login-box">\n            <!-- Log In -->\n            <div class="login-form" ng-show="vm.formTab === \'login\'">\n              <p class="login-title">{{\'common.landing.loginTitle\' | translate}}</p>\n              <p class="login-subhead visible-xs-block">Due to the comprehensive functionality of PC*MILER Web, it is <strong>not available on phones</strong>. Please log\n                in using a tablet, laptop, or desktop computer.</p>\n\n                <div id="tmxtid-sign-in-component" class="tmxtid-init"></div>\n                <div class="has-error">\n                  <p class="help-block" ng-show="showAccountDisabled">User or account is disabled</p>\n                  <p class="help-block" ng-show="showUserDisabled">Your account is not enabled. Please contact your Company Administrator.</p>\n                  <p class="help-block" ng-show="showPasswordIncorrect || showGenericError">Username or password is incorrect</p>\n                  <p class="help-block" ng-show="showNoAccountForApplication">Your login credentials do not have access to PC*MILER Interactive. Please Sign Up</p>\n                  <p class="help-block" ng-show="userNotExistError">This username does not exist. Please try a different email or <a href="https://maps.trimble.com/support/">contact support</a> for help.</p>\n                  <p class="help-block" ng-show="showAccountExpired">Failed to login. Your user or account has expired.</p>\n                </div>\n              <!-- Login form directive -->\n              <!-- <alk-login marketing-link="https://support.pcmiler.com/en/support/solutions/articles/19000063047-what-is-an-alk-id-or-copilot-id" controller-name="loginController"></alk-login> -->\n\n            </div>\n            <!-- Forgot Password -->\n            <div class="login-form" ng-show="vm.formTab === \'forgot\'">\n              <p class="login-title">{{"views.forgotPassword.Forgot Password" | translate}}</p>\n              <p class="login-subhead">{{"views.forgotPassword.Helptext" | translate}}</p>\n              <alk-forgot-password controller-name="forgotPasswordController"></alk-forgot-password>\n            </div>\n          </div>\n          <div class="login-cta-section text-center">\n              <a href="/features" class="btn btn-lg btn-success">Get Access</a>\n              <p class="availability text-center" style="font-size: 11pt; margin-bottom: 0px;">\n                Supported on Microsoft Edge, Firefox, and Google Chrome.\n              </p>\n              <p class="availability text-center" style="font-size: 11pt; margin: 0px; font-weight: 200;">\n                No longer supported on Internet Explorer\n              </p>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class="copilot-section">\n    <div class="container">\n      <div class="row">\n        <div class="col-sm-8 col-sm-offset-2 text-center">\n          <img class="copilot-icon" src="/img/CP_rounded-corners.png" alt="CoPilot" height="110" width="110" />\n          <h2>Take your plan on the road&hellip; Literally.</h2>\n          <p class="subhead">\n            Download CoPilot from Google Play or the App Store to any device and get consistent routes with navigation powered\n            by PC<span class="pcmiler-asterisk">*</span>MILER. <span style="font-weight: 600;"> Take a Test Drive </span>\n          </p>\n            <p class="text-center">\n              <a href="https://apps.apple.com/gb/app/copilot-gps-plan-explore-offline/id504677517?mt=8&ct=pcmilerweb"\n                target="_blank" rel="noopener">\n            <img src="/img/app-store.svg" alt="App Store" class="text-center app-store-badge" height="60" width="203">\n          </a>\n          <a href="https://play.google.com/store/apps/details?id=com.alk.copilot.mapviewer&amp;utm_source=pcmweb&amp;utm_medium=site" target="_blank" rel="noopener">\n            <img src="/img/googleplay.png" srcset="/img/googleplay@x2.png 2x" alt="Google Play" class="text-center app-store-badge" height="60" width="201">\n          </a>\n            </p>\n        </div>\n      </div>\n    </div>\n  </div>\n  </div>\n  <marketing-footer></marketing-footer>\n</div>');
  $templateCache.put('/pages/loginPage.html', '<div class="container">\n  <div class="panel col-md-push-3 col-md-6">\n    <div class="page-header" ng-include="\'/app/account/loginHeader.template.html\'"></div>\n    <div class="page-content forms-content">\n      <pcm-messages></pcm-messages>\n      <h1>Login</h1>\n      <div ng-controller="loginController">\n        <form name="loginForm" pcm-submit="login(userInfo)" novalidate role="form" ng-show="!isltIE9">\n          <div class="form-group" ng-class="{ \'has-error\' : loginForm.username.$invalid && loginForm.submitted }">\n            <label for="username" class="control-label label-sm">Email Address</label>\n            <input id="username" name="username" class="form-control" type="text" pcm-email ng-model="userInfo.username" ng-disabled="isProcessing || accounts.length>1"\n              required alkmaps-focus="isEmailFocused" pcm-class-on-value="filled" />\n            <p ng-show="loginForm.username.$error.pcmEmail && loginForm.submitted" class="help-block">not a valid email address</p>\n            <p ng-show="loginForm.username.$error.required && loginForm.submitted" class="help-block">required</p>\n            <div class="clearfix"></div>\n          </div>\n          <div class="form-group" ng-class="{ \'has-error\' : loginForm.password.$invalid && loginForm.submitted }">\n            <label for="password" class="control-label label-sm">Password</label>\n            <input id="password" name="password" class="form-control" type="password" ng-model="userInfo.password" ng-disabled="isProcessing || accounts.length>1"\n              required pcm-class-on-value="filled" />\n            <p ng-show="loginForm.password.$error.required && loginForm.submitted" class="help-block">Password is required.</p>\n            <div class="clearfix"></div>\n          </div>\n          <div class="form-group" ng-if="accounts.length>=1" ng-class="{ \'has-error\' : loginForm.account.$invalid && loginForm.submitted }">\n            <label for="account" class="control-label label-sm">Select Account</label>\n            <select id="account" name="account" class="form-control input-sm" ng-model="userInfo.account" required ng-disabled="isProcessing"\n              pcm-class-on-value="filled">\n                            <option ng-repeat="account in accounts" value="{{account}}">{{account}}</option>\n                        </select>\n            <p ng-show="loginForm.account.$error.required && loginForm.submitted" class="help-block">Account is required.</p>\n            <div class="clearfix"></div>\n          </div>\n          <div class="form-group row">\n            <div class="col-md-6">\n              <p><a href="/forgotPassword">Forgot Password?</a></p>\n\n            </div>\n            <div class="col-md-6 text-right">\n              <button id="login-submit" type="submit" class="btn btn-success" ng-disabled="isProcessing"><i ng-show="isProcessing" class="ico ico-circle-notch ico-spin ng-cloak" ng-cloak></i> <span ng-bind="(isProcessing)?\'Logging in...\':\'Login\'"></span></button>\n              <p><a ng-disabled="isProcessing" href="/signup">or Sign Up</a></p>\n            </div>\n\n          </div>\n          <div class="has-error">\n            <p class="help-block" ng-show="showAccountDisabled">User or account is disabled</p>\n            <p class="help-block" ng-show="showPasswordIncorrect">Username or password is incorrect</p>\n            <p class="help-block" ng-show="showNoAccountForApplication">Your login credentials do not have access to PC*Miler | Web. <br /><a href="/signup">Signup here.</a></p>\n            <p class="help-block" ng-show="showGenericError">A server error has occurred. Please try logging in again later.</p>\n          </div>\n        </form>\n        <div class="ie-old-warn alert alert-danger" ng-if="isltIE9">\n          <strong>This application will not work in your old Internet Explorer browser.  Please use Chrome or Firefox.</strong>\n        </div>\n        <div class="ie9-warn alert alert-warning alert-dismissable" ng-if="isIE9">\n          <button type="button" class="close" data-dismiss="alert" aria-hidden="true">&times;</button>\n          <strong>This application may have some issues in Internet Explorer 9.  IE9 does not handle complex applications well.  For a better experience please use Chrome or Firefox.</strong>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n');
  $templateCache.put('/pages/logout.html', '<div class="marketing-page login-page login-pcmweb" ng-controller="pcmlogoutController as vm">\n    <div class="top-section pcmweb-top-section">\n      <div class="container">\n        <div class="row">\n          <div class="col-sm-10"><img src="/img/PCMILER-Web_Logo_reversed.svg" alt="PC*MILER Web" class="page-logo img-responsive"></div>\n          <div class="col-sm-2 text-right form-group">\n            <div alk-language-select></div>\n          </div>\n        </div>\n        <div class="row">\n          <div class="col-sm-6" style="padding-top: 30px;">\n            <h1 class="with-icon">\n  \n            <span class="landing-app-icon">\n              <img src="/img/cloud-menu-pcmweb.svg" alt="PC*MILER Web Icon">\n            </span>\n            <span translate={{\'views.login.PCMWebHeading\'}}> </span>\n              </h1>\n            <div class="callout">\n            <p class="subhead">{{\'views.login.PCMWebSubhead1\' | translate}}</p>\n            <!-- <p class="subhead">{{\'views.login.PCMWebSubhead2\' | translate}}</p> -->\n          </div>\n            <p class="subhead bullet"><span class="ico ico-check-circle-o"></span>{{\'views.login.PCMWebBullet1\' | translate}}</p>\n            <p class="subhead bullet"><span class="ico ico-check-circle-o"></span>{{\'views.login.PCMWebBullet2\' | translate}}</p>\n            <p class="subhead bullet"><span class="ico ico-check-circle-o"></span>{{\'views.login.PCMWebBullet3\' | translate}}</p>\n            <p class="subhead bullet"><span class="ico ico-check-circle-o"></span>{{\'views.login.PCMWebBullet4\' | translate}}</p>\n          </div>\n          <div id="tmxtid-countdown-component" class="tmxtid-init" ng-show="!vm.showLegacySignIn.show"></div>\n   <div id="tmxtid-prompt-component" class="tmxtid-init"></div>\n   <div id="tmxtid-migrate-component" class="tmxtid-init" ng-show="!vm.showLegacySignIn.show"></div>\n          <div class="col-sm-5 col-sm-offset-1">\n            <div class="login-box">\n              <!-- Log In -->\n              <div class="row">\n                <div class="login-form">\n                    <p>Logging out from Trimble Id</p>\n                </div>\n              </div>\n              <div class="row">\n                <div class="col-sm-12 text-right form-group">\n               \n                </div>\n              </div>\n            \n            </div>\n            <!-- <div class="login-cta-section text-center">\n                <a href="/features" class="btn btn-lg btn-success">Sign Up Now</a>\n                <p class="availability">\n                  Supported on Internet Explorer 11+, Microsoft Edge, Firefox, and Google Chrome\n                </p>\n            </div> -->\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class="copilot-section">\n      <div class="container">\n        <div class="row">\n          <div class="col-sm-8 col-sm-offset-2 text-center">\n            <img class="copilot-icon" src="/img/CP_rounded-corners.png" alt="CoPilot" height="110" width="110" />\n            <h2>Take your plan on the road&hellip; Literally.</h2>\n            <p class="subhead">\n              Download CoPilot from Google Play or the App Store to any device and get consistent routes with navigation powered\n              by PC<span class="pcmiler-asterisk">*</span>MILER. <span style="font-weight: 600;"> Take a Test Drive </span>\n            </p>\n              <p class="text-center">\n                <a href="https://apps.apple.com/gb/app/copilot-gps-plan-explore-offline/id504677517?mt=8&ct=pcmilerweb"\n                  target="_blank" rel="noopener">\n              <img src="/img/app-store.svg" alt="App Store" class="text-center app-store-badge" height="60" width="203">\n            </a>\n            <a href="https://play.google.com/store/apps/details?id=com.alk.copilot.mapviewer&amp;utm_source=pcmweb&amp;utm_medium=site" target="_blank" rel="noopener">\n              <img src="/img/googleplay.png" srcset="/img/googleplay@x2.png 2x" alt="Google Play" class="text-center app-store-badge" height="60" width="201">\n            </a>\n              </p>\n          </div>\n        </div>\n      </div>\n    </div>\n    <marketing-footer></marketing-footer>\n  </div>\n  ');
  $templateCache.put('/pages/mainPage.html', '<div class="page-container">\n  <div ng-controller="pcmmodernController as pm" style="position: absolute; top:0; height: 45px; background-color: #FFF5E4; width: 100%; font-size: 14px; border-width: 1px; border-style: solid;border-color: #E49325;">\n    <div style="color: black; text-align: center;"><img src="/img/switch-alert.png" alt="Modern Switch">\n      <b style="font-weight:800">&nbsp;On Jan 22 2025, our PC*Miler legacy version will be permanently shut down. All users will need to transition to </b><a target="_self" rel="noopener" style="color:  #0063A3; font-weight:700" href="" ng-click="pm.newPCMWeb()">our new and improved version.</a><br>\n      <b style="font-weight:800;">&nbsp;If you encounter any issues with our latest version, please don\'t hesitate to reach out to our team at </b><a href="mailto:support@trimblemaps.com">support@trimblemaps.com</a>\n    </div>\n  </div>\n  <div id="header" ng-include="\'/app/layout/mainNav.template.html\'" style="top: 45px;" class="hidden-print alk-menu-bar slant"></div>\n  <!--<div id="map"></div>-->\n  <div id="center-section">\n    <alkmaps-map id="pcmMap" url-sync="true" ng-style="{\'left\': \'500px\'}"></alkmaps-map>\n    <alkmaps-navigation map-id="pcmMap"></alkmaps-navigation>\n\n    <div id="left-panel-wrapper" class="ui-panel left-panel" ng-style="{\'width\': \'500px\'}">\n      <div class="left-panel-ui-view">\n        <div id="routeView" ng-include="\'/app/route/routePanel.template.html\'"></div>\n      </div>\n    </div>\n    <div id="rsView" ng-include="\'/app/vehicle/vehiclesPanel.template.html\'"></div>\n  </div>\n  <div class="printableFrame printableFrame-landscape" pcm-show-on-key="221">\n    <p>Landscape</p>\n  </div>\n  <div class="printableFrame printableFrame-portrait" pcm-show-on-key="219">\n    <p>Portrait</p>\n  </div>\n  <map-footer app="PCMWebUI" map-shown="true"></map-footer>\n</div>');
  $templateCache.put('/pages/migrate.html', '<div class="container">\n    <div class="panel main-panel">\n        <div class="page-header" ng-include="\'/app/layout/pageHeader.template.html\'"></div>\n        <div class="page-content forms-content">\n            <h1>Update Login Credentials</h1>\n            <div ng-controller="migrateController as vm">\n                <pcm-messages></pcm-messages>\n\n                <fieldset ng-disabled="vm.isProcessing">\n\n                    <!-- Step 0: Enter Existing PCMilerLive Username, Account, Password -->\n                    <form name="existingUserForm" ng-if="vm.wizardStep >= 0" pcm-submit="vm.loginToPcMiler()" novalidate>\n                        <fieldset ng-disabled="vm.wizardStep != 0">\n\n                            <p class="signup-section"><span class="label label-warning">*</span> PC*MILER|Web Login</p>\n                            <p class="form-message">Please enter your existing PC*MILER|Web Username, Account and Password.</p>\n\n                            <div class="form-group row" ng-class="{ \'has-error\' : existingUserForm.existingUsername.$invalid && (!existingUserForm.existingUsername.$pristine || existingUserForm.submitted) }">\n                                <div class="col-md-4">\n                                    <input id="existingUsername" name="existingUsername" class="form-control input-sm input-line" type="text" autofocus ng-model="vm.pcmUser.username" required pcm-class-on-value="filled" />\n                                    <label for="existingUsername" class="control-label label-sm label-line">Username</label>\n                                </div>\n                                <div class="col-md-4">\n                                    <input id="existingAccount" name="existingAccount" class="form-control input-sm input-line" type="text" ng-model="vm.pcmUser.account" required pcm-class-on-value="filled" />\n                                    <label for="existingAccount" class="control-label label-sm label-line">Account</label>\n                                </div>\n                                <div class="col-md-4">\n                                    <input id="existingPassword" name="existingPassword" class="form-control input-sm input-line" type="password" ng-model="vm.pcmUser.password" required pcm-class-on-value="filled" />\n                                    <label for="existingPassword" class="control-label label-sm label-line">Password</label>\n                                </div>\n                            </div>\n                            <div class="form-group row">\n                                <div class="col-md-4" ng-if="vm.wizardStep == 0">\n                                    <button type="submit" class="btn btn-sm btn-success" ng-disabled="existingUserForm.$invalid"><i ng-show="vm.isProcessing" class="ico ico-circle-notch ico-spin ng-cloak" ng-cloak></i><span ng-bind="(vm.isProcessing)?\'Verifying...\':\'Login\'"></span></button>\n                                </div>\n                            </div>\n                        </fieldset>\n                    </form>\n\n                    <!-- SSO Login Credentials -->\n                    <form name="ssoLoginForm" ng-if="vm.wizardStep >= 1 && vm.signup.user.ssoExists" pcm-submit="vm.loginToSSO()" novalidate>\n                        <fieldset ng-disabled="vm.wizardStep != 1">\n\n                            <p class="signup-section"><span class="label label-warning">*</span> New PC*MILER|Web Login Credentials</p>\n                            <p class="form-message">We recognize your email.  Please enter your password associated to this email account.</p>\n\n                            <div class="form-group row" ng-class="{ \'has-error\' : ssoLoginForm.email.$invalid && (!ssoLoginForm.email.$pristine || ssoLoginForm.submitted) }">\n                                <div class="col-md-4">\n                                    <input id="email" name="email" class="form-control input-sm input-line" type="text" pcm-email autofocus ng-model="vm.signup.user.email" required pcm-class-on-value="filled" />\n                                    <label for="email" class="control-label label-sm label-line label-line">Email Address (This will become your new user name)</label>\n                                    <p class="help-block" ng-if="ssoLoginForm.email.$error.pcmEmail">Not a valid Email</p>\n                                </div>\n                                <div class="col-md-4">\n                                    <input id="password" name="password" class="form-control input-sm input-line" type="password" ng-model="vm.signup.user.password" required pcm-class-on-value="filled" />\n                                    <label for="password" class="control-label label-sm label-line">Password</label>\n                                    <p class="help-block" ng-if="ssoLoginForm.password.$error.required">required</p>\n                                    <label class="control-label label-sm label-line pull-right"><a href="/forgotPassword">Forgot Password?</a></label>\n                                </div>\n\n                                <div class="col-md-4" ng-if="vm.wizardStep == 1">\n                                    <button type="submit" class="btn btn-sm btn-success" ng-disabled="ssoLoginForm.$invalid"><i ng-show="vm.isProcessing" class="ico ico-circle-notch ico-spin ng-cloak" ng-cloak></i><span ng-bind="(vm.isProcessing)?\'Verifying...\':\'Login\'"></span></button>\n                                    <button type="button" class="btn btn-sm btn-default" ng-click="vm.notMyEmail()">Not my email</button>\n                                </div>\n                            </div>\n                            <div class="form-group row" ng-class="{ \'has-error\' : !vm.isSSOPasswordValid }">\n                                <p class="help-block">Username or password is incorrect</p>\n                            </div>\n                        </fieldset>\n                    </form>\n\n                    <!-- Step 4: If username does not exist, enter password and confirmation for new account -->\n                    <form name="detailsForm" ng-if="vm.wizardStep >= 2" pcm-submit="vm.migrate()" novalidate>\n                        <div ng-if="!vm.signup.user.ssoExists">\n                            <p class="form-message">Please enter new login credentials</p>\n\n                            <div class="row">\n                                <div class="col-md-6 form-group" ng-class="{ \'has-error\' : detailsForm.ssoFirstName.$invalid && (!detailsForm.ssoFirstName.$pristine || detailsForm.submitted) }">\n                                    <input id="ssoFirstName" class="form-control input-sm input-line" name="ssoFirstName" type="text" ng-model="vm.signup.user.ssoFirstName" required pcm-class-on-value="filled" />\n                                    <label for="ssoFirstName" class="control-label label-sm label-line">First Name</label>\n                                    <p class="help-block" ng-if="detailsForm.ssoFirstName.$error.required">required</p>\n                                </div>\n                                <div class="col-md-6 form-group" ng-class="{ \'has-error\' : detailsForm.ssoLastName.$invalid && (!detailsForm.ssoLastName.$pristine || detailsForm.submitted) }">\n                                    <input id="ssoLastName" class="form-control input-sm input-line" name="ssoLastName" type="text" ng-model="vm.signup.user.ssoLastName" required pcm-class-on-value="filled" />\n                                    <label for="ssoLastName" class="control-label label-sm label-line">Last Name</label>\n                                    <p class="help-block" ng-if="detailsForm.ssoLastName.$error.required">required</p>\n                                </div>\n                            </div>\n\n                            <div class="row">\n                                <div class="col-md-6 form-group" ng-class="{ \'has-error\' : detailsForm.newemail.$invalid && (!detailsForm.newemail.$pristine || detailsForm.submitted) }">\n                                    <input id="newemail" name="newemail" class="form-control input-sm input-line" type="text" pcm-email autofocus ng-model="vm.signup.user.email" ng-model-options="{ debounce: 300 }" required unique-username pcm-class-on-value="filled" />\n                                    <label for="newemail" class="control-label label-sm label-line label-line">Email Address (user name)</label>\n                                    <p class="help-block" ng-if="detailsForm.newemail.$error.pcmEmail">Not a valid Email</p>\n                                    <p class="help-block" ng-if="detailsForm.newemail.$error.uniqueUsername">This email is taken. Please use a new one.</p>\n                                </div>\n                            </div>\n\n                            <div class="row">\n                                <div class="col-md-6 form-group" ng-class="{ \'has-error\' : detailsForm.newPassword.$invalid && (!detailsForm.newPassword.$pristine || detailsForm.submitted) }">\n                                    <input id="newPassword" class="form-control input-sm input-line" name="newPassword" type="password" ng-model="vm.signup.user.password" ng-minlength="8" ng-maxlength="20" required pcm-class-on-value="filled" />\n                                    <label for="newPassword" class="control-label label-sm label-line">Password</label>\n                                    <p class="help-block" ng-if="detailsForm.newPassword.$error.required">required</p>\n                                    <p class="help-block" ng-if="detailsForm.newPassword.$error.maxlength">Password must be less than or equal to 20 characters</p>\n                                    <p class="help-block" ng-if="detailsForm.newPassword.$error.minlength">Password must be more than or equal to 8 characters</p>\n                                </div>\n                                <div class="col-md-6 form-group" ng-class="{ \'has-error\' : detailsForm.confirmPassword.$invalid && (!detailsForm.confirmPassword.$pristine || detailsForm.submitted) }">\n                                    <input id="confirmPassword" class="form-control input-sm input-line" name="confirmPassword" type="password" ng-model="vm.signup.user.confirmPassword" pcm-compare-field="vm.signup.user.password" pcm-class-on-value="filled" />\n                                    <label for="confirmPassword" class="control-label label-sm label-line">Confirm Password</label>\n                                    <p class="help-block" ng-if="detailsForm.confirmPassword.$error.pcmCompareField">Passwords must match</p>\n                                </div>\n                            </div>\n                        </div>\n\n                        <p class="signup-section"><span class="label label-warning">*</span> Account Information</p>\n\n                        <div class="row" ng-show="vm.userAccounts.length && !vm.enterNewAccount">\n                            <div class="col-md-6">\n                                <div>\n                                    <p class="pricing-header">Select Account</p>\n                                    <div class="form-group" style="margin-bottom: 0;">\n                                        <div class="input-group" ng-repeat="account in vm.userAccounts">\n                                            <span class="input-group-addon">\n                                                <input type="radio" value="{{account.AccountId}}" name="accountId" ng-model="vm.signup.user.accountId" ng-disabled="account.AssociatedWithPCM" ng-change="vm.accountSelected(account)" ng-required="vm.userAccounts.length && !vm.enterNewAccount">\n                                            </span>\n                                            <div style="height: 30px; font-size: 12px; padding: 6px 10px; color: #555; border: 1px solid #ccc;">\n                                                {{account.AccountName}}\n                                                <span style="margin-left: 10px;" class="ico ico-info-circle" ng-show="{{account.AssociatedWithPCM}}" tooltip-placement="right" uib-tooltip="This account already is associated with PC*MILER Web. Please contact your Company Admin to be added."></span>\n                                            </div>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                            <div class="col-md-6" style="padding-top: 19px;">\n                                <div class="form-group" ng-class="{ \'has-error\' : detailsForm.accountId.$invalid && (!detailsForm.accountId.$pristine || detailsForm.submitted) }">\n                                    <p ng-if="detailsForm.accountId.$error.required" class="help-block">Selecting an account is required or choose \'Enter New Account\'</p>\n                                </div>\n                            </div>\n                        </div>\n\n                        <!-- New Company Name -->\n                        <div class="row clearfix" ng-show="!vm.userAccounts.length || vm.enterNewAccount">\n                            <div class="form-group col-md-6" ng-class="{ \'has-error\' : detailsForm.account.$invalid && (!detailsForm.account.$pristine || detailsForm.submitted) }">\n                                <input id="account" name="account" class="form-control input-sm input-line" type="text" ng-model="vm.signup.user.account" ng-model-options="{ updateOn: \'blur\' }" ng-required="!vm.userAccounts.length || vm.enterNewAccount" pcm-unique-account pcm-class-on-value="filled" />\n                                <label for="account" class="control-label label-sm label-line">Account Name</label>\n                                <p ng-if="detailsForm.account.$error.required" class="help-block">required</p>\n                                <p ng-if="detailsForm.account.$error.pcmUniqueAccount" class="help-block">Account Name already exists. Please contact your administrator.</p>\n                            </div>\n                        </div>\n\n                        <div class="row clearfix" ng-if="vm.userAccounts.length">\n                            <div class="form-group col-md-12" style="margin-top: 10px;">\n                                <button class="btn btn-sm btn-default" type="button" ng-click="vm.toggleUseExistingAccount()"><span ng-bind="(vm.enterNewAccount)?\'Use Existing Account\':\'Enter New Account\'"></span></button>\n                            </div>\n                        </div>\n\n                        <p ng-show="vm.oSignup.customer.isInvoiced">Your account is currently invoiced. In order to change the feature level or number of users in your account you should contact support.</p>\n\n                        <div ng-if="!vm.oSignup.customer.isInvoiced">\n\n                            <!-- Items that affect cost - feature level and number of users-->\n                            <p class="signup-section"><span class="label label-warning">*</span> Feature Level</p>\n                            <div class="row">\n                                <div class="col-md-12">\n                                    <p class="pricing-header">Select a Feature Level</p>\n                                </div>\n                            </div>\n\n                            <p ng-show="vm.oSignup.user.featureLevel === \'Lite\'">Your current feature level is Lite, which is no longer available with new PC*MILER|Web.  Please select your new feature level.</p>\n\n                            <div class="row pricing-table">\n                                <div class="col-md-4" ng-class="(vm.signup.user.featureLevel === \'Standard\')?\'selected\':\'\'" ng-show="vm.oSignup.user.featureLevel !== \'Premium\'">\n                                    <table class="table">\n                                        <tr>\n                                            <th>\n                                                <input type="radio" value="Standard" id="account_type_standard" name="account_type_radio" ng-model="vm.signup.user.featureLevel" />\n                                                <label class="standard" for="account_type_standard"><span class="glyphicon glyphicon-ok" aria-hidden="true" ng-show="(vm.signup.user.featureLevel === \'Standard\')"></span>Standard</label>\n                                            </th>\n                                        </tr>\n                                        <tr>\n                                            <td>Limited routing and options.<br />\n                                                <small><a href="#">View full feature list</a></small></td>\n                                        </tr>\n                                        <tr>\n                                            <td><span class="price">$59.99</span>a month per user</td>\n                                        </tr>\n                                    </table>\n                                </div>\n                                <div class="col-md-4" ng-class="(vm.signup.user.featureLevel === \'Premium\')?\'selected\':\'\'">\n                                    <table class="table">\n                                        <tr>\n                                            <th>\n                                                <input type="radio" value="Premium" id="account_type_premium" name="account_type_radio" ng-model="vm.signup.user.featureLevel" />\n                                                <label class="premium" for="account_type_premium"><span class="glyphicon glyphicon-ok" aria-hidden="true" ng-show="(vm.signup.user.featureLevel === \'Premium\')"></span>Premium</label>\n                                            </th>\n                                        </tr>\n                                        <tr>\n                                            <td>Full routing and options features<br />\n                                                <small><a href="#">View full feature list</a></small></td>\n                                        </tr>\n                                        <tr>\n                                            <td><span class="price">$84.99</span>a month per user</td>\n                                        </tr>\n                                    </table>\n                                </div>\n                            </div>\n\n                            <div class="row pricing-totals">\n                                <div class="col-md-6 form-group text-center" ng-class="{ \'has-error\' : detailsForm.numberOfUsers.$invalid && (!detailsForm.numberOfUsers.$pristine || detailsForm.submitted) }">\n                                    <span class="num-users">Select Number of Users:</span>\n                                    <input id="numberOfUsers" class="input-sm input-line" name="numberOfUsers" type="number" min="{{vm.oSignup.user.numberOfUsers}}" ng-model="vm.signup.user.numberOfUsers" maxlength="6" style="width: 75px; text-align: center" ng-required="!vm.signup.customer.isInvoiced" />\n                                    <p ng-if="detailsForm.numberOfUsers.$error.required" class="help-block">required</p>\n                                    <p ng-if="detailsForm.numberOfUsers.$error.number" class="help-block">Not a valid number of users</p>\n                                    <p ng-if="detailsForm.numberOfUsers.$error.min" class="help-block">Number of users cannot be reduced lower than the original number of users: {{vm.oSignup.user.numberOfUsers}}.  Contact customer service for support.</p>\n                                    <p ng-if="detailsForm.numberOfUsers.$error.maxlength" class="help-block">Number of users must be below 999,999</p>\n                                </div>\n                            </div>\n\n                            <div class="row" ng-show="vm.isBillingChanged()">\n                                <div class="col-md-12">\n                                    <div class="checkbox" ng-class="{ \'has-error\' : detailsForm.isBillingAccepted.$invalid && (!detailsForm.isBillingAccepted.$pristine || detailsForm.submitted) }">\n                                        <label>\n                                            <input name="isBillingAccepted" type="checkbox" ng-model="vm.signup.user.isBillingAccepted" ng-required="vm.isBillingChanged()">\n                                            I understand that the new monthly payment is {{vm.totalPrice() | currency}} /Month\n                                        </label>\n                                        <p class="help-block" ng-if="detailsForm.isBillingAccepted.$error.required">required</p>\n                                    </div>\n                                </div>\n                            </div>\n\n                            <!-- Billing Address-->\n                            <div ng-class="slideInOut">\n                                <p class="signup-section"><span class="label label-warning">*</span> Billing Address</p>\n\n                                <div class="form-group sm row">\n                                    <div class="col-md-6" ng-class="{ \'has-error\' : detailsForm.address1.$invalid && (!detailsForm.address1.$pristine || detailsForm.submitted) }">\n                                        <input id="address1" name="address1" class="form-control input-sm input-line" type="text" ng-model="vm.signup.customer.billing.Address1" required pcm-class-on-value="filled" />\n                                        <label for="address1" class="control-label label-sm label-line">Address 1</label>\n                                        <p class="help-block" ng-if="detailsForm.address1.$error.required">required</p>\n                                    </div>\n                                    <div class="col-md-6">\n                                        <input id="address2" name="address2" class="form-control input-sm input-line" type="text" ng-model="vm.signup.customer.billing.Address2" pcm-class-on-value="filled" />\n                                        <label for="address2" class="control-label label-sm label-line">Address 2</label>\n                                    </div>\n                                </div>\n\n                                <div class="form-group sm row">\n                                    <div class="col-md-6" ng-class="{ \'has-error\' : detailsForm.city.$invalid && (!detailsForm.city.$pristine || detailsForm.submitted) }">\n                                        <input id="city" name="city" class="form-control input-sm input-line" type="text" ng-model="vm.signup.customer.billing.City" required pcm-class-on-value="filled" />\n                                        <label for="city" class="control-label label-sm label-line">City</label>\n                                        <p class="help-block" ng-if="detailsForm.city.$error.required">required</p>\n                                    </div>\n                                    <div class="col-md-3" ng-class="{ \'has-error\' : detailsForm.state.$invalid && (!detailsForm.state.$pristine || detailsForm.submitted) }">\n                                        <select id="state" name="state" class="form-control input-sm input-line" ng-model="vm.signup.customer.billing.State" ng-options="state.abbreviation as state.name group by state.country for state in vm.states" required ng-change="vm.stateChanged()" pcm-class-on-value="filled">\n                                            <option value=""></option>\n                                        </select>\n                                        <label for="state" class="control-label label-sm label-line">State/Province</label>\n                                        <p class="help-block" ng-if="detailsForm.state.$error.required">required</p>\n                                    </div>\n                                    <div class="col-md-3" ng-class="{ \'has-error\' : detailsForm.postalCode.$invalid && (!detailsForm.postalCode.$pristine || detailsForm.submitted) }">\n                                        <input id="postalCode" name="postalCode" class="form-control input-sm input-line" type="text" ng-model="vm.signup.customer.billing.Zip" required pcm-class-on-value="filled" />\n                                        <label for="postalCode" class="control-label label-sm label-line">ZIP Code</label>\n                                        <p class="help-block" ng-if="detailsForm.postalCode.$error.required">required</p>\n                                    </div>\n                                </div>\n\n                                <div class="form-group sm row">\n                                    <div class="col-md-6" ng-class="{ \'has-error\' : detailsForm.country.$invalid && (!detailsForm.country.$pristine || detailsForm.submitted) }">\n                                        <select id="country" name="country" class="form-control input-sm input-line" ng-model="vm.signup.customer.billing.Country" ng-options="country.country as country.country for country in vm.countries" required ng-change="vm.countryChanged()" pcm-class-on-value="filled">\n                                            <option value=""></option>\n                                        </select>\n                                        <label for="country" class="control-label label-sm label-line">Country</label>\n                                        <p class="help-block" ng-if="detailsForm.country.$error.required">required</p>\n                                    </div>\n                                    <div class="col-md-6" ng-class="{ \'has-error\' : detailsForm.phoneNumber.$invalid && (!detailsForm.phoneNumber.$pristine || detailsForm.submitted) }">\n                                        <input id="phoneNumber" name="phoneNumber" class="form-control input-sm input-line" type="text" ng-model="vm.signup.customer.billing.Phone" required pcm-class-on-value="filled" />\n                                        <label for="phoneNumber" class="control-label label-sm label-line">Phone Number</label>\n                                        <p class="help-block" ng-if="detailsForm.phoneNumber.$error.required">required</p>\n\n                                    </div>\n                                </div>\n                            </div>\n\n                            <!-- Credit Card -->\n                            <div ng-class="slideInOut">\n                                <p class="signup-section"><span class="label label-warning">*</span> Credit Card</p>\n                                <billing-information ng-model="vm.signup.customer.credit" has-changed="vm.creditChanged" ng-required="!!vm.creditChanged || vm.isOriginalCardValid() == false"></billing-information>\n                            </div>\n\n                        </div>\n\n                        <!-- Sub-users -->\n                        <div class="row form-group sm">\n                            <p class="signup-section"><span class="label label-warning">*</span> Users</p>\n                            <p>Please verify and update email addresses for users associated with this account.  Trimble MAPS will email all the users with a link to reset their password to access the new PC*MILER|Web.</p>\n                            <div class="col-md-12">\n                                <table class="table table-bordered table-condensed">\n                                    <thead>\n                                        <tr>\n                                            <th>Old Username</th>\n                                            <th>Email (new login)</th>\n                                            <th class="text-center">Account<br />\n                                                Administrator</th>\n                                            <th class="text-center">Remove</th>\n                                        </tr>\n                                    </thead>\n                                    <tbody>\n                                        <tr>\n                                            <td><span ng-bind="vm.signup.user.pcmUsername"></span></td>\n                                            <td>\n                                                <p class="pull-left form-control-static" ng-bind="vm.signup.user.email"></p>\n                                            </td>\n                                            <td class="text-center">\n                                                <span class="glyphicon glyphicon-ok"></span>\n                                            </td>\n                                            <td class="text-center">&nbsp;</td>\n                                        </tr>\n                                        <tr ng-repeat="user in vm.signup.user.subUsers" ng-form="subUserForm">\n                                            <td><span ng-bind="user.username"></span></td>\n                                            <td ng-class="{ \'has-error\' : subUserForm.email.$invalid }">\n                                                <input name="email" type="text" ng-model="user.email" pcm-unique items="vm.signup.user.subUsers" pcm-email class="form-control" />\n                                            </td>\n                                            <td class="text-center">\n                                                <span class="glyphicon glyphicon-ok" ng-show="user.role === \'Company Administrator\'"></span>\n                                                <span class="glyphicon glyphicon-remove" ng-show="user.role !== \'Company Administrator\'"></span>\n                                            </td>\n                                            <td class="text-center">\n                                                <button type="button" class="btn btn-default btn-xs" ng-click="vm.deleteUser(user)"><i class="ico ico-trash" style="color: #c4161c; font-size: 13px;"></i></button>\n                                            </td>\n                                        </tr>\n                                    </tbody>\n                                </table>\n                            </div>\n                        </div>\n\n                        <div class="row" style="margin-top: 30px">\n                            <div class="col-md-offset-6 col-md-6 text-right">\n                                <button class="btn btn-default" type="reset" ng-click="vm.reset()">Start Over</button>\n                                <button type="submit" class="btn btn-lg btn-success">\n                                    <i ng-show="vm.isProcessing" class="ico ico-circle-notch ico-spin ng-cloak" ng-cloak></i>\n                                    <span ng-bind="(vm.isProcessing)?\'Submitting...\':\'Submit\'"></span>\n                                    <span class="has-error" ng-if="detailsForm.$invalid">&nbsp;\n                                        <i class="glyphicon glyphicon-exclamation-sign"></i>\n                                    </span>\n                                </button>\n                            </div>\n                        </div>\n                    </form>\n                </fieldset>\n            </div>\n        </div>\n    </div>\n</div>\n');
  $templateCache.put('/pages/resetPassword.html', '\n<div class="container">\n    <div class="panel col-md-push-3 col-md-6">\n        <div class="page-header" ng-include="\'/app/account/loginHeader.template.html\'"></div>\n        <div class="page-content">\n            <h1>Reset Password</h1>\n            <div ng-controller="resetPasswordController" ng-init="init()">\n               <pcm-messages></pcm-messages>\n\n                <form name="resetPasswordForm" pcm-submit="submitResetPassword()" novalidate role="form">\n                    <div class="form-group" ng-class="{ \'has-error\' : resetPasswordForm.email.$invalid && (!resetPasswordForm.email.$pristine || resetPasswordForm.$submitted) }">\n                        <input id="email" name="email" class="form-control" type="text" pcm-email ng-model="userInfo.email" inputmode="email" placeholder="Email" ng-disabled="isProcessing" required />\n                        <div ng-show="!resetPasswordForm.email.$pristine || resetPasswordForm.$submitted">\n                            <p ng-show="resetPasswordForm.email.$error.pcmEmail" class="help-block">Email is invalid.</p>\n                            <p ng-show="resetPasswordForm.email.$error.required" class="help-block">Email is required.</p>\n                        </div>\n                    </div>\n                    <div class="form-group" ng-class="{ \'has-error\' : resetPasswordForm.token.$invalid && (!resetPasswordForm.token.$pristine || resetPasswordForm.$submitted) }">\n                        <input id="token" name="token" class="form-control" type="text" ng-model="userInfo.token" placeholder="Token" spellcheck="false" autocorrect="off" ng-disabled="isProcessing" required />\n                        <div ng-show="!resetPasswordForm.token.$pristine || resetPasswordForm.$submitted">\n                            <p ng-show="resetPasswordForm.token.$error.required" class="help-block">Token is required.</p>\n                        </div>\n                    </div>\n                    <div class="form-group" ng-class="{ \'has-error\' : resetPasswordForm.password.$invalid && (!resetPasswordForm.password.$pristine || resetPasswordForm.$submitted) }">\n                        <input id="password" name="password" class="form-control" type="password" ng-model="userInfo.password" autocomplete="new-password" placeholder="New Password" ng-disabled="isProcessing" ng-minlength="8" ng-maxlength="20" tid-password required />\n                        <div ng-show="!resetPasswordForm.password.$pristine || resetPasswordForm.$submitted">\n                            <p ng-show="resetPasswordForm.password.$error.required" class="help-block">Password is required.</p>\n                        </div>\n                    </div>\n                    <div class="form-group" ng-class="{ \'has-error\' : resetPasswordForm.confirmPassword.$invalid && (!resetPasswordForm.confirmPassword.$pristine || resetPasswordForm.$submitted) }">\n                        <input name="confirmPassword" class="form-control" type="password" ng-model="userInfo.confirmPassword" autocomplete="new-password" placeholder="Confirm New Password"\n                            ng-disabled="isProcessing || resetPasswordForm.password.$invalid" pcm-compare-field="userInfo.password" />\n                        <div ng-show="!resetPasswordForm.confirmPassword.$pristine || resetPasswordForm.$submitted">\n                            <p ng-show="resetPasswordForm.confirmPassword.$error.pcmCompareField" class="help-block">Passwords must match</p>\n                        </div>\n                    </div>\n                    <button type="submit" class="btn btn-primary" ng-disabled="isProcessing || resetPasswordForm.password.$invalid || resetPasswordForm.confirmPassword.$invalid">\n                        <i ng-show="isProcessing" class="ico ico-circle-notch ico-spin ng-cloak" ng-cloak></i> <span ng-bind="(isProcessing)?\'Submitting...\':\'Submit\'"></span></button>\n                    <p>Click <a href="/login">here</a> to login.</p>\n                </form>\n                <div>\n                    <ul>\n                      <li ng-class="{\'text-danger\':resetPasswordForm.password.$error.maxlength || resetPasswordForm.password.$error.minlength}">Must be between 8 and 20 characters</li>\n                      <li ng-class="{\'text-danger\':resetPasswordForm.password.$error.hasNumber}">At least one number</li>\n                      <li ng-class="{\'text-danger\':resetPasswordForm.password.$error.hasLowercase}">At least one lowercase letter</li>\n                      <li ng-class="{\'text-danger\':resetPasswordForm.password.$error.hasUppercase}">At least one uppercase letter</li>\n                      <li ng-class="{\'text-danger\':resetPasswordForm.password.$error.hasCharacter}">At least one of these characters (!@#$%&amp;*^_-+)</li>\n                    </ul>\n                  </div>\n            </div>\n        </div>\n    </div>\n</div>\n');
  $templateCache.put('/pages/signUpPage.html', '<div class="marketing-page signup-page signup-pcmweb">\n  <div class="marketing-page-header">\n    <div class="container">\n      <div class="row">\n        <div class="col-sm-12">\n          <a href="/"><img src="/img/PCMILER-Web_Logo_reversed.svg" alt="PC*MILER Web" class="page-logo"></a>\n        </div>\n        <h1 class="page-title">Sign Up</h1>\n      </div>\n    </div>\n  </div>\n  <div class="signup-page-section forms-content signup-form">\n    <div class="container">\n      <div ng-controller="signUpController as vm">\n        <form name="signUpForm" ng-submit="vm.signUp()" novalidate>\n          <div class="row">\n            <div class="col-md-10 col-md-offset-1">\n              <h3>Sign up</h3>\n\n              <pcm-messages></pcm-messages>\n\n              <p class="signup-section"><span class="label label-warning">1</span> Login Information</p>\n              <p class="form-instruction" ng-if="vm.searchObject.state === undefined ">Please enter your email address to determine if you already have an account</p>\n              <!-- Step 1: Enter Username/Email -->\n              <ng-form name="usernameForm">\n                <div class="form-group row" show-errors>\n                  <div class="col-md-6">\n                    <label for="username" class="control-label label-sm">Email Address (user name)</label>\n                    <input id="username" name="username" class="form-control input-sm" type="text" pcm-email autofocus ng-model="vm.signup.userName"\n                      required ng-disabled="vm.isProcessing || vm.wizardStep != 1" pcm-class-on-value="filled" />\n                      <p class="help-block" ng-if="usernameForm.username.$error.pcmEmail || vm.signup.newPlusAccount">Please enter a valid email address</p>\n                    <p class="help-block" ng-if="vm.signup.userExists">This email is already associated with a user account, please enter the password to continue</p>\n                    <p class="help-block" ng-if=" vm.invalidToken">Token Expired. Please click check email to get new token</p>\n                  \n                  </div>\n                  <div class="col-sm-2" ng-if="vm.signup.newPlusAccount">\n                    <label class="control-label label-sm"></label>\n                    <button type="reset" class="btn btn-sm btn-default" ng-disabled="vm.isProcessing" ng-click="vm.reset()">Start Over</button>\n                  </div>\n                  <div class="col-sm-2" ng-if="vm.wizardStep == 1">\n                    <label class="control-label label-sm"></label>\n                    <button type="submit" class="btn btn-sm btn-success" ng-disabled="vm.isProcessing || usernameForm.$invalid"><i ng-show="vm.isProcessing" class="ico ico-circle-notch ico-spin ng-cloak" ng-cloak></i> <span ng-bind="(vm.isProcessing)?\'Verifying...\':\'Check Email\'"></span></button>\n                  </div>\n                </div>\n                   <!--disallow the new email id creation with + symbol -->\n                   <!-- <div class="form-group col-md-14" ng-if="vm.signup.newPlusAccount">\n                    <p class="form-instruction">New user email address is not allowed to create with the "+" symbol. Please enter a valid email address!</p>\n                  </div> -->\n              </ng-form>\n\n              <!-- Step 2: Verify the user - for existing users this is through the password, for new users this is through a verification token -->\n              <ng-form name="userVerificationForm" ng-if="vm.wizardStep >= 2">\n                <!-- <div class="row" ng-if="vm.signup.userExists">\n                  <div class="col-md-12">\n                    <p class="form-instruction">Your email address is already associated with an account. Please enter the password for that account.</p>\n                  </div> -->\n                  <!-- <div class="form-group col-md-6" show-errors>\n                    <label for="password" class="control-label label-sm">Password</label>\n                    <input id="password" class="form-control input-sm" name="password" type="password" ng-model="vm.signup.password" required\n                      ng-disabled="vm.isProcessing || vm.wizardStep != 2" pcm-class-on-value="filled" />\n                    <p class="help-block" ng-if="userVerificationForm.password.$error.required">required</p>\n                    <label class="control-label label-sm pull-right"><a href="/forgotPassword?r=signup">Forgot Password?</a></label>\n                  </div>\n                  <div class="form-group col-md-6" ng-if="vm.wizardStep == 2">\n                    <label class="control-label label-sm"></label>\n                    <button type="reset" class="btn btn-sm btn-default" ng-disabled="vm.isProcessing" ng-click="vm.reset()">Start Over</button>\n                    <button type="submit" class="btn btn-sm btn-success" ng-disabled="vm.isProcessing"><i ng-show="vm.isProcessing" class="ico ico-circle-notch ico-spin"></i> <span ng-bind="(vm.isProcessing)?\'Verifying...\':\'Continue\'"></span></button>\n                  </div> -->\n                <!-- </div> -->\n               <!-- <div class="row" ng-if="!vm.signup.userExists && !vm.signup.newPlusAccount">\n                  <div class="col-md-12">\n                    <p class="form-instruction">You do not have an existing account so we have sent you an email to verify the email is valid.</p>\n                  </div>\n                  <div class="form-group col-md-6" show-errors>\n                    <label for="verificationToken" class="control-label label-sm">Enter your Activation Token (sent to the email above)</label>\n                    <input id="verificationToken" class="form-control input-sm" name="verificationToken" type="text" ng-model="vm.signup.verificationToken"\n                      ng-model-options="{ debounce: 300 }" ng-disabled="vm.isProcessing || vm.wizardStep != 2" required pcm-verification-token="{{vm.signup.userName}}"\n                      pcm-class-on-value="filled" />\n                    <p class="help-block" ng-if="userVerificationForm.verificationToken.$error.pcmVerificationToken">Token has expired or is incorrect. Click \'Get Activation Code\' to send another token to your email.</p>\n                    <p class="help-block" ng-if="userVerificationForm.verificationToken.$error.required">Token is required.</p>\n                    <p class="help-block" ng-if="verificationEmailSent">Activation code has been sent to your email address</p>\n                  </div>\n\n                  <div class="form-group col-md-6" ng-if="vm.wizardStep == 2">\n                    <label class="control-label label-sm"></label>\n                    <button type="reset" class="btn btn-sm btn-default" ng-disabled="vm.isProcessing" ng-click="vm.reset()">Start Over</button>\n                    <button type="button" class="btn btn-sm btn-default" ng-disabled="vm.isProcessing" ng-click="vm.sendVerificationToken()">Resend Activation Email</button>\n                    <button type="submit" class="btn btn-sm btn-success" ng-disabled="vm.isProcessing || userVerificationForm.$pending || userVerificationForm.$invalid"><i ng-show="vm.isProcessing" class="ico ico-circle-notch ico-spin ng-cloak" ng-cloak></i> <span ng-bind="(vm.isProcessing)?\'Verifying...\':\'Activate &amp; Continue\'"></span></button>\n                  </div>\n                </div>-->\n              </ng-form>\n\n              <!-- Step 3: If this user exists and they have 1+ accounts, let them select an account -->\n              <ng-form name="accountSelectionForm" ng-if="vm.wizardStep >= 3 && vm.userAccounts.length">\n                <div class="row" ng-if="!vm.enterNewAccount">\n                  <div class="col-md-6">\n                    <div>\n                      <p class="pricing-header">Select Account</p>\n                      <div class="form-group" style="margin-bottom: 0;">\n                        <div class="input-group" ng-repeat="account in vm.userAccounts">\n                          <span class="input-group-addon">\n                                                        <input type="radio" value="{{account.accountId}}" name="accountId" ng-model="vm.signup.accountId" ng-disabled="true" ng-change="vm.accountSelected(account)">\n                                                    </span>\n                          <div style="height:30px; font-size: 12px; padding: 6px 10px; color: #555; border: 1px solid #ccc;" ng-click="vm.accountSelected(account)">\n                            {{account.accountName}}\n                            <span style="margin-left: 10px;" class="ico ico-info-circle"  tooltip-placement="right"\n                              uib-tooltip="This account already exists. Please contact your Company Admin to be added."></span>\n                          </div>\n                        </div>\n                      </div>\n                    </div>\n                  </div>\n                  <div class="col-md-6" style="padding-top: 19px;">\n                    <div class="form-group" show-errors>\n                      <input type="hidden" id="hdnAccountId" name="hdnAccountId" ng-model="vm.hdnAccountId" required pcm-account-in-use />\n                      <p ng-if="accountSelectionForm.hdnAccountId.$error.required" class="help-block">Selecting an account is required or choose \'Enter New Account\'</p>\n                      <p ng-if="accountSelectionForm.hdnAccountId.$error.pcmAccountInUse" class="help-block">This company is already used. Email the <span ng-if="vm.companyAdminEmail"><a href="mailto:{{vm.companyAdminEmail}}">Company Admin</a></span>\n                        <span ng-if="!vm.companyAdminEmail">Company Admin</span> for more information.</p>\n                    </div>\n                  </div>\n                </div>\n                <div class="row form-group" ng-if="vm.enterNewAccount" show-errors>\n                  <div class="col-md-6" style="padding-top: 19px;">\n                    <label for="companyName" class="control-label label-sm">Company Name</label>\n                    <input id="companyName" name="companyName" class="form-control input-sm" type="text" ng-model="vm.signup.companyName" required\n                      pcm-unique-account ng-disabled="vm.isProcessing || vm.wizardStep != 3" pcm-class-on-value="filled" />\n                    <p ng-if="accountSelectionForm.companyName.$error.required" class="help-block">required</p>\n                    <p ng-if="accountSelectionForm.companyName.$error.pcmUniqueAccount" class="help-block">Company Name already exists. Please contact your administrator.</p>\n                  </div>\n                </div>\n                <div class="row">\n                  <div class="form-group col-md-12" style="margin-top: 10px;" ng-if="vm.wizardStep == 3">\n                    <button class="btn btn-sm btn-default" type="button" ng-click="vm.useNewAccount()" ng-if="vm.wizardStep == 3 && !vm.enterNewAccount">Enter New Account</button>\n                    <button class="btn btn-sm btn-default" type="button" ng-click="vm.useExistingAccount()" ng-if="vm.wizardStep == 3 && vm.enterNewAccount">Use Existing Account</button>\n                    <button type="reset" class="btn btn-sm btn-default" ng-disabled="vm.isProcessing" ng-click="vm.reset()">Start Over</button>\n                    <button type="submit" class="btn btn-sm btn-success" ng-disabled="vm.isProcessing"><i ng-show="vm.isProcessing" class="ico ico-circle-notch ico-spin ng-cloak" ng-cloak></i> <span ng-bind="(vm.isProcessing)?\'Verifying...\':\'Continue\'"></span></button>\n                  </div>\n                </div>\n              </ng-form>\n\n              <!-- Step 4: If username does not exist, enter password and confirmation for new account -->\n              <ng-form name="detailsForm" ng-if="vm.wizardStep >= 4">\n               <!-- <div class="row" ng-if="!vm.signup.userExists">\n                  <div class="col-md-12">\n                    <p class="form-instruction">Create a password for your account.</p>\n                  </div>\n                  <div class="col-md-6 form-group" show-errors>\n                    <label for="password" class="control-label label-sm">Password</label>\n                    <input id="password" class="form-control input-sm" name="password" type="password" ng-model="vm.signup.password" ng-minlength="8"\n                      ng-maxlength="20" required ng-disabled="vm.isProcessing" pcm-class-on-value="filled" />\n                    <p class="help-block" ng-if="detailsForm.password.$error.required">required</p>\n                    <p class="help-block" ng-if="detailsForm.password.$error.maxlength">Password must be less than or equal to 20 characters</p>\n                    <p class="help-block" ng-if="detailsForm.password.$error.minlength">Password must be more than or equal to 8 characters</p>\n                  </div>\n                  <div class="col-md-6 form-group" ng-if="!vm.signup.userExists" show-errors>\n                    <label for="confirmPassword" class="control-label label-sm">Confirm Password</label>\n                    <input id="confirmPassword" class="form-control input-sm" name="confirmPassword" type="password" ng-model="vm.signup.confirmPassword"\n                      pcm-compare-field="vm.signup.password" ng-disabled="vm.isProcessing" pcm-class-on-value="filled" />\n                    <p class="help-block" ng-if="detailsForm.confirmPassword.$error.pcmCompareField">Passwords must match</p>\n                  </div>\n                </div>-->\n\n                <p class="signup-section"><span class="label label-warning">2</span> Account Information</p>\n\n                <div class="row clearfix">\n                  <div class="form-group col-md-6" show-errors ng-if="!vm.userAccounts.length">\n                    <label for="companyName" class="control-label label-sm">Company Name</label>\n                    <input id="companyName" name="companyName" class="form-control input-sm" type="text" ng-model="vm.signup.companyName" required\n                      pcm-unique-account ng-disabled="vm.isProcessing" pcm-class-on-value="filled" />\n\n                    <p ng-if="detailsForm.companyName.$error.required" class="help-block">required</p>\n                    <p ng-if="detailsForm.companyName.$error.pcmUniqueAccount" class="help-block">Company Name already exists. Please contact your administrator.</p>\n                  </div>\n                  <!-- If the user has 0 accounts (new user or existing user with 0 accounts) show them the form to enter the new company name -->\n                  <div class="form-group col-md-3" show-errors>\n                    <label for="companyType" class="control-label label-sm">Company Type</label>\n                    <select id="companyType" name="companyType" class="form-control input-sm" ng-model="vm.signup.companyType" required ng-disabled="vm.isProcessing"\n                      pcm-class-on-value="filled">\n                                            <option value="1">Carrier \u2013 TL</option>\n                                            <option value="2">Carrier \u2013 LTL</option>\n                                            <option value="3">Company Driver</option>\n                                            <option value="4">Owner Operator</option>\n                                            <option value="5">Brokerage</option>\n                                            <option value="6">Manufacturer</option>\n                                            <option value="7">Logistics</option>\n                                            <option value="8">Consultant</option>\n                                            <option value="9">Courier</option>\n                                            <option value="10">Developer</option>\n                                            <option value="11">Freight Forwarder</option>\n                                            <option value="12">Government</option>\n                                            <option value="13">Intermodal</option>\n                                            <option value="14">Private Fleet</option>\n                                            <option value="15">Shipper</option>\n                                            <option value="16">Other</option>\n                                        </select>\n                    <p ng-if="detailsForm.companyType.$error.required" class="help-block">required</p>\n                  </div>\n                  <div class="form-group col-md-3" show-errors>\n                    <label for="numberOfTrucks" class="control-label label-sm">Number of Trucks</label>\n                    <input id="numberOfTrucks" name="numberOfTrucks" class="form-control input-sm" type="number" min="0" ng-model="vm.signup.numberOfTrucks"\n                      ng-disabled="vm.isProcessing" pcm-class-on-value="filled" />\n                    <p ng-if="detailsForm.numberOfTrucks.$error.number" class="help-block">Not a valid number of trucks</p>\n                  </div>\n                </div>\n\n                <div class="row">\n                  <div class="form-group col-md-4" show-errors>\n                    <label for="firstName" class="control-label label-sm">First Name</label>\n                    <input id="firstName" name="firstName" class="form-control input-sm" type="text" ng-model="vm.signup.firstName" required\n                      ng-disabled="vm.isProcessing" pcm-class-on-value="filled" />\n                    <p ng-if="detailsForm.firstName.$error.required" class="help-block">required</p>\n                  </div>\n                  <div class="form-group col-md-4" show-errors>\n                    <label for="lastName" class="control-label label-sm">Last Name</label>\n                    <input id="lastName" name="lastName" class="form-control input-sm" type="text" ng-model="vm.signup.lastName" required ng-disabled="vm.isProcessing"\n                      pcm-class-on-value="filled" />\n                    <p ng-if="detailsForm.lastName.$error.required" class="help-block">required</p>\n                  </div>\n                  <div class="form-group col-md-4" show-errors>\n                    <label for="jobTitle" class="control-label label-sm">Job Title</label>\n                    <select id="jobTitle" name="jobTitle" class="form-control input-sm" ng-model="vm.signup.jobTitle" required ng-disabled="vm.isProcessing"\n                      pcm-class-on-value="filled">\n                                            <option>Billing</option>\n                                            <option>Broker</option>\n                                            <option>Developer/Engineer</option>\n                                            <option>Dispatcher</option>\n                                            <option>Operations Manager</option>\n                                            <option>President/Owner</option>\n                                            <option>Project Manager</option>\n                                            <option>Other</option>\n                                        </select>\n                    <p ng-if="detailsForm.jobTitle.$error.required" class="help-block">required</p>\n                  </div>\n                </div>\n\n                <div class="row">\n                  <div class="form-group col-md-12" show-errors>\n                    <label for="address1" class="control-label label-sm">Address 1</label>\n                    <input id="address1" name="address1" class="form-control input-sm" type="text" ng-model="vm.signup.address1" required ng-disabled="vm.isProcessing"\n                      pcm-class-on-value="filled" />\n                    <p ng-if="detailsForm.address1.$error.required" class="help-block">required</p>\n                  </div>\n                </div>\n\n                <div class="row">\n                  <div class="form-group col-md-12">\n                    <label for="address2" class="control-label label-sm">Address 2</label>\n                    <input id="address2" name="address2" class="form-control input-sm" type="text" ng-model="vm.signup.address2" ng-disabled="vm.isProcessing"\n                      pcm-class-on-value="filled" />\n                  </div>\n                </div>\n\n                <div class="row">\n                  <div class="form-group col-md-5" show-errors>\n                    <label for="city" class="control-label label-sm">City</label>\n                    <input id="city" name="city" class="form-control input-sm" type="text" ng-model="vm.signup.city" required ng-disabled="vm.isProcessing"\n                      pcm-class-on-value="filled" />\n                    <p ng-if="detailsForm.city.$error.required" class="help-block">required</p>\n                  </div>\n                  <div class="form-group col-md-3" show-errors>\n                    <label for="state" class="control-label label-sm">State/Province</label>\n                    <select id="state" name="state" class="form-control input-sm" ng-model="vm.signup.state" ng-options="state.abbreviation as state.name group by state.country for state in vm.states"\n                      required ng-disabled="vm.isProcessing" pcm-class-on-value="filled">\n                                            <option value=""></option>\n                                        </select>\n                    <p ng-if="detailsForm.state.$error.required" class="help-block">required</p>\n                  </div>\n                  <div class="form-group col-md-2" show-errors>\n                    <label for="postalCode" class="control-label label-sm">ZIP Code</label>\n                    <input id="postalCode" name="postalCode" class="form-control input-sm" type="text" ng-model="vm.signup.postalCode" required\n                      ng-disabled="vm.isProcessing" pcm-class-on-value="filled" />\n                    <p ng-if="detailsForm.postalCode.$error.required" class="help-block">required</p>\n                  </div>\n                  <div class="form-group col-md-2" show-errors>\n                    <label for="country" class="control-label label-sm">Country</label>\n                    <select id="country" name="country" class="form-control input-sm" ng-model="vm.signup.country" ng-options="country.country as country.country for country in vm.countries"\n                      required ng-disabled="vm.isProcessing" pcm-class-on-value="filled">\n                                            <option value=""></option>\n                                        </select>\n                    <p ng-if="detailsForm.country.$error.required" class="help-block">required</p>\n                  </div>\n                </div>\n\n                <div class="row clearfix">\n                  <div class="form-group col-md-5" show-errors>\n                    <label for="phoneNumber" class="control-label label-sm">Phone Number</label>\n                    <input id="phoneNumber" name="phoneNumber" class="form-control input-sm" type="text" ng-model="vm.signup.phoneNumber" required\n                      ng-disabled="vm.isProcessing" pcm-class-on-value="filled" />\n                    <p ng-if="detailsForm.phoneNumber.$error.required" class="help-block">required</p>\n                  </div>\n                </div>\n\n                <p class="signup-section"><span class="label label-warning">3</span> Select a Subscription Level</p>\n                <div class="row">\n                  <div class="col-sm-offset-2 col-md-8">\n                    <p class="pricing-header text-center">Select a Feature Level</p>\n                  </div>\n                </div>\n                <div class="row pricing-table col-sm-offset-2 col-sm-12">\n                  <div class="col-md-4" ng-show="vm.canUserSignupForTrial">\n                    <table class="table free" ng-class="(vm.signup.featureLevel === \'Trial\')?\'selected\':\'\'" ng-click="vm.signup.featureLevel = \'Trial\'">\n                      <tr class="price-title">\n                        <td>\n                          <label class="trial" for="account_type_trial">Trial <span class="ico ico-check-circle-o" aria-hidden="true" ng-show="(vm.signup.featureLevel === \'Trial\')"></span></label>\n                          <input type="radio" class="account-type-radio" value="Trial" id="account_type_trial" name="account_type_radio" ng-model="vm.signup.featureLevel"\n                            ng-disabled="vm.isProcessing" />\n                        </td>\n                      </tr>\n                      <tr>\n                        <td>\n                          <p class="price">Free</p>\n                          <p class="price-note">for one user</p>\n                        </td>\n                      </tr>\n                      <tr>\n                        <td>\n                          <p class="price-features">Access to <strong>All Features</strong> for<br />7 days or 35 routes</p>\n                        </td>\n                      </tr>\n                    </table>\n                  </div>\n                  <div ng-class="vm.canUserSignupForTrial ? \'col-md-4\' : \'col-sm-offset-2 col-md-4\'">\n                    <table class="table premium" ng-class="(vm.signup.featureLevel === \'Premium\')?\'selected\':\'\'" ng-click="vm.signup.featureLevel = \'Premium\'">\n                      <tr class="price-title">\n                        <td>\n                          <label class="premium" for="account_type_premium">Premium <span class="ico ico-check-circle-o" aria-hidden="true" ng-show="(vm.signup.featureLevel === \'Premium\')"></span></label>\n                          <input type="radio" class="account-type-radio" value="Premium" id="account_type_premium" name="account_type_radio" ng-model="vm.signup.featureLevel"\n                            ng-disabled="vm.isProcessing" />\n                        </td>\n                      </tr>\n                      <tr>\n                        <td>\n                          <p class="price">$84.99</p>\n                          <p class="price-note">a month per user</p>\n                        </td>\n                      </tr>\n                      <tr>\n                        <td>\n                          <p class="price-features">\n                            <strong>Full Service Set</strong><br/> of comprehensive routing options<br/> and planning tools\n                            with:<br />\n                            <small>Real-time traffic &amp; weather display</small>\n                            <small>Map &amp; toll data updates</small>\n                            <small>Street-level routing in the U.S. &amp; Canada</small>\n                          </p>\n                        </td>\n                      </tr>\n                    </table>\n                  </div>\n                  <!-- <div class="col-md-4">\n                    <table class="table standard" ng-class="(vm.signup.featureLevel === \'Standard\')?\'selected\':\'\'" ng-click="vm.signup.featureLevel = \'Standard\'">\n                      <tr class="price-title">\n                        <td>\n                          <label class="standard" for="account_type_standard">Standard <span class="ico ico-check-circle-o" aria-hidden="true" ng-show="(vm.signup.featureLevel === \'Standard\')"></span></label>\n                          <input type="radio" class="account-type-radio" value="Standard" id="account_type_standard" name="account_type_radio" ng-model="vm.signup.featureLevel"\n                            ng-disabled="vm.isProcessing" />\n                        </td>\n                      </tr>\n                      <tr>\n                        <td>\n                          <p class="price">$59.99</p>\n                          <p class="price-note">a month per user</p>\n                        </td>\n                      </tr>\n                      <tr>\n                        <td>\n                          <p class="price-features">Basic Routing and Reporting<br/><br/></p>\n                        </td>\n                      </tr>\n                    </table>\n                  </div> -->\n                </div>\n\n                <div class="row pricing-totals">\n                  <div class="col-md-6 form-group text-center" show-errors>\n                    <span class="num-users">Select Number of Users:</span>\n                    <input id="numberOfUsers" class="form-control input-sm" name="numberOfUsers" type="number" min="1" ng-model="vm.signup.numberOfUsers"\n                      maxlength="6" style="width:75px; display: inline-block" ng-disabled="vm.isProcessing || !vm.signup.isCreditCardRequired()"\n                      required pcm-class-on-value="filled" />\n                    <p ng-if="detailsForm.numberOfUsers.$error.required" class="help-block">required</p>\n                    <p ng-if="detailsForm.numberOfUsers.$error.number" class="help-block">Not a valid number of users</p>\n                    <p ng-if="detailsForm.numberOfUsers.$error.min" class="help-block">Number of users must be greater than 0</p>\n                    <p ng-if="detailsForm.numberOfUsers.$error.maxlength" class="help-block">Number of users must be below 999,999</p>\n                  </div>\n\n                  <div class="col-md-6 form-group text-center">\n                    <span class="total-price">\n                                            Total Charge: <strong ng-if="vm.signup.price > 0">{{vm.signup.price | currency}} /Month</strong><strong ng-if="vm.signup.price <= 0">Free</strong>\n                                        </span>\n                  </div>\n                </div>\n                <div ng-class="slideInOut" ng-if="vm.signup.featureLevel !== \'Trial\'">\n                  <p class="signup-section"><span class="label label-warning">4</span> Billing Information</p>\n\n                  <billing-information ng-model="vm.signup.card" ng-required="vm.signup.isCreditCardRequired()" ng-disabled="!vm.signup.isCreditCardRequired() || vm.isProcessing"></billing-information>\n\n                </div>\n                <div class="row" style="margin-top:30px">\n                  <div class="col-md-offset-6 col-md-6 text-right">\n                    <div>\n                      <div class="alert alert-success ng-hide ng-cloak fadeInOut right" style="display:inline-block" role="alert" ng-cloak ng-show="vm.isAlertShowing">\n                        {{vm.alertMessage}}\n                      </div>\n                    </div>\n                    <button class="btn btn-default" type="reset" ng-disabled="vm.isProcessing" ng-click="vm.reset()">Start Over</button>\n                    <button type="submit" class="btn btn-lg btn-success" ng-disabled="vm.isAlertShowing || vm.isProcessing || detailsForm.$invalid">\n                                            <i ng-show="vm.isProcessing" class="ico ico-circle-notch ico-spin ng-cloak" ng-cloak></i>\n                                            <span ng-bind="(vm.isProcessing)?\'Submitting...\':\'Complete Sign Up\'"></span>\n                                            <span class="has-error" ng-if="detailsForm.$invalid">\n                                                &nbsp;\n                                                <i class="glyphicon glyphicon-exclamation-sign"></i>\n                                            </span>\n                                        </button>\n                                        <span class="has-error pull-right">\n                                         <p ng-show="detailsForm.$invalid" class="help-block">All fields are required</p>\n                                        </span>\n                  </div>\n                </div>\n              </ng-form>\n              <br />\n              <br />\n              <br />\n            </div>\n          </div>\n        </form>\n      </div>\n    </div>\n  </div>\n\n  <marketing-footer></marketing-footer>\n</div>');
  $templateCache.put('/pages/terms.html', '\n<div class="container">\n    <div class="panel col-md-12">\n        <div class="page-header" ng-include="\'/app/account/loginHeader.template.html\'"></div>\n        <div class="page-content">\n            <h1>Terms of Use</h1>\n            <div ng-include="\'/app/account/tos_text.html\'"></div>\n        </div>\n    </div>\n</div>');
  $templateCache.put('/app/account/billing_address.html', '<div>\n\n  <div class="form-group sm row">\n    <div class="col-md-6" ng-class="{ \'has-error\' : form.address1.$invalid && form.submitted }">\n      <label for="address1" class="control-label label-sm">Address 1</label>\n      <input id="address1" name="address1" class="form-control input-sm" type="text" ng-model="address.address1" required ng-disabled="ngDisabled"\n        pcm-class-on-value="filled" />\n      <div ng-if="form.submitted">\n        <p ng-if="form.address1.$error.required" class="help-block">Address is required</p>\n      </div>\n    </div>\n    <div class="col-md-6">\n      <label for="address2" class="control-label label-sm">Address 2</label>\n      <input id="address2" name="address2" class="form-control input-sm" type="text" ng-model="address.address2" ng-disabled="ngDisabled"\n        pcm-class-on-value="filled" />\n    </div>\n  </div>\n\n  <div class="form-group sm row">\n    <div class="col-md-6" ng-class="{ \'has-error\' : form.city.$invalid && form.submitted }">\n      <label for="city" class="control-label label-sm">City</label>\n      <input id="city" name="city" class="form-control input-sm" type="text" ng-model="address.city" required ng-disabled="ngDisabled"\n        pcm-class-on-value="filled" />\n      <div ng-if="form.submitted">\n        <p ng-if="form.city.$error.required" class="help-block">City is required</p>\n      </div>\n    </div>\n    <div class="col-md-3" ng-class="{ \'has-error\' : form.state.$invalid && form.submitted }">\n      <label for="state" class="control-label label-sm">State/Province</label>\n      <select id="state" name="state" class="form-control input-sm" ng-model="address.state" ng-options="state.abbreviation as state.name group by state.country for state in states"\n        required ng-disabled="ngDisabled" pcm-class-on-value="filled">\n        <option value=""></option>\n      </select>\n      <div ng-if="form.submitted">\n        <p ng-if="form.state.$error.required" class="help-block">State/Province is required</p>\n      </div>\n    </div>\n    <div class="col-md-3" ng-class="{ \'has-error\' : form.postalCode.$invalid && form.submitted }">\n      <label for="postalCode" class="control-label label-sm">ZIP Code</label>\n      <input id="postalCode" name="postalCode" class="form-control input-sm" type="text" ng-model="address.postalCode" required\n        ng-disabled="ngDisabled" pcm-class-on-value="filled" />\n      <div ng-if="form.submitted">\n        <p ng-if="form.postalCode.$error.required" class="help-block">ZIP Code is required</p>\n      </div>\n    </div>\n  </div>\n\n  <div class="form-group sm row">\n    <div class="col-md-6" ng-class="{ \'has-error\' : form.country.$invalid && form.submitted }">\n      <label for="country" class="control-label label-sm">Country</label>\n      <select id="country" name="country" class="form-control input-sm" ng-model="address.country" ng-options="country.country as country.country for country in countries"\n        required ng-disabled="ngDisabled" pcm-class-on-value="filled">\n        <option value=""></option>\n      </select>\n      <div ng-if="form.submitted">\n        <p ng-if="form.country.$error.required" class="help-block">Country is required</p>\n      </div>\n    </div>\n    <div class="col-md-6" ng-class="{ \'has-error\' : form.phoneNumber.$invalid && form.submitted }">\n      <label for="phoneNumber" class="control-label label-sm">Phone Number</label>\n      <input id="phoneNumber" name="phoneNumber" class="form-control input-sm" type="text" ng-model="address.phoneNumber" required\n        ng-disabled="ngDisabled" pcm-class-on-value="filled" />\n      <div ng-if="form.submitted">\n        <p ng-if="form.phoneNumber.$error.required" class="help-block">Phone Number is required</p>\n      </div>\n    </div>\n  </div>\n</div>\n\n');
  $templateCache.put('/app/account/billing_information.html', '<div>\n  <style>\n    .help-block {\n      display: none;\n    }\n\n    .has-error .help-block {\n      display: block;\n    }\n\n  </style>\n  <div class="form-group sm row">\n    <div class="col-md-3" ng-class="{ \'has-error\' : form.cardType.$invalid && (!form.cardType.$pristine || form.submitted || showErrorsOnLoad) }">\n      <label for="cardType" class="control-label label-sm label-static">Card Type</label>\n      <span class="form-control-static input-sm">{{card.type}}</span>\n    </div>\n    <div class="col-md-5" ng-class="{ \'has-error\' : form.cardNumber.$invalid && (!form.cardNumber.$pristine || form.submitted || showErrorsOnLoad) }">\n      <label for="cardNumber" class="control-label label-sm">Card Number</label>\n      <input id="cardNumber" name="cardNumber" class="form-control input-sm" type="text" ng-model="card.number" ng-required="ngRequired"\n        ng-disabled="ngDisabled" ng-minlength="15" maxlength="19" card-type="card.type" pcm-class-on-value="filled" />\n      <span class="pull-right">{{card.last4Digits}}</span>\n      <div>\n        <p ng-show="form.cardNumber.$error.required" class="help-block">required</p>\n        <p ng-show="form.cardNumber.$error.cardType" class="help-block">Card card must be a valid AMEX, VISA, or MasterCard</p>\n        <p ng-show="form.cardNumber.$error.minlength" class="help-block">Credit card must be 15-19 digits</p>\n      </div>\n    </div>\n    <div class="col-md-4" ng-class="{ \'has-error\' : form.cardName.$invalid && (!form.cardName.$pristine || form.submitted || showErrorsOnLoad) }">\n      <label for="cardName" class="control-label label-sm">Cardholder Name</label>\n      <input class="form-control input-sm" type="text" id="cardName" name="cardName" ng-model="card.name" ng-required="ngRequired"\n        ng-disabled="ngDisabled" pcm-class-on-value="filled" />\n      <div ng-show="!form.expirationMonth.$pristine || form.submitted || showErrorsOnLoad">\n        <p ng-show="form.cardName.$error.required" class="help-block">required</p>\n      </div>\n    </div>\n\n  </div>\n  <div class="form-group sm row">\n    <div class="col-md-3 col-md-offset-3" ng-class="{ \'has-error\' : (form.cardExpiration.$invalid && (!form.expirationMonth.$pristine || !form.expirationYear.$pristine || form.submitted || showErrorsOnLoad))  || (form.expirationMonth.$invalid && (!form.expirationMonth.$pristine || form.submitted || showErrorsOnLoad)) }">\n      <label for="expirationMonth" class="control-label label-sm">Exp. Month</label>\n      <select id="expirationMonth" name="expirationMonth" class="form-control input-sm" ng-required="ngRequired" ng-model="card.expMonth"\n        pcm-integer ng-disabled="ngDisabled" pcm-class-on-value="filled">\n                <option value="1">01</option>\n                <option value="2">02</option>\n                <option value="3">03</option>\n                <option value="4">04</option>\n                <option value="5">05</option>\n                <option value="6">06</option>\n                <option value="7">07</option>\n                <option value="8">08</option>\n                <option value="9">09</option>\n                <option value="10">10</option>\n                <option value="11">11</option>\n                <option value="12">12</option>\n            </select>\n      <div ng-show="!form.expirationMonth.$pristine || form.submitted || showErrorsOnLoad">\n        <p ng-show="form.expirationMonth.$error.required" class="help-block">required</p>\n      </div>\n      <div ng-show="form.cardExpiration.$invalid && (!form.expirationMonth.$pristine || !form.expirationYear.$pristine || form.submitted || showErrorsOnLoad)">\n        <p ng-show="form.cardExpiration.$error.cardExpiration" class="help-block">expiration date must be in the future</p>\n      </div>\n    </div>\n    <div class="col-md-3" ng-class="{ \'has-error\' : form.expirationYear.$invalid && (!form.expirationYear.$pristine || form.submitted|| showErrorsOnLoad) }">\n      <label for="expirationYear" class="control-label label-sm">Exp. Year</label>\n      <select id="expirationYear" name="expirationYear" class="form-control input-sm" ng-options="year for year in expirationYears"\n        ng-required="ngRequired" ng-model="card.expYear" ng-disabled="ngDisabled" pcm-class-on-value="filled">\n                <option style="display:none" value="">{{card.expYear}}</option>\n            </select>\n      <p ng-show="form.expirationYear.$error.required && (!form.expirationYear.$pristine || form.submitted || showErrorsOnLoad)"\n        class="help-block">required</p>\n    </div>\n    <div class="col-md-3" ng-class="{ \'has-error\' : form.cvv.$invalid && (!form.cvv.$pristine || form.submitted || showErrorsOnLoad) }">\n      <label for="cvv" class="control-label label-sm">CVV</label>\n      <input id="cvv" name="cvv" class="form-control input-sm" type="text" ng-model="card.cvv" ng-required="ngRequired" ng-disabled="ngDisabled"\n        ng-pattern="/^[0-9]{3,4}$/" maxlength="4" pcm-class-on-value="filled" />\n      <p ng-show="form.cvv.$error.required && (!form.cvv.$pristine || form.submitted || showErrorsOnLoad)" class="help-block">required</p>\n      <p ng-show="form.cvv.$error.pattern && (!form.cvv.$pristine || form.submitted || showErrorsOnLoad)" class="help-block">invalid</p>\n    </div>\n  </div>\n  <input type="hidden" name="cardExpiration" ng-model="cardExpiration" card-month="card.expMonth" card-year="card.expYear"\n    card-expiration />\n</div>\n');
  $templateCache.put('/app/account/cancelCustomer.template.html', '<div>\n    <div class="modal-header">\n        <h3 class="modal-title">Cancel Account</h3>\n    </div>\n    <div class="modal-body">\n        <div ng-bind="vm.message">\n        </div>\n    </div>\n    <div class="modal-footer">\n        <button type="button" class="btn btn-default" ng-disabled="vm.processing" ng-click="vm.close()">Do not cancel</button>\n        <button type="button" class="btn btn-primary" ng-disabled="vm.processing" ng-click="vm.ok()"><span ng-bind="(vm.processing)?\'Cancelling...\':\'Confirm Cancel\'"></span></button>\n    </div>\n</div>\n');
  $templateCache.put('/app/account/loginHeader.template.html', '<div>\n    <a class="pull-left" href="/app">\n        <img src="/img/pcm-header-pages.png" />\n    </a>\n    <div class="clearfix"></div>\n</div>\n');
  $templateCache.put('/app/account/replaceUser.template.html', '<div>\n  <form id="replaceUserForm" name="replaceUserForm" novalidate pcm-submit="vm.replaceUser()">\n    <div class="modal-header">\n      <h3 class="modal-title">Replace User</h3>\n    </div>\n    <div class="modal-body">\n      <div class="alert alert-danger alert-sm" ng-if="vm.showGenericError">\n        <span><i class="glyphicon glyphicon-exclamation-sign"></i>&nbsp; There was an error replacing this user. Please contact support.</span>\n      </div>\n      <div class="form-group">\n        <label class="control-label label-sm label-line">Replacing User</label>\n        <input class="form-control input-sm input-line" type="text" name="OldUserEmail" disabled readonly ng-model="vm.oldUser.UserName"/>\n      </div>\n      <div class="alert alert-warning alert-sm" ng-if="userInfo.userName === vm.oldUser.UserName">\n        <span><i class="glyphicon glyphicon-exclamation-sign"></i>&nbsp; You are currently replacing yourself.  Upon completion of this, you will be logged out of this account and no longer permitted to login.</span>\n      </div>\n\n      <div class="form-group" ng-class="{ \'has-error\' : replaceUserForm.firstName.$invalid && replaceUserForm.submitted}">\n        <label for="newFirstName" class="control-label label-sm label-line">First Name</label>        \n        <input class="form-control input-sm input-line" id="newFirstName" name="firstName" type="text" required ng-disabled="vm.isProcessing"\n          ng-model="vm.newUser.firstName" autofocus/>\n        <div ng-if="replaceUserForm.submitted">\n          <p ng-if="replaceUserForm.firstName.$error.required" class="help-block">required</p>\n        </div>\n      </div>\n\n      <div class="form-group" ng-class="{ \'has-error\' : replaceUserForm.lastName.$invalid && replaceUserForm.submitted}">\n        <label for="newLastName" class="control-label label-sm label-line">Last Name</label>\n        <input class="form-control input-sm input-line" id="newLastName" name="lastName" type="text" required ng-disabled="vm.isProcessing"\n          ng-model="vm.newUser.lastName" />\n        <div ng-if="replaceUserForm.submitted">\n          <p ng-if="replaceUserForm.lastName.$error.required" class="help-block">required</p>\n        </div>\n      </div>\n\n      <div class="form-group" ng-class="{ \'has-error\' : replaceUserForm.email.$invalid && replaceUserForm.submitted}">\n        <label for="email" class="control-label label-sm label-line">Email Address</label>\n        <input class="form-control input-sm input-line" id="email" name="email" type="text" ng-model="vm.newUser.email" account-Email\n          required ng-disabled="vm.isProcessing" />\n        <div ng-if="replaceUserForm.submitted">\n          <p ng-if="replaceUserForm.email.$error.required" class="help-block">required</p>\n          <p ng-if="replaceUserForm.email.$error.accountEmail" class="help-block">Not a valid email</p>\n        </div>\n      </div>\n\n    </div>\n    <div class="modal-footer">\n      <button type="button" class="btn btn-default" ng-click="vm.close()" ng-disabled="vm.isProcessing">Cancel</button>\n      <button type="submit" class="btn btn-primary" ng-disabled="vm.isProcessing">Replace</button>\n    </div>\n  </form>\n</div>\n');
  $templateCache.put('/app/account/terms.html', '\n<div class="container">\n    <div class="panel col-md-12">\n        <div class="page-header" ng-include="\'/app/account/loginHeader.template.html\'"></div>\n        <div class="page-content">\n            <h1>Terms of Use</h1>\n            <h3>Read through to the bottom of the page to accept these terms</h3>\n            <div ng-include="\'/app/account/tos_text.html\'"></div>\n\n            <div ng-controller="termsController" class="text-center">\n                <button type="button" class="btn btn-lg btn-success" ng-disabled="isProcessing" ng-click="acceptTerms()">\n                    <i ng-show="isProcessing" class="ico ico-circle-notch ico-spin ng-cloak" ng-cloak></i> \n                    <span>Accept</span>\n                </button>\n            </div>\n        </div>\n    </div>\n</div>');
  $templateCache.put('/app/account/tos_text.html', '<p>A PC*MILER|Web ("<strong>PC*MILER</strong>") account is solely for use by individuals, and a PC*MILER|Web username may only be used by one individual at a time. If you would like to purchase multiple usernames for a single account, or a subscription to our companion product, PC*MILER Web Services, which permits interfacing to computer programs using XML, you may do so by telephoning Trimble MAPS, Inc.\u2019s (\u201C<strong>Trimble MAPS</strong>\u201D) sales department during business hours at 1-800-377-MILE (6453) ext. 2..</p>\n<p>In order to use PC*MILER|Web, you must first agree to the Terms of Use. You may not use PC*MILER|Web if you do not accept the Terms of Use. You can accept the Terms of Use by clicking to accept or agree to the Terms of Use, where this option is made available to you by Trimble MAPS in PC*MILER|Web, upon account activation, or by actually using PC*MILER|Web. In so doing, you understand and agree that Trimble MAPS will treat your use of PC*MILER|Web as acceptance of the Terms of Use from that point onwards.</p>\n<p>You may not use PC*MILER|Web and may not accept the Terms of Use if you are not of legal age to form a binding contract with Trimble MAPS, or if you are a person barred from receiving PC*MILER|Web under the laws of the United States or other countries including the country in which you reside or from which you access PC*MILER|Web.</p>\n\n<p>1. <strong><u>Licensed Uses and Restrictions.</u></strong></p>\n<p>PC*MILER is owned by Trimble MAPS, and is licensed to you on a worldwide (except as limited below), non-exclusive, non-sublicenseable basis on the terms and conditions set forth herein. These Terms of Use define legal use of PC*MILER, including all updates and revisions. All rights not expressly granted to you are reserved by Trimble MAPS, Inc.,. PC*MILER services provided to you may change from time to time and you acknowledge that the provision of any service at any given point in time does not constitute a promise by Trimble MAPS, to continue to provide such service in the future.</p>\n<p>a) YOU MAY use PC*MILER and any updates provided by Trimble MAPS, (in its sole discretion) provided you pay all associated fees in a timely manner and otherwise comply with these Terms of Use. Your license to PC*MILER under these Terms of Use continues until it is terminated by either party in accordance with these Terms of Use.</p>\n<p>b) YOU SHALL NOT:</p>\n<ul>\n  <li>(i) use PC*MILER in any manner or for any purpose that violates any law or regulation, any right of any person, including but not limited to intellectual property rights, rights of privacy, or rights of personality, or in any manner inconsistent with these Terms of Use;</li>\n  <li>(ii) use PC*MILER by any automated means, including scripts, "screen scraping", "bots" or the like, nor shall you interface any computer program directly to PC*MILER other than by manual copy and paste methods;</li>\n  <li>(iii) sell, lease, or sublicense PC*MILER or access thereto;</li>\n  <li>(iv) use PC*MILER in a manner that exceeds reasonable request volume, defined as, for each individual user name, the number of route and/or map requests that could be reasonably typed in by and viewed by an individual; or</li>\n  <li>(v) extract and publish, or allow other users to extract and publish, any substantial percentage of the data contained in or produced by PC*MILER, not to exceed the percentage that would constitute "fair use" under copyright law, unless each recipient of such data is currently licensed for that data by Trimble MAPS.</li>\n</ul>\n\n<p>2. <strong><u>Limited Warranty and Disclaimer.</u></strong></p>\n<p>a) Limited Warranty as to Virus Control. Trimble MAPS. hereby warrants that to the best of its knowledge there is no virus in any portion of PC*MILER and that it has used commercially reasonable efforts to ensure that PC*MILER is free of computer viruses and has undergone virus checking procedures consistent with industry standards. The term "virus" as used hereunder means (a) any computer code designed to disable, disrupt or damage your use of PC*MILER or your computer or network, or (b) damage or destroy any data or files residing on your computer system without your consent.</p>\n<p>b) Disclaimer of all other Warranties. Except for the limited warranty provided in the preceding paragraph of this Section 2, TRIMBLE MAPS, DOES NOT REPRESENT OR WARRANT THAT PC*MILER IS OR WILL BE FREE OF INACCURACIES, ERRORS, BUGS, OR INTERRUPTIONS, OR IS RELIABLE, ACCURATE, COMPLETE, OR OTHERWISE VALID. PC*MILER IS PROVIDED "AS IS". TRIMBLE MAPS, EXPRESSLY DISCLAIMS ANY AND ALL WARRANTIES AND CONDITIONS, INCLUDING, BUT NOT LIMITED TO, ANY IMPLIED WARRANTY OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AVAILABILITY, SECURITY, TITLE AND/OR NON-INFRINGEMENT. YOUR USE OF PC*MILER IS AT YOUR OWN DISCRETION AND RISK. YOU WILL BE SOLELY RESPONSIBLE FOR ANY DAMAGE THAT RESULTS FROM USING PC*MILER INCLUDING, BUT NOT LIMITED TO, ANY DAMAGE TO YOUR COMPUTER SYSTEM OR LOSS OF DATA.</p>\n\n<p>3. <strong><u>Ownership and Relationship of Parties.</u></strong></p>\n<p>PC*MILER may be protected by copyrights, trademarks, service marks, international treaties, and/or other proprietary rights and laws of the U.S. and other countries. Trimble MAPS\' rights apply to PC*MILER and all output and executables of PC*MILER. You agree to abide by all applicable proprietary rights laws and other laws, as well as any additional copyright notices or restrictions contained in these Terms of Use. Trimble MAPS, owns all rights, title, and interest in and to PC*MILER. These Terms of Use grant you no right, title, or interest in any intellectual property owned or licensed by Trimble MAPS, including (but not limited to) PC*MILER and Trimble MAPS\u2019 trademarks.</p>\n\n<p>4. <strong><u>Operating Hours.</u></strong></p>\n<p>a) Trimble MAPS, shall operate PC*MILER 24 hours a day, 7 days a week, 365 days a year, subject to the limitations set forth in this section, during the term of this agreement.</p>\n<p>b) Trimble MAPS, shall operate PC*MILER so that scheduled maintenance will not normally result in PC*MILER interruption. If scheduled maintenance requires PC*MILER interruption, Trimble MAPS will provide a minimum of 7 days\u2019 prior written notice, and will use commercially reasonable efforts to perform such maintenance with the minimum interruption time. Scheduled maintenance along with Force Majeure events and Security events defined in section 9(f) shall be considered "Excused Outages".</p>\n<p>c) Not including Excused Outages, Trimble MAPS\u2019 uptime commitment is 99.5% for PC*MILER. If in any calendar month this uptime commitment is not met, Trimble MAPS. will issue to you on request a pro rata credit equal to the amount of downtime. If in any one month cumulative downtime exceeds 72 hours, you may also request early termination of this Agreement and receive a pro-rata refund of any prepayments applying to the remainder of the contract term. This Section 4(c) shall be Trimble MAPS\u2019 sole obligation and your exclusive remedy for any failure by Trimble MAPS, to meet its uptime commitment and must be requested in writing to Trimble MAPS, within five (5) business days following the outage in question.</p>\n\n<p>5. <strong><u>Technical Support.</u></strong></p>\n<p>a) Trimble MAPS, shall provide technical support services, updates, and enhancements to PC*MILER, including the correction of errors or defects ("Support") at Trimble MAPS\u2019 discretion during Trimble MAPS\u2019 standard business hours excluding holidays. "Errors or defects" shall mean the failure of PC*MILER to operate in substantial conformity with the PC*MILER documentation.</p>\n<p>b) You may report suspected errors or defects to Trimble MAPS, by electronic mail, website, or telephone. Trimble MAPS will, upon receipt of your report, seek to identify the cause of the reported problem and, if the problem is determined by Trimble MAPS, to result from an error or defect in PC*MILER, Trimble MAPS shall use due diligence to investigate the reported error or defect.</p>\n<p>c) Trimble MAPS shall make available for your use during the term of this Agreement, at no additional charge, all standard updates and enhancements to PC*MILER where such updates and enhancements are generally made available without charge to Trimble MAPS\u2019 other customers of PC*MILER.</p>\n<p>d) Trimble MAPS shall not be obligated to provide support services under this Agreement if such services are required because of</p>\n<ul>\n  <li>(i) use by you that is inconsistent with this agreement or the PC*MILER documentation,</li>\n  <li>(ii) incorrect or incomplete data or input provided by you, or</li>\n  <li>iii) causes external to PC*MILER.</li>\n</ul>\n\n<p>6. <strong><u>Limitation of Liability.</u></strong></p>\n<p>TRIMBLE MAPS, SHALL NOT, UNDER ANY CIRCUMSTANCES, BE LIABLE TO YOU FOR ANY INDIRECT, INCIDENTAL, CONSEQUENTIAL, SPECIAL OR EXEMPLARY DAMAGES ARISING OUT OF OR IN CONNECTION WITH USE OF PC*MILER, WHETHER BASED ON BREACH OF CONTRACT, BREACH OF WARRANTY, TORT (INCLUDING NEGLIGENCE, PRODUCT LIABILITY OR OTHERWISE), OR ANY OTHER PECUNIARY LOSS, WHETHER OR NOT TRIMBLE MAPS, HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. UNDER NO CIRCUMSTANCES SHALL TRIMBLE MAPS BE LIABLE TO YOU FOR ANY AMOUNT.</p>\n\n<p>7. <strong><u>Force Majeure.</u></strong></p>\n<p>NEITHER PARTY SHALL BE IN BREACH OF THIS AGREEMENT IN THE EVENT IT IS UNABLE TO PERFORM ITS OBLIGATIONS (OTHER THAN TIMELY PAYMENT OF FEES) AS A RESULT OF NATURAL DISASTER, WAR, EMERGENCY CONDITIONS, LABOR STRIFE, THE FAILURE OR SUBSTANTIAL FAILURE OF THE INTERNET OR ANY PORTION THEREOF, OR OTHER REASONS OR CONDITIONS BEYOND ITS REASONABLE CONTROL (TOGETHER, "FORCE MAJEURE EVENTS").</p>\n\n<p>8. <strong><u>Hold Harmless and Indemnity.</u></strong></p>\n<p>To the maximum extent permitted by applicable law, you agree to hold harmless and indemnify Trimble MAPS, and its subsidiaries, affiliates, officers, agents, licensors, co-branders or other partners, and employees from and against any third party claim arising from or in any way related to your use of PC*MILER for routing of trucks, including any liability or expense arising from all claims, losses, damages (actual and/or consequential), suits, judgments, litigation costs and attorneys\' fees, of every kind and nature. Trimble MAPS shall use good faith efforts to provide you with written notice of such claim, suit or action.</p>\n\n<p>9. <strong><u>General Terms.</u></strong>\n<p>a) Relationship of the Parties. For all purposes of the Terms of Use, you and Trimble MAPS shall be and act independently and not as partner, joint venturer, agent, employee or employer of the other. Neither party shall have any authority to assume or create any obligation for or on behalf of the other party, express or implied, and neither party will attempt to bind the other party to any contract.</p>\n<p>b) Invalidity of Specific Terms. If a court of competent jurisdiction rules any provision of the Terms of Use invalid, the parties nevertheless agree that the court should endeavor to give effect to the parties\' intentions as reflected in the provision and the other provisions of such documents remain in full force and effect.</p>\n<p>c) Location of Lawsuit and Choice of Law. The Terms of Use and the relationship between you and Trimble MAPS shall be governed by the laws of the State of New Jersey without regard to its conflict of law provisions. You and Trimble MAPS, agree to submit to the personal jurisdiction of the courts located in Mercer County, New Jersey.</p>\n<p>d) No Waiver of Rights by Trimble MAPS. Trimble MAPS\' failure to exercise or enforce any right or provision of the Terms of Use shall not constitute a waiver of such right or provision.</p>\n<p>e) Non-Transferability. This license is personal to you and you may not assign or transfer it to any third party without Trimble MAPS\u2019 prior written consent and any such purported assignment shall be void.</p>\n<p>f) Security. Both parties agree to take reasonable and customary measures common in the IT industry to secure their systems from virus, hacker, and denial of service attacks, and you agree that Trimble MAPS may immediately slow down or cut off service to you if necessary to temporarily halt an attack originating with or through you until such time as you take corrective action.</p>\n<p>g) You understand that the use of PC*MILER involves the transmission of your data over the Internet and over various networks, only part of which may be owned or operated by Trimble MAPS, and that Trimble MAPS takes no responsibility for data which are lost, altered, intercepted or stored without your authorization during the transmission of any data whatsoever across networks not owned or operated by Trimble MAPS.</p>\n\n<p>10. <strong><u>Privacy.</u></strong></p>\n<p>You understand and agree that you must provide certain personal information to Trimble MAPS in order to use the PC*MILER|Web service.</p>\n<p>When you order PC*MILER|Web, you must provide your name, e-mail address, mailing address, credit card number, and its expiration date. This allows Trimble MAPS to process and fulfill your order, to notify you of your order status, and to contact you with news about the PC*MILER|Web service. This information will be stored by Trimble MAPS, for use in processing future orders by you. Trimble MAPS may also use your e-mail address to notify you about important Trimble MAPS news, special offers, or new product releases that Trimble MAPS thinks you\'ll find valuable. If you would rather not receive such information, Trimble MAPS includes an "unsubscribe" option in each such e-mail we send.</p>\n<p>When you use PC*MILER|Web, you must provide information on origins and destinations of the routes that you want to run, and you may choose to change options settings and enter "favorites" to personalize PC*MILER|Web for your use. This allows Trimble MAPS to make the PC*MILER|Web service function for you. This information will be stored by Trimble MAPS for your future use, and may also be used by Trimble MAPS for purposes of testing and quality control.</p>\n<p>When you contact Trimble MAPS to report a data correction or suggestion, Trimble MAPS may use the information you provide to improve future versions of PC*MILER.</p>\n<p>You agree that Trimble MAPS may store and use your private data for the purposes set forth immediately above. Trimble MAPS agrees that it will not voluntarily disclose your personal data to third parties, and that it will take reasonable and customary measures common in the IT industry to secure its systems against involuntary disclosure of your personal data to third parties.</p>\n\n<p>11. <strong><u>Payments.</u></strong></p>\nYou agree that you will pay for PC*MILER|Web and that Trimble MAPS may charge your payment method for your access to PC*MILER|Web and for any additional amounts (including any taxes and late fees, as applicable) that may be accrued by or in connection with your account. YOU ARE RESPONSIBLE FOR THE TIMELY PAYMENT OF ALL FEES AND FOR PROVIDING TRIMBLE MAPS WITH A VALID METHOD OF PAYMENT FOR ALL FEES. Prices for PC*MILER|Web may change from time to time and Trimble MAPS does not provide price protection or refund subject to Section 12(e) of this Agreement.\n\n<p>12. <strong><u>Term and Termination.</u></strong></p>\n<p>a) This Agreement shall commence immediately upon activation of your account for whichever initial term you purchase (monthly, quarterly or annually). This Agreement shall automatically renew for renewal terms of the same length of time, unless and until either party gives at least thirty (30) days advance notice to the other party of its intention not to renew the Agreement as of the expiration of the then-current term.</p>\n<p>b) This Agreement may also be terminated by either party at any time for a material breach of the other party\u2019s obligations under this Agreement, if such breach is not cured within seven (7) days of receipt of written notice of breach by that party.</p>\n<p>c) If you fail for any reason to comply with the timely payment provisions of Section 11 of this Agreement, Trimble MAPS at its sole discretion, without notice to you may (i) terminate this Agreement and/or your account, and you will remain liable for all amounts due under your account up to and including the date of termination; and/or (ii) terminate the license to PC*MILER|Web, and you will remain liable for all amounts due under your account up to and including the date of termination.</p>\n<p>d) You acknowledge and agree that no earlier than thirty (30) days following the termination of this Agreement and/or your account and/or the license to PC*MILER|Web Trimble MAPS may immediately delete all of your related data and files in such account. Trimble MAPS will not be liable to you or to any third party for any termination of your access or deletion of data of any kind arising from such termination.</p>\n<p>e) If you are not satisfied with PC*MILER, you may cancel this Agreement within seven (7) days of the date the initial term commences for a refund of the price paid.</p>\n<p>f) Except as provided in Section 4(c) of this Agreement, Trimble MAPS will not provide any refunds or prorated license fees to you in the event you terminate this Agreement.</p>\n<p>g) Trimble MAPS reserves the right to modify, suspend or discontinue PC*MILER|Web at any time with or without notice to you, and Trimble MAPS will not be liable to any third party should it exercise such rights.</p>\n\n<p>13. <strong><u>Changes.</u></strong></p>\n<p>Trimble MAPS reserves the right at any time to modify this Agreement and to impose new or additional terms or conditions on your use of PC*MILER|Web. Such modification and additional terms or conditions will be effective immediately and incorporated into this Agreement. Your continued use of PC*MILER|Web will be deemed acceptance thereof.</p>\n\n<br />\n<p>Terms are effective as of September 2nd,\xA0 2019.</p>\n\n<br />\n');
  $templateCache.put('/app/alk-cloud/cloud_login_header.html', '<div>\n    <a class="pull-left" href="/">\n        <img src="/img/pcmiler-header-pages.png" />\n    </a>\n    <div class="menu-section pull-right" ng-if="userInfo.isLoggedIn">\n        <button class="btn btn-default" ng-click="logout()">Logout</button>\n    </div>\n    <div class="clearfix"></div>\n</div>\n');
  $templateCache.put('/app/alk-cloud/cloud_page_header.html', '\n<div class="row" ng-controller="pageController">\n    <div class="col-md-12">\n        <a class="pull-left"  href="/">\n            <img src="/img/pcmiler-header-pages.png" />\n        </a>\n\n        <div class="menu-section pull-right" style="margin: 20px;">\n            <a class="btn btn-success" href="/join">Join Account</a>\n            <a class="btn btn-primary" href="/signup">Sign Up</a>\n            <a class="btn btn-default" href="/login">User Login</a>\n        </div>\n    </div>\n</div>\n');
  $templateCache.put('/app/alk-cloud/page_footer.html', '<div id="page-footer" class="row">\n    <div class="col-md-12">\n        <div class="legal-text"><copyright-text type="WebUI"></copyright-text> | <a href="/terms">Terms of Use</a> | <a href="http://support.pcmiler.com" target="_blank">Contact Support</a></div> \n    </div>\n</div>');
  $templateCache.put('/app/avoidFavors/avoidFavors.template.html', '<div class="body">\n  <!--route Modifiers-->\n  <div class="">\n    <div class="form-inline filter-group">\n      <!-- Set Filter -->\n      <div class="input-group">\n        <span class="input-group-btn">\n          <span class="btn btn-sm btn-fake-addon">\n            <i class="ico ico-filter"></i>\n          </span>\n        </span>\n        <input id="filterInput" type="text" class="form-control grouped-input ng-valid" placeholder="Filter" ng-model="filterby.$"\n          ng-model-options="{ debounce: 300 }" ng-change="">\n        <span class="input-group-btn">\n          <button class="btn btn-sm btn-default" type="button" ng-click="filterby.$ = \'\'">\xD7</button>\n        </span>\n      </div>\n    </div>\n\n    <div class="item-list-container route-exceptions-container">\n      <ul class="list-group item-list exception-list">\n        <li class="clearfix" ng-if="vm.sets.length === 0">\n          <i class="ico ico-info-circle ico-info-color"></i>\n          <span class="exception-address">No Sets have been saved.</span>\n        </li>\n        <li class="clearfix" ng-if="(vm.sets.length !== 0) && (vm.filteredSets.length === 0)">\n          <i class="ico ico-info-circle ico-info-color"></i>\n          <span class="exception-address">No Match Results found.</span>\n        </li>\n        <li class="list-group-item" ng-repeat="set in vm.filteredSets=(vm.sets | filter : filterby | limitTo: 50)" alkmaps-input ng-if="set.groups.length > 0">\n          <div class="flex-group">\n            <!-- Switch and name-->\n            <div class="result-info text-ellipsis flex-element">\n              <switch ng-click="vm.updateResult(set);$event.preventDefault(); $event.stopPropagation();" ng-model="set.visible" \n              ng-style="{\'background-color\':(set.visible)?(\'#123ec4\' | hexToRGBa : 0.5):\'\', \'border-color\': (set.visible)?(\'#123ec4\' | hexToRGBa : 0.6):\'\'}"\n              title="{{(set.visible)?\'Cancel set\':\'Apply set\'}}">\n              </switch>\n              <span class="exception-name">\n                  <span class="name"><strong> {{set.Name}} </strong></span>\n              </span>\n            </div>\n            <span class="badge with-actions pull-right" title="{{set.groups.length}} exceptions">{{set.groups.length}}</span>\n          </div>\n        </li>\n      </ul>\n    </div>\n  </div>\n</div>\n');
  $templateCache.put('/app/avoidFavors/avoidFavorsMap.html', '<ul>\n<li class="large-btn btn-group dropdown" uib-dropdown auto-close="outsideClick" is-open="vm.isDropDownShow">\n  <button id="route-modifiers-btn" uib-dropdown-toggle ng-click="vm.getSets()" ng-disabled="!vm.isPremium() || !vm.isAvoidFavorsSetReady()"\n    title="{{(vm.isPremium())?\'Toggle Route Modifiers\':\'Premium Only\'}}" alkmaps-input alk-analytics="[\'Map Style\',\'AvoidFavors\',\'{{(vm.isAvoidFavorsLayerVisible() !== \'\')?\'On\':\'Off\'}}\']">\n    <img class="" src="/img/icons/route-exceptions.svg" />Route<br/>Modifiers\n    <span class="caret"></span>\n  </button>\n  <span ng-hide="vm.isPremium()" tooltip-placement="bottom" uib-tooltip="Premium Only" ng-cloak class="ng-cloak premium-feature-note"\n    style="position: absolute; right: 4px; top: -5px;"></span>\n\n  <ul class="list-group item-list exceptions-dropdown" uib-dropdown-menu role="menu" ng-show="vm.isDropDownShow" ng-if="vm.hasAvoidFavors()">\n  <li class="list-group-item" alkmaps-input style="cursor: default">\n     <div class="flex-group">\n    <button class="btn btn-default btn-xs list-buttons" alkmaps-input ng-show="vm.isDropDownShow" ng-click="vm.showAll(); $event.preventDefault(); $event.stopPropagation();">\n      Show All\n      <!-- <i class="ico ico-eye-open"></i> -->\n    </button>\n    <button class="btn btn-default btn-xs list-buttons"  alkmaps-input ng-show="vm.isDropDownShow" ng-click="vm.hideAll(); $event.preventDefault(); $event.stopPropagation();">\n     Show None\n     <!-- <i class="ico ico-eye-blocked"></i>  -->\n    </button>\n     </div>\n    </li>\n    <li class="list-group-item" ng-repeat="set in vm.sets" alkmaps-input ng-if="set.groups.length > 0">\n      <div class="flex-group">\n        <!-- Switch and name-->\n        <div class="result-info text-ellipsis flex-element" >\n          <switch ng-click="vm.toggleSetOnMap(set);$event.preventDefault(); $event.stopPropagation();" ng-model="set.visible"\n          ng-style="{\'background-color\':(set.visible)?(\'#123ec4\' | hexToRGBa : 0.5):\'\', \'border-color\': (set.visible)?(\'#123ec4\' | hexToRGBa : 0.6):\'\'}"\n            title="{{(set.visible)?\'Hide set\':\'View set\'}}" >\n          </switch>\n          <span ng-click="vm.toggleSetOnMap(set);$event.preventDefault(); $event.stopPropagation();" class="exception-name">\n            <span class="name"><strong> {{set.Name}} </strong></span>\n          </span>\n        </div>\n        <span class="badge with-actions pull-right" title="{{set.groups.length}} Modifiers">{{set.groups.length}}</span>\n          <button tabindex="-1" class="btn btn-xs btn-link" ng-disabled="!set.visible" ng-click="vm.frameAvoidFavorsSet(set); $event.preventDefault(); $event.stopPropagation();"\n            analytics="[\'Route Modifiers\',\'More\',\'Frame\']" title="Frame Set">\n            <i class="ico ico-frame-box"></i>\n          </button>\n      </div>\n    </li>\n\n  </ul>\n  <ul class="list-group item-list exceptions-dropdown" role="menu" ng-show="vm.isDropDownShow" ng-if="!vm.hasAvoidFavors()">\n        <li class="list-group-item" alkmaps-input  ng-show="vm.isDropDownShow">\n          <p> Get access to Route Modifiers by using Content Tools available in the Web Tools menu </p>\n    </li>\n  </ul>\n</li>\n</ul>\n');
  $templateCache.put('/app/applicationSettings/applicationSettings.html', '<div ng-controller="applicationSettingsController as vm">\n  <div class="page-container">\n    <!-- Menu-->\n    <div id="header" class="hidden-print alk-menu-bar slant" ng-include="\'/app/layout/supportNav.template.html\'"></div>\n\n    <div class="container">\n      <!-- Application Settings container -->\n      <form name="applicationSettingForm" class="form-horizontal">\n\n        <div class="panel panel-page forms-content">\n          <div class="left-panel"></div>\n          <!--<div class="panel-header">\n            <div class="panel-heading">\n              <h3><span class="ico ico-gears"> </span> Application Settings </h3>\n            </div>\n          </div>-->\n          <div class="panel-body">\n            <pcm-messages></pcm-messages>\n            <uib-tabset class="tabs-left tab-box">\n              <!-- General Tab -->\n              <uib-tab id="general-tab first-tab" heading="General">\n                <div class="row">\n                  <div class="col-md-push-1 col-md-10 col-sm-push-1 col-sm-10 col-xs-push-1 col-xs-10">\n                    <h4 class="header"><b>General</b></h4>\n                    <br />\n                    <div class="form-group" ng-if="vm.supported">\n                      <div class="col-md-12 col-sm-12 col-xs-12">\n                        <label class="col-md-12 col-sm-12 col-xs-12">Default Region</label>\n                        <select id="default-region-dropdown" name="default-region-dropdown" class="form-control input-sm" required alkmaps-input\n                          disabled>\n                      </select>\n                      </div>\n                    </div>\n                    <div class="form-group">\n                      <div class="col-md-12 col-sm-12 col-xs-12">\n                        <label class="" style ng-class="{ \'premium-feature-heading\': (!userInfo.isPremium()) }"><strong>Add Stop </strong> Search Preference</label>\n                        <div class="radio" ng-repeat= "type in vm.optionsUI.classicSearchView">\n                          <label>\n                            <input type="radio" name="classicSearchView" ng-value="type.value" ng-model="vm.userCfg.classicSearchView" ng-disabled="(!userInfo.isPremium())" alkmaps-input>{{type.display}}\n                            &nbsp;&nbsp;\n                            <input ng-if="!type.value" type="checkbox" ng-model="vm.userCfg.includePOI" ng-disabled="(!userInfo.isPremium() || vm.userCfg.classicSearchView)" alkmaps-input>\n                            <span ng-if="!type.value">Include places (businesses, attractions, etc)</span>\n                          </label>\n                          <!--Change to icomoon-->\n                        </div>\n                      </div>\n                    </div>\n                    <div class="form-group">\n                       <div class="col-md-12 col-sm-12 col-xs-12">\n                        <button class="btn btn-sm btn-default" ng-click="vm.resetToDefaults()" ng-disabled="vm.isAlertShowing">\n                          Reset to System Defaults\n                          </button>\n                      </div>\n                      </div>\n                  </div>\n                </div>\n              </uib-tab>\n              <!-- Geocoding Tab -->\n              <uib-tab id="geocoding-tab" heading="Geocoding" ng-if="vm.supported">\n                <div class="row">\n                  <div class="col-md-push-1 col-md-6 col-sm-push-1 col-sm-6 col-xs-push-1 col-xs-6">\n                    <h4><b>Geocoding</b></h4>\n                    <br />\n                    <div class="form-group">\n                      <label class="col-md-12 col-sm-12">Multiple Geocoding Results</label>\n                      <div class="col-md-12 col-sm-12 col-xs-12">\n                        <input type="checkbox" alkmaps-input /> Provide Pick List\n                      </div>\n                    </div>\n                    <br />\n                    <div class="form-group">\n                      <label class="col-md-12 col-sm-12 col-xs-12">Postal Code Preference</label>\n                      <div class="col-md-12 col-sm-12 col-xs-12">\n                        <select id="postal-code-dropdown" name="postal-code-dropdown" class="form-control input-sm" required alkmaps-input>\n                      </select>\n                      </div>\n                    </div>\n                    <br />\n                    <div class="form-group">\n                      <label class="col-md-12 col-sm-12 col-xs-12">NL Abbreviation</label>\n                      <div class="col-md-12 col-sm-12 col-xs-12">\n                        <select id="NL-Abbreviation-dropdown" name="NL-Abbreviation-dropdown" class="form-control input-sm" required alkmaps-input>\n                      </select>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n              </uib-tab>\n\n              <!-- Report Tab -->\n              <uib-tab id="report-tab" heading="Report" ng-if="vm.supported">\n                <div class="row">\n                  <div class="col-md-push-1 col-md-3 col-sm-push-1 col-sm-3 col-xs-push-1 col-xs-3">\n                    <h4><b>Geocoding</b></h4>\n                    <br />\n                    <div class="form-group">\n                      <label class="col-md-12 col-sm-12 col-xs-12">State/Country Report Order</label>\n                      <div class="col-md-12 col-sm-12 col-xs-12">\n                        <select id="report-order-dropdown" name="report-order-dropdown" class="form-control input-sm" required alkmaps-input>\n                      </select>\n                      </div>\n                    </div>\n                    <br />\n                    <div class="form-group">\n                      <label class="col-md-12 col-sm-12 col-xs-12">Ferry Distances</label>\n                      <div class="col-md-12 col-sm-12 col-xs-12">\n                        <select id="ferry-distance-dropdown" name="ferry-distance-dropdown" class="form-control input-sm" required alkmaps-input>\n                      </select>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n              </uib-tab>\n\n              <!-- Road Speed Tab -->\n              <!--change to input groupd-->\n              <uib-tab id="roadSpeeds-tab" heading="Road Speeds" ng-if="vm.supported">\n                <div class="row">\n                  <div class="col-md-push-1 col-md-6 col-sm-push-1 col-sm-11 col-xs-push-1 col-xs-11">\n                    <h4><b>Road Speeds</b></h4>\n                    <br />\n                    <div class="form-group">\n                      <label class="col-md-12 col-sm-12 col-xs-12">Vehicle Type</label>\n                      <div class="col-md-6 col-sm-6 col-xs-6">\n                        <select id="vehicle-type-dropdown" name="vehicle-type-dropdown" class="form-control input-sm" required alkmaps-input>\n                        </select>\n                      </div>\n                    </div>\n                    <div class="form-group">\n                      <label class="col-md-5 col-sm-5 col-xs-5">Interstate Highways:</label>\n                      <div class="col-md-5 col-sm-5 col-xs-5 input-group">\n                        <input class="form-control input-sm" id="interstate-highways" name="interstate-highways" type="text" alkmaps-input />\n                        <span class="input-group-addon">  mph </span>\n                      </div>\n                    </div>\n                    <div class="form-group">\n                      <label class="col-md-5 col-sm-5 col-xs-5">Major Highways:</label>\n                      <div class="col-md-5 col-sm-5 col-xs-5">\n                        <input class="form-control input-sm" id="major-highways" name="major-highways" type="text" alkmaps-input />\n                      </div>\n                      <div class="col-md-2 col-sm-2 col-xs-2">\n                        <span>  mph </span>\n                      </div>\n                    </div>\n                    <div class="form-group">\n                      <label class="col-md-5 col-sm-5 col-xs-5">Primary Highways:</label>\n                      <div class="col-md-5 col-sm-5 col-xs-5">\n                        <input class="form-control input-sm" id="primary-highways" name="primary-highways" type="text" alkmaps-input />\n                      </div>\n                      <div class="col-md-2 col-sm-2 col-xs-2">\n                        <span>  mph </span>\n                      </div>\n                    </div>\n                    <div class="form-group">\n                      <label class="col-md-5 col-sm-5 col-xs-5">Secondary Highways:</label>\n                      <div class="col-md-5 col-sm-5 col-xs-5">\n                        <input class="form-control input-sm" id="secondary-highways" name="secondary-highways" type="text" alkmaps-input />\n                      </div>\n                      <div class="col-md-2 col-sm-2 col-xs-2">\n                        <span>  mph </span>\n                      </div>\n                    </div>\n                    <div class="form-group">\n                      <label class="col-md-5 col-sm-5 col-xs-5">Local Roads:</label>\n                      <div class="col-md-5 col-sm-5 col-xs-5">\n                        <input class="form-control input-sm" id="local-roads" name="local-roads" type="text" alkmaps-input />\n                      </div>\n                      <div class="col-md-2 col-sm-2 col-xs-2">\n                        <span>  mph </span>\n                      </div>\n                    </div>\n                    <div class="form-group">\n                      <div class="col-md-push-8 col-md-4 col-sm-push-8 col-sm-4 col-xs-push-8 col-xs-4">\n                        <button type="button" class="btn btn-default">Reset to Default</button>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n              </uib-tab>\n\n              <!-- Route Cost Tab -->\n              <uib-tab id="routeCosts-tab" heading="Route Costs">\n                <!--<span class="has-error" ng-show="((applicationSettingForm.fuelCostUnit.$invalid && !applicationSettingForm.fuelCostUnit.$pristine)\n                || (applicationSettingForm.greenhouseGases.$invalid && !applicationSettingForm.greenhouseGases.$pristine)\n                || (applicationSettingForm.mpgLoaded.$invalid && !applicationSettingForm.mpgLoaded.$pristine)\n                || (applicationSettingForm.mpgEmpty.$invalid && !applicationSettingForm.mpgEmpty.$pristine)\n                || (applicationSettingForm.otherLoaded.$invalid && !applicationSettingForm.otherLoaded.$pristine)\n                || (applicationSettingForm.otherEmpty.$invalid && !applicationSettingForm.otherEmpty.$pristine)\n                || (applicationSettingForm.laborLoaded.$invalid && !applicationSettingForm.laborLoaded.$pristine)\n                || (applicationSettingForm.laborEmpty.$invalid && !applicationSettingForm.laborEmpty.$pristine))">\n                <i class="glyphicon glyphicon-exclamation-sign"></i>\n              </span>-->\n                <!-- Route cost is only available for current dataVersion-->\n                <div class="row" ng-hide="userInfo.isPremium()">\n                  <div class="col-md-push-1 col-md-11 col-sm-push-1 col-sm-11 col-xs-push-1 col-xs-11">\n                    <h4 class="header"><b>Route Costs</b></h4>\n                    <div class="form-group">\n                      <label>\n                        <i class="glyphicon glyphicon-certificate" style="color: #E29A00;"></i> Available to Premium only\n                      </label>\n                    </div>\n                  </div>\n                </div>\n\n                <div class="row" ng-show="userInfo.isPremium()">\n                  <div class="col-md-push-1 col-md-6 col-sm-push-1 col-sm-11 col-xs-push-1 col-xs-11">\n                    <h4 class="header"><b>Route Costs</b></h4>\n                    <br />\n                    <div class="form-group" ng-hide="vm.appSettingCopy.dataVersion == \'current\' || vm.appSettingCopy.dataVersion == \'PCM_EU\'">\n                        <label>\n                            These values only apply to current data version. All other versions will use the system default costs. <br/>\n                            To change Data Version, please go to main page => Default Options => Reporting Preference and update Report Data Version.\n                        </label>\n                    </div>\n                    <div ng-show="vm.appSettingCopy.dataVersion == \'current\' || vm.appSettingCopy.dataVersion == \'PCM_EU\'">\n                      <div class="form-group" ng-class="{ \'has-error\': (applicationSettingForm.costPerFuelUnit.$invalid && !applicationSettingForm.costPerFuelUnit.$pristine)}">\n                        <label for="costPerFuelUnit" class="col-md-4 col-sm-4 col-xs-4">Fuel Cost Per {{(vm.appSettingCopy.fuelUnits === 0)? "Gallon" : "Liter"}}</label>\n                        <div class="col-md-3 col-sm-3 col-xs-3">\n                          <input class="form-control input-sm" id="costPerFuelUnit" name="costPerFuelUnit" type="text" ng-model="vm.appSettingCopy.costPerFuelUnit"\n                            required pcm-number alkmaps-input />\n                          <div class="glyphicon glyphicon-exclamation-sign error-glyph error-icon" ng-show="(applicationSettingForm.costPerFuelUnit.$invalid && !applicationSettingForm.costPerFuelUnit.$pristine)">\n                            <div class="error-tooltip bg-danger">\n                              <p ng-show="applicationSettingForm.costPerFuelUnit.$error.required && !applicationSettingForm.costPerFuelUnit.$pristine"\n                                class="help-block">Cost Per {{(vm.appSettingCopy.fuelUnits === 0)? "Gallon" : "Liter"}} is required.</p>\n                              <p ng-show="applicationSettingForm.costPerFuelUnit.$error.pcmNumber && !applicationSettingForm.costPerFuelUnit.$pristine"\n                                class="help-block">Cost Per {{(vm.appSettingCopy.fuelUnits === 0)? "Gallon" : "Liter"}} must be a number.</p>\n                            </div>\n                          </div>\n                        </div>\n                      </div>\n\n                      <!-- mpgLoaded & mpgEmpty-->\n                      <!-- for EU customers with default Metric units selected, we would like to use this liters per 100 km field -->\n                      <div class="form-group" ng-if="vm.region == \'EU\' && vm.appSettingCopy.distanceUnits === 1 && vm.appSettingCopy.fuelUnits === 1">\n                        <label for="mpgLoaded" class="col-md-4 col-sm-4 col-xs-4"> Liters Per 100 kms</label>\n                        <div class="col-md-3 col-sm-3 col-xs-3" ng-class="{ \'has-error\': (applicationSettingForm.mpgLoaded.$invalid && !applicationSettingForm.mpgLoaded.$pristine)}">\n                          <input class="form-control input-sm" id="mpgLoaded" name="mpgLoaded" type="text" ng-model="vm.appSettingCopy.EUFuelEconLoad"\n                            required pcm-number alkmaps-input/>\n                          <div class="glyphicon glyphicon-exclamation-sign error-glyph-small-left error-icon"  ng-show="(applicationSettingForm.mpgLoaded.$invalid && !applicationSettingForm.mpgLoaded.$pristine)">\n                            <div class="error-tooltip bg-danger">\n                              <p ng-show="applicationSettingForm.mpgLoaded.$error.required && !applicationSettingForm.mpgLoaded.$pristine" class="help-block"> Liters Per 100 kms Loaded is required.</p>\n                              <p ng-show="applicationSettingForm.mpgLoaded.$error.pcmNumber && !applicationSettingForm.mpgLoaded.$pristine" class="help-block"> Liters Per 100 kms Loaded must be a number.</p>\n                            </div>\n                          </div>\n                        </div>\n                      </div>\n                      <!-- for EU customers with default Metric units selected, we would like to use the above liters per 100 km field and this to be hidden -->\n                      <div class="form-group" ng-hide="vm.region == \'EU\' && vm.appSettingCopy.distanceUnits === 1 && vm.appSettingCopy.fuelUnits === 1">\n                        <label for="mpgLoaded" class="col-md-4 col-sm-4 col-xs-4">{{(vm.appSettingCopy.distanceUnits === 0)? "Miles" : "Kilometers"}} Per {{(vm.appSettingCopy.fuelUnits === 0)? "Gallon" : "Liter"}}</label>\n                        <div class="col-md-3 col-sm-3 col-xs-3" ng-class="{ \'has-error\': (applicationSettingForm.mpgLoaded.$invalid && !applicationSettingForm.mpgLoaded.$pristine)}">\n                          <input class="form-control input-sm" id="mpgLoaded" name="mpgLoaded" type="text" ng-model="vm.appSettingCopy.fuelEconLoad"\n                            required pcm-number alkmaps-input/>\n                          <div class="glyphicon glyphicon-exclamation-sign error-glyph-small-left error-icon"  ng-show="(applicationSettingForm.mpgLoaded.$invalid && !applicationSettingForm.mpgLoaded.$pristine)">\n                            <div class="error-tooltip bg-danger">\n                              <p ng-show="applicationSettingForm.mpgLoaded.$error.required && !applicationSettingForm.mpgLoaded.$pristine" class="help-block">{{(vm.appSettingCopy.distanceUnits === 0)? "Miles" : "Kilometers"}} Per {{(vm.appSettingCopy.fuelUnits\n                                === 0)? "Gallon" : "Liter"}} Loaded is required.</p>\n                              <p ng-show="applicationSettingForm.mpgLoaded.$error.pcmNumber && !applicationSettingForm.mpgLoaded.$pristine" class="help-block">{{(vm.appSettingCopy.distanceUnits === 0)? "Miles" : "Kilometers"}} Per {{(vm.appSettingCopy.fuelUnits\n                                === 0)? "Gallon" : "Liter"}} Loaded must be a number.</p>\n                            </div>\n                          </div>\n                        </div>\n\n                        <!--<div class="col-md-3 col-sm-3 col-xs-3" ng-class="{ \'has-error\': (applicationSettingForm.mpgEmpty.$invalid && !applicationSettingForm.mpgEmpty.$pristine)}">\n                          <input class="form-control input-sm" id="mpgEmpty" name="mpgEmpty" type="text" ng-model="vm.appSettingCopy.fuelEconEmpty"\n                            required pcm-number alkmaps-input/>\n                          <div class="glyphicon glyphicon-exclamation-sign error-glyph-small-left error-icon" ng-show="(applicationSettingForm.mpgEmpty.$invalid && !applicationSettingForm.mpgEmpty.$pristine)">\n                            <div class="error-tooltip bg-danger">\n                              <p ng-show="applicationSettingForm.mpgEmpty.$error.required && !applicationSettingForm.mpgEmpty.$pristine" class="help-block">{{(vm.appSettingCopy.distanceUnits === 0)? "Miles" : "Kilometers"}} Per {{(vm.appSettingCopy.fuelUnits\n                                === 0)? "Gallon" : "Liter"}} Empty is required.</p>\n                              <p ng-show="applicationSettingForm.mpgEmpty.$error.pcmNumber && !applicationSettingForm.mpgEmpty.$pristine" class="help-block">{{(vm.appSettingCopy.distanceUnits === 0)? "Miles" : "Kilometers"}} Per {{(vm.appSettingCopy.fuelUnits\n                                === 0)? "Gallon" : "Liter"}} Empty must be a number.</p>\n                            </div>\n                          </div>\n                        </div>-->\n                      </div>\n\n                      <!-- fuelCostLoaded & fuelCostEmpty-->\n                      <div class="form-group">\n                        <label for="fuelCostLoaded" class="col-md-4 col-sm-4 col-xs-4">Fuel Cost Per {{(vm.appSettingCopy.distanceUnits === 0)? "Mile" : "Kilometer"}}</label>\n                        <div class="col-md-3 col-sm-3 col-xs-3" ng-class="{ \'has-error\': (applicationSettingForm.fuelCostLoaded.$invalid && !applicationSettingForm.fuelCostLoaded.$pristine)}">\n                          <input class="form-control input-sm" id="fuelCostLoaded" name="fuelCostLoaded" type="text" value="{{(vm.appSettingCopy.costPerFuelUnit / vm.appSettingCopy.fuelEconLoad) | number:2}}"\n                            disabled alkmaps-input/>\n                        </div>\n                        <!--<div class="col-md-3 col-sm-3 col-xs-3" ng-class="{ \'has-error\': (applicationSettingForm.fuelCostEmpty.$invalid && !applicationSettingForm.fuelCostEmpty.$pristine)}">\n                          <input class="form-control input-sm" id="fuelCostEmpty" name="fuelCostEmpty" type="text" value="{{(vm.appSettingCopy.costPerFuelUnit / vm.appSettingCopy.fuelEconEmpty) | number:2}}"\n                            disabled alkmaps-input/>\n                        </div>-->\n                      </div>\n\n                      <!-- otherLoaded & otherEmpty-->\n                      <div class="form-group">\n                        <label for="otherLoaded" class="col-md-4 col-sm-4 col-xs-4">Other Cost Per {{(vm.appSettingCopy.distanceUnits === 0)? "Mile" : "Kilometer"}}</label>\n                        <div class="col-md-3 col-sm-3 col-xs-3" ng-class="{ \'has-error\': (applicationSettingForm.otherLoaded.$invalid && !applicationSettingForm.otherLoaded.$pristine)}">\n                          <input class="form-control input-sm" id="otherLoaded" name="otherLoaded" type="text" ng-model="vm.appSettingCopy.costMaintLoad"\n                            required pcm-number alkmaps-input/>\n                          <div class="glyphicon glyphicon-exclamation-sign error-glyph-small-left error-icon" ng-show="(applicationSettingForm.otherLoaded.$invalid && !applicationSettingForm.otherLoaded.$pristine)">\n                            <div class="error-tooltip bg-danger">\n                              <p ng-show="applicationSettingForm.otherLoaded.$error.required && !applicationSettingForm.otherLoaded.$pristine" class="help-block">Other Cost Per {{(vm.appSettingCopy.distanceUnits === 0)? "Mile" : "Kilometer"}} Loaded is required.</p>\n                              <p ng-show="applicationSettingForm.otherLoaded.$error.pcmNumber && !applicationSettingForm.otherLoaded.$pristine" class="help-block">Other Cost Per {{(vm.appSettingCopy.distanceUnits === 0)? "Mile" : "Kilometer"}} Loaded must\n                                be a number.</p>\n                            </div>\n                          </div>\n                        </div>\n                        <!--<div class="col-md-3 col-sm-3 col-xs-3" ng-class="{ \'has-error\': (applicationSettingForm.otherEmpty.$invalid && !applicationSettingForm.otherEmpty.$pristine)}">\n                          <input class="form-control input-sm" id="otherEmpty" name="otherEmpty" type="text" ng-model="vm.appSettingCopy.costMaintEmpty"\n                            required pcm-number alkmaps-input/>\n                          <div class="glyphicon glyphicon-exclamation-sign error-glyph-small-left error-icon"  ng-show="(applicationSettingForm.otherEmpty.$invalid && !applicationSettingForm.otherEmpty.$pristine)">\n                            <div class="error-tooltip bg-danger">\n                              <p ng-show="applicationSettingForm.otherLoaded.$error.required && !applicationSettingForm.otherLoaded.$pristine" class="help-block">Other Cost Per {{(vm.appSettingCopy.distanceUnits === 0)? "Mile" : "Kilometer"}} Empty is required.</p>\n                              <p ng-show="applicationSettingForm.otherLoaded.$error.pcmNumber && !applicationSettingForm.otherLoaded.$pristine" class="help-block">Other Cost Per {{(vm.appSettingCopy.distanceUnits === 0)? "Mile" : "Kilometer"}} Empty must be\n                                a number.</p>\n                            </div>\n                          </div>\n                        </div>-->\n                      </div>\n\n                      <!-- laborLoaded & laborEmpty-->\n                      <div class="form-group row">\n                        <div class="col-md-4 col-sm-4 col-xs-4">\n                          <label for="laborLoaded">Labor Cost Per Hour</label> </div>\n                        <div class="col-md-3 col-sm-3 col-xs-3" ng-class="{ \'has-error\': (applicationSettingForm.laborLoaded.$invalid && !applicationSettingForm.laborLoaded.$pristine)}">\n                          <input class="form-control input-sm" id="laborLoaded" name="laborLoaded" type="text" ng-model="vm.appSettingCopy.costTimeLoad"\n                            required pcm-number alkmaps-input/>\n                          <div class="glyphicon glyphicon-exclamation-sign error-glyph-small-left error-icon"  ng-show="(applicationSettingForm.laborLoaded.$invalid && !applicationSettingForm.laborLoaded.$pristine)">\n                            <div class="error-tooltip bg-danger">\n                              <p ng-show="applicationSettingForm.laborLoaded.$error.required && !applicationSettingForm.laborLoaded.$pristine" class="help-block">Labor Cost Per Hour Loaded is required.</p>\n                              <p ng-show="applicationSettingForm.laborLoaded.$error.pcmNumber && !applicationSettingForm.laborLoaded.$pristine" class="help-block">Labor Cost Per Hour Loaded must be a number.</p>\n                            </div>\n                          </div>\n                        </div>\n                        <!--<div class="col-md-3 col-sm-3 col-xs-3" ng-class="{ \'has-error\': (applicationSettingForm.laborEmpty.$invalid && !applicationSettingForm.laborEmpty.$pristine)}">\n                          <input class="form-control input-sm" id="laborEmpty" name="laborEmpty" type="text" ng-model="vm.appSettingCopy.costTimeEmpty"\n                            required pcm-number alkmaps-input/>\n                          <div class="glyphicon glyphicon-exclamation-sign error-glyph-small-left error-icon" ng-show="(applicationSettingForm.laborEmpty.$invalid && !applicationSettingForm.laborEmpty.$pristine)">\n                            <div class="error-tooltip bg-danger">\n                              <p ng-show="applicationSettingForm.laborEmpty.$error.required && !applicationSettingForm.laborEmpty.$pristine" class="help-block">Labor Cost Per Hour Empty is required.</p>\n                              <p ng-show="applicationSettingForm.laborEmpty.$error.pcmNumber && !applicationSettingForm.laborEmpty.$pristine" class="help-block">Labor Cost Per Hour Empty must be a number.</p>\n                            </div>\n                          </div>\n                        </div>-->\n                      </div>\n                      <div class="form-group row" ng-class="{ \'has-error\': (applicationSettingForm.greenhouseGases.$invalid && !applicationSettingForm.greenhouseGases.$pristine)}">\n                        <div class="col-md-4 col-sm-4 col-xs-4">\n                          <label for="greenhouseGases">Greenhouse Gases</label> </div>\n                        <div class="col-md-5 col-sm-5 col-xs-5">\n                          <div class="input-group col-md-11 col-xs-11 col-sm-11">\n                            <input id="greenhouseGases" name="greenhouseGases" class="form-control input-sm" ng-model="vm.appSettingCopy.costGHG" type="text"\n                              required pcm-number alkmaps-input /> <span class="input-group-addon">  {{(vm.appSettingCopy.distanceUnits === 0)? "lbs" : "kgs"}}/{{(vm.appSettingCopy.fuelUnits === 0)? "gallon" : "liter"}} </span>\n                          </div>\n                          <div class="glyphicon glyphicon-exclamation-sign error-glyph error-icon" ng-show="(applicationSettingForm.greenhouseGases.$invalid && !applicationSettingForm.greenhouseGases.$pristine)">\n                            <div class="error-tooltip bg-danger">\n                              <p ng-show="applicationSettingForm.greenhouseGases.$error.required && !applicationSettingForm.greenhouseGases.$pristine"\n                                class="help-block">Greenhouse Gases is required.</p>\n                              <p ng-show="applicationSettingForm.greenhouseGases.$error.pcmNumber && !applicationSettingForm.greenhouseGases.$pristine"\n                                class="help-block">Greenhouse Gases must be a number.</p>\n                            </div>\n                          </div>\n                        </div>\n                      </div>\n                      <div class="form-group row">\n                        <div class="col-md-4 col-sm-4 col-xs-4">\n                          <label ng-if="vm.region !== \'EU\'"> (Cost in {{vm.appSettingCopy.tollCurrency === 0 ? "US Dollars" : "Canadian Dollars"}}) </label>\n                          <label ng-if="vm.region === \'EU\'"> (Cost in  {{vm.tollCurrencyStr()}}) </label>\n                        </div>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n              </uib-tab>\n\n              <!-- Tolls Tab -->\n              <uib-tab id="tolls-tab" heading="Tolls" ng-if="true">\n\n                <div class="row">\n                  <div class="col-md-push-1 col-md-8 col-sm-push-1 col-sm-11 col-xs-push-1 col-xs-11">\n                    <h4 class="header"><b>Tolls</b></h4>\n                    </br>\n                    <div class="form-group">\n                      <div class="col-md-12 col-sm-12 col-xs-12">\n                        <label>\n                            <input type="checkbox" ng-model="vm.appSettingCopy.inclTollData" ng-disabled="(!userInfo.isPremium())" alkmaps-input="" class="ng-pristine ng-untouched ng-valid ng-isolate-scope ng-empty"> Show Toll Costs\n                        </label>\n                      </div>\n                      <div class="col-md-12 col-sm-12 col-xs-12">\n                        <label>\n                            <input type="checkbox" ng-model="vm.useTollDiscounts" ng-disabled="((!vm.appSettingCopy.inclTollData) || (!userInfo.isPremium()))" alkmaps-input="" class="ng-pristine ng-untouched ng-valid ng-isolate-scope ng-empty" disabled="disabled"> Use Toll Discount Programs\n                        </label>\n                      </div>\n                    </div>\n\n                  </div>\n                  <!-- NA Region -->\n                  <div class="col-md-push-1 col-md-10 col-sm-push-1 col-sm-11 col-xs-push-1 col-xs-11" ng-if="vm.region !== \'EU\'">\n\n                    <div class="form-group" ng-if="vm.supported">\n                      <span class="col-md-12 col-sm-12 col-xs-12">\n                        <h6 class="header"><b>\n                        State/Country Distance Report </b> </h6>\n                        </span>\n                      <div class="col-md-12 col-sm-12 col-xs-12">\n                        <input type="checkbox" alkmaps-input /> Show Cash and Discount Program Breakdown\n                      </div>\n                    </div>\n                  </div>\n                  <!-- End of NA Region -->\n\n                  <!-- EU Region -->\n\n                  <!-- End of EU Region -->\n                </div>\n              </uib-tab>\n\n              <!-- Units Tab -->\n              <uib-tab id="units-tab" heading="Currency & Units" ng-if="true">\n                <div class="row">\n                  <div class="col-md-push-1 col-md-8 col-sm-push-1 col-sm-11 col-xs-push-1 col-xs-11">\n                    <h4 class="header"><b>Currency & Units</b></h4>\n                    <br />\n                    <div class="form-group">\n                      <div class="col-md-12 col-sm-12 col-xs-12" ng-if="vm.region !== \'EU\'">\n                        <label>Exchange Rate</label> </div>\n                      <div class="" ng-if="vm.region !== \'EU\'">\n                        <div class="col-md-1 col-sm-1 col-xs-1" ng-class="{ \'has-error\': (applicationSettingForm.exchangeRate.$invalid && !applicationSettingForm.exchangeRate.$pristine)}">\n                          <input class="form-control input-sm base-unit" type="text" ng-disabled="1" readonly value="1" />\n                        </div>\n                        <div class="col-md-3 col-sm-3 col-xs-3">\n                          <select id="tollCurrency" name="tollCurrency" class="form-control input-sm" ng-model="vm.appSettingCopy.tollCurrency" ng-change="vm.tollCurrencyChanged()"\n                            ng-disabled="(!userInfo.isPremium())" ng-options="type.value as type.display for type in vm.optionsUI.tollCurrency"\n                            required alkmaps-input></select>\n                        </div>\n                        <div class="col-md-2 col-sm-2 col-xs-2" ng-class="{ \'has-error\': (applicationSettingForm.exchangeRate.$invalid && !applicationSettingForm.exchangeRate.$pristine)}">\n                          <input id="exchangeRate" name="exchangeRate" class="form-control input-sm base-unit" type="text" ng-disabled="(!userInfo.isPremium())"\n                            ng-model="vm.appSettingCopy.exchangeRate" required pcm-number alkmaps-input />\n                          <div class="glyphicon glyphicon-exclamation-sign error-glyph error-icon" ng-show="(applicationSettingForm.exchangeRate.$invalid && !applicationSettingForm.exchangeRate.$pristine)">\n                            <div class="error-tooltip bg-danger">\n                              <p ng-show="applicationSettingForm.exchangeRate.$error.required && !applicationSettingForm.exchangeRate.$pristine" class="help-block">exchangeRate is required.</p>\n                              <p ng-show="applicationSettingForm.exchangeRate.$error.pcmNumber && !applicationSettingForm.exchangeRate.$pristine" class="help-block">exchangeRate must be a number.</p>\n                            </div>\n                          </div>\n                        </div>\n                        <div class="col-md-3 col-sm-3 col-xs-3">\n                          <select id="tollCurrency" name="tollCurrency" class="form-control input-sm" ng-disabled="(!userInfo.isPremium())" readonly=a\n                            lkmaps-input>\n                         <option> {{vm.appSettingCopy.tollCurrency === 1 ? "US Dollars" : "Canadian Dollars"}}</option>\n                         </select>\n                        </div>\n                      </div>\n                      <div class="  col-md-6  col-sm-11   col-xs-11" ng-if="vm.region === \'EU\'">\n                        <div class="form-group">\n                          <label for="tollCurrency" class="col-md-5 col-sm-5 col-xs-5" ng-class="{ \'premium-feature-heading\': (!userInfo.isPremium()) }">Currency</label>\n                        </div>\n                        <div class="form-group">\n                          <div class="col-md-6 col-sm-6 col-xs-6">\n                            <select id="tollCurrency" name="tollCurrency" class="form-control input-sm" ng-model="vm.appSettingCopy.tollCurrency" ng-disabled="(!userInfo.isPremium())"\n                              ng-options="type.value as type.display for type in vm.optionsUI.tollCurrencyEU" required alkmaps-input></select>\n                          </div>\n                        </div>\n                      </div>\n                    </div><div class="form-group">\n                      <div class="col-md-12 col-sm-12 col-xs-12">\n                        <label for="trkUnits">Length, Distance and Weight Units</label> </div>\n                      <div class="col-md-6 col-sm-6 col-xs-6">\n                        <div class="input-group">\n                          <select ng-if="vm.region===\'NA\'" id="trkUnits" name="trkUnits" class=" input-sm" ng-model="vm.appSettingCopy.trkUnits" ng-change="vm.changeUnits();vm.afterUnitChange()"\n                            ng-options="type.value as type.displayNA for type in vm.optionsUI.trkUnits" required alkmaps-input></select>\n                          <select ng-if="vm.region===\'EU\'" id="trkUnits" name="trkUnits" class=" input-sm" ng-model="vm.appSettingCopy.trkUnits" ng-change="vm.changeUnits();vm.afterUnitChange()"\n                            ng-options="type.value as type.displayEU for type in vm.optionsUI.trkUnits" required alkmaps-input></select>\n                          <span class="input-group-addon">{{(vm.appSettingCopy.trkUnits === 0)? "mi, ft, in, lbs" : "km, m, kg"}}</span>\n                        </div>\n                      </div>\n                    </div>\n                    <div class="form-group" ng-if="vm.supported">\n                      <label class="col-md-12 col-sm-12 col-xs-11">Distance Precision</label>\n                      <div class="col-md-6 col-sm-6 col-xs-6">\n                        <select id="distance-precision" name="distance-precision" class="form-control input-sm" required alkmaps-input></select>\n                      </div>\n                      <span class="col-md-3 col-sm-3 col-xs-3">ex. 852.1</span>\n                    </div>\n                    <div class="form-group" ng-if="vm.supported">\n                      <label class="col-md-12 col-sm-12 col-xs-12">Time Format</label>\n                      <div class="col-md-6 col-sm-6 col-xs-6">\n                        <select id="time-format" name="time-format" class="form-control input-sm" required alkmaps-input></select>\n                      </div>\n                      <span class="col-md-3 col-sm-3 col-xs-3">ex. 9:21PM</span>\n                    </div>\n                    <div class="form-group" ng-if="vm.supported">\n                      <label class="col-md-12 col-sm-12 col-xs-12">Time Zone</label>\n                      <div class="col-md-6 col-sm-6 col-xs-6">\n                        <select id="time-zone" name="time-zone" class="form-control input-sm" required alkmaps-input></select>\n                      </div>\n                      <span class="col-md-6 col-sm-6 col-xs-6">Reported ETA/ETD will comform to the time zone where each stop or toll plaza is located</span>\n                    </div>\n                    <div class="form-group">\n                      <label for="fuelUnits" class="col-md-12 col-sm-12 col-xs-12">Fuel in</label>\n                      <div class="col-md-5 col-sm-5 col-xs-5">\n                        <select id="fuelUnits" name="fuelUnits" class="form-control input-sm" ng-model="vm.appSettingCopy.fuelUnits" ng-change="vm.afterUnitChange()"\n                          ng-options="type.value as type.display for type in vm.optionsUI.fuelUnits" required alkmaps-input></select>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n              </uib-tab>\n\n              <!-- Weather Tab -->\n              <uib-tab id="weather-tab" heading="Weather" ng-if="vm.supported">\n                <div class="row">\n                  <div class="col-md-push-1 col-md-6 col-sm-push-1 col-sm-11 col-md-6 col-xs-push-1 col-xs-11">\n                    <h4><b>Weather</b></h4>\n                    <br />\n                    <div class="form-group">\n                      <span>Weather function is not yet implemented in ALKMaps</span>\n                    </div>\n                  </div>\n                </div>\n              </uib-tab>\n            </uib-tabset>\n          </div>\n          <div class="action-footer">\n            <div class="alert alert-success ng-hide ng-cloak fadeInOut right" role="alert" ng-cloak ng-show="vm.isAlertShowing">\n              {{vm.alertMessage}}\n            </div>\n            <div>\n              <button class="btn btn-success pull-right" ng-click="vm.ok()" ng-disabled="applicationSettingForm.$invalid || vm.isAlertShowing"> Save\n                <span class="has-error" ng-if="applicationSettingForm.$invalid">\n                    &nbsp;\n                    <i class="glyphicon glyphicon-exclamation-sign"></i>\n                </span>\n              </button>\n            </div>\n            <div>\n              <button ng-click="vm.cancel()" class="btn btn-default pull-right" ng-disabled="vm.isAlertShowing"> Cancel\n              </button>\n            </div>\n          </div>\n        </div>\n      </form>\n\n    </div>\n\n    <map-footer app="PCMWebUI"></map-footer>\n  </div>\n</div>\n');
  $templateCache.put('/app/layout/appMenu.template.html', '<div class="nav-section general">\n  <ul>\n    <li class="large-btn">\n      <button id="new-route-btn" ng-click="newRoute()" alkmaps-input alk-analytics="[\'Routing\',\'New Route\']" ng-disabled="routeCount() >= 8"\n        title="{{(routeCount() >= 8)?\'You have the maximum of 8 routes open\':\'New Route\'}}">\n          <img src="/img/icons/New_Route.png" />\n          New<br />Route\n      </button>\n    </li>\n  </ul>\n  <ul>\n    <li class="small-btn">\n      <button ng-if="userInfo.account != \'Trimble MAPS Marketing Offers\'" ng-click="openRoute()" alkmaps-input alk-analytics="[\'Routing\',\'Load Route\']" ng-disabled="routeCount() >= 8" title="{{(routeCount() >= 8)?\'You have the maximum of 8 routes open\':\'Open Saved Route\'}}">\n          <img src="/img/icons/Open_Route.png" />Open Saved Route\n      </button>\n    </li>\n    <li class="small-btn">\n      <button ng-disabled="!hasRoutes()" ng-click="deleteAllRoutes()" alkmaps-input alk-analytics="[\'Routing\',\'Delete All Routes\']">\n          <img src="/img/icons/Close_Route.png" />Delete All Routes\n      </button>\n    </li>\n    <li class="small-btn">\n      <button ng-click="defaultOptions()" alkmaps-input alk-analytics="[\'Routing\',\'Default Options\']">\n          <img src="/img/icons/Route_Defaults.png" />Default Options\n      </button>\n    </li>\n  </ul>\n</div>\n\n<div class="nav-section applicationSetting">\n  <ul>\n    <li class="large-btn">\n      <button id="application-setting-btn" ng-click="goToApplicationSettings()" alkmaps-input alk-analytics="[\'Routing\',\'Application Setting Panel\']">\n          <img src="/img/icons/Route_Options.png" />\n          Application<br />Settings\n      </button>\n    </li>\n  </ul>\n</div>\n\n<div class="nav-section">\n  <ul>\n    <li class="large-btn btn-group dropdown" uib-dropdown is-open="isOpen">\n      <button class="dropdown-toggle" uib-dropdown-toggle ng-disabled="!userInfo.isPremium()" title="{{(userInfo.isPremium())?\'\':\'Premium Only\'}}">\n          <img src="/img/icons/map_layers.svg" class="layers-icon"/>\n          Map Layers <br />\n          <span class="caret"></span>\n      </button>\n      <span ng-hide="userInfo.isPremium()" tooltip-placement="bottom" uib-tooltip="Premium Only" ng-cloak class="ng-cloak premium-feature-note"\n        style="position: absolute; right: 4px; top: -2px;"></span>\n      <ul class="dropdown-menu" role="menu">\n        <li id="traf-style-btn" ng-class="isTrafficVisible()" ng-click="toggleTrafficVisibility()" alkmaps-input alkmaps-input alk-analytics="[\'Map Style\',\'Traffic\',\'{{(isTrafficVisible() !== \'\')?\'On\':\'Off\'}}\']">\n          <a href="#"><span ng-class="(isTrafficVisible())?\'ico-checkbox-checked\':\'ico-checkbox-unchecked\'" class="ico"></span> Traffic Layer</a>\n        </li>\n        <li id="weather-radar-btn" ng-class="isWeatherRadarVisible()" ng-click="toggleWeatherRadarVisibility()" alkmaps-input alk-analytics="[\'Map Style\',\'Toggle Weather Rader Panel\']">\n          <a href="#"><span ng-class="(isWeatherRadarVisible())?\'ico-checkbox-checked\':\'ico-checkbox-unchecked\'" class="ico"></span> Radar Layer</a>\n        </li>\n        <li id="weather-cloud-btn" ng-click="toggleWeatherCloudVisibility()" ng-class="isWeatherCloudVisible()" alkmaps-input alk-analytics="[\'Map Style\',\'Toggle Weather Cloud Panel\']">\n          <a href="#"><span ng-class="(isWeatherCloudVisible())?\'ico-checkbox-checked\':\'ico-checkbox-unchecked\'" class="ico"></span> Cloud Layer</a>\n        </li>\n        <li id="road-surface-btn" ng-class="isRoadSurfaceVisible()" ng-click="toggleRoadSurfaceVisibility()" alkmaps-input ng-if="userInfo.region==\'NA\'"\n          alk-analytics="[\'Map Style\',\'Toggle Road Surface Panel\']">\n          <a href="#"><span ng-class="(isRoadSurfaceVisible())?\'ico-checkbox-checked\':\'ico-checkbox-unchecked\'" class="ico"></span> Road Conditions Layer</a>\n        </li>\n        <li id="weather-alerts-btn" ng-click="toggleWeatherAlertsVisibility()" ng-class="isWeatherAlertsVisible()" alkmaps-input\n          ng-if="userInfo.region==\'NA\'" alk-analytics="[\'Map Style\',\'Toggle Weather Alerts Panel\']">\n          <a href="#"><span ng-class="(isWeatherAlertsVisible())?\'ico-checkbox-checked\':\'ico-checkbox-unchecked\'" class="ico"></span> Weather Alerts</a>\n        </li>\n        <li id="custom-places-btn" ng-class="customPlacesStyle()"  ng-click="toggleCustomPlacesVisibility()" alkmaps-input\n          ng-if="userInfo.region==\'NA\'" alk-analytics="[\'Map Style\',\'Toggle Custom Places\']">\n          <a href="#"><span ng-class="(customPlacesStyle())?\'ico-checkbox-checked\':\'ico-checkbox-unchecked\'" class="ico"></span> Custom Places</a>\n        </li>\n      </ul>\n    </li>\n  </ul>\n</div>\n\n<div class="nav-section">\n  <avoid-favors-map></avoid-favors-map>\n</div>\n\n<div class="nav-section">\n  <map-styles></map-styles>\n</div>\n\n<div class="nav-section routesync">\n  <!-- SWPWEB-165 -->\n  <ul>\n    <li class="large-btn" ng-if="false">\n      <button id="rs-vehicles-btn" ng-click="" alkmaps-input alk-analytics="[\'Vehicles\',\'Toggle RouteSync Panel\']" ng-disabled="!userInfo.isPremium()"\n        title="{{(userInfo.isPremium())?\'\':\'Premium Only\'}}">\n          <img src="/img/icons/RouteSync_SignIn.png" />\n          RouteSync<br />Routes\n      </button>\n      <span ng-hide="userInfo.isPremium()" ng-cloak class="ng-cloak premium-feature-note" style="position: absolute; right: 22px; top: -5px;"></span>\n    </li>\n    <li class="large-btn" ng-if="userInfo.canUseTripDirect()">\n      <button id="rs-vehicles-btn" ng-click="toggleVehicles()" alkmaps-input alk-analytics="[\'Vehicles\',\'Toggle Vehicle Panel\']"\n        ng-disabled="!userInfo.isPremium()" title="{{(userInfo.isPremium())?\'\':\'Premium Only\'}}">\n          <img src="/img/truck-32x32.png" />\n          CoPilot<br/>Vehicles\n      </button>\n      <span ng-hide="userInfo.isPremium()" ng-cloak class="ng-cloak premium-feature-note" style="position: absolute; right: 7px; top: -5px;"></span>\n    </li>\n  </ul>\n</div>\n');
  $templateCache.put('/app/layout/main.html', '<div>\n  <alk-main-nav></alk-main-nav>\n  <p>Hello world</p>\n  <div id="center-section">\n    <div alkmap id="map">\n    </div>\n    <div alkmaps-navigation map-id="map">\n    </div>\n  </div>\n</div>\n');
  $templateCache.put('/app/layout/mainNav.template.html', '<div ng-controller="menuController">\n  <span class="main-logo" ng-click="home()">\n      <div>\n        <img class="pcm-product-logo" alt="Home" src="/img/PCMILER-Web_Logo_reversed.svg">\n      </div>\n  </span>\n  <div ng-include="\'/app/layout/appMenu.template.html\'" include-replace></div>\n  <div class="nav-section general info-message-container">\n    <div class="trial-info alert alert-warning alert-sm" ng-show="userInfo.accountType === \'Trial\'">\n      <strong>TRIAL ACCOUNT</strong>\n      <span>Expires {{userInfo.expirationDate | moment:\'fromNow\'}}</span><br />\n      <span>{{userInfo.remainingRoutes}} Remaining routes</span>\n    </div>\n\n    <div class="trial-info alert alert-warning alert-sm" ng-show="userInfo.netSuiteOnline && userInfo.creditExpiresSoon() &&  userInfo.isMonthlyPaidCustomer && !user.isInvoiced">\n      <strong>BILLING WARNING</strong>\n      <span>Credit card on file is scheduled to expire soon.</span><br />\n    </div>\n\n    <div class="trial-info alert alert-warning alert-sm" ng-show="routingProfileNotAvailable()">\n      <span>\n          Due to a technical issue, your saved routing options are temporarily unavailable. <br />\n          Please check back again for an updated status.  <br />\n          Default route options are available at this time.\n      </span>\n    </div>\n  </div>\n\n  <div class="zoomWarning label label-warning" ng-show="isRoadSurfaceVisible() && (getZoomLevel() > 16)">\n    <span class="glyphicon glyphicon-exclamation-sign"></span>\n    <span>Zoom out to see road surface condition </span>\n  </div>\n  <div class="zoomWarning label label-warning" ng-show="isPlacesVisible() && (getZoomLevel() < 10)">\n    <span class="glyphicon glyphicon-exclamation-sign"></span>\n    <span>Zoom in to see Places</span>\n  </div>\n  <div id="legends" class="">\n  <div id="weatherLegend"></div>\n  <div ng-class="{\'closed\': !isRSCollapsed, \'relativeLegend\': !isWeatherAlertsVisible()}" ng-show="isRoadSurfaceVisible() && !(getZoomLevel() > 16)" class="panel panel-default panel-floating ng-cloak roadSuraceLegend">\n    <div class="panel-heading">\n      <button class="btn btn-xs btn-link btn-icon-only">\n    <i class="ico ico-up-open" ng-click="toggleRS()" ng-class="(!isRSCollapsed)?\'ico-rotate-180\':\'ico-rotate-0\'"></i>\n    </button>\n      <h4 class="panel-name" ng-click="toggleRS()" style="cursor:pointer">Road Conditions </h4>\n      <button class="btn btn-xs btn-link btn-icon-only">\n    <i class="ico ico-close" ng-click="closeRS()"></i>\n    </button>\n    </div>\n    <div class="panel-body" ng-show="isRSCollapsed">\n      <ul class="legend-labels">\n        <li>\n          <span class="surface-icon range"></span>\n          <span> Not in range </span>\n        </li>\n        <li>\n          <span class="surface-icon dry"></span>\n          <span> Dry/Dew </span>\n        </li>\n        <li>\n          <span class="surface-icon wet"></span>\n          <span> Wet/Melting Snow </span>\n        </li>\n        <li>\n          <span class="surface-icon ice"></span>\n          <span class="span"> Ice/Icing Rain/Snow/Frost </span>\n        </li>\n        <li>\n          <span class="surface-icon snow"></span>\n          <span> Mix water/Snow </span>\n        </li>\n      </ul>\n    </div>\n  </div>\n  </div>\n  <div ng-include="\'/app/layout/userMenu.template.html\'" include-replace></div>\n</div>\n');
  $templateCache.put('/app/layout/pageHeader.template.html', '\n<div class="row" ng-controller="pageController">\n    <div class="col-md-12">\n        <a class="pull-left"  href="/">\n            <img src="/img/pcm-header-pages.png" />\n        </a>\n        <div class="menu-section page-left-content">\n            <ul class="nav nav-pills">\n                <li ng-class="getClass(\'/features\')"><a href="/features">Features &amp; Pricing</a></li>\n                <li ng-class="getClass(\'/info\')"><a href="/info">More Info</a></li>\n                <li ng-class="getClass(\'/contact\')"><a href="/contact">Contact</a></li>\n            </ul>\n        </div>\n        <div class="menu-section pull-right">\n            <a class="btn btn-info" href="/signup">Sign Up</a>\n            <a class="btn btn-default" href="/login">User Login</a>\n        </div>\n    </div>\n</div>\n');
  $templateCache.put('/app/layout/page_footer.html', '<div id="page-footer" class="row">\n    <div class="col-md-12">\n        <div class="legal-text"><copyright-text type="WebUI"></copyright-text> | <a href="/terms">Terms of Use</a> | <a href="https://support.pcmiler.com" target="_blank" rel="noopener">Contact Support</a></div> \n    </div>\n</div>');
  $templateCache.put('/app/layout/supportNav.template.html', '<div ng-controller="supportMenuController">\n <span class="main-logo" ng-click="home()">\n      <div>\n        <img class="pcm-product-logo" alt="Home" src="/img/PCMILER-Web_Logo_reversed.svg">\n      </div>\n  </span>\n\n    <!--<div class="nav-section button-section">\n       <a class="btn btn-info" href="/app" ng-if="userInfo.isTrialValid() && !userInfo.hasBillingIssue">Return to Application</a>\n    </div>-->\n\n    <div ng-include="\'/app/layout/userMenu.template.html\'"></div>\n    <h1 class="nav-title" style="position: absolute; color: white;right: 50%;">\n      <span ng-if="currentPath===\'/applicationSettings\'">Application Settings </span>\n      <span ng-if="currentPath===\'/account\'"> My Account </span>\n  </h1>\n</div>\n');
  $templateCache.put('/app/layout/userMenu.template.html', '\uFEFF<div class="nav-section right" style="border:none;">\n  <alk-cloud-menu ng-if="(userInfo.account !== \'Trimble MAPS Marketing Offers\') && (userInfo.account !== \'Marketing Offers\')" hide-change-password="true"  on-log-out="onLogOut()" on-app-change="onAppChange(product)"></alk-cloud-menu>\n</div>\n<div class="nav-section account right">\n  <ul>\n    <li class="small-btn">\n      <button ng-if="userInfo.account != \'Trimble MAPS Marketing Offers\'" id="account-btn" title="My Account" ng-click="goToAccount()" alkmaps-input>\n        <img src="/img/icons/My_Account_sm.png" />\n        My Account\n      </button>\n    </li>\n    <li class="small-btn btn-group">\n      <button id="help-btn" title="Help" ng-click="showHelp()" alkmaps-input>\n        <img src="/img/icons/Help_icon.svg"/>\n        Help\n      </button>\n    </li>\n    <li class="small-btn" ng-if="hasChatAccess()" >\n      <button id="fc-btn" title="Chat With Support" ng-click="toggleShowChat()" alkmaps-input>\n        <img src="img/icons/FreshChat.svg" />\n        Chat With Support\n      </button>\n    </li>\n  </ul>\n</div>\n<!-- <div class="nav-section account right">\n  <ul>\n    <li class="large-btn">\n      <button id="account-btn" ng-click="goToAccount()" alkmaps-input>\n          <img src="/img/icons/My_Account.png" />\n          My Account\n      </button>\n    </li>\n  </ul>\n\n</div>\n<div class="nav-section right">\n  <ul>\n    <li class="large-btn btn-group">\n      <button ng-click="showHelp()" alkmaps-input>\n      <img src="/img/icons/Help_icon.svg"/> Help\n  </button>\n    </li>\n  </ul>\n</div> -->');
  $templateCache.put('/app/modal/dialog.template.html', '<div class="modal-header">\n    <h4 class="modal-title">{{modalOptions.headerText}}</h4>\n</div>\n<div class="modal-body">\n    <p ng-if="modalOptions.bodyText">{{modalOptions.bodyText}}</p>\n    <div ng-if="modalOptions.bodyTemplate" ng-include="modalOptions.bodyTemplate"></div>\n</div>\n<div class="modal-footer">\n    <button class="btn" ng-if="!modalOptions.okOnly" ng-click="modalOptions.close()">{{modalOptions.closeButtonText}}</button>\n    <button class="btn btn-primary" ng-click="modalOptions.ok(modalOptions)">{{modalOptions.actionButtonText}}</button>\n</div>');
  $templateCache.put('/app/modal/emptyResponse.template.html', '<p>There is a technical problem with your account.  Please contact support <a href=\'mailto:support@trimblemaps.com\'>support@trimblemaps.com</a> so we can help resolve it.</p>');
  $templateCache.put('/app/modal/favoriteDialog.template.html', '<div>\n  <form name="saveLocationForm" ng-submit="ok(saveLocationForm.$valid)">\n    <div class="modal-header">\n      <h4 class="modal-title">Save Location</h4>\n    </div>\n    <div class="modal-body">\n      <div class="form-group" ng-class="{ \'has-error\': (saveLocationForm.locationName.$invalid && !saveLocationForm.locationName.$pristine)}">\n        <label class="control-label" for="favorite-name">Name:</label>\n        <input id="favorite-name" name="locationName" type="text" maxlength="140" class="form-control input" ng-model="location.name" required unique-favorite-name\n          ng-model-options="{ debounce: 300 }" alkmaps-input autofocus />\n        <div class="glyphicon glyphicon-exclamation-sign error-glyph" ng-show="(saveLocationForm.locationName.$invalid && !saveLocationForm.locationName.$pristine)">\n          <div class="error-tooltip bg-danger">\n            <p ng-show="saveLocationForm.locationName.$error.required" class="help-block">required.</p>\n            <p ng-show="saveLocationForm.locationName.$error.uniqueFavoriteName" class="help-block">location name must be unique.</p>\n          </div>\n        </div>\n      </div>\n      <div class="checkbox">\n        <label>\n          <input type="checkbox" ng-model="location.isShared"> Share this location with everyone in your account?\n        </label>\n      </div>\n    </div>\n    <div class="modal-footer">\n      <button class="btn btn-default" ng-click="close()" type="button">Cancel</button>\n      <button class="btn btn-primary" type="submit" ng-disabled="saveLocationForm.$invalid || saveLocationForm.$pending">OK\n        <span class="has-error" ng-if="saveLocationForm.$invalid">&nbsp;\n          <i class="glyphicon glyphicon-exclamation-sign"></i>\n        </span>\n      </button>\n    </div>\n  </form>\n</div>\n');
  $templateCache.put('/app/modal/leastCostDialog.template.html', '<alkmaps-map id="leastcostMap">\n</alkmaps-map>\n\n<div id="leastcostReports">\n    <div id="route-panel-header" class="panel-header">\n        <div class="expander"></div>\n    </div>\n    <div id="leastcostTableContainer">\n        <table>\n            <thead>\n                <tr>\n                    <th class="track-col-visible">Visible</th>\n                    <th class="track-col-color">Color</th>\n                    <th class="track-col-options">Options</th>\n                    <th class="track-col-aDist numeric">Miles</th>\n                    <th class="track-col-aDur numeric">Costs</th>\n                    <th class="track-col-aDur numeric">Hours</th>\n                    <th class="track-col-aDur numeric">Tolls</th>\n                    <th class="track-col-aDur numeric">Fuel</th>\n                    <th class="track-col-aDur numeric">Labor</th>\n                    <th class="track-col-aDur numeric">Other</th>\n                    <th class="track-col-aDur numeric">EstGHG</th>\n                </tr>\n            </thead>\n            <tbody id="route-table-body">\n                <tr ng-repeat="route in modalOptions.data.routes" ng-click="selectRow(route)" tabindex="{{200 + $index}}" list-select="selectRow(route)">\n                    <td><input type="checkbox" ng-model=route.checked ng-change="changeTrackVisibility(route)" ng-click="$event.stopPropagation();" /></td>\n                    <td class="color-block-cell"><div class="color-block" ng-style="{\'background-color\':route.strokeColor}"></div></td>\n                    <td>{{route.dispOptions}}</td>\n                    <td class="numeric" ng-class="(route.minMiles===true)?\'min-value\':\'\'">{{route.miles}}</td>\n                    <td class="numeric" ng-class="(route.minCosts===true)?\'min-value\':\'\'">{{route.costs}}</td>\n                    <td class="numeric" ng-class="(route.minHours===true)?\'min-value\':\'\'">{{route.hours}}</td>\n                    <td class="numeric" ng-class="(route.minTolls===true)?\'min-value\':\'\'">{{route.tolls}}</td>\n                    <td class="numeric">{{route.fuel}}</td>\n                    <td class="numeric">{{route.labor}}</td>\n                    <td class="numeric">{{route.other}}</td>\n                    <td class="numeric">{{route.estghg}}</td>\n                </tr>\n            </tbody>\n        </table>\n    </div>\n</div>\n\n');
  $templateCache.put('/app/modal/placesDialog.template.html', '<div class="modal-header">\n  <h4 class="modal-title">Custom Places</h4>\n</div>\n<!--place sets-->\n<div class="modal-body">\n\n\n  <div ng-if="!vm.hideContent">\n    <h5 class="legend" ng-show="vm.display===\'sets\'">\n      <span> Sets </span>\n    </h5>\n    <h5 class="legend" ng-show="vm.display===\'places\'"> {{vm.setName}} </h5>\n    <div class="place-sets">\n      <div class="form-inline filter-group">\n        <!-- Set Filter -->\n        <div class="input-group">\n          <span class="input-group-btn">\n            <span class="btn btn-sm btn-fake-addon">\n              <i class="ico ico-filter"></i>\n            </span>\n          </span>\n          <input id="filterInput" type="text" class="form-control ng-pristine ng-untouched ng-valid" placeholder="Filter" ng-model="filterby.$"\n            ng-model-options="{ debounce: 300 }" ng-change="">\n          <span class="input-group-btn">\n            <button class="btn btn-sm btn-default" type="button" ng-click="filterby.$ = \'\'">\xD7</button>\n          </span>\n        </div>\n\n      </div>\n      <div class="item-list-container places-container">\n        <ul class="list-group item-list favorite-list">\n          <li class="clearfix" ng-if="vm.customPlaceSets.length === 0 && !vm.loading">\n            <i class="ico ico-info-circle ico-info-color"></i>\n            <span class="favorite-address">No Locations have been saved.</span>\n          </li>\n          <li ng-if="vm.loading">\n            <svg class="lds-spinner" width="32" height="32" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" style="background:0 0">\n              <rect x="47" y="24" rx="9.4" ry="4.8" width="6" height="12" fill="#6a6767"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.9166666666666666s" repeatCount="indefinite"/></rect>\n              <rect x="47" y="24" rx="9.4" ry="4.8" width="6" height="12" fill="#6a6767" transform="rotate(30 50 50)"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.8333333333333334s" repeatCount="indefinite"/></rect>\n              <rect x="47" y="24" rx="9.4" ry="4.8" width="6" height="12" fill="#6a6767" transform="rotate(60 50 50)"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.75s" repeatCount="indefinite"/></rect>\n              <rect x="47" y="24" rx="9.4" ry="4.8" width="6" height="12" fill="#6a6767" transform="rotate(90 50 50)"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.6666666666666666s" repeatCount="indefinite"/></rect>\n              <rect x="47" y="24" rx="9.4" ry="4.8" width="6" height="12" fill="#6a6767" transform="rotate(120 50 50)"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.5833333333333334s" repeatCount="indefinite"/></rect>\n              <rect x="47" y="24" rx="9.4" ry="4.8" width="6" height="12" fill="#6a6767" transform="rotate(150 50 50)"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.5s" repeatCount="indefinite"/></rect>\n              <rect x="47" y="24" rx="9.4" ry="4.8" width="6" height="12" fill="#6a6767" transform="rotate(180 50 50)"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.4166666666666667s" repeatCount="indefinite"/></rect>\n              <rect x="47" y="24" rx="9.4" ry="4.8" width="6" height="12" fill="#6a6767" transform="rotate(210 50 50)"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.3333333333333333s" repeatCount="indefinite"/></rect>\n              <rect x="47" y="24" rx="9.4" ry="4.8" width="6" height="12" fill="#6a6767" transform="rotate(240 50 50)"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.25s" repeatCount="indefinite"/></rect>\n              <rect x="47" y="24" rx="9.4" ry="4.8" width="6" height="12" fill="#6a6767" transform="rotate(270 50 50)"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.16666666666666666s" repeatCount="indefinite"/></rect>\n              <rect x="47" y="24" rx="9.4" ry="4.8" width="6" height="12" fill="#6a6767" transform="rotate(300 50 50)"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.08333333333333333s" repeatCount="indefinite"/></rect>\n              <rect x="47" y="24" rx="9.4" ry="4.8" width="6" height="12" fill="#6a6767" transform="rotate(330 50 50)"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="0s" repeatCount="indefinite"/></rect>\n            </svg>\n            Loading...\n          </li>\n          <li class="clearfix" ng-if="(vm.customPlaceSets.length !== 0) && (vm.filteredSets.length === 0) && !vm.loading">\n            <i class="ico ico-info-circle ico-info-color"></i>\n            <span class="favorite-address">No Match Results found.</span>\n          </li>\n          <li class="list-group-item" ng-show="vm.display===\'sets\'" ng-repeat="placeSet in vm.filteredSets=(vm.customPlaceSets | filter : filterby | limitTo: 50)"\n            ng-click="vm.showPlacesInSet(placeSet)" list-select list-select-skip-auto-focus="true"\n            alkmaps-input alk-analytics="[\'Search\',\'Favorites\',\'Add Stop\']">\n            <div class="flex-group">\n              <div class="result-info text-ellipsis flex-element">\n                <span class="favorite-address">\n                    <span class="categories-container" ng-if="vm.showCategories(placeSet) && placeSet.AlkPublicReadOnly" title="{{placeSet.Categories[0].Icon}}"><img class="cat-icons" ng-src="/img/poi-icons/alk_poi_{{placeSet.Categories[0].Icon}}.png" ></span>\n                    <span class="categories-container" ng-if="vm.showCategories(placeSet) && !placeSet.AlkPublicReadOnly" title="{{placeSet.Categories[0].Icon}}"><img class="cat-icons" ng-src="/img/poi-icons/poi_{{placeSet.Categories[0].Icon}}.png" ></span>\n                    <span class="categories-container" ng-if="!vm.showCategories(placeSet)"  title="No Category Assigned"><img class="cat-icons" ng-src="/img/poi-icons/poi_other.png" ></span>\n                  <span class="name">\n                    <strong> {{placeSet.Name}} </strong>\n                  </span>\n                </span>\n              </div>\n              <span class="badge with-actions pull-right">{{placeSet.PlaceCounts}}</span>\n              <div class="line-arrow">\n                <span class="ico ico-chevron-right-thick"></span>\n              </div>\n            </div>\n          </li>\n\n          <li ng-if="vm.display === \'places\' && vm.filteredSetPlaces.length > 100" class="list-group-item conditional-item">\n            There are too many Places to show. Please use the filter to narrow down the results.\n          </li>\n          <li ng-if="$index <= 100" class="list-group-item" ng-show="vm.display===\'places\'" ng-repeat="place in vm.filteredSetPlaces = (vm.places | filter : filterby)" list-select\n            list-select-skip-auto-focus="true" alkmaps-input alk-analytics="[\'Search\',\'Favorites\',\'Add Stop\']">\n            <div class="flex-group">\n              <div class="result-info text-ellipsis flex-element">\n                <label class="checkbox-label">\n                  <input type="checkbox" ng-model="vm.selectedPlacesDict[place.Id]">\n                  <span class="favorite-address">\n                    <span class="name">\n                      <strong> {{place.Name}} - <strong>\n                    </span>\n                    <span>\n                      <strong> {{place.Address.StreetAddress}},</strong> {{place.Address.County}}, {{place.Address.City}}, {{place.Address.State}},\n                      {{place.Address.Zip}}</span>\n                  </span>\n                  </input>\n                </label>\n              </div>\n              <button class="btn btn-xs btn-link btn-action" ng-if="place.ALKObj.SiteId !== null" alk-analytics="[\'Search\',\'ALK Place\',\'Locate\']">\n                <i class="ico ico-polygon" title="Site"></i>\n              </button>\n              <button class="btn btn-xs btn-link btn-action" title="Show Location" ng-click="vm.showPlaceOnMap(place)" alk-analytics="[\'Search\',\'Favorites\',\'Locate\']">\n                <i class="ico ico-location-icon"></i>\n              </button>\n            </div>\n          </li>\n        </ul>\n      </div>\n    </div>\n  </div>\n</div>\n<!--places-->\n<div class="modal-footer">\n  <button class="btn btn-default pull-left" ng-show="vm.display===\'places\'" ng-click="vm.back()" type="button">{{vm.hideContent? "Resume List" : "Back"}}</button>\n  <button class="btn btn-default" ng-click="vm.close()" type="button">Close</button>\n  <button class="btn btn-primary" ng-disabled="vm.getSelectedPlacesLength() === 0" ng-click="vm.ok()">{{vm.getSelectedPlacesLength() > 0 ? "Add " + vm.getSelectedPlacesLength() + " Places ": "Select Place(s) to Add" }}\n  </button>\n</div>\n');
  $templateCache.put('/app/route/openRoute.template.html', '<div class="modal-header">\n  <h4 class="modal-title">Open Route</h4>\n</div>\n<div class="modal-body">\n  <div>\n   <h4> Saved Routes </h4>\n     <div class="item-list-container places-container">\n      <div class="alert alert-warning alert-sm" ng-if="savedRoutes.length >= getSaveRouteLimit()">\n        <span><i class="glyphicon glyphicon-exclamation-sign"></i>&nbsp;  You have exceeded the maximum number of saved routes. To continue saving new routes, please delete previously saved routes. </span>\n      </div>\n    <ul class="favorite-routeList list-group item-list">\n      <li ng-if="(savedRoutes.length === 0)" class="list-group-item clearfix">\n        <i class="ico ico-info-circle"></i>\n        <span class="no-routes favorite-address">\n          No Routes have been saved.\n        </span>\n      </li>\n      <li class="list-group-item" ng-repeat="route in savedRoutes" ng-click="selectRoute(route)" ng-dblclick="selectRoute(route); ok();" tabindex="{{300 + $index}}"\n        list-select="selectRoute(route)" list-select-on-enter="selectRoute(route); ok();">\n        <div class="favorite-address">\n          <span ng-if="(route.name)" ng-bind="route.name" class="name"></span>\n          <route-dialog-location location="route.stops[0]"></route-dialog-location>\n          <span> &gt;&gt; </span>\n          <route-dialog-location location="route.stops[route.stops.length-1]"></route-dialog-location>\n        </div>\n        <div class="item-actions" showonhoverparent="li">\n          <button tabindex="-1" class="btn btn-more" ng-click="$event.preventDefault(); $event.stopPropagation();">\n                    <i class="ico ico-more-vertical"></i>\n                  </button>\n          <div class="item-actions-well">\n            <button class="btn-link btn-action btn-sm btn" ng-click="deleteRoute(route); $event.preventDefault(); $event.stopPropagation();">\n                        <i class="ico ico-trash"></i>\n                    </button>\n          </div>\n        </div>\n      </li>\n    </ul>\n     </div>\n  </div>\n</div>\n<div class="modal-footer">\n  <button class="btn btn-default" ng-click="close()">Cancel</button>\n  <button class="btn btn-primary" ng-click="ok()" ng-disabled="!selectedRoute">Open</button>\n</div>\n');
  $templateCache.put('/app/route/options.template.html', '<div class="modal-header">\n  <h4 class="modal-title" ng-bind="(vm.isDefault) ? \'Default Options\' : vm.localOptions.name"></h4>\n</div>\n\n\n<div class="modal-body">\n  <div id="" ng-class="(!userInfo.isPremium()) ? \'basic-subscription\':\'premium-subscription\'">\n    <form name="routeOptionsForm">\n      <div class="row">\n        <div class="form-group col-md-6" ng-class="(routeOptionsForm.routeName.$error.required && !routeOptionsForm.routeName.$pristine)?\'has-error\':\'\'"\n          ng-if="(!vm.isDefault)">\n          <label for="routeName" class="control-label">Route Name</label>\n          <input id="routeName" name="routeName" class="form-control input-sm" type="text" ng-model="vm.routeCopy.name" ng-disabled="vm.isDefault"\n            required alkmaps-input autofocus />\n          <div class="glyphicon glyphicon-exclamation-sign error-glyph" ng-show="(routeOptionsForm.routeName.$invalid && !routeOptionsForm.routeName.$pristine)">\n            <div class="error-tooltip bg-danger">\n              <p ng-show="routeOptionsForm.routeName.$error.required && !routeOptionsForm.routeName.$pristine" class="help-block">Route Name is required.</p>\n            </div>\n          </div>\n        </div>\n        <div class="form-group col-md-12" ng-if="(vm.isDefault)">\n          <div class="alert alert-warning alert-sm">\n            <em>\n                <strong>NOTE:</strong> These options will not be applied to existing or saved routes.  They will only be applied to new routes created after saving these settings.  Individual settings can still be changed for any new route you create.\n            </em>\n            </div>\n        </div>\n      </div>\n\n      <div class="row" ng-if="(vm.routeCopy.options.routingProfileNotAvailable)">\n        <div class="form-group col-md-12">\n          <div class="alert alert-warning alert-sm">\n            <em>\n                <strong>NOTE:</strong> Due to a technical issue, your saved routing options are temporarily unavailable.  Please check back again for an updated status.  Default route options are available at this time.<br />\n                New custom default options will not be applied to existing or saved routes.\n            </em>\n          </div>\n        </div>\n      </div>\n\n\n      <div class="container routeOptionsPanel" style="width:100%">\n        <p></p>\n        <div class="panel-group routeOptions" id="accordion">\n\n          <div class="panel panel-default">\n            <a data-toggle="collapse" data-parent="#accordion" data-target="#routingPref">\n              <div class="panel-heading" ng-model="vm.expandRouting" ng-init="vm.expandRouting = true" ng-click="vm.expandRouting = !vm.expandRouting; vm.expandExceptions = false; vm.expandVehicle = false; vm.expandReporting=false; vm.expandArrDep = false"\n                ng-class="{\'closed\':!vm.expandRouting}">\n                <h4 class="panel-title">\n\n                  <label>Routing Preferences </label>\n                  <span class="has-error" ng-show="(routeOptionsForm.elevLimit.$invalid || routeOptionsForm.governorSpeedLimit.$invalid)">\n                    <i class="glyphicon glyphicon-exclamation-sign"></i>\n                    </span>\n                  <div class="expand-container pull-right">\n                    <div class="expand-button" ng-class="{\'open\':vm.expandRouting}"></div>\n                  </div>\n                </h4>\n              </div>\n            </a>\n            <div id="routingPref" class="panel-collapse collapse in">\n              <div class="panel-body">\n                <div class="row">\n                  <div class="col-md-4 col-xs-4">\n                    <label for="routingType" class="control-label">Route Type</label>\n                    <select id="routingType" name="routingType" class="form-control input-sm" ng-model="vm.routeCopy.options.routingType" ng-options="type.value as type.display for type in vm.optionsUI.routingType"\n                      required alkmaps-input></select>\n                  </div>\n                  <div class="col-md-4 col-xs-4">\n                    <label for="classOverrides" class="control-label routing-center">Road Network </label>\n                    <span class="ico ico-help help-question " tooltip-placement="right" uib-tooltip="State + National Network routing favors the US Federally designated National Network (primary Interstates with\n                                        reasonable entry/egress points up to 1 mile off the Interstate) and state designated extensions to the National Network (additional highways and supporting roads any distance off the Interstate, as\n                                        determined by individual states). This option also incorporates roads that permit 53\' trailers or twins."> </span>\n                    <select id="classOverrides" name="classOverrides" class="form-control input-sm" ng-model="vm.routeCopy.options.classOverrides" ng-options="type.value as type.display for type in vm.optionsUI.classOverrides" ng-disabled="vm.getDisabledOption()"\n                      required alkmaps-input></select>\n                  </div>\n                  <div class="col-md-4 col-xs-4">\n                    <label for="highwayOnly" class="control-label" ng-class="{ \'premium-feature-heading\': (!userInfo.isPremium()) }">Roads</label>\n                    <select id="highwayOnly" name="highwayOnly" class="form-control input-sm" ng-model="vm.routeCopy.options.highwayOnly" ng-options="type.value as type.display for type in vm.optionsUI.highwayOnly"\n                      ng-disabled="(!userInfo.isPremium())" required alkmaps-input></select>\n                  </div>\n                </div>\n                <div>\n                  <p></p>\n                </div>\n                <div class="row">\n                  <div class="col-md-4">\n                    <label for="tollDiscourage" class="control-label">Toll Roads</label>\n                    <select id="tollDiscourage" name="tollDiscourage" class="form-control input-sm" ng-model="vm.routeCopy.options.tollDiscourage" ng-options="type.value as type.display for type in vm.optionsUI.tollDiscourage"\n                      required alkmaps-input></select>\n                  </div>\n                  <div class="col-md-4">\n                    <label for="bordersOpen" class="control-label routing-center">International Borders</label><span class="ico ico-help help-question"\n                      tooltip-placement="right" uib-tooltip="Select Closed to minimize\n                                      the number of international border crossings. For example, if all your stops are in the lower 48&quot; United States, the resulting route will stay in the United States even though the most practical or shortest route would\n                                        normally involve some Canadian mileage. The Open option ignores international boundaries in generating the best route. "></span>\n                    <select id="bordersOpen" name="bordersOpen" class="form-control input-sm" ng-model="vm.routeCopy.options.bordersOpen" ng-options="type.value as type.display for type in vm.optionsUI.bordersOpen"\n                      required alkmaps-input></select>\n                  </div>\n                  <div class="col-md-4 col-xs-4">\n                    <label for="overrideRestrict" class="control-label ">Restrictions</label>\n                    <span class="ico ico-help help-question " tooltip-placement="right" uib-tooltip="Select Override to relax specialized road restrictions such as size and weight restrictions, time-based restrictions, no through trucks, or delivery only\n                    restrictions, and specialized turn restrictions noting that Override will still avoid roads that are prohibited or discouraged for truck travel."> </span>\n                    <select id="overrideRestrict" name="overrideRestrict" class="form-control input-sm" ng-model="vm.routeCopy.options.overrideRestrict" ng-options="type.value as type.display for type in vm.optionsUI.overrideRestrict"\n                      required alkmaps-input></select>\n                  </div>\n                </div>\n                <div>\n                  <p></p>\n                </div>\n                <div class="row">\n                  <div class="col-md-4 col-xs-4">\n                    <label for="ferryDiscourage" class="control-label">Ferries </label>\n                    <select id="ferryDiscourage" name="ferryDiscourage" class="form-control input-sm" ng-model="vm.routeCopy.options.ferryDiscourage" ng-options="type.value as type.display for type in vm.optionsUI.ferryDiscourage"\n                      required alkmaps-input></select>\n                  </div>\n                  <div class="col-md-4 col-xs-4">\n                    <label for="hubRouting" class="control-label routing-center">Hub Routing </label>\n                    <span class="ico ico-help help-question" tooltip-placement="right" uib-tooltip="Enable this option to calculate distances from one location (the route\'s origin) to multiple destinations (every other stop on the route). "></span>\n                    <select id="hubRouting" name="hubRouting" class="form-control input-sm" ng-model="vm.routeCopy.options.hubRouting" ng-options="type.value as type.display for type in vm.optionsUI.hubRouting"\n                      required alkmaps-input></select>\n                  </div>\n                  <div class="col-md-4 col-xs-4">\n                    <label for="sideOfStreetAdherence" class="control-label">Side of Street Adherence</label>\n                    <select id="sideOfStreetAdherence" name="sideOfStreetAdherence" class="form-control input-sm" ng-model="vm.routeCopy.options.sideOfStreetAdherence"\n                      ng-options="type.value as type.display for type in vm.optionsUI.sideOfStreetAdherence" required alkmaps-input></select>\n                  </div>\n                </div>\n                <div>\n                  <p></p>\n                </div>\n                <div class="row">\n                  <div class="col-md-4 col-xs-4" ng-if="vm.region === \'EU\' && false">\n                    <div ng-if="vm.region === \'EU\'">\n                      <label for="euhazMatType" class="control-label" ng-class="{ \'premium-feature-heading\': (!userInfo.isPremium()) }">HazMat Type </label>\n                      <span class="ico ico-help help-question" tooltip-placement="right" uib-tooltip=" hazmat classifications correspond to PCMILER HazMat route type"></span>\n                      <select id="euhazMatType" name="euhazMatType" ng-disabled="(!userInfo.isPremium())" class="form-control input-sm" ng-model="vm.EUOptions.hazMatType"\n                        ng-options="type.value as type.display for type in vm.optionsUI.euHazmatType" required alkmaps-input></select>\n                    </div>\n                    <div ng-if="vm.region === \'EU\'">\n                      <label for="euhazMatCat" class="control-label" ng-class="{ \'premium-feature-heading\': (!userInfo.isPremium()) }">Prohibited Tunnel Categories</label>\n                      <span class="ico ico-help help-question" tooltip-placement="right" uib-tooltip=" hazmat classifications correspond to PCMILER HazMat route type"></span>\n                      <select id="euhazMatCat" name="euhazMatCat" ng-disabled="(!userInfo.isPremium()) || vm.EUOptions.hazMatType === \'None\'"\n                        class="form-control input-sm" ng-model="vm.EUOptions.categories" ng-options="type.value as type.display for type in vm.optionsUI.euHazmatCat"\n                        required alkmaps-input></select>\n                    </div>\n                  </div>\n                  <div class="col-md-4 col-xs-4 ">\n                    <div class="">\n                      <label for="governorSpeedLimit" class="control-label">Governor Speed Limiting</label>\n                      <span class="ico ico-help help-question" tooltip-placement="right" uib-tooltip="Enables a maximum average road speed to use in route calculations (use the 55 mph default or enter a custom speed). This speed\n                                        overrides all other road speeds used in route calculations when they are higher than the governor setting."></span>\n                    </div>\n                    <div class="col-md-7 col-xs-7 select-options">\n                      <select class="form-control input-sm" ng-model="vm.localOptions.isGovernorSpeedLimit" alkmaps-input ng-change="vm.changeGovernorSpeedLimit()"\n                        ng-options="type.value as type.display for type in vm.optionsUI.governorSpeedLimits" required alkmaps-input\n                        ng-required="vm.localOptions.isGovernorSpeedLimit" alkmaps-input></select>\n                    </div>\n                    <div class="input-group col-md-5 col-sm-5 col-xs-5">\n                      <input id="governorSpeedLimit" name="governorSpeedLimit" type="text" class="form-control input-sm" pcm-integer pcm-range\n                        pcm-range-min="1" pcm-range-max="{{(vm.routeCopy.options.distanceUnits === 0)? 100 : 160 }}" ng-model="vm.localOptions.governorSpeedLimit"\n                        ng-required="vm.localOptions.isGovernorSpeedLimit" ng-disabled="!vm.localOptions.isGovernorSpeedLimit" alkmaps-input\n                      />\n                      <div class="glyphicon glyphicon-exclamation-sign error-glyph" style="top:8px;" ng-show="(routeOptionsForm.governorSpeedLimit.$invalid)">\n                        <div class="error-tooltip bg-danger">\n                          <p ng-show="routeOptionsForm.governorSpeedLimit.$error.required" class="help-block"> Governor Speed Limit is required.</p>\n                          <p ng-show="routeOptionsForm.governorSpeedLimit.$error.pcmInteger" class="help-block">Governor Speed Limit must be a whole number.</p>\n                          <p ng-show="routeOptionsForm.governorSpeedLimit.$error.pcmRange" class="help-block">Governor Speed Limit must be 1 to {{(vm.routeCopy.options.distanceUnits === 0)? "100 mph" : "160 km/h"}}</p>\n                        </div>\n                      </div>\n                      <span class="input-group-addon">{{(vm.routeCopy.options.distanceUnits === 0)? "mph" : "km/h"}}</span>\n                    </div>\n                  </div>\n                  <div class="col-md-4 col-xs-4">\n                    <div>\n                      <label for="elevationlimit" class="control-label routing-center" ng-class="{ \'premium-feature-heading\': (!userInfo.isPremium()) }">Elevation</label>\n                    </div>\n                    <div class="col-md-8 col-sm-8 col-xs-8 select-options">\n                      <select id="elevationlimit" name="elevationlimit" class="form-control input-sm" ng-model="vm.localOptions.isElevationDiscouraged"\n                        ng-disabled="(!userInfo.isPremium())" ng-change="vm.changeElevationDiscouraged()" ng-options="type.value as type.display for type in vm.optionsUI.elevLimit"\n                        alkmaps-input></select>\n                    </div>\n                    <div class="form-group input-group col-md-4 col-sm-4 col-xs-4" ng-class="{ \'has-error\': (routeOptionsForm.elevLimit.$invalid)}">\n                      <input id="elevLimit" name="elevLimit" type="text" class="form-control input-sm" pcm-integer pcm-range\n                        pcm-range-min="0" pcm-range-max="{{(vm.routeCopy.options.distanceUnits === 0)? 29035 : 8850 }}" ng-model="vm.localOptions.elevationLimit"\n                        ng-required="vm.localOptions.isElevationDiscouraged" ng-disabled="!vm.localOptions.isElevationDiscouraged || !userInfo.isPremium()"\n                        alkmaps-input />\n                      <div class="glyphicon glyphicon-exclamation-sign error-glyph" style="top:8px; right: 32px;" ng-show="(routeOptionsForm.elevLimit.$invalid)">\n                        <div class="error-tooltip bg-danger">\n                          <p ng-show="routeOptionsForm.elevLimit.$error.required" class="help-block">Elevation Limit is required.</p>\n                          <p ng-show="routeOptionsForm.elevLimit.$error.pcmInteger" class="help-block">Elevation Limit must be a whole number.</p>\n                          <p ng-show="routeOptionsForm.elevLimit.$error.pcmRange" class="help-block">Elevation Limit must be 1 to {{(vm.routeCopy.options.distanceUnits === 0)? "29035 ft" : "8850 m"}}</p>\n                        </div>\n                      </div>\n                      <span class="input-group-addon">{{(vm.routeCopy.options.distanceUnits === 0)? "ft" : "m"}}</span>\n                    </div>\n                  </div>\n                  <div class="col-md-4 col-xs-4" ng-if="vm.region !== \'EU\'">\n                    <label for="hazMatType" class="control-label" ng-class="{ \'premium-feature-heading\': (!userInfo.isPremium()) }">Hazmat </label>\n                    <span class="ico ico-help help-question" tooltip-placement="right" uib-tooltip="U.S. DOT hazmat classifications correspond to PCMILER HazMat route type. For more information, please reference the Help page."></span>\n                    <select id="hazMatType" name="hazMatType" ng-disabled="(!userInfo.isPremium())" class="form-control input-sm" ng-model="vm.routeCopy.options.hazMatType"\n                      ng-options="type.value as type.display for type in vm.optionsUI.hazmat" required alkmaps-input></select>\n                  </div>\n                </div>\n                <div>\n                  <p></p>\n                </div>\n                <div class="row">\n                  <div class="col-md-4 col-xs-4">\n                    <label for="useSites" class="control-label" ng-class="{ \'premium-feature-heading\': (!userInfo.isPremium()) }">Site Routing</label>\n                    <span class="ico ico-help help-question" tooltip-placement="right" uib-tooltip="Uses Custom Places and public Places with defined Sites and Entry/Exit Gates"></span>\n                    <select id="useSites" name="useSites" ng-disabled="(!userInfo.isPremium())" class="form-control input-sm" ng-model="vm.routeCopy.options.useSites" ng-options="type.value as type.display for type in vm.optionsUI.useSites"\n                      required alkmaps-input></select>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n\n          <!--end of routing preferences-->\n\n          <div class="panel panel-default">\n            <a data-toggle="collapse" data-parent="#accordion" data-target="#routeExceptions">\n              <div class="panel-heading" ng-model="vm.expandExceptions" ng-init="vm.expandExceptions = false" ng-click="vm.expandExceptions = !vm.expandExceptions; vm.expandVehicle = false; vm.expandReporting=false; vm.expandArrDep = false"\n                ng-class="{\'closed\':!vm.expandExceptions}">\n                <h4 class="panel-title">\n\n                  <label ng-class="{ \'premium-feature-heading\': (!userInfo.isPremium()) }">\n                    Route Modifiers\n                  </label>\n                  <span class="has-error" ng-show="">\n                    <i class="glyphicon glyphicon-exclamation-sign"></i>\n                    </span>\n                  <div class="expand-container pull-right">\n                    <div class="expand-button" ng-class="{\'open\':vm.expandExceptions}"></div>\n                  </div>\n                </h4>\n              </div>\n            </a>\n            <div id="routeExceptions" class="panel-collapse collapse out">\n              <div class="panel-body">\n                <label class="control-label">Sets </label>\n                 <avoid-favors-panel id="afsView" avoid-favors-set-list="vm.routeCopy.options.afSetIDs"></avoid-favors-panel>\n              </div>\n            </div>\n          </div>\n          <!--end of route Modifiers -->\n\n          <div class="panel panel-default">\n            <a class="accordion-toggle" data-toggle="collapse" data-parent="#accordion" data-target="#vehicleDimensions">\n              <div class="panel-heading" ng-model="vm.expandVehicle" ng-click="vm.expandVehicle = !vm.expandVehicle; vm.expandExceptions = false; vm.expandRouting= false; vm.expandReporting=false; vm.expandArrDep = false"\n                ng-class="{\'closed\':!vm.expandVehicle}">\n                <h4 class="panel-title">\n                  <label ng-class="{ \'premium-feature-heading\': (!userInfo.isPremium()) }">\n                    Vehicle Dimensions\n                  </label>\n                  <span class="has-error" ng-show="((routeOptionsForm.trkHeightFeet.$invalid && !routeOptionsForm.trkHeightFeet.$pristine)\n                    || (routeOptionsForm.trkHeightInches.$invalid && !routeOptionsForm.trkHeightInches.$pristine)\n                    || (routeOptionsForm.trkHeightMeters.$invalid && !routeOptionsForm.trkHeightMeters.$pristine)\n                    || (routeOptionsForm.trkLengthFeet.$invalid && !routeOptionsForm.trkLengthFeet.$pristine)\n                    || (routeOptionsForm.trkLengthInches.$invalid && !routeOptionsForm.trkLengthInches.$pristine)\n                    || (routeOptionsForm.trkLengthMeters.$invalid && !routeOptionsForm.trkLengthMeters.$pristine)\n                    || (routeOptionsForm.trkWidthEnglish.$invalid && !routeOptionsForm.trkWidthEnglish.$pristine)\n                    || (routeOptionsForm.trkWidthMetric.$invalid && !routeOptionsForm.trkWidthMetric.$pristine)\n                    || (routeOptionsForm.trkWeight.$invalid && !routeOptionsForm.trkWeight.$pristine)\n                    || (routeOptionsForm.trkWeightKg.$invalid && !routeOptionsForm.trkWeightKg.$pristine)\n                    || (routeOptionsForm.trlMaxHtFeet.$invalid && !routeOptionsForm.trlMaxHtFeet.$pristine)\n                    || (routeOptionsForm.trlMaxHtInches.$invalid && !routeOptionsForm.trlMaxHtInches.$pristine)\n                    || (routeOptionsForm.trlMaxHtMeters.$invalid && !routeOptionsForm.trlMaxHtMeters.$pristine)\n                    || (routeOptionsForm.trlMaxWt.$invalid && !routeOptionsForm.trlMaxWt.$pristine)\n                    || (routeOptionsForm.trlMaxWtKg.$invalid && !routeOptionsForm.trlMaxWtKg.$pristine)\n                    || (routeOptionsForm.fuelConsumption.$invalid && !routeOptionsForm.fuelConsumption.$pristine))">\n                    <i class="glyphicon glyphicon-exclamation-sign"></i>\n                  </span>\n                  <div class="expand-container pull-right">\n                    <div class="expand-button" ng-class="{\'open\':vm.expandVehicle}"></div>\n                  </div>\n                </h4>\n              </div>\n            </a>\n\n            <div id="vehicleDimensions" class="panel-collapse collapse out">\n              <div class="panel-body">\n                <div class="row">\n                  <div class="form-group col-md-2 col-xs-2">\n                    <label for="vehicleType" class="control-label">Vehicle Type</label>\n                    <select id="vehicleType" name="vehicleType" class="form-control input-sm" ng-model="vm.routeCopy.options.vehicleType" ng-change="vm.vehicleTypeChanged()"\n                      ng-options="type.value as type.display for type in vm.optionsUI.vehicleType" ng-disabled="(!userInfo.isPremium())"\n                      required alkmaps-input></select>\n                  </div>\n                </div>\n\n                <div class="row">\n                  <div class="col-md-4 col-xs-4">\n                    <div class="row" ng-if="vm.routeCopy.options.trkUnits == \'0\'">\n                      <div class="form-group col-md-6 col-xs-6" ng-if="(vm.routeCopy.options.trkUnits === 0)?true:false" ng-class="{ \'has-error\': (routeOptionsForm.trkHeightFeet.$invalid && !routeOptionsForm.trkHeightFeet.$pristine)}">\n                        <label for="trkHeightFeet" class="control-label">Height</label>\n                        <div class="input-group">\n                          <input id="trkHeightFeet" name="trkHeightFeet" class="form-control input-sm" type="text" ng-model="vm.localOptions.heightFeet"\n                            ng-disabled="(!userInfo.isPremium() || vm.routeCopy.options.vehicleType === 2)" pcm-range pcm-range-min="{{vm.defaultDimensions.min.heightEnglish}}"\n                            pcm-range-max="{{vm.defaultDimensions.max.heightEnglish}}" pcm-integer alkmaps-input required\n                            ui-validate=" \'($value < vm.defaultDimensions.max.heightEnglish) || (($value == vm.defaultDimensions.max.heightEnglish) && (vm.localOptions.heightInches == 0))\' "\n                            ui-validate-watch=" \'vm.localOptions.heightInches\' " />\n                          <div class="glyphicon glyphicon-exclamation-sign error-glyph" ng-show="(routeOptionsForm.trkHeightFeet.$invalid && !routeOptionsForm.trkHeightFeet.$pristine)">\n                            <div class="error-tooltip bg-danger">\n                              <p ng-show="routeOptionsForm.trkHeightFeet.$error.required && !routeOptionsForm.trkHeightFeet.$pristine" class="help-block">Height (feet) is required.</p>\n                              <p ng-show="routeOptionsForm.trkHeightFeet.$error.pcmInteger && !routeOptionsForm.trkHeightFeet.$pristine" class="help-block">Height (feet) must be a whole number.</p>\n                              <p ng-show="routeOptionsForm.trkHeightFeet.$error.pcmRange && !routeOptionsForm.trkHeightFeet.$pristine" class="help-block">\n                                Height (feet) must be between {{vm.defaultDimensions.min.heightEnglish}} and {{vm.defaultDimensions.max.heightEnglish}} feet.\n                              </p>\n                              <p ng-show="routeOptionsForm.trkHeightFeet.$error.validator && !routeOptionsForm.trkHeightFeet.$pristine" class="help-block">\n                                Total height must be between {{vm.defaultDimensions.min.heightEnglish}}\'0" and {{vm.defaultDimensions.max.heightEnglish}}\'0".\n                              </p>\n                            </div>\n                          </div>\n                          <span class="input-group-addon">ft&nbsp;</span>\n                        </div>\n                      </div>\n                      <div class="form-group col-md-6 col-xs-6" ng-if="(vm.routeCopy.options.trkUnits === 0)?true:false" ng-class="{ \'has-error\': (routeOptionsForm.trkHeightInches.$invalid && !routeOptionsForm.trkHeightInches.$pristine)}">\n                        <label for="trkHeightInches" class="control-label">  &nbsp; </label>\n                        <div class="input-group">\n                          <input id="trkHeightInches" name="trkHeightInches" class="form-control input-sm" type="text" ng-model="vm.localOptions.heightInches"\n                            ng-disabled="(!userInfo.isPremium() || vm.routeCopy.options.vehicleType === 2)" pcm-range pcm-range-min="0"\n                            pcm-range-max="11" pcm-integer alkmaps-input required ui-validate=" \'(vm.localOptions.heightFeet < vm.defaultDimensions.max.heightEnglish) || ((vm.localOptions.heightFeet == vm.defaultDimensions.max.heightEnglish) && ($value == 0))\' "\n                            ui-validate-watch=" \'vm.localOptions.heightFeet\' " />\n                          <div class="glyphicon glyphicon-exclamation-sign error-glyph" ng-show="(routeOptionsForm.trkHeightInches.$invalid && !routeOptionsForm.trkHeightInches.$pristine)">\n                            <div class="error-tooltip bg-danger">\n                              <p ng-show="routeOptionsForm.trkHeightInches.$error.required && !routeOptionsForm.trkHeightInches.$pristine" class="help-block">Height (inches) is required.</p>\n                              <p ng-show="routeOptionsForm.trkHeightInches.$error.pcmInteger && !routeOptionsForm.trkHeightInches.$pristine" class="help-block">Height (inches) must be a whole number.</p>\n                              <p ng-show="routeOptionsForm.trkHeightInches.$error.pcmRange && !routeOptionsForm.trkHeightInches.$pristine" class="help-block">Height (inches) must be less than 12.</p>\n                              <p ng-show="routeOptionsForm.trkHeightInches.$error.validator && !routeOptionsForm.trkHeightInches.$pristine" class="help-block">\n                                Total height must be between {{vm.defaultDimensions.min.heightEnglish}}\'0" and {{vm.defaultDimensions.max.heightEnglish}}\'0".\n                              </p>\n                            </div>\n                          </div>\n                          <span class="input-group-addon">in&nbsp;</span>\n                        </div>\n                      </div>\n                    </div>\n                    <div class="form-group" ng-if="vm.routeCopy.options.trkUnits !== 0" ng-class="{ \'has-error\': (routeOptionsForm.trkHeightMeters.$invalid && !routeOptionsForm.trkHeightMeters.$pristine)}">\n                      <label for="trkHeightMeters" class="control-label">Height</label>\n                      <div class="input-group">\n                        <input id="trkHeightMeters" name="trkHeightMeters" class="form-control input-sm" type="text" ng-model="vm.localOptions.heightMeters"\n                          ng-disabled="(!userInfo.isPremium() || vm.routeCopy.options.vehicleType === 2)" pcm-range pcm-range-min="{{vm.defaultDimensions.min.heightMetric}}"\n                          pcm-range-max="{{vm.defaultDimensions.max.heightMetric}}" pcm-number alkmaps-input required />\n\n                        <div class="glyphicon glyphicon-exclamation-sign error-glyph" ng-show="(routeOptionsForm.trkHeightMeters.$invalid && !routeOptionsForm.trkHeightMeters.$pristine)">\n                          <div class="error-tooltip bg-danger">\n                            <p ng-show="routeOptionsForm.trkHeightMeters.$error.required" class="help-block">Height (meters) is required.</p>\n                            <p ng-show="routeOptionsForm.trkHeightMeters.$error.pcmNumber" class="help-block">Height (meters) must be a number.</p>\n                            <p ng-show="routeOptionsForm.trkHeightMeters.$error.pcmRange" class="help-block">\n                              Height (meters) must be between {{vm.defaultDimensions.min.heightMetric}} and {{vm.defaultDimensions.max.heightMetric}}.\n                            </p>\n                          </div>\n                        </div>\n                        <span class="input-group-addon">m&nbsp;</span>\n                      </div>\n                    </div>\n                  </div>\n\n                  <!--end of height-->\n                  <div class="col-md-4 col-xs-4">\n                    <div class="row" ng-if="vm.routeCopy.options.trkUnits == \'0\'">\n                      <div class="form-group col-md-6 col-xs-6" ng-class="{ \'has-error\': (routeOptionsForm.trkLengthFeet.$invalid && !routeOptionsForm.trkLengthFeet.$pristine)}">\n                        <label for="trkLengthFeet" class="control-label">Length</label>\n                        <div class="input-group">\n                          <input id="trkLengthFeet" name="trkLengthFeet" class="form-control input-sm" type="text" ng-model="vm.localOptions.lengthFeet"\n                            ng-disabled="(!userInfo.isPremium() || vm.routeCopy.options.vehicleType === 2)" pcm-range pcm-range-min="{{vm.defaultDimensions.min.lengthEnglish}}" ng-change="vm.updateClassOverrides()"\n                            pcm-range-max="{{vm.defaultDimensions.max.lengthEnglish}}" pcm-integer alkmaps-input required\n                            ui-validate=" \'($value < vm.defaultDimensions.max.lengthEnglish) || (($value == vm.defaultDimensions.max.lengthEnglish) && (vm.localOptions.lengthInches == 0))\' "\n                            ui-validate-watch=" \'vm.localOptions.lengthInches\' " />\n                          <div class="glyphicon glyphicon-exclamation-sign error-glyph" ng-show="(routeOptionsForm.trkLengthFeet.$invalid && !routeOptionsForm.trkLengthFeet.$pristine)">\n                            <div class="error-tooltip bg-danger">\n                              <p ng-show="routeOptionsForm.trkLengthFeet.$error.required && !routeOptionsForm.trkLengthFeet.$pristine" class="help-block">Length (feet) is required.</p>\n                              <p ng-show="routeOptionsForm.trkLengthFeet.$error.pcmInteger && !routeOptionsForm.trkLengthFeet.$pristine" class="help-block">Length (feet) must be a whole number.</p>\n                              <p ng-show="routeOptionsForm.trkLengthFeet.$error.pcmRange && !routeOptionsForm.trkLengthFeet.$pristine" class="help-block">\n                                Length (feet) must be between {{vm.defaultDimensions.min.lengthEnglish}} and {{vm.defaultDimensions.max.lengthEnglish}} feet.\n                              </p>\n                              <p ng-show="routeOptionsForm.trkLengthFeet.$error.validator && !routeOptionsForm.trkLengthFeet.$pristine" class="help-block">\n                                Total length must be between {{vm.defaultDimensions.min.lengthEnglish}}\'0" and {{vm.defaultDimensions.max.lengthEnglish}}\'0".\n                              </p>\n                            </div>\n                          </div>\n                          <span class="input-group-addon">ft&nbsp;</span>\n                        </div>\n                      </div>\n                      <div class="form-group col-md-6 col-xs-6" ng-class="{ \'has-error\': (routeOptionsForm.trkLengthInches.$invalid && !routeOptionsForm.trkLengthInches.$pristine)}">\n                        <label for="trkLengthInches" class="control-label"> &nbsp; </label>\n                        <div class="input-group">\n                          <input id="trkLengthInches" name="trkLengthInches" class="form-control input-sm" type="text" ng-model="vm.localOptions.lengthInches"\n                            ng-disabled="(!userInfo.isPremium() || vm.routeCopy.options.vehicleType === 2)" pcm-range pcm-range-min="0"\n                            pcm-range-max="11" pcm-integer alkmaps-input required ui-validate=" \'((vm.localOptions.lengthFeet < vm.defaultDimensions.max.lengthEnglish) || ((vm.localOptions.lengthFeet == vm.defaultDimensions.max.lengthEnglish) && ($value == 0)))\' "\n                            ui-validate-watch=" \'vm.localOptions.lengthFeet\' " />\n                          <div class="glyphicon glyphicon-exclamation-sign error-glyph" ng-show="(routeOptionsForm.trkLengthInches.$invalid && !routeOptionsForm.trkLengthInches.$pristine)">\n                            <div class="error-tooltip bg-danger">\n                              <p ng-show="routeOptionsForm.trkLengthInches.$error.required && !routeOptionsForm.trkLengthInches.$pristine" class="help-block">Length (inches) is required.</p>\n                              <p ng-show="routeOptionsForm.trkLengthInches.$error.pcmInteger && !routeOptionsForm.trkLengthInches.$pristine" class="help-block">Length (inches) must be a whole number.</p>\n                              <p ng-show="routeOptionsForm.trkLengthInches.$error.pcmRange && !routeOptionsForm.trkLengthInches.$pristine" class="help-block">Length (inches) must be less than 12.</p>\n                              <p ng-show="routeOptionsForm.trkLengthInches.$error.validator && !routeOptionsForm.trkLengthInches.$pristine" class="help-block">\n                                Total length must be between {{vm.defaultDimensions.min.lengthEnglish}}\'0" and {{vm.defaultDimensions.max.lengthEnglish}}\'0".\n                              </p>\n                            </div>\n                          </div>\n                          <span class="input-group-addon">in&nbsp;</span>\n                        </div>\n                      </div>\n                    </div>\n                    <div class="" ng-if="(vm.routeCopy.options.trkUnits === 0)?false:true">\n                      <div class="form-group" ng-class="{ \'has-error\': (routeOptionsForm.trkLengthMeters.$invalid && !routeOptionsForm.trkLengthMeters.$pristine)}">\n                        <label for="trkLengthMeters" class="control-label">Length</label>\n                        <div class="input-group">\n                          <input id="trkLengthMeters" name="trkLengthMeters" class="form-control input-sm" type="text" ng-model="vm.localOptions.lengthMeters"\n                            ng-disabled="(!userInfo.isPremium() || vm.routeCopy.options.vehicleType === 2)" pcm-range pcm-range-min="{{vm.defaultDimensions.min.lengthMetric}}"\n                            pcm-range-max="{{vm.defaultDimensions.max.lengthMetric}}" pcm-number alkmaps-input required />\n                          <div class="glyphicon glyphicon-exclamation-sign error-glyph" ng-show="(routeOptionsForm.trkLengthMeters.$invalid && !routeOptionsForm.trkLengthMeters.$pristine)">\n                            <div class="error-tooltip bg-danger">\n                              <p ng-show="routeOptionsForm.trkLengthMeters.$error.required && !routeOptionsForm.trkLengthMeters.$pristine" class="help-block">Length (meters) is required.</p>\n                              <p ng-show="routeOptionsForm.trkLengthMeters.$error.pcmNumber && !routeOptionsForm.trkLengthMeters.$pristine" class="help-block">Length (meters) must be a number.</p>\n                              <p ng-show="routeOptionsForm.trkLengthMeters.$error.pcmRange && !routeOptionsForm.trkLengthMeters.$pristine" class="help-block">\n                                Length (meters) must be between {{vm.defaultDimensions.min.lengthMetric}} and {{vm.defaultDimensions.max.lengthMetric}}.\n                              </p>\n                            </div>\n                          </div>\n                          <span class="input-group-addon">m &nbsp;</span>\n                        </div>\n                      </div>\n                    </div>\n                  </div>\n                  <!--end of length-->\n                  <div class="col-md-3 col-xs-4">\n                    <div class="form-group" ng-if="vm.routeCopy.options.trkUnits === 0" ng-class="{ \'has-error\': (routeOptionsForm.trkWidthEnglish.$invalid && !routeOptionsForm.trkWidthEnglish.$pristine)}">\n                      <label for="trkWidthEnglish" class="control-label">Width</label>\n                      <div class="input-group">\n                        <input id="trkWidthEnglish" name="trkWidthEnglish" class="form-control input-sm" type="text" ng-model="vm.localOptions.widthEnglish" ng-disabled="(!userInfo.isPremium() || vm.routeCopy.options.vehicleType === 2)" ng-change="vm.updateClassOverrides()"\n                          pcm-range pcm-range-min="{{vm.defaultDimensions.min.widthEnglish}}" pcm-range-max="{{vm.defaultDimensions.max.widthEnglish}}" pcm-number alkmaps-input required />\n                        <div class="glyphicon glyphicon-exclamation-sign error-glyph" ng-show="(routeOptionsForm.trkWidthEnglish.$invalid && !routeOptionsForm.trkWidthEnglish.$pristine)">\n                          <div class="error-tooltip bg-danger">\n                            <p ng-show="routeOptionsForm.trkWidthEnglish.$error.required && !routeOptionsForm.trkWidthEnglish.$pristine" class="help-block">Width (inches) is required.</p>\n                            <p ng-show="routeOptionsForm.trkWidthEnglish.$error.pcmNumber && !routeOptionsForm.trkWidthEnglish.$pristine" class="help-block">Width (inches) must be a number.</p>\n                            <p ng-show="routeOptionsForm.trkWidthEnglish.$error.pcmRange && !routeOptionsForm.trkWidthEnglish.$pristine" class="help-block">\n                              Width (inches) must be between {{vm.defaultDimensions.min.widthEnglish}} and {{vm.defaultDimensions.max.widthEnglish}}.\n                            </p>\n                          </div>\n                        </div>\n                        <span class="input-group-addon"> in &nbsp; </span>\n                      </div>\n                    </div>\n                    <div class="form-group" ng-if="vm.routeCopy.options.trkUnits !== 0" ng-class="{ \'has-error\': (routeOptionsForm.trkWeightKg.$invalid && !routeOptionsForm.trkWeightKg.$pristine)}">\n                      <label for="trkWidthMetric" class="control-label">Width</label>\n                      <div class="input-group">\n                        <input id="trkWidthMetric" name="trkWidthMetric" class="form-control input-sm" type="text" ng-model="vm.localOptions.widthMetric"\n                          ng-disabled="(!userInfo.isPremium() || vm.routeCopy.options.vehicleType === 2)" pcm-range pcm-range-min="{{vm.defaultDimensions.min.widthMetric}}"\n                          pcm-range-max="{{vm.defaultDimensions.max.widthMetric}}" pcm-number alkmaps-input required />\n                        <div class="glyphicon glyphicon-exclamation-sign error-glyph" ng-show="(routeOptionsForm.trkWidthMetric.$invalid && !routeOptionsForm.trkWidthMetric.$pristine)">\n                          <div class="error-tooltip bg-danger">\n                            <p ng-show="routeOptionsForm.trkWidthMetric.$error.required && !routeOptionsForm.trkWidthMetric.$pristine" class="help-block">Width (m) is required.</p>\n                            <p ng-show="routeOptionsForm.trkWidthMetric.$error.pcmNumber && !routeOptionsForm.trkWidthMetric.$pristine" class="help-block">Width (m) must be a number.</p>\n                            <p ng-show="routeOptionsForm.trkWidthMetric.$error.pcmRange && !routeOptionsForm.trkWidthMetric.$pristine" class="help-block">\n                              Width (m) must be between {{vm.defaultDimensions.min.widthMetric}} and {{vm.defaultDimensions.max.widthMetric}}.\n                            </p>\n                          </div>\n                          <p> </p>\n                        </div>\n                        <span class="input-group-addon"> m  &nbsp; </span>\n                      </div>\n                    </div>\n                  </div>\n                  <!-- end of width-->\n                </div>\n                <!--end of first row-->\n                <div class="row">\n                  <div class="form-group col-md-2 col-xs-2" ng-if="(vm.routeCopy.options.trkUnits === 0)?true:false" ng-class="{ \'has-error\': (routeOptionsForm.trkWeight.$invalid && !routeOptionsForm.trkWeight.$pristine)}">\n                    <label for="trkWeight" class="control-label">Weight</label>\n                    <div class="input-group">\n                      <input id="trkWeight" name="trkWeight" class="form-control input-sm" type="text" ng-model="vm.localOptions.weightPounds" ng-disabled="(!userInfo.isPremium() || vm.routeCopy.options.vehicleType === 2)"\n                        pcm-range pcm-range-min="{{vm.defaultDimensions.min.weightEnglish}}" pcm-range-max="{{vm.defaultDimensions.max.weightEnglish}}" pcm-number alkmaps-input required />\n                      <div class="glyphicon glyphicon-exclamation-sign error-glyph" ng-show="(routeOptionsForm.trkWeight.$invalid && !routeOptionsForm.trkWeight.$pristine)">\n                        <div class="error-tooltip bg-danger">\n                          <p ng-show="routeOptionsForm.trkWeight.$error.required && !routeOptionsForm.trkWeight.$pristine" class="help-block">Weight (lbs) is required.</p>\n                          <p ng-show="routeOptionsForm.trkWeight.$error.pcmNumber && !routeOptionsForm.trkWeight.$pristine" class="help-block">Weight (lbs) must be a number.</p>\n                          <p ng-show="routeOptionsForm.trkWeight.$error.pcmRange && !routeOptionsForm.trkWeight.$pristine" class="help-block">\n                            Weight (lbs) must be between {{vm.defaultDimensions.min.weightEnglish}} and {{vm.defaultDimensions.max.weightEnglish}}.\n                          </p>\n                        </div>\n                      </div>\n                      <span class="input-group-addon"> lbs</span>\n                    </div>\n                  </div>\n                  <div class="form-group col-md-2 col-xs-2" ng-if="(vm.routeCopy.options.trkUnits === 0)?false:true" ng-class="{ \'has-error\': (routeOptionsForm.trkWeightKg.$invalid && !routeOptionsForm.trkWeightKg.$pristine)}">\n                    <label for="trkWeightKg" class="control-label">Weight</label>\n                    <div class="input-group">\n                      <input id="trkWeightKg" name="trkWeightKg" class="form-control input-sm" type="text" ng-model="vm.localOptions.weightKilograms"\n                        ng-disabled="(!userInfo.isPremium() || vm.routeCopy.options.vehicleType === 2)" pcm-range pcm-range-min="{{vm.defaultDimensions.min.weightMetric}}"\n                        pcm-range-max="{{vm.defaultDimensions.max.weightMetric}}" pcm-number alkmaps-input required />\n                      <div class="glyphicon glyphicon-exclamation-sign error-glyph" ng-show="(routeOptionsForm.trkWeightKg.$invalid && !routeOptionsForm.trkWeightKg.$pristine)">\n                        <div class="error-tooltip bg-danger">\n                          <p ng-show="routeOptionsForm.trkWeightKg.$error.required && !routeOptionsForm.trkWeightKg.$pristine" class="help-block">Weight (kg) is required.</p>\n                          <p ng-show="routeOptionsForm.trkWeightKg.$error.pcmNumber && !routeOptionsForm.trkWeightKg.$pristine" class="help-block">Weight (kg) must be a number.</p>\n                          <p ng-show="routeOptionsForm.trkWeightKg.$error.pcmRange && !routeOptionsForm.trkWeightKg.$pristine" class="help-block">\n                            Weight (kg) must be between {{vm.defaultDimensions.min.weightMetric}} and {{vm.defaultDimensions.max.weightMetric}}.\n                          </p>\n                        </div>\n                        <p> </p>\n                      </div>\n                      <span class="input-group-addon">kg</span>\n                    </div>\n                  </div>\n                  <div class="form-group col-md-2 col-xs-2">\n                    <label for="trkAxles" class="control-label">Axles</label>\n                    <select id="trkAxles" name="trkAxles" class="form-control input-sm" ng-model="vm.routeCopy.options.trkAxles" ng-options="type.value as type.display for type in vm.optionsUI.trkAxles"\n                      ng-disabled="(!userInfo.isPremium() || vm.routeCopy.options.vehicleType === 2)" required alkmaps-input>\n                    </select>\n                  </div>\n                  <div class="form-group col-md-2 col-xs-2" ng-if="vm.region === \'EU\'">\n                    <!-- hide if !EU -->\n                    <label for="emiType" class="control-label">Emission Type</label>\n                    <select id="emiType" name="emiType" class="form-control input-sm" ng-model="vm.EUOptions.emiType" ng-disabled="(!userInfo.isPremium() || vm.routeCopy.options.vehicleType === 2)"\n                      ng-options="type.value as type.display for type in vm.optionsUI.emiType" required alkmaps-input>\n                    </select>\n                  </div>\n\n                  <div class="form-group col-md-2 col-xs-2 col-sm-6" ng-if="vm.region === \'EU\'">\n                    <!-- hide if !EU -->\n                    <div class="checkbox options">\n                      <label>\n                        <input type="checkbox" class= "control-input-sm" ng-model="vm.EUOptions.isHybrid" ng-disabled="(!userInfo.isPremium() || vm.routeCopy.options.vehicleType === 2)" alkmaps-input /> Hybrid Engine\n                      </label>\n                    </div>\n                  </div>\n\n                  <div class="form-group col-md-4 col-xs-4" ng-if="vm.region === \'EU\'">\n                    <!-- hide if !EU -->\n                    <div class="checkbox options">\n                      <label>\n                        <input type="checkbox" class= "control-input-sm" ng-model="vm.EUOptions.minPoll" ng-disabled="(!userInfo.isPremium() || vm.routeCopy.options.vehicleType === 2)" alkmaps-input /> Minimum Pollution Vehicle\n                      </label>\n                      <span class="ico ico-help help-question" tooltip-placement="right" uib-tooltip="Whether the vehicle is a minimum pollution vehicle."></span>\n                    </div>\n                  </div>\n                </div>\n\n                <div class="row">\n                  <div class="form-group col-md-6 col-xs-6" ng-if="vm.region != \'EU\'">\n                    <!-- hide if EU -->\n                    <div class="checkbox">\n                      <label>\n                        <input type="checkbox" class= "control-input-sm" ng-model="vm.routeCopy.options.trkLCV" ng-disabled="(!userInfo.isPremium() || vm.routeCopy.options.vehicleType === 2)" alkmaps-input /> Multiple Trailer (MT)\n                      </label>\n                      <span class="ico ico-help help-question" tooltip-placement="right" uib-tooltip="Check if vehicle is a long combination vehicle with multiple trailers. Only affects toll cost calculation, does not affect routing."></span>\n                    </div>\n                  </div>\n                  <div class="form-group col-md-6 col-xs-6" ng-if="vm.region === \'EU\'">\n                    <!-- hide if !EU -->\n                    <div class="checkbox">\n                      <label>\n                        <input type="checkbox" class= "control-input-sm" ng-model="vm.EUOptions.hasTrailer" ng-disabled="(!userInfo.isPremium() || vm.routeCopy.options.vehicleType === 2)" alkmaps-input /> Has Trailer?\n                      </label>\n                      <span class="ico ico-help help-question" tooltip-placement="right" uib-tooltip="Check if vehicle has a trailer. Only affect EU toll detail report, does not affect routing."></span>\n                    </div>\n                  </div>\n                </div>\n\n                <h6 class="trailer-settings" ng-if="vm.region == \'EU\'"><strong>Trailer Dimensions</strong></h6>\n                <!-- EU only options -->\n                <div class="row" ng-if="vm.region === \'EU\'">\n                  <!-- hide if !EU -->\n                  <div class="form-group col-md-2 col-xs-2">\n                    <label for="trlType " class="control-label">Type</label>\n                    <select id="trlType " name="trlType" ng-disabled="!vm.EUOptions.hasTrailer" class="form-control input-sm" ng-model="vm.EUOptions.trlType "\n                      ng-disabled="(!userInfo.isPremium() || vm.routeCopy.options.vehicleType === 2)" ng-options="type.value as type.display for type in vm.optionsUI.trlType"\n                      required alkmaps-input>\n                    </select>\n                  </div>\n                  <div class="form-group col-md-2 col-xs-2" ng-if="vm.region === \'EU\'" ng-disabled="!vm.EUOptions">\n                    <!-- hide if !EU -->\n                    <label for="trlMaxAxles" class="control-label">Axles</label>\n                    <select id="trlMaxAxles" name="trlMaxAxles" class="form-control input-sm" ng-disabled="!vm.EUOptions.hasTrailer" ng-model="vm.EUOptions.trlMaxAxles"\n                      ng-disabled="(!userInfo.isPremium() || vm.routeCopy.options.vehicleType === 2)" ng-options="type.value as type.display for type in vm.optionsUI.trlMaxAxles"\n                      required alkmaps-input>\n                    </select>\n                  </div>\n\n                  <div class="form-group col-md-3 col-xs-3 col-sm-3" ng-if="vm.routeCopy.options.trkUnits === 0 && vm.region === \'EU\'" ng-disabled="!vm.EUOptions.hasTrailer"\n                    ng-class="{ \'has-error\': (routeOptionsForm.trlMaxWt.$invalid && !routeOptionsForm.trlMaxWt.$pristine)}">\n                    <!-- hide if !EU -->\n                    <label for="trlMaxWt" class="control-label">Max Weight</label>\n                    <div class="input-group">\n                      <input id="trlMaxWt" name="trlMaxWt" class="form-control input-sm" type="text" ng-disabled="!vm.EUOptions.hasTrailer"\n                        ng-model="vm.localOptionsEU.weightPounds" ng-disabled="(!userInfo.isPremium() || vm.routeCopy.options.vehicleType === 2)"\n                        pcm-range pcm-range-min="{{vm.defaultDimensions.min.trlWeightEnglish}}" pcm-range-max="{{vm.defaultDimensions.max.trlWeightEnglish}}" pcm-integer alkmaps-input required />\n                      <div class="glyphicon glyphicon-exclamation-sign error-glyph" ng-show="(routeOptionsForm.trlMaxWt.$invalid && !routeOptionsForm.trlMaxWt.$pristine)">\n                        <div class="error-tooltip bg-danger">\n                          <p ng-show="routeOptionsForm.trlMaxWt.$error.required && !routeOptionsForm.trlMaxWt.$pristine" class="help-block">Weight (lbs) is required.</p>\n                          <p ng-show="routeOptionsForm.trlMaxWt.$error.pcmInteger && !routeOptionsForm.trlMaxWt.$pristine" class="help-block">Weight (lbs) must be a whole number.</p>\n                          <p ng-show="routeOptionsForm.trlMaxWt.$error.pcmRange && !routeOptionsForm.trlMaxWt.$pristine" class="help-block">\n                            Weight (lbs) must be between {{vm.defaultDimensions.min.trlWeightEnglish}} and {{vm.defaultDimensions.max.trlWeightEnglish}}.</p>\n                        </div>\n                      </div>\n                      <span class="input-group-addon">lbs</span>\n                    </div>\n                  </div>\n                  <div class="form-group col-md-3 col-xs-3 col-sm-3" ng-if="vm.routeCopy.options.trkUnits === 1 && vm.region === \'EU\'" ng-disabled="!vm.EUOptions.hasTrailer"\n                    ng-class="{ \'has-error\': (routeOptionsForm.trlMaxWtKg.$invalid && !routeOptionsForm.trlMaxWtKg.$pristine)}">\n                    <!-- hide if !EU -->\n                    <label for="trlMaxWtKg" class="control-label">Max Weight</label>\n                    <div class="input-group">\n                      <input id="trlMaxWtKg" name="trlMaxWtKg" class="form-control input-sm" type="text" ng-disabled="!vm.EUOptions.hasTrailer"\n                        ng-model="vm.localOptionsEU.weightKilograms" ng-disabled="(!userInfo.isPremium() || vm.routeCopy.options.vehicleType === 2)"\n                        pcm-range pcm-range-min="{{vm.defaultDimensions.min.trlWeightMetric}}" pcm-range-max="{{vm.defaultDimensions.max.trlWeightMetric}}" pcm-integer alkmaps-input required />\n                      <div class="glyphicon glyphicon-exclamation-sign error-glyph" ng-show="(routeOptionsForm.trlMaxWtKg.$invalid && !routeOptionsForm.trlMaxWtKg.$pristine)">\n                        <div class="error-tooltip bg-danger">\n                          <p ng-show="routeOptionsForm.trlMaxWtKg.$error.required && !routeOptionsForm.trlMaxWtKg.$pristine" class="help-block">Weight (lbs) is required.</p>\n                          <p ng-show="routeOptionsForm.trlMaxWtKg.$error.pcmInteger && !routeOptionsForm.trlMaxWtKg.$pristine" class="help-block">Weight (lbs) must be a whole number.</p>\n                          <p ng-show="routeOptionsForm.trlMaxWtKg.$error.pcmRange && !routeOptionsForm.trlMaxWtKg.$pristine" class="help-block">\n                            Weight (kg) must be between {{vm.defaultDimensions.min.trlWeightMetric}} and {{vm.defaultDimensions.max.trlWeightMetric}}.</p>\n                        </div>\n                      </div>\n                      <span class="input-group-addon">kg</span>\n                    </div>\n                  </div>\n\n                  <!-- START of trailer height -->\n                  <div class="col-md-3 col-xs-3 col-sm-3" ng-if="vm.region === \'EU\'">\n                    <!-- hide if !EU -->\n                    <div class="row" ng-if="vm.routeCopy.options.trkUnits == \'0\'">\n                      <div class="form-group col-md-6 col-xs-6" ng-if="(vm.routeCopy.options.trkUnits === 0)?true:false" ng-class="{ \'has-error\': (routeOptionsForm.trlMaxHtFeet.$invalid && !routeOptionsForm.trlMaxHtFeet.$pristine)}">\n                        <label for="trlMaxHtFeet" class="control-label"> Max Height</label>\n                        <div class="input-group">\n                          <input id="trlMaxHtFeet" name="trlMaxHtFeet" class="form-control input-sm" type="text" ng-disabled="!vm.EUOptions.hasTrailer"\n                            ng-model="vm.localOptionsEU.heightFeet" ng-disabled="(!userInfo.isPremium() || vm.routeCopy.options.vehicleType === 2)"\n                            pcm-range pcm-range-min="{{vm.defaultDimensions.min.trlHeightEnglish}}" pcm-range-max="{{vm.defaultDimensions.max.trlHeightEnglish}}" pcm-integer alkmaps-input required ui-validate=" \'(($value < vm.defaultDimensions.max.trlHeightEnglish)|| (($value == vm.defaultDimensions.max.trlHeightEnglish) && (vm.localOptionsEU.heightInches <= 0)))\' "\n                            ui-validate-watch=" \'vm.localOptionsEU.heightInches\' " />\n                          <div class="glyphicon glyphicon-exclamation-sign error-glyph" ng-show="(routeOptionsForm.trlMaxHtFeet.$invalid && !routeOptionsForm.trlMaxHtFeet.$pristine)">\n                            <div class="error-tooltip bg-danger">\n                              <p ng-show="routeOptionsForm.trlMaxHtFeet.$error.required && !routeOptionsForm.trlMaxHtFeet.$pristine" class="help-block">Height (feet) is required.</p>\n                              <p ng-show="routeOptionsForm.trlMaxHtFeet.$error.pcmInteger && !routeOptionsForm.trlMaxHtFeet.$pristine" class="help-block">Height (feet) must be a whole number.</p>\n                              <p ng-show="routeOptionsForm.trlMaxHtFeet.$error.pcmRange && !routeOptionsForm.trlMaxHtFeet.$pristine" class="help-block">\n                                Height (feet) must be between {{vm.defaultDimensions.min.trlHeightEnglish}} and {{vm.defaultDimensions.max.trlHeightEnglish}} feet.\n                              </p>\n                              <p ng-show="routeOptionsForm.trlMaxHtFeet.$error.validator && !routeOptionsForm.trlMaxHtFeet.$pristine" class="help-block">\n                                Total height must be between {{vm.defaultDimensions.min.trlHeightEnglish}}\' and {{vm.defaultDimensions.max.trlHeightEnglish}}\'0".\n                              </p>\n                            </div>\n                          </div>\n                          <span class="input-group-addon">ft&nbsp;</span>\n                        </div>\n                      </div>\n                      <div class="form-group col-md-6 col-xs-6" ng-if="(vm.routeCopy.options.trkUnits === 0)?true:false" ng-class="{ \'has-error\': (routeOptionsForm.trlMaxHtInches.$invalid && !routeOptionsForm.trlMaxHtInches.$pristine)}">\n                        <label for="trlMaxHtInches" class="control-label">  &nbsp; </label>\n                        <div class="input-group">\n                          <input id="trlMaxHtInches" name="trlMaxHtInches" class="form-control input-sm" type="text" ng-model="vm.localOptionsEU.heightInches"\n                            ng-disabled="!vm.EUOptions.hasTrailer" ng-disabled="(!userInfo.isPremium() || vm.routeCopy.options.vehicleType === 2)"\n                            pcm-range pcm-range-min="0" pcm-range-max="11" pcm-integer alkmaps-input required ui-validate=" \'((vm.localOptionsEU.heightFeet < vm.defaultDimensions.max.trlHeightEnglish) || ((vm.localOptionsEU.heightFeet == vm.defaultDimensions.max.trlHeightEnglish) && ($value <= 0)))\' "\n                            ui-validate-watch=" \'vm.localOptionsEU.heightFeet\' " />\n                          <div class="glyphicon glyphicon-exclamation-sign error-glyph" ng-show="(routeOptionsForm.trlMaxHtInches.$invalid && !routeOptionsForm.trlMaxHtInches.$pristine)">\n                            <div class="error-tooltip bg-danger">\n                              <p ng-show="routeOptionsForm.trlMaxHtInches.$error.required && !routeOptionsForm.trlMaxHtInches.$pristine" class="help-block">Height (inches) is required.</p>\n                              <p ng-show="routeOptionsForm.trlMaxHtInches.$error.pcmInteger && !routeOptionsForm.trlMaxHtInches.$pristine" class="help-block">Height (inches) must be a number.</p>\n                              <p ng-show="routeOptionsForm.trlMaxHtInches.$error.pcmRange && !routeOptionsForm.trlMaxHtInches.$pristine" class="help-block">\n                                Height (inches) must be less than 12.\n                              </p>\n                              <p ng-show="routeOptionsForm.trlMaxHtInches.$error.validator && !routeOptionsForm.trlMaxHtInches.$pristine" class="help-block">\n                                Total height must be between {{vm.defaultDimensions.min.trlHeightEnglish}}\' and {{vm.defaultDimensions.max.trlHeightEnglish}}\'0".\n                              </p>\n                            </div>\n                          </div>\n                          <span class="input-group-addon">in.&nbsp;</span>\n                        </div>\n                      </div>\n                    </div>\n                    <div class="form-group" ng-if="vm.routeCopy.options.trkUnits !== 0 && vm.region === \'EU\'" ng-class="{ \'has-error\': (routeOptionsForm.trlMaxHtMeters.$invalid && !routeOptionsForm.trlMaxHtMeters.$pristine)}">\n                      <!-- hide if !EU -->\n                      <label for="trlMaxHtMeters" class="control-label">Max Height</label>\n                      <div class="input-group">\n                        <input id="trlMaxHtMeters" name="trlMaxHtMeters " class="form-control input-sm" type="text" ng-disabled="!vm.EUOptions.hasTrailer"\n                          ng-model="vm.localOptionsEU.heightMeters" ng-disabled="(!userInfo.isPremium() || vm.routeCopy.options.vehicleType === 2)"\n                          pcm-range pcm-range-min="{{vm.defaultDimensions.min.trlHeightMetric}}" pcm-range-max="{{vm.defaultDimensions.max.trlHeightMetric}}" pcm-number alkmaps-input required ui-validate=" \'$value >=0\' "\n                          ui-validate-watch=" \'vm.localOptionsEU.heightFeet \' " />\n\n                        <div class="glyphicon glyphicon-exclamation-sign error-glyph" ng-show="(routeOptionsForm.trlMaxHtMeters.$invalid && !routeOptionsForm.trlMaxHtMeters.$pristine)">\n                          <div class="error-tooltip bg-danger">\n                            <p ng-show="routeOptionsForm.trlMaxHtMeters.$error.required" class="help-block">Height (meters) is required.</p>\n                            <p ng-show="routeOptionsForm.trlMaxHtMeters.$error.pcmNumber" class="help-block">Height (meters) must be a number.</p>\n                            <p ng-show="routeOptionsForm.trlMaxHtMeters.$error.pcmRange" class="help-block">\n                              Height (meters) must be between {{vm.defaultDimensions.min.trlHeightMetric}} and {{vm.defaultDimensions.max.trlHeightMetric}}.</p>\n                          </div>\n                        </div>\n                        <span class="input-group-addon">m &nbsp;</span>\n                      </div>\n                    </div>\n                  </div>\n                  <!-- END of trailer height -->\n\n                  <div class="form-group col-md-2 col-xs-2" ng-if="vm.region === \'EU\'" ng-class="{ \'has-error\': (routeOptionsForm.trlCount.$invalid && !routeOptionsForm.trlCount.$pristine)}">\n                    <!-- hide if !EU -->\n                    <label for="trlCount" class="control-label">Trailer Count</label>\n                    <div class="input-group">\n                      <input id="trlCount" name="trlCount" class="form-control input-sm" type="text" ng-model="vm.EUOptions.trlCount" ng-disabled="!vm.EUOptions.hasTrailer"\n                        ng-disabled="(!userInfo.isPremium() || vm.routeCopy.options.vehicleType === 2)" pcm-range pcm-range-min="0"\n                        pcm-range-max="100" pcm-number alkmaps-input required />\n                      <div class="glyphicon glyphicon-exclamation-sign error-glyph" ng-show="(routeOptionsForm.trlCount.$invalid && !routeOptionsForm.trlCount.$pristine)">\n                        <div class="error-tooltip bg-danger">\n                          <p ng-show="routeOptionsForm.trlCount.$error.required && !routeOptionsForm.trlCount.$pristine" class="help-block">Trailer count is required.</p>\n                          <p ng-show="routeOptionsForm.trlCount.$error.pcmInteger && !routeOptionsForm.trlCount.$pristine" class="help-block">Trailer count must be a whole number.</p>\n                          <p ng-show="routeOptionsForm.trlCount.$error.pcmRange && !routeOptionsForm.trlCount.$pristine" class="help-block">Trailer count must be no less than 0.</p>\n                        </div>\n                      </div>\n                    </div>\n                  </div>\n                  <!-- end of EU tolls -->\n                </div>\n\n                <h6 class="eu-emissions" ng-if="vm.region == \'EU\'"><strong>Europe Emissions</strong></h6>\n                <div class="row" ng-if="vm.region === \'EU\'">\n                  <!-- hide if !EU -->\n                  <div class="form-group col-md-2 col-xs-2">\n                    <label for="fuelType" class="control-label">Fuel Type</label>\n                    <select id="fuelType" name="fuelType" class="form-control input-sm" ng-model="vm.EUOptions.fuelType"\n                      ng-disabled="(!userInfo.isPremium())" ng-options="type.value as type.display for type in vm.optionsUI.fuelType"\n                      required alkmaps-input>\n                    </select>\n                  </div>\n\n                  <div class="form-group col-md-2 col-xs-2" ng-if="vm.region === \'EU\'">\n                    <!-- hide if !EU -->\n                    <div class="checkbox options">\n                      <label>\n                        <input type="checkbox" class= "control-input-sm" ng-model="vm.EUOptions.refrigerated" ng-disabled="!userInfo.isPremium()" alkmaps-input /> refrigerated truck?\n                      </label>\n                    </div>\n                  </div>\n\n                  <div class="form-group col-md-2 col-xs-2" ng-if="vm.region === \'EU\'" ng-class="{ \'has-error\': (routeOptionsForm.fuelConsumption.$invalid && !routeOptionsForm.fuelConsumption.$pristine)}">\n                    <!-- hide if !EU -->\n                    <label for="trlCount" class="control-label">Fuel Consumption (Average Value)</label>\n                    <div class="input-group">\n                      <input id="fuelConsumption" name="fuelConsumption" class="form-control input-sm" type="text" ng-model="vm.EUOptions.fuelConsumption"\n                        ng-disabled="!userInfo.isPremium()" pcm-range pcm-range-min="0" pcm-range-max="100"\n                        pcm-range-max="100" pcm-number alkmaps-input required />\n                      <div class="glyphicon glyphicon-exclamation-sign error-glyph" ng-show="(routeOptionsForm.fuelConsumption.$invalid && !routeOptionsForm.fuelConsumption.$pristine)">\n                        <div class="error-tooltip bg-danger">\n                          <p ng-show="routeOptionsForm.fuelConsumption.$error.required && !routeOptionsForm.fuelConsumption.$pristine" class="help-block">Fuel Consumption is required.</p>\n                          <p ng-show="routeOptionsForm.fuelConsumption.$error.pcmRange && !routeOptionsForm.fuelConsumption.$pristine" class="help-block">Fuel Consumption must be 0 to 100.</p>\n                        </div>\n                      </div>\n                    </div>\n                  </div>\n                </div><!-- End of Europe Emissions -->\n              </div>\n            </div>\n          </div><!--end of vehicle dimensions-->\n\n          <div class="panel panel-default" ng-hide="vm.region === \'EU\'">\n            <a data-toggle="collapse" data-parent="#accordion" data-target="#repPref">\n              <div class="panel-heading" ng-model="vm.expandReporting" ng-click="vm.expandReporting = !vm.expandReporting; vm.expandExceptions = false; vm.expandVehicle = false; vm.expandRouting= false; vm.expandArrDep = false"\n                ng-class="{\'closed\':!vm.expandReporting}">\n                <h4 class="panel-title">\n\n                  <label ng-class="{ \'premium-feature-heading\': (!userInfo.isPremium()) }"> Reporting Preferences\n                  </label>\n                  <div class="expand-container pull-right">\n                    <div class="expand-button" ng-class="{\'open\':vm.expandReporting}"></div>\n                  </div>\n\n                </h4>\n              </div>\n            </a>\n            <div id="repPref" class="panel-collapse collapse">\n              <div class="panel-body">\n                <div class="row">\n                  <div class="col-md-4 col-xs-4" ng-if="vm.region !== \'EU\'">\n                    <div class="form-group">\n                      <label for="dataVersion" class="control-label"><h6><strong> Report Data Version</strong></h6></label>\n                      <select id="dataVersion" name="dataVersion" class="form-control input-sm" ng-model="vm.routeCopy.options.dataVersion" ng-options="type.value as type.display for type in vm.optionsUI.reportDataVersion"\n                        ng-disabled="(!userInfo.isPremium())" required alkmaps-input ng-if="vm.region !== \'EU\'"></select>\n                      <input id="dataVersion" name="dataVersion" class="form-control input-sm" ng-model="vm.routeCopy.options.dataVersion" ng-disabled="true"\n                        required alkmaps-input ng-if="vm.region === \'EU\' && false">\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n\n          <!--end of reporting-->\n\n          <div class="panel panel-default" ng-hide="vm.isDefault">\n            <a data-toggle="collapse" data-parent="#accordion" data-target="#arrivalDeparture">\n              <div class="panel-heading" ng-model="vm.expandArrDep" ng-click="vm.expandArrDep = !vm.expandArrDep; vm.expandExceptions = false; vm.expandVehicle = false; vm.expandRouting= false; vm.expandReporting=false;"\n                ng-class="{\'closed\':!vm.expandArrDep}">\n                <h4 class="panel-title">\n\n                  <label ng-class="{ \'premium-feature-heading\': (!userInfo.isPremium()) }">Arrival & Departure </label>\n                  <span class="has-error" ng-show="((routeOptionsForm.fuelCostUnit.$invalid && !routeOptionsForm.fuelCostUnit.$pristine)\n                    || (routeOptionsForm.greenhouseGases.$invalid && !routeOptionsForm.greenhouseGases.$pristine)\n                    || (routeOptionsForm.mpgLoaded.$invalid && !routeOptionsForm.mpgLoaded.$pristine)\n                    || (routeOptionsForm.mpgEmpty.$invalid && !routeOptionsForm.mpgEmpty.$pristine)\n                    || (routeOptionsForm.otherLoaded.$invalid && !routeOptionsForm.otherLoaded.$pristine)\n                    || (routeOptionsForm.otherEmpty.$invalid && !routeOptionsForm.otherEmpty.$pristine)\n                    || (routeOptionsForm.laborLoaded.$invalid && !routeOptionsForm.laborLoaded.$pristine)\n                    || (routeOptionsForm.laborEmpty.$invalid && !routeOptionsForm.laborEmpty.$pristine))">\n                    <i class="glyphicon glyphicon-exclamation-sign"></i>\n                  </span>\n                  <div class="expand-container pull-right">\n                    <div class="expand-button" ng-class="{\'open\':vm.expandArrDep}"></div>\n                  </div>\n\n                </h4>\n              </div>\n            </a>\n            <div id="arrivalDeparture" class="panel-collapse collapse">\n              <div class="panel-body">\n                <div>\n                  <!-- vm.isDefault is true, returning true -->\n                  <span ng-hide="(subscriptionLevel== \'Premium\')" ng-cloak class="ng-cloak"></span>\n                  <div class="row" ng-click="route.updateRoutingSelection($index)">\n                    <div class="col-md-3 col-xs-3">\n                      <label for="timeTypeOpt" class="control-label routing-center" ng-disabled="(!userInfo.isPremium())">Arrival/Departure</label>\n                      <select id="timeTypeOpt" name="timeValue" ng-value="opts.value" class="form-control input-sm" ng-model="vm.routeCopy.uiArrDepSelection.type"\n                        ng-disabled="(!userInfo.isPremium())" ng-change="route.updateRoutingSelection($index); vm.depTypeChanged()"\n                        alk-analytics="[\'Routing\',\'Route\',\'Route Type\']" ng-options="type.value as type.display for type in vm.optionsUI.arrDepTypes"\n                        alkmaps-input></select>\n                    </div>\n                    <div class="col-md-3 col-md-offset-1 col-xs-3 col-xs-offset-1 " ng-hide="vm.routeCopy.uiArrDepSelection.type === \'None\'">\n                      <div><label> Day/Date </label>\n                        <div>\n                          <div class="bottom-space">\n                            <select name="timeValue" class="form-control input-sm" ng-change="vm.routeCopy.updateArrDepSelection()" ng-model="vm.routeCopy.uiArrDepSelection.datetype"\n                              ng-options="type.value as type.display for type in vm.optionsUI.daydatetype" ng-disabled="vm.routeCopy.uiArrDepSelection.type === \'now\'"\n                              alkmaps-input></select> </div>\n                          <div>\n                            <div class=\'input-group input-group-sm date ng-cloak\' date-time-picker="date" ng-cloak ng-show="vm.routeCopy.uiArrDepSelection.datetype === \'date\'">\n                              <input type=\'text\' name="timeValue" class=\'form-control input-sm \' ng-class="{\'readOnly-input\':vm.routeCopy.uiArrDepSelection.type !== \'now\'}"\n                                readonly ng-change="vm.routeCopy.applyArrDep()" ng-model="vm.routeCopy.uiArrDepSelection.date" ng-disabled="vm.routeCopy.uiArrDepSelection.type === \'now\'"\n                                alkmaps-input><span class=\'input-group-addon\' ng-hide="vm.routeCopy.uiArrDepSelection.type===\'now\'"><i class=\'glyphicon\'></i></span>\n                            </div>\n                            <div class="ng-cloak" ng-cloak ng-show="(vm.routeCopy.uiArrDepSelection.datetype === \'weekday\')">\n                              <select class="form-control input-sm" ng-change="vm.routeCopy.applyArrDep()" ng-model="vm.routeCopy.uiArrDepSelection.weekday"\n                                ng-disabled="vm.routeCopy.uiArrDepSelection.type === \'now\'" alkmaps-input>\n                                <option> Sunday</option>\n                                <option>Monday</option>\n                                <option>Tuesday</option>\n                                <option>Wednesday</option>\n                                <option>Thursday</option>\n                                <option>Friday</option>\n                                <option>Saturday</option>\n                              </select>\n                            </div>\n                          </div>\n                        </div>\n                      </div>\n                      <div><label> Time of the day</label>\n                        <div class=\'input-group input-group-sm date\' date-time-picker="time">\n                          <input type=\'text\' class=\'form-control input-sm\' ng-class="{\'readOnly-input\':vm.routeCopy.uiArrDepSelection.type !== \'now\'}"\n                            readonly ng-change="route.applyArrDep()" ng-model="vm.routeCopy.uiArrDepSelection.time" ng-disabled="vm.routeCopy.uiArrDepSelection.type === \'now\'"\n                            alkmaps-input>\n                          <span class=\'input-group-addon\' ng-hide="vm.routeCopy.uiArrDepSelection.type===\'now\'"> <i class=\'glyphicon\'></i></span>\n                        </div>\n                      </div>\n                    </div>\n                    <div class="col-md-3 col-md-offset-1 col-xs-3 col-xs-offset-1">\n                      <label for="traffic-toggle" ng-disabled="(!userInfo.isPremium())">Travel Speeds</label>\n                      <select id="traffic-toggle" name="routeTrafficToggle" ng-disabled="true" class="form-control input-sm" ng-model="vm.routeCopy.options.useTraffic"\n                        ng-disabled="!userInfo.isPremium()" ng-change="runRoute(route)" ng-options="type.value as type.display for type in vm.optionsUI.travelSpeeds"\n                        alkmaps-input></select>\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n\n           <!--end of ArrDep-->\n\n        </div>\n\n      </div>\n\n      <label class="pull-right">Additional options are available in <a ng-click="vm.goToApplicationSettings()"> Application Settings </a> </label>\n\n      </form>\n\n      <div ng-show="(vm.subscriptionLevel !== \'Premium\')" class="premium-help-text">\n        <i class="glyphicon glyphicon-certificate" style="color: #E29A00;"></i> Available to Premium Subscribers only\n        </div>\n      </div>\n</div>\n\n\n<div class="modal-footer">\n  <div class="alert alert-success text-left ng-hide ng-cloak fadeInOut" role="alert" ng-cloak ng-show="vm.isAlertShowing">\n    Options have been saved as Default Options.\n  </div>\n  <div class="pull-left">\n    <button class="btn btn-sm btn-link" ng-click="vm.resetToDefaults()" ng-if="(vm.isDefault)">\n            Reset to System Defaults\n        </button>\n    <button class="btn btn-sm btn-link" ng-click="vm.saveAsDefaults()" ng-disabled="routeOptionsForm.$invalid" ng-if="(!vm.isDefault)">\n            Save as Default Options\n        </button>\n  </div>\n  <button class="btn btn-default" ng-click="vm.close()">Cancel</button>\n  <button class="btn btn-primary" ng-click="vm.ok()" ng-disabled="routeOptionsForm.$invalid">\n        OK\n        <span class="has-error" ng-if="routeOptionsForm.$invalid">\n            &nbsp;\n            <i class="glyphicon glyphicon-exclamation-sign"></i>\n        </span>\n    </button>\n</div>\n');
  $templateCache.put('/app/route/routeDialogLocation.template.html', '<span title="{{location.Address | fullAddressFilter:false}}">\n  <span ng-if="location.PlaceNameID">\n    <strong>{{location.PlaceNameID}}</strong>\n    -\n  </span>\n  <span ng-bind-html="location.Address | fullAddressFilter:true"></span>\n</span>\n');
  $templateCache.put('/app/route/routePanel.template.html', '<!-- Overall Routing Panel -->\n<div class="ui-panel left-panel" ng-style="{\'width\': \'500px\'}">\n  <div class="panel panel-default panel-fixed ng-cloak slide-container slideInRight" ng-cloak>\n    <!-- Main panel header -->\n    <div class="panel-heading">\n      <div class="no-button"></div>\n      <h4 class="panel-name text-center">\n        <span class="panel-name-text">Routes</span>\n      </h4>\n      <div class="no-button"></div>\n    </div>\n    <!-- Main panel body-->\n    <div class="panel-body v-flex-container">\n      <!-- Route List (flexes) -->\n      <div id="route-panel" class="item-list-container list-flex v-flex-container" ng-controller="routeController as routeVm">\n        <!-- repating Route item (flex-shrink only) -->\n        <div class="route-item flex-shrink-container itemAddDelete" ng-repeat="route in routeVm.routes" ng-class="{\'selected\':route.isSelectedRoute}">\n          <!-- Route item header (always visible) -->\n          <div class="route-item-fixed-section route-item-heading" ng-class="[(route.isOpen)?\'open\':\'closed\']">\n            <div class="route-item-header" ng-style="{\'border-color\':(route.isSelectedRoute)?route.uicolor:(route.uicolor | hexToRGBa : 0.4)}"\n              ng-click="routeVm.selectRoute(route)" alk-analytics="[\'Routing\',\'Route\',\'Select\']">\n              <div class="flex-group">\n                <div class="route-name flex-element"><i class="" ng-class="(!route.isOpen)?\'ico-rotate-180\':\'ico-rotate-0\'"></i>{{route.name}}</div>\n\n                <div class="route-info">\n                  <span class="ng-cloak" ng-show="route.isValidRoute() && !route.isOpen" ng-cloak>\n                    <span ng-if="routeVm.region !== \'EU\'"> ${{route.routeTCost}} | </span> {{route.routeTMiles | number:1}}\n                    {{(route.options.distanceUnits === 0)? \'mi\' : \'km\'}} | {{route.routeTHours}} hrs\n                  </span>\n                  <span class="ng-cloak" ng-show="!route.isValidRoute() && !route.isOpen" ng-cloak>(No route\n                    calculated)</span>\n                </div>\n                <div class="route-controls hidden-print">\n                  <button class="btn btn-xs btn-default btn-icon-only" ng-click="routeVm.frameRoute(route); $event.preventDefault(); $event.stopPropagation();"\n                    ng-disabled="!route.isValidRoute()" uib-tooltip="Zoom to Route" tooltip-placement="bottom">\n                    <i class="ico ico-frame-box"></i>\n                  </button>\n                  <switch class="route-toggle-switch" ng-click="routeVm.toggleRouteVisibility(route); $event.preventDefault(); $event.stopPropagation();"\n                    ng-model="route.isVisible" title="{{(route.isVisible)?\'Hide Route\':\'Show Route\'}}" ng-style="{\'margin\': \'5px 5px 0 0\', \'background-color\': (route.isVisible)?(route.uicolor | hexToRGBa : 0.7):\'\', \'border-top-color\': (route.isVisible)?route.uicolor:\'\', \'border-left-color\': (route.isVisible)?route.uicolor:\'\'}"\n                    alk-analytics="[\'Routing\',\'Route\',\'{{(route.isVisible)?\'Show\':\'Hide\'}}\']">\n                  </switch>\n                </div>\n              </div>\n              <div class="route-head-options ng-cloak" ng-show="route.isOpen" ng-cloak title="{{route | optionSummaryFilter}}">{{route\n                | optionSummaryFilter}}</div>\n            </div>\n            <!-- Route Options-->\n            <div class="route-options ng-cloak" ng-cloak ng-style="{\'border-left-color\':route.uicolor}" ng-show="route.isOpen && !routeVm.isRouteSyncPanelVisible">\n              <!-- Routing type-->\n              <div class="btn-group" uib-dropdown>\n                <button type="button" class="btn btn-default btn-xs dropdown-toggle" uib-dropdown-toggle>\n                  {{routeVm.uiRoutingOpt[route.options.routingType]}}&nbsp;<span class="caret"></span>\n                </button>\n                <ul class="dropdown-menu" role="menu">\n                  <li ng-repeat="option in routeVm.uiRoutingOpt"><button class="btn btn-link btn-xs btn-menu" ng-click="route.updateRoutingSelection($index)"\n                      alk-analytics="[\'Routing\',\'Route\',\'Route Type\']">{{option}}</button></li>\n                </ul>\n              </div>\n              <!-- Arrive/Depart -->\n              <div class="btn-group" uib-dropdown is-open="arrDep">\n                <button type="button" class="btn btn-default btn-xs dropdown-toggle" uib-dropdown-toggle alk-analytics="[\'Routing\',\'Route\',\'Time Options\']">\n                  Arrival/Departure <span class="caret"></span>\n                </button>\n                <ul class="dropdown-menu arrDepPanel" role="menu" ng-click="$event.stopPropagation()">\n                  <span ng-hide="userInfo.isPremium()" ng-cloak class="ng-cloak"><span class="premium-feature-note">Premium\n                      only</span></span>\n                  <li>\n                    <span class="traffic-option">\n                      <input id="route-traffic-toggle" name="route-traffic-toggle" type="checkbox" ng-model="route.options.useTraffic"\n                        ng-disabled="!userInfo.isPremium() || route.uiArrDepSelection.type === \'None\'" ng-change="routeVm.changeTraffic(route)" />\n                      <label for="route-traffic-toggle" ng-disabled="!userInfo.isPremium() || route.uiArrDepSelection.type === \'None\'">Use\n                        Traffic</label>\n                      <span ng-show="!userInfo.isPremium()" class="premium-feature-note" tooltip-placement="right"\n                        uib-tooltip="Premium Only"></span>\n                    </span>\n                  <li class="divider"></li>\n                  </li>\n                  <li>\n                  <form>\n                    <div class="radio" ng-repeat="opts in routeVm.optionsUI.arrDepTypes">\n                      <label>\n                        <input type="radio" name="timeType" ng-value="opts.value" ng-model="route.uiArrDepSelection.type"\n                          checked alkmaps-input ng-disabled="!userInfo.isPremium()" ng-change="routeVm.watchTraffic(route); route.applyArrDep();">\n                        {{opts.display}}\n                      </label>\n                    </div>\n                  </form>\n                  </li>\n                  <li class="divider ng-cloak" ng-cloak ng-show="route.uiArrDepSelection.type !== \'None\' && route.uiArrDepSelection.type !== \'now\'"></li>\n                  <li class="ng-cloak" ng-cloak ng-show="route.uiArrDepSelection.type !== \'None\' && route.uiArrDepSelection.type !== \'now\'">\n                  <form>\n                    <div class="radio">\n                      <label>\n                        <input type="radio" name="timeValue" ng-disabled="route.uiArrDepSelection.type === \'None\'"\n                          ng-change="route.applyArrDep()" ng-model="route.uiArrDepSelection.datetype" value="date"\n                          checked alkmaps-input>\n                        Specific Date &amp; Time\n                      </label>\n                      <div class=\'input-group input-group-sm date ng-cloak\' date-time-picker="date" ng-cloak ng-show="route.uiArrDepSelection.datetype === \'date\'">\n                        <input type=\'text\' class=\'form-control input-sm readOnly-input\' readonly ng-change="route.applyArrDep()"\n                          ng-model="route.uiArrDepSelection.date" alkmaps-input><span class=\'input-group-addon\' style="line-height:1;height:initial"><i\n                            class=\'glyphicon\'></i></span>\n                      </div>\n                    </div>\n                  </form>\n                  <form>\n                    <div class="radio">\n                      <label>\n                        <input type="radio" name="timeValue" ng-disabled="route.uiArrDepSelection.type === \'None\'"\n                          ng-change="route.applyArrDep()" ng-model="route.uiArrDepSelection.datetype" value="weekday"\n                          alkmaps-input>\n                        Day of the Week &amp; Time\n                      </label>\n                      <select class="form-control input-sm ng-cloak no-trans" ng-cloak ng-show="route.uiArrDepSelection.datetype === \'weekday\'"\n                        ng-change="route.applyArrDep()" ng-model="route.uiArrDepSelection.weekday" alkmaps-input style="height:26px">\n                        <option>Sunday</option>\n                        <option>Monday</option>\n                        <option>Tuesday</option>\n                        <option>Wednesday</option>\n                        <option>Thursday</option>\n                        <option>Friday</option>\n                        <option>Saturday</option>\n                      </select>\n                    </div>\n                  </form>\n                  </li>\n                  <li class="ng-cloak" ng-cloak ng-show="route.uiArrDepSelection.type !== \'None\'  && route.uiArrDepSelection.type !== \'now\'">\n                    Arrive or Depart at (local time)\n                    <form>\n                    <div class=\'input-group input-group-sm date\' date-time-picker="time">\n                      <input type=\'text\' class=\'form-control input-sm readOnly-input\' ng-change="route.applyArrDep()"\n                        readonly ng-model="route.uiArrDepSelection.time" alkmaps-input><span class=\'input-group-addon\'\n                        style="line-height:1;height:initial"><i class=\'glyphicon\' style="line-height:1;height:initial"></i></span>\n                    </div>\n                  </form>\n                  </li>\n                  <li class="divider"></li>\n                  <li class="text-right">\n                    <button class="btn btn-xs btn-link" ng-click="arrDep = !arrDep; $event.stopPropagation();"\n                      alkmaps-input>Close</button>\n                  </li>\n                </ul>\n              </div>\n              <!-- Traffic Options -->\n              <div class="pull-right">\n                <div class="btn-group dropdown" uib-dropdown>\n                  <button type="button" class="btn btn-default btn-xs dropdown-toggle" data-toggle="dropdown"\n                    ng-disabled="" alk-analytics="[\'Routing\',\'Route\',\'Stop Options\']"> Stop Options\n                    <span class="caret"></span>\n                  </button>\n                  <ul class="dropdown-menu dropdown-menu-right" role="menu">\n                    <li><button id="show-options-btn" class="btn btn-link btn-xs btn-menu" ng-disabled="!userInfo.isPremium() || !route.isValidRoute()"\n                        ng-click="routeVm.stopTimeClick(route)" ng-model="route.stopTime" alk-analytics="[\'Routing\',\'Route\',\'More Options\']">Stop\n                        Time</button></li>\n                    <li><button type="button" class="btn btn-link btn-xs btn-menu" ng-click="routeVm.showImportStops()"\n                        ng-if="userInfo.isPremium()" uib-tooltip="Import stops from CSV file" tooltip-placement="bottom">Import\n                        Stops...</button></li>\n                  </ul>\n                </div>\n                <button id="show-options-btn" class="btn btn-default btn-xs" ng-click="routeVm.showOptions(route)"\n                  alk-analytics="[\'Routing\',\'Route\',\'More Options\']"><i class="ico ico-cog"> </i>Route Options</button>\n              </div>\n            </div>\n          </div>\n\n          <!-- Stop List (flex-shrink) -->\n\n          <div class="stops-list flex-shrink-element" ng-style="{\'border-left-color\':route.uicolor}" ng-show="route.isOpen && !routeVm.isRouteSyncPanelVisible">\n            <!-- Avoid Favours Panel-->\n            <avoid-favors-panel id="afsView" ng-if="route.showAFs" updateparent="routeVm.hideAvoidFavorsPanel()"\n              avoid-favors-set-list="route.options.afSetIDs"></avoid-favors-panel>\n\n            <table class="panel-table" ng-hide="route.showAFs">\n              <!-- Header row -->\n              <thead ng-show="route.isValidRoute()">\n                <tr>\n                  <th>&nbsp;</th>\n                  <th>&nbsp;</th>\n                  <th ng-if="route.stopTime">&nbsp;</th>\n                  <!--<th colspan="2" ng-if="route.stopTime">Stop Duration</th>-->\n                  <th class="numeric" ng-if="route.options.inclTollData && !route.stopTime"> <span ng-hide="routeVm.region === \'EU\' ">\n                      Tolls </span></th>\n                  <!--<th class="numeric" ng-if="!route.stopTime">Cost</th>-->\n                  <th class="numeric" ng-bind="(route.options.distanceUnits === 0)? \'Miles\' : \'km\'" ng-if="!route.stopTime"></th>\n                  <th class="numeric" ng-if="!route.stopTime">Time\n                  </th>\n                  <!--<th class="date-range" ng-if="route.hasTime && !route.stopTime">Expected Arrival</th>-->\n                  <th class="numeric last-column" ng-if="route.hasTime && !route.stopTime">\n                    <span ng-click="route.etaetd = 1">ETA/ETD</span>\n                    <!-- strong if selected, other is light-->\n                  </th>\n\n                </tr>\n              </thead>\n              <!-- Stops body -->\n              <tbody ui-sortable="routeVm.sortableOptions" ng-model="route.sortableItems" ui-sortable-before-stop="routeVm.onSortableUpdate()">\n                <!-- Stops, warnings and Search repeater -->\n                <tr ng-repeat="sortableItem in route.sortableItems" ng-class="{\'hubroute\': route.options.hubRouting, \'hubstart\': $index === 0,\n                \'stop-item\': sortableItem != null, \'sort-item\': sortableItem.type !== \'warning\', \'search-row\': sortableItem.type === \'search\',\n                \'add-stop\':route.hasStops() && sortableItem.type === \'search\', \'route-panel-error\':sortableItem.type === \'warning\'}">\n\n                  <!-- Stops Control-->\n                  <td class="stop-num" ng-if="sortableItem.type === \'stop\'">\n                    <div class="cell-liner">\n                      <span class="insert-icon ico-stack" ng-if="route.stops.length >= 2" ng-hide="route.getSearchPanelIndex() !== -1 && $index === route.getSearchPanelIndex() + 1">\n                        <span class="ico ico-circle ico-stack-1x"></span>\n                        <span class="ico ico-plus ico-stack-1x" ng-click="routeVm.moveSearchPanel($index)"></span>\n                      </span>\n                      <span class="stop-line" ng-class="{\'origin\': $index === 0 || ($index === 1 && route.getSearchPanelIndex() !== -1 && $index > route.getSearchPanelIndex()),\n                        \'destination\': ($index === route.sortableItems.length - 1) || ($index ===(route.sortableItems.length - 2) && route.getSearchPanelIndex() !== -1 && $index < route.getSearchPanelIndex())}"\n                        ng-attr-style="{{\'background-color:\' + route.color + \' !important\'}}"></span>\n                      <span class="stop-line search-ext" ng-hide="route.stopTime" ng-class="{\'origin\': ($index === 1 && route.getSearchPanelIndex() !== -1 && $index > route.getSearchPanelIndex()),\n                        \'destination\': ($index ===(route.sortableItems.length - 2) && route.getSearchPanelIndex() !== -1 && $index < route.getSearchPanelIndex())}">\n                      </span>\n                      <span class="circle" ng-style="{ \'color\':routeVm.lightenRouteColor(route, 0.25), \'border-color\':routeVm.lightenRouteColor(route, 0.2) }"\n                        ng-class="sortableItem.value.Icon">{{sortableItem.value.IconText}}</span>\n                      <span class="insert-icon ico-stack last" ng-if="route.stops.length >= 2 && $index === (route.sortableItems.length - 1)">\n                        <span class="ico ico-circle ico-stack-1x"></span>\n                        <span class="ico ico-plus ico-stack-1x" ng-click="routeVm.moveSearchPanel($index+1)"></span>\n                      </span>\n                    </div>\n                  </td>\n                  <td class="address" ng-if="sortableItem.type === \'stop\'">\n                    <!--width: 275px if no other columns un table -->\n                      <div class="cell-liner" ng-if="sortableItem.value.Address.City !== \'\' || sortableItem.value.Address.State !== \'\' || sortableItem.value.Address.Zip !== \'\'|| sortableItem.value.PlaceNameID !==\'\' ">\n                      <span class="address-text place-name"  title="{{sortableItem.value.PlaceNameID}}">{{sortableItem.value.PlaceNameID}} </span>\n                      <span class="address-text" title="{{sortableItem.value.Address.StreetAddress}}" ng-if="sortableItem.value.Address.StreetAddress">{{sortableItem.value.Address.StreetAddress}}</span>\n                      <span class="city-text">{{sortableItem.value.CityStateZip}}</span>\n                      <span class="county-name">{{sortableItem.value.CountyStr}}<span ng-if="routeVm.region === \'EU\'">\n                          {{sortableItem.value.Country}}</span></span>\n                    </div>\n                    <div class="cell-liner" ng-if="sortableItem.value.Address.City === \'\' && sortableItem.value.Address.State === \'\' && sortableItem.value.Address.Zip === \'\' ">\n                      <span class="latlon-text">Lon: {{sortableItem.value.Coords.Lon}}, Lat:\n                        {{sortableItem.value.Coords.Lat}}</span>\n                    </div>\n                  </td>\n                  <td class="numeric" ng-if="sortableItem.type === \'stop\' && route.options.inclTollData && !route.stopTime">\n                    <div class="cell-liner">\n                      <span ng-hide="routeVm.region === \'EU\' ">{{sortableItem.value.Tolls | currency}}</span>\n                    </div>\n                  </td>\n                  <!--We may add this later-->\n                  <!--<td class="numeric" ng-if="sortableItem.type === \'stop\' && !route.stopTime">\n                    <div class="cell-liner">\n                      <span>{{sortableItem.value.Cost | currency}}</span>\n                    </div>\n                  </td>-->\n                  <td class="numeric" ng-if="sortableItem.type === \'stop\' && !route.stopTime">\n                    <div class="cell-liner">\n                      <span ng-if="route.stops.length > 1">{{sortableItem.value.Miles | number:1}}</span>\n                    </div>\n                  </td>\n                  <td class="numeric" ng-if="sortableItem.type === \'stop\' && !route.stopTime">\n                    <div class="cell-liner">\n                      <span ng-if="route.stops.length > 1">{{sortableItem.value.getHoursWithoutDuration()}}</span>\n                      <div ng-if="route.stops.length > 1 && routeVm.getDurationInHHMM(sortableItem.value)!==\'00:00\'">({{routeVm.getDurationInHHMM(sortableItem.value)}})</div>\n                    </div>\n                  </td>\n                  <!-- Hidden for now, will be added later\n                  <td class="date-range" ng-if="sortableItem.type === \'stop\' && route.hasTime && !route.stopTime">\n                    <div class="cell-liner">\n                      <span ng-class="{ \'missedTimeWindow\': !sortableItem.value.etaInTimeWindow() }">{{sortableItem.value.getArrivalDateRange()}}</span>\n                    </div>\n                  </td> -->\n\n                  <td class="numeric last-column" ng-if="sortableItem.type === \'stop\' && route.hasTime && !route.stopTime">\n                    <div class="cell-liner">\n                      <span ng-bind-html="sortableItem.value.displayETA"></span>\n                    </div>\n                  </td>\n                  <td class="hover-panel" ng-if="sortableItem.type === \'stop\' && !route.stopTime">\n                    <div class="stop-ctrl-container cell-liner" showonhoverparent="tr">\n                      <button class="stop-ctrl stop-ctrl-indicator">\n                        <span class="ico ico-more-vertical"></span>\n                      </button>\n\n                      <button class="delete-stop btn-action stop-ctrl" ng-click="routeVm.deleteStop(sortableItem.value)" title="Delete" alk-analytics="[\'Routing\',\'Route\',\'Delete Stop\']"><i class="ico ico-trash"></i></button>\n                      <button class="fav-stop btn-action stop-ctrl" ng-click="routeVm.saveFavorite(sortableItem.value)" ng-disabled="(!userInfo.isPremium()||!routeVm.canSaveFavorite(sortableItem.value))"\n                        title="{{(userInfo.isPremium())?\'Save Location\':\'Premium Only\'}}" alk-analytics="[\'Routing\',\'Route\',\'Add Favorite Stop\']">\n                        <i class="ico ico-star" ng-style="{\'color\': (userInfo.isPremium() && !routeVm.canSaveFavorite(sortableItem.value)) ? \'#428bca\' : \'\'}"></i>\n                      </button>\n                      <button class="zoom-stop btn-action stop-ctrl" ng-click="routeVm.showLocation(sortableItem.value)" title="Show on Map"><i class="ico ico-frame-stop" alk-analytics="[\'Routing\',\'Route\',\'Locate Stop\']"></i></button>\n                    </div>\n                  </td>\n                  <!-- stop time input-->\n                  <td colspan="2" ng-if="sortableItem.type === \'stop\' && route.hasTime && route.stopTime ">\n                    <div class="btn-group" uib-dropdown dropdown-append-to-body is-open="sortableItem.dropdownStatus.stopArr"\n                      ng-if="false">\n                      <button type="button" class="btn btn-default btn-xs dropdown-toggle" uib-dropdown-toggle\n                        alk-analytics="[\'Routing\',\'Route\',\'Time Options\']">\n                        Arrival <span class="caret"></span>\n                      </button>\n                      <ul class="dropdown-menu stopArrPanel panel" uib-dropdown-menu role="menu" ng-click="$event.stopPropagation()">\n                        <span ng-hide="userInfo.isPremium()" ng-cloak class="ng-cloak"><span class="premium-feature-note">Premium\n                            only</span></span>\n                        <li ng-repeat-start="earliestOrLatest in [sortableItem.value.earliestArrivalTime, sortableItem.value.latestArrivalTime]">\n                          <div class="checkbox">\n                            <label>\n                              <input type="checkbox" ng-model="earliestOrLatest.enabled" alkmaps-input ng-disabled="!userInfo.isPremium()">\n                              {{ earliestOrLatest.checkboxLabel }}\n                            </label>\n                          </div>\n                          <div class=\'input-group input-group-sm date\' date-time-picker="time" ng-show="earliestOrLatest.enabled">\n                            <input type=\'text\' class=\'form-control input-sm readOnly-input\' readonly ng-model="earliestOrLatest.arrivalTime"\n                              alkmaps-input>\n                            <span class=\'input-group-addon\' style="line-height:1;height:initial"><i class=\'glyphicon\'></i></span>\n                          </div>\n                        </li>\n                        <li class="divider"></li>\n                        <li class="text-right" ng-if="earliestOrLatest.type === 1" ng-repeat-end>\n                          <button class="btn btn-xs btn-link" ng-click="$event.preventDefault(); $event.stopPropagation(); sortableItem.dropdownStatus.stopArr=false;"\n                            alkmaps-input>\n                            Close\n                          </button>\n                        </li>\n                      </ul>\n                    </div>\n                  </td>\n                  <td colspan="5" class="" ng-if="sortableItem.type === \'stop\' && route.stopTime">\n                    <form>\n                      <div class="cell-liner control-group">\n                        <label class="control-label" for="durationinput">Stop Duration</label>\n                        <div class="controls">\n                          <input id="durationinput" maxlength="6" ng-class="{ \'stopDurationInputError\': !routeVm.isDurationValid(sortableItem.value.duration) }"\n                            placeholder="hh:mm, hh.hh or mm" value="00:00" ng-model="sortableItem.value.duration" type="text"></input>\n                        </div>\n                      </div>\n                    </form>\n                  </td>\n                  <!-- No stops, add some-->\n                  <td class="stop-num add-stop" ng-if="sortableItem.type === \'search\' && !route.hasStops()">\n                    <span class="circle unknown">?</span>\n                  </td>\n                  <td colspan="6" class="info-line search-cell" ng-if="sortableItem.type === \'search\' && !route.hasStops()">\n                    <search-stop hide-close="true" label-text="Click on the map or search for a location to add a stop."\n                      label-class="info-label"></search-stop>\n                  </td>\n                  <!-- 1-stop, add another -->\n                  <td class="stop-num add-stop" ng-class="{\'last\': $index === route.sortableItems.length - 1, \'first\': $index === 0}"\n                    ng-if=" sortableItem.type === \'search\' && route.stops.length === 1">\n                    <span class="stop-line"></span>\n                    <span class="circle unknown">?</span>\n                  </td>\n                  <td colspan="6" class="info-line search-cell" ng-if=" sortableItem.type === \'search\' && route.stops.length === 1">\n                    <search-stop hide-close="true" label-text="Add another stop to calculate a route (click on the map or search for a location)"\n                      label-class="info-label"></search-stop>\n                  </td>\n                  <!-- normal Search control -->\n                  <td class="stop-num add-stop" ng-class="{\'last\': $index === route.sortableItems.length - 1, \'first\': $index === 0}"\n                    ng-if="sortableItem.type === \'search\' && route.stops.length > 1 && !route.stopTime">\n                    <div class="cell-liner">\n                      <span class="stop-line"></span>\n                      <span class="circle"><i class="ico ico-plus"></i></span>\n                    </div>\n                  </td>\n                  <td class="search-cell" colspan="6" ng-if="sortableItem.type === \'search\' && route.stops.length > 1 && !route.stopTime">\n                    <search-stop sortable-item-index="$index"></search-stop>\n                  </td>\n                  <!-- warnings -->\n                  <td class="stop-num" ng-if="sortableItem.type === \'warning\'">\n                    <div class="cell-liner">\n                      <span class="stop-line" ng-class="{\'origin\': $index === 0 || ($index === 1 && route.getSearchPanelIndex() !== -1 && $index > route.getSearchPanelIndex()),\n                        \'destination\': ($index === route.sortableItems.length - 1) || ($index ===(route.sortableItems.length - 2) && route.getSearchPanelIndex() !== -1 && $index < route.getSearchPanelIndex())}"\n                        ng-attr-style="{{\'background-color:\' + route.color + \' !important\'}}"></span>\n                    </div>\n                  </td>\n                  <td colspan="5" ng-if="sortableItem.type === \'warning\'">\n                  <div class="warning-text">\n                    <span title="{{sortableItem.value}}">{{sortableItem.value}}</span></br>\n                    <a ng-click="routeVm.showReports(route)">View the report for more info.</a>\n                  </div>\n                </td>\n                </tr>\n              </tbody>\n              <tfoot ng-show="route.isValidRoute()">\n                <tr ng-show="!route.stopTime && !route.options.hubRouting">\n                  <td>&nbsp;</td>\n                  <td><span class="pull-right">Totals &nbsp; {{route.routeTCost | tollCostSummaryFilter:\n                      route.options.tollCurrency}}</span></td>\n                  <td class="numeric" ng-if="route.options.inclTollData"><span ng-hide="routeVm.region === \'EU\'">\n                      {{route.routeTTolls | currency}}</span></td>\n                  <!-- hidden for now, may be added back\n                    <td class="numeric">{{route.routeTCost | currency}}</td>-->\n                  <td class="numeric">{{route.routeTMiles | number:1}}</td>\n                  <td class="numeric">{{route.routeTHours}}</td>\n                  <td class="numeric" ng-if="route.hasTime"></td>\n                  <td>&nbsp;</td>\n                </tr>\n                <tr ng-show="route.stopTime">\n                  <td colspan="10">\n                    <button class="pull-right btn btn-default btn-xs" type="button" ng-click="routeVm.stopTimeCancel(route)">Cancel</button>\n                    <button class="pull-right btn btn-default btn-xs" type="submit" ng-disabled="!routeVm.canSaveDurations(route)"\n                      ng-click="routeVm.stopTimeSave(route)">Save</button> </td>\n                <tr>\n              </tfoot>\n            </table>\n          </div>\n          <!-- Search and Route controls section -->\n          <div class="route-item-fixed-section">\n            <!-- Route actions -->\n            <div class="route-actions" ng-style="{\'border-color\':route.uicolor}" ng-show="route.isOpen && !routeVm.isRouteSyncPanelVisible">\n              <div class="route-warning" ng-show="route.options.highwayOnly">\n                <p class="alert alert-warning alert-sm">Highway Only routing option enabled, streets may be ignored.<span\n                    ng-show="!userInfo.isPremium()" class="premium-feature-note" tooltip-placement="right" uib-tooltip="Street Data is Premium Only"></span></p>\n              </div>\n              <div class="btn-group-x" ng-if="!route.stopTime && !route.showAFs">\n                <button type="button" class="btn btn-default btn-xs pull-left" ng-disabled="!route.isValidRoute()"\n                  ng-click="routeVm.showReports(route)">Reports</button>\n                <span title="Save Route">\n                  <button id="save-route-btn" class="btn btn-default btn-xs" ng-click="routeVm.saveRoute(route)"\n                    ng-disabled="!routeVm.canSaveRoute(route)" alk-analytics="[\'Routing\',\'Route\',\'Save Route\']"><i><img\n                        class="save-icon" src="/img/icons/cloud-save.svg"></i></button>\n                </span>\n                <span title="{{(routeVm.routeCount() >= 8) ? \'You have the maximum of 8 routes open\' : \'Duplicate Route\'}}">\n                  <button id="duplicate-route-btn" class="btn btn-default btn-xs" ng-click="routeVm.duplicateRoute(route)"\n                    ng-if="route.stops.length" ng-disabled="routeVm.routeCount() >= 8" alk-analytics="[\'Routing\',\'Route\',\'Duplicate Route\']"><i><img\n                        class="duplicate-icon" src="/img/icons/route-duplicate.svg"></i></button>\n                </span>\n                <span title="Delete Route">\n                  <button id="clear-route-btn" class="btn btn-default btn-xs" ng-click="routeVm.deleteRoute(route)"\n                    ng-if="route.stops.length" alk-analytics="[\'Routing\',\'Route\',\'Delete Route\']"><i class="ico ico-trash"></i></button>\n                </span>\n\n                <div class="btn-group dropup" uib-dropdown>\n                  <button type="button" class="btn btn-default btn-xs dropdown-toggle" title="Optimize route"\n                    data-toggle="dropdown" ng-disabled="" alk-analytics="[\'Routing\',\'Route\',\'Menu\']"> <i class="ico ico-route-optimize"\n                      style="top:1px;"></i>\n                    <span class="caret"></span>\n                  </button>\n                  <ul class="dropdown-menu dropdown-menu-right" role="menu">\n                    <li><button class="btn btn-link btn-xs btn-menu" ng-disabled="route.sortableItems.length<4?true:false || !route.isValidRoute()"\n                        ng-click="routeVm.optimizeStopOrder(1, route)" alk-analytics="[\'Routing\',\'Route\',\'Optimize Stop Order\']">Optimize\n                        Stop Order</button></li>\n                    <li><button class="btn btn-link btn-xs btn-menu" ng-disabled="route.sortableItems.length<5?true:false || !route.isValidRoute()"\n                        ng-click="routeVm.optimizeStopOrder(2, route)" alk-analytics="[\'Routing\',\'Route\',\'Optimize Stop Order (Keep Destination)\']">Optimize\n                        Stop Order (Keep Destination)</button></li>\n                    <li ng-if="false">\n                      <button class="btn btn-link btn-xs btn-menu" ng-click="routeVm.showLeastCost(route)" ng-hide="routeVm.region === \'EU\'"\n                        ng-disabled="!userInfo.isPremium() || !route.isValidRoute()" alk-analytics="[\'Routing\',\'Route\',\'Least Cost Routing\']">\n                        Least Cost Routing\n                        <span ng-hide="userInfo.isPremium()" ng-cloak class="ng-cloak"><span class="premium-feature-note">Premium\n                            only</span></span>\n                      </button>\n                    </li>\n                  </ul>\n                </div>\n                <span uib-tooltip="{{routeVm.getRouteSyncErrors()}}" tooltip-enable="!routeVm.shouldAllowRouteSync()">\n                  <button ng-if="userInfo.canUseTripDirect()" id="send-route-btn" class="btn btn-default btn-xs"\n                    ng-click="routeVm.showRouteSync()" ng-disabled="!route.isValidRoute() || !routeVm.shouldAllowRouteSync()"\n                    alk-analytics="[\'Routing\',\'Route\',\'Send RouteSync\']">Send to CoPilot</button>\n                </span>\n              </div>\n              <div class="warning alert alert-warning alert-sm route-warning" ng-show="route.isError">{{route.errorMessage}}</div>\n            </div>\n          </div>\n          <!-- Modal Dialog placeholder -->\n          <!--<div ng-include="modalTemplate"></div>-->\n          <route-sync-panel ng-if="routeVm.isRouteSyncPanelVisible && route.isOpen"></route-sync-panel>\n          <!-- Calculation overlay -->\n          <div class="route-screen ng-cloak" ng-show="route.isCalculating" ng-cloak>\n            <span class="route-wait"><i class="ico ico-circle-notch ico-spin"></i>Calculating...</span>\n          </div>\n        </div>\n        <!-- Add route button -->\n        <div class="route-item" style="padding: 7px 6px;" ng-if="!routeVm.hasRoutes()">\n          <button id="new-route-btn" class="btn btn-default form-control" ng-click="routeVm.newRoute()" alkmaps-input\n            alk-analytics="[\'Routing\',\'New Route\']" title="New Route">\n            <span class="ico ico-plus"></span>\n            New Route\n          </button>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n');
  $templateCache.put('/app/route/saveRoute.template.html', '<div>\n    <form name="saveRouteForm" ng-submit="ok(saveRouteForm.$valid)">\n        <div class="modal-header">\n            <h4 class="modal-title">Save Route</h4>\n        </div>\n        <div class="modal-body">\n            <div class="form-group" ng-class="{ \'has-error\': ((saveRouteForm.routeName.$invalid || isRouteNameDuplicate) && !saveRouteForm.routeName.$pristine)}">\n                <label class="control-label" for="route-name">Name:</label>\n                <input id="route-name" name="routeName" type="text" class="form-control input" ng-model="route.name" required alkmaps-input alkmaps-focus="isFocused" />\n                <div class="glyphicon glyphicon-exclamation-sign error-glyph" ng-show="((saveRouteForm.routeName.$invalid || isRouteNameDuplicate) && !saveRouteForm.routeName.$pristine)">\n                    <div class="error-tooltip bg-danger">\n                        <p ng-show="saveRouteForm.routeName.$error.required" class="help-block">required.</p>\n                        <p ng-show="isRouteNameDuplicate" class="help-block">route name must be unique.</p>\n                    </div>\n                </div>\n                <p ng-show="isCheckingRouteName" class="help-block">checking route name...</p>\n            </div>\n        </div>\n        <div class="modal-footer">\n            <button class="btn btn-default" ng-click="close()" type="button">Cancel</button>\n            <button class="btn btn-primary" type="submit" ng-disabled="saveRouteForm.$invalid || saveRouteForm.$pending">\n                OK\n                <span class="has-error" ng-if="saveRouteForm.$invalid">&nbsp;\n                    <i class="glyphicon glyphicon-exclamation-sign"></i>\n                </span>\n            </button>\n        </div>\n    </form>\n</div>\n');
  $templateCache.put('/app/route/showLimitError.template.html', '<div>\n   \n        <div class="modal-header">\n            <h4 class="modal-title">Save Route Limit Error</h4>\n        </div>\n        <div class="modal-body">\n            <div class="form-group">\n                You have exceeded the maximum number of saved routes. To continue saving new routes, please delete previously saved routes.\n            </div>\n        </div>\n        <div class="modal-footer">\n            <button class="btn btn-default" ng-click="$dismiss(\'cancel\')" type="button">OK</button>\n           \n        </div>\n    \n</div>\n');
  $templateCache.put('/app/route/updateRoute.template.html', '<div>\n    <form name="saveRouteForm" ng-submit="ok(saveRouteForm.$valid)">\n        <div class="modal-header">\n            <h4 class="modal-title">Update Route?</h4>\n        </div>\n        <div class="modal-body">\n            <div class="form-group">\n                \'{{route.name}}\' saved route already exists. Would you like to replace it?\n            </div>\n        </div>\n        <div class="modal-footer">\n            <button class="btn btn-default" ng-click="close()" type="button">No</button>\n            <button class="btn btn-primary" type="submit">Yes</button>\n        </div>\n    </form>\n</div>\n');
  $templateCache.put('/app/search/search.template.html', '<div ng-controller="searchController as searchVm">\n  <div class="search-panel" ng-class="{ \'places-tab\' : searchVm.activeTab === 4}">\n    <uib-tabset active="searchVm.activeTab">\n      <uib-tab index="-1" disable="{{true}}">\n        <uib-tab-heading class="label-tab">\n          Add Stop\n        </uib-tab-heading>\n      </uib-tab>\n\n      <!-- Classic Search -->\n      <uib-tab index="0" select="searchVm.searchFocus()" ng-if="!searchVm.isSingleSearch">\n        <uib-tab-heading>\n          <i class="ico ico-envelope"></i>\n        </uib-tab-heading>\n        <form ng-submit="searchVm.searchClassic()" class="classic-search">\n          <div class="flex-group">\n            <div class="flex-element">\n              <input id="search-address" autocomplete="off" type="text" class="form-control input search-address-input" placeholder="Street Address"\n                ng-disabled="!searchVm.userIsPremium" ng-model="searchVm.searchAddrString" alkmaps-input />\n              <input autocomplete="off" type="text" class="form-control input search-city-input" placeholder="City, State or ZIP/Postal Code"\n                ng-model="searchVm.searchCityString" alkmaps-input ng-keydown="$event.which === 40 ? searchVm.focusClass(\'csList0\') : 0"\n              />\n            </div>\n            <div style="margin: -7px 0 0 5px;">\n              <button id="address-search-btn" class="search-btn btn btn-success btn-sm" alk-analytics="[\'Search\',\'Address\',\'Submit\']">Search</button>\n              </br>\n              <button class="btn btn-link btn-sm search-clear" style="margin: 5px 0 0" ng-click="searchVm.clearSearch()">Clear</button>\n            </div>\n          </div>\n\n          <div class="search-controls">\n            <span ng-hide="searchVm.userIsPremium" ng-cloak class="ng-cloak">\n              <span class="premium-feature-note">Street Address is Premium only</span>\n            </span>\n          </div>\n\n        </form>\n        <div class="item-list-container ng-cloak" ng-cloak ng-show="searchVm.searchResultsVisibility()">\n          <ul class="list-group item-list">\n            <li class="list-group-item error-item" ng-if="searchVm.searchError !== \'\'">\n              <i class="ico ico-warning"></i> {{searchVm.searchError}}\n            </li>\n            <li class="list-group-item loading-item" ng-if="searchVm.isSearching">\n              <i class="ico ico-circle-notch ico-spin"></i> Loading...\n            </li>\n            <li ng-class="\'csList\' + $index" ng-repeat="result in searchVm.searchResults" class="list-group-item" tabindex="0" ng-click="searchVm.addStopToRoute(result)"\n              alkmaps-input alk-analytics="[\'Search\',\'Address\',\'Add Stop\']" list-select list-select-skip-auto-focus="true"\n              list-select-on-enter="searchVm.addStopToRoute(result)" list-input-class="search-city-input">\n              <div class="flex-group">\n                <div class="result-icon">\n                  <span class="ico" ng-class="result.TypeIcon"></span>\n                </div>\n                <div class="result-info">\n                  <div class="results-address" ng-bind-html="result.Address | fullAddressFilter:true" title="{{result.Address | fullAddressFilter:false}}"></div>\n                  <div class="results-county">{{result.CountyStr}}</div>\n                </div>\n              </div>\n              <div class="item-actions" showonhoverparent="li">\n                <button tabindex="-1" class="btn btn-more" ng-click="$event.preventDefault(); $event.stopPropagation();">\n                  <i class="ico ico-more-vertical"></i>\n                </button>\n\n                <div class="item-actions-well">\n                  <button tabindex="-1" class="btn btn-xs btn-link btn-action" ng-disabled="!searchVm.canSaveFavorite(result)" ng-click="saveFavorite(result); $event.preventDefault(); $event.stopPropagation();"\n                    title="{{(searchVm.userIsPremium)?\'Save Location\':\'Premium Only\'}}" alk-analytics="[\'Search\',\'Address\',\'Add Favorite\']">\n                    <i class="ico ico-star"></i>\n                  </button>\n                  <button tabindex="-1" class="btn btn-xs btn-link btn-action" ng-click="searchVm.showLocation(result, true); $event.preventDefault(); $event.stopPropagation();"\n                    alk-analytics="[\'Search\',\'Address\',\'Locate\']" title="Show Location">\n                    <i class="ico ico-map-marker"></i>\n                  </button>\n                </div>\n              </div>\n\n            </li>\n          </ul>\n        </div>\n      </uib-tab>\n\n      <!-- SPLC/Lat-Long -->\n      <uib-tab index="1" select="searchVm.searchFocus()" ng-if="!searchVm.isSingleSearch" disable="!searchVm.userIsPremium">\n        <uib-tab-heading>\n          <i class="ico ico-point-location">\n            <span ng-hide="searchVm.userIsPremium" ng-cloak class="ng-cloak">\n              <span class="ico premium-feature-note" uib-tooltip="SPLC is Premium Only" tooltip-placement="bottom"></span>\n          </i>\n        </uib-tab-heading>\n        <form ng-submit="searchVm.searchSplc()" class="classic-search">\n          <div class="flex-group">\n            <div class="flex-element">\n              <input autocomplete="off" type="text" class="form-control input search-splc-input" placeholder="SPLC Code or Latitude, Longitude"\n                ng-model="searchVm.searchSplcString" ng-keydown="$event.which === 40 ? searchVm.focusClass(\'splcList0\') : 0"\n                alkmaps-input />\n            </div>\n            <div style="margin: -7px 0 0 5px;">\n              <button id="address-search-btn" class="search-btn btn btn-success btn-sm" alk-analytics="[\'Search\',\'Address\',\'Submit\']">Search</button>\n              <button class="btn btn-link btn-sm search-clear" ng-click="searchVm.clearSplc()">Clear</button>\n            </div>\n          </div>\n        </form>\n        <div class="item-list-container ng-cloak" ng-cloak ng-show="searchVm.splcResultsVisibility()">\n          <ul class="list-group item-list">\n            <li class="list-group-item error-item" ng-if="searchVm.splcError !== \'\'">\n              <i class="ico ico-warning"></i> {{searchVm.splcError}}\n            </li>\n            <li class="list-group-item loading-item" ng-if="searchVm.isSearching">\n              <i class="ico ico-circle-notch ico-spin"></i> Loading...\n            </li>\n            <li ng-class="\'splcList\' + $index" ng-repeat="result in searchVm.splcResults" class="list-group-item" tabindex="0" ng-click="searchVm.addStopToRoute(result)"\n              alkmaps-input alk-analytics="[\'Search\',\'Address\',\'Add Stop\']" list-select list-select-skip-auto-focus="true"\n              list-select-on-enter="searchVm.addStopToRoute(result)" list-input-class="search-splc-input">\n              <div class="flex-group">\n                <div class="result-info">\n                  <!--<i class="type-icon ico" ng-class="((searchVm.canSaveFavorite(result)) || (!searchVm.userIsPremium))?result.TypeIcon:\'ico-star active\'"></i>-->\n                  <div class="results-address" ng-bind-html="result.Address | fullAddressFilter:true" title="{{result.Address | fullAddressFilter:false}}"></div>\n                  <div class="results-county">{{result.CountyStr}}</div>\n                </div>\n              </div>\n              <div class="item-actions" showonhoverparent="li">\n                <button tabindex="-1" class="btn btn-more" ng-click="$event.preventDefault(); $event.stopPropagation();">\n                  <i class="ico ico-more-vertical"></i>\n                </button>\n\n                <div class="item-actions-well">\n                  <button class="btn btn-xs btn-link btn-action" ng-disabled="!searchVm.canSaveFavorite(result) " ng-click="saveFavorite(result); $event.preventDefault(); $event.stopPropagation();"\n                    title="{{(searchVm.userIsPremium)?\'Save Location\':\'Premium Only\'}}" alk-analytics="[\'Search\',\'Address\',\'Add Favorite\']">\n                    <i class="ico ico-star"></i>\n                  </button>\n                  <button class="btn btn-xs btn-link btn-action" ng-click="searchVm.showLocation(result, true); $event.preventDefault(); $event.stopPropagation();"\n                    alk-analytics="[\'Search\',\'Address\',\'Locate\']" title="Show Location">\n                    <i class="ico ico-map-marker"></i>\n                  </button>\n                </div>\n              </div>\n\n            </li>\n          </ul>\n        </div>\n      </uib-tab>\n      <!-- Single Search -->\n      <uib-tab index="0" select="searchVm.searchFocus()" ng-if="searchVm.isSingleSearch">\n        <uib-tab-heading>\n          <i class="ico ico-search" style="font-size: 15px; line-height: 19px;"></i>\n        </uib-tab-heading>\n        <div class="single-search">\n          <div class="flex-group">\n            <div class="search-input-area flex-element">\n              <input autocomplete="off" type="text" class="form-control input single-search-input" placeholder="Search" ng-change="searchVm.singleSearch()"\n                ng-model="searchVm.singleSearchString" alkmaps-input ng-keydown="$event.which === 40 || $event.which === 13 ? searchVm.focusClass(\'ssList0\') : 0"\n                ng-model-options="{debounce: 400}"\n              />\n            </div>\n          </div>\n          <div class="single-search-results item-list-container" ng-if="searchVm.singleSearchString.length > 0">\n            <ul class="list-group item-list">\n              <li ng-class="\'ssList\' + $index" class="list-group-item" ng-repeat="result in searchVm.singleSearchResults" tabindex="0"\n                ng-click="searchVm.addStopToRoute(result)" alkmaps-input alk-analytics="[\'Search\',\'Single Search\',\'Add Stop\']"\n                list-select list-select-skip-auto-focus="true" list-select-on-enter="searchVm.addStopToRoute(result)" list-input-class="single-search-input">\n                <div class="flex-group">\n                  <div class="result-icon">\n                    <span class="ico" ng-class="result.TypeIcon"></span>\n                  </div>\n                  <div class="result-info">\n                    <!-- pchen: one-line search results, no matter if POI (or Athena Place) Custom Place-->\n                    <div class="results-address" title="{{result.Address | fullAddressFilter:false}}" >\n                      <span ng-if="result.PlaceNameID">\n                        <strong>{{result.PlaceNameID}}</strong>\n                        -\n                      </span>\n                      <span ng-bind-html="result.Address | fullAddressFilter:true"> </span>\n                  </div>\n                  </div>\n                  <!-- Action buttons -->\n                  <div class="item-actions" showonhoverparent="li">\n                    <button tabindex="-1" class="btn btn-more" ng-click="$event.preventDefault(); $event.stopPropagation();">\n                      <i class="ico ico-more-vertical"></i>\n                    </button>\n                    <div class="item-actions-well">\n                      <!-- Show Location-->\n                      <button tabindex="-1" class="btn btn-xs btn-link btn-action" ng-click="searchVm.showLocation(result, true); $event.preventDefault(); $event.stopPropagation();"\n                        alk-analytics="[\'Search\',\'Address\',\'Locate\']">\n                        <i class="ico ico-map-marker"></i>\n                      </button>\n                    </div>\n                  </div>\n                </div>\n              </li>\n            </ul>\n          </div>\n        </div>\n      </uib-tab>\n      <!-- Favorites -->\n      <uib-tab index="3" select="searchVm.searchFocus()" disable="!searchVm.userIsPremium">\n        <uib-tab-heading>\n          <i class="ico ico-star">\n            <span ng-hide="searchVm.userIsPremium" ng-cloak class="ng-cloak">\n              <span class="ico premium-feature-note" uib-tooltip="Favorite Places is Premium Only" tooltip-placement="bottom"></span>\n          </i>\n        </uib-tab-heading>\n        <div class="favorites-area">\n          <div class="flex-group">\n            <div class="flex-element">\n              <input type="text" class="form-control input favorite-filter-input" placeholder="Filter" ng-model="searchVm.favoriteFilter"\n                ng-keydown="$event.which === 40 ? searchVm.focusClass(\'fvList0\') : 0" alkmaps-input />\n            </div>\n\n          </div>\n          <div class="item-list-container">\n            <ul class="list-group item-list favorite-list">\n              <li ng-if="((searchVm.getFavorites().length === 0) && (searchVm.userIsPremium))" class="clearfix">\n                <i class="ico ico-info-circle ico-info-color"></i>\n                <span class="favorite-address">\n                  No Locations have been saved.\n                </span>\n              </li>\n              <li ng-if="((searchVm.getFavorites().length !== 0) && (searchVm.filteredFavorites.length === 0) && (searchVm.userIsPremium))"\n                class="clearfix">\n                <i class="ico ico-info-circle ico-info-color"></i>\n                <span class="favorite-address">\n                  No Match Results found.\n                </span>\n              </li>\n              <li ng-class="\'fvList\' + $index" class="list-group-item" ng-repeat="favorite in searchVm.filteredFavorites = (searchVm.getFavorites() | filter: searchVm.filterFunction | orderBy:\'Name\' | limitTo: 50)"\n                tabindex="0" ng-click="searchVm.addFavoriteToRoute(favorite)" list-select list-select-skip-auto-focus="true"\n                list-select-on-enter="searchVm.addFavoriteToRoute(favorite)" alkmaps-input alk-analytics="[\'Search\',\'Favorites\',\'Add Stop\']"\n                list-input-class="favorite-filter-input">\n                <div class="flex-group">\n                  <div class="result-info text-ellipsis flex-element">\n                    <i class="ico ico-star-open" title="Shared Location" ng-show="favorite.IsShared"></i>\n                    <i class="ico ico-star" title="Private Location" ng-show="!favorite.IsShared"></i>\n                    <span class="favorite-address">\n                      <span ng-if="(favorite.Name)" ng-bind="favorite.Name" class="name"></span>\n                      <span title="{{favorite.Address | fullAddressFilter:false}}" ng-bind-html="favorite.Address | fullAddressFilter:true"></span>\n                    </span>\n                  </div>\n                  <div class="item-actions" showonhoverparent="li">\n                    <button tabindex="-1" class="btn btn-more" ng-click="$event.preventDefault(); $event.stopPropagation();">\n                      <i class="ico ico-more-vertical"></i>\n                    </button>\n                    <div class="item-actions-well">\n                      <button tabindex="-1" class="btn btn-xs btn-link btn-action" title="Delete Location" ng-disabled="favorite.IsShared && !searchVm.userIsAdmin"\n                        ng-click="searchVm.deleteFavorite(favorite); $event.preventDefault(); $event.stopPropagation();" alk-analytics="[\'Search\',\'Favorites\',\'Delete\']">\n                        <i class="ico ico-trash"></i>\n                      </button>\n                      <button tabindex="-1" class="btn btn-xs btn-link btn-action" title="Show Location" ng-click="searchVm.pickFavorite(favorite); $event.preventDefault(); $event.stopPropagation();"\n                        alk-analytics="[\'Search\',\'Favorites\',\'Locate\']">\n                        <i class="ico ico-map-marker"></i>\n                      </button>\n                    </div>\n                  </div>\n                </div>\n              </li>\n            </ul>\n          </div>\n        </div>\n      </uib-tab>\n\n      <!-- Custom Place -->\n      <uib-tab index="4" select="searchVm.showMorePlaces()" disable="!searchVm.userIsPremium">\n        <uib-tab-heading class="label-tab">\n            <i class="ico ico-map-marker">\n              <span ng-hide="searchVm.userIsPremium" ng-cloak class="ng-cloak">\n                <span class="ico premium-feature-note" uib-tooltip="Custom Place is Premium Only" tooltip-placement="bottom">\n              </span>\n            </i>\n        </uib-tab-heading>\n      </uib-tab>\n    </uib-tabset>\n    <!-- Label -->\n    <div class="flex-group search-stop-label" style="align-items: flex-start">\n      <label class="flex-element {{searchVm.labelClass()}}">{{searchVm.labelText()}}</label>\n    </div>\n    <a class="btn btn-sm btn-link btn-icon-only close-btn" ng-hide="searchVm.hideClose" ng-click="searchVm.hideSortableItem(); $event.preventDefault(); $event.stopPropagation();">\n      <span class="ico ico-close"></span>\n    </a>\n  </div>\n</div>\n');
  $templateCache.put('/app/vehicle/vehiclesPanel.template.html', '<div id="vehicles-panel" class="panel panel-default panel-floating ng-cloak" ng-controller="vehiclesController" ng-cloak\n  ng-show="showVehicles" ng-class="{\'closed\': !isVehiclesCollapsed}">\n  <div class="panel-heading">\n\n    <button class="btn btn-xs btn-link btn-icon-only">\n    <i class="ico ico-up-open" ng-click="toggleVehicles()" ng-class="(!isVehiclesCollapsed)?\'ico-rotate-180\':\'ico-rotate-0\'"></i>\n    </button>\n    <h4 class="panel-name" ng-click="toggleVehicles()" style="cursor:pointer">CoPilot Vehicles</h4>\n    <button class="btn btn-xs btn-link btn-icon-only">\n    <i class="ico ico-close" ng-click="closeVehicles()"></i>\n    </button>\n  </div>\n  <div class="panel-body" ng-show="isVehiclesCollapsed">\n    <div class="form-inline filter-group">\n      <!-- Set Filter -->\n      <div class="input-group">\n        <span class="input-group-btn">\n                <span class="btn btn-sm btn-fake-addon">\n                <i class="ico ico-filter"></i>\n                </span> \n        </span>\n        <input id="filterInput" type="text" class="form-control" id="set-filter" placeholder="{{\'common.Filter\' | translate }}" ng-model="searchText">\n        <span class="input-group-btn">\n                <button class="btn btn-sm btn-default" type="button" ng-click="searchText = \'\'">&times;</button>\n              </span>\n      </div>\n      <!-- All vehicle actions -->\n      <button class="btn btn-default btn-xs btn-icon-only pull-right" ng-click="frameAll()" title="Frame All Vehicles"><span class="ico ico-markers"></span></button>\n      <button class="btn btn-default btn-xs btn-icon-only pull-right" ng-click="refreshVehicles()" title="Update Vehicles"><span class="ico ico-refresh"></span></button>\n\n    </div>\n\n    <div class="item-list-container">\n      <ul class="list-group item-list vehicle-list" ng-class="{loading:isLoadingVehicles}">\n        <li class="list-group-item" ng-if="vehicleList.length === 0">\n          <span class="driver-name">No vehicles have been connected to this account</span>\n        </li>\n        <li class="list-group-item" ng-repeat="vehicle in vehicleList | filter:searchText">\n          <div class="flex-group">\n            <div class="result-info text-ellipsis flex-element">\n              <span class="status-indicator" ng-class="(vehicle.OnlineStatus === 1)?\'status-online\':\'status-offline\'" ng-bind="(vehicle.OnlineStatus === 1)?\'on\':\'off\'"></span>\n              <span class="driver-name">{{vehicle.Email}}</span>\n              <span class="driver-location driver-info">Near: {{getVehicleAddressString(vehicle.Address)}}</span>\n              <span class="driver-update driver-info">Updated: {{vehicle.displayDate}}</span>\n            </div>\n            <div class="item-actions" showonhoverparent="li">\n              <button tabindex="-1" class="btn btn-more" ng-click="$event.preventDefault(); $event.stopPropagation();">\n                    <i class="ico ico-more-vertical"></i>\n                  </button>\n              <div class="item-actions-well">\n                <button class="btn btn-xs btn-link btn-action" ng-click="showLocation(vehicle); $event.preventDefault(); $event.stopPropagation();"\n                  alk-analytics="[\'RouteSync\',\'Vehicle\',\'Locate\']" title="Show Vehicle Location">\n                            <i class="ico ico-map-marker"></i>\n                        </button>\n              </div>\n            </div>\n          </div>\n\n        </li>\n        <li class="loading-overlay" ng-show="isLoadingVehicles">\n          <span class="vehicle-wait"><i class="ico ico-circle-notch ico-spin"></i>Loading...</span>\n        </li>\n      </ul>\n    </div>\n    <h5 class="legend">Account Short Code</h5>\n    <div class="flex-group">\n      <div class="flex-element">\n        <p class="form-control-static input-line">\n          <span class="shortcode-wait" ng-show="shortcode === \'\'"><i class="ico ico-circle-notch ico-spin"></i>Loading...</span>\n          <span ng-bind="shortcode"></span>\n          <span class="ico ico-info-circle tooltip-icon" tooltip-placement="bottom" uib-tooltip="Enter this code into CoPilot to add a vehicle to this list"></span>\n        </p>\n      </div>\n    </div>\n  </div>\n</div>\n');
  $templateCache.put('/app/route-sync/route-sync-panel/routeSyncPanel.template.html', '<div id="routesync-overlay" class="modal-overlay" class="itemAddDelete">\n  <div class="modal-header" ng-style="{\'border-left-color\':$parent.route.uicolor}">\n    <h4 class="modal-title">Send Route to CoPilot</h4>\n  </div>\n  <div class="modal-body">\n    <route-sync-summary></route-sync-summary>\n    <div id="pcm-routesync-send" class="forms-content forms-content-xsmall">\n      <div class="row">\n        <div class=" col-md-6">\n          <div class="row">\n            <div class="col-md-6">\n              <h4 class="field-section">CoPilot Vehicles</h4>\n            </div>\n            <div class="col-md-6 text-right">\n              <div class="vehicle-list-btns">\n                <button class="btn btn-default btn-xs btn-icon-only" style="margin-top:5px" ng-click="rsCtrl.frameClosest()" title="Show Closest"><span class="ico ico-location-icon"></span></button>\n                <button class="btn btn-default btn-xs btn-icon-only" style="margin-top:5px" ng-click="rsCtrl.filterVehicles()" title="Filter Vehicle List"><span class="ico ico-filter"></span></button>\n                <button class="btn btn-default btn-xs btn-icon-only" style="margin-top:5px" ng-click="rsCtrl.getVehicles()" title="Update Vehicles"><span class="ico ico-refresh"></span></button>\n              </div>\n            </div>\n          </div>\n          <div ng-if="rsCtrl.showSearch" style="margin-top: 5px;" class="slideInOut">\n            <div class="form-inline filter-group">\n              <div class="input-group">\n                <input type="text" class="form-control" ng-model="rsCtrl.searchText" placeholder="Filter">\n                <span class="input-group-btn">\n                <button class="btn btn-sm btn-default" type="button" ng-click="rsCtrl.cancelSearch()">x</button>\n              </span>\n              </div>\n            </div>\n          </div>\n          <div class="item-list-container">\n            <ul class="list-group item-list vehicle-list" ng-class="{loading: rsCtrl.isLoadingVehicles}">\n              <li class="list-group-item" ng-if="rsCtrl.vehicleList.length === 0">\n                <span class="driver-name">No vehicles have been connected to this account</span>\n              </li>\n              <li class="list-group-item" ng-repeat="vehicle in rsCtrl.vehicleList | filter: rsCtrl.searchText" ng-class="{selected:vehicle.OwnerID === rsCtrl.getSelectedVehicle().OwnerID}"\n                ng-click="rsCtrl.setSelectedVehicle(vehicle)">\n                <div class="results-actions" showonhoverparent>\n                  <!-- Action buttons -->\n                  <div class="item-actions" showonhoverparent="li">\n                    <button tabindex="-1" class="btn btn-more" ng-click="$event.preventDefault(); $event.stopPropagation();">\n                    <i class="ico ico-more-vertical"></i>\n                  </button>\n                    <div class="item-actions-well">\n                      <!-- Show Location-->\n                      <button tabindex="-1" class="btn btn-xs btn-link btn-action" ng-click="rsCtrl.showLocation(vehicle,true); $event.preventDefault(); $event.stopPropagation();"\n                        alk-analytics="[\'RouteSync\',\'Vehicle\',\'Locate\']" title="Show Vehicle Location">\n                        <i class="ico ico-map-marker"></i>\n                        </button>\n                    </div>\n                  </div>\n                </div>\n                <span class="status-indicator" ng-class="(vehicle.OnlineStatus === 1)?\'status-online\':\'status-offline\'" ng-bind="(vehicle.OnlineStatus === 1)?\'on\':\'off\'"\n                  title="Updated: {{vehicle.displayDate}}"></span>\n                <span class="driver-name" title="{{vehicle.OwnerID}}">{{vehicle.Email}}</span>\n              </li>\n              <li class="loading-overlay" ng-show="rsCtrl.isLoadingVehicles">\n                <span class="vehicle-wait"><i class="ico ico-circle-notch ico-spin"></i>Loading...</span>\n              </li>\n            </ul>\n          </div>\n        </div>\n        <div class="col-md-6">\n          <h4 class="field-section">Route Compliance <span class="ico ico-info-circle tooltip-icon" tooltip-placement="bottom" uib-tooltip="How strictly should CoPilot navigate back to the original route?"></span></h4>\n          <!--<p class="form-info">How strictly should CoPilot navigate back to the original route?</p>-->\n          <span ng-repeat="amount in rsCtrl.complianceAmounts">\n            <label>\n              <input type="radio" ng-model="rsCtrl.routeSyncOptions.complianceAmount" ng-value="amount.value">{{amount.display}}\n            </label>\n          </span>\n          <h4 class="field-section">Alert Distance <span class="ico ico-info-circle tooltip-icon" tooltip-placement="bottom" uib-tooltip="Send alert when vehicle is a minimum distance off route"></span></h4>\n          <!--<p class="form-info">Send alert when vehicle is a minimum distance off route</p>-->\n          <div class="form-group">\n            <input class="form-control input-sm" style="width: 25%; display: inline-block;" ng-model="rsCtrl.routeSyncOptions.alertDist"\n              type="text" />\n            <label class="control-label">miles off route</label>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class="modal-footer">\n    <div class="pull-left fadeOut route-error" ng-show="rsCtrl.getSelectedVehicle() === null">Please select a vehicle</div>\n    <div class="pull-left" ng-if="rsCtrl.displaySuccessMessage">\n      <p class="text-success">Successfully sent to CoPilot!</p>\n    </div>\n    <div class="pull-left" ng-if="rsCtrl.displayErrorMessage">\n      <p class="text-danger">Could not send route to CoPilot!</p>\n    </div>\n    <button class="btn btn-default btn-sm" ng-click="close()">Cancel</button>\n    <button class="btn btn-primary btn-sm" ng-disabled="rsCtrl.getSelectedVehicle() === null" ng-click="rsCtrl.send()">Send</button>\n  </div>\n</div>\n');
  $templateCache.put('/app/route-sync/route-sync-summary/routeSyncSummary.template.html', '<div class="routesync-summary">\n  <p>\n    <span class="route-od-info">{{vm.routeODInfo()}}</span><br />\n    <span class="route-stat-info">{{vm.routeStats()}}</span><br />\n    <span class="route-vehicle-info" ng-if="vm.route.options.vehicleType !== 2">{{vm.getCurrentRoute() | vehicleSummaryFilter}}</span>\n  </p>\n</div>\n');
}]);

/***/ }),

/***/ 341:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Papa Parse
	v4.1.4
	https://github.com/mholt/PapaParse
*/
(function(root, factory)
{
	if (true)
	{
		// AMD. Register as an anonymous module.
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	else if (typeof module === 'object' && module.exports)
	{
		// Node. Does not work with strict CommonJS, but
		// only CommonJS-like environments that support module.exports,
		// like Node.
		module.exports = factory();
	}
	else
	{
		// Browser globals (root is window)
		root.Papa = factory();
	}
}(this, function()
{
	'use strict';

	var global = (function () {
		// alternative method, similar to `Function('return this')()`
		// but without using `eval` (which is disabled when
		// using Content Security Policy).

		if (typeof self !== 'undefined') { return self; }
		if (typeof window !== 'undefined') { return window; }
		if (typeof global !== 'undefined') { return global; }

        // When running tests none of the above have been defined
        return {};
	})();


	var IS_WORKER = !global.document && !!global.postMessage,
		IS_PAPA_WORKER = IS_WORKER && /(\?|&)papaworker(=|&|$)/.test(global.location.search),
		LOADED_SYNC = false, AUTO_SCRIPT_PATH;
	var workers = {}, workerIdCounter = 0;

	var Papa = {};

	Papa.parse = CsvToJson;
	Papa.unparse = JsonToCsv;

	Papa.RECORD_SEP = String.fromCharCode(30);
	Papa.UNIT_SEP = String.fromCharCode(31);
	Papa.BYTE_ORDER_MARK = '\ufeff';
	Papa.BAD_DELIMITERS = ['\r', '\n', '"', Papa.BYTE_ORDER_MARK];
	Papa.WORKERS_SUPPORTED = !IS_WORKER && !!global.Worker;
	Papa.SCRIPT_PATH = null;	// Must be set by your code if you use workers and this lib is loaded asynchronously

	// Configurable chunk sizes for local and remote files, respectively
	Papa.LocalChunkSize = 1024 * 1024 * 10;	// 10 MB
	Papa.RemoteChunkSize = 1024 * 1024 * 5;	// 5 MB
	Papa.DefaultDelimiter = ',';			// Used if not specified and detection fails

	// Exposed for testing and development only
	Papa.Parser = Parser;
	Papa.ParserHandle = ParserHandle;
	Papa.NetworkStreamer = NetworkStreamer;
	Papa.FileStreamer = FileStreamer;
	Papa.StringStreamer = StringStreamer;

	if (global.jQuery)
	{
		var $ = global.jQuery;
		$.fn.parse = function(options)
		{
			var config = options.config || {};
			var queue = [];

			this.each(function(idx)
			{
				var supported = $(this).prop('tagName').toUpperCase() === 'INPUT'
								&& $(this).attr('type').toLowerCase() === 'file'
								&& global.FileReader;

				if (!supported || !this.files || this.files.length === 0)
					return true;	// continue to next input element

				for (var i = 0; i < this.files.length; i++)
				{
					queue.push({
						file: this.files[i],
						inputElem: this,
						instanceConfig: $.extend({}, config)
					});
				}
			});

			parseNextFile();	// begin parsing
			return this;		// maintains chainability


			function parseNextFile()
			{
				if (queue.length === 0)
				{
					if (isFunction(options.complete))
						options.complete();
					return;
				}

				var f = queue[0];

				if (isFunction(options.before))
				{
					var returned = options.before(f.file, f.inputElem);

					if (typeof returned === 'object')
					{
						if (returned.action === 'abort')
						{
							error('AbortError', f.file, f.inputElem, returned.reason);
							return;	// Aborts all queued files immediately
						}
						else if (returned.action === 'skip')
						{
							fileComplete();	// parse the next file in the queue, if any
							return;
						}
						else if (typeof returned.config === 'object')
							f.instanceConfig = $.extend(f.instanceConfig, returned.config);
					}
					else if (returned === 'skip')
					{
						fileComplete();	// parse the next file in the queue, if any
						return;
					}
				}

				// Wrap up the user's complete callback, if any, so that ours also gets executed
				var userCompleteFunc = f.instanceConfig.complete;
				f.instanceConfig.complete = function(results)
				{
					if (isFunction(userCompleteFunc))
						userCompleteFunc(results, f.file, f.inputElem);
					fileComplete();
				};

				Papa.parse(f.file, f.instanceConfig);
			}

			function error(name, file, elem, reason)
			{
				if (isFunction(options.error))
					options.error({name: name}, file, elem, reason);
			}

			function fileComplete()
			{
				queue.splice(0, 1);
				parseNextFile();
			}
		}
	}


	if (IS_PAPA_WORKER)
	{
		global.onmessage = workerThreadReceivedMessage;
	}
	else if (Papa.WORKERS_SUPPORTED)
	{
		AUTO_SCRIPT_PATH = getScriptPath();

		// Check if the script was loaded synchronously
		if (!document.body)
		{
			// Body doesn't exist yet, must be synchronous
			LOADED_SYNC = true;
		}
		else
		{
			document.addEventListener('DOMContentLoaded', function () {
				LOADED_SYNC = true;
			}, true);
		}
	}




	function CsvToJson(_input, _config)
	{
		_config = _config || {};
		_config.dynamicTyping = _config.dynamicTyping || false;

		if (_config.worker && Papa.WORKERS_SUPPORTED)
		{
			var w = newWorker();

			w.userStep = _config.step;
			w.userChunk = _config.chunk;
			w.userComplete = _config.complete;
			w.userError = _config.error;

			_config.step = isFunction(_config.step);
			_config.chunk = isFunction(_config.chunk);
			_config.complete = isFunction(_config.complete);
			_config.error = isFunction(_config.error);
			delete _config.worker;	// prevent infinite loop

			w.postMessage({
				input: _input,
				config: _config,
				workerId: w.id
			});

			return;
		}

		var streamer = null;
		if (typeof _input === 'string')
		{
			if (_config.download)
				streamer = new NetworkStreamer(_config);
			else
				streamer = new StringStreamer(_config);
		}
		else if ((global.File && _input instanceof File) || _input instanceof Object)	// ...Safari. (see issue #106)
			streamer = new FileStreamer(_config);

		return streamer.stream(_input);
	}






	function JsonToCsv(_input, _config)
	{
		var _output = '';
		var _fields = [];

		// Default configuration

		/** whether to surround every datum with quotes */
		var _quotes = false;

		/** whether to write headers */
		var _writeHeader = true;

		/** delimiting character */
		var _delimiter = ',';

		/** newline character(s) */
		var _newline = '\r\n';

		/** quote character */
		var _quoteChar = '"';

		unpackConfig();

		var quoteCharRegex = new RegExp(_quoteChar, 'g');

		if (typeof _input === 'string')
			_input = JSON.parse(_input);

		if (_input instanceof Array)
		{
			if (!_input.length || _input[0] instanceof Array)
				return serialize(null, _input);
			else if (typeof _input[0] === 'object')
				return serialize(objectKeys(_input[0]), _input);
		}
		else if (typeof _input === 'object')
		{
			if (typeof _input.data === 'string')
				_input.data = JSON.parse(_input.data);

			if (_input.data instanceof Array)
			{
				if (!_input.fields)
					_input.fields =  _input.meta && _input.meta.fields;

				if (!_input.fields)
					_input.fields =  _input.data[0] instanceof Array
									? _input.fields
									: objectKeys(_input.data[0]);

				if (!(_input.data[0] instanceof Array) && typeof _input.data[0] !== 'object')
					_input.data = [_input.data];	// handles input like [1,2,3] or ['asdf']
			}

			return serialize(_input.fields || [], _input.data || []);
		}

		// Default (any valid paths should return before this)
		throw 'exception: Unable to serialize unrecognized input';


		function unpackConfig()
		{
			if (typeof _config !== 'object')
				return;

			if (typeof _config.delimiter === 'string'
				&& _config.delimiter.length === 1
				&& Papa.BAD_DELIMITERS.indexOf(_config.delimiter) === -1)
			{
				_delimiter = _config.delimiter;
			}

			if (typeof _config.quotes === 'boolean'
				|| _config.quotes instanceof Array)
				_quotes = _config.quotes;

			if (typeof _config.newline === 'string')
				_newline = _config.newline;

			if (typeof _config.quoteChar === 'string')
				_quoteChar = _config.quoteChar;

			if (typeof _config.header === 'boolean')
				_writeHeader = _config.header;
		}


		/** Turns an object's keys into an array */
		function objectKeys(obj)
		{
			if (typeof obj !== 'object')
				return [];
			var keys = [];
			for (var key in obj)
				keys.push(key);
			return keys;
		}

		/** The double for loop that iterates the data and writes out a CSV string including header row */
		function serialize(fields, data)
		{
			var csv = '';

			if (typeof fields === 'string')
				fields = JSON.parse(fields);
			if (typeof data === 'string')
				data = JSON.parse(data);

			var hasHeader = fields instanceof Array && fields.length > 0;
			var dataKeyedByField = !(data[0] instanceof Array);

			// If there a header row, write it first
			if (hasHeader && _writeHeader)
			{
				for (var i = 0; i < fields.length; i++)
				{
					if (i > 0)
						csv += _delimiter;
					csv += safe(fields[i], i);
				}
				if (data.length > 0)
					csv += _newline;
			}

			// Then write out the data
			for (var row = 0; row < data.length; row++)
			{
				var maxCol = hasHeader ? fields.length : data[row].length;

				for (var col = 0; col < maxCol; col++)
				{
					if (col > 0)
						csv += _delimiter;
					var colIdx = hasHeader && dataKeyedByField ? fields[col] : col;
					csv += safe(data[row][colIdx], col);
				}

				if (row < data.length - 1)
					csv += _newline;
			}

			return csv;
		}

		/** Encloses a value around quotes if needed (makes a value safe for CSV insertion) */
		function safe(str, col)
		{
			if (typeof str === 'undefined' || str === null)
				return '';

			str = str.toString().replace(quoteCharRegex, _quoteChar+_quoteChar);

			var needsQuotes = (typeof _quotes === 'boolean' && _quotes)
							|| (_quotes instanceof Array && _quotes[col])
							|| hasAny(str, Papa.BAD_DELIMITERS)
							|| str.indexOf(_delimiter) > -1
							|| str.charAt(0) === ' '
							|| str.charAt(str.length - 1) === ' ';

			return needsQuotes ? _quoteChar + str + _quoteChar : str;
		}

		function hasAny(str, substrings)
		{
			for (var i = 0; i < substrings.length; i++)
				if (str.indexOf(substrings[i]) > -1)
					return true;
			return false;
		}
	}

	/** ChunkStreamer is the base prototype for various streamer implementations. */
	function ChunkStreamer(config)
	{
		this._handle = null;
		this._paused = false;
		this._finished = false;
		this._input = null;
		this._baseIndex = 0;
		this._partialLine = '';
		this._rowCount = 0;
		this._start = 0;
		this._nextChunk = null;
		this.isFirstChunk = true;
		this._completeResults = {
			data: [],
			errors: [],
			meta: {}
		};
		replaceConfig.call(this, config);

		this.parseChunk = function(chunk)
		{
			// First chunk pre-processing
			if (this.isFirstChunk && isFunction(this._config.beforeFirstChunk))
			{
				var modifiedChunk = this._config.beforeFirstChunk(chunk);
				if (modifiedChunk !== undefined)
					chunk = modifiedChunk;
			}
			this.isFirstChunk = false;

			// Rejoin the line we likely just split in two by chunking the file
			var aggregate = this._partialLine + chunk;
			this._partialLine = '';

			var results = this._handle.parse(aggregate, this._baseIndex, !this._finished);

			if (this._handle.paused() || this._handle.aborted())
				return;

			var lastIndex = results.meta.cursor;

			if (!this._finished)
			{
				this._partialLine = aggregate.substring(lastIndex - this._baseIndex);
				this._baseIndex = lastIndex;
			}

			if (results && results.data)
				this._rowCount += results.data.length;

			var finishedIncludingPreview = this._finished || (this._config.preview && this._rowCount >= this._config.preview);

			if (IS_PAPA_WORKER)
			{
				global.postMessage({
					results: results,
					workerId: Papa.WORKER_ID,
					finished: finishedIncludingPreview
				});
			}
			else if (isFunction(this._config.chunk))
			{
				this._config.chunk(results, this._handle);
				if (this._paused)
					return;
				results = undefined;
				this._completeResults = undefined;
			}

			if (!this._config.step && !this._config.chunk) {
				this._completeResults.data = this._completeResults.data.concat(results.data);
				this._completeResults.errors = this._completeResults.errors.concat(results.errors);
				this._completeResults.meta = results.meta;
			}

			if (finishedIncludingPreview && isFunction(this._config.complete) && (!results || !results.meta.aborted))
				this._config.complete(this._completeResults, this._input);

			if (!finishedIncludingPreview && (!results || !results.meta.paused))
				this._nextChunk();

			return results;
		};

		this._sendError = function(error)
		{
			if (isFunction(this._config.error))
				this._config.error(error);
			else if (IS_PAPA_WORKER && this._config.error)
			{
				global.postMessage({
					workerId: Papa.WORKER_ID,
					error: error,
					finished: false
				});
			}
		};

		function replaceConfig(config)
		{
			// Deep-copy the config so we can edit it
			var configCopy = copy(config);
			configCopy.chunkSize = parseInt(configCopy.chunkSize);	// parseInt VERY important so we don't concatenate strings!
			if (!config.step && !config.chunk)
				configCopy.chunkSize = null;  // disable Range header if not streaming; bad values break IIS - see issue #196
			this._handle = new ParserHandle(configCopy);
			this._handle.streamer = this;
			this._config = configCopy;	// persist the copy to the caller
		}
	}


	function NetworkStreamer(config)
	{
		config = config || {};
		if (!config.chunkSize)
			config.chunkSize = Papa.RemoteChunkSize;
		ChunkStreamer.call(this, config);

		var xhr;

		if (IS_WORKER)
		{
			this._nextChunk = function()
			{
				this._readChunk();
				this._chunkLoaded();
			};
		}
		else
		{
			this._nextChunk = function()
			{
				this._readChunk();
			};
		}

		this.stream = function(url)
		{
			this._input = url;
			this._nextChunk();	// Starts streaming
		};

		this._readChunk = function()
		{
			if (this._finished)
			{
				this._chunkLoaded();
				return;
			}

			xhr = new XMLHttpRequest();

			if (this._config.withCredentials)
			{
				xhr.withCredentials = this._config.withCredentials;
			}

			if (!IS_WORKER)
			{
				xhr.onload = bindFunction(this._chunkLoaded, this);
				xhr.onerror = bindFunction(this._chunkError, this);
			}

			xhr.open('GET', this._input, !IS_WORKER);

			if (this._config.chunkSize)
			{
				var end = this._start + this._config.chunkSize - 1;	// minus one because byte range is inclusive
				xhr.setRequestHeader('Range', 'bytes='+this._start+'-'+end);
				xhr.setRequestHeader('If-None-Match', 'webkit-no-cache'); // https://bugs.webkit.org/show_bug.cgi?id=82672
			}

			try {
				xhr.send();
			}
			catch (err) {
				this._chunkError(err.message);
			}

			if (IS_WORKER && xhr.status === 0)
				this._chunkError();
			else
				this._start += this._config.chunkSize;
		}

		this._chunkLoaded = function()
		{
			if (xhr.readyState != 4)
				return;

			if (xhr.status < 200 || xhr.status >= 400)
			{
				this._chunkError();
				return;
			}

			this._finished = !this._config.chunkSize || this._start > getFileSize(xhr);
			this.parseChunk(xhr.responseText);
		}

		this._chunkError = function(errorMessage)
		{
			var errorText = xhr.statusText || errorMessage;
			this._sendError(errorText);
		}

		function getFileSize(xhr)
		{
			var contentRange = xhr.getResponseHeader('Content-Range');
			if (contentRange === null) { // no content range, then finish!
        			return -1;
            		}
			return parseInt(contentRange.substr(contentRange.lastIndexOf('/') + 1));
		}
	}
	NetworkStreamer.prototype = Object.create(ChunkStreamer.prototype);
	NetworkStreamer.prototype.constructor = NetworkStreamer;


	function FileStreamer(config)
	{
		config = config || {};
		if (!config.chunkSize)
			config.chunkSize = Papa.LocalChunkSize;
		ChunkStreamer.call(this, config);

		var reader, slice;

		// FileReader is better than FileReaderSync (even in worker) - see http://stackoverflow.com/q/24708649/1048862
		// But Firefox is a pill, too - see issue #76: https://github.com/mholt/PapaParse/issues/76
		var usingAsyncReader = typeof FileReader !== 'undefined';	// Safari doesn't consider it a function - see issue #105

		this.stream = function(file)
		{
			this._input = file;
			slice = file.slice || file.webkitSlice || file.mozSlice;

			if (usingAsyncReader)
			{
				reader = new FileReader();		// Preferred method of reading files, even in workers
				reader.onload = bindFunction(this._chunkLoaded, this);
				reader.onerror = bindFunction(this._chunkError, this);
			}
			else
				reader = new FileReaderSync();	// Hack for running in a web worker in Firefox

			this._nextChunk();	// Starts streaming
		};

		this._nextChunk = function()
		{
			if (!this._finished && (!this._config.preview || this._rowCount < this._config.preview))
				this._readChunk();
		}

		this._readChunk = function()
		{
			var input = this._input;
			if (this._config.chunkSize)
			{
				var end = Math.min(this._start + this._config.chunkSize, this._input.size);
				input = slice.call(input, this._start, end);
			}
			var txt = reader.readAsText(input, this._config.encoding);
			if (!usingAsyncReader)
				this._chunkLoaded({ target: { result: txt } });	// mimic the async signature
		}

		this._chunkLoaded = function(event)
		{
			// Very important to increment start each time before handling results
			this._start += this._config.chunkSize;
			this._finished = !this._config.chunkSize || this._start >= this._input.size;
			this.parseChunk(event.target.result);
		}

		this._chunkError = function()
		{
			this._sendError(reader.error);
		}

	}
	FileStreamer.prototype = Object.create(ChunkStreamer.prototype);
	FileStreamer.prototype.constructor = FileStreamer;


	function StringStreamer(config)
	{
		config = config || {};
		ChunkStreamer.call(this, config);

		var string;
		var remaining;
		this.stream = function(s)
		{
			string = s;
			remaining = s;
			return this._nextChunk();
		}
		this._nextChunk = function()
		{
			if (this._finished) return;
			var size = this._config.chunkSize;
			var chunk = size ? remaining.substr(0, size) : remaining;
			remaining = size ? remaining.substr(size) : '';
			this._finished = !remaining;
			return this.parseChunk(chunk);
		}
	}
	StringStreamer.prototype = Object.create(StringStreamer.prototype);
	StringStreamer.prototype.constructor = StringStreamer;



	// Use one ParserHandle per entire CSV file or string
	function ParserHandle(_config)
	{
		// One goal is to minimize the use of regular expressions...
		var FLOAT = /^\s*-?(\d*\.?\d+|\d+\.?\d*)(e[-+]?\d+)?\s*$/i;

		var self = this;
		var _stepCounter = 0;	// Number of times step was called (number of rows parsed)
		var _input;				// The input being parsed
		var _parser;			// The core parser being used
		var _paused = false;	// Whether we are paused or not
		var _aborted = false;   // Whether the parser has aborted or not
		var _delimiterError;	// Temporary state between delimiter detection and processing results
		var _fields = [];		// Fields are from the header row of the input, if there is one
		var _results = {		// The last results returned from the parser
			data: [],
			errors: [],
			meta: {}
		};

		if (isFunction(_config.step))
		{
			var userStep = _config.step;
			_config.step = function(results)
			{
				_results = results;

				if (needsHeaderRow())
					processResults();
				else	// only call user's step function after header row
				{
					processResults();

					// It's possbile that this line was empty and there's no row here after all
					if (_results.data.length === 0)
						return;

					_stepCounter += results.data.length;
					if (_config.preview && _stepCounter > _config.preview)
						_parser.abort();
					else
						userStep(_results, self);
				}
			};
		}

		/**
		 * Parses input. Most users won't need, and shouldn't mess with, the baseIndex
		 * and ignoreLastRow parameters. They are used by streamers (wrapper functions)
		 * when an input comes in multiple chunks, like from a file.
		 */
		this.parse = function(input, baseIndex, ignoreLastRow)
		{
			if (!_config.newline)
				_config.newline = guessLineEndings(input);

			_delimiterError = false;
			if (!_config.delimiter)
			{
				var delimGuess = guessDelimiter(input, _config.newline);
				if (delimGuess.successful)
					_config.delimiter = delimGuess.bestDelimiter;
				else
				{
					_delimiterError = true;	// add error after parsing (otherwise it would be overwritten)
					_config.delimiter = Papa.DefaultDelimiter;
				}
				_results.meta.delimiter = _config.delimiter;
			}
			else if(typeof _config.delimiter === 'function')
			{
				_config.delimiter = _config.delimiter(input);
				_results.meta.delimiter = _config.delimiter;
			}

			var parserConfig = copy(_config);
			if (_config.preview && _config.header)
				parserConfig.preview++;	// to compensate for header row

			_input = input;
			_parser = new Parser(parserConfig);
			_results = _parser.parse(_input, baseIndex, ignoreLastRow);
			processResults();
			return _paused ? { meta: { paused: true } } : (_results || { meta: { paused: false } });
		};

		this.paused = function()
		{
			return _paused;
		};

		this.pause = function()
		{
			_paused = true;
			_parser.abort();
			_input = _input.substr(_parser.getCharIndex());
		};

		this.resume = function()
		{
			_paused = false;
			self.streamer.parseChunk(_input);
		};

		this.aborted = function ()
		{
			return _aborted;
		};

		this.abort = function()
		{
			_aborted = true;
			_parser.abort();
			_results.meta.aborted = true;
			if (isFunction(_config.complete))
				_config.complete(_results);
			_input = '';
		};

		function processResults()
		{
			if (_results && _delimiterError)
			{
				addError('Delimiter', 'UndetectableDelimiter', 'Unable to auto-detect delimiting character; defaulted to \''+Papa.DefaultDelimiter+'\'');
				_delimiterError = false;
			}

			if (_config.skipEmptyLines)
			{
				for (var i = 0; i < _results.data.length; i++)
					if (_results.data[i].length === 1 && _results.data[i][0] === '')
						_results.data.splice(i--, 1);
			}

			if (needsHeaderRow())
				fillHeaderFields();

			return applyHeaderAndDynamicTyping();
		}

		function needsHeaderRow()
		{
			return _config.header && _fields.length === 0;
		}

		function fillHeaderFields()
		{
			if (!_results)
				return;
			for (var i = 0; needsHeaderRow() && i < _results.data.length; i++)
				for (var j = 0; j < _results.data[i].length; j++)
					_fields.push(_results.data[i][j]);
			_results.data.splice(0, 1);
		}

		function parseDynamic(field, value)
		{
			if ((_config.dynamicTyping[field] || _config.dynamicTyping) === true)
			{
				if (value === 'true' || value === 'TRUE')
					return true;
				else if (value === 'false' || value === 'FALSE')
					return false;
				else
					return tryParseFloat(value);
			}
			return value;
		}

		function applyHeaderAndDynamicTyping()
		{
			if (!_results || (!_config.header && !_config.dynamicTyping))
				return _results;

			for (var i = 0; i < _results.data.length; i++)
			{
				var row = _config.header ? {} : [];

				for (var j = 0; j < _results.data[i].length; j++)
				{
					var field = j;
					var value = _results.data[i][j];

					if (_config.header)
						field = j >= _fields.length ? '__parsed_extra' : _fields[j];

					value = parseDynamic(field, value);

					if (field === '__parsed_extra')
					{
						row[field] = row[field] || [];
						row[field].push(value);
					}
					else
						row[field] = value;
				}

				_results.data[i] = row;

				if (_config.header)
				{
					if (j > _fields.length)
						addError('FieldMismatch', 'TooManyFields', 'Too many fields: expected ' + _fields.length + ' fields but parsed ' + j, i);
					else if (j < _fields.length)
						addError('FieldMismatch', 'TooFewFields', 'Too few fields: expected ' + _fields.length + ' fields but parsed ' + j, i);
				}
			}

			if (_config.header && _results.meta)
				_results.meta.fields = _fields;
			return _results;
		}

		function guessDelimiter(input, newline)
		{
			var delimChoices = [',', '\t', '|', ';', Papa.RECORD_SEP, Papa.UNIT_SEP];
			var bestDelim, bestDelta, fieldCountPrevRow;

			for (var i = 0; i < delimChoices.length; i++)
			{
				var delim = delimChoices[i];
				var delta = 0, avgFieldCount = 0;
				fieldCountPrevRow = undefined;

				var preview = new Parser({
					delimiter: delim,
					newline: newline,
					preview: 10
				}).parse(input);

				for (var j = 0; j < preview.data.length; j++)
				{
					var fieldCount = preview.data[j].length;
					avgFieldCount += fieldCount;

					if (typeof fieldCountPrevRow === 'undefined')
					{
						fieldCountPrevRow = fieldCount;
						continue;
					}
					else if (fieldCount > 1)
					{
						delta += Math.abs(fieldCount - fieldCountPrevRow);
						fieldCountPrevRow = fieldCount;
					}
				}

				if (preview.data.length > 0)
					avgFieldCount /= preview.data.length;

				if ((typeof bestDelta === 'undefined' || delta < bestDelta)
					&& avgFieldCount > 1.99)
				{
					bestDelta = delta;
					bestDelim = delim;
				}
			}

			_config.delimiter = bestDelim;

			return {
				successful: !!bestDelim,
				bestDelimiter: bestDelim
			}
		}

		function guessLineEndings(input)
		{
			input = input.substr(0, 1024*1024);	// max length 1 MB

			var r = input.split('\r');

			var n = input.split('\n');

			var nAppearsFirst = (n.length > 1 && n[0].length < r[0].length);

			if (r.length === 1 || nAppearsFirst)
				return '\n';

			var numWithN = 0;
			for (var i = 0; i < r.length; i++)
			{
				if (r[i][0] === '\n')
					numWithN++;
			}

			return numWithN >= r.length / 2 ? '\r\n' : '\r';
		}

		function tryParseFloat(val)
		{
			var isNumber = FLOAT.test(val);
			return isNumber ? parseFloat(val) : val;
		}

		function addError(type, code, msg, row)
		{
			_results.errors.push({
				type: type,
				code: code,
				message: msg,
				row: row
			});
		}
	}





	/** The core parser implements speedy and correct CSV parsing */
	function Parser(config)
	{
		// Unpack the config object
		config = config || {};
		var delim = config.delimiter;
		var newline = config.newline;
		var comments = config.comments;
		var step = config.step;
		var preview = config.preview;
		var fastMode = config.fastMode;
		var quoteChar = config.quoteChar || '"';

		// Delimiter must be valid
		if (typeof delim !== 'string'
			|| Papa.BAD_DELIMITERS.indexOf(delim) > -1)
			delim = ',';

		// Comment character must be valid
		if (comments === delim)
			throw 'Comment character same as delimiter';
		else if (comments === true)
			comments = '#';
		else if (typeof comments !== 'string'
			|| Papa.BAD_DELIMITERS.indexOf(comments) > -1)
			comments = false;

		// Newline must be valid: \r, \n, or \r\n
		if (newline != '\n' && newline != '\r' && newline != '\r\n')
			newline = '\n';

		// We're gonna need these at the Parser scope
		var cursor = 0;
		var aborted = false;

		this.parse = function(input, baseIndex, ignoreLastRow)
		{
			// For some reason, in Chrome, this speeds things up (!?)
			if (typeof input !== 'string')
				throw 'Input must be a string';

			// We don't need to compute some of these every time parse() is called,
			// but having them in a more local scope seems to perform better
			var inputLen = input.length,
				delimLen = delim.length,
				newlineLen = newline.length,
				commentsLen = comments.length;
			var stepIsFunction = typeof step === 'function';

			// Establish starting state
			cursor = 0;
			var data = [], errors = [], row = [], lastCursor = 0;

			if (!input)
				return returnable();

			if (fastMode || (fastMode !== false && input.indexOf(quoteChar) === -1))
			{
				var rows = input.split(newline);
				for (var i = 0; i < rows.length; i++)
				{
					var row = rows[i];
					cursor += row.length;
					if (i !== rows.length - 1)
						cursor += newline.length;
					else if (ignoreLastRow)
						return returnable();
					if (comments && row.substr(0, commentsLen) === comments)
						continue;
					if (stepIsFunction)
					{
						data = [];
						pushRow(row.split(delim));
						doStep();
						if (aborted)
							return returnable();
					}
					else
						pushRow(row.split(delim));
					if (preview && i >= preview)
					{
						data = data.slice(0, preview);
						return returnable(true);
					}
				}
				return returnable();
			}

			var nextDelim = input.indexOf(delim, cursor);
			var nextNewline = input.indexOf(newline, cursor);
			var quoteCharRegex = new RegExp(quoteChar+quoteChar, 'g');

			// Parser loop
			for (;;)
			{
				// Field has opening quote
				if (input[cursor] === quoteChar)
				{
					// Start our search for the closing quote where the cursor is
					var quoteSearch = cursor;

					// Skip the opening quote
					cursor++;

					for (;;)
					{
						// Find closing quote
						var quoteSearch = input.indexOf(quoteChar, quoteSearch+1);

						if (quoteSearch === -1)
						{
							if (!ignoreLastRow) {
								// No closing quote... what a pity
								errors.push({
									type: 'Quotes',
									code: 'MissingQuotes',
									message: 'Quoted field unterminated',
									row: data.length,	// row has yet to be inserted
									index: cursor
								});
							}
							return finish();
						}

						if (quoteSearch === inputLen-1)
						{
							// Closing quote at EOF
							var value = input.substring(cursor, quoteSearch).replace(quoteCharRegex, quoteChar);
							return finish(value);
						}

						// If this quote is escaped, it's part of the data; skip it
						if (input[quoteSearch+1] === quoteChar)
						{
							quoteSearch++;
							continue;
						}

						if (input[quoteSearch+1] === delim)
						{
							// Closing quote followed by delimiter
							row.push(input.substring(cursor, quoteSearch).replace(quoteCharRegex, quoteChar));
							cursor = quoteSearch + 1 + delimLen;
							nextDelim = input.indexOf(delim, cursor);
							nextNewline = input.indexOf(newline, cursor);
							break;
						}

						if (input.substr(quoteSearch+1, newlineLen) === newline)
						{
							// Closing quote followed by newline
							row.push(input.substring(cursor, quoteSearch).replace(quoteCharRegex, quoteChar));
							saveRow(quoteSearch + 1 + newlineLen);
							nextDelim = input.indexOf(delim, cursor);	// because we may have skipped the nextDelim in the quoted field

							if (stepIsFunction)
							{
								doStep();
								if (aborted)
									return returnable();
							}

							if (preview && data.length >= preview)
								return returnable(true);

							break;
						}
					}

					continue;
				}

				// Comment found at start of new line
				if (comments && row.length === 0 && input.substr(cursor, commentsLen) === comments)
				{
					if (nextNewline === -1)	// Comment ends at EOF
						return returnable();
					cursor = nextNewline + newlineLen;
					nextNewline = input.indexOf(newline, cursor);
					nextDelim = input.indexOf(delim, cursor);
					continue;
				}

				// Next delimiter comes before next newline, so we've reached end of field
				if (nextDelim !== -1 && (nextDelim < nextNewline || nextNewline === -1))
				{
					row.push(input.substring(cursor, nextDelim));
					cursor = nextDelim + delimLen;
					nextDelim = input.indexOf(delim, cursor);
					continue;
				}

				// End of row
				if (nextNewline !== -1)
				{
					row.push(input.substring(cursor, nextNewline));
					saveRow(nextNewline + newlineLen);

					if (stepIsFunction)
					{
						doStep();
						if (aborted)
							return returnable();
					}

					if (preview && data.length >= preview)
						return returnable(true);

					continue;
				}

				break;
			}


			return finish();


			function pushRow(row)
			{
				data.push(row);
				lastCursor = cursor;
			}

			/**
			 * Appends the remaining input from cursor to the end into
			 * row, saves the row, calls step, and returns the results.
			 */
			function finish(value)
			{
				if (ignoreLastRow)
					return returnable();
				if (typeof value === 'undefined')
					value = input.substr(cursor);
				row.push(value);
				cursor = inputLen;	// important in case parsing is paused
				pushRow(row);
				if (stepIsFunction)
					doStep();
				return returnable();
			}

			/**
			 * Appends the current row to the results. It sets the cursor
			 * to newCursor and finds the nextNewline. The caller should
			 * take care to execute user's step function and check for
			 * preview and end parsing if necessary.
			 */
			function saveRow(newCursor)
			{
				cursor = newCursor;
				pushRow(row);
				row = [];
				nextNewline = input.indexOf(newline, cursor);
			}

			/** Returns an object with the results, errors, and meta. */
			function returnable(stopped)
			{
				return {
					data: data,
					errors: errors,
					meta: {
						delimiter: delim,
						linebreak: newline,
						aborted: aborted,
						truncated: !!stopped,
						cursor: lastCursor + (baseIndex || 0)
					}
				};
			}

			/** Executes the user's step function and resets data & errors. */
			function doStep()
			{
				step(returnable());
				data = [], errors = [];
			}
		};

		/** Sets the abort flag */
		this.abort = function()
		{
			aborted = true;
		};

		/** Gets the cursor position */
		this.getCharIndex = function()
		{
			return cursor;
		};
	}


	// If you need to load Papa Parse asynchronously and you also need worker threads, hard-code
	// the script path here. See: https://github.com/mholt/PapaParse/issues/87#issuecomment-57885358
	function getScriptPath()
	{
		var scripts = document.getElementsByTagName('script');
		return scripts.length ? scripts[scripts.length - 1].src : '';
	}

	function newWorker()
	{
		if (!Papa.WORKERS_SUPPORTED)
			return false;
		if (!LOADED_SYNC && Papa.SCRIPT_PATH === null)
			throw new Error(
				'Script path cannot be determined automatically when Papa Parse is loaded asynchronously. ' +
				'You need to set Papa.SCRIPT_PATH manually.'
			);
		var workerUrl = Papa.SCRIPT_PATH || AUTO_SCRIPT_PATH;
		// Append 'papaworker' to the search string to tell papaparse that this is our worker.
		workerUrl += (workerUrl.indexOf('?') !== -1 ? '&' : '?') + 'papaworker';
		var w = new global.Worker(workerUrl);
		w.onmessage = mainThreadReceivedMessage;
		w.id = workerIdCounter++;
		workers[w.id] = w;
		return w;
	}

	/** Callback when main thread receives a message */
	function mainThreadReceivedMessage(e)
	{
		var msg = e.data;
		var worker = workers[msg.workerId];
		var aborted = false;

		if (msg.error)
			worker.userError(msg.error, msg.file);
		else if (msg.results && msg.results.data)
		{
			var abort = function() {
				aborted = true;
				completeWorker(msg.workerId, { data: [], errors: [], meta: { aborted: true } });
			};

			var handle = {
				abort: abort,
				pause: notImplemented,
				resume: notImplemented
			};

			if (isFunction(worker.userStep))
			{
				for (var i = 0; i < msg.results.data.length; i++)
				{
					worker.userStep({
						data: [msg.results.data[i]],
						errors: msg.results.errors,
						meta: msg.results.meta
					}, handle);
					if (aborted)
						break;
				}
				delete msg.results;	// free memory ASAP
			}
			else if (isFunction(worker.userChunk))
			{
				worker.userChunk(msg.results, handle, msg.file);
				delete msg.results;
			}
		}

		if (msg.finished && !aborted)
			completeWorker(msg.workerId, msg.results);
	}

	function completeWorker(workerId, results) {
		var worker = workers[workerId];
		if (isFunction(worker.userComplete))
			worker.userComplete(results);
		worker.terminate();
		delete workers[workerId];
	}

	function notImplemented() {
		throw 'Not implemented.';
	}

	/** Callback when worker thread receives a message */
	function workerThreadReceivedMessage(e)
	{
		var msg = e.data;

		if (typeof Papa.WORKER_ID === 'undefined' && msg)
			Papa.WORKER_ID = msg.workerId;

		if (typeof msg.input === 'string')
		{
			global.postMessage({
				workerId: Papa.WORKER_ID,
				results: Papa.parse(msg.input, msg.config),
				finished: true
			});
		}
		else if ((global.File && msg.input instanceof File) || msg.input instanceof Object)	// thank you, Safari (see issue #106)
		{
			var results = Papa.parse(msg.input, msg.config);
			if (results)
				global.postMessage({
					workerId: Papa.WORKER_ID,
					results: results,
					finished: true
				});
		}
	}

	/** Makes a deep copy of an array or object (mostly) */
	function copy(obj)
	{
		if (typeof obj !== 'object')
			return obj;
		var cpy = obj instanceof Array ? [] : {};
		for (var key in obj)
			cpy[key] = copy(obj[key]);
		return cpy;
	}

	function bindFunction(f, self)
	{
		return function() { f.apply(self, arguments); };
	}

	function isFunction(func)
	{
		return typeof func === 'function';
	}

	return Papa;
}));


/***/ }),

/***/ 47:
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ })

/******/ });


// WEBPACK FOOTER //
// app.cfc0ca3c52738b14d4c4.js